webpackJsonp([1],{

/***/ "+3tv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+BAp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+F4+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "+Q4U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+ed2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/2eN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/C2o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Wfl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4154764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("aN9Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0+iC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0DIp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Y+T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0kVb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1DHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4a3d730","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_cell = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("ej5L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_cell,
  src_components_cell,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2gLD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjBCQUNDMjY5QTI0MTFFODhDQjQ5NUZGODM3RTJDRjIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjBCQUNDMjc5QTI0MTFFODhDQjQ5NUZGODM3RTJDRjIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyMEJBQ0MyNDlBMjQxMUU4OENCNDk1RkY4MzdFMkNGMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyMEJBQ0MyNTlBMjQxMUU4OENCNDk1RkY4MzdFMkNGMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjnNJlQAAAGkSURBVHjajFI9r8FgGO3bdiCxuguL2SoxGQWLSLCYiF9RISESDBYSg92PsCAW8RUfg0htEgMWU1u3Wr2H3jRVN3KfpX2fPuec55y3VKlUSqfT+/1e07T7/a79o4wxWlXV4/FYKBSAJ4RQr4Wvp9MJ0+amMcZ0u93D4cDz/GKx8Pv9DofDPDcYDKrVqsvlcrvd79QU1EVRhHIoFMpkMvr++m7D4TAajUYikXg8Pp1O303RwNvt9nw+D1lsWC6Xz+czmuPxuNlsAgDZ6/Vaq9VWqxUAZmGmWCw+Hgzj8/n43Y7fbufzuSAI7XYbG6VSKS6XEwVhs9lMJhOPx+N0ft0UhWXZh3kzmSzL4Fqv13oq2Ww2FovpVlutFtKx2WwY8Hq9QPX7fcpi43K5cBwXDAY7nQ6iNvqKosBFOBxOJpPL5RJxJBIJYrGBkiRpNpsFAoH3eBuNRq/XAxGyoGn6D/CHgq9KpYLkwfubtvnaPnMhDiRnHF/AgihZwN/yDc7199FoVK/XcQXkWda1FUVlWdAR0+8Jb0Q3rzxvCOMadafJQ/VHgAEA5RdT2/1CnHsAAAAASUVORK5CYII="

/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46ce9210","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3wvI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/authCode_bg.7ac395e.png";

/***/ }),

/***/ "4F7/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/colect_no.87ceffd.png";

/***/ }),

/***/ "4d+Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5933":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5POz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAkFJREFUWAntWDtrFFEYPd+4aoIPjEVII2KpCypYWWoZBLsYG/+Bu4uC4AsXbBUcERu7QMxmC0HRMmpnJxY+sLGxSRofsIgyznyeCY6EvffOTnKHXZW5MNyZ73G+c8+de+cBVK1SYLQKiKt8+5mOfV7GZQhOqKLOuM2u2A3aI2KfuT0rnbz8ms154aHuILkXCtRFscJRPCdYZIvdqI3YUa2G94PyrQR/fMPNlBwC3JiYxMX2Mfk5CGhoflWVxoJ+bS7o6/R8aIUdhYJ++7kH2EfbTlJ7KcIJHnEzCGqErb85HRwxt9XyBsE/pBSHGot6bdTTbNxj57t6IIrxJiPKgA9cwa94XeYq7kHxNDwt97M6rt4g2Oro/kTx1pVQpj0QhLdmpZWH6Z7ivCyHTwSPd09hvP+g/Y4thQ+As+2ubrf5Mpt1H8yc6+255GPumd/785odte6jjA++JNjD+Hf9Odl1qQpmoGX2FUFfNY17cFMASWI/2FZXjyYJ5vkcmudWctUHzSAYJ9yhPBrJHdcYjwixjUBXmosa+CAaBL0UVBym+k9Ibiwboya4xI1+Obteb28Q9FRwr5WAYspqL2CsVnEBkXJDKgVz5SngrBQsIFJuSKVgrjwFnP+egjqOTwUGNrQQQ8HwpKzwFf3j0BgMKGQQXI0XXB+QV4qbX2zJriBfDCvB8JTcS//LpAClMHGBCO62Z6Tncqd247NzbXCjq0cQY5pTXuc73Za1Pp9z/lbpsfJSOIO5v+H3is9Yqtz/X4Ffp7KVkMwwygsAAAAASUVORK5CYII="

/***/ }),

/***/ "5Zmm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6d7H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6fPh":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "6xlL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Ah8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/scroller.js
var scroller = __webpack_require__("+geU");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/index.js
var flexbox = __webpack_require__("F3HL");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/chain.js
var chain = __webpack_require__("zDi5");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/value2name.js
var value2name = __webpack_require__("NE4E");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/is-array.js
var is_array = __webpack_require__("cEdU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e92ef554","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/picker/index.vue
var picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-picker"},[_c('flexbox',{attrs:{"gutter":0}},_vm._l((_vm.currentData),function(one,index){return _c('flexbox-item',{key:index,staticStyle:{"margin-left":"0"},attrs:{"span":_vm.columnWidth && _vm.columnWidth[index]}},[_c('div',{staticClass:"vux-picker-item",attrs:{"id":("vux-picker-" + _vm.uuid + "-" + index)}})])}))],1)}
var staticRenderFns = []
var esExports = { render: picker_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_picker = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("mT/2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_picker,
  src_components_picker,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_picker = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/index.vue + 3 modules
var cell = __webpack_require__("1DHf");

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/index.vue + 3 modules
var popup = __webpack_require__("HD9R");

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup-header/index.vue + 3 modules
var popup_header = __webpack_require__("WZtS");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/array2String.js
var array2String = __webpack_require__("LsKW");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: cell["a" /* default */],
    Popup: popup["a" /* default */],
    PopupHeader: popup_header["a" /* default */],
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent.labelWidth || this.$parent.$parent.labelWidth || 'auto',
        textAlign: this.$parent.labelAlign || this.$parent.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = popup_picker_getObject(val);
        this.currentValue = popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', popup_picker_getObject(val));
      this.$emit('on-change', popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var components_popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var components_popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: cell["a" /* default */],
    Popup: popup["a" /* default */],
    PopupHeader: popup_header["a" /* default */],
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent.labelWidth || this.$parent.$parent.labelWidth || 'auto',
        textAlign: this.$parent.labelAlign || this.$parent.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = components_popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = components_popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = components_popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = components_popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = components_popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = components_popup_picker_getObject(val);
        this.currentValue = components_popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', components_popup_picker_getObject(val));
      this.$emit('on-change', components_popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: components_popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-276dacd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-picker/index.vue
var popup_picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCell),expression:"showCell"}],staticClass:"weui-cell vux-tap-active",class:{'weui-cell_access': !_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("title",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyles),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()],{labelClass:"weui-label",labelStyle:_vm.labelStyles,labelTitle:_vm.title}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-primary vux-popup-picker-select-box"},[_c('div',{staticClass:"vux-popup-picker-select",style:({textAlign: _vm.valueTextAlign})},[(!_vm.displayFormat && !_vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]):_vm._e(),_vm._v(" "),(!_vm.displayFormat && _vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("value2name")(_vm.value,_vm.data)))]):_vm._e(),_vm._v(" "),(_vm.displayFormat && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]):_vm._e(),_vm._v(" "),(!_vm.value.length && _vm.placeholder)?_c('span',{staticClass:"vux-popup-picker-placeholder vux-cell-placeholder",domProps:{"textContent":_vm._s(_vm.placeholder)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"})]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.isTransferDom),expression:"isTransferDom"}]},[_c('popup',{staticClass:"vux-popup-picker",attrs:{"id":("vux-popup-picker-" + _vm.uuid),"popup-style":_vm.popupStyle},on:{"on-hide":_vm.onPopupHide,"on-show":_vm.onPopupShow},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"vux-popup-picker-container"},[_c('popup-header',{attrs:{"left-text":_vm.cancelText || '取消',"right-text":_vm.confirmText || '完成',"title":_vm.popupTitle},on:{"on-click-left":function($event){_vm.onHide(false)},"on-click-right":function($event){_vm.onHide(true)}}}),_vm._v(" "),_c('picker',{attrs:{"data":_vm.data,"columns":_vm.columns,"fixed-columns":_vm.fixedColumns,"container":'#vux-popup-picker-'+_vm.uuid,"column-width":_vm.columnWidth},on:{"on-change":_vm.onPickerChange},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)])],1)])}
var popup_picker_staticRenderFns = []
var popup_picker_esExports = { render: popup_picker_render, staticRenderFns: popup_picker_staticRenderFns }
/* harmony default export */ var src_components_popup_picker = (popup_picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-picker/index.vue
function popup_picker_injectStyle (ssrContext) {
  __webpack_require__("bg0x")
}
var popup_picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_picker___vue_template_functional__ = false
/* styles */
var popup_picker___vue_styles__ = popup_picker_injectStyle
/* scopeId */
var popup_picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_picker___vue_module_identifier__ = null
var popup_picker_Component = popup_picker_normalizeComponent(
  components_popup_picker,
  src_components_popup_picker,
  popup_picker___vue_template_functional__,
  popup_picker___vue_styles__,
  popup_picker___vue_scopeId__,
  popup_picker___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_popup_picker = __webpack_exports__["a"] = (popup_picker_Component.exports);


/***/ }),

/***/ "7I26":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7I74":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7V4Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8H5w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "90XA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "98Sc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9FLu":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAACaCAYAAABVCoEqAAAAAXNSR0IArs4c6QAABPRJREFUeAHt3UFOW0sQQFEbGPAZwxAh739R9pwNICFMvpFMCNUpOVQhPTcHKQK67dJ7p2/sSaysVr4IfKPAervd7r9xvtE/XOBqv9+vf7iB2/9Ggavj7M1mc/zRdwJlgf/fGd9mvAe2XnshK6saEAQuwooFAo0CAmvENCoKCCyaWGkUEFgjplFRQGDRxEqjgMAaMY2KAgKLJlYaBQTWiGlUFBBYNLHSKCCwRkyjooDAoomVRgGBNWIaFQUEFk2sNAoIrBHTqCggsGhipVFAYI2YRkUBgUUTK40CAmvENCoKCCyaWGkUEFgjplFRQGDRxEqjgMAaMY2KAgKLJlYaBQTWiGlUFBBYNLHSKCCwRkyjooDAoomVRgGBNWIaFQUEFk2sNAoIrBHTqCggsGhipVFAYI2YRkUBgUUTK40CAmvENCoKCCyaWGkUEFgjplFRQGDRxEqjgMAaMY2KAgKLJlYaBQTWiGlUFBBYNLHSKCCwRkyjooDAoomVRgGBNWIaFQUEFk2sNAoIrBHTqCggsGhipVFAYI2YRkWB9/+QNG5Z+Sjw9PS0enx8fFu6u7tbXV9ff9z2818EvIL9Bebz8iGu5+fntz/H0D4/xu9RQGDRZLhyiOv49fHn45rvYwGBjV2sNgkIrAnSmLGAwMYuVpsEBNYEacxYQGBjF6tNAgJrgjRmLCCwsYvVJgGBNUEaMxYQ2NjFapOAwJogjRkLCGzsYrVJQGBNkMaMBQQ2drHaJCCwJkhjxgICG7tYbRIQWBOkMWMBgY1drDYJCKwJ0pixgMDGLlabBKb7VNHx0z8vLy9NROMxu91uvPHF1cvLy9WMn1aaLrDjp3++eM4nP22/35/82FMeeJh3uPb7+/tTHn42j5nuLfL19fVs8D9f6Dlf++d7Of4+XWC3t7erw9vNuX0drvlw7bN9TfcWeXNzs3p4eFh1vxpst9s/zn6z2fzxe/WX9XpdHbHI508X2FH5uw/su+cf7+Pcv0/3FnnuBzLb9QtsthNd2P0IbGEHMtvlCGy2E13Y/QhsYQcy2+UIbLYTXdj9CGxhBzLb5QhsthNd2P0IbGEHMtvlCGy2E13Y/QhsYQcy2+UIbLYTXdj9CGxhBzLb5QhsthNd2P0IbGEHMtvlCGy2E13Y/QhsYQcy2+UIbLYTXdj9COzEA7m6+v2vyz/+fOLTf+zDBHbi0R8/rTTrp39OZPjnh/3+a/nPT/1ZTzh+Wuln3XX9br2C1Q1NSAQEluDYqgsIrG5oQiIgsATHVl1AYHVDExIBgSU4tuoCAqsbmpAICCzBsVUXEFjd0IREQGAJjq26gMDqhiYkAgJLcGzVBQRWNzQhERBYgmOrLiCwuqEJiYDAEhxbdQGB1Q1NSAQEluDYqgsIrG5oQiIgsATHVl1AYHVDExIBgSU4tuoCAqsbmpAICCzBsVUXEFjd0IREQGAJjq26gMDqhiYkAgJLcGzVBQRWNzQhERBYgmOrLiCwuqEJiYDAEhxbdQGB1Q1NSAQEluDYqgsIrG5oQiIgsATHVl1AYHVDExIBgSU4tuoCAqsbmpAICCzBsVUXEFjd0IREQGAJjq26gMDqhiYkAgJLcGzVBQRWNzQhERBYgmOrLiCwuqEJiYDAEhxbdQGB1Q1NSATe/8fb3W6XPMwWga8JvAe23++/NsGzCCQCVxcXF/8l+7YIlAR+ARQzUFJ9mWDGAAAAAElFTkSuQmCC"

/***/ }),

/***/ "9S6h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9UmN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A4Qo":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "AHIP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/defaultImg.2a02a39.png";

/***/ }),

/***/ "As1b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/colect_yes.cfde283.png";

/***/ }),

/***/ "B7Bd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BcM0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BoMB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C5Jt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CBpU":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "CkLX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DI1c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DdAS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DdhL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EVTt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ExZm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F0Jx":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAoCAYAAACIC2hQAAAAAXNSR0IArs4c6QAAA0hJREFUWAntWDtrFFEUPmdfaBJE8AEmnaC7YCvWSaNgE1BJYZbYxV8gIioEDIhYiJUQsEhcFYIRYmGpW4s2ikUsUojERiGEvMxucjznjjM7d3funTvZzZhiD8zOfZx7vm/v+xuArnV7YH/3ALZLj95P5GDp2yDHGQbAM0DQz2l5xJYA+QH6yul56D9dxaGJuqpJ+LNrovRi/CjQ6h0gvMZEDrvh4jIgTQP2TeLVqV9ubTyvxETp43geFtZvANFNJngoCVjDF1cA8QEUex7i2alao9ycSkSUXo8dgfXtV0xw0BwySQ1WoSd7BS/N/I5r5UyUZstFqO285Tl4Mi5oonqERchnLuJIZcHWzomo6smN+oeOk/SZCdmDuXO2ns34vqa3mpMy3J3uyTCgxGYMhRUuD6VjiaqFk2hO4nfept7w8yOE45DkeS+L1GBWot4WJKvb0RA+QeF4CcvPh+FYpsQr+4tjS8+NdxKFGdHIShRo7W6iLYhwFkcebQgOXni2xm3nIjAtRbzdyd4cYUai6sQhGItoYyticiEjXA3l3JJ8gCjsJm8jUe9YdD1xmqK2lWVM70jWopiJqrNb800zw/cG3SxE+YLx36wVO2fk4t2CjNVOFYh13n83A1+kDOcLQd6UiMA2E0Ua4KBtGY5WHnMAeQKjufIJ2KQnfKlpGd7AqXFNDIrMQ0/YJs0AQ0vg5cpPyGZuaYUOGTNRufQmNaRTjk2yMX4t2JahZ6IExZiAejXhdXo5+hkg/w4Ktdab/FYBAbcGoL5zX2/YlFOqQC8zE/Xkw5DuHpejA7ANTwG2ANT51Oz/p7nAkFfSRauzDf285plupgXbTJSFGJ/Yy+nyEzTGVNg6spGoUosIM7p7CjkWf1FK1UhUUcLee/wPV1Kg9w9CRF/fZBSelaiStKIW0zLGMsloK1HFjyUt92p177kyhsKKRoolqnQ3S1r+4rEYHaIDpRJbZLNF48cSFRpKHbKk3ROyvlyO0fZORBVZ0d0saTs7DXi4RSbHaHrBdyaqyMq/LvWeB8zcbm83kNXNMTiWTcsLpm9OHyB85/DbU6gs/pSucpUs8pGM92be9kyrO4wRTu+aqB8krc+OPl733e2B/doDfwFI2/q9eFkZ9wAAAABJRU5ErkJggg=="

/***/ }),

/***/ "FNbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GSxG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/set.js
var set = __webpack_require__("lHA8");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-easy-uploader/uploader.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var uploader = ({
  props: ['url'],
  data: function data() {
    return {
      files: [], // 文件缓存
      index: 0 // 序列号
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])({
    imgStore: function imgStore(state) {
      return state.imgstore.img_upload_cache;
    },
    imgPaths: function imgPaths(state) {
      return state.imgstore.img_paths;
    },
    imgStatus: function imgStatus(state) {
      return state.imgstore.img_status;
    }
  })),
  methods: {
    // 选择图片
    selectImgs: function selectImgs() {
      var _this = this;

      var fileList = this.$refs.file.files;
      for (var i = 0; i < fileList.length; i++) {
        // 文件过滤
        if (fileList[i].name.match(/.jpg|.gif|.png|.bmp/i)) {
          (function () {
            var item = {
              key: _this.index++,
              name: fileList[i].name,
              size: fileList[i].size,
              file: fileList[i]
              // 将图片文件转成BASE64格式
            };var reader = new FileReader();
            reader.onload = function (e) {
              _this.$set(item, 'src', e.target.result);
            };
            reader.readAsDataURL(fileList[i]);
            _this.files.push(item);
            _this.$store.commit('set_img_upload_cache', _this.files); // 存储文件缓存
            _this.$store.commit('set_img_status', 'selected'); // 更新文件上传状态
          })();
        }
      }
    },

    // 上传图片
    submit: function submit() {
      var _this2 = this;

      var formData = new FormData();
      this.imgStore.forEach(function (item, index) {
        item.name = 'imgFiles[' + index + ']';
        formData.append(item.name, item.file);
      });
      formData.forEach(function (v, k) {
        return console.log(k, ' => ', v);
      });
      // 新建请求
      var xhr = new XMLHttpRequest();
      xhr.open('POST', this.url, true);
      xhr.send(formData);
      xhr.onload = function () {
        if (xhr.status === 200 || xhr.status === 304) {
          var datas = JSON.parse(xhr.responseText);
          console.log('response: ', datas);
          // 存储返回的地址
          var imgUrlPaths = new set_default.a();
          datas.forEach(function (e) {
            // error === 0为成功状态
            e.error === 0 && imgUrlPaths.add(e.url);
          });
          _this2.$store.commit('set_img_paths', imgUrlPaths); // 存储返回的地址
          _this2.files = []; // 清空文件缓存
          _this2.index = 0; // 初始化序列号
          _this2.$store.commit('set_img_status', 'finished'); // 更新文件上传状态
        } else {
          alert(xhr.status + ' \u8BF7\u6C42\u9519\u8BEF!');
        }
      };
    },

    // 移除图片
    remove: function remove(index) {
      this.files.splice(index, 1);
      this.$store.commit('set_img_upload_cache', this.files); // 更新存储文件缓存
    },

    // 清空图片
    empty: function empty() {
      this.files.splice(0, this.files.length);
      this.$store.commit('set_img_upload_cache', this.files); // 更新存储文件缓存
      this.$store.commit('set_img_paths', []);
    }
  },
  beforeCreate: function beforeCreate() {
    this.$store.commit('set_img_status', 'ready'); // 更新文件上传状态
  },
  destroyed: function destroyed() {
    this.$store.commit('set_img_upload_cache', []);
    this.$store.commit('set_img_paths', []);
  },

  watch: {
    imgStatus: function imgStatus() {
      if (this.imgStatus === 'uploading') {
        this.submit();
      }
    },
    imgStore: function imgStore() {
      if (this.imgStore.length <= 0) {
        this.$store.commit('set_img_status', 'ready'); // 更新文件上传状态
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-easy-uploader/uploader.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var vue_easy_uploader_uploader = ({
  props: ['url'],
  data: function data() {
    return {
      files: [], // 文件缓存
      index: 0 // 序列号
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])({
    imgStore: function imgStore(state) {
      return state.imgstore.img_upload_cache;
    },
    imgPaths: function imgPaths(state) {
      return state.imgstore.img_paths;
    },
    imgStatus: function imgStatus(state) {
      return state.imgstore.img_status;
    }
  })),
  methods: {
    // 选择图片
    selectImgs: function selectImgs() {
      var _this = this;

      var fileList = this.$refs.file.files;
      for (var i = 0; i < fileList.length; i++) {
        // 文件过滤
        if (fileList[i].name.match(/.jpg|.gif|.png|.bmp/i)) {
          (function () {
            var item = {
              key: _this.index++,
              name: fileList[i].name,
              size: fileList[i].size,
              file: fileList[i]
              // 将图片文件转成BASE64格式
            };var reader = new FileReader();
            reader.onload = function (e) {
              _this.$set(item, 'src', e.target.result);
            };
            reader.readAsDataURL(fileList[i]);
            _this.files.push(item);
            _this.$store.commit('set_img_upload_cache', _this.files); // 存储文件缓存
            _this.$store.commit('set_img_status', 'selected'); // 更新文件上传状态
          })();
        }
      }
    },

    // 上传图片
    submit: function submit() {
      var _this2 = this;

      var formData = new FormData();
      this.imgStore.forEach(function (item, index) {
        item.name = 'imgFiles[' + index + ']';
        formData.append(item.name, item.file);
      });
      formData.forEach(function (v, k) {
        return console.log(k, ' => ', v);
      });
      // 新建请求
      var xhr = new XMLHttpRequest();
      xhr.open('POST', this.url, true);
      xhr.send(formData);
      xhr.onload = function () {
        if (xhr.status === 200 || xhr.status === 304) {
          var datas = JSON.parse(xhr.responseText);
          console.log('response: ', datas);
          // 存储返回的地址
          var imgUrlPaths = new set_default.a();
          datas.forEach(function (e) {
            // error === 0为成功状态
            e.error === 0 && imgUrlPaths.add(e.url);
          });
          _this2.$store.commit('set_img_paths', imgUrlPaths); // 存储返回的地址
          _this2.files = []; // 清空文件缓存
          _this2.index = 0; // 初始化序列号
          _this2.$store.commit('set_img_status', 'finished'); // 更新文件上传状态
        } else {
          alert(xhr.status + ' \u8BF7\u6C42\u9519\u8BEF!');
        }
      };
    },

    // 移除图片
    remove: function remove(index) {
      this.files.splice(index, 1);
      this.$store.commit('set_img_upload_cache', this.files); // 更新存储文件缓存
    },

    // 清空图片
    empty: function empty() {
      this.files.splice(0, this.files.length);
      this.$store.commit('set_img_upload_cache', this.files); // 更新存储文件缓存
      this.$store.commit('set_img_paths', []);
    }
  },
  beforeCreate: function beforeCreate() {
    this.$store.commit('set_img_status', 'ready'); // 更新文件上传状态
  },
  destroyed: function destroyed() {
    this.$store.commit('set_img_upload_cache', []);
    this.$store.commit('set_img_paths', []);
  },

  watch: {
    imgStatus: function imgStatus() {
      if (this.imgStatus === 'uploading') {
        this.submit();
      }
    },
    imgStore: function imgStore() {
      if (this.imgStore.length <= 0) {
        this.$store.commit('set_img_status', 'ready'); // 更新文件上传状态
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c75544b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-easy-uploader/uploader.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imgUploader"},[_c('div',{staticClass:"file-list"},[_vm._l((_vm.imgStore),function(file,index){return _c('section',{key:index,staticClass:"file-item draggable-item"},[_c('img',{attrs:{"src":file.src,"alt":"","ondragstart":"return false;"}}),_vm._v(" "),_c('span',{staticClass:"file-remove",on:{"click":function($event){_vm.remove(index)}}},[_vm._v("+")])])}),_vm._v(" "),(_vm.imgStatus !== 'finished')?_c('section',{staticClass:"file-item"},[_c('div',{staticClass:"add"},[_c('span',[_vm._v("+")]),_vm._v(" "),_c('input',{ref:"file",attrs:{"type":"file","pictype":"30010003","multiple":"","data-role":"none","accept":"image/*"},on:{"change":_vm.selectImgs}})])]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"uploadBtn"},[_c('section',[(_vm.imgStore.length > 0)?_c('span',{staticClass:"empty",on:{"click":_vm.empty}},[_vm._v("\n          "+_vm._s(_vm.imgStatus === 'finished' ? '重新上传' : '清空')+"\n      ")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_node_modules_vue_easy_uploader_uploader = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-easy-uploader/uploader.vue
function injectStyle (ssrContext) {
  __webpack_require__("lDWe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c75544b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  vue_easy_uploader_uploader,
  selectortype_template_index_0_node_modules_vue_easy_uploader_uploader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var node_modules_vue_easy_uploader_uploader = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GgSw":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Gmjg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GwFB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HD9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-928b9794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("/Wfl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HZwK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IGUU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IWdX":
/***/ (function(module, exports) {

//
//
//
//
//
//

/***/ }),

/***/ "Js7q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KB9y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KFCM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LHZU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LbyF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_popup_header_index_vue__ = __webpack_require__("WZtS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_group_index_vue__ = __webpack_require__("rHil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_input_index_vue__ = __webpack_require__("pDNl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_popup_picker_index_vue__ = __webpack_require__("7Ah8");






/* unused harmony default export */ var _unused_webpack_default_export = ({
  data: function data() {
    return {
      value1: "",
      muSid: '',
      value3: ['本人'],
      list1: [["亲戚", "老师", "朋友"]],
      phones: '',
      openids: ''
    };
  },
  beforeMount: function beforeMount() {
    this.muSid = this.$router.history.current.query.msId;
    this.phones = this.$router.history.current.query.phone;
    this.openids = this.$router.history.current.query.openid;
    var urls = global.host + 'users/personalCenter';
    this.$http.get(urls).then(function (res) {}, function (err) {
      console.log(err);
    });
  },

  components: {
    PopupHeader: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_popup_header_index_vue__["a" /* default */],
    Group: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_group_index_vue__["a" /* default */],
    XInput: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_input_index_vue__["a" /* default */],
    PopupPicker: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_popup_picker_index_vue__["a" /* default */]
  },
  methods: {
    cancle: function cancle() {
      this.$router.push({ path: '/userinfo', query: { openid: this.openids, phone: this.phones } });
    },
    colectMethod: function colectMethod() {
      var urls = global.host + 'users/personalCenter';
      this.$http.get(urls).then(function (res) {
        this.$router.push({ path: '/userinfo', query: { openid: openids, phone: phones } });
      }, function (err) {
        console.log(err);
      });
    },
    onChanges: function onChanges() {}
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "Lc37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LwSa":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "MKn2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mxs7":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAABGhJREFUWAnNmUtME0EYgP9Z2iKK+OClIHIQDKCoiSYaFUQTjZ4UY2OiB+8Go1ETDxqMJj4OEDUxHrwZD8ZgJB7VxAiKN+MDRBTxBRQK1ChvtqXj/0+7zW67pbtlW50Euzv7P775Z3dm/l8GcbYdnS0rZJ93L/jZemA8jwHLA87zhDnGXBy4CzhzgcRfO2z2R8+Kt3TF44qZUdr1pSVnQvbWcIBq4LDajC4waENnjWkO+80nRVsGjOoaAqwa+JDu8wydYn5+GuHSjRrXk0OHo1xidbbMrPrnOatG9WTUfTEBKz827ff7+S1UylUrWnDtliR2tLl028OZbEnRHnLO2daPTef9HB6gjNVw5DaXbJMP8hWNQ/eBs/tVWt+wfAeVnNEULe5vWJrhONJQsHki3G5EBGk0SYYjJif51ItkBGBFR3MtKYSPJAn3zqBvjSvNFIsPgt65Gd4JjbbVN4zhBw4H1B9OCFAsJYODX9BnIj4IM0Nx27Kzi5QlKDTFtM79B3A0kNwgixiUiKDYIaa8XbNdhIVFC/5BqNG0VPsK2nFEBMdl37FEw5WnZcDD4k3womwbNJVWwo6M7KhDIRbaUkkgOMV8X1RpCx6sm7sA6grXQLY9VVir7+uEZ8ODM1pGyGoSYOJUInvp40hI2zBvIVwpWA1zpBRh/5a7C+55egz5cjjsRZI4MhkSNy+0cd4iuFpQHoK7O/TTMBx5IzZJnOfM+46psTk9Ey5j5FKlwFvU+MsFtwe+xdTTCOBZ00aHTTzbWdoq5mfBxWWlYGMBuKd/3HCtv9O8D2Sz0UkYT78xldPxHUJZISdzP0zhn17bjl9nbT7BBWRbRjxwqbfDgIdIa8RmCx3TI59renYvXALHlxSJPh/ncN/TLaZMjbkzIwfO5pdAShDuzdhvqO35ANMaSyZuMIWQOO5/RlQe/OqFG/2Bj52iczhrOVwvXAuLUuxCfc+CXDinguuYGIEz3W0g42DibcTGKtqbPuExZ6VRIwcW54ciSTpD3il4jO/YocwCYMHIfZsag5rvb2F42mfUrK4c2vssiexL97F+pzqSJJGFiy9FU4Hrkyfh5I/3s4Yj28QmidSQ7ky0cEhF1eOT4cSPdzCEv5Y0TFslylvjMRYOOTLtFZFzeSfjMaevg2wSJdX6T2P3KpDj/mk4/bMVvuK7Z2UjNrFYbW1/3ooTbi4RV5Fk2hxA02tpw0T/ZVlVuVjqkbJxNsYth0MYhUkAUjkCO2Jm+bMZhBldYiEm0hGAdHKlcoQZI4mUJRalfhPYzdEb1Urwx51IxwZtu4MsQjwESFkU1UpwxY1/bzJIEFWM0k5kUDI6kgsB0o3IRxlcoOt/0tC3OicmBnwftY3KD7g/38feZFcXGjChOohbpmYGNREkVBKgQg5eNtB9kpooHoXDke+ICCpAIpJUp+FwPmGlEIoWTuuLksqLenAzAiqg/7qAGTWCCiD9/tclYDUolUioCoEntX2m9+5EFtHVkMp1sv4b4i9p287W1VQC7gAAAABJRU5ErkJggg=="

/***/ }),

/***/ "N7uh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NF7M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vue-easy-uploader/index.js + 1 modules
var vue_easy_uploader = __webpack_require__("FwIe");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af94ad74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("topb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue + 3 modules
var flexbox = __webpack_require__("YxJB");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue + 3 modules
var flexbox_item = __webpack_require__("3Lt7");

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup-picker/index.vue + 7 modules
var popup_picker = __webpack_require__("7Ah8");

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vux/src/components/swiper/swiper.js
var swiper = __webpack_require__("NjrX");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["b" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val) {
      this.rerender();
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["b" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val) {
      this.rerender();
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e45d3b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper.vue
var swiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){_vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){_vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}))])}
var swiper_staticRenderFns = []
var swiper_esExports = { render: swiper_render, staticRenderFns: swiper_staticRenderFns }
/* harmony default export */ var src_components_swiper_swiper = (swiper_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper.vue
function swiper_injectStyle (ssrContext) {
  __webpack_require__("VrI9")
}
var swiper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper___vue_template_functional__ = false
/* styles */
var swiper___vue_styles__ = swiper_injectStyle
/* scopeId */
var swiper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper___vue_module_identifier__ = null
var swiper_Component = swiper_normalizeComponent(
  components_swiper_swiper,
  src_components_swiper_swiper,
  swiper___vue_template_functional__,
  swiper___vue_styles__,
  swiper___vue_scopeId__,
  swiper___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_swiper_swiper = (swiper_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/index.vue + 3 modules
var cell = __webpack_require__("1DHf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9b2d09a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swiper-item"},[_vm._t("default")],2)}
var swiper_item_staticRenderFns = []
var swiper_item_esExports = { render: swiper_item_render, staticRenderFns: swiper_item_staticRenderFns }
/* harmony default export */ var components_swiper_swiper_item = (swiper_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper_item___vue_template_functional__ = false
/* styles */
var swiper_item___vue_styles__ = null
/* scopeId */
var swiper_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper_item___vue_module_identifier__ = null
var swiper_item_Component = swiper_item_normalizeComponent(
  swiper_swiper_item,
  components_swiper_swiper_item,
  swiper_item___vue_template_functional__,
  swiper_item___vue_styles__,
  swiper_item___vue_scopeId__,
  swiper_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swiper_swiper_item = (swiper_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux-blazy/blazy.js
var blazy = __webpack_require__("iRq5");
var blazy_default = /*#__PURE__*/__webpack_require__.n(blazy);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/webp-support.js
var webp_support = __webpack_require__("p3QP");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-img/index.vue
//
//
//
//





/* harmony default export */ var x_img = ({
  name: 'x-img',
  mixins: [mixin_uuid["a" /* default */]],
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.init);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.blazy && this.blazy.destroy();
      this.$el.src = this.defaultSrc;
      this.$el.className = this.$el.className.replace('b-loaded', '');

      this.blazy = new blazy_default.a({
        scroller: this.scroller,
        container: this.container,
        selector: '#vux-ximg-' + this.uuid,
        offset: _this.offset,
        errorClass: _this.errorClass,
        successClass: _this.successClass,
        success: function success(ele) {
          _this.$emit('on-success', _this.src, ele);
        },
        error: function error(ele, msg) {
          _this.$emit('on-error', _this.src, ele, msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$el.setAttribute('id', 'vux-ximg-' + this.uuid);
    this.$nextTick(function () {
      setTimeout(function () {
        _this2.init();
      }, _this2.delay);
    });
    Object(webp_support["a" /* detectWebp */])();
  },

  computed: {
    currentSrc: function currentSrc() {
      if (Object(webp_support["b" /* isSupported */])() && this.webpSrc) {
        return this.webpSrc;
      }
      return this.src;
    }
  },
  props: {
    src: String,
    webpSrc: String,
    defaultSrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    errorClass: String,
    successClass: String,
    offset: {
      type: Number,
      default: 100
    },
    scroller: Object,
    container: String,
    delay: {
      type: Number,
      default: 0
    }
  },
  watch: {
    src: function src(val) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blazy && this.blazy.destroy();
    this.blazy = null;
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.init);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-img/index.vue
//
//
//
//





/* harmony default export */ var components_x_img = ({
  name: 'x-img',
  mixins: [mixin_uuid["a" /* default */]],
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.init);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.blazy && this.blazy.destroy();
      this.$el.src = this.defaultSrc;
      this.$el.className = this.$el.className.replace('b-loaded', '');

      this.blazy = new blazy_default.a({
        scroller: this.scroller,
        container: this.container,
        selector: '#vux-ximg-' + this.uuid,
        offset: _this.offset,
        errorClass: _this.errorClass,
        successClass: _this.successClass,
        success: function success(ele) {
          _this.$emit('on-success', _this.src, ele);
        },
        error: function error(ele, msg) {
          _this.$emit('on-error', _this.src, ele, msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$el.setAttribute('id', 'vux-ximg-' + this.uuid);
    this.$nextTick(function () {
      setTimeout(function () {
        _this2.init();
      }, _this2.delay);
    });
    Object(webp_support["a" /* detectWebp */])();
  },

  computed: {
    currentSrc: function currentSrc() {
      if (Object(webp_support["b" /* isSupported */])() && this.webpSrc) {
        return this.webpSrc;
      }
      return this.src;
    }
  },
  props: {
    src: String,
    webpSrc: String,
    defaultSrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    errorClass: String,
    successClass: String,
    offset: {
      type: Number,
      default: 100
    },
    scroller: Object,
    container: String,
    delay: {
      type: Number,
      default: 0
    }
  },
  watch: {
    src: function src(val) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blazy && this.blazy.destroy();
    this.blazy = null;
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.init);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aca665e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-img/index.vue
var x_img_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vux-x-img",attrs:{"src":_vm.defaultSrc,"data-src":_vm.currentSrc}})}
var x_img_staticRenderFns = []
var x_img_esExports = { render: x_img_render, staticRenderFns: x_img_staticRenderFns }
/* harmony default export */ var src_components_x_img = (x_img_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-img/index.vue
function x_img_injectStyle (ssrContext) {
  __webpack_require__("fZR+")
}
var x_img_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_img___vue_template_functional__ = false
/* styles */
var x_img___vue_styles__ = x_img_injectStyle
/* scopeId */
var x_img___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_img___vue_module_identifier__ = null
var x_img_Component = x_img_normalizeComponent(
  components_x_img,
  src_components_x_img,
  x_img___vue_template_functional__,
  x_img___vue_styles__,
  x_img___vue_scopeId__,
  x_img___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_img = (x_img_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/alert/index.vue + 3 modules
var components_alert = __webpack_require__("mzja");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/marquee/marquee.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var marquee = ({
  name: 'marquee',
  props: {
    interval: {
      type: Number,
      default: 2000
    },
    duration: {
      type: Number,
      default: 300
    },
    direction: {
      type: String,
      default: 'up'
    },
    itemHeight: Number
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  },
  data: function data() {
    return {
      currenTranslateY: 0,
      height: '',
      length: 0,
      currentIndex: 0,
      noAnimate: false
    };
  },

  methods: {
    destroy: function destroy() {
      this.timer && clearInterval(this.timer);
    },
    init: function init() {
      this.destroy();

      if (this.cloneNode) {
        this.$refs.box.removeChild(this.cloneNode);
      }

      this.cloneNode = null;
      var firstItem = this.$refs.box.firstElementChild;
      if (!firstItem) {
        return false;
      }
      this.length = this.$refs.box.children.length;
      this.height = this.itemHeight || firstItem.offsetHeight;

      if (this.direction === 'up') {
        this.cloneNode = firstItem.cloneNode(true);
        this.$refs.box.appendChild(this.cloneNode);
      } else {
        this.cloneNode = this.$refs.box.lastElementChild.cloneNode(true);
        this.$refs.box.insertBefore(this.cloneNode, firstItem);
      }
      return true;
    },
    start: function start() {
      var _this = this;

      if (this.direction === 'down') this.go(false);
      this.timer = setInterval(function () {
        if (_this.direction === 'up') {
          _this.currentIndex += 1;
          _this.currenTranslateY = -_this.currentIndex * _this.height;
        } else {
          _this.currentIndex -= 1;
          _this.currenTranslateY = -(_this.currentIndex + 1) * _this.height;
        }
        if (_this.currentIndex === _this.length) {
          setTimeout(function () {
            _this.go(true);
          }, _this.duration);
        } else if (_this.currentIndex === -1) {
          setTimeout(function () {
            _this.go(false);
          }, _this.duration);
        } else {
          _this.noAnimate = false;
        }
      }, this.interval + this.duration);
    },
    go: function go(toFirst) {
      this.noAnimate = true;
      if (toFirst) {
        this.currentIndex = 0;
        this.currenTranslateY = 0;
      } else {
        this.currentIndex = this.length - 1;
        this.currenTranslateY = -(this.currentIndex + 1) * this.height;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/marquee/marquee.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var marquee_marquee = ({
  name: 'marquee',
  props: {
    interval: {
      type: Number,
      default: 2000
    },
    duration: {
      type: Number,
      default: 300
    },
    direction: {
      type: String,
      default: 'up'
    },
    itemHeight: Number
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  },
  data: function data() {
    return {
      currenTranslateY: 0,
      height: '',
      length: 0,
      currentIndex: 0,
      noAnimate: false
    };
  },

  methods: {
    destroy: function destroy() {
      this.timer && clearInterval(this.timer);
    },
    init: function init() {
      this.destroy();

      if (this.cloneNode) {
        this.$refs.box.removeChild(this.cloneNode);
      }

      this.cloneNode = null;
      var firstItem = this.$refs.box.firstElementChild;
      if (!firstItem) {
        return false;
      }
      this.length = this.$refs.box.children.length;
      this.height = this.itemHeight || firstItem.offsetHeight;

      if (this.direction === 'up') {
        this.cloneNode = firstItem.cloneNode(true);
        this.$refs.box.appendChild(this.cloneNode);
      } else {
        this.cloneNode = this.$refs.box.lastElementChild.cloneNode(true);
        this.$refs.box.insertBefore(this.cloneNode, firstItem);
      }
      return true;
    },
    start: function start() {
      var _this = this;

      if (this.direction === 'down') this.go(false);
      this.timer = setInterval(function () {
        if (_this.direction === 'up') {
          _this.currentIndex += 1;
          _this.currenTranslateY = -_this.currentIndex * _this.height;
        } else {
          _this.currentIndex -= 1;
          _this.currenTranslateY = -(_this.currentIndex + 1) * _this.height;
        }
        if (_this.currentIndex === _this.length) {
          setTimeout(function () {
            _this.go(true);
          }, _this.duration);
        } else if (_this.currentIndex === -1) {
          setTimeout(function () {
            _this.go(false);
          }, _this.duration);
        } else {
          _this.noAnimate = false;
        }
      }, this.interval + this.duration);
    },
    go: function go(toFirst) {
      this.noAnimate = true;
      if (toFirst) {
        this.currentIndex = 0;
        this.currenTranslateY = 0;
      } else {
        this.currentIndex = this.length - 1;
        this.currenTranslateY = -(this.currentIndex + 1) * this.height;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c625a4a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/marquee/marquee.vue
var marquee_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-marquee",style:({height: _vm.height + 'px'})},[_c('ul',{ref:"box",staticClass:"vux-marquee-box",style:({transform: ("translate3d(0," + _vm.currenTranslateY + "px,0)"), transition: ("transform " + (_vm.noAnimate ? 0 : _vm.duration) + "ms")})},[_vm._t("default")],2)])}
var marquee_staticRenderFns = []
var marquee_esExports = { render: marquee_render, staticRenderFns: marquee_staticRenderFns }
/* harmony default export */ var components_marquee_marquee = (marquee_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/marquee/marquee.vue
function marquee_injectStyle (ssrContext) {
  __webpack_require__("qNPa")
}
var marquee_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var marquee___vue_template_functional__ = false
/* styles */
var marquee___vue_styles__ = marquee_injectStyle
/* scopeId */
var marquee___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var marquee___vue_module_identifier__ = null
var marquee_Component = marquee_normalizeComponent(
  marquee_marquee,
  components_marquee_marquee,
  marquee___vue_template_functional__,
  marquee___vue_styles__,
  marquee___vue_scopeId__,
  marquee___vue_module_identifier__
)

/* harmony default export */ var src_components_marquee_marquee = (marquee_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/marquee/marquee-item.vue
//
//
//
//
//
//

/* harmony default export */ var marquee_item = ({
  name: 'marquee-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.destroy();
      _this.$parent.init();
      _this.$parent.start();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/marquee/marquee-item.vue
//
//
//
//
//
//

/* harmony default export */ var marquee_marquee_item = ({
  name: 'marquee-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.destroy();
      _this.$parent.init();
      _this.$parent.start();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03f1fc62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/marquee/marquee-item.vue
var marquee_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._t("default")],2)}
var marquee_item_staticRenderFns = []
var marquee_item_esExports = { render: marquee_item_render, staticRenderFns: marquee_item_staticRenderFns }
/* harmony default export */ var components_marquee_marquee_item = (marquee_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/marquee/marquee-item.vue
var marquee_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var marquee_item___vue_template_functional__ = false
/* styles */
var marquee_item___vue_styles__ = null
/* scopeId */
var marquee_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var marquee_item___vue_module_identifier__ = null
var marquee_item_Component = marquee_item_normalizeComponent(
  marquee_marquee_item,
  components_marquee_marquee_item,
  marquee_item___vue_template_functional__,
  marquee_item___vue_styles__,
  marquee_item___vue_scopeId__,
  marquee_item___vue_module_identifier__
)

/* harmony default export */ var src_components_marquee_marquee_item = (marquee_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var components_load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adb1491a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/load-more/index.vue
var load_more_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-loadmore weui-loadmore",class:{'weui-loadmore_line':!_vm.showLoading, 'weui-loadmore_dot': !_vm.showLoading && !_vm.tip}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tip || !_vm.showLoading),expression:"tip || !showLoading"}],staticClass:"weui-loadmore__tips"},[_vm._v(_vm._s(_vm.tip))])])}
var load_more_staticRenderFns = []
var load_more_esExports = { render: load_more_render, staticRenderFns: load_more_staticRenderFns }
/* harmony default export */ var src_components_load_more = (load_more_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/load-more/index.vue
function load_more_injectStyle (ssrContext) {
  __webpack_require__("+BAp")
}
var load_more_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var load_more___vue_template_functional__ = false
/* styles */
var load_more___vue_styles__ = load_more_injectStyle
/* scopeId */
var load_more___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var load_more___vue_module_identifier__ = null
var load_more_Component = load_more_normalizeComponent(
  components_load_more,
  src_components_load_more,
  load_more___vue_template_functional__,
  load_more___vue_styles__,
  load_more___vue_scopeId__,
  load_more___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_load_more = (load_more_Component.exports);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12306fcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",[_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){_vm.$emit('on-click-title')}}},[_vm._t("default",[_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])])],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){_vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var x_header_staticRenderFns = []
var x_header_esExports = { render: x_header_render, staticRenderFns: x_header_staticRenderFns }
/* harmony default export */ var src_components_x_header = (x_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function x_header_injectStyle (ssrContext) {
  __webpack_require__("4d+Q")
}
var x_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_header___vue_template_functional__ = false
/* styles */
var x_header___vue_styles__ = x_header_injectStyle
/* scopeId */
var x_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_header___vue_module_identifier__ = null
var x_header_Component = x_header_normalizeComponent(
  components_x_header,
  src_components_x_header,
  x_header___vue_template_functional__,
  x_header___vue_styles__,
  x_header___vue_scopeId__,
  x_header___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (x_header_Component.exports);

// CONCATENATED MODULE: ./static/js/global.js
/*生产环境*/
var host = 'https://wuye.youmeijia.net/';
var baseImg = "http://image.h5.wuye.youmeijia.net/";
var imgUrl = 'http://wuye.youmeijia.net';

/*生产环境(耀客松)*/
// const host = 'http://wuye.yaokesong.com:12356/';
// const baseImg = "http://wuye.yaokesong.com/";
// const imgUrl = 'http://wuye.yaokesong.com';

/*开发环境*/
// const host = 'http://192.168.1.100:12354/';
// const baseImg = 'http://192.168.1.100:8081/';
// const imgUrl = 'http://sq.datamavin.cn';

/*测试环境*/
// const host = 'http://114.116.27.40:12354/';
// const baseImg = "http://114.116.27.40:12364/images/";

//本地数据
// const host = 'http://youmeijia.ngrok.xiaomiqiu.cn/';
// const host = 'http://192.168.1.100:12354/';
// const baseImg = "http://images.ngrok.xiaomiqiu.cn/";

var SMSHost = 'http://120.78.69.176:12353/';

/*生产环境*/
var wechat = {
  corpid: 'wx3921ae84c7b2fd56',
  corpsecret: 'd44a75efa20443927e546393a7154dd7'

  /*生产环境(耀客松)*/
  // const wechat = {
  //   corpid:'wx7c7073559f0c012e',
  //   corpsecret:'cc45927ba99a6842b4e2653477e2f47d'
  // }

  /*测试环境*/
  // const wechat = {
  //    corpid:'wxf425aaf70ac87365',
  //    corpsecret:'222c3245ca976cf6df8bb24070483035'
  // }

};var dingding = {
  corpid: 'ding4d93dde8c21f381e35c2f4657eb6378f',
  corpsecret: '0Q1wnX39_i9hWMYrZlQp3IxZrobkHlJp3xGXhQye5Xh9MinJP9UzAFAGZp7R4gs6'
};

/* harmony default export */ var global = ({
  host: host,
  wechat: wechat,
  dingding: dingding,
  SMSHost: SMSHost,
  imgUrl: imgUrl,
  baseImg: baseImg
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef6948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({ position: _vm.position })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var loading_staticRenderFns = []
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var src_components_loading = (loading_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function loading_injectStyle (ssrContext) {
  __webpack_require__("S/I2")
}
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = loading_injectStyle
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  components_loading,
  src_components_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loadingPage.vue



/* harmony default export */ var loadingPage = ({
  data: function data() {
    return {};
  },

  components: {
    Loading: vux_src_components_loading
  },
  props: ['shows', 'text_1']
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loadingPage.vue



/* harmony default export */ var components_loadingPage = ({
  data: function data() {
    return {};
  },

  components: {
    Loading: vux_src_components_loading
  },
  props: ['shows', 'text_1']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dd04ed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadingPage.vue
var loadingPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading',{attrs:{"show":_vm.shows,"text":_vm.text_1}})],1)}
var loadingPage_staticRenderFns = []
var loadingPage_esExports = { render: loadingPage_render, staticRenderFns: loadingPage_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_loadingPage = (loadingPage_esExports);
// CONCATENATED MODULE: ./src/components/loadingPage.vue
var loadingPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loadingPage___vue_template_functional__ = false
/* styles */
var loadingPage___vue_styles__ = null
/* scopeId */
var loadingPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loadingPage___vue_module_identifier__ = null
var loadingPage_Component = loadingPage_normalizeComponent(
  components_loadingPage,
  selectortype_template_index_0_src_components_loadingPage,
  loadingPage___vue_template_functional__,
  loadingPage___vue_styles__,
  loadingPage___vue_scopeId__,
  loadingPage___vue_module_identifier__
)

/* harmony default export */ var src_components_loadingPage = (loadingPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/index.vue

















/* harmony default export */ var components = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    Cell: cell["a" /* default */],
    SwiperItem: src_components_swiper_swiper_item,
    XImg: vux_src_components_x_img,
    Alert: components_alert["a" /* default */],
    Marquee: src_components_marquee_marquee,
    MarqueeItem: src_components_marquee_marquee_item,
    LoadMore: vux_src_components_load_more,
    loadPage: src_components_loadingPage,
    XHeader: vux_src_components_x_header
  },
  data: function data() {
    return {
      loopList: [],
      communityName: '    ',
      funcEnter: '',
      temp: [0, 1, 2],
      advList: [],
      communityId: '',
      openid: this.$router.history.current.query.openid,
      phone: this.$router.history.current.query.phone,
      show: false,
      newList: [],
      comnCodes: '',
      show_loading: false
    };
  },
  beforeMount: function beforeMount() {
    this.show_loading = true;
    /*正式环境*/
    var urlother = global.host + 'home/home/' + this.$router.history.current.query.openid + '/' + this.$router.history.current.query.phone;
    /*测试环境*/

    this.$http.get(urlother).then(function (res) {
      if (res.body.result) {
        /*传给商家入驻的参数*/
        this.comnCodes = res.body.result.loopPictureList[0].comnCode;

        this.communityName = res.body.result.community.comnName;
        this.communityId = res.body.result.community.comnCode;
        this.$http.get(global.host + 'home/findimportnotice?comnCode=' + this.communityId).then(function (res) {
          console.log(res);

          var data = res.body.result;
          for (var i = 0; i < data.length; i++) {
            var temp = new Object();
            temp.title = data[i].newsTitle;
            temp.id = data[i].newsId;
            this.newList.push(temp);
          }
        }, function (err) {
          console.log(err);
        });

        /*图片轮播数据处理*/
        var loopPictureList = res.body.result.loopPictureList;
        this.loopList = new Array();
        for (var i = 0; i < loopPictureList.length; i++) {
          this.loopList[i] = loopPictureList[i];
        }
        /*功能入口数据处理*/
        this.funcEnter = new Array();
        var funcList = res.body.result.funcList;
        var beginIndex = 0;
        if (funcList.length <= 12) {
          for (var _i = 0; _i < funcList.length; _i++) {
            if (_i == 0) {
              this.funcEnter[beginIndex] = new Array();
              this.funcEnter[beginIndex][_i % 4] = new Object();
            } else if (_i != 0 && _i % 4 == 0) {
              beginIndex++;
              this.funcEnter[beginIndex] = new Array();
              this.funcEnter[beginIndex][_i % 4] = new Object();
            } else {
              this.funcEnter[beginIndex][_i % 4] = new Object();
            }
            for (var prop in funcList[_i]) {
              if (prop == 'icon') {
                this.funcEnter[beginIndex][_i % 4][prop] = funcList[_i][prop];
              } else {
                this.funcEnter[beginIndex][_i % 4][prop] = funcList[_i][prop];
              }
            }
          }
        } else {
          for (var _i2 = 0; _i2 < 11; _i2++) {
            if (_i2 == 0) {
              this.funcEnter[beginIndex] = new Array();
              this.funcEnter[beginIndex][_i2 % 4] = new Object();
            } else if (_i2 != 0 && _i2 % 4 == 0) {
              beginIndex++;
              this.funcEnter[beginIndex] = new Array();
              this.funcEnter[beginIndex][_i2 % 4] = new Object();
            } else {
              this.funcEnter[beginIndex][_i2 % 4] = new Object();
            }
            for (var _prop in funcList[_i2]) {
              if (_prop == 'icon') {
                this.funcEnter[beginIndex][_i2 % 4][_prop] = funcList[_i2][_prop];
              } else {
                this.funcEnter[beginIndex][_i2 % 4][_prop] = funcList[_i2][_prop];
              }
            }
          }
          var more = {
            icon: global.imgUrl + '/image/more.png',
            title: '更多',
            remark: '更多入口',
            link: '',
            show: false
          };
          this.funcEnter[beginIndex].push(more);
        }
        /*广告位数据处理*/
        this.advList = new Array();
        var adv = res.body.result.advertisementList;
        for (var _i3 = 0; _i3 < adv.length; _i3++) {
          this.advList[_i3] = new Object();
          for (var _prop2 in adv[_i3]) {
            if (_prop2 == 'image') {
              this.advList[_i3][_prop2] = adv[_i3][_prop2];
            } else {
              this.advList[_i3][_prop2] = adv[_i3][_prop2];
            }
          }
        }
        this.show_loading = false;
      }
    }, function (err) {
      this.show_loading = false;
      console.log(err);
    });
  },

  methods: {
    showAlert: function showAlert(url) {
      if (url == '/') {
        this.show = true;
      } else if (url.indexOf('tel:') != -1) {
        window.location.href = url;
      }
    },
    gotoNotice: function gotoNotice(id) {
      this.$router.push({ path: '/notice', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, id: id, communityId: this.communityId } });
    }
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/") {
      if (global.host.indexOf('yaokesong') == -1) {
        document.title = "优每家";
      } else {
        document.title = "耀客松平安社区";
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/index.vue

















/* harmony default export */ var selectortype_script_index_0_src_components = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    Cell: cell["a" /* default */],
    SwiperItem: src_components_swiper_swiper_item,
    XImg: vux_src_components_x_img,
    Alert: components_alert["a" /* default */],
    Marquee: src_components_marquee_marquee,
    MarqueeItem: src_components_marquee_marquee_item,
    LoadMore: vux_src_components_load_more,
    loadPage: src_components_loadingPage,
    XHeader: vux_src_components_x_header
  },
  data: function data() {
    return {
      loopList: [],
      communityName: '    ',
      funcEnter: '',
      temp: [0, 1, 2],
      advList: [],
      communityId: '',
      openid: this.$router.history.current.query.openid,
      phone: this.$router.history.current.query.phone,
      show: false,
      newList: [],
      comnCodes: '',
      show_loading: false
    };
  },
  beforeMount: function beforeMount() {
    this.show_loading = true;
    /*正式环境*/
    var urlother = global.host + 'home/home/' + this.$router.history.current.query.openid + '/' + this.$router.history.current.query.phone;
    /*测试环境*/

    this.$http.get(urlother).then(function (res) {
      if (res.body.result) {
        /*传给商家入驻的参数*/
        this.comnCodes = res.body.result.loopPictureList[0].comnCode;

        this.communityName = res.body.result.community.comnName;
        this.communityId = res.body.result.community.comnCode;
        this.$http.get(global.host + 'home/findimportnotice?comnCode=' + this.communityId).then(function (res) {
          console.log(res);

          var data = res.body.result;
          for (var i = 0; i < data.length; i++) {
            var temp = new Object();
            temp.title = data[i].newsTitle;
            temp.id = data[i].newsId;
            this.newList.push(temp);
          }
        }, function (err) {
          console.log(err);
        });

        /*图片轮播数据处理*/
        var loopPictureList = res.body.result.loopPictureList;
        this.loopList = new Array();
        for (var i = 0; i < loopPictureList.length; i++) {
          this.loopList[i] = loopPictureList[i];
        }
        /*功能入口数据处理*/
        this.funcEnter = new Array();
        var funcList = res.body.result.funcList;
        var beginIndex = 0;
        if (funcList.length <= 12) {
          for (var _i = 0; _i < funcList.length; _i++) {
            if (_i == 0) {
              this.funcEnter[beginIndex] = new Array();
              this.funcEnter[beginIndex][_i % 4] = new Object();
            } else if (_i != 0 && _i % 4 == 0) {
              beginIndex++;
              this.funcEnter[beginIndex] = new Array();
              this.funcEnter[beginIndex][_i % 4] = new Object();
            } else {
              this.funcEnter[beginIndex][_i % 4] = new Object();
            }
            for (var prop in funcList[_i]) {
              if (prop == 'icon') {
                this.funcEnter[beginIndex][_i % 4][prop] = funcList[_i][prop];
              } else {
                this.funcEnter[beginIndex][_i % 4][prop] = funcList[_i][prop];
              }
            }
          }
        } else {
          for (var _i2 = 0; _i2 < 11; _i2++) {
            if (_i2 == 0) {
              this.funcEnter[beginIndex] = new Array();
              this.funcEnter[beginIndex][_i2 % 4] = new Object();
            } else if (_i2 != 0 && _i2 % 4 == 0) {
              beginIndex++;
              this.funcEnter[beginIndex] = new Array();
              this.funcEnter[beginIndex][_i2 % 4] = new Object();
            } else {
              this.funcEnter[beginIndex][_i2 % 4] = new Object();
            }
            for (var _prop in funcList[_i2]) {
              if (_prop == 'icon') {
                this.funcEnter[beginIndex][_i2 % 4][_prop] = funcList[_i2][_prop];
              } else {
                this.funcEnter[beginIndex][_i2 % 4][_prop] = funcList[_i2][_prop];
              }
            }
          }
          var more = {
            icon: global.imgUrl + '/image/more.png',
            title: '更多',
            remark: '更多入口',
            link: '',
            show: false
          };
          this.funcEnter[beginIndex].push(more);
        }
        /*广告位数据处理*/
        this.advList = new Array();
        var adv = res.body.result.advertisementList;
        for (var _i3 = 0; _i3 < adv.length; _i3++) {
          this.advList[_i3] = new Object();
          for (var _prop2 in adv[_i3]) {
            if (_prop2 == 'image') {
              this.advList[_i3][_prop2] = adv[_i3][_prop2];
            } else {
              this.advList[_i3][_prop2] = adv[_i3][_prop2];
            }
          }
        }
        this.show_loading = false;
      }
    }, function (err) {
      this.show_loading = false;
      console.log(err);
    });
  },

  methods: {
    showAlert: function showAlert(url) {
      if (url == '/') {
        this.show = true;
      } else if (url.indexOf('tel:') != -1) {
        window.location.href = url;
      }
    },
    gotoNotice: function gotoNotice(id) {
      this.$router.push({ path: '/notice', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, id: id, communityId: this.communityId } });
    }
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/") {
      if (global.host.indexOf('yaokesong') == -1) {
        document.title = "优每家";
      } else {
        document.title = "耀客松平安社区";
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc8e7760","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
var components_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.communityName)?_c('div',[_c('group',{staticClass:"indexpage"},[_c('cell',{staticStyle:{"text-align":"center"},attrs:{"title":_vm.communityName}})],1),_vm._v(" "),_c('div',[_c('swiper',{staticStyle:{"width":"100%"},attrs:{"aspect-ratio":100/230,"auto":"","dots-class":"custom-bottom","dots-position":"center"}},_vm._l((_vm.loopList),function(item,index){return _c('swiper-item',{key:index,staticClass:"am-swiperList"},[_c('router-link',{attrs:{"to":{path:item.link,query:{openid:_vm.openid,phone:_vm.phone,communityId:_vm.communityId}}}},[_c('img',{attrs:{"src":item.image}})])],1)}))],1),_vm._v(" "),_c('group',{staticStyle:{"margin-top":"-1.37647em"}},[_c('cell',{staticStyle:{"font-size":"0.8em"},attrs:{"title":"重要通知","primary":"content"}},[_c('marquee',{staticStyle:{"height":"19px","overflow":"hidden","line-height":"1.5","text-align":"left"}},_vm._l((_vm.newList),function(item,index){return _c('marquee-item',{key:index,staticStyle:{"color":"red"},nativeOn:{"click":function($event){_vm.gotoNotice(item.id)}}},[_vm._v(_vm._s(item.title))])}))],1)],1),_vm._v(" "),_vm._l((_vm.temp),function(currentIndex,index){return _c('flexbox',{key:index,staticStyle:{"padding-top":"6%"}},_vm._l((_vm.funcEnter[index]),function(item,idx){return _c('flexbox-item',{key:idx},[(item.link.indexOf('tel:') != -1)?_c('router-link',{attrs:{"to":{path:'#'}},nativeOn:{"click":function($event){_vm.showAlert(item.link)}}},[_c('div',{staticClass:"iconbox"},[_c('x-img',{attrs:{"src":item.icon,"alt":item.remark}}),_c('span',[_vm._v(_vm._s(item.title))])],1)]):_c('router-link',{attrs:{"to":{path:item.link,query:{communityId:_vm.communityId,openid:_vm.openid,phone:_vm.phone,comnCode:_vm.comnCodes,comnCodes:_vm.comnCodes,communityName:_vm.communityName}}},nativeOn:{"click":function($event){_vm.showAlert(item.link)}}},[_c('div',{staticClass:"iconbox"},[_c('x-img',{attrs:{"src":item.icon,"alt":item.remark}}),_c('span',[_vm._v(_vm._s(item.title))])],1)])],1)}))}),_vm._v(" "),_c('div',{staticStyle:{"height":"15px"}}),_vm._v(" "),_vm._l((_vm.advList),function(item,index){return _c('div',{key:index,staticStyle:{"width":"50%","display":"inline-block"}},[_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_c('x-img',{attrs:{"src":item.image,"alt":item.remark}})],1)])}),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v("功能暂未上线"),_c('br'),_vm._v("敬请期待")])],1)],2):_c('div',{staticStyle:{"padding-top":"55%"}},[_c('load-more',{attrs:{"tip":"正在加载"}})],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_loading}})],1)}
var components_staticRenderFns = []
var components_esExports = { render: components_render, staticRenderFns: components_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components = (components_esExports);
// CONCATENATED MODULE: ./src/components/index.vue
function components_injectStyle (ssrContext) {
  __webpack_require__("/2eN")
}
var components_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var components___vue_template_functional__ = false
/* styles */
var components___vue_styles__ = components_injectStyle
/* scopeId */
var components___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var components___vue_module_identifier__ = null
var components_Component = components_normalizeComponent(
  selectortype_script_index_0_src_components,
  selectortype_template_index_0_src_components,
  components___vue_template_functional__,
  components___vue_styles__,
  components___vue_scopeId__,
  components___vue_module_identifier__
)

/* harmony default export */ var src_components = (components_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-resource/dist/vue-resource.esm.js
var vue_resource_esm = __webpack_require__("8+8L");

// EXTERNAL MODULE: ./node_modules/vue-awesome-swiper/dist/vue-awesome-swiper.js
var vue_awesome_swiper = __webpack_require__("7QTg");
var vue_awesome_swiper_default = /*#__PURE__*/__webpack_require__.n(vue_awesome_swiper);

// EXTERNAL MODULE: ./node_modules/vue-lazyload/vue-lazyload.js
var vue_lazyload = __webpack_require__("cTzj");
var vue_lazyload_default = /*#__PURE__*/__webpack_require__.n(vue_lazyload);

// EXTERNAL MODULE: ./node_modules/swiper/dist/css/swiper.css
var css_swiper = __webpack_require__("v2ns");
var swiper_default = /*#__PURE__*/__webpack_require__.n(css_swiper);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/animate.css/animate.css
var animate = __webpack_require__("oPmM");
var animate_default = /*#__PURE__*/__webpack_require__.n(animate);

// EXTERNAL MODULE: ./node_modules/vue-fullpage/vue-fullpage.css
var vue_fullpage = __webpack_require__("DI1c");
var vue_fullpage_default = /*#__PURE__*/__webpack_require__.n(vue_fullpage);

// EXTERNAL MODULE: ./node_modules/vue-fullpage/index.js
var node_modules_vue_fullpage = __webpack_require__("M6Dg");
var node_modules_vue_fullpage_default = /*#__PURE__*/__webpack_require__.n(node_modules_vue_fullpage);

// EXTERNAL MODULE: ./node_modules/vue-touch/dist/vue-touch.js
var vue_touch = __webpack_require__("I0MY");
var vue_touch_default = /*#__PURE__*/__webpack_require__.n(vue_touch);

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-input/index.vue + 7 modules
var x_input = __webpack_require__("pDNl");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b3d2bd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("X+dp")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/register.vue







/* harmony default export */ var register = ({
  data: function data() {
    return {
      mobile: '',
      verify: '',
      code: '',
      messageWarn: '',
      message: '获取验证码',
      isShow: false,
      isdisable: false,
      isjump: false,
      readonly: false
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: x_input["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button
  },
  methods: {
    beforXy: function beforXy(mrquerUrl) {

      var objectInfo = new Object();
      objectInfo.comnCode = "";
      objectInfo.hsNo = "";
      objectInfo.hsName = "";
      objectInfo.phone = this.mobile;
      objectInfo.phoneModel = navigator.userAgent;
      objectInfo.requestUrl = mrquerUrl;

      console.log("&&&&&&&&&&&&&&&");
      console.log(objectInfo);
      var newUrl = global.host + 'sys/addSystemLog';
      this.$http.post(newUrl, objectInfo).then(function (res) {
        console.log(res.body.result);
      }, function (err) {
        console.log(err);
      });
    },
    getSms: function getSms() {
      if (!this.mobile) {
        this.messageWarn = '请输入您输入的手机号';
      } else if (!this.$refs.mobile.valid) {
        this.messageWarn = '您输入的手机号有误';
      } else {
        this.messageWarn = '';
        this.readonly = true;
        this.beforXy("#发送验证码检测#message/pushMessage?phone=" + this.mobile);
        this.$http.get(global.host + 'message/pushMessage?phone=' + this.mobile).then(function (res) {
          this.code = res.body.result.code;
          console.log(res);
        }, function (err) {
          console.log(err);
        });
        this.changeState();
      }
    },
    changeState: function changeState() {
      var time = 60;
      this.isdisable = true;
      this.isShow = true;
      var self = this;
      self.message = time + 's';
      var hander = window.setInterval(function () {
        if (time == 0) {
          self.isdisable = false;
          self.isShow = false;
          self.message = '重新获取';
          this.readonly = false;
          window.clearInterval(hander);
        } else {
          time--;
          self.message = time + 's';
        }
      }, 1000);
    },
    redirection: function redirection() {
      if (!this.mobile) {
        this.messageWarn = '请输入手机号码';
      } else if (!this.verify) {
        this.messageWarn = '请输入验证码';
      } else if (this.verify != this.code) {
        this.messageWarn = '验证码有误';
      } else {
        this.isjump = false;
        this.beforXy("#进入下一步验证#users/register_first/" + this.$router.history.current.query.openid + '/' + this.mobile + "/" + this.$router.history.current.query.nickname + '?url=' + this.$router.history.current.query.headerimgurl);
        this.$http.post(global.host + 'users/register_first/' + this.$router.history.current.query.openid + '/' + this.mobile + "/" + this.$router.history.current.query.nickname + '?url=' + this.$router.history.current.query.headerimgurl).then(function (res) {
          console.log(res);
          if (res.body.success) {
            this.$router.push({ path: '/houseBind', query: { openid: this.$router.history.current.query.openid, phone: this.mobile, IsDefault: 1 } });
          } else {
            this.messageWarn = '服务异常，请稍后！';
          }
        }, function (err) {
          console.log(err);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/register.vue







/* harmony default export */ var components_register = ({
  data: function data() {
    return {
      mobile: '',
      verify: '',
      code: '',
      messageWarn: '',
      message: '获取验证码',
      isShow: false,
      isdisable: false,
      isjump: false,
      readonly: false
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: x_input["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button
  },
  methods: {
    beforXy: function beforXy(mrquerUrl) {

      var objectInfo = new Object();
      objectInfo.comnCode = "";
      objectInfo.hsNo = "";
      objectInfo.hsName = "";
      objectInfo.phone = this.mobile;
      objectInfo.phoneModel = navigator.userAgent;
      objectInfo.requestUrl = mrquerUrl;

      console.log("&&&&&&&&&&&&&&&");
      console.log(objectInfo);
      var newUrl = global.host + 'sys/addSystemLog';
      this.$http.post(newUrl, objectInfo).then(function (res) {
        console.log(res.body.result);
      }, function (err) {
        console.log(err);
      });
    },
    getSms: function getSms() {
      if (!this.mobile) {
        this.messageWarn = '请输入您输入的手机号';
      } else if (!this.$refs.mobile.valid) {
        this.messageWarn = '您输入的手机号有误';
      } else {
        this.messageWarn = '';
        this.readonly = true;
        this.beforXy("#发送验证码检测#message/pushMessage?phone=" + this.mobile);
        this.$http.get(global.host + 'message/pushMessage?phone=' + this.mobile).then(function (res) {
          this.code = res.body.result.code;
          console.log(res);
        }, function (err) {
          console.log(err);
        });
        this.changeState();
      }
    },
    changeState: function changeState() {
      var time = 60;
      this.isdisable = true;
      this.isShow = true;
      var self = this;
      self.message = time + 's';
      var hander = window.setInterval(function () {
        if (time == 0) {
          self.isdisable = false;
          self.isShow = false;
          self.message = '重新获取';
          this.readonly = false;
          window.clearInterval(hander);
        } else {
          time--;
          self.message = time + 's';
        }
      }, 1000);
    },
    redirection: function redirection() {
      if (!this.mobile) {
        this.messageWarn = '请输入手机号码';
      } else if (!this.verify) {
        this.messageWarn = '请输入验证码';
      } else if (this.verify != this.code) {
        this.messageWarn = '验证码有误';
      } else {
        this.isjump = false;
        this.beforXy("#进入下一步验证#users/register_first/" + this.$router.history.current.query.openid + '/' + this.mobile + "/" + this.$router.history.current.query.nickname + '?url=' + this.$router.history.current.query.headerimgurl);
        this.$http.post(global.host + 'users/register_first/' + this.$router.history.current.query.openid + '/' + this.mobile + "/" + this.$router.history.current.query.nickname + '?url=' + this.$router.history.current.query.headerimgurl).then(function (res) {
          console.log(res);
          if (res.body.success) {
            this.$router.push({ path: '/houseBind', query: { openid: this.$router.history.current.query.openid, phone: this.mobile, IsDefault: 1 } });
          } else {
            this.messageWarn = '服务异常，请稍后！';
          }
        }, function (err) {
          console.log(err);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-464b6242","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register.vue
var register_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: false}}},[_vm._v("用户注册")]),_vm._v(" "),_c('div',{staticStyle:{"margin":"15% auto 6%"}},[_c('group',[_c('x-input',{ref:"mobile",attrs:{"title":"手机号码:","name":"mobile","placeholder":"请输入手机号码","readonly":_vm.readonly,"keyboard":"number","is-type":"china-mobile"},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}})],1),_vm._v(" "),_c('group',[_c('x-input',{staticClass:"weui-vcode",attrs:{"title":"验证码:","name":"verify","keyboard":"number"},model:{value:(_vm.verify),callback:function ($$v) {_vm.verify=$$v},expression:"verify"}},[_c('x-button',{attrs:{"slot":"right","show-loading":_vm.isShow,"type":"default","disabled":_vm.isdisable,"mini":""},nativeOn:{"click":function($event){return _vm.getSms($event)}},slot:"right"},[_vm._v(_vm._s(_vm.message))])],1)],1)],1),_vm._v(" "),(_vm.messageWarn)?_c('h4',{staticStyle:{"text-align":"center","color":"red","padding-bottom":"6%"}},[_vm._v(_vm._s(_vm.messageWarn))]):_vm._e(),_vm._v(" "),_c('x-button',{attrs:{"type":"primary","disabled":_vm.isjump},nativeOn:{"click":function($event){return _vm.redirection($event)}}},[_vm._v("下一步")])],1)}
var register_staticRenderFns = []
var register_esExports = { render: register_render, staticRenderFns: register_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_register = (register_esExports);
// CONCATENATED MODULE: ./src/components/register.vue
function register_injectStyle (ssrContext) {
  __webpack_require__("7I74")
}
var register_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var register___vue_template_functional__ = false
/* styles */
var register___vue_styles__ = register_injectStyle
/* scopeId */
var register___vue_scopeId__ = "data-v-464b6242"
/* moduleIdentifier (server only) */
var register___vue_module_identifier__ = null
var register_Component = register_normalizeComponent(
  components_register,
  selectortype_template_index_0_src_components_register,
  register___vue_template_functional__,
  register___vue_styles__,
  register___vue_scopeId__,
  register___vue_module_identifier__
)

/* harmony default export */ var src_components_register = (register_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/beforelogin/beforelogin.vue


//
//
//
//
//


/* harmony default export */ var beforelogin = ({
	data: function data() {
		return {
			code: '',
			state: '',
			messageWarn: '',
			temp: ''
		};
	},

	mounted: function mounted() {
		this.code = this.$router.history.current.query.code;
		this.state = this.$router.history.current.query.state;
		//this.messageWarn = 'code: ' + this.code + 'state: ' + this.state
		var url = '';
		if (this.state == 0) {
			url = global.host + 'users/getuserid?code=' + this.code;
		} else if (this.state == 1) {
			url = global.host + 'users/getuser?code=' + this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
		}
		//this.messageWarn = url;
		if (url) {
			this.$http.get(url).then(function (res) {
				if (res.body.success) {
					if (res.body.result.state == 'banding') {
						this.$router.replace({ path: '/houseBind', query: { openid: res.body.result.list[0].openId, phone: res.body.result.list[0].mainPhone, IsDefault: 1 } });
					} else if (res.body.result.state == 'login') {
						this.$router.replace({ path: '/user', query: { openid: res.body.result.openId, phone: res.body.result.mainPhone, comnCode: res.body.result.comn_code, hsNo: res.body.result.hsNo } });
					} else {
						if (res.body.statusCode == '120') {
							/*异常信息*/
							this.messageWarn = '获取openId异常，请联系管理员';
						} else {
							/*用户不存在，需要注册*/
							this.$router.replace({ path: '/register', query: { openid: res.body.result.openId, nickname: res.body.result.nickname, headerimgurl: res.body.result.headimgurl } });
						}
					}
				} else {
					this.$router.replace({ path: '/register', query: { openid: res.body.result.openId, nickname: res.body.result.nickname, headerimgurl: res.body.result.headimgurl } });
					//this.$router.replace({path:'/register',query:{openid:res.body.statusCode,nickname:JSON.parse(res.body.message).nickname,headerimgurl:JSON.parse(res.body.message).headimgurl}})
				}
			}, function (err) {
				/*异常信息*/
				console.log(err);
				this.messageWarn = err;
			});
		}
	},
	methods: {
		iterator: function iterator(obj) {
			var str = '';
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = get_iterator_default()(obj), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var prop = _step.value;

					if (typeof_default()(obj[prop]) === 'object') {
						continue;
					} else if (typeof obj[prop] === 'function') {
						continue;
					} else {
						str = str + prop + ':' + obj[prop];
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return str;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/beforelogin/beforelogin.vue


//
//
//
//
//


/* harmony default export */ var beforelogin_beforelogin = ({
	data: function data() {
		return {
			code: '',
			state: '',
			messageWarn: '',
			temp: ''
		};
	},

	mounted: function mounted() {
		this.code = this.$router.history.current.query.code;
		this.state = this.$router.history.current.query.state;
		//this.messageWarn = 'code: ' + this.code + 'state: ' + this.state
		var url = '';
		if (this.state == 0) {
			url = global.host + 'users/getuserid?code=' + this.code;
		} else if (this.state == 1) {
			url = global.host + 'users/getuser?code=' + this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
		}
		//this.messageWarn = url;
		if (url) {
			this.$http.get(url).then(function (res) {
				if (res.body.success) {
					if (res.body.result.state == 'banding') {
						this.$router.replace({ path: '/houseBind', query: { openid: res.body.result.list[0].openId, phone: res.body.result.list[0].mainPhone, IsDefault: 1 } });
					} else if (res.body.result.state == 'login') {
						this.$router.replace({ path: '/user', query: { openid: res.body.result.openId, phone: res.body.result.mainPhone, comnCode: res.body.result.comn_code, hsNo: res.body.result.hsNo } });
					} else {
						if (res.body.statusCode == '120') {
							/*异常信息*/
							this.messageWarn = '获取openId异常，请联系管理员';
						} else {
							/*用户不存在，需要注册*/
							this.$router.replace({ path: '/register', query: { openid: res.body.result.openId, nickname: res.body.result.nickname, headerimgurl: res.body.result.headimgurl } });
						}
					}
				} else {
					this.$router.replace({ path: '/register', query: { openid: res.body.result.openId, nickname: res.body.result.nickname, headerimgurl: res.body.result.headimgurl } });
					//this.$router.replace({path:'/register',query:{openid:res.body.statusCode,nickname:JSON.parse(res.body.message).nickname,headerimgurl:JSON.parse(res.body.message).headimgurl}})
				}
			}, function (err) {
				/*异常信息*/
				console.log(err);
				this.messageWarn = err;
			});
		}
	},
	methods: {
		iterator: function iterator(obj) {
			var str = '';
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = get_iterator_default()(obj), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var prop = _step.value;

					if (typeof_default()(obj[prop]) === 'object') {
						continue;
					} else if (typeof obj[prop] === 'function') {
						continue;
					} else {
						str = str + prop + ':' + obj[prop];
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return str;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d02417c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/beforelogin/beforelogin.vue
var beforelogin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.messageWarn))])])}
var beforelogin_staticRenderFns = []
var beforelogin_esExports = { render: beforelogin_render, staticRenderFns: beforelogin_staticRenderFns }
/* harmony default export */ var components_beforelogin_beforelogin = (beforelogin_esExports);
// CONCATENATED MODULE: ./src/components/beforelogin/beforelogin.vue
var beforelogin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var beforelogin___vue_template_functional__ = false
/* styles */
var beforelogin___vue_styles__ = null
/* scopeId */
var beforelogin___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var beforelogin___vue_module_identifier__ = null
var beforelogin_Component = beforelogin_normalizeComponent(
  beforelogin_beforelogin,
  components_beforelogin_beforelogin,
  beforelogin___vue_template_functional__,
  beforelogin___vue_styles__,
  beforelogin___vue_scopeId__,
  beforelogin___vue_module_identifier__
)

/* harmony default export */ var src_components_beforelogin_beforelogin = (beforelogin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/beforelogin/firstlogin.vue


//
//
//
//
//


/* harmony default export */ var firstlogin = ({
	data: function data() {
		return {
			code: '',
			state: '',
			messageWarn: '',
			temp: ''
		};
	},

	mounted: function mounted() {
		this.code = this.$router.history.current.query.code;
		this.state = this.$router.history.current.query.state;
		var url = '';
		if (this.state == 0) {
			url = global.host + 'users/getuserid?code=' + this.code;
		} else if (this.state == 1) {
			url = global.host + 'users/getuser?code=' + this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
		}
		if (url) {
			this.$http.get(url).then(function (res) {
				if (res.body.success) {
					if (res.body.result.state == 'banding') {
						//muId从我的社区进入业主绑定
						this.$router.replace({ path: '/houseBind', query: { openid: res.body.result.list[0].openId, phone: res.body.result.list[0].mainPhone, IsDefault: 1, muId: 4 } });
					} else if (res.body.result.state == 'login') {
						this.$router.replace({ path: '/', query: { openid: res.body.result.openId, phone: res.body.result.mainPhone } });
					} else {
						if (res.body.statusCode == '120') {
							/*异常信息*/
							this.messageWarn = '获取openId异常，请联系管理员';
						} else {
							/*用户不存在，需要注册*/
							this.$router.replace({ path: '/register', query: { openid: res.body.result.openId, nickname: res.body.result.nickname, headerimgurl: res.body.result.headimgurl } });
						}
					}
				} else {
					this.$router.replace({ path: '/register', query: { openid: res.body.result.openId, nickname: res.body.result.nickname, headerimgurl: res.body.result.headimgurl } });
					//this.$router.replace({path:'/register',query:{openid:res.body.result.openId,nickname:res.body.result.nickname,headerimgurl:res.body.result.headimgurl}})
				}
			}, function (err) {
				/*异常信息*/
				console.log(err);
				this.messageWarn = res.body.message;
			});
		}
	},
	methods: {
		iterator: function iterator(obj) {
			var str = '';
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = get_iterator_default()(obj), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var prop = _step.value;

					if (typeof_default()(obj[prop]) === 'object') {
						continue;
					} else if (typeof obj[prop] === 'function') {
						continue;
					} else {
						str = str + prop + ':' + obj[prop];
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return str;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/beforelogin/firstlogin.vue


//
//
//
//
//


/* harmony default export */ var beforelogin_firstlogin = ({
	data: function data() {
		return {
			code: '',
			state: '',
			messageWarn: '',
			temp: ''
		};
	},

	mounted: function mounted() {
		this.code = this.$router.history.current.query.code;
		this.state = this.$router.history.current.query.state;
		var url = '';
		if (this.state == 0) {
			url = global.host + 'users/getuserid?code=' + this.code;
		} else if (this.state == 1) {
			url = global.host + 'users/getuser?code=' + this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
		}
		if (url) {
			this.$http.get(url).then(function (res) {
				if (res.body.success) {
					if (res.body.result.state == 'banding') {
						//muId从我的社区进入业主绑定
						this.$router.replace({ path: '/houseBind', query: { openid: res.body.result.list[0].openId, phone: res.body.result.list[0].mainPhone, IsDefault: 1, muId: 4 } });
					} else if (res.body.result.state == 'login') {
						this.$router.replace({ path: '/', query: { openid: res.body.result.openId, phone: res.body.result.mainPhone } });
					} else {
						if (res.body.statusCode == '120') {
							/*异常信息*/
							this.messageWarn = '获取openId异常，请联系管理员';
						} else {
							/*用户不存在，需要注册*/
							this.$router.replace({ path: '/register', query: { openid: res.body.result.openId, nickname: res.body.result.nickname, headerimgurl: res.body.result.headimgurl } });
						}
					}
				} else {
					this.$router.replace({ path: '/register', query: { openid: res.body.result.openId, nickname: res.body.result.nickname, headerimgurl: res.body.result.headimgurl } });
					//this.$router.replace({path:'/register',query:{openid:res.body.result.openId,nickname:res.body.result.nickname,headerimgurl:res.body.result.headimgurl}})
				}
			}, function (err) {
				/*异常信息*/
				console.log(err);
				this.messageWarn = res.body.message;
			});
		}
	},
	methods: {
		iterator: function iterator(obj) {
			var str = '';
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = get_iterator_default()(obj), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var prop = _step.value;

					if (typeof_default()(obj[prop]) === 'object') {
						continue;
					} else if (typeof obj[prop] === 'function') {
						continue;
					} else {
						str = str + prop + ':' + obj[prop];
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return str;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f316a2b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/beforelogin/firstlogin.vue
var firstlogin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.messageWarn))])])}
var firstlogin_staticRenderFns = []
var firstlogin_esExports = { render: firstlogin_render, staticRenderFns: firstlogin_staticRenderFns }
/* harmony default export */ var components_beforelogin_firstlogin = (firstlogin_esExports);
// CONCATENATED MODULE: ./src/components/beforelogin/firstlogin.vue
var firstlogin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var firstlogin___vue_template_functional__ = false
/* styles */
var firstlogin___vue_styles__ = null
/* scopeId */
var firstlogin___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var firstlogin___vue_module_identifier__ = null
var firstlogin_Component = firstlogin_normalizeComponent(
  beforelogin_firstlogin,
  components_beforelogin_firstlogin,
  firstlogin___vue_template_functional__,
  firstlogin___vue_styles__,
  firstlogin___vue_scopeId__,
  firstlogin___vue_module_identifier__
)

/* harmony default export */ var src_components_beforelogin_firstlogin = (firstlogin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/beforelogin/dayPay.vue


//
//
//
//
//


/* harmony default export */ var dayPay = ({
	data: function data() {
		return {
			code: '',
			state: '',
			messageWarn: '',
			temp: ''
		};
	},

	mounted: function mounted() {
		this.code = this.$router.history.current.query.code;
		this.state = this.$router.history.current.query.state;
		var url = '';
		if (this.state == 0) {
			url = global.host + 'users/getuserid?code=' + this.code;
		} else if (this.state == 1) {
			url = global.host + 'users/getuser?code=' + this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
		}
		if (url) {
			this.$http.get(url).then(function (res) {
				if (res.body.success) {
					if (res.body.result.state == 'banding') {
						//muId代表从日常缴费进去绑定房屋
						this.$router.replace({ path: '/houseBind', query: { openid: res.body.result.list[0].openId, phone: res.body.result.list[0].mainPhone, IsDefault: 1, muId: 3 } });
					} else if (res.body.result.state == 'login') {
						console.log(res);
						this.$router.replace({ path: '/pay/tenement', query: { openid: res.body.result.openId, phone: res.body.result.mainPhone } });
					} else {
						if (res.body.statusCode == '120') {
							/*异常信息*/
							this.messageWarn = '获取openId异常，请联系管理员';
						} else {
							/*用户不存在，需要注册*/
							this.$router.replace({ path: '/register', query: { openid: res.body.result.openId, nickname: res.body.result.nickname, headerimgurl: res.body.result.headimgurl } });
						}
					}
				} else {
					this.$router.replace({ path: '/register', query: { openid: res.body.result.openId, nickname: res.body.result.nickname, headerimgurl: res.body.result.headimgurl } });
					// this.$router.replace({path:'/register',query:{openid:res.body.statusCode,nickname:JSON.parse(res.body.message).nickname,headerimgurl:JSON.parse(res.body.message).headimgurl}})
				}
			}, function (err) {
				/*异常信息*/
				console.log(err);
				this.messageWarn = err;
			});
		}
	},
	methods: {
		iterator: function iterator(obj) {
			var str = '';
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = get_iterator_default()(obj), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var prop = _step.value;

					if (typeof_default()(obj[prop]) === 'object') {
						continue;
					} else if (typeof obj[prop] === 'function') {
						continue;
					} else {
						str = str + prop + ':' + obj[prop];
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return str;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/beforelogin/dayPay.vue


//
//
//
//
//


/* harmony default export */ var beforelogin_dayPay = ({
	data: function data() {
		return {
			code: '',
			state: '',
			messageWarn: '',
			temp: ''
		};
	},

	mounted: function mounted() {
		this.code = this.$router.history.current.query.code;
		this.state = this.$router.history.current.query.state;
		var url = '';
		if (this.state == 0) {
			url = global.host + 'users/getuserid?code=' + this.code;
		} else if (this.state == 1) {
			url = global.host + 'users/getuser?code=' + this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
		}
		if (url) {
			this.$http.get(url).then(function (res) {
				if (res.body.success) {
					if (res.body.result.state == 'banding') {
						//muId代表从日常缴费进去绑定房屋
						this.$router.replace({ path: '/houseBind', query: { openid: res.body.result.list[0].openId, phone: res.body.result.list[0].mainPhone, IsDefault: 1, muId: 3 } });
					} else if (res.body.result.state == 'login') {
						console.log(res);
						this.$router.replace({ path: '/pay/tenement', query: { openid: res.body.result.openId, phone: res.body.result.mainPhone } });
					} else {
						if (res.body.statusCode == '120') {
							/*异常信息*/
							this.messageWarn = '获取openId异常，请联系管理员';
						} else {
							/*用户不存在，需要注册*/
							this.$router.replace({ path: '/register', query: { openid: res.body.result.openId, nickname: res.body.result.nickname, headerimgurl: res.body.result.headimgurl } });
						}
					}
				} else {
					this.$router.replace({ path: '/register', query: { openid: res.body.result.openId, nickname: res.body.result.nickname, headerimgurl: res.body.result.headimgurl } });
					// this.$router.replace({path:'/register',query:{openid:res.body.statusCode,nickname:JSON.parse(res.body.message).nickname,headerimgurl:JSON.parse(res.body.message).headimgurl}})
				}
			}, function (err) {
				/*异常信息*/
				console.log(err);
				this.messageWarn = err;
			});
		}
	},
	methods: {
		iterator: function iterator(obj) {
			var str = '';
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = get_iterator_default()(obj), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var prop = _step.value;

					if (typeof_default()(obj[prop]) === 'object') {
						continue;
					} else if (typeof obj[prop] === 'function') {
						continue;
					} else {
						str = str + prop + ':' + obj[prop];
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return str;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e438b2f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/beforelogin/dayPay.vue
var dayPay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.messageWarn))])])}
var dayPay_staticRenderFns = []
var dayPay_esExports = { render: dayPay_render, staticRenderFns: dayPay_staticRenderFns }
/* harmony default export */ var components_beforelogin_dayPay = (dayPay_esExports);
// CONCATENATED MODULE: ./src/components/beforelogin/dayPay.vue
var dayPay_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dayPay___vue_template_functional__ = false
/* styles */
var dayPay___vue_styles__ = null
/* scopeId */
var dayPay___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dayPay___vue_module_identifier__ = null
var dayPay_Component = dayPay_normalizeComponent(
  beforelogin_dayPay,
  components_beforelogin_dayPay,
  dayPay___vue_template_functional__,
  dayPay___vue_styles__,
  dayPay___vue_scopeId__,
  dayPay___vue_module_identifier__
)

/* harmony default export */ var src_components_beforelogin_dayPay = (dayPay_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/beforelogin/bindSysUser.vue








/* harmony default export */ var bindSysUser = ({
  data: function data() {
    return {
      code: '',
      state: '',
      openId: '',
      userObj: {},
      wechatJson: {},
      messageWarn: '',
      username: '',
      password: '',
      disabledFlag: false,
      bindState: false,
      pageTitle: '账号绑定'
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: x_input["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button
  },
  mounted: function mounted() {
    this.code = this.$router.history.current.query.code;
    this.state = this.$router.history.current.query.state;
    var url = global.host + 'sysUser/getUser?code=' + this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
    this.$http.get(url).then(function (res) {
      if (res.body.statusCode == '200') {
        this.bindState = true;
        this.pageTitle = '绑定信息';
        this.userObj = res.body.result.userObj;
        this.openId = res.body.result.openId;
        this.wechatJson.openId = res.body.result.openId;
        this.wechatJson.nickName = res.body.result.nickName;
        this.wechatJson.headImgUrl = res.body.result.headImgUrl;
      } else if (res.body.statusCode == '404') {
        this.bindState = false;
        this.openId = res.body.result.openId;
        this.wechatJson.openId = res.body.result.openId;
        this.wechatJson.nickName = res.body.result.nickName;
        this.wechatJson.headImgUrl = res.body.result.headImgUrl;
      } else {
        this.bindState = false;
        this.messageWarn = res.body.message;
      }
    }, function (err) {
      this.messageWarn = '服务网络异常，请稍后重试';
      console.log(err);
    });
  },
  methods: {
    submitData: function submitData(handleDesc) {
      var data = new Object();
      if (handleDesc == 'bind') {
        if (!this.username) {
          this.messageWarn = '请输入账号';
          return false;
        }
        if (!this.password) {
          this.messageWarn = '请输入密码';
          return false;
        }
        if (!this.openId) {
          this.messageWarn = 'openId无效';
          return false;
        }
        data.openId = this.openId;
      } else {
        data.openId = "";
        this.username = this.userObj.userId;
        this.password = "";
      }
      this.disabledFlag = true;
      data.handleDesc = handleDesc;
      data.userId = this.username;
      data.userPass = this.password;
      data.wechatJson = stringify_default()(this.wechatJson);
      this.$http.post(global.host + 'sysUser/bindUser', data).then(function (res) {
        this.disabledFlag = false;
        if (res.body.statusCode == '200') {
          if (handleDesc == 'bind') {
            this.bindState = true;
            this.pageTitle = '绑定信息';
          } else {
            this.bindState = false;
            this.pageTitle = '账号绑定';
          }
          this.userObj = res.body.result;
        } else {
          this.messageWarn = res.body.message;
        }
      }, function (err) {
        this.disabledFlag = false;
        this.messageWarn = '服务网络异常，请稍后重试';
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/beforelogin/bindSysUser.vue








/* harmony default export */ var beforelogin_bindSysUser = ({
  data: function data() {
    return {
      code: '',
      state: '',
      openId: '',
      userObj: {},
      wechatJson: {},
      messageWarn: '',
      username: '',
      password: '',
      disabledFlag: false,
      bindState: false,
      pageTitle: '账号绑定'
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: x_input["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button
  },
  mounted: function mounted() {
    this.code = this.$router.history.current.query.code;
    this.state = this.$router.history.current.query.state;
    var url = global.host + 'sysUser/getUser?code=' + this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
    this.$http.get(url).then(function (res) {
      if (res.body.statusCode == '200') {
        this.bindState = true;
        this.pageTitle = '绑定信息';
        this.userObj = res.body.result.userObj;
        this.openId = res.body.result.openId;
        this.wechatJson.openId = res.body.result.openId;
        this.wechatJson.nickName = res.body.result.nickName;
        this.wechatJson.headImgUrl = res.body.result.headImgUrl;
      } else if (res.body.statusCode == '404') {
        this.bindState = false;
        this.openId = res.body.result.openId;
        this.wechatJson.openId = res.body.result.openId;
        this.wechatJson.nickName = res.body.result.nickName;
        this.wechatJson.headImgUrl = res.body.result.headImgUrl;
      } else {
        this.bindState = false;
        this.messageWarn = res.body.message;
      }
    }, function (err) {
      this.messageWarn = '服务网络异常，请稍后重试';
      console.log(err);
    });
  },
  methods: {
    submitData: function submitData(handleDesc) {
      var data = new Object();
      if (handleDesc == 'bind') {
        if (!this.username) {
          this.messageWarn = '请输入账号';
          return false;
        }
        if (!this.password) {
          this.messageWarn = '请输入密码';
          return false;
        }
        if (!this.openId) {
          this.messageWarn = 'openId无效';
          return false;
        }
        data.openId = this.openId;
      } else {
        data.openId = "";
        this.username = this.userObj.userId;
        this.password = "";
      }
      this.disabledFlag = true;
      data.handleDesc = handleDesc;
      data.userId = this.username;
      data.userPass = this.password;
      data.wechatJson = stringify_default()(this.wechatJson);
      this.$http.post(global.host + 'sysUser/bindUser', data).then(function (res) {
        this.disabledFlag = false;
        if (res.body.statusCode == '200') {
          if (handleDesc == 'bind') {
            this.bindState = true;
            this.pageTitle = '绑定信息';
          } else {
            this.bindState = false;
            this.pageTitle = '账号绑定';
          }
          this.userObj = res.body.result;
        } else {
          this.messageWarn = res.body.message;
        }
      }, function (err) {
        this.disabledFlag = false;
        this.messageWarn = '服务网络异常，请稍后重试';
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05c35227","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/beforelogin/bindSysUser.vue
var bindSysUser_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: false}}},[_vm._v(_vm._s(_vm.pageTitle))]),_vm._v(" "),(_vm.bindState==false)?_c('div',[_c('group',[_c('x-input',{attrs:{"title":"账号:","placeholder":"APP登录账号","type":"text","keyboard":"text"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"密码:","placeholder":"APP登录密码","type":"password","keyboard":"text"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.messageWarn)?_c('h4',{staticStyle:{"text-align":"center","color":"red"}},[_vm._v(_vm._s(_vm.messageWarn))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary","disabled":_vm.disabledFlag},nativeOn:{"click":function($event){_vm.submitData('bind')}}},[_vm._v("绑定")])],1):_vm._e(),_vm._v(" "),(_vm.bindState==true)?_c('div',[_c('group',[_c('div',[_vm._v("账号："+_vm._s(_vm.userObj.userId))])]),_vm._v(" "),_c('group',[_c('div',[_vm._v("姓名："+_vm._s(_vm.userObj.userName))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticStyle:{"text-align":"center","color":"green"}},[_vm._v("您已成功绑定账号!")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary","disabled":_vm.disabledFlag},nativeOn:{"click":function($event){_vm.submitData('unbind')}}},[_vm._v("解绑")])],1):_vm._e()],1)}
var bindSysUser_staticRenderFns = []
var bindSysUser_esExports = { render: bindSysUser_render, staticRenderFns: bindSysUser_staticRenderFns }
/* harmony default export */ var components_beforelogin_bindSysUser = (bindSysUser_esExports);
// CONCATENATED MODULE: ./src/components/beforelogin/bindSysUser.vue
var bindSysUser_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bindSysUser___vue_template_functional__ = false
/* styles */
var bindSysUser___vue_styles__ = null
/* scopeId */
var bindSysUser___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var bindSysUser___vue_module_identifier__ = null
var bindSysUser_Component = bindSysUser_normalizeComponent(
  beforelogin_bindSysUser,
  components_beforelogin_bindSysUser,
  bindSysUser___vue_template_functional__,
  bindSysUser___vue_styles__,
  bindSysUser___vue_scopeId__,
  bindSysUser___vue_module_identifier__
)

/* harmony default export */ var src_components_beforelogin_bindSysUser = (bindSysUser_Component.exports);

// EXTERNAL MODULE: ./src/components/black.vue
var black = __webpack_require__("gW3h");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab = ({
  name: 'button-tab',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    height: Number
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_button_tab = ({
  name: 'button-tab',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    height: Number
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63786a38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
var button_tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-button-group"},[_vm._t("default")],2)}
var button_tab_staticRenderFns = []
var button_tab_esExports = { render: button_tab_render, staticRenderFns: button_tab_staticRenderFns }
/* harmony default export */ var components_button_tab_button_tab = (button_tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/button-tab/button-tab.vue
function button_tab_injectStyle (ssrContext) {
  __webpack_require__("gYt2")
}
var button_tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_tab___vue_template_functional__ = false
/* styles */
var button_tab___vue_styles__ = button_tab_injectStyle
/* scopeId */
var button_tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var button_tab___vue_module_identifier__ = null
var button_tab_Component = button_tab_normalizeComponent(
  button_tab_button_tab,
  components_button_tab_button_tab,
  button_tab___vue_template_functional__,
  button_tab___vue_styles__,
  button_tab___vue_scopeId__,
  button_tab___vue_module_identifier__
)

/* harmony default export */ var src_components_button_tab_button_tab = (button_tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_item = ({
  name: 'button-tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  computed: {
    classes: function classes() {
      return {
        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
        'vux-button-tab-item-first': this.currentIndex === 0,
        'vux-button-tab-item-last': this.currentIndex === this.$parent.$children.length - 1,
        'vux-button-tab-item-middle': this.currentIndex > 0 && this.currentIndex !== this.$parent.$children.length - 1
      };
    },
    style: function style() {
      if (this.$parent.height) {
        return {
          height: this.$parent.height + 'px',
          lineHeight: this.$parent.height + 'px'
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_button_tab_item = ({
  name: 'button-tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  computed: {
    classes: function classes() {
      return {
        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
        'vux-button-tab-item-first': this.currentIndex === 0,
        'vux-button-tab-item-last': this.currentIndex === this.$parent.$children.length - 1,
        'vux-button-tab-item-middle': this.currentIndex > 0 && this.currentIndex !== this.$parent.$children.length - 1
      };
    },
    style: function style() {
      if (this.$parent.height) {
        return {
          height: this.$parent.height + 'px',
          lineHeight: this.$parent.height + 'px'
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a466023","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
var button_tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-button-tab-item",class:_vm.classes,style:(_vm.style),attrs:{"href":"javascript:"},on:{"click":_vm.onItemClick}},[_vm._t("default")],2)}
var button_tab_item_staticRenderFns = []
var button_tab_item_esExports = { render: button_tab_item_render, staticRenderFns: button_tab_item_staticRenderFns }
/* harmony default export */ var components_button_tab_button_tab_item = (button_tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/button-tab/button-tab-item.vue
var button_tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_tab_item___vue_template_functional__ = false
/* styles */
var button_tab_item___vue_styles__ = null
/* scopeId */
var button_tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var button_tab_item___vue_module_identifier__ = null
var button_tab_item_Component = button_tab_item_normalizeComponent(
  button_tab_button_tab_item,
  components_button_tab_button_tab_item,
  button_tab_item___vue_template_functional__,
  button_tab_item___vue_styles__,
  button_tab_item___vue_scopeId__,
  button_tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_button_tab_button_tab_item = (button_tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/payment.vue







/* harmony default export */ var components_payment = ({
  components: {
    XHeader: vux_src_components_x_header,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    $: jquery_default.a
  },
  data: function data() {
    return {
      title: '物业缴费',
      select1: false,
      select2: false,
      select3: false,
      hidet: false,
      hidet1: false,
      hidet2: false
    };
  },
  beforeMount: function beforeMount() {
    var url = global.host + 'pay/findhouse?openid=' + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone;
    this.$http.get(url).then(function (res) {

      var urls = global.host + 'feeItem/getList?comnCode=' + res.body.comnCode;

      this.$http.get(urls).then(function (res) {
        var mlit = res.body.result;
        for (var m in mlit) {
          if (mlit[m].feeName == "物业费") {
            this.hidet = true;
          } else if (mlit[m].feeName == "电费") {
            this.hidet1 = true;
          } else if (mlit[m].feeName == "水费") {
            this.hidet2 = true;
          }
        }
      }, function (err) {
        console.log(err);
      });
    }, function (err) {
      console.log(err);
    });

    if (this.$router.history.current.path == '/pay/tenement') {
      document.title = "物业缴费";
      this.select1 = true;
    } else if (this.$router.history.current.path == '/pay/electricity') {
      document.title = "电费缴纳";
      this.select2 = true;
    } else if (this.$router.history.current.path == '/pay/water') {
      document.title = "水费缴纳";
      this.select3 = true;
    }
  },

  methods: {
    changePage: function changePage(index) {
      switch (index) {
        case 0:
          this.$router.push({ path: '/pay/tenement', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, comnCode: this.$router.history.current.query.comnCode } });
          break;
        /*$(".vux-button-tab-item:eq(0)").addClass("vux-button-group-current").siblings(".vux-button-tab-item").removeClass("vux-button-group-current")
        this.title = '物业缴费';*/
        case 1:
          this.$router.push({ path: '/pay/electricity', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, comnCode: this.$router.history.current.query.comnCode } });
          break;
        case 2:
          this.$router.push({ path: '/pay/water', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, comnCode: this.$router.history.current.query.comnCode } });
          break;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/payment.vue







/* harmony default export */ var selectortype_script_index_0_src_components_payment = ({
  components: {
    XHeader: vux_src_components_x_header,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    $: jquery_default.a
  },
  data: function data() {
    return {
      title: '物业缴费',
      select1: false,
      select2: false,
      select3: false,
      hidet: false,
      hidet1: false,
      hidet2: false
    };
  },
  beforeMount: function beforeMount() {
    var url = global.host + 'pay/findhouse?openid=' + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone;
    this.$http.get(url).then(function (res) {

      var urls = global.host + 'feeItem/getList?comnCode=' + res.body.comnCode;

      this.$http.get(urls).then(function (res) {
        var mlit = res.body.result;
        for (var m in mlit) {
          if (mlit[m].feeName == "物业费") {
            this.hidet = true;
          } else if (mlit[m].feeName == "电费") {
            this.hidet1 = true;
          } else if (mlit[m].feeName == "水费") {
            this.hidet2 = true;
          }
        }
      }, function (err) {
        console.log(err);
      });
    }, function (err) {
      console.log(err);
    });

    if (this.$router.history.current.path == '/pay/tenement') {
      document.title = "物业缴费";
      this.select1 = true;
    } else if (this.$router.history.current.path == '/pay/electricity') {
      document.title = "电费缴纳";
      this.select2 = true;
    } else if (this.$router.history.current.path == '/pay/water') {
      document.title = "水费缴纳";
      this.select3 = true;
    }
  },

  methods: {
    changePage: function changePage(index) {
      switch (index) {
        case 0:
          this.$router.push({ path: '/pay/tenement', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, comnCode: this.$router.history.current.query.comnCode } });
          break;
        /*$(".vux-button-tab-item:eq(0)").addClass("vux-button-group-current").siblings(".vux-button-tab-item").removeClass("vux-button-group-current")
        this.title = '物业缴费';*/
        case 1:
          this.$router.push({ path: '/pay/electricity', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, comnCode: this.$router.history.current.query.comnCode } });
          break;
        case 2:
          this.$router.push({ path: '/pay/water', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, comnCode: this.$router.history.current.query.comnCode } });
          break;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01a6e61d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment.vue
var payment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin":"2% auto"}},[_c('button-tab',[_c('button-tab-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.hidet),expression:"hidet"}],attrs:{"selected":_vm.select1},on:{"on-item-click":_vm.changePage}},[_vm._v("物业费")]),_vm._v(" "),_c('button-tab-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.hidet1),expression:"hidet1"}],attrs:{"selected":_vm.select2},on:{"on-item-click":_vm.changePage}},[_vm._v("电费")]),_vm._v(" "),_c('button-tab-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.hidet2),expression:"hidet2"}],attrs:{"selected":_vm.select3},on:{"on-item-click":_vm.changePage}},[_vm._v("水费")])],1)],1),_vm._v(" "),_c('router-view')],1)}
var payment_staticRenderFns = []
var payment_esExports = { render: payment_render, staticRenderFns: payment_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_payment = (payment_esExports);
// CONCATENATED MODULE: ./src/components/payment.vue
function payment_injectStyle (ssrContext) {
  __webpack_require__("98Sc")
}
var payment_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var payment___vue_template_functional__ = false
/* styles */
var payment___vue_styles__ = payment_injectStyle
/* scopeId */
var payment___vue_scopeId__ = "data-v-01a6e61d"
/* moduleIdentifier (server only) */
var payment___vue_module_identifier__ = null
var payment_Component = payment_normalizeComponent(
  selectortype_script_index_0_src_components_payment,
  selectortype_template_index_0_src_components_payment,
  payment___vue_template_functional__,
  payment___vue_styles__,
  payment___vue_scopeId__,
  payment___vue_module_identifier__
)

/* harmony default export */ var src_components_payment = (payment_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js
var base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("JnrT");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      if (this.max && newVal && newVal.length > this.max) {
        this.currentValue = newVal.slice(0, this.max);
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      return {
        width: this.$parent.labelWidth || this.labelWidth + 'em',
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var components_x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      if (this.max && newVal && newVal.length > this.max) {
        this.currentValue = newVal.slice(0, this.max);
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      return {
        width: this.$parent.labelWidth || this.labelWidth + 'em',
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b89a341","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-textarea/index.vue
var x_textarea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-x-textarea"},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'), textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"textarea",staticClass:"weui-textarea",style:(_vm.textareaStyle),attrs:{"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"name":_vm.name,"rows":_vm.rows,"cols":_vm.cols,"maxlength":_vm.max},domProps:{"value":(_vm.currentValue)},on:{"focus":function($event){_vm.$emit('on-focus')},"blur":function($event){_vm.$emit('on-blur')},"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCounter && _vm.max),expression:"showCounter && max"}],staticClass:"weui-textarea-counter",on:{"click":_vm.focus}},[_c('span',[_vm._v(_vm._s(_vm.count))]),_vm._v("/"+_vm._s(_vm.max)+"\n    ")])])])}
var x_textarea_staticRenderFns = []
var x_textarea_esExports = { render: x_textarea_render, staticRenderFns: x_textarea_staticRenderFns }
/* harmony default export */ var src_components_x_textarea = (x_textarea_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-textarea/index.vue
function x_textarea_injectStyle (ssrContext) {
  __webpack_require__("CkLX")
}
var x_textarea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_textarea___vue_template_functional__ = false
/* styles */
var x_textarea___vue_styles__ = x_textarea_injectStyle
/* scopeId */
var x_textarea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_textarea___vue_module_identifier__ = null
var x_textarea_Component = x_textarea_normalizeComponent(
  components_x_textarea,
  src_components_x_textarea,
  x_textarea___vue_template_functional__,
  x_textarea___vue_styles__,
  x_textarea___vue_scopeId__,
  x_textarea___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_textarea = (x_textarea_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/index.vue + 3 modules
var popup = __webpack_require__("HD9R");

// EXTERNAL MODULE: ./node_modules/vux/src/components/checklist/object-filter.js
var object_filter = __webpack_require__("q5lo");

// EXTERNAL MODULE: ./node_modules/vux/src/components/radio/props.js
var props = __webpack_require__("Zor0");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["b" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var src_components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = radio_contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["b" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function radio_contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e55c14a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/radio/index.vue
var radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells_radio",class:_vm.disabled ? 'vux-radio-disabled' : ''},[_vm._l((_vm.options),function(one,index){return _c('label',{staticClass:"weui-cell weui-cell_radio weui-check__label",attrs:{"for":("radio_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__bd"},[_vm._t("each-item",[_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(one && one.icon),expression:"one && one.icon"}],staticClass:"vux-radio-icon",attrs:{"src":one.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label",style:(_vm.currentValue === _vm.getKey(one) ? (_vm.selectedLabelStyle || '') : '')},[_vm._v(_vm._s(_vm._f("getValue")(one)))])])],{icon:one.icon,label:_vm.getValue(one),index:index,selected:_vm.currentValue === _vm.getKey(one)})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"radio","id":_vm.disabled ? '' : ("radio_" + _vm.uuid + "_" + index)},domProps:{"value":_vm.getKey(one),"checked":_vm._q(_vm.currentValue,_vm.getKey(one))},on:{"change":function($event){_vm.currentValue=_vm.getKey(one)}}}),_vm._v(" "),_c('span',{staticClass:"weui-icon-checked"})])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fillMode),expression:"fillMode"}],staticClass:"weui-cell"},[_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",attrs:{"for":""}},[_vm._v(_vm._s(_vm.fillLabel))])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fillValue),expression:"fillValue"}],staticClass:"weui-input needsclick",attrs:{"type":"text","placeholder":_vm.fillPlaceholder},domProps:{"value":(_vm.fillValue)},on:{"blur":function($event){_vm.isFocus=false},"focus":function($event){_vm.onFocus()},"input":function($event){if($event.target.composing){ return; }_vm.fillValue=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value==='' && !_vm.isFocus),expression:"value==='' && !isFocus"}],staticClass:"weui-cell__ft"},[_c('i',{staticClass:"weui-icon-warn"})])])],2)}
var radio_staticRenderFns = []
var radio_esExports = { render: radio_render, staticRenderFns: radio_staticRenderFns }
/* harmony default export */ var vux_src_components_radio = (radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/radio/index.vue
function radio_injectStyle (ssrContext) {
  __webpack_require__("pC2a")
}
var radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var radio___vue_template_functional__ = false
/* styles */
var radio___vue_styles__ = radio_injectStyle
/* scopeId */
var radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var radio___vue_module_identifier__ = null
var radio_Component = radio_normalizeComponent(
  src_components_radio,
  vux_src_components_radio,
  radio___vue_template_functional__,
  radio___vue_styles__,
  radio___vue_scopeId__,
  radio___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_radio = (radio_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var cell_props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// EXTERNAL MODULE: ./node_modules/array-find/find.js
var find = __webpack_require__("NXHL");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var _cellProps = Object(cell_props["a" /* default */])();
delete _cellProps.value;

/* harmony default export */ var popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: popup["a" /* default */],
    Radio: node_modules_vux_src_components_radio,
    Cell: cell["a" /* default */]
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, _cellProps, Object(props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var popup_radio__cellProps = Object(cell_props["a" /* default */])();
delete popup_radio__cellProps.value;

/* harmony default export */ var components_popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: popup["a" /* default */],
    Radio: node_modules_vux_src_components_radio,
    Cell: cell["a" /* default */]
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, popup_radio__cellProps, Object(props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04768dae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-radio/index.vue
var popup_radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{attrs:{"title":_vm.title,"value":_vm.currentValue,"is-link":!_vm.readonly,"value-align":_vm.valueAlign,"border-intent":_vm.borderIntent},nativeOn:{"click":function($event){return _vm.show($event)}}},[(!_vm.displayValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.displayValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayValue))]):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"icon"},slot:"icon"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{staticStyle:{"background-color":"#fff"},on:{"on-hide":function($event){_vm.$emit('on-hide')},"on-show":function($event){_vm.$emit('on-show')}},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}},[_vm._t("popup-header",null,{options:_vm.options,value:_vm.currentValue}),_vm._v(" "),_c('radio',{attrs:{"options":_vm.options,"fill-mode":false},on:{"on-change":_vm.onValueChange},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_vm._t("each-item",[_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(props.icon),expression:"props.icon"}],staticClass:"vux-radio-icon",attrs:{"src":props.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label"},[_vm._v(_vm._s(props.label))])])],{icon:props.icon,label:props.label,index:props.index})]}}]),model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],2)],1)])}
var popup_radio_staticRenderFns = []
var popup_radio_esExports = { render: popup_radio_render, staticRenderFns: popup_radio_staticRenderFns }
/* harmony default export */ var src_components_popup_radio = (popup_radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-radio/index.vue
function popup_radio_injectStyle (ssrContext) {
  __webpack_require__("X+l2")
}
var popup_radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_radio___vue_template_functional__ = false
/* styles */
var popup_radio___vue_styles__ = popup_radio_injectStyle
/* scopeId */
var popup_radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_radio___vue_module_identifier__ = null
var popup_radio_Component = popup_radio_normalizeComponent(
  components_popup_radio,
  src_components_popup_radio,
  popup_radio___vue_template_functional__,
  popup_radio___vue_styles__,
  popup_radio___vue_scopeId__,
  popup_radio___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_radio = (popup_radio_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a59d98f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var confirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]),_vm._v(" "),_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))])])],2)],1)}
var confirm_staticRenderFns = []
var confirm_esExports = { render: confirm_render, staticRenderFns: confirm_staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (confirm_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function confirm_injectStyle (ssrContext) {
  __webpack_require__("KB9y")
}
var confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirm___vue_template_functional__ = false
/* styles */
var confirm___vue_styles__ = confirm_injectStyle
/* scopeId */
var confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confirm___vue_module_identifier__ = null
var confirm_Component = confirm_normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  confirm___vue_template_functional__,
  confirm___vue_styles__,
  confirm___vue_scopeId__,
  confirm___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = (confirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/payComponents/water.vue
















/* harmony default export */ var water = ({
  components: {
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    XTextarea: vux_src_components_x_textarea,
    Cell: cell["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    PopupRadio: vux_src_components_popup_radio,
    Alert: components_alert["a" /* default */],
    XInput: x_input["a" /* default */],
    $: jquery_default.a,
    loadPage: src_components_loadingPage,
    Confirm: node_modules_vux_src_components_confirm
  },
  data: function data() {
    return {
      houseinfo: '',
      number: '0',
      show: false,
      shows1: false,
      shows2: false,
      shows3: false,
      show4: false,
      show5: false,
      hidds: false,
      isshowBtn: true,
      paytype: '0',
      pricd: '',
      status: '',
      buyOne: '',
      buyLimt: '',
      buyCouts: '',
      electricCout: '',
      elecouts: '',
      numbers: '',
      paysum: '',
      title: '',
      housrCode: '',
      successCode: '',
      listCode: '',
      numList: [],
      allCount: '',
      feeNamet: '',
      waterSimplePrice: '',

      comnCode: '',
      hsNo: '',
      hsName: '',
      feeCode: '',
      feeCodes: '',
      feePrices: '',
      feeCount: '',
      billMoney: '',
      realMoney: '',
      mainPhone: '',
      openId: '',
      prompt: '',
      showprompt: false,
      submitable: false
    };
  },
  mounted: function mounted() {
    this.elecouts = this.$router.history.current.query.elecout;
    this.numbers = this.$router.history.current.query.numbers;
    this.feeCodes = this.$router.history.current.query.feeCodes;
    this.feePrices = this.$router.history.current.query.feePrices;

    if (this.$router.history.current.path == '/pay/water') {
      jquery_default()(".vux-button-tab-item:last-child").addClass("vux-button-group-current").siblings(".vux-button-tab-item").removeClass("vux-button-group-current");

      document.title = "水费缴纳";
    }

    var index = "";
    var selfs = this;
    jquery_default()(".btnm").click(function () {
      index = jquery_default()(this).index();
      jquery_default()(this).addClass("btnActive");
      jquery_default()(this).parent(".vux-flexbox-item").siblings(".vux-flexbox-item").find(".btnm").removeClass("btnActive");
      selfs.number = parseInt(jquery_default()(this).find("strong").text());

      if (selfs.status == false) {
        if (selfs.number > parseInt(selfs.buyLimt)) {
          selfs.show = true;
          selfs.shows1 = false;
          selfs.electricCout = selfs.number * selfs.pricd;
        }
      } else if (selfs.status == true) {
        if (selfs.number > parseInt(selfs.buyOne)) {
          selfs.shows1 = true;
          selfs.show = false;
          selfs.electricCout = selfs.number * selfs.pricd;
        }
      }
    });

    jquery_default()(".kystr .weui-input").on("change", function () {
      if (isNaN(selfs.number)) {
        selfs.prompt = '请输入有效内容！';
        selfs.showprompt = true;
        selfs.number = 0;
      } else {
        if (selfs.status == false) {
          if (selfs.number > parseInt(selfs.buyLimt)) {
            console.log("****************");
            console.log(selfs.number);
            selfs.show = true;
            selfs.shows1 = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          } else {
            selfs.show = false;
            selfs.shows1 = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          }
        } else if (selfs.status == true) {
          if (selfs.number > parseInt(selfs.buyOne)) {
            selfs.shows1 = true;
            selfs.show = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          } else {
            selfs.shows1 = false;
            selfs.show = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          }
        }
      }
    });
    jquery_default()("#no1").click(function () {
      selfs.number = selfs.buyLimt;
    });
    jquery_default()("#no2").click(function () {
      selfs.number = selfs.buyOne;
    });

    jquery_default()("#submitForm .weui-dialog__btn_primary").click(function () {

      var mInfo = new Object();
      mInfo.comnCode = selfs.comnCode;
      mInfo.openid = selfs.$router.history.current.query.openid;;
      mInfo.memberNo = selfs.$router.history.current.query.phone;
      mInfo.tradeAmount = selfs.allCount;
      mInfo.tradeDesc = selfs.feeNamet;
      mInfo.tradeName = selfs.feeNamet;
      mInfo.tradeNo = selfs.listCode;
      var url = global.host + 'hydro/getpayurl';
      selfs.$http.post(url, mInfo).then(function (res) {

        window.location.href = res.body.payurl;
      }, function (err) {
        console.log(err);
      });
    });
  },

  methods: {
    /*根据不同的操作进行操作*/
    refresh: function refresh() {
      if (this.prompt == '您有未处理的订单,请优先处理') {
        this.submitable = true;
        this.$router.push({ path: '/paymentRecord', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
      } else {
        this.submitable = false;
      }
    },

    /*提交订单之前的操作*/
    submitBefore: function submitBefore() {
      this.submitable = true;
      this.$http.get(global.host + 'hydro/findownerunpaidorder?comnCode=' + this.comnCode + '&houseNo=' + this.hsNo + '&openid=' + this.$router.history.current.query.openid + '&phoneNo=' + this.$router.history.current.query.phone).then(function (res) {
        console.log("%%%%%%%%%%%%%%%%%%%%%");
        console.log(res);
        if (res.body.code == '110') {
          this.submitable = false;
          this.submit();
        } else if (res.body.code == '120') {
          this.prompt = '您有未处理的订单,请优先处理';
          this.showprompt = true;
        }
      }, function (err) {
        console.log(err);
      });
      /*提交订单信息*/
    },
    submit: function submit() {
      var selfs = this;
      if (selfs.buyCouts <= 0) {
        selfs.shows2 = true;
      } else {
        if (selfs.number == 0) {
          selfs.shows3 = true;
        } else {

          /***************提交订单ajax*****************/

          var uns = new Object();
          uns.comnCode = selfs.$router.history.current.query.comnCodes;
          uns.hsNo = selfs.$router.history.current.query.hsNos;
          uns.hsName = selfs.$router.history.current.query.hsNames;
          uns.feeCount = selfs.numbers;
          uns.billMoney = selfs.elecouts;
          uns.realMoney = selfs.elecouts;
          uns.feeCode = selfs.feeCodes;
          uns.feePrice = selfs.feePrices;
          uns.mainPhone = selfs.$router.history.current.query.phone;
          uns.openId = selfs.$router.history.current.query.openid;

          var usino = new Object();
          usino.comnCode = selfs.comnCode;
          usino.hsNo = selfs.hsNo;
          usino.hsName = selfs.hsName;
          usino.feeCount = selfs.number;
          usino.billMoney = selfs.electricCout;
          usino.realMoney = selfs.electricCout;
          usino.feeCode = selfs.feeCode;
          usino.feePrice = selfs.pricd;
          usino.mainPhone = selfs.$router.history.current.query.phone;
          usino.openId = selfs.$router.history.current.query.openid;
          var datms = {
            "list": [usino, uns]
          };
          if (selfs.numbers == undefined || selfs.numbers == 0) {
            datms.list.pop();
          }

          var url = global.host + 'hydro/subwaterelec';
          selfs.$http.post(url, datms).then(function (res) {
            selfs.successCode = res.body.code;
            selfs.listCode = res.body.tradeNo;
            if (selfs.successCode == "110") {
              var _url = global.host + 'hydro/findunpaiddetail?tradeNo=' + selfs.listCode;
              selfs.$http.get(_url).then(function (res) {
                selfs.allCount = res.body.account;

                var dalList = res.body.result;
                selfs.numList = new Object();
                for (var mk in dalList) {
                  if (dalList[mk].feeCount == 0) {
                    continue;
                  }
                  selfs.numList[mk] = dalList[mk];
                  selfs.feeNamet = dalList[mk].feeName;
                }
              }, function (err) {
                console.log(err);
              });
            } else if (selfs.successCode == "120") {
              selfs.show5 = true;
            }
          }, function (err) {
            console.log(err);
          });
          selfs.show4 = true;
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    var url = global.host + 'hydro/findhouseinfo?openid=' + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone + "&paytype=" + this.paytype;
    this.$http.get(url).then(function (res) {

      this.show_1 = false;
      this.houseinfo = res.body.comnName + " " + res.body.houseCode;
      this.dataList = new Object();
      var dats = res.body.typeprice;
      var dats1 = res.body.limitlist;
      this.pricd = dats.feePrice;
      this.status = res.body.paystatus;
      this.buyOne = dats1[0].buyOnce;
      this.buyLimt = dats1[0].buyLimit;
      this.buyCouts = res.body.buycount;

      this.comnCode = dats1[0].comnCode;
      this.hsNo = res.body.houseCode;
      this.hsName = res.body.hsName;
      this.feeCode = dats.feeCode;
      this.feePrice = dats.feePrice;
      this.feeCount = dats.feeCount;
      this.billMoney = dats.billMoney;
      this.realMoney = dats.realMoney;
      this.mainPhone = dats.mainPhone;
    }, function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/payComponents/water.vue
















/* harmony default export */ var payComponents_water = ({
  components: {
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    XTextarea: vux_src_components_x_textarea,
    Cell: cell["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    PopupRadio: vux_src_components_popup_radio,
    Alert: components_alert["a" /* default */],
    XInput: x_input["a" /* default */],
    $: jquery_default.a,
    loadPage: src_components_loadingPage,
    Confirm: node_modules_vux_src_components_confirm
  },
  data: function data() {
    return {
      houseinfo: '',
      number: '0',
      show: false,
      shows1: false,
      shows2: false,
      shows3: false,
      show4: false,
      show5: false,
      hidds: false,
      isshowBtn: true,
      paytype: '0',
      pricd: '',
      status: '',
      buyOne: '',
      buyLimt: '',
      buyCouts: '',
      electricCout: '',
      elecouts: '',
      numbers: '',
      paysum: '',
      title: '',
      housrCode: '',
      successCode: '',
      listCode: '',
      numList: [],
      allCount: '',
      feeNamet: '',
      waterSimplePrice: '',

      comnCode: '',
      hsNo: '',
      hsName: '',
      feeCode: '',
      feeCodes: '',
      feePrices: '',
      feeCount: '',
      billMoney: '',
      realMoney: '',
      mainPhone: '',
      openId: '',
      prompt: '',
      showprompt: false,
      submitable: false
    };
  },
  mounted: function mounted() {
    this.elecouts = this.$router.history.current.query.elecout;
    this.numbers = this.$router.history.current.query.numbers;
    this.feeCodes = this.$router.history.current.query.feeCodes;
    this.feePrices = this.$router.history.current.query.feePrices;

    if (this.$router.history.current.path == '/pay/water') {
      jquery_default()(".vux-button-tab-item:last-child").addClass("vux-button-group-current").siblings(".vux-button-tab-item").removeClass("vux-button-group-current");

      document.title = "水费缴纳";
    }

    var index = "";
    var selfs = this;
    jquery_default()(".btnm").click(function () {
      index = jquery_default()(this).index();
      jquery_default()(this).addClass("btnActive");
      jquery_default()(this).parent(".vux-flexbox-item").siblings(".vux-flexbox-item").find(".btnm").removeClass("btnActive");
      selfs.number = parseInt(jquery_default()(this).find("strong").text());

      if (selfs.status == false) {
        if (selfs.number > parseInt(selfs.buyLimt)) {
          selfs.show = true;
          selfs.shows1 = false;
          selfs.electricCout = selfs.number * selfs.pricd;
        }
      } else if (selfs.status == true) {
        if (selfs.number > parseInt(selfs.buyOne)) {
          selfs.shows1 = true;
          selfs.show = false;
          selfs.electricCout = selfs.number * selfs.pricd;
        }
      }
    });

    jquery_default()(".kystr .weui-input").on("change", function () {
      if (isNaN(selfs.number)) {
        selfs.prompt = '请输入有效内容！';
        selfs.showprompt = true;
        selfs.number = 0;
      } else {
        if (selfs.status == false) {
          if (selfs.number > parseInt(selfs.buyLimt)) {
            console.log("****************");
            console.log(selfs.number);
            selfs.show = true;
            selfs.shows1 = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          } else {
            selfs.show = false;
            selfs.shows1 = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          }
        } else if (selfs.status == true) {
          if (selfs.number > parseInt(selfs.buyOne)) {
            selfs.shows1 = true;
            selfs.show = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          } else {
            selfs.shows1 = false;
            selfs.show = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          }
        }
      }
    });
    jquery_default()("#no1").click(function () {
      selfs.number = selfs.buyLimt;
    });
    jquery_default()("#no2").click(function () {
      selfs.number = selfs.buyOne;
    });

    jquery_default()("#submitForm .weui-dialog__btn_primary").click(function () {

      var mInfo = new Object();
      mInfo.comnCode = selfs.comnCode;
      mInfo.openid = selfs.$router.history.current.query.openid;;
      mInfo.memberNo = selfs.$router.history.current.query.phone;
      mInfo.tradeAmount = selfs.allCount;
      mInfo.tradeDesc = selfs.feeNamet;
      mInfo.tradeName = selfs.feeNamet;
      mInfo.tradeNo = selfs.listCode;
      var url = global.host + 'hydro/getpayurl';
      selfs.$http.post(url, mInfo).then(function (res) {

        window.location.href = res.body.payurl;
      }, function (err) {
        console.log(err);
      });
    });
  },

  methods: {
    /*根据不同的操作进行操作*/
    refresh: function refresh() {
      if (this.prompt == '您有未处理的订单,请优先处理') {
        this.submitable = true;
        this.$router.push({ path: '/paymentRecord', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
      } else {
        this.submitable = false;
      }
    },

    /*提交订单之前的操作*/
    submitBefore: function submitBefore() {
      this.submitable = true;
      this.$http.get(global.host + 'hydro/findownerunpaidorder?comnCode=' + this.comnCode + '&houseNo=' + this.hsNo + '&openid=' + this.$router.history.current.query.openid + '&phoneNo=' + this.$router.history.current.query.phone).then(function (res) {
        console.log("%%%%%%%%%%%%%%%%%%%%%");
        console.log(res);
        if (res.body.code == '110') {
          this.submitable = false;
          this.submit();
        } else if (res.body.code == '120') {
          this.prompt = '您有未处理的订单,请优先处理';
          this.showprompt = true;
        }
      }, function (err) {
        console.log(err);
      });
      /*提交订单信息*/
    },
    submit: function submit() {
      var selfs = this;
      if (selfs.buyCouts <= 0) {
        selfs.shows2 = true;
      } else {
        if (selfs.number == 0) {
          selfs.shows3 = true;
        } else {

          /***************提交订单ajax*****************/

          var uns = new Object();
          uns.comnCode = selfs.$router.history.current.query.comnCodes;
          uns.hsNo = selfs.$router.history.current.query.hsNos;
          uns.hsName = selfs.$router.history.current.query.hsNames;
          uns.feeCount = selfs.numbers;
          uns.billMoney = selfs.elecouts;
          uns.realMoney = selfs.elecouts;
          uns.feeCode = selfs.feeCodes;
          uns.feePrice = selfs.feePrices;
          uns.mainPhone = selfs.$router.history.current.query.phone;
          uns.openId = selfs.$router.history.current.query.openid;

          var usino = new Object();
          usino.comnCode = selfs.comnCode;
          usino.hsNo = selfs.hsNo;
          usino.hsName = selfs.hsName;
          usino.feeCount = selfs.number;
          usino.billMoney = selfs.electricCout;
          usino.realMoney = selfs.electricCout;
          usino.feeCode = selfs.feeCode;
          usino.feePrice = selfs.pricd;
          usino.mainPhone = selfs.$router.history.current.query.phone;
          usino.openId = selfs.$router.history.current.query.openid;
          var datms = {
            "list": [usino, uns]
          };
          if (selfs.numbers == undefined || selfs.numbers == 0) {
            datms.list.pop();
          }

          var url = global.host + 'hydro/subwaterelec';
          selfs.$http.post(url, datms).then(function (res) {
            selfs.successCode = res.body.code;
            selfs.listCode = res.body.tradeNo;
            if (selfs.successCode == "110") {
              var _url = global.host + 'hydro/findunpaiddetail?tradeNo=' + selfs.listCode;
              selfs.$http.get(_url).then(function (res) {
                selfs.allCount = res.body.account;

                var dalList = res.body.result;
                selfs.numList = new Object();
                for (var mk in dalList) {
                  if (dalList[mk].feeCount == 0) {
                    continue;
                  }
                  selfs.numList[mk] = dalList[mk];
                  selfs.feeNamet = dalList[mk].feeName;
                }
              }, function (err) {
                console.log(err);
              });
            } else if (selfs.successCode == "120") {
              selfs.show5 = true;
            }
          }, function (err) {
            console.log(err);
          });
          selfs.show4 = true;
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    var url = global.host + 'hydro/findhouseinfo?openid=' + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone + "&paytype=" + this.paytype;
    this.$http.get(url).then(function (res) {

      this.show_1 = false;
      this.houseinfo = res.body.comnName + " " + res.body.houseCode;
      this.dataList = new Object();
      var dats = res.body.typeprice;
      var dats1 = res.body.limitlist;
      this.pricd = dats.feePrice;
      this.status = res.body.paystatus;
      this.buyOne = dats1[0].buyOnce;
      this.buyLimt = dats1[0].buyLimit;
      this.buyCouts = res.body.buycount;

      this.comnCode = dats1[0].comnCode;
      this.hsNo = res.body.houseCode;
      this.hsName = res.body.hsName;
      this.feeCode = dats.feeCode;
      this.feePrice = dats.feePrice;
      this.feeCount = dats.feeCount;
      this.billMoney = dats.billMoney;
      this.realMoney = dats.realMoney;
      this.mainPhone = dats.mainPhone;
    }, function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-202db940","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payComponents/water.vue
var water_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{staticStyle:{"margin-top":"-12px"}},[_c('cell',{staticStyle:{"font-size":"0.9em"},attrs:{"title":"房屋信息","value":_vm.houseinfo}})],1),_vm._v(" "),_c('div',{staticStyle:{"height":"20px"}}),_vm._v(" "),_c('group',[_c('cell',{staticStyle:{"text-align":"center"},attrs:{"title":"购水详情"}}),_vm._v(" "),_c('cell',{attrs:{"title":"单价"}},[_vm._v(_vm._s(_vm.pricd)+"元/吨")]),_vm._v(" "),_c('cell',{directives:[{name:"show",rawName:"v-show",value:(_vm.hidds),expression:"hidds"}],attrs:{"title":"限购数量","value":"5"}}),_vm._v(" "),_c('cell',{directives:[{name:"show",rawName:"v-show",value:(_vm.hidds),expression:"hidds"}],attrs:{"title":"限购次数","value":"4"}})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"90%","margin":"0 auto"}},[_c('div',{staticStyle:{"height":"25px"}}),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('x-button',{staticClass:"btnm",attrs:{"type":"primary","plain":""}},[_c('strong',[_vm._v("5")]),_vm._v("吨")])],1),_vm._v(" "),_c('flexbox-item',[_c('x-button',{staticClass:"btnm",attrs:{"type":"primary","plain":""}},[_c('strong',[_vm._v("10")]),_vm._v("吨")])],1),_vm._v(" "),_c('flexbox-item',[_c('x-button',{staticClass:"btnm",attrs:{"type":"primary","plain":""}},[_c('strong',[_vm._v("20")]),_vm._v("吨")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"height":"10px"}})],1),_vm._v(" "),_c('div',{staticStyle:{"height":"10px"}}),_vm._v(" "),_c('group',[_c('x-input',{staticClass:"kystr",attrs:{"title":"购水数量","text-align":"right"},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})],1),_vm._v(" "),_c('div',{staticStyle:{"height":"20px"}}),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('router-link',{attrs:{"to":{path:'/pay/electricity',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone,elecout:_vm.electricCout,numbers:_vm.number,feeCodes:_vm.feeCode,feePrices:_vm.pricd,comnCodes:_vm.comnCode,hsNos:_vm.hsNo,hsNames:_vm.hsName,comnCode:_vm.comnCode}}}},[_c('x-button',{attrs:{"type":"primary"}},[_vm._v("缴电费")])],1)],1),_vm._v(" "),_c('flexbox-item',[_c('x-button',{attrs:{"type":"primary","id":"waterButton","disabled":_vm.submitable},nativeOn:{"click":function($event){return _vm.submitBefore($event)}}},[_vm._v("提交订单")])],1)],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示","id":"no1"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v("您当前有欠费最多可购买"+_vm._s(_vm.buyLimt)+"吨水")])],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示","id":"no2"},model:{value:(_vm.shows1),callback:function ($$v) {_vm.shows1=$$v},expression:"shows1"}},[_vm._v("您最多可购买"+_vm._s(_vm.buyOne)+"吨水")])],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.shows2),callback:function ($$v) {_vm.shows2=$$v},expression:"shows2"}},[_vm._v("您本月购水次数已用完")])],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.shows3),callback:function ($$v) {_vm.shows3=$$v},expression:"shows3"}},[_vm._v("请选择购水数量")])],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.show5),callback:function ($$v) {_vm.show5=$$v},expression:"show5"}},[_vm._v("提交失败")])],1),_vm._v(" "),_c('confirm',{attrs:{"title":"订单详情","confirm-text":"去支付","id":"submitForm"},model:{value:(_vm.show4),callback:function ($$v) {_vm.show4=$$v},expression:"show4"}},[_c('div',{staticStyle:{"border-bottom":"1px solid #ddd","margin":"1px -5px","line-height":"1.4","padding":"8px 0"}},_vm._l((_vm.numList),function(item,key){return _c('div',{key:_vm.index},[_c('flexbox',{staticStyle:{"margin-bottom":"6px"},attrs:{"gutter":0}},[_c('flexbox-item',{attrs:{"span":1/4}},[_c('p',{staticStyle:{"color":"black","font-size":"0.9em","text-align":"center"}},[_vm._v(_vm._s(item.feeName))])]),_vm._v(" "),(item.feeName == '水费')?_c('flexbox-item',{attrs:{"span":1/4}},[_c('p',{staticStyle:{"color":"orange","font-size":"0.9em","text-align":"left","padding-left":"0"},attrs:{"text-align":"right"}},[_vm._v(_vm._s(item.feePrice)+"元/吨")])]):(item.feeName == '电费')?_c('flexbox-item',{attrs:{"span":1/4}},[_c('p',{staticStyle:{"color":"orange","font-size":"0.9em","text-align":"left","padding-left":"0"},attrs:{"text-align":"right"}},[_vm._v(_vm._s(item.feePrice)+"元/度")])]):_vm._e(),_vm._v(" "),(item.feeName == '水费')?_c('flexbox-item',{attrs:{"span":1/4}},[_c('p',{staticStyle:{"color":"orange","font-size":"0.9em","text-align":"left","padding-left":"0"},attrs:{"text-align":"right"}},[_vm._v(_vm._s(item.feeCount)+"吨")])]):_vm._e(),_vm._v(" "),(item.feeName == '电费')?_c('flexbox-item',{attrs:{"span":1/4}},[_c('p',{staticStyle:{"color":"orange","font-size":"0.9em","text-align":"left","padding-left":"0"},attrs:{"text-align":"right"}},[_vm._v(_vm._s(item.feeCount)+"度")])]):_vm._e(),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/4}},[_c('p',{staticStyle:{"color":"orange","font-size":"0.9em","text-align":"center"}},[_vm._v(_vm._s(item.realMoney)+"元")])])],1)],1)})),_vm._v(" "),_c('h5',{staticStyle:{"line-height":"1.5","font-size":"0.9em","padding":"5px 0px 0","text-align":"right","color":"red"}},[_vm._v("费用总计 ： "),_c('span',{staticStyle:{"text-indent":"20px"}},[_vm._v(_vm._s(_vm.allCount)+"元")])])]),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},on:{"on-hide":_vm.refresh},model:{value:(_vm.showprompt),callback:function ($$v) {_vm.showprompt=$$v},expression:"showprompt"}},[_vm._v(_vm._s(_vm.prompt))])],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var water_staticRenderFns = []
var water_esExports = { render: water_render, staticRenderFns: water_staticRenderFns }
/* harmony default export */ var components_payComponents_water = (water_esExports);
// CONCATENATED MODULE: ./src/components/payComponents/water.vue
function water_injectStyle (ssrContext) {
  __webpack_require__("+Q4U")
}
var water_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var water___vue_template_functional__ = false
/* styles */
var water___vue_styles__ = water_injectStyle
/* scopeId */
var water___vue_scopeId__ = "data-v-202db940"
/* moduleIdentifier (server only) */
var water___vue_module_identifier__ = null
var water_Component = water_normalizeComponent(
  payComponents_water,
  components_payComponents_water,
  water___vue_template_functional__,
  water___vue_styles__,
  water___vue_scopeId__,
  water___vue_module_identifier__
)

/* harmony default export */ var src_components_payComponents_water = (water_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/payComponents/electricity.vue
















/* harmony default export */ var electricity = ({
  components: {
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    XTextarea: vux_src_components_x_textarea,
    Cell: cell["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    PopupRadio: vux_src_components_popup_radio,
    Alert: components_alert["a" /* default */],
    XInput: x_input["a" /* default */],
    $: jquery_default.a,
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      houseinfo: '',
      number: '0',
      show: false,
      shows1: false,
      isshowBtn: true,
      hidds: false,
      paytype: '1',
      pricd: '',
      status: '',
      buyOne: '',
      buyLimt: '',
      buyCouts: '',
      shows2: false,
      shows3: false,
      show4: false,
      show5: false,
      electricCout: '',
      elecouts: '',
      numbers: '',
      housrCode: '',
      successCode: '',
      listCode: '',
      numList: [],
      allCount: '',
      feeNamet: '',
      feeCodes: '',
      feePrices: '',

      comnCode: '',
      hsNo: '',
      hsName: '',
      feeCode: '',
      feePrice: '',
      feeCount: '',
      billMoney: '',
      realMoney: '',
      mainPhone: '',
      openId: '',
      prompt: '',
      showprompt: false,
      submitable: false
    };
  },
  mounted: function mounted() {
    this.elecouts = this.$router.history.current.query.elecout;
    this.numbers = this.$router.history.current.query.numbers;
    this.feeCodes = this.$router.history.current.query.feeCodes;
    this.feePrices = this.$router.history.current.query.feePrices;

    if (this.$router.history.current.path == '/pay/electricity') {
      jquery_default()(".vux-button-tab-item:eq(1)").addClass("vux-button-group-current").siblings(".vux-button-tab-item").removeClass("vux-button-group-current");

      document.title = "电费缴纳";
    }

    var index = "";
    var selfs = this;
    jquery_default()(".btnm").click(function () {
      index = jquery_default()(this).index();
      jquery_default()(this).addClass("btnActive");
      jquery_default()(this).parent(".vux-flexbox-item").siblings(".vux-flexbox-item").find(".btnm").removeClass("btnActive");
      selfs.number = parseInt(jquery_default()(this).find("strong").text());

      if (selfs.status == false) {
        if (selfs.number > parseInt(selfs.buyLimt)) {
          selfs.show = true;
          selfs.shows1 = false;
          selfs.electricCout = selfs.number * selfs.pricd;
        }
      } else if (selfs.status == true) {
        if (selfs.number > parseInt(selfs.buyOne)) {
          selfs.shows1 = true;
          selfs.show = false;
          selfs.electricCout = selfs.number * selfs.pricd;
        }
      }
    });

    jquery_default()(".kystr .weui-input").on("change", function () {
      if (isNaN(selfs.number)) {
        selfs.prompt = '请输入有效内容！';
        selfs.showprompt = true;
        selfs.number = 0;
      } else {
        if (selfs.status == false) {
          if (selfs.number > parseInt(selfs.buyLimt)) {
            selfs.show = true;
            selfs.shows1 = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          } else {
            selfs.show = false;
            selfs.shows1 = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          }
        } else if (selfs.status == true) {
          if (selfs.number > parseInt(selfs.buyOne)) {
            selfs.shows1 = true;
            selfs.show = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          } else {
            selfs.shows1 = false;
            selfs.show = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          }
        }
      }
    });
    jquery_default()("#no1").click(function () {
      selfs.number = selfs.buyLimt;
    });
    jquery_default()("#no2").click(function () {
      selfs.number = selfs.buyOne;
    });

    jquery_default()("#submitForm .weui-dialog__btn_primary").click(function () {

      var mInfo = new Object();
      mInfo.comnCode = selfs.comnCode;
      mInfo.openid = selfs.$router.history.current.query.openid;;
      mInfo.memberNo = selfs.$router.history.current.query.phone;
      mInfo.tradeAmount = selfs.allCount;
      mInfo.tradeDesc = selfs.feeNamet;
      mInfo.tradeName = selfs.feeNamet;
      mInfo.tradeNo = selfs.listCode;

      var url = global.host + 'hydro/getpayurl';
      selfs.$http.post(url, mInfo).then(function (res) {

        window.location.href = res.body.payurl;
      }, function (err) {
        console.log(err);
      });
    });
  },

  methods: {
    /*根据不同的操作进行操作*/
    refresh: function refresh() {
      if (this.prompt == '您有未处理的订单,请优先处理') {
        this.submitable = true;
        this.$router.push({ path: '/paymentRecord', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
      } else {
        this.submitable = false;
      }
    },

    /*提交订单之前的操作*/
    submitBefore: function submitBefore() {
      this.submitable = true;
      this.$http.get(global.host + 'hydro/findownerunpaidorder?comnCode=' + this.comnCode + '&houseNo=' + this.hsNo + '&openid=' + this.$router.history.current.query.openid + '&phoneNo=' + this.$router.history.current.query.phone).then(function (res) {
        console.log("%%%%%%%%%%%%%%%%%%%%%");
        console.log(res);
        if (res.body.code == '110') {
          this.submitable = false;
          this.submit();
        } else if (res.body.code == '120') {
          this.prompt = '您有未处理的订单,请优先处理';
          this.showprompt = true;
        }
      }, function (err) {
        console.log(err);
      });
    },
    submit: function submit() {
      var selfs = this;
      if (selfs.buyCouts <= 0) {
        selfs.shows2 = true;
      } else {
        if (selfs.number == 0) {
          selfs.shows3 = true;
        } else {

          /***************提交订单ajax*****************/

          var uns = new Object();
          uns.comnCode = selfs.$router.history.current.query.comnCodes;
          uns.hsNo = selfs.$router.history.current.query.hsNos;
          uns.hsName = selfs.$router.history.current.query.hsNames;
          uns.feeCount = selfs.numbers;
          uns.billMoney = selfs.elecouts;
          uns.realMoney = selfs.elecouts;
          uns.feeCode = selfs.feeCodes;
          uns.feePrice = selfs.feePrices;
          uns.mainPhone = selfs.$router.history.current.query.phone;
          uns.openId = selfs.$router.history.current.query.openid;

          var usino = new Object();
          usino.comnCode = selfs.comnCode;
          usino.hsNo = selfs.hsNo;
          usino.hsName = selfs.hsName;
          usino.feeCount = selfs.number;
          usino.billMoney = selfs.electricCout;
          usino.realMoney = selfs.electricCout;
          usino.feeCode = selfs.feeCode;
          usino.feePrice = selfs.pricd;
          usino.mainPhone = selfs.$router.history.current.query.phone;
          usino.openId = selfs.$router.history.current.query.openid;
          var datms = {
            "list": [usino, uns]
          };
          if (selfs.numbers == undefined || selfs.numbers == 0) {
            datms.list.pop();
          }
          console.log("********************");
          console.log(datms);

          var url = global.host + 'hydro/subwaterelec';
          selfs.$http.post(url, datms).then(function (res) {
            selfs.successCode = res.body.code;
            selfs.listCode = res.body.tradeNo;
            console.log(res.body.tradeNo);
            if (selfs.successCode == "110") {
              var _url = global.host + 'hydro/findunpaiddetail?tradeNo=' + selfs.listCode;
              selfs.$http.get(_url).then(function (res) {
                selfs.allCount = res.body.account;

                var dalList = res.body.result;
                selfs.numList = new Object();
                for (var mk in dalList) {
                  if (dalList[mk].feeCount == 0) {
                    continue;
                  }
                  selfs.numList[mk] = dalList[mk];
                  selfs.feeNamet = dalList[mk].feeName;
                }
              }, function (err) {
                console.log(err);
              });
            } else if (selfs.successCode == "120") {
              selfs.show5 = true;
            }
          }, function (err) {
            console.log(err);
          });

          selfs.show4 = true;
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    var url = global.host + 'hydro/findhouseinfo?openid=' + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone + "&paytype=" + this.paytype;
    this.$http.get(url).then(function (res) {
      this.show_1 = false;
      this.houseinfo = res.body.comnName + " " + res.body.houseCode;
      this.dataList = new Object();
      var dats = res.body.typeprice;
      var dats1 = res.body.limitlist;
      this.pricd = dats.feePrice;
      this.status = res.body.paystatus;
      this.buyOne = dats1[0].buyOnce;
      this.buyLimt = dats1[0].buyLimit;
      this.buyCouts = res.body.buycount;

      this.comnCode = dats1[0].comnCode;
      this.hsNo = res.body.houseCode;
      this.hsName = res.body.hsName;
      this.feeCode = dats.feeCode;
      this.feePrice = dats.feePrice;
      this.feeCount = dats.feeCount;
      this.billMoney = dats.billMoney;
      this.realMoney = dats.realMoney;
      this.mainPhone = dats.mainPhone;
    }, function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/payComponents/electricity.vue
















/* harmony default export */ var payComponents_electricity = ({
  components: {
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    XTextarea: vux_src_components_x_textarea,
    Cell: cell["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    PopupRadio: vux_src_components_popup_radio,
    Alert: components_alert["a" /* default */],
    XInput: x_input["a" /* default */],
    $: jquery_default.a,
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      houseinfo: '',
      number: '0',
      show: false,
      shows1: false,
      isshowBtn: true,
      hidds: false,
      paytype: '1',
      pricd: '',
      status: '',
      buyOne: '',
      buyLimt: '',
      buyCouts: '',
      shows2: false,
      shows3: false,
      show4: false,
      show5: false,
      electricCout: '',
      elecouts: '',
      numbers: '',
      housrCode: '',
      successCode: '',
      listCode: '',
      numList: [],
      allCount: '',
      feeNamet: '',
      feeCodes: '',
      feePrices: '',

      comnCode: '',
      hsNo: '',
      hsName: '',
      feeCode: '',
      feePrice: '',
      feeCount: '',
      billMoney: '',
      realMoney: '',
      mainPhone: '',
      openId: '',
      prompt: '',
      showprompt: false,
      submitable: false
    };
  },
  mounted: function mounted() {
    this.elecouts = this.$router.history.current.query.elecout;
    this.numbers = this.$router.history.current.query.numbers;
    this.feeCodes = this.$router.history.current.query.feeCodes;
    this.feePrices = this.$router.history.current.query.feePrices;

    if (this.$router.history.current.path == '/pay/electricity') {
      jquery_default()(".vux-button-tab-item:eq(1)").addClass("vux-button-group-current").siblings(".vux-button-tab-item").removeClass("vux-button-group-current");

      document.title = "电费缴纳";
    }

    var index = "";
    var selfs = this;
    jquery_default()(".btnm").click(function () {
      index = jquery_default()(this).index();
      jquery_default()(this).addClass("btnActive");
      jquery_default()(this).parent(".vux-flexbox-item").siblings(".vux-flexbox-item").find(".btnm").removeClass("btnActive");
      selfs.number = parseInt(jquery_default()(this).find("strong").text());

      if (selfs.status == false) {
        if (selfs.number > parseInt(selfs.buyLimt)) {
          selfs.show = true;
          selfs.shows1 = false;
          selfs.electricCout = selfs.number * selfs.pricd;
        }
      } else if (selfs.status == true) {
        if (selfs.number > parseInt(selfs.buyOne)) {
          selfs.shows1 = true;
          selfs.show = false;
          selfs.electricCout = selfs.number * selfs.pricd;
        }
      }
    });

    jquery_default()(".kystr .weui-input").on("change", function () {
      if (isNaN(selfs.number)) {
        selfs.prompt = '请输入有效内容！';
        selfs.showprompt = true;
        selfs.number = 0;
      } else {
        if (selfs.status == false) {
          if (selfs.number > parseInt(selfs.buyLimt)) {
            selfs.show = true;
            selfs.shows1 = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          } else {
            selfs.show = false;
            selfs.shows1 = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          }
        } else if (selfs.status == true) {
          if (selfs.number > parseInt(selfs.buyOne)) {
            selfs.shows1 = true;
            selfs.show = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          } else {
            selfs.shows1 = false;
            selfs.show = false;
            selfs.electricCout = selfs.number * selfs.pricd;
          }
        }
      }
    });
    jquery_default()("#no1").click(function () {
      selfs.number = selfs.buyLimt;
    });
    jquery_default()("#no2").click(function () {
      selfs.number = selfs.buyOne;
    });

    jquery_default()("#submitForm .weui-dialog__btn_primary").click(function () {

      var mInfo = new Object();
      mInfo.comnCode = selfs.comnCode;
      mInfo.openid = selfs.$router.history.current.query.openid;;
      mInfo.memberNo = selfs.$router.history.current.query.phone;
      mInfo.tradeAmount = selfs.allCount;
      mInfo.tradeDesc = selfs.feeNamet;
      mInfo.tradeName = selfs.feeNamet;
      mInfo.tradeNo = selfs.listCode;

      var url = global.host + 'hydro/getpayurl';
      selfs.$http.post(url, mInfo).then(function (res) {

        window.location.href = res.body.payurl;
      }, function (err) {
        console.log(err);
      });
    });
  },

  methods: {
    /*根据不同的操作进行操作*/
    refresh: function refresh() {
      if (this.prompt == '您有未处理的订单,请优先处理') {
        this.submitable = true;
        this.$router.push({ path: '/paymentRecord', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
      } else {
        this.submitable = false;
      }
    },

    /*提交订单之前的操作*/
    submitBefore: function submitBefore() {
      this.submitable = true;
      this.$http.get(global.host + 'hydro/findownerunpaidorder?comnCode=' + this.comnCode + '&houseNo=' + this.hsNo + '&openid=' + this.$router.history.current.query.openid + '&phoneNo=' + this.$router.history.current.query.phone).then(function (res) {
        console.log("%%%%%%%%%%%%%%%%%%%%%");
        console.log(res);
        if (res.body.code == '110') {
          this.submitable = false;
          this.submit();
        } else if (res.body.code == '120') {
          this.prompt = '您有未处理的订单,请优先处理';
          this.showprompt = true;
        }
      }, function (err) {
        console.log(err);
      });
    },
    submit: function submit() {
      var selfs = this;
      if (selfs.buyCouts <= 0) {
        selfs.shows2 = true;
      } else {
        if (selfs.number == 0) {
          selfs.shows3 = true;
        } else {

          /***************提交订单ajax*****************/

          var uns = new Object();
          uns.comnCode = selfs.$router.history.current.query.comnCodes;
          uns.hsNo = selfs.$router.history.current.query.hsNos;
          uns.hsName = selfs.$router.history.current.query.hsNames;
          uns.feeCount = selfs.numbers;
          uns.billMoney = selfs.elecouts;
          uns.realMoney = selfs.elecouts;
          uns.feeCode = selfs.feeCodes;
          uns.feePrice = selfs.feePrices;
          uns.mainPhone = selfs.$router.history.current.query.phone;
          uns.openId = selfs.$router.history.current.query.openid;

          var usino = new Object();
          usino.comnCode = selfs.comnCode;
          usino.hsNo = selfs.hsNo;
          usino.hsName = selfs.hsName;
          usino.feeCount = selfs.number;
          usino.billMoney = selfs.electricCout;
          usino.realMoney = selfs.electricCout;
          usino.feeCode = selfs.feeCode;
          usino.feePrice = selfs.pricd;
          usino.mainPhone = selfs.$router.history.current.query.phone;
          usino.openId = selfs.$router.history.current.query.openid;
          var datms = {
            "list": [usino, uns]
          };
          if (selfs.numbers == undefined || selfs.numbers == 0) {
            datms.list.pop();
          }
          console.log("********************");
          console.log(datms);

          var url = global.host + 'hydro/subwaterelec';
          selfs.$http.post(url, datms).then(function (res) {
            selfs.successCode = res.body.code;
            selfs.listCode = res.body.tradeNo;
            console.log(res.body.tradeNo);
            if (selfs.successCode == "110") {
              var _url = global.host + 'hydro/findunpaiddetail?tradeNo=' + selfs.listCode;
              selfs.$http.get(_url).then(function (res) {
                selfs.allCount = res.body.account;

                var dalList = res.body.result;
                selfs.numList = new Object();
                for (var mk in dalList) {
                  if (dalList[mk].feeCount == 0) {
                    continue;
                  }
                  selfs.numList[mk] = dalList[mk];
                  selfs.feeNamet = dalList[mk].feeName;
                }
              }, function (err) {
                console.log(err);
              });
            } else if (selfs.successCode == "120") {
              selfs.show5 = true;
            }
          }, function (err) {
            console.log(err);
          });

          selfs.show4 = true;
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    var url = global.host + 'hydro/findhouseinfo?openid=' + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone + "&paytype=" + this.paytype;
    this.$http.get(url).then(function (res) {
      this.show_1 = false;
      this.houseinfo = res.body.comnName + " " + res.body.houseCode;
      this.dataList = new Object();
      var dats = res.body.typeprice;
      var dats1 = res.body.limitlist;
      this.pricd = dats.feePrice;
      this.status = res.body.paystatus;
      this.buyOne = dats1[0].buyOnce;
      this.buyLimt = dats1[0].buyLimit;
      this.buyCouts = res.body.buycount;

      this.comnCode = dats1[0].comnCode;
      this.hsNo = res.body.houseCode;
      this.hsName = res.body.hsName;
      this.feeCode = dats.feeCode;
      this.feePrice = dats.feePrice;
      this.feeCount = dats.feeCount;
      this.billMoney = dats.billMoney;
      this.realMoney = dats.realMoney;
      this.mainPhone = dats.mainPhone;
    }, function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c49b16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payComponents/electricity.vue
var electricity_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{staticStyle:{"margin-top":"-12px"}},[_c('cell',{staticStyle:{"font-size":"0.9em"},attrs:{"title":"房屋信息","value":_vm.houseinfo}})],1),_vm._v(" "),_c('div',{staticStyle:{"height":"20px"}}),_vm._v(" "),_c('group',[_c('cell',{staticStyle:{"text-align":"center"},attrs:{"title":"购电详情"}}),_vm._v(" "),_c('cell',{attrs:{"title":"单价"}},[_vm._v(_vm._s(_vm.pricd)+"元/度")]),_vm._v(" "),_c('cell',{directives:[{name:"show",rawName:"v-show",value:(_vm.hidds),expression:"hidds"}],attrs:{"title":"限购数量","value":"5"}}),_vm._v(" "),_c('cell',{directives:[{name:"show",rawName:"v-show",value:(_vm.hidds),expression:"hidds"}],attrs:{"title":"限购次数","value":"4"}})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"90%","margin":"0 auto"}},[_c('div',{staticStyle:{"height":"25px"}}),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('x-button',{staticClass:"btnm",attrs:{"type":"primary","plain":""}},[_c('strong',[_vm._v("50")]),_vm._v("度")])],1),_vm._v(" "),_c('flexbox-item',[_c('x-button',{staticClass:"btnm",attrs:{"type":"primary","plain":""}},[_c('strong',[_vm._v("100")]),_vm._v("度")])],1),_vm._v(" "),_c('flexbox-item',[_c('x-button',{staticClass:"btnm",attrs:{"type":"primary","plain":""}},[_c('strong',[_vm._v("300")]),_vm._v("度")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"height":"10px"}})],1),_vm._v(" "),_c('div',{staticStyle:{"height":"10px"}}),_vm._v(" "),_c('group',[_c('x-input',{staticClass:"kystr",attrs:{"title":"购电数量","text-align":"right"},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})],1),_vm._v(" "),_c('div',{staticStyle:{"height":"20px"}}),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('router-link',{attrs:{"to":{path:'/pay/water',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone,elecout:_vm.electricCout,numbers:_vm.number,feeCodes:_vm.feeCode,feePrices:_vm.pricd,comnCodes:_vm.comnCode,hsNos:_vm.hsNo,hsNames:_vm.hsName,comnCode:_vm.comnCode}}}},[_c('x-button',{attrs:{"type":"primary"}},[_vm._v("缴水费")])],1)],1),_vm._v(" "),_c('flexbox-item',[_c('x-button',{attrs:{"type":"primary","id":"electricButton","disabled":_vm.submitable},nativeOn:{"click":function($event){return _vm.submitBefore($event)}}},[_vm._v("提交订单")])],1)],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示","id":"no1"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v("您当前有欠费最多可购买"+_vm._s(_vm.buyLimt)+"度电")])],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示","id":"no2"},model:{value:(_vm.shows1),callback:function ($$v) {_vm.shows1=$$v},expression:"shows1"}},[_vm._v("您最多可购买"+_vm._s(_vm.buyOne)+"度电")])],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.shows2),callback:function ($$v) {_vm.shows2=$$v},expression:"shows2"}},[_vm._v("您本月购电次数已用完")])],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.shows3),callback:function ($$v) {_vm.shows3=$$v},expression:"shows3"}},[_vm._v("请选择购电数量")])],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.show5),callback:function ($$v) {_vm.show5=$$v},expression:"show5"}},[_vm._v("提交失败")])],1),_vm._v(" "),_c('confirm',{attrs:{"title":"订单详情","confirm-text":"去支付","id":"submitForm"},model:{value:(_vm.show4),callback:function ($$v) {_vm.show4=$$v},expression:"show4"}},[_c('div',{staticStyle:{"border-bottom":"1px solid #ddd","margin":"1px -5px","line-height":"1.4","padding":"8px 0"}},_vm._l((_vm.numList),function(item,key){return _c('div',{key:_vm.index},[_c('flexbox',{staticStyle:{"margin-bottom":"6px"},attrs:{"gutter":0}},[_c('flexbox-item',{attrs:{"span":1/4}},[_c('p',{staticStyle:{"color":"black","font-size":"0.9em","text-align":"center"}},[_vm._v(_vm._s(item.feeName))])]),_vm._v(" "),(item.feeName == '电费')?_c('flexbox-item',{attrs:{"span":1/4}},[_c('p',{staticStyle:{"color":"orange","font-size":"0.9em","text-align":"left","padding-left":"0"},attrs:{"text-align":"right"}},[_vm._v(_vm._s(item.feePrice)+"元/度")])]):(item.feeName == '水费')?_c('flexbox-item',{attrs:{"span":1/4}},[_c('p',{staticStyle:{"color":"orange","font-size":"0.9em","text-align":"left","padding-left":"0"},attrs:{"text-align":"right"}},[_vm._v(_vm._s(item.feePrice)+"元/吨")])]):_vm._e(),_vm._v(" "),(item.feeName == '电费')?_c('flexbox-item',{attrs:{"span":1/4}},[_c('p',{staticStyle:{"color":"orange","font-size":"0.9em","text-align":"left","padding-left":"0"},attrs:{"text-align":"right"}},[_vm._v(_vm._s(item.feeCount)+"度")])]):(item.feeName == '水费')?_c('flexbox-item',{attrs:{"span":1/4}},[_c('p',{staticStyle:{"color":"orange","font-size":"0.9em","text-align":"left","padding-left":"0"},attrs:{"text-align":"right"}},[_vm._v(_vm._s(item.feeCount)+"吨")])]):_vm._e(),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/4}},[_c('p',{staticStyle:{"color":"orange","font-size":"0.9em","text-align":"center"}},[_vm._v(_vm._s(item.realMoney)+"元")])])],1)],1)})),_vm._v(" "),_c('h5',{staticStyle:{"line-height":"1.5","font-size":"0.9em","padding":"5px 0px 0","text-align":"right","color":"red"}},[_vm._v("费用总计 ： "),_c('span',{staticStyle:{"text-indent":"20px"}},[_vm._v(_vm._s(_vm.allCount)+"元")])])]),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},on:{"on-hide":_vm.refresh},model:{value:(_vm.showprompt),callback:function ($$v) {_vm.showprompt=$$v},expression:"showprompt"}},[_vm._v(_vm._s(_vm.prompt))])],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var electricity_staticRenderFns = []
var electricity_esExports = { render: electricity_render, staticRenderFns: electricity_staticRenderFns }
/* harmony default export */ var components_payComponents_electricity = (electricity_esExports);
// CONCATENATED MODULE: ./src/components/payComponents/electricity.vue
function electricity_injectStyle (ssrContext) {
  __webpack_require__("u1cv")
}
var electricity_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var electricity___vue_template_functional__ = false
/* styles */
var electricity___vue_styles__ = electricity_injectStyle
/* scopeId */
var electricity___vue_scopeId__ = "data-v-51c49b16"
/* moduleIdentifier (server only) */
var electricity___vue_module_identifier__ = null
var electricity_Component = electricity_normalizeComponent(
  payComponents_electricity,
  components_payComponents_electricity,
  electricity___vue_template_functional__,
  electricity___vue_styles__,
  electricity___vue_scopeId__,
  electricity___vue_module_identifier__
)

/* harmony default export */ var src_components_payComponents_electricity = (electricity_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/payComponents/tenement.vue

















/* harmony default export */ var tenement = ({
  components: {
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    Cell: cell["a" /* default */],
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage,
    $: jquery_default.a
  },
  data: function data() {
    return {
      showConfirm: false,
      feeLateFlag: false,
      calcFeeLate: 0, // 计算违约金
      selectDate: [[], []],
      selectedDate: [],
      houseinfo: "",
      detailData: [],
      balance: "",
      balancebackup: "",
      totalFee: "",
      totalFeebackup: "",
      addCondition: true,
      comnCode: "",
      hs_no: "",
      zhstatus: "",
      submitable: false,
      paydate: [],
      paysum: "",
      /*赠送月份*/
      giving: "",
      show: false,
      showprompt: false,
      billCode: "",
      prompt: "",
      begin: "",
      end: "",
      offset: "",
      PreferentialTerms: [],
      showLog: false,
      mList: [],
      ndList: [],
      msrue1: false,
      msrue: false,
      feeShow: false,
      comdes: "",
      housePlace: "",

      /*可以做优化，做法：仅定义2个字段*/
      plain3: false,
      plain6: false,
      plain12: false,
      plain121: false,
      plain243: false,
      isshowBtn: true,
      yhPlus: "",
      format: function format(value) {
        return Object(date_format["a" /* default */])(new Date(value[0], parseInt(value[1]) - 1, 1), "YYYY-MM");
      }
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    this.getInitSelectDate();
    var url = global.host + "pay/findhouse?openid=" + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone;
    this.$http.get(url).then(function (res) {
      for (var i = 0; i < res.body.paymentdetail.length; i++) {
        this.calcFeeLate += res.body.paymentdetail[i].calcFeeLate;
      }
      if (this.calcFeeLate > 0) {
        this.feeLateFlag = true;
      }
      this.show_1 = false;
      this.housePlace = res.body.housearea + "㎡";
      this.houseinfo = res.body.comnName + " " + res.body.houseCode;
      this.comnCode = res.body.comnCode;
      this.hs_no = res.body.houseCode;
      this.hsName = res.body.hsName;
      this.paydate = res.body.paydate;
      this.begin = res.body.starttime;
      var threemonth = Object(date_format["a" /* default */])(new Date(this.begin.split("-")[0], this.begin.split("-")[1] * 1 + 1, this.begin.split("-")[2]), "YYYY-MM-DD").toString();
      if (threemonth == this.end) {
        jquery_default()(".am_ulist li:first").find("button").addClass("am_persfors");
      } else {
        jquery_default()(".am_ulist li:first").find("button").removeClass("am_persfors");
      }
      this.end = res.body.endtime;
      if (res.body.code == 120) {
        this.prompt = "费用未生成，请联系物业处理！!";
        this.showprompt = true;
      } else if (res.body.code == 130) {
        this.prompt = res.body.feetypes;
        this.showprompt = true;
      } else if (res.body.code == 140) {
        this.prompt = res.body.nofeedata;
        this.showprompt = true;
      } else {
        this.balance = res.body.zhmoney;
        this.balancebackup = res.body.zhmoney;
        this.totalFee = res.body.sumpayment;
        this.totalFeebackup = res.body.sumpayment;
        var endDate = this.$router.history.current.query.endDate;
        if (endDate) {
          var formatDate = endDate.split("-");
          this.selectedDate.push(formatDate[0]);
          this.selectedDate.push(parseInt(formatDate[1]));
        } else {
          var _formatDate = res.body.endtime.split("-");
          this.selectedDate.push(_formatDate[0]);
          this.selectedDate.push(parseInt(_formatDate[1]));
        }

        this.zhstatus = res.body.zhstatus;
        if (this.begin == this.end) {
          this.submitable = true;
        }

        /*let orderInfo = res.body.paymentdetail;
        for(let i = 0 ; i < orderInfo.length; i++){
        orderInfo[i].startTime = dateFormat(new Date(orderInfo[i].starttime),'YYYY/MM')
        orderInfo[i].endTime = dateFormat(new Date(res.body.endtime),'YYYY/MM')
        if(orderInfo[i].youhui){
        this.isshowBtn = false;
        }
        this.detailData.push(orderInfo[i]);
        }*/
      }
      this.getDiscount();
    }, function (err) {
      console.log(err);
    });

    /*let urlt = global.host + 'pay/findhouse?openid=' + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone
    this.$http.get(urlt).then(function(res){
    let gNum = res.body.paymentdetail;
    for(let itm in gNum){
    this.mList[itm] = gNum[itm];
    }
    },function(err){
    console.log(err)
    })*/
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/pay/tenement") {

      document.title = "物业缴费";
    }
    jquery_default()(".am_font1").parent(".weui-dialog__bd").css({ "padding-left": "0.1em", "padding-right": "0.1em" });

    jquery_default()(".am_ulist").delegate("li", "click", function () {
      jquery_default()(this).find("button").addClass("am_persfors");
      jquery_default()(this).siblings("li").find("button").removeClass("am_persfors");
    });
    this.msrue = true;
    this.msrue1 = false;
  },

  methods: {
    getDiscount: function getDiscount() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var durl;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                durl = global.host + "discountConfig/getList?comnCode=" + _this.comnCode;
                _context.next = 3;
                return _this.$http.get(durl).then(function (res) {
                  var mdatas = res.body.result;
                  this.PreferentialTerms = new Object();
                  for (var item in mdatas) {
                    this.PreferentialTerms[item] = mdatas[item];
                  }
                }, function (err) {
                  console.log(err);
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    serchDetail: function serchDetail() {

      this.showLog = true;
    },
    cancel: function cancel() {
      this.submitable = false;
    },

    /*根据不同的操作进行操作*/
    refresh: function refresh() {
      if (this.prompt == "支付成功") {
        this.submitable = true;
        this.$router.push({
          path: "/pay/tenement",
          query: {
            openid: this.$router.history.current.query.openid,
            phone: this.$router.history.current.query.phone
          }
        });
      } else if (this.prompt == "您有未处理的订单,请优先处理") {
        this.submitable = true;
        this.$router.push({
          path: "/paymentRecord",
          query: {
            openid: this.$router.history.current.query.openid,
            phone: this.$router.history.current.query.phone
          }
        });
      } else if (this.prompt.indexOf("费用未生成") > -1) {
        this.show = false;
        this.submitable = true;
      } else if (this.prompt == "当前小区费用类型不存在!") {
        this.show = false;
        this.submitable = true;
      } else if (this.prompt == "费用没有生成!") {
        this.show = false;
        this.submitable = true;
      } else if (this.prompt.indexOf("您所欠缴的费用已产生违约金") > -1) {
        this.show = false;
        this.submitable = true;
      } else {
        this.show = true;
        this.submitable = false;
      }
    },

    /*去支付方法*/
    gopay: function gopay() {
      this.submitable = true;
      /*数据准备*/
      var senddata = new Object();
      senddata.comnCode = this.comnCode;
      /*不调用微信接口去支付*/
      if (this.totalFee == 0) {
        senddata.accoubalance = this.balance;
        if (!this.addCondition) {
          senddata.flag = 0; /*启用*/
        } else {
          senddata.flag = 1; /*禁用*/
        }
        senddata.flag = 1;
        senddata.billCode = this.billCode;
        senddata.giving = this.giving;
        senddata.houseNo = this.hs_no;
        senddata.payMonth = this.paydate;
        senddata.paysum = this.paysum;
        senddata.hsName = this.hsName;
        var url = global.host + "pay/payproperorder";
        this.$http.post(url, senddata).then(function (res) {
          this.showprompt = true;
          if (res.body.code == 120) {
            this.prompt = "支付失败";
          } else if (res.body.code == 110) {
            this.prompt = "支付成功";
          }
        }, function (err) {
          console.log(err);
        });
      } else {
        /*调用微信接口去支付*/
        senddata.memberNo = this.$router.history.current.query.phone;
        senddata.openid = this.$router.history.current.query.openid;
        senddata.tradeAmount = this.totalFee;
        senddata.tradeNo = this.billCode;
        senddata.tradeName = "物业费";
        senddata.tradeDesc = "物业费(包括电梯费、生活垃圾费)";
        var _url = global.host + "pay/getpayurl";
        this.$http.post(_url, senddata).then(function (res) {
          if (res.body.code == "110") {
            location.href = res.body.payurl;
          } else {
            this.prompt = "支付异常,请稍候再试";
            this.submitable = false;
            this.showprompt = true;
          }
        }, function (err) {
          console.log(err);
        });
      }
    },

    /*提交订单之前的操作*/
    submitBefore: function submitBefore() {
      this.submitable = true;
      this.$http.get(global.host + "pay/findownerunpaidorder?comnCode=" + this.comnCode + "&houseNo=" + this.hs_no + "&openid=" + this.$router.history.current.query.openid + "&phoneNo=" + this.$router.history.current.query.phone).then(function (res) {
        if (res.body.code == "110") {
          this.submitable = false;
          this.submit();
        } else if (res.body.code == "120") {
          this.prompt = "您有未处理的订单,请优先处理";
          this.showprompt = true;
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*提交订单*/
    submit: function submit() {
      this.show_1 = true;
      console.log("计算违约金" + this.calcFeeLate);
      if (!this.feeLateFlag) {
        var totalYH = 0,
            totalfeeLate = 0,
            totalYouHui = 0;
        var givyouhuisum = this.yhPlus;
        for (var i = 0; i < this.detailData.length; i++) {
          totalYH = this.detailData[i].yingshou * 1 + totalYH;
          totalfeeLate = this.detailData[i].feeLate * 1 + totalfeeLate;
          totalYouHui = this.detailData[i].youhui * 1 + totalYouHui;
        }
        totalYouHui = totalYouHui + givyouhuisum;
        console.log("%%%%%%%%%%%%%%%%%%%");
        console.log(totalYouHui);
        var senddata = new Object();
        senddata.comnCode = this.comnCode;
        senddata.houseNo = this.hs_no;
        senddata.hsName = this.hsName;
        senddata.shishou = this.totalFeebackup;
        senddata.yingshou = totalYH + givyouhuisum;
        senddata.startDate = this.begin;
        senddata.endDate = this.end;
        senddata.giving = this.giving;
        senddata.openid = this.$router.history.current.query.openid;
        senddata.memberNo = this.$router.history.current.query.phone;
        if (totalYouHui) {
          senddata.youhui = totalYouHui;
        }
        if (totalfeeLate) {
          senddata.feeLate = totalfeeLate;
        }
        if (this.zhstatus == 1) {
          senddata.accoubalance = this.balancebackup;
        }
        /*冲抵暂且不做*/

        senddata.flag = 1; /*禁用*/

        var url = global.host + "pay/subproperorder";
        this.$http.post(url, senddata).then(function (res) {
          this.show_1 = false;
          if (res.body.code == "110") {
            this.show = true;
            this.billCode = res.body.tradeNo;
          }
        }, function (err) {
          this.show_1 = false;
          console.log(err);
        });
      } else {
        this.show_1 = false;
        this.prompt = "您所欠缴的费用已产生违约金，如需缴费请计算应缴违约金";
        this.showConfirm = true;
      }
    },

    /*设置缴费时长*/
    setPayTime: function setPayTime(time, giving) {
      console.log("$$$");
      console.log(giving);
      var backupdate = this.paydate;
      console.log(backupdate);
      var temp = parseInt(backupdate.split("-")[1]);
      this.selectedDate.pop();
      this.selectedDate.pop();
      this.selectedDate.push(parseInt(backupdate.split("-")[0]));
      this.selectedDate.push(temp + time * 1);
      this.paysum = time;

      this["plain" + time + (giving ? giving : "")] = true;
      this.giving = giving ? giving : "";
      this.getDetail(time, giving);
    },

    /*初始化时间选择*/
    getInitSelectDate: function getInitSelectDate() {
      var date = new Date();
      date = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      this.selectDate[0].push(date.getFullYear());
      this.selectDate[0].push(date.getFullYear() + 1);
      this.selectDate[0].push(date.getFullYear() + 2);
      var curM = date.getMonth() + 1;
      this.selectDate[1] = new Array();
      for (var i = curM; i < 13; i++) {
        this.selectDate[1].push(i);
      }
    },

    /*获取订单的信息信息*/
    getDetail: function getDetail(time, giving) {
      this.show_1 = true;
      this.msrue = false;
      this.msrue1 = true;
      console.error(this.paydate + ":" + time);
      giving = giving ? giving : "";
      var url = global.host + "pay/findpayment";
      this.$http.post(url, {
        payMonth: this.paydate,
        paysum: time,
        giving: giving,
        houseNo: this.hs_no,
        comnCode: this.comnCode
      }).then(function (res) {
        this.ndList = [];
        this.show_1 = false;
        var ndNum = res.body.paymentdetail;
        this.yhPlus = Number(res.body.givyouhuisum);
        for (var itm in ndNum) {
          console.log(ndNum[itm]);
          this.ndList[itm] = ndNum[itm];
        }
        if (res.body.code == 120) {
          this.prompt = "费用未生成，请联系物业处理！";
          this.showprompt = true;
        } else if (res.body.code == 130) {
          this.prompt = res.body.feetypes;
          this.showprompt = true;
        } else if (res.body.code == 140) {
          this.prompt = res.body.nofeedata;
          this.showprompt = true;
        } else {
          this.zhstatus = res.body.zhstatus;
          var orderInfo = res.body.paymentdetail;
          var size = this.detailData.length;
          this.balance = res.body.zhmoney;
          this.totalFee = res.body.sumpayment;
          this.totalFeebackup = res.body.sumpayment;
          this.begin = res.body.startdate;
          this.end = res.body.enddate;
          for (var j = 0; j < size; j++) {
            this.detailData.pop();
          }

          if (orderInfo == null) {
            this.show_1 = false;
            return false;
          } else {
            for (var i = 0; i < orderInfo.length; i++) {
              orderInfo[i].startTime = Object(date_format["a" /* default */])(new Date(orderInfo[i].startDate), "YYYY/MM");
              orderInfo[i].endTime = Object(date_format["a" /* default */])(new Date(orderInfo[i].endDate), "YYYY/MM");
              this.detailData.push(orderInfo[i]);
            }
          }

          var data1 = orderInfo[0].endDate;
          var data2 = jquery_default()("#mlists").find(".vux-cell-value").html();
          var mdata1 = Object(date_format["a" /* default */])(new Date(data1), 'YYYY/MM');
          var mdata2 = Object(date_format["a" /* default */])(new Date(data2), 'YYYY/MM');
          if (mdata2 > mdata1) {
            this.show_1 = false;
            var dateStr = mdata1.split("/");
            this.prompt = "当前只能缴纳" + dateStr[0] + "年" + dateStr[1] + "月之前的费用，如需办理请到物业缴费，谢谢！";
            this.feeShow = true;
            this.submitable = true;
            return false;
          }

          this.submitable = false;
        }
      }, function (err) {
        alert(err);
      });
    },

    /*获取未来的日期 3年的*/
    getFutureDate: function getFutureDate(value) {
      var lastDate = new Date(this.paydate);
      console.log("$$$$$$$$$$$$$$$" + value[0] + "-" + value[1]);
      var futureDate = new Date(value[0], value[1] - 1, 1);
      var totalMonth = (futureDate.getFullYear() - lastDate.getFullYear()) * 12 + (futureDate.getMonth() - lastDate.getMonth());
      this.paysum = totalMonth;
      this.giving = "";
      this.getDetail(totalMonth);
    },

    /*时间选择*/
    updateMonth: function updateMonth(value) {
      this.clearDate(value[0]);
    },

    /*重新生成选择的时间*/
    clearDate: function clearDate(value) {
      var date = new Date();
      date = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      var yearArr = new Array();
      yearArr.push(date.getFullYear());
      yearArr.push(date.getFullYear() + 1);
      yearArr.push(date.getFullYear() + 2);
      yearArr.push(date.getFullYear() + 3);
      var monthArr = new Array();
      if (value == date.getFullYear()) {
        var curM = date.getMonth() + 1;
        for (var i = curM; i < 13; i++) {
          monthArr.push(i);
        }
      } else {
        for (var _i = 1; _i < 13; _i++) {
          monthArr.push(_i);
        }
      }
      this.selectDate = [];
      this.selectDate.push(yearArr);
      this.selectDate.push(monthArr);
    },

    /*判断是否可选 */
    /*冲抵暂且不做*/
    addfactor: function addfactor() {
      if (this.zhstatus == 1) {
        /*默认不抵扣*/
        this.addCondition = !this.addCondition;
        var temp = this.totalFeebackup * 1;
        var balanceold = this.balancebackup * 1;
        if (!this.addCondition) {
          /*减去 小数点后有问题*/
          this.totalFee = temp - balanceold >= 0 ? temp - balanceold : 0;
          this.offset = temp - balanceold >= 0 ? balanceold : balanceold - temp;
          this.balance = balanceold - temp >= 0 ? balanceold - temp : 0;
        } else {
          this.totalFee = temp;
          this.offset = 0;
          this.balance = balanceold;
        }
      }
    },

    /*计算违约金*/
    calcFeeLateEvent: function calcFeeLateEvent() {
      this.show_1 = true;
      var url = global.host + "pay/updateLateFeeMoney?comnCode=" + this.comnCode + "&houseNo=" + this.hs_no + "&endDate=" + this.end;
      this.$http.get(url).then(function (res) {
        this.show_1 = false;
        console.log(res.body);
        this.showConfirm = false;
        this.feeLateFlag = false;
        this.getDetail(this.paysum, this.giving);
      }, function (err) {
        this.show_1 = false;
        alert("网络异常，请稍后重试！");
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/payComponents/tenement.vue

















/* harmony default export */ var payComponents_tenement = ({
  components: {
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    Cell: cell["a" /* default */],
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage,
    $: jquery_default.a
  },
  data: function data() {
    return {
      showConfirm: false,
      feeLateFlag: false,
      calcFeeLate: 0, // 计算违约金
      selectDate: [[], []],
      selectedDate: [],
      houseinfo: "",
      detailData: [],
      balance: "",
      balancebackup: "",
      totalFee: "",
      totalFeebackup: "",
      addCondition: true,
      comnCode: "",
      hs_no: "",
      zhstatus: "",
      submitable: false,
      paydate: [],
      paysum: "",
      /*赠送月份*/
      giving: "",
      show: false,
      showprompt: false,
      billCode: "",
      prompt: "",
      begin: "",
      end: "",
      offset: "",
      PreferentialTerms: [],
      showLog: false,
      mList: [],
      ndList: [],
      msrue1: false,
      msrue: false,
      feeShow: false,
      comdes: "",
      housePlace: "",

      /*可以做优化，做法：仅定义2个字段*/
      plain3: false,
      plain6: false,
      plain12: false,
      plain121: false,
      plain243: false,
      isshowBtn: true,
      yhPlus: "",
      format: function format(value) {
        return Object(date_format["a" /* default */])(new Date(value[0], parseInt(value[1]) - 1, 1), "YYYY-MM");
      }
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    this.getInitSelectDate();
    var url = global.host + "pay/findhouse?openid=" + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone;
    this.$http.get(url).then(function (res) {
      for (var i = 0; i < res.body.paymentdetail.length; i++) {
        this.calcFeeLate += res.body.paymentdetail[i].calcFeeLate;
      }
      if (this.calcFeeLate > 0) {
        this.feeLateFlag = true;
      }
      this.show_1 = false;
      this.housePlace = res.body.housearea + "㎡";
      this.houseinfo = res.body.comnName + " " + res.body.houseCode;
      this.comnCode = res.body.comnCode;
      this.hs_no = res.body.houseCode;
      this.hsName = res.body.hsName;
      this.paydate = res.body.paydate;
      this.begin = res.body.starttime;
      var threemonth = Object(date_format["a" /* default */])(new Date(this.begin.split("-")[0], this.begin.split("-")[1] * 1 + 1, this.begin.split("-")[2]), "YYYY-MM-DD").toString();
      if (threemonth == this.end) {
        jquery_default()(".am_ulist li:first").find("button").addClass("am_persfors");
      } else {
        jquery_default()(".am_ulist li:first").find("button").removeClass("am_persfors");
      }
      this.end = res.body.endtime;
      if (res.body.code == 120) {
        this.prompt = "费用未生成，请联系物业处理！!";
        this.showprompt = true;
      } else if (res.body.code == 130) {
        this.prompt = res.body.feetypes;
        this.showprompt = true;
      } else if (res.body.code == 140) {
        this.prompt = res.body.nofeedata;
        this.showprompt = true;
      } else {
        this.balance = res.body.zhmoney;
        this.balancebackup = res.body.zhmoney;
        this.totalFee = res.body.sumpayment;
        this.totalFeebackup = res.body.sumpayment;
        var endDate = this.$router.history.current.query.endDate;
        if (endDate) {
          var formatDate = endDate.split("-");
          this.selectedDate.push(formatDate[0]);
          this.selectedDate.push(parseInt(formatDate[1]));
        } else {
          var _formatDate = res.body.endtime.split("-");
          this.selectedDate.push(_formatDate[0]);
          this.selectedDate.push(parseInt(_formatDate[1]));
        }

        this.zhstatus = res.body.zhstatus;
        if (this.begin == this.end) {
          this.submitable = true;
        }

        /*let orderInfo = res.body.paymentdetail;
        for(let i = 0 ; i < orderInfo.length; i++){
        orderInfo[i].startTime = dateFormat(new Date(orderInfo[i].starttime),'YYYY/MM')
        orderInfo[i].endTime = dateFormat(new Date(res.body.endtime),'YYYY/MM')
        if(orderInfo[i].youhui){
        this.isshowBtn = false;
        }
        this.detailData.push(orderInfo[i]);
        }*/
      }
      this.getDiscount();
    }, function (err) {
      console.log(err);
    });

    /*let urlt = global.host + 'pay/findhouse?openid=' + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone
    this.$http.get(urlt).then(function(res){
    let gNum = res.body.paymentdetail;
    for(let itm in gNum){
    this.mList[itm] = gNum[itm];
    }
    },function(err){
    console.log(err)
    })*/
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/pay/tenement") {

      document.title = "物业缴费";
    }
    jquery_default()(".am_font1").parent(".weui-dialog__bd").css({ "padding-left": "0.1em", "padding-right": "0.1em" });

    jquery_default()(".am_ulist").delegate("li", "click", function () {
      jquery_default()(this).find("button").addClass("am_persfors");
      jquery_default()(this).siblings("li").find("button").removeClass("am_persfors");
    });
    this.msrue = true;
    this.msrue1 = false;
  },

  methods: {
    getDiscount: function getDiscount() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var durl;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                durl = global.host + "discountConfig/getList?comnCode=" + _this.comnCode;
                _context.next = 3;
                return _this.$http.get(durl).then(function (res) {
                  var mdatas = res.body.result;
                  this.PreferentialTerms = new Object();
                  for (var item in mdatas) {
                    this.PreferentialTerms[item] = mdatas[item];
                  }
                }, function (err) {
                  console.log(err);
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    serchDetail: function serchDetail() {

      this.showLog = true;
    },
    cancel: function cancel() {
      this.submitable = false;
    },

    /*根据不同的操作进行操作*/
    refresh: function refresh() {
      if (this.prompt == "支付成功") {
        this.submitable = true;
        this.$router.push({
          path: "/pay/tenement",
          query: {
            openid: this.$router.history.current.query.openid,
            phone: this.$router.history.current.query.phone
          }
        });
      } else if (this.prompt == "您有未处理的订单,请优先处理") {
        this.submitable = true;
        this.$router.push({
          path: "/paymentRecord",
          query: {
            openid: this.$router.history.current.query.openid,
            phone: this.$router.history.current.query.phone
          }
        });
      } else if (this.prompt.indexOf("费用未生成") > -1) {
        this.show = false;
        this.submitable = true;
      } else if (this.prompt == "当前小区费用类型不存在!") {
        this.show = false;
        this.submitable = true;
      } else if (this.prompt == "费用没有生成!") {
        this.show = false;
        this.submitable = true;
      } else if (this.prompt.indexOf("您所欠缴的费用已产生违约金") > -1) {
        this.show = false;
        this.submitable = true;
      } else {
        this.show = true;
        this.submitable = false;
      }
    },

    /*去支付方法*/
    gopay: function gopay() {
      this.submitable = true;
      /*数据准备*/
      var senddata = new Object();
      senddata.comnCode = this.comnCode;
      /*不调用微信接口去支付*/
      if (this.totalFee == 0) {
        senddata.accoubalance = this.balance;
        if (!this.addCondition) {
          senddata.flag = 0; /*启用*/
        } else {
          senddata.flag = 1; /*禁用*/
        }
        senddata.flag = 1;
        senddata.billCode = this.billCode;
        senddata.giving = this.giving;
        senddata.houseNo = this.hs_no;
        senddata.payMonth = this.paydate;
        senddata.paysum = this.paysum;
        senddata.hsName = this.hsName;
        var url = global.host + "pay/payproperorder";
        this.$http.post(url, senddata).then(function (res) {
          this.showprompt = true;
          if (res.body.code == 120) {
            this.prompt = "支付失败";
          } else if (res.body.code == 110) {
            this.prompt = "支付成功";
          }
        }, function (err) {
          console.log(err);
        });
      } else {
        /*调用微信接口去支付*/
        senddata.memberNo = this.$router.history.current.query.phone;
        senddata.openid = this.$router.history.current.query.openid;
        senddata.tradeAmount = this.totalFee;
        senddata.tradeNo = this.billCode;
        senddata.tradeName = "物业费";
        senddata.tradeDesc = "物业费(包括电梯费、生活垃圾费)";
        var _url = global.host + "pay/getpayurl";
        this.$http.post(_url, senddata).then(function (res) {
          if (res.body.code == "110") {
            location.href = res.body.payurl;
          } else {
            this.prompt = "支付异常,请稍候再试";
            this.submitable = false;
            this.showprompt = true;
          }
        }, function (err) {
          console.log(err);
        });
      }
    },

    /*提交订单之前的操作*/
    submitBefore: function submitBefore() {
      this.submitable = true;
      this.$http.get(global.host + "pay/findownerunpaidorder?comnCode=" + this.comnCode + "&houseNo=" + this.hs_no + "&openid=" + this.$router.history.current.query.openid + "&phoneNo=" + this.$router.history.current.query.phone).then(function (res) {
        if (res.body.code == "110") {
          this.submitable = false;
          this.submit();
        } else if (res.body.code == "120") {
          this.prompt = "您有未处理的订单,请优先处理";
          this.showprompt = true;
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*提交订单*/
    submit: function submit() {
      this.show_1 = true;
      console.log("计算违约金" + this.calcFeeLate);
      if (!this.feeLateFlag) {
        var totalYH = 0,
            totalfeeLate = 0,
            totalYouHui = 0;
        var givyouhuisum = this.yhPlus;
        for (var i = 0; i < this.detailData.length; i++) {
          totalYH = this.detailData[i].yingshou * 1 + totalYH;
          totalfeeLate = this.detailData[i].feeLate * 1 + totalfeeLate;
          totalYouHui = this.detailData[i].youhui * 1 + totalYouHui;
        }
        totalYouHui = totalYouHui + givyouhuisum;
        console.log("%%%%%%%%%%%%%%%%%%%");
        console.log(totalYouHui);
        var senddata = new Object();
        senddata.comnCode = this.comnCode;
        senddata.houseNo = this.hs_no;
        senddata.hsName = this.hsName;
        senddata.shishou = this.totalFeebackup;
        senddata.yingshou = totalYH + givyouhuisum;
        senddata.startDate = this.begin;
        senddata.endDate = this.end;
        senddata.giving = this.giving;
        senddata.openid = this.$router.history.current.query.openid;
        senddata.memberNo = this.$router.history.current.query.phone;
        if (totalYouHui) {
          senddata.youhui = totalYouHui;
        }
        if (totalfeeLate) {
          senddata.feeLate = totalfeeLate;
        }
        if (this.zhstatus == 1) {
          senddata.accoubalance = this.balancebackup;
        }
        /*冲抵暂且不做*/

        senddata.flag = 1; /*禁用*/

        var url = global.host + "pay/subproperorder";
        this.$http.post(url, senddata).then(function (res) {
          this.show_1 = false;
          if (res.body.code == "110") {
            this.show = true;
            this.billCode = res.body.tradeNo;
          }
        }, function (err) {
          this.show_1 = false;
          console.log(err);
        });
      } else {
        this.show_1 = false;
        this.prompt = "您所欠缴的费用已产生违约金，如需缴费请计算应缴违约金";
        this.showConfirm = true;
      }
    },

    /*设置缴费时长*/
    setPayTime: function setPayTime(time, giving) {
      console.log("$$$");
      console.log(giving);
      var backupdate = this.paydate;
      console.log(backupdate);
      var temp = parseInt(backupdate.split("-")[1]);
      this.selectedDate.pop();
      this.selectedDate.pop();
      this.selectedDate.push(parseInt(backupdate.split("-")[0]));
      this.selectedDate.push(temp + time * 1);
      this.paysum = time;

      this["plain" + time + (giving ? giving : "")] = true;
      this.giving = giving ? giving : "";
      this.getDetail(time, giving);
    },

    /*初始化时间选择*/
    getInitSelectDate: function getInitSelectDate() {
      var date = new Date();
      date = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      this.selectDate[0].push(date.getFullYear());
      this.selectDate[0].push(date.getFullYear() + 1);
      this.selectDate[0].push(date.getFullYear() + 2);
      var curM = date.getMonth() + 1;
      this.selectDate[1] = new Array();
      for (var i = curM; i < 13; i++) {
        this.selectDate[1].push(i);
      }
    },

    /*获取订单的信息信息*/
    getDetail: function getDetail(time, giving) {
      this.show_1 = true;
      this.msrue = false;
      this.msrue1 = true;
      console.error(this.paydate + ":" + time);
      giving = giving ? giving : "";
      var url = global.host + "pay/findpayment";
      this.$http.post(url, {
        payMonth: this.paydate,
        paysum: time,
        giving: giving,
        houseNo: this.hs_no,
        comnCode: this.comnCode
      }).then(function (res) {
        this.ndList = [];
        this.show_1 = false;
        var ndNum = res.body.paymentdetail;
        this.yhPlus = Number(res.body.givyouhuisum);
        for (var itm in ndNum) {
          console.log(ndNum[itm]);
          this.ndList[itm] = ndNum[itm];
        }
        if (res.body.code == 120) {
          this.prompt = "费用未生成，请联系物业处理！";
          this.showprompt = true;
        } else if (res.body.code == 130) {
          this.prompt = res.body.feetypes;
          this.showprompt = true;
        } else if (res.body.code == 140) {
          this.prompt = res.body.nofeedata;
          this.showprompt = true;
        } else {
          this.zhstatus = res.body.zhstatus;
          var orderInfo = res.body.paymentdetail;
          var size = this.detailData.length;
          this.balance = res.body.zhmoney;
          this.totalFee = res.body.sumpayment;
          this.totalFeebackup = res.body.sumpayment;
          this.begin = res.body.startdate;
          this.end = res.body.enddate;
          for (var j = 0; j < size; j++) {
            this.detailData.pop();
          }

          if (orderInfo == null) {
            this.show_1 = false;
            return false;
          } else {
            for (var i = 0; i < orderInfo.length; i++) {
              orderInfo[i].startTime = Object(date_format["a" /* default */])(new Date(orderInfo[i].startDate), "YYYY/MM");
              orderInfo[i].endTime = Object(date_format["a" /* default */])(new Date(orderInfo[i].endDate), "YYYY/MM");
              this.detailData.push(orderInfo[i]);
            }
          }

          var data1 = orderInfo[0].endDate;
          var data2 = jquery_default()("#mlists").find(".vux-cell-value").html();
          var mdata1 = Object(date_format["a" /* default */])(new Date(data1), 'YYYY/MM');
          var mdata2 = Object(date_format["a" /* default */])(new Date(data2), 'YYYY/MM');
          if (mdata2 > mdata1) {
            this.show_1 = false;
            var dateStr = mdata1.split("/");
            this.prompt = "当前只能缴纳" + dateStr[0] + "年" + dateStr[1] + "月之前的费用，如需办理请到物业缴费，谢谢！";
            this.feeShow = true;
            this.submitable = true;
            return false;
          }

          this.submitable = false;
        }
      }, function (err) {
        alert(err);
      });
    },

    /*获取未来的日期 3年的*/
    getFutureDate: function getFutureDate(value) {
      var lastDate = new Date(this.paydate);
      console.log("$$$$$$$$$$$$$$$" + value[0] + "-" + value[1]);
      var futureDate = new Date(value[0], value[1] - 1, 1);
      var totalMonth = (futureDate.getFullYear() - lastDate.getFullYear()) * 12 + (futureDate.getMonth() - lastDate.getMonth());
      this.paysum = totalMonth;
      this.giving = "";
      this.getDetail(totalMonth);
    },

    /*时间选择*/
    updateMonth: function updateMonth(value) {
      this.clearDate(value[0]);
    },

    /*重新生成选择的时间*/
    clearDate: function clearDate(value) {
      var date = new Date();
      date = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      var yearArr = new Array();
      yearArr.push(date.getFullYear());
      yearArr.push(date.getFullYear() + 1);
      yearArr.push(date.getFullYear() + 2);
      yearArr.push(date.getFullYear() + 3);
      var monthArr = new Array();
      if (value == date.getFullYear()) {
        var curM = date.getMonth() + 1;
        for (var i = curM; i < 13; i++) {
          monthArr.push(i);
        }
      } else {
        for (var _i = 1; _i < 13; _i++) {
          monthArr.push(_i);
        }
      }
      this.selectDate = [];
      this.selectDate.push(yearArr);
      this.selectDate.push(monthArr);
    },

    /*判断是否可选 */
    /*冲抵暂且不做*/
    addfactor: function addfactor() {
      if (this.zhstatus == 1) {
        /*默认不抵扣*/
        this.addCondition = !this.addCondition;
        var temp = this.totalFeebackup * 1;
        var balanceold = this.balancebackup * 1;
        if (!this.addCondition) {
          /*减去 小数点后有问题*/
          this.totalFee = temp - balanceold >= 0 ? temp - balanceold : 0;
          this.offset = temp - balanceold >= 0 ? balanceold : balanceold - temp;
          this.balance = balanceold - temp >= 0 ? balanceold - temp : 0;
        } else {
          this.totalFee = temp;
          this.offset = 0;
          this.balance = balanceold;
        }
      }
    },

    /*计算违约金*/
    calcFeeLateEvent: function calcFeeLateEvent() {
      this.show_1 = true;
      var url = global.host + "pay/updateLateFeeMoney?comnCode=" + this.comnCode + "&houseNo=" + this.hs_no + "&endDate=" + this.end;
      this.$http.get(url).then(function (res) {
        this.show_1 = false;
        console.log(res.body);
        this.showConfirm = false;
        this.feeLateFlag = false;
        this.getDetail(this.paysum, this.giving);
      }, function (err) {
        this.show_1 = false;
        alert("网络异常，请稍后重试！");
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08219747","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payComponents/tenement.vue
var tenement_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-x":"hidden"}},[_c('group',{staticStyle:{"margin-top":"-12px"}},[_c('cell',{staticStyle:{"font-size":"0.9em"},attrs:{"title":"房屋信息","value":_vm.houseinfo,"id":"texrt"}}),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{attrs:{"span":1/2}},[_c('x-input',{staticClass:"am_housePlace",attrs:{"title":"房屋面积","disabled":"","text-align":"right"},model:{value:(_vm.housePlace),callback:function ($$v) {_vm.housePlace=$$v},expression:"housePlace"}})],1),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/2}},[_c('popup-picker',{ref:"dateSelect",staticStyle:{"font-size":"0.9em"},attrs:{"id":"mlists","title":"缴至日期","placeholder":"请选择缴费日期","data":_vm.selectDate,"display-format":_vm.format},on:{"on-shadow-change":_vm.updateMonth,"on-change":_vm.getFutureDate},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","margin":"0 auto"}},[_c('div',{staticStyle:{"height":"10px"}}),_vm._v(" "),_c('ul',{staticClass:"am_ulist fix"},[_c('li',[_c('x-button',{staticClass:"amIndexs",attrs:{"type":"primary","plain":""},nativeOn:{"click":function($event){_vm.setPayTime(3)}}},[_vm._v("三个月")])],1),_vm._v(" "),_c('li',[_c('x-button',{staticClass:"amIndexs",attrs:{"type":"primary","plain":""},nativeOn:{"click":function($event){_vm.setPayTime(6)}}},[_vm._v("半年")])],1),_vm._v(" "),_c('li',[_c('x-button',{staticClass:"amIndexs",attrs:{"type":"primary","plain":""},nativeOn:{"click":function($event){_vm.setPayTime(12)}}},[_vm._v("一年")])],1),_vm._v(" "),_vm._l((_vm.PreferentialTerms),function(item,index){return _c('li',{key:index},[_c('x-button',{staticClass:"amIndex",attrs:{"type":"primary","plain":""},nativeOn:{"click":function($event){_vm.setPayTime(item.baseRate,item.defaultRate)}}},[_c('p',[_vm._v(_vm._s(item.discName))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.discDesc))])])],1)})],2),_vm._v(" "),_c('div',{staticStyle:{"height":"10px"}})]),_vm._v(" "),_c('flexbox',[_c('flexbox-item',{staticStyle:{"color":"#1AAD19 !important"}},[_c('x-button',{staticClass:"am_borfot am_cnter",staticStyle:{"color":"#1AAD19 !important"},attrs:{"type":"primary","mini":""},nativeOn:{"click":function($event){return _vm.serchDetail($event)}}},[_vm._v("缴费明细")])],1)],1),_vm._v(" "),(_vm.detailData && _vm.detailData.length > 0)?_c('div',[_c('group',_vm._l((_vm.detailData),function(item,index){return _c('div',{staticClass:"feeitem"},[_c('flexbox',[_c('flexbox-item',{attrs:{"span":3.5}},[_c('p',[_vm._v(_vm._s(item.feeTypeName))])]),_vm._v(" "),_c('flexbox-item',[_c('p',[_vm._v(_vm._s(item.startTime)+"~"+_vm._s(item.endTime))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(item.yingshou)+"元")])])],1),_vm._v(" "),(item.youhui)?_c('flexbox',[_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-indent":"2em","color":"green","font-size":"0.6em"}},[_vm._v("优惠")])]),_vm._v(" "),_c('flexbox-item',[_c('p')]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"text-align":"right","color":"green","font-size":"0.6em"}},[_vm._v("-"+_vm._s(item.youhui)+"元")])])],1):_vm._e(),_vm._v(" "),(item.feeLate&&item.feeLate!='0.00')?_c('flexbox',[_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-indent":"2em","color":"red","font-size":"0.6em"}},[_vm._v("违约金")])]),_vm._v(" "),_c('flexbox-item',[_c('p')]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"text-align":"right","color":"red","font-size":"0.6em"}},[_vm._v("+"+_vm._s(item.feeLate)+"元")])])],1):_vm._e()],1)})),_vm._v(" "),_c('flexbox',{staticClass:"am_dark"},[_c('flexbox-item',{attrs:{"span":2/5}}),_vm._v(" "),_c('flexbox-item',{staticClass:"am_cnter",attrs:{"span":3/5}},[_c('h5',{staticStyle:{"line-height":"2.5","font-size":"1.1em","text-align":"right"}},[_vm._v("费用总计：\n          "),_c('span',{staticStyle:{"color":"red","font-size":"1.1em","margin-right":"15px"}},[_vm._v(_vm._s(_vm.totalFee)+"元")])])])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"height":"20px"}}),_vm._v(" "),_c('alert',{staticClass:"am_alert_cont",attrs:{"button-text":"关闭"},model:{value:(_vm.showLog),callback:function ($$v) {_vm.showLog=$$v},expression:"showLog"}},[_c('h1',{staticClass:"am_font1"},[_vm._v("本次费用明细")]),_vm._v(" "),_c('group',[_c('ul',[_c('li',{staticClass:"am_font2"},[_vm._v("项目")]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v("单价")]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v("月费用")]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v("月份")]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v("金额")])])]),_vm._v(" "),_vm._l((_vm.ndList),function(item,index){return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.msrue1),expression:"msrue1"}],key:index},[_c('li',{staticClass:"am_font2"},[_vm._v(_vm._s(item.feeTypeName))]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v(_vm._s(item.feePrice))]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v(_vm._s(item.tradeAmount))]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v(_vm._s(item.paysum))]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v(_vm._s(item.shishou))])])})],2),_vm._v(" "),_c('x-button',{staticStyle:{"width":"98%"},attrs:{"type":"primary","disabled":_vm.submitable},nativeOn:{"click":function($event){return _vm.submitBefore($event)}}},[_vm._v("提交订单")]),_vm._v(" "),_c('confirm',{attrs:{"title":"订单详情","confirm-text":"去支付"},on:{"on-confirm":_vm.gopay,"on-cancel":_vm.cancel},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._l((_vm.detailData),function(item,index){return _c('div',{staticStyle:{"border-bottom":"1px solid #ddd","margin":"1px -5px","line-height":"1.4","padding":"4px 0"}},[_c('flexbox',[_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"color":"black","font-size":"0.9em"}},[_vm._v(_vm._s(item.feeTypeName))])]),_vm._v(" "),_c('flexbox-item',[_c('p',{staticStyle:{"font-size":"0.8em"}},[_vm._v(_vm._s(item.startTime)+"~"+_vm._s(item.endTime))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"text-align":"right","color":"orange","font-size":"0.9em"}},[_vm._v(_vm._s(item.yingshou)+"元")])])],1),_vm._v(" "),(item.youhui)?_c('flexbox',[_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-indent":"2em","color":"green","font-size":"0.6em"}},[_vm._v("优惠")])]),_vm._v(" "),_c('flexbox-item',[_c('p')]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"text-align":"right","color":"green","font-size":"0.6em"}},[_vm._v("-"+_vm._s(item.youhui)+"元")])])],1):_vm._e(),_vm._v(" "),(item.feeLate&&item.feeLate!='0.00')?_c('flexbox',[_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-indent":"2em","color":"red","font-size":"0.6em"}},[_vm._v("违约金")])]),_vm._v(" "),_c('flexbox-item',[_c('p')]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"text-align":"right","color":"red","font-size":"0.6em"}},[_vm._v("+"+_vm._s(item.feeLate)+"元")])])],1):_vm._e()],1)}),_vm._v(" "),_c('h5',{staticStyle:{"line-height":"1.5","font-size":"0.9em","padding":"5px 0px 0","text-align":"right","color":"red"}},[_vm._v("费用总计：\n      "),_c('span',{staticStyle:{"text-indent":"20px"}},[_vm._v(_vm._s(_vm.totalFee)+"元")])])],2),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},on:{"on-hide":_vm.refresh},model:{value:(_vm.showprompt),callback:function ($$v) {_vm.showprompt=$$v},expression:"showprompt"}},[_vm._v(_vm._s(_vm.prompt))])],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.feeShow),callback:function ($$v) {_vm.feeShow=$$v},expression:"feeShow"}},[_vm._v(_vm._s(_vm.prompt))])],1),_vm._v(" "),_c('group',[_c('confirm',{attrs:{"title":"温馨提示","confirm-text":"计算违约金"},on:{"on-confirm":_vm.calcFeeLateEvent,"on-cancel":_vm.cancel},model:{value:(_vm.showConfirm),callback:function ($$v) {_vm.showConfirm=$$v},expression:"showConfirm"}},[_vm._v("\n      "+_vm._s(_vm.prompt)+"\n    ")])],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var tenement_staticRenderFns = []
var tenement_esExports = { render: tenement_render, staticRenderFns: tenement_staticRenderFns }
/* harmony default export */ var components_payComponents_tenement = (tenement_esExports);
// CONCATENATED MODULE: ./src/components/payComponents/tenement.vue
function tenement_injectStyle (ssrContext) {
  __webpack_require__("8H5w")
}
var tenement_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tenement___vue_template_functional__ = false
/* styles */
var tenement___vue_styles__ = tenement_injectStyle
/* scopeId */
var tenement___vue_scopeId__ = "data-v-08219747"
/* moduleIdentifier (server only) */
var tenement___vue_module_identifier__ = null
var tenement_Component = tenement_normalizeComponent(
  payComponents_tenement,
  components_payComponents_tenement,
  tenement___vue_template_functional__,
  tenement___vue_styles__,
  tenement___vue_scopeId__,
  tenement___vue_module_identifier__
)

/* harmony default export */ var src_components_payComponents_tenement = (tenement_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userComponents/user.vue














/* harmony default export */ var user = ({
  components: {
    XInput: x_input["a" /* default */],
    Group: group["a" /* default */],
    Cell: cell["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    XButton: vux_src_components_x_button,
    Alert: components_alert["a" /* default */],
    loadPage: src_components_loadingPage

  },
  data: function data() {
    return {
      username: '',
      headimgurl: '',
      communityName: '',
      houseInfo: '',
      show: false,
      userphone: '',
      phoneback: '',
      comnCodes: '',
      bgimgurl: global.imgUrl + '/image/bg.jpg',

      balance: '',
      expiration: '',
      fontcolor: ''
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/user") {
      document.title = "个人中心";
    }
    if (this.$router.history.current.query.phone) {
      this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
        if (res.body.result) {
          var data = res.body.result[0];
          console.log("接口获取数据   ===   " + stringify_default()(data));
          this.communityName = data.comName;
          this.houseInfo = data.hsNo;
          this.userphone = data.mainPhone;
          var phone = this.userphone;
          this.comnCodes = data.comn_code;
          this.phoneback = phone.substring(0, 3) + '****' + phone.substring(7, 11);
          this.headimgurl = data.photoUrl;
          this.username = data.name;
          this.$http.get(global.host + 'pay/findmonexpiredate?comnCode=' + data.comn_code + '&houseCode=' + data.hsNo).then(function (result) {
            console.log(result);
            this.balance = result.body.accountbalance;
            this.expiration = result.body.lastdate;
            var date = new Date(this.expiration.split('-')[0], this.expiration.split('-')[1], this.expiration.split('-')[2], 23, 59, 59);
            var curday = new Date();
            if (Date.parse(date) - Date.parse(curday) >= 0) {
              this.fontcolor = '#333333';
            } else {
              this.fontcolor = 'red';
            }
            console.log(this.fontcolor);
            this.expiration = Object(date_format["a" /* default */])(new Date(this.expiration.split('-')[0], this.expiration.split('-')[1] - 1, this.expiration.split('-')[2]), 'YYYY/MM/DD');
          }, function (err) {
            console.log(err);
          });
        }
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    } else if (this.$router.history.current.query.userinfo) {
      var data = JSON.parse(this.$router.history.current.query.userinfo);
      console.log("不知道哪里获取数据   ===   " + stringify_default()(data));
      this.username = data.wxName;
      this.headimgurl = data.photoUrl;
      this.communityName = data.comName;
      this.houseInfo = data.buildName + '  ' + data.hsNo;
      this.userphone = this.$router.history.current.query.phone = data.mainPhone;
      var phone = this.userphone;
      this.phoneback = phone.substring(0, 3) + '****' + phone.substring(7, 11);
      this.$router.history.current.query.openid = data.openId;
    }
  },

  methods: {
    shouAlert: function shouAlert() {
      this.show = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userComponents/user.vue














/* harmony default export */ var userComponents_user = ({
  components: {
    XInput: x_input["a" /* default */],
    Group: group["a" /* default */],
    Cell: cell["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    XButton: vux_src_components_x_button,
    Alert: components_alert["a" /* default */],
    loadPage: src_components_loadingPage

  },
  data: function data() {
    return {
      username: '',
      headimgurl: '',
      communityName: '',
      houseInfo: '',
      show: false,
      userphone: '',
      phoneback: '',
      comnCodes: '',
      bgimgurl: global.imgUrl + '/image/bg.jpg',

      balance: '',
      expiration: '',
      fontcolor: ''
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/user") {
      document.title = "个人中心";
    }
    if (this.$router.history.current.query.phone) {
      this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
        if (res.body.result) {
          var data = res.body.result[0];
          console.log("接口获取数据   ===   " + stringify_default()(data));
          this.communityName = data.comName;
          this.houseInfo = data.hsNo;
          this.userphone = data.mainPhone;
          var phone = this.userphone;
          this.comnCodes = data.comn_code;
          this.phoneback = phone.substring(0, 3) + '****' + phone.substring(7, 11);
          this.headimgurl = data.photoUrl;
          this.username = data.name;
          this.$http.get(global.host + 'pay/findmonexpiredate?comnCode=' + data.comn_code + '&houseCode=' + data.hsNo).then(function (result) {
            console.log(result);
            this.balance = result.body.accountbalance;
            this.expiration = result.body.lastdate;
            var date = new Date(this.expiration.split('-')[0], this.expiration.split('-')[1], this.expiration.split('-')[2], 23, 59, 59);
            var curday = new Date();
            if (Date.parse(date) - Date.parse(curday) >= 0) {
              this.fontcolor = '#333333';
            } else {
              this.fontcolor = 'red';
            }
            console.log(this.fontcolor);
            this.expiration = Object(date_format["a" /* default */])(new Date(this.expiration.split('-')[0], this.expiration.split('-')[1] - 1, this.expiration.split('-')[2]), 'YYYY/MM/DD');
          }, function (err) {
            console.log(err);
          });
        }
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    } else if (this.$router.history.current.query.userinfo) {
      var data = JSON.parse(this.$router.history.current.query.userinfo);
      console.log("不知道哪里获取数据   ===   " + stringify_default()(data));
      this.username = data.wxName;
      this.headimgurl = data.photoUrl;
      this.communityName = data.comName;
      this.houseInfo = data.buildName + '  ' + data.hsNo;
      this.userphone = this.$router.history.current.query.phone = data.mainPhone;
      var phone = this.userphone;
      this.phoneback = phone.substring(0, 3) + '****' + phone.substring(7, 11);
      this.$router.history.current.query.openid = data.openId;
    }
  },

  methods: {
    shouAlert: function shouAlert() {
      this.show = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51d4e1eb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userComponents/user.vue
var user_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:('background-image:url(' + _vm.bgimgurl + ');background-repeat:no-repeat;background-size: 200% 200%;background-position: 81% 37%;'),attrs:{"id":"userinfo"}},[_c('div',{staticStyle:{"text-align":"center","height":"110px","overflow":"hidden","padding-bottom":"10px","display":"inline-block","width":"40%"}},[_c('x-img',{staticStyle:{"width":"80%","height":"110px"},attrs:{"src":_vm.headimgurl}})],1),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","display":"inline-block","width":"55%","text-align":"left","height":"110px"}},[_c('h4',{staticStyle:{"text-align":"left","font-size":"18px","position":"absolute","top":"20px","color":"white","width":"200px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}},[_c('i',{staticClass:"iconfont icon-gerenzhongxin",staticStyle:{"color":"white","padding-right":"1em"}}),_vm._v(_vm._s(_vm.username))]),_vm._v(" "),_c('h4',{staticStyle:{"text-align":"left","position":"absolute","top":"50px","color":"white"}},[_c('i',{staticClass:"iconfont icon-shouji-copy",staticStyle:{"color":"white"}}),_vm._v(_vm._s(_vm.phoneback))]),_vm._v(" "),_c('router-link',{staticStyle:{"position":"absolute","color":"white","font-size":"30px","right":"0px","top":"21px"},attrs:{"to":{path:"/userinfo",query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone,}}}},[_c('i',{staticClass:"iconfont icon-gengduo"})])],1)]),_vm._v(" "),_c('group',[_c('router-link',{attrs:{"to":{path:"/changeHouse",query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone}}}},[_c('h4',{staticStyle:{"font-size":"16px","color":"#333","line-height":"1.7","font-weight":"700","padding":"7px 0 7px 0"}},[_c('i',{staticClass:"iconfont icon-weibiaoti-_huabanfuben",staticStyle:{"font-size":"26px","float":"left","padding-left":"15px","margin-top":"-8px","margin-right":"10px"}}),_vm._v("我的房产 "),_c('i',{staticClass:"iconfont icon-gengduo",staticStyle:{"color":"#ddd","float":"right","padding-right":"15px","font-size":"20px","margin-top":"-5px"}})])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"16px","color":"#333","line-height":"1.7","text-align":"left","padding":"2px 15px 2px 0","text-indent":"30px"}},[_vm._v(_vm._s(_vm.communityName)+" "+_vm._s(_vm.houseInfo))]),_vm._v(" "),_c('h4',{staticStyle:{"font-size":"15px","text-indent":"15px","color":"#333","line-height":"1.7","border-bottom":"1px solid #dddddd","padding":"7px 0 7px 0"}},[_c('span',{staticStyle:{"padding-left":"14px"}},[_vm._v("缴费到期时间 "),_c('span',{style:({'padding-left': '6px','color': _vm.fontcolor})},[_vm._v(_vm._s(_vm.expiration))])])]),_vm._v(" "),_c('router-link',{attrs:{"to":{path:"/myCarInfo",query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone}}}},[_c('h4',{staticStyle:{"border-bottom":"1px solid #dddddd","font-size":"16px","color":"#333","line-height":"1.7","font-weight":"700","padding":"7px 0 7px 0"}},[_c('i',{staticClass:"iconfont icon-banjiapeisong",staticStyle:{"font-size":"26px","float":"left","padding-left":"15px","margin-top":"-8px","margin-right":"10px"}}),_vm._v("我的车位 "),_c('i',{staticClass:"iconfont icon-gengduo",staticStyle:{"color":"#ddd","float":"right","padding-right":"15px","font-size":"20px","margin-top":"-5px"}})])]),_vm._v(" "),_c('router-link',{attrs:{"to":{path:"/paymentRecord",query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone}}}},[_c('h4',{staticStyle:{"font-size":"16px","color":"#333","line-height":"1.7","font-weight":"700","padding":"7px 0 7px 0","border-bottom":"1px solid #dddddd"}},[_c('i',{staticClass:"iconfont icon-zhangdan",staticStyle:{"font-size":"26px","float":"left","padding-left":"22px","margin-top":"-8px","margin-right":"-8px"}}),_vm._v("缴费记录"),_c('i',{staticClass:"iconfont icon-gengduo",staticStyle:{"color":"#ddd","float":"right","padding-right":"15px","font-size":"20px","margin-top":"-5px"}})])]),_vm._v(" "),_c('router-link',{attrs:{"to":{path:"/orderList",query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone}}}},[_c('h4',{staticStyle:{"font-size":"16px","color":"#333","line-height":"1.7","font-weight":"700","padding":"7px 0 7px 6px","border-bottom":"1px solid #dddddd"}},[_c('i',{staticClass:"iconfont icon-weixiu1",staticStyle:{"font-size":"18px","float":"left","padding-left":"15px","margin-top":"-1px","margin-right":"10px"}}),_vm._v("我的报修"),_c('i',{staticClass:"iconfont icon-gengduo",staticStyle:{"color":"#ddd","float":"right","padding-right":"15px","font-size":"20px","margin-top":"-5px"}})])]),_vm._v(" "),_c('router-link',{attrs:{"to":{path:"/complaintCollect",query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone}}}},[_c('h4',{staticStyle:{"font-size":"16px","color":"#333","line-height":"1.7","font-weight":"700","padding":"7px 0 7px 6px","border-bottom":"1px solid #dddddd"}},[_c('i',{staticClass:"iconfont icon-ai206",staticStyle:{"font-size":"18px","float":"left","padding-left":"15px","margin-top":"-1px","margin-right":"10px"}}),_vm._v("我的建议 "),_c('i',{staticClass:"iconfont icon-gengduo",staticStyle:{"float":"right","padding-right":"15px","font-size":"20px","margin-top":"-5px","color":"#ddd"}})])]),_vm._v(" "),_c('router-link',{attrs:{"to":{path:"/accessControl",query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone}}}},[_c('h4',{staticStyle:{"font-size":"16px","color":"#333","line-height":"1.7","font-weight":"700","padding":"7px 0 7px 6px","border-bottom":"1px solid #dddddd"}},[_c('img',{staticStyle:{"width":"18px","height":"18px","float":"left","padding-left":"15px","margin-top":"4px","margin-right":"10px"},attrs:{"src":__webpack_require__("WBmC"),"alt":""}}),_vm._v("智慧门禁 "),_c('i',{staticClass:"iconfont icon-gengduo",staticStyle:{"float":"right","padding-right":"15px","font-size":"20px","margin-top":"-5px","color":"#ddd"}})])])],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v("功能暂未上线"),_c('br'),_vm._v("敬请期待")])],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var user_staticRenderFns = []
var user_esExports = { render: user_render, staticRenderFns: user_staticRenderFns }
/* harmony default export */ var components_userComponents_user = (user_esExports);
// CONCATENATED MODULE: ./src/components/userComponents/user.vue
function user_injectStyle (ssrContext) {
  __webpack_require__("uJm6")
}
var user_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var user___vue_template_functional__ = false
/* styles */
var user___vue_styles__ = user_injectStyle
/* scopeId */
var user___vue_scopeId__ = "data-v-51d4e1eb"
/* moduleIdentifier (server only) */
var user___vue_module_identifier__ = null
var user_Component = user_normalizeComponent(
  userComponents_user,
  components_userComponents_user,
  user___vue_template_functional__,
  user___vue_styles__,
  user___vue_scopeId__,
  user___vue_module_identifier__
)

/* harmony default export */ var src_components_userComponents_user = (user_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/datetimepicker.js + 3 modules
var datetimepicker = __webpack_require__("zV4+");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f2db92d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var datetime_staticRenderFns = []
var datetime_esExports = { render: datetime_render, staticRenderFns: datetime_staticRenderFns }
/* harmony default export */ var src_components_datetime = (datetime_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime/index.vue
function datetime_injectStyle (ssrContext) {
  __webpack_require__("apyy")
}
var datetime_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datetime___vue_template_functional__ = false
/* styles */
var datetime___vue_styles__ = datetime_injectStyle
/* scopeId */
var datetime___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datetime___vue_module_identifier__ = null
var datetime_Component = datetime_normalizeComponent(
  components_datetime,
  src_components_datetime,
  datetime___vue_template_functional__,
  datetime___vue_styles__,
  datetime___vue_scopeId__,
  datetime___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_datetime = (datetime_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var form_preview = ({
  name: 'form-preview',
  props: ['headerLabel', 'headerValue', 'bodyItems', 'footerButtons', 'name'],
  methods: {
    onButtonClick: function onButtonClick(cb, link) {
      cb && cb(this.name);
      if (link) {
        Object(router["b" /* go */])(link, this.$router);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_form_preview = ({
  name: 'form-preview',
  props: ['headerLabel', 'headerValue', 'bodyItems', 'footerButtons', 'name'],
  methods: {
    onButtonClick: function onButtonClick(cb, link) {
      cb && cb(this.name);
      if (link) {
        Object(router["b" /* go */])(link, this.$router);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f694e57","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/form-preview/index.vue
var form_preview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-form-preview weui-form-preview"},[_c('div',{staticClass:"weui-form-preview__hd"},[_c('label',{staticClass:"weui-form-preview__label",domProps:{"innerHTML":_vm._s(_vm.headerLabel)}}),_vm._v(" "),_c('em',{staticClass:"weui-form-preview__value",domProps:{"innerHTML":_vm._s(_vm.headerValue || '&nbsp;')}})]),_vm._v(" "),_c('div',{staticClass:"weui-form-preview__bd"},_vm._l((_vm.bodyItems),function(item){return _c('div',{staticClass:"weui-form-preview__item"},[_c('label',{staticClass:"weui-form-preview__label"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticClass:"weui-form-preview__value"},[_vm._v(_vm._s(item.value))])])})),_vm._v(" "),_c('div',{staticClass:"weui-form-preview__ft"},_vm._l((_vm.footerButtons),function(button){return _c('a',{staticClass:"weui-form-preview__btn",class:{'weui-form-preview__btn_default': button.style==='default', 'weui-form-preview__btn_primary': button.style === 'primary'},attrs:{"href":"javascript:"},on:{"click":function($event){_vm.onButtonClick(button.onButtonClick, button.link)}}},[_vm._v(_vm._s(button.text))])}))])}
var form_preview_staticRenderFns = []
var form_preview_esExports = { render: form_preview_render, staticRenderFns: form_preview_staticRenderFns }
/* harmony default export */ var src_components_form_preview = (form_preview_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/form-preview/index.vue
function form_preview_injectStyle (ssrContext) {
  __webpack_require__("be3g")
}
var form_preview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var form_preview___vue_template_functional__ = false
/* styles */
var form_preview___vue_styles__ = form_preview_injectStyle
/* scopeId */
var form_preview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var form_preview___vue_module_identifier__ = null
var form_preview_Component = form_preview_normalizeComponent(
  components_form_preview,
  src_components_form_preview,
  form_preview___vue_template_functional__,
  form_preview___vue_styles__,
  form_preview___vue_scopeId__,
  form_preview___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_form_preview = (form_preview_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var components_selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var components_selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: components_selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ac472c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/selector/index.vue
var selector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-selector weui-cell",class:{
    'weui-cell_select': !_vm.readonly,
    'weui-cell_select-after': _vm.title
  }},[(_vm.title)?_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.cleanStyle({
        width: _vm.$parent.labelWidth,
        textAlign: _vm.$parent.labelAlign,
        marginRight: _vm.$parent.labelMarginRight
      })),attrs:{"for":("vux-selector-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_vm._v(" "),(!_vm.readonly)?_c('div',{staticClass:"weui-cell__bd"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-select",style:(_vm.cleanStyle({
        direction: _vm.direction,
        color: _vm.color
      })),attrs:{"id":("vux-selector-" + _vm.uuid),"name":_vm.name},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[(_vm.showPlaceholder)?_c('option',{domProps:{"value":_vm.value === null ? 'null' : '',"selected":_vm.isEmptyValue(_vm.value) && !!_vm.placeholder}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.fixIos)?_c('option',{attrs:{"disabled":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.processOptions),function(one){return _c('option',{domProps:{"value":one.key}},[_vm._v(_vm._s(one.value))])})],2)]):_c('div',{staticClass:"weui-cell__ft vux-selector-readonly"},[_vm._v("\n    "+_vm._s(_vm._f("findByKey")(_vm.value,_vm.processOptions))+"\n  ")])])}
var selector_staticRenderFns = []
var selector_esExports = { render: selector_render, staticRenderFns: selector_staticRenderFns }
/* harmony default export */ var src_components_selector = (selector_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/selector/index.vue
function selector_injectStyle (ssrContext) {
  __webpack_require__("yiUR")
}
var selector_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var selector___vue_template_functional__ = false
/* styles */
var selector___vue_styles__ = selector_injectStyle
/* scopeId */
var selector___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var selector___vue_module_identifier__ = null
var selector_Component = selector_normalizeComponent(
  components_selector,
  src_components_selector,
  selector___vue_template_functional__,
  selector___vue_styles__,
  selector___vue_scopeId__,
  selector___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_selector = (selector_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-table/index.vue
//
//
//
//
//
//

/* harmony default export */ var x_table = ({
  name: 'x-table',
  props: {
    fullBordered: Boolean,
    cellBordered: {
      type: Boolean,
      default: true
    },
    contentBordered: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-table/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_x_table = ({
  name: 'x-table',
  props: {
    fullBordered: Boolean,
    cellBordered: {
      type: Boolean,
      default: true
    },
    contentBordered: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d55df8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-table/index.vue
var x_table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"vux-table",class:{'vux-table-bordered': _vm.fullBordered, 'vux-table-no-cell-bordered': !_vm.cellBordered, 'vux-table-no-content-bordered': !_vm.contentBordered}},[_vm._t("default")],2)}
var x_table_staticRenderFns = []
var x_table_esExports = { render: x_table_render, staticRenderFns: x_table_staticRenderFns }
/* harmony default export */ var src_components_x_table = (x_table_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-table/index.vue
function x_table_injectStyle (ssrContext) {
  __webpack_require__("cC6l")
}
var x_table_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_table___vue_template_functional__ = false
/* styles */
var x_table___vue_styles__ = x_table_injectStyle
/* scopeId */
var x_table___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_table___vue_module_identifier__ = null
var x_table_Component = x_table_normalizeComponent(
  components_x_table,
  src_components_x_table,
  x_table___vue_template_functional__,
  x_table___vue_styles__,
  x_table___vue_scopeId__,
  x_table___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_table = (x_table_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/payComponents/paymentRecord.vue


















/* harmony default export */ var paymentRecord = ({
  components: {
    Selector: vux_src_components_selector,
    Group: group["a" /* default */],
    Cell: cell["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XTable: vux_src_components_x_table,
    dateFormat: date_format["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    FormPreview: vux_src_components_form_preview,
    Alert: components_alert["a" /* default */],
    loadPage: src_components_loadingPage,
    PopupPicker: popup_picker["a" /* default */],
    Datetime: vux_src_components_datetime,
    jquery: jquery_default.a
  },
  filter: {
    dateFormat: date_format["a" /* default */]
  },
  data: function data() {
    return {
      username: '',
      usertype: '',
      district: ' 玫瑰苑',
      house: '',
      flag: '',
      accout: '',
      comnCode: "",
      createDate: '',
      houseAreas: '',
      show: false,
      mlist1: [[{
        name: '全部',
        value: 'other'
      }, {
        name: '物业费',
        value: 'wuye'
      }, {
        name: '车位费',
        value: 'park'
      }, {
        name: '水电费',
        value: 'water'
      }]],
      mValue1: ['other'],
      mValue2: this.getNowFormatMonth(),
      allOrder: [],
      totalFee: '',
      totalSumFee: 0,
      detailData: [],
      detailSuccess: [],
      end: '',
      start: '',
      hsName: '',
      hs_no: '',
      billCode: '',
      showprompt: false,
      showDetail: false,
      showWaterDetail: false,
      showWaterUnpay: false,
      prompt: '',
      paymonth: '',
      giving: '',
      paysum: '',
      feeType: '',
      payDate: '',
      carShow: false,
      parkInfo: {},
      Mtitle: '去支付',
      Mclose: '取消订单',
      carInfosMessage: '',
      show_1: false
    };
  },
  beforeMount: function beforeMount() {

    if (this.$router.history.current.path == "/paymentRecord") {
      document.title = "缴费记录";
    }
    this.show_1 = true;
    /* console.log(this.mlist1[0][0].name)
    this.mValue1[0] = this.mlist1[0][0].name;*/
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      if (res.body.result) {
        console.log(res);
        var data = res.body.result[0];
        this.username = data.name;
        this.usertype = data.type;

        this.houseAreas = data.houseArea;

        var mgData = data.parkCode;
        var mSms = mgData.toString();
        var replaces = ',';
        this.carInfosMessage = mSms.replace(new RegExp(replaces, 'gm'), '   ');

        this.house = data.hsNo;
        this.district = data.comName;
        this.comnCode = data.comn_code;
        this.hsName = data.hsName;
        this.hs_no = data.hsNo;

        this.searchFeeList();
      }
    }, function (err) {
      console.log(err);
    });
  },
  updated: function updated() {
    jquery_default()(".mDailog .weui-dialog__bd").css("padding", "1.3em 0em 0.5em");
  },

  methods: {
    searchFeeList: function searchFeeList() {
      this.show_1 = true;
      this.feeType = this.mValue1[0];
      this.payDate = this.mValue2;
      console.log("&&&&&&&&&&&&&&&&&&&&&&&&&");
      console.log(this.payDate);

      this.$http.get(global.host + 'pay/findownerorder?comnCode=' + this.comnCode + '&houseNo=' + this.hs_no + '&phoneNo=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid + '&feeType=' + this.feeType + "&payDate=" + this.payDate).then(function (res) {
        var data = res.body;
        this.allOrder = [];
        var total = 0;
        for (var i = 0; i < data.length; i++) {
          this.allOrder.push(data[i]);
          total = total + data[i].totalMoney;
        }
        this.totalSumFee = total.toFixed(2);
        this.show_1 = false;
      }, function (err) {
        this.show_1 = false;
        console.log(err);
      });
    },
    changeFeeType: function changeFeeType() {
      this.searchFeeList();
    },
    changeFeeDate: function changeFeeDate() {
      this.searchFeeList();
    },

    /*显示已支付和作废的订单详情弹框*/
    showOrder: function showOrder(item) {
      this.show_1 = true;
      this.billCode = item.billCode;
      this.createDate = item.createDate;
      /*清空详情数组中的内容*/
      var size = this.detailSuccess.length;
      for (var j = 0; j < size; j++) {
        this.detailSuccess.pop();
      }
      this.$http.get(global.host + 'pay/findunpaiddetail?tradeNo=' + this.billCode).then(function (res) {

        this.totalFee = 0;
        this.accout = res.body.accountbanlance;
        var detail = res.body.result;
        if (res.body.orderType == 'wuye') {
          for (var i = 0; i < detail.length; i++) {
            detail[i].start = Object(date_format["a" /* default */])(new Date(detail[i].startDate), 'YYYY/MM');
            detail[i].end = Object(date_format["a" /* default */])(new Date(detail[i].endDate), 'YYYY/MM');
            this.detailSuccess.push(detail[i]);
            this.totalFee = this.totalFee * 1 + detail[i].shishou * 1;
          }
          /*容易出现小数点截取异常*/
          this.totalFee = this.totalFee.toFixed(2);
          this.showDetail = true;
        } else if (res.body.orderType == 'water') {
          for (var _i = 0; _i < detail.length; _i++) {
            this.detailSuccess.push(detail[_i]);
            this.totalFee = res.body.account;
          }
          this.showWaterDetail = true;
        } else if (res.body.orderType == 'park') {
          this.carShow = true;
          this.parkInfo = res.body.result;
          this.totalFee = this.parkInfo.feeMoney;
        }
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },

    /*取消订单*/
    cancelpay: function cancelpay() {
      if (this.Mclose == "关闭") {
        this.carShow = false;
      } else {
        this.$http.get(global.host + 'pay/cancelpayorder?tradeNo=' + this.billCode).then(function (res) {
          if (res.body.code == '110') {
            /*重新加载数据*/
            this.feeType = this.mValue1[0];
            this.payDate = this.mValue2;
            this.$http.get(global.host + 'pay/findownerorder?comnCode=' + this.comnCode + '&houseNo=' + this.hs_no + '&openid=' + this.$router.history.current.query.openid + '&phoneNo=' + this.$router.history.current.query.phone + "&feeType=" + this.feeType + "&payDate=" + this.payDate).then(function (res) {
              console.log(res);
              var data = res.body;
              this.allOrder = [];
              var total = 0;
              for (var i = 0; i < data.length; i++) {
                this.allOrder.push(data[i]);
                total = total + data[i].totalMoney;
              }
              this.totalSumFee = total.toFixed(2);
            }, function (err) {
              console.log(err);
            });
          } else {
            this.prompt = '订单取消异常,请稍候再试';
            this.showprompt = true;
          }
        }, function (err) {
          console.log(err);
        });
      }
    },

    /*刷新页面*/
    refresh: function refresh() {
      if (this.prompt == '支付成功') {
        this.submitable = false;
        this.$router.push({ path: '/paymentRecord', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
      } else {
        this.show = true;
        this.submitable = true;
      }
    },

    /*显示未支付订单的详情*/
    showpay: function showpay(item, index, feeType) {
      this.show_1 = true;
      this.billCode = item.billCode;
      this.createDate = item.createDate;
      var size = this.detailData.length;
      for (var j = 0; j < size; j++) {
        this.detailData.pop();
      }

      jquery_default()(".mDailog .weui-dialog__bd").css("padding", "1.3em 0em 0.5em");
      this.$http.get(global.host + 'pay/findunpaiddetail?tradeNo=' + this.billCode).then(function (res) {
        console.log(res);

        this.totalFee = 0;
        this.paymonth = res.body.paymonth;
        this.giving = res.body.freemonth;
        this.paysum = res.body.paysum;
        var detail = res.body.result;
        if (res.body.orderType == 'wuye') {
          for (var i = 0; i < detail.length; i++) {
            detail[i].start = Object(date_format["a" /* default */])(new Date(detail[i].startDate), 'YYYY/MM');
            detail[i].end = Object(date_format["a" /* default */])(new Date(detail[i].endDate), 'YYYY/MM');
            this.detailData.push(detail[i]);
            this.totalFee = this.totalFee + detail[i].shishou * 1;
          }
          this.totalFee = (this.totalFee * 1).toFixed(2);
          this.accout = (this.accout * 1).toFixed(2);
          this.show = true;
        } else if (res.body.orderType == 'water') {
          for (var _i2 = 0; _i2 < detail.length; _i2++) {
            this.detailData.push(detail[_i2]);
          }
          this.totalFee = res.body.account;
          this.showWaterUnpay = true;
        } else if (res.body.orderType == 'park') {
          this.carShow = true;
          this.parkInfo = res.body.result;
          this.totalFee = this.parkInfo.feeMoney;
        }
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },

    /*去支付*/
    gopay: function gopay(feeType) {
      this.show_1 = true;
      var senddata = new Object();
      senddata.comnCode = this.comnCode;
      /*当账户余额大于0时，调用微信支付的接口*/
      if (this.totalFee > 0) {
        /*调用微信支付的接口*/
        senddata.memberNo = this.$router.history.current.query.phone;
        senddata.openid = this.$router.history.current.query.openid;
        senddata.tradeAmount = this.totalFee;
        senddata.tradeNo = this.billCode;

        senddata.tradeName = '物业费';
        senddata.tradeDesc = '物业费(包括电梯费、生活垃圾费)';
        var url = global.host + 'pay/getpayurl';
        if (feeType === "park") {
          senddata.tradeName = '车位费';
          senddata.tradeDesc = '停车费(临时停车费、车位管理费)';
          url = global.host + 'parkFeeBill/getpayurl';
        } else if (feeType === "water") {
          senddata.tradeName = '水电费';
          senddata.tradeDesc = '水电费(水费、电费)';
          url = global.host + 'hydro/getpayurl';
        }
        this.$http.post(url, senddata).then(function (res) {
          console.log(res);
          if (res.body.code == '110') {
            location.href = res.body.payurl;
          } else {
            this.prompt = '支付异常,请稍候再试';
            this.showprompt = true;
          }
        }, function (err) {
          this.show_1 = false;
          console.log(err);
        });
      }
    },

    /**
    * 获取当前月份
    * 格式YYYY-MM
    */
    getNowFormatMonth: function getNowFormatMonth() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return year + seperator1 + month;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/payComponents/paymentRecord.vue


















/* harmony default export */ var payComponents_paymentRecord = ({
  components: {
    Selector: vux_src_components_selector,
    Group: group["a" /* default */],
    Cell: cell["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XTable: vux_src_components_x_table,
    dateFormat: date_format["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    FormPreview: vux_src_components_form_preview,
    Alert: components_alert["a" /* default */],
    loadPage: src_components_loadingPage,
    PopupPicker: popup_picker["a" /* default */],
    Datetime: vux_src_components_datetime,
    jquery: jquery_default.a
  },
  filter: {
    dateFormat: date_format["a" /* default */]
  },
  data: function data() {
    return {
      username: '',
      usertype: '',
      district: ' 玫瑰苑',
      house: '',
      flag: '',
      accout: '',
      comnCode: "",
      createDate: '',
      houseAreas: '',
      show: false,
      mlist1: [[{
        name: '全部',
        value: 'other'
      }, {
        name: '物业费',
        value: 'wuye'
      }, {
        name: '车位费',
        value: 'park'
      }, {
        name: '水电费',
        value: 'water'
      }]],
      mValue1: ['other'],
      mValue2: this.getNowFormatMonth(),
      allOrder: [],
      totalFee: '',
      totalSumFee: 0,
      detailData: [],
      detailSuccess: [],
      end: '',
      start: '',
      hsName: '',
      hs_no: '',
      billCode: '',
      showprompt: false,
      showDetail: false,
      showWaterDetail: false,
      showWaterUnpay: false,
      prompt: '',
      paymonth: '',
      giving: '',
      paysum: '',
      feeType: '',
      payDate: '',
      carShow: false,
      parkInfo: {},
      Mtitle: '去支付',
      Mclose: '取消订单',
      carInfosMessage: '',
      show_1: false
    };
  },
  beforeMount: function beforeMount() {

    if (this.$router.history.current.path == "/paymentRecord") {
      document.title = "缴费记录";
    }
    this.show_1 = true;
    /* console.log(this.mlist1[0][0].name)
    this.mValue1[0] = this.mlist1[0][0].name;*/
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      if (res.body.result) {
        console.log(res);
        var data = res.body.result[0];
        this.username = data.name;
        this.usertype = data.type;

        this.houseAreas = data.houseArea;

        var mgData = data.parkCode;
        var mSms = mgData.toString();
        var replaces = ',';
        this.carInfosMessage = mSms.replace(new RegExp(replaces, 'gm'), '   ');

        this.house = data.hsNo;
        this.district = data.comName;
        this.comnCode = data.comn_code;
        this.hsName = data.hsName;
        this.hs_no = data.hsNo;

        this.searchFeeList();
      }
    }, function (err) {
      console.log(err);
    });
  },
  updated: function updated() {
    jquery_default()(".mDailog .weui-dialog__bd").css("padding", "1.3em 0em 0.5em");
  },

  methods: {
    searchFeeList: function searchFeeList() {
      this.show_1 = true;
      this.feeType = this.mValue1[0];
      this.payDate = this.mValue2;
      console.log("&&&&&&&&&&&&&&&&&&&&&&&&&");
      console.log(this.payDate);

      this.$http.get(global.host + 'pay/findownerorder?comnCode=' + this.comnCode + '&houseNo=' + this.hs_no + '&phoneNo=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid + '&feeType=' + this.feeType + "&payDate=" + this.payDate).then(function (res) {
        var data = res.body;
        this.allOrder = [];
        var total = 0;
        for (var i = 0; i < data.length; i++) {
          this.allOrder.push(data[i]);
          total = total + data[i].totalMoney;
        }
        this.totalSumFee = total.toFixed(2);
        this.show_1 = false;
      }, function (err) {
        this.show_1 = false;
        console.log(err);
      });
    },
    changeFeeType: function changeFeeType() {
      this.searchFeeList();
    },
    changeFeeDate: function changeFeeDate() {
      this.searchFeeList();
    },

    /*显示已支付和作废的订单详情弹框*/
    showOrder: function showOrder(item) {
      this.show_1 = true;
      this.billCode = item.billCode;
      this.createDate = item.createDate;
      /*清空详情数组中的内容*/
      var size = this.detailSuccess.length;
      for (var j = 0; j < size; j++) {
        this.detailSuccess.pop();
      }
      this.$http.get(global.host + 'pay/findunpaiddetail?tradeNo=' + this.billCode).then(function (res) {

        this.totalFee = 0;
        this.accout = res.body.accountbanlance;
        var detail = res.body.result;
        if (res.body.orderType == 'wuye') {
          for (var i = 0; i < detail.length; i++) {
            detail[i].start = Object(date_format["a" /* default */])(new Date(detail[i].startDate), 'YYYY/MM');
            detail[i].end = Object(date_format["a" /* default */])(new Date(detail[i].endDate), 'YYYY/MM');
            this.detailSuccess.push(detail[i]);
            this.totalFee = this.totalFee * 1 + detail[i].shishou * 1;
          }
          /*容易出现小数点截取异常*/
          this.totalFee = this.totalFee.toFixed(2);
          this.showDetail = true;
        } else if (res.body.orderType == 'water') {
          for (var _i = 0; _i < detail.length; _i++) {
            this.detailSuccess.push(detail[_i]);
            this.totalFee = res.body.account;
          }
          this.showWaterDetail = true;
        } else if (res.body.orderType == 'park') {
          this.carShow = true;
          this.parkInfo = res.body.result;
          this.totalFee = this.parkInfo.feeMoney;
        }
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },

    /*取消订单*/
    cancelpay: function cancelpay() {
      if (this.Mclose == "关闭") {
        this.carShow = false;
      } else {
        this.$http.get(global.host + 'pay/cancelpayorder?tradeNo=' + this.billCode).then(function (res) {
          if (res.body.code == '110') {
            /*重新加载数据*/
            this.feeType = this.mValue1[0];
            this.payDate = this.mValue2;
            this.$http.get(global.host + 'pay/findownerorder?comnCode=' + this.comnCode + '&houseNo=' + this.hs_no + '&openid=' + this.$router.history.current.query.openid + '&phoneNo=' + this.$router.history.current.query.phone + "&feeType=" + this.feeType + "&payDate=" + this.payDate).then(function (res) {
              console.log(res);
              var data = res.body;
              this.allOrder = [];
              var total = 0;
              for (var i = 0; i < data.length; i++) {
                this.allOrder.push(data[i]);
                total = total + data[i].totalMoney;
              }
              this.totalSumFee = total.toFixed(2);
            }, function (err) {
              console.log(err);
            });
          } else {
            this.prompt = '订单取消异常,请稍候再试';
            this.showprompt = true;
          }
        }, function (err) {
          console.log(err);
        });
      }
    },

    /*刷新页面*/
    refresh: function refresh() {
      if (this.prompt == '支付成功') {
        this.submitable = false;
        this.$router.push({ path: '/paymentRecord', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
      } else {
        this.show = true;
        this.submitable = true;
      }
    },

    /*显示未支付订单的详情*/
    showpay: function showpay(item, index, feeType) {
      this.show_1 = true;
      this.billCode = item.billCode;
      this.createDate = item.createDate;
      var size = this.detailData.length;
      for (var j = 0; j < size; j++) {
        this.detailData.pop();
      }

      jquery_default()(".mDailog .weui-dialog__bd").css("padding", "1.3em 0em 0.5em");
      this.$http.get(global.host + 'pay/findunpaiddetail?tradeNo=' + this.billCode).then(function (res) {
        console.log(res);

        this.totalFee = 0;
        this.paymonth = res.body.paymonth;
        this.giving = res.body.freemonth;
        this.paysum = res.body.paysum;
        var detail = res.body.result;
        if (res.body.orderType == 'wuye') {
          for (var i = 0; i < detail.length; i++) {
            detail[i].start = Object(date_format["a" /* default */])(new Date(detail[i].startDate), 'YYYY/MM');
            detail[i].end = Object(date_format["a" /* default */])(new Date(detail[i].endDate), 'YYYY/MM');
            this.detailData.push(detail[i]);
            this.totalFee = this.totalFee + detail[i].shishou * 1;
          }
          this.totalFee = (this.totalFee * 1).toFixed(2);
          this.accout = (this.accout * 1).toFixed(2);
          this.show = true;
        } else if (res.body.orderType == 'water') {
          for (var _i2 = 0; _i2 < detail.length; _i2++) {
            this.detailData.push(detail[_i2]);
          }
          this.totalFee = res.body.account;
          this.showWaterUnpay = true;
        } else if (res.body.orderType == 'park') {
          this.carShow = true;
          this.parkInfo = res.body.result;
          this.totalFee = this.parkInfo.feeMoney;
        }
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },

    /*去支付*/
    gopay: function gopay(feeType) {
      this.show_1 = true;
      var senddata = new Object();
      senddata.comnCode = this.comnCode;
      /*当账户余额大于0时，调用微信支付的接口*/
      if (this.totalFee > 0) {
        /*调用微信支付的接口*/
        senddata.memberNo = this.$router.history.current.query.phone;
        senddata.openid = this.$router.history.current.query.openid;
        senddata.tradeAmount = this.totalFee;
        senddata.tradeNo = this.billCode;

        senddata.tradeName = '物业费';
        senddata.tradeDesc = '物业费(包括电梯费、生活垃圾费)';
        var url = global.host + 'pay/getpayurl';
        if (feeType === "park") {
          senddata.tradeName = '车位费';
          senddata.tradeDesc = '停车费(临时停车费、车位管理费)';
          url = global.host + 'parkFeeBill/getpayurl';
        } else if (feeType === "water") {
          senddata.tradeName = '水电费';
          senddata.tradeDesc = '水电费(水费、电费)';
          url = global.host + 'hydro/getpayurl';
        }
        this.$http.post(url, senddata).then(function (res) {
          console.log(res);
          if (res.body.code == '110') {
            location.href = res.body.payurl;
          } else {
            this.prompt = '支付异常,请稍候再试';
            this.showprompt = true;
          }
        }, function (err) {
          this.show_1 = false;
          console.log(err);
        });
      }
    },

    /**
    * 获取当前月份
    * 格式YYYY-MM
    */
    getNowFormatMonth: function getNowFormatMonth() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return year + seperator1 + month;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74689b4c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payComponents/paymentRecord.vue
var paymentRecord_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"am_personInfomation"},[_c('div',{staticClass:"am_ncontent"},[_c('flexbox',{staticClass:"am_box_bor",attrs:{"gutter":0}},[_c('flexbox-item',{staticStyle:{"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","line-height":"35px","padding-left":"15px"},attrs:{"span":6/10}},[_vm._v(_vm._s(_vm.district))]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":4/10}},[_vm._v(_vm._s(_vm.house))])],1),_vm._v(" "),_c('flexbox',{staticClass:"am_box_bor",attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_aitem am_name",attrs:{"span":1/2}},[_vm._v("绑定姓名："+_vm._s(_vm.username))]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_center",attrs:{"span":1/2}},[_vm._v("房屋面积："+_vm._s(_vm.houseAreas))])],1),_vm._v(" "),_c('flexbox',{staticClass:"am_box_bor am_noBorL",attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_aitem am_name am_noBoright"},[_vm._v("车位信息："+_vm._s(_vm.carInfosMessage))])],1)],1)]),_vm._v(" "),_c('group',{attrs:{"id":"am_out"}},[_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{attrs:{"span":1/2}},[_c('popup-picker',{attrs:{"title":"类别","data":_vm.mlist1,"show-name":"true"},on:{"on-change":_vm.changeFeeType},model:{value:(_vm.mValue1),callback:function ($$v) {_vm.mValue1=$$v},expression:"mValue1"}})],1),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/2}},[_c('datetime',{attrs:{"title":"日期","format":"YYYY-MM"},on:{"on-change":_vm.changeFeeDate},model:{value:(_vm.mValue2),callback:function ($$v) {_vm.mValue2=$$v},expression:"mValue2"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"am_personInfomation"},[_c('div',{staticClass:"uList"},[_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"amDate",attrs:{"span":1/3}},[_vm._v(_vm._s(_vm.mValue2))]),_vm._v(" "),_c('flexbox-item',{staticClass:"amSum",attrs:{"span":2/3}},[_c('span',[_vm._v("费用合计："),_c('b',[_vm._v("￥"+_vm._s(_vm.totalSumFee))])])])],1),_vm._v(" "),_vm._l((_vm.allOrder),function(order,index){return _c('div',{key:index,staticClass:"am_clist"},_vm._l((order.orderList),function(item,index){return (item.payStatus != "-1")?_c('div',{key:index,staticStyle:{"border-top":"1px solid #c1c3c1"}},[(item.payStatus == "1")?_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.showOrder(item)}}},[_c('h1',[_vm._v("订单编号："+_vm._s(item.billCode))]),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"amName",attrs:{"span":2/5}},[_c('h2',[_vm._v(_vm._s(order.feeType))]),_vm._v(" "),_c('p',{staticClass:"am_center"},[_vm._v(_vm._s(item.createDate))])]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_center",attrs:{"span":1/5}},[(item.payStatus == "1")?_c('strong',{staticStyle:{"color":"green"}},[_vm._v("已支付")]):(item.payStatus == "0")?_c('strong',[_vm._v("未支付")]):_c('strong',[_vm._v("作废")])]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_center",attrs:{"span":2/5}},[_c('h5',[_vm._v("订单金额:"),_c('b',[_vm._v(_vm._s(item.yingshou)+"元")])]),_vm._v(" "),_c('h5',[_vm._v("优惠金额:"),_c('b',[_vm._v(_vm._s(item.youhui ? item.youhui :'0')+"元")])]),_vm._v(" "),_c('h5',[_vm._v("付款金额:"),(item.flag == "1")?_c('b',[_vm._v(_vm._s(item.feeMoney)+"元")]):_c('b',[_vm._v(_vm._s(item.shishou)+"元")])])])],1),_vm._v(" "),(item.voucherNo == '')?_c('h6',[_vm._v("凭证号："+_vm._s(item.voucherNo))]):_vm._e()],1):(item.payStatus == "0")?_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.showpay(item,index,order.feeType)}}},[_c('h1',[_vm._v("订单编号："+_vm._s(item.billCode))]),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"amName",attrs:{"span":2/5}},[_c('h2',[_vm._v(_vm._s(order.feeType))]),_vm._v(" "),_c('p',{staticClass:"am_center"},[_vm._v(_vm._s(item.createDate))])]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_center",attrs:{"span":1/5}},[(item.payStatus == "1")?_c('strong',[_vm._v("已支付")]):(item.payStatus == "0")?_c('strong',[_vm._v("未支付")]):_c('strong',[_vm._v("作废")])]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_center",attrs:{"span":2/5}},[_c('h5',[_vm._v("订单金额:"),_c('b',[_vm._v(_vm._s(item.yingshou)+"元")])]),_vm._v(" "),_c('h5',[_vm._v("优惠金额:"),_c('b',[_vm._v(_vm._s(item.youhui ? item.youhui :'0')+"元")])]),_vm._v(" "),_c('h5',[_vm._v("付款金额:"),(item.flag == "1")?_c('b',[_vm._v(_vm._s(item.feeMoney)+"元")]):_c('b',[_vm._v(_vm._s(item.shishou)+"元")])])])],1),_vm._v(" "),(item.voucherNo == '')?_c('h6',[_vm._v("凭证号："+_vm._s(item.voucherNo))]):_vm._e()],1):_vm._e()]):_vm._e()}))})],2)]),_vm._v(" "),(_vm.parkInfo.payStatus == "0")?_c('confirm',{staticClass:"mDailog",attrs:{"title":"订单详情","confirm-text":_vm.Mtitle,"cancel-text":_vm.Mclose},on:{"on-confirm":function($event){_vm.gopay('park')},"on-cancel":_vm.cancelpay},model:{value:(_vm.carShow),callback:function ($$v) {_vm.carShow=$$v},expression:"carShow"}},[_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_centers"},[_vm._v("订单编号："+_vm._s(_vm.parkInfo.billCode))])],1),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_centers",attrs:{"span":5/8}},[_vm._v("车位编号："+_vm._s(_vm.parkInfo.pkId))]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_centers",attrs:{"span":3/8}},[_vm._v("购买量："+_vm._s(_vm.parkInfo.feeCount)+"个月")])],1),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_centers",attrs:{"span":5/8}},[_vm._v("到期时间："+_vm._s(_vm.parkInfo.endDate))]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_centers",attrs:{"span":3/8}},[_vm._v("月费用："+_vm._s(_vm.parkInfo.feePrice)+"元")])],1),_vm._v(" "),_c('h5',{staticStyle:{"line-height":"1.2","font-size":"0.9em","text-align":"right","color":"red","padding":"10px 10px 0 0"}},[_vm._v("费用总计 ： "),_c('span',{staticStyle:{"text-indent":"20px"}},[_vm._v(_vm._s(_vm.parkInfo.feeMoney)+"元")])])],1):_vm._e(),_vm._v(" "),(_vm.parkInfo.payStatus == "1")?_c('alert',{staticClass:"mDailog",attrs:{"title":"订单详情"},model:{value:(_vm.carShow),callback:function ($$v) {_vm.carShow=$$v},expression:"carShow"}},[_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_centers"},[_vm._v("订单编号："+_vm._s(_vm.parkInfo.billCode))])],1),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_centers",attrs:{"span":5/8}},[_vm._v("车位编号："+_vm._s(_vm.parkInfo.pkId))]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_centers",attrs:{"span":3/8}},[_vm._v("购买量："+_vm._s(_vm.parkInfo.feeCount)+"个月")])],1),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_centers",attrs:{"span":5/8}},[_vm._v("到期时间："+_vm._s(_vm.parkInfo.endDate))]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_centers",attrs:{"span":3/8}},[_vm._v("月费用："+_vm._s(_vm.parkInfo.feePrice)+"元")])],1),_vm._v(" "),_c('h5',{staticStyle:{"line-height":"1.2","font-size":"0.9em","text-align":"right","color":"red","padding":"10px 10px 0 0"}},[_vm._v("费用总计 ： "),_c('span',{staticStyle:{"text-indent":"20px"}},[_vm._v(_vm._s(_vm.parkInfo.feeMoney)+"元")])])],1):_vm._e(),_vm._v(" "),_c('confirm',{attrs:{"title":"订单详情","confirm-text":"去支付","cancel-text":"取消订单"},on:{"on-confirm":function($event){_vm.gopay('wuye')},"on-cancel":_vm.cancelpay},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('p',{staticStyle:{"color":"black","font-size":"0.9em","line-height":"1.2","text-align":"left"}},[_vm._v("订单号："+_vm._s(_vm.billCode))]),_vm._v(" "),_c('p',{staticStyle:{"color":"black","font-size":"0.9em","line-height":"1.2","text-align":"right","padding-top":"10px"}},[_vm._v(_vm._s(_vm.createDate))]),_vm._v(" "),_vm._l((_vm.detailData),function(item,index){return _c('div',{staticStyle:{"border-bottom":"1px solid #ddd","margin":"1px -5px","line-height":"1.4","padding":"4px 0"}},[_c('flexbox',[_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"color":"black","font-size":"0.9em"}},[_vm._v(_vm._s(item.feeTypeName))])]),_vm._v(" "),_c('flexbox-item',[_c('p',{staticStyle:{"font-size":"0.8em"}},[_vm._v(_vm._s(item.start)+"~"+_vm._s(item.end))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"text-align":"right","color":"orange","font-size":"0.9em"}},[_vm._v(_vm._s(item.yingshou)+"元")])])],1),_vm._v(" "),(item.youhui)?_c('flexbox',[_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-indent":"2em","color":"green","font-size":"0.6em"}},[_vm._v("优惠")])]),_vm._v(" "),_c('flexbox-item',[_c('p')]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-align":"right","color":"green","font-size":"0.6em"}},[_vm._v("-"+_vm._s(item.youhui)+"元")])])],1):_vm._e(),_vm._v(" "),(item.feeLate&&item.feeLate!='0.00')?_c('flexbox',[_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-indent":"2em","color":"red","font-size":"0.6em"}},[_vm._v("违约金")])]),_vm._v(" "),_c('flexbox-item',[_c('p')]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-align":"right","color":"red","font-size":"0.6em"}},[_vm._v("+"+_vm._s(item.feeLate)+"元")])])],1):_vm._e()],1)}),_vm._v(" "),_c('h5',{staticStyle:{"line-height":"1.2","font-size":"0.9em","text-align":"right","color":"red","padding-top":"10px"}},[_vm._v("费用总计 ： "),_c('span',{staticStyle:{"text-indent":"20px"}},[_vm._v(_vm._s(_vm.totalFee)+"元")])])],2),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},on:{"on-hide":_vm.refresh},model:{value:(_vm.showprompt),callback:function ($$v) {_vm.showprompt=$$v},expression:"showprompt"}},[_vm._v(_vm._s(_vm.prompt))])],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"订单详情"},model:{value:(_vm.showDetail),callback:function ($$v) {_vm.showDetail=$$v},expression:"showDetail"}},[_c('p',{staticStyle:{"color":"black","font-size":"0.9em","line-height":"1.2","text-align":"left"}},[_vm._v("订单号："+_vm._s(_vm.billCode))]),_vm._v(" "),_c('p',{staticStyle:{"color":"black","font-size":"0.9em","line-height":"1.2","text-align":"right","padding-top":"10px"}},[_vm._v(_vm._s(_vm.createDate))]),_vm._v(" "),_vm._l((_vm.detailSuccess),function(item,index){return _c('div',{staticStyle:{"border-bottom":"1px solid #ddd","margin":"5px 0px 0","line-height":"1.4","padding":"4px 0"}},[_c('flexbox',[_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"color":"black","font-size":"0.9em"}},[_vm._v(_vm._s(item.feeTypeName))])]),_vm._v(" "),_c('flexbox-item',[_c('p',{staticStyle:{"font-size":"0.8em"}},[_vm._v(_vm._s(item.start)+"~"+_vm._s(item.end))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"text-align":"right","color":"orange","font-size":"0.9em"}},[_vm._v(_vm._s(item.yingshou)+"元")])])],1),_vm._v(" "),(item.youhui)?_c('flexbox',[_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-indent":"2em","color":"red","font-size":"0.6em"}},[_vm._v("优惠")])]),_vm._v(" "),_c('flexbox-item',[_c('p')]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-align":"right","color":"green","font-size":"0.6em"}},[_vm._v("-"+_vm._s(item.youhui)+"元")])])],1):_vm._e(),_vm._v(" "),(item.feeLate&&item.feeLate!='0.00')?_c('flexbox',[_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-indent":"2em","color":"red","font-size":"0.6em"}},[_vm._v("违约金")])]),_vm._v(" "),_c('flexbox-item',[_c('p')]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-align":"right","color":"red","font-size":"0.6em"}},[_vm._v("+"+_vm._s(item.feeLate)+"元")])])],1):_vm._e()],1)}),_vm._v(" "),_c('h5',{staticStyle:{"line-height":"1.2","font-size":"0.9em","text-align":"right","color":"red","padding-top":"10px"}},[_vm._v("费用总计 ： "),_c('span',{staticStyle:{"text-indent":"20px"}},[_vm._v(_vm._s(_vm.totalFee)+"元")])])],2)],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"订单详情"},model:{value:(_vm.showWaterDetail),callback:function ($$v) {_vm.showWaterDetail=$$v},expression:"showWaterDetail"}},[_c('p',{staticStyle:{"color":"black","font-size":"0.9em","line-height":"1.2","text-align":"left"}},[_vm._v("订单号："+_vm._s(_vm.billCode))]),_vm._v(" "),_c('p',{staticStyle:{"color":"black","font-size":"0.9em","line-height":"1.2","text-align":"right","padding-top":"10px"}},[_vm._v(_vm._s(_vm.createDate))]),_vm._v(" "),_vm._l((_vm.detailSuccess),function(item,index){return _c('div',{staticStyle:{"border-bottom":"1px solid #ddd","margin":"5px 0px 0","line-height":"1.4","padding":"4px 0"}},[_c('flexbox',[_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"color":"black","font-size":"0.9em"}},[_vm._v(_vm._s(item.feeName))])]),_vm._v(" "),(item.feeName == '电费')?_c('flexbox-item',[_c('p',{staticStyle:{"font-size":"0.8em"}},[_vm._v(_vm._s(item.feePrice)+"元/度")])]):_vm._e(),_vm._v(" "),(item.feeName == '水费')?_c('flexbox-item',[_c('p',{staticStyle:{"font-size":"0.8em"}},[_vm._v(_vm._s(item.feePrice)+"元/吨")])]):_vm._e(),_vm._v(" "),(item.feeName == '电费')?_c('flexbox-item',[_c('p',{staticStyle:{"font-size":"0.8em"}},[_vm._v(_vm._s(item.feeCount)+"度")])]):_vm._e(),_vm._v(" "),(item.feeName == '水费')?_c('flexbox-item',[_c('p',{staticStyle:{"font-size":"0.8em"}},[_vm._v(_vm._s(item.feeCount)+"吨")])]):_vm._e(),_vm._v(" "),_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"text-align":"right","color":"orange","font-size":"0.9em"}},[_vm._v(_vm._s(item.realMoney)+"元")])])],1),_vm._v(" "),(item.youhui)?_c('flexbox',[_c('flexbox-item',{attrs:{"span":4}}),_vm._v(" "),_c('flexbox-item',[_c('p')]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":6}},[_c('p',{staticStyle:{"text-align":"right","color":"red","font-size":"0.9em"}},[_c('span',{staticStyle:{"padding-right":"10px"}},[_vm._v("优惠")]),_vm._v(_vm._s(item.youhui)+"元")])])],1):_vm._e()],1)}),_vm._v(" "),_c('h5',{staticStyle:{"line-height":"1.2","font-size":"0.9em","text-align":"right","color":"red","padding-top":"10px"}},[_vm._v("费用总计 ： "),_c('span',{staticStyle:{"text-indent":"20px"}},[_vm._v(_vm._s(_vm.totalFee)+"元")])])],2)],1),_vm._v(" "),_c('confirm',{attrs:{"title":"订单详情","confirm-text":"去支付","cancel-text":"取消订单"},on:{"on-confirm":function($event){_vm.gopay('water')},"on-cancel":_vm.cancelpay},model:{value:(_vm.showWaterUnpay),callback:function ($$v) {_vm.showWaterUnpay=$$v},expression:"showWaterUnpay"}},[_c('p',{staticStyle:{"color":"black","font-size":"0.9em","line-height":"1.2","text-align":"left"}},[_vm._v("订单号："+_vm._s(_vm.billCode))]),_vm._v(" "),_c('p',{staticStyle:{"color":"black","font-size":"0.9em","line-height":"1.2","text-align":"right","padding-top":"10px"}},[_vm._v(_vm._s(_vm.createDate))]),_vm._v(" "),_vm._l((_vm.detailData),function(item,index){return _c('div',{staticStyle:{"border-bottom":"1px solid #ddd","margin":"1px -5px","line-height":"1.4","padding":"4px 0"}},[_c('flexbox',[_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"color":"black","font-size":"0.9em"}},[_vm._v(_vm._s(item.feeName))])]),_vm._v(" "),(item.feeName == '电费')?_c('flexbox-item',[_c('p',{staticStyle:{"font-size":"0.8em"}},[_vm._v(_vm._s(item.feePrice)+"元/度")])]):_vm._e(),_vm._v(" "),(item.feeName == '水费')?_c('flexbox-item',[_c('p',{staticStyle:{"font-size":"0.8em"}},[_vm._v(_vm._s(item.feePrice)+"元/吨")])]):_vm._e(),_vm._v(" "),(item.feeName == '电费')?_c('flexbox-item',[_c('p',{staticStyle:{"font-size":"0.8em"}},[_vm._v(_vm._s(item.feeCount)+"度")])]):_vm._e(),_vm._v(" "),(item.feeName == '水费')?_c('flexbox-item',[_c('p',{staticStyle:{"font-size":"0.8em"}},[_vm._v(_vm._s(item.feeCount)+"吨")])]):_vm._e(),_vm._v(" "),_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"text-align":"right","color":"orange","font-size":"0.9em"}},[_vm._v(_vm._s(item.realMoney)+"元")])])],1),_vm._v(" "),(item.youhui)?_c('flexbox',[_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-indent":"2em","color":"green","font-size":"0.6em"}},[_vm._v("优惠")])]),_vm._v(" "),_c('flexbox-item',[_c('p')]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"text-align":"right","color":"green","font-size":"0.6em"}},[_vm._v("-"+_vm._s(item.youhui)+"元")])])],1):_vm._e(),_vm._v(" "),(item.feeLate&&item.feeLate!='0.00')?_c('flexbox',[_c('flexbox-item',{attrs:{"span":4}},[_c('p',{staticStyle:{"text-indent":"2em","color":"red","font-size":"0.6em"}},[_vm._v("违约金")])]),_vm._v(" "),_c('flexbox-item',[_c('p')]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":3}},[_c('p',{staticStyle:{"text-align":"right","color":"red","font-size":"0.6em"}},[_vm._v("+"+_vm._s(item.feeLate)+"元")])])],1):_vm._e()],1)}),_vm._v(" "),_c('h5',{staticStyle:{"line-height":"1.2","font-size":"0.9em","text-align":"right","color":"red","padding-top":"10px"}},[_vm._v("费用总计 ： "),_c('span',{staticStyle:{"text-indent":"20px"}},[_vm._v(_vm._s(_vm.totalFee)+"元")])])],2),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var paymentRecord_staticRenderFns = []
var paymentRecord_esExports = { render: paymentRecord_render, staticRenderFns: paymentRecord_staticRenderFns }
/* harmony default export */ var components_payComponents_paymentRecord = (paymentRecord_esExports);
// CONCATENATED MODULE: ./src/components/payComponents/paymentRecord.vue
function paymentRecord_injectStyle (ssrContext) {
  __webpack_require__("C5Jt")
}
var paymentRecord_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var paymentRecord___vue_template_functional__ = false
/* styles */
var paymentRecord___vue_styles__ = paymentRecord_injectStyle
/* scopeId */
var paymentRecord___vue_scopeId__ = "data-v-74689b4c"
/* moduleIdentifier (server only) */
var paymentRecord___vue_module_identifier__ = null
var paymentRecord_Component = paymentRecord_normalizeComponent(
  payComponents_paymentRecord,
  components_payComponents_paymentRecord,
  paymentRecord___vue_template_functional__,
  paymentRecord___vue_styles__,
  paymentRecord___vue_scopeId__,
  paymentRecord___vue_module_identifier__
)

/* harmony default export */ var src_components_payComponents_paymentRecord = (paymentRecord_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userComponents/changeHouse.vue













/* harmony default export */ var changeHouse = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Icon: icon["a" /* default */],
    XButton: vux_src_components_x_button,
    Alert: components_alert["a" /* default */],
    Group: group["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage
  }, directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    this.width = window.screen.width - 10;
    /*正式环境*/

    /*测试环境*/
    var url = global.host + 'clientHouse/getClientHouseByUser?phone=' + this.$router.history.current.query.phone;
    this.$http.get(url).then(function (res) {
      console.log(res);
      if (res.body.result) {
        var data = res.body.result;
        for (var i = 0; i < data.length; i++) {
          this.list.push(data[i]);
        }
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },
  data: function data() {
    return defineProperty_default()({
      list: [],
      currentIndex: 0,
      width: '',
      alertTitle: '温馨提示',
      alertContent: '',
      showAlert: false,
      showconfirm: false
    }, 'currentIndex', '');
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/changeHouse") {
      document.title = "我的房产";
    }
  },

  methods: {
    /*用户切换房屋后更新数据重新渲染数据*/
    onHide: function onHide() {
      this.showAlert = false;
      this.resetData();
    },
    confirmCancel: function confirmCancel(index) {
      this.showconfirm = true;
      this.currentIndex = index;
    },

    /*房屋解绑*/
    houseUnbind: function houseUnbind() {
      var data = this.list[this.currentIndex];
      var url = global.host + "users/Unbind?id=" + data.id + "&phone=" + this.$router.history.current.query.phone;
      this.$http.delete(url).then(function (res) {
        console.log(res);
        if (res.body.success == true) {
          this.alertContent = '房屋解绑成功';
          this.showAlert = true;
        } else {
          if (res.body.statusCode == 120) {
            this.alertContent = '房屋解绑异常';
            this.showAlert = true;
          } else {
            this.alertContent = '房屋解绑成功';
            this.showAlert = true;
          }
        }
      }, function (err) {
        console.log(err);
      });
    },
    addHouse: function addHouse() {
      this.$router.push({ path: '/houseBind', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, IsDefault: 0 } });
    },
    submitChange: function submitChange(index) {
      this.currentIndex = index;
      /*修改数据所有的为0 要修改的为1*/
      for (var i = 0; i < this.list.length; i++) {
        this.list[i].isDefault = 0;
      }
      this.list[this.currentIndex].isDefault = 1;
      var url = global.host + 'clientHouse/updateClientHouseStatus';
      this.$http.post(url, this.list).then(function (res) {
        if (res.body.success) {
          this.resetData();
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*用户切换房屋后更新数据*/
    resetData: function resetData() {
      var url = global.host + 'clientHouse/getClientHouseByUser?phone=' + this.$router.history.current.query.phone;
      this.$http.get(url).then(function (res) {
        var size = this.list.length;
        for (var i = 0; i < size; i++) {
          this.list.pop();
        }
        if (res.body.result) {
          var data = res.body.result;
          for (var _i = 0; _i < data.length; _i++) {
            this.list.push(data[_i]);
          }
        }
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userComponents/changeHouse.vue













/* harmony default export */ var userComponents_changeHouse = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Icon: icon["a" /* default */],
    XButton: vux_src_components_x_button,
    Alert: components_alert["a" /* default */],
    Group: group["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage
  }, directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    this.width = window.screen.width - 10;
    /*正式环境*/

    /*测试环境*/
    var url = global.host + 'clientHouse/getClientHouseByUser?phone=' + this.$router.history.current.query.phone;
    this.$http.get(url).then(function (res) {
      console.log(res);
      if (res.body.result) {
        var data = res.body.result;
        for (var i = 0; i < data.length; i++) {
          this.list.push(data[i]);
        }
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },
  data: function data() {
    return defineProperty_default()({
      list: [],
      currentIndex: 0,
      width: '',
      alertTitle: '温馨提示',
      alertContent: '',
      showAlert: false,
      showconfirm: false
    }, 'currentIndex', '');
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/changeHouse") {
      document.title = "我的房产";
    }
  },

  methods: {
    /*用户切换房屋后更新数据重新渲染数据*/
    onHide: function onHide() {
      this.showAlert = false;
      this.resetData();
    },
    confirmCancel: function confirmCancel(index) {
      this.showconfirm = true;
      this.currentIndex = index;
    },

    /*房屋解绑*/
    houseUnbind: function houseUnbind() {
      var data = this.list[this.currentIndex];
      var url = global.host + "users/Unbind?id=" + data.id + "&phone=" + this.$router.history.current.query.phone;
      this.$http.delete(url).then(function (res) {
        console.log(res);
        if (res.body.success == true) {
          this.alertContent = '房屋解绑成功';
          this.showAlert = true;
        } else {
          if (res.body.statusCode == 120) {
            this.alertContent = '房屋解绑异常';
            this.showAlert = true;
          } else {
            this.alertContent = '房屋解绑成功';
            this.showAlert = true;
          }
        }
      }, function (err) {
        console.log(err);
      });
    },
    addHouse: function addHouse() {
      this.$router.push({ path: '/houseBind', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, IsDefault: 0 } });
    },
    submitChange: function submitChange(index) {
      this.currentIndex = index;
      /*修改数据所有的为0 要修改的为1*/
      for (var i = 0; i < this.list.length; i++) {
        this.list[i].isDefault = 0;
      }
      this.list[this.currentIndex].isDefault = 1;
      var url = global.host + 'clientHouse/updateClientHouseStatus';
      this.$http.post(url, this.list).then(function (res) {
        if (res.body.success) {
          this.resetData();
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*用户切换房屋后更新数据*/
    resetData: function resetData() {
      var url = global.host + 'clientHouse/getClientHouseByUser?phone=' + this.$router.history.current.query.phone;
      this.$http.get(url).then(function (res) {
        var size = this.list.length;
        for (var i = 0; i < size; i++) {
          this.list.pop();
        }
        if (res.body.result) {
          var data = res.body.result;
          for (var _i = 0; _i < data.length; _i++) {
            this.list.push(data[_i]);
          }
        }
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-437a1d52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userComponents/changeHouse.vue
var changeHouse_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticStyle:{"overflow":"hidden"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"item",style:({width:_vm.width + 95 +'px'})},[_c('div',{staticClass:"info",style:({width:_vm.width+'px',backgroundColor: item.isDefault == 1 ? '#e9edd4' : ''})},[_vm._m(0,true),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","width":"70%"}},[_c('h4',{staticClass:"community"},[_vm._v(_vm._s(item.comnName))]),_vm._v(" "),_c('h4',{staticClass:"houseNum"},[_vm._v(_vm._s(item.houseNo)+"\n                                "),_c('span',[(item.isDefault == 1)?_c('span',{on:{"click":function($event){_vm.submitChange(index)}}},[_c('i',{staticClass:"iconfont icon-xuanze",staticStyle:{"color":"#fb0808"}}),_vm._v(" 默认房产")]):_c('span',{on:{"click":function($event){_vm.submitChange(index)}}},[_c('i',{staticClass:"iconfont icon-xuanzekuang"}),_vm._v(" 设为默认")])])])])]),_vm._v(" "),_c('div',{staticClass:"delete",on:{"click":function($event){_vm.confirmCancel(index)}}},[_vm._v("删除")])])])])}),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.addHouse($event)}}},[_vm._v(" 添加房产")]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('alert',{attrs:{"title":_vm.alertTitle,"content":_vm.alertContent},on:{"on-hide":_vm.onHide},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}}),_vm._v(" "),_c('confirm',{attrs:{"title":_vm.alertTitle,"content":"您确定要解除绑定"},on:{"on-confirm":_vm.houseUnbind},model:{value:(_vm.showconfirm),callback:function ($$v) {_vm.showconfirm=$$v},expression:"showconfirm"}})],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],2)}
var changeHouse_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block","width":"25%"}},[_c('h4',{staticClass:"community"},[_vm._v("小区名称:")]),_vm._v(" "),_c('h4',{staticClass:"houseNum"},[_vm._v("房       号: ")])])}]
var changeHouse_esExports = { render: changeHouse_render, staticRenderFns: changeHouse_staticRenderFns }
/* harmony default export */ var components_userComponents_changeHouse = (changeHouse_esExports);
// CONCATENATED MODULE: ./src/components/userComponents/changeHouse.vue
function changeHouse_injectStyle (ssrContext) {
  __webpack_require__("l+GJ")
}
var changeHouse_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var changeHouse___vue_template_functional__ = false
/* styles */
var changeHouse___vue_styles__ = changeHouse_injectStyle
/* scopeId */
var changeHouse___vue_scopeId__ = "data-v-437a1d52"
/* moduleIdentifier (server only) */
var changeHouse___vue_module_identifier__ = null
var changeHouse_Component = changeHouse_normalizeComponent(
  userComponents_changeHouse,
  components_userComponents_changeHouse,
  changeHouse___vue_template_functional__,
  changeHouse___vue_styles__,
  changeHouse___vue_scopeId__,
  changeHouse___vue_module_identifier__
)

/* harmony default export */ var src_components_userComponents_changeHouse = (changeHouse_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userComponents/userInfo.vue









/* harmony default export */ var userInfo = ({
  components: {
    XHeader: vux_src_components_x_header,
    Group: group["a" /* default */],
    Cell: cell["a" /* default */],
    XImg: vux_src_components_x_img,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      bindphone: '',
      username: '',
      type: '',
      houseowner: '',
      houseName: '',
      distrctName: '',
      portrait: '',
      phones: '',
      openids: ''
    };
  },
  beforeMount: function beforeMount() {
    this.phones = this.$router.history.current.query.phone;
    this.openids = this.$router.history.current.query.openid;
    this.show_1 = true;
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      if (res.body.result) {
        console.log(res);
        var data = res.body.result[0];
        var phone = data.mainPhone;
        this.bindphone = phone.substring(0, 3) + '****' + phone.substring(7, 11);
        this.portrait = data.photoUrl;
        this.username = data.name;
        this.type = data.type;
        this.houseName = data.hsNo;
        this.distrctName = data.comName;
        this.houseowner = data.hsName;
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userComponents/userInfo.vue









/* harmony default export */ var userComponents_userInfo = ({
  components: {
    XHeader: vux_src_components_x_header,
    Group: group["a" /* default */],
    Cell: cell["a" /* default */],
    XImg: vux_src_components_x_img,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      bindphone: '',
      username: '',
      type: '',
      houseowner: '',
      houseName: '',
      distrctName: '',
      portrait: '',
      phones: '',
      openids: ''
    };
  },
  beforeMount: function beforeMount() {
    this.phones = this.$router.history.current.query.phone;
    this.openids = this.$router.history.current.query.openid;
    this.show_1 = true;
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      if (res.body.result) {
        console.log(res);
        var data = res.body.result[0];
        var phone = data.mainPhone;
        this.bindphone = phone.substring(0, 3) + '****' + phone.substring(7, 11);
        this.portrait = data.photoUrl;
        this.username = data.name;
        this.type = data.type;
        this.houseName = data.hsNo;
        this.distrctName = data.comName;
        this.houseowner = data.hsName;
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44755020","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userComponents/userInfo.vue
var userInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('h4',{staticStyle:{"line-height":"70px","padding":"0 15px"}},[_c('i',{staticClass:"iconfont icon-gerenzhongxin"}),_vm._v(" 我的头像"),_c('span',{staticStyle:{"float":"right","margin-right":"15px","width":"50px","height":"50px","border-radius":"50%","margin":"10px 0","overflow":"hidden"}},[_c('x-img',{attrs:{"src":_vm.portrait}})],1)])]),_vm._v(" "),_c('group',[_c('div',{staticStyle:{"line-height":"45px","height":"45px","padding":"0 15px"}},[_c('span',{staticClass:"left"},[_c('i',{staticClass:"iconfont icon-dashaxiaoqudizhi01"}),_vm._v(" 小区名称")]),_vm._v(" "),_c('span',{staticClass:"right"},[_vm._v(_vm._s(_vm.distrctName))]),_vm._v(" "),_c('div',{staticClass:"clear"})])]),_vm._v(" "),_c('group',[_c('div',{staticStyle:{"line-height":"45px","height":"45px","padding":"0 15px"}},[_c('span',{staticClass:"left"},[_c('i',{staticClass:"iconfont icon-fangjian"}),_vm._v(" 房号")]),_vm._v(" "),_c('span',{staticClass:"right"},[_vm._v(_vm._s(_vm.houseName))]),_vm._v(" "),_c('div',{staticClass:"clear"})])]),_vm._v(" "),_c('group',[_c('div',{staticStyle:{"line-height":"45px","height":"45px","padding":"0 15px"}},[_c('span',{staticClass:"left"},[_c('i',{staticClass:"iconfont icon-yezhu"}),_vm._v(" 业主姓名")]),_vm._v(" "),_c('span',{staticClass:"right"},[_vm._v(_vm._s(_vm.houseowner))]),_vm._v(" "),_c('div',{staticClass:"clear"})])]),_vm._v(" "),_c('group',[_c('div',{staticStyle:{"line-height":"45px","height":"45px","padding":"0 15px"}},[_c('span',{staticClass:"left"},[_c('i',{staticClass:"iconfont icon-11guanxi"}),_vm._v(" 与业主关系")]),_vm._v(" "),_c('span',{staticClass:"right am_icflex"},[_c('strong',[_vm._v(_vm._s(_vm.type))])]),_vm._v(" "),_c('div',{staticClass:"clear"})])]),_vm._v(" "),_c('group',[_c('div',{staticStyle:{"line-height":"45px","height":"45px","padding":"0 15px"}},[_c('span',{staticClass:"left"},[_c('i',{staticClass:"iconfont icon-xingming"}),_vm._v(" 绑定人姓名")]),_vm._v(" "),_c('span',{staticClass:"right am_icflex"},[_c('strong',[_vm._v(_vm._s(_vm.username))])]),_vm._v(" "),_c('div',{staticClass:"clear"})])]),_vm._v(" "),_c('group',[_c('div',{staticStyle:{"line-height":"45px","height":"45px","padding":"0 15px"}},[_c('span',{staticClass:"left"},[_c('i',{staticClass:"iconfont icon-shouji-copy"}),_vm._v(" 绑定手机号")]),_vm._v(" "),_c('span',{staticClass:"right"},[_vm._v(_vm._s(_vm.bindphone))]),_vm._v(" "),_c('div',{staticClass:"clear"})])]),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var userInfo_staticRenderFns = []
var userInfo_esExports = { render: userInfo_render, staticRenderFns: userInfo_staticRenderFns }
/* harmony default export */ var components_userComponents_userInfo = (userInfo_esExports);
// CONCATENATED MODULE: ./src/components/userComponents/userInfo.vue
function userInfo_injectStyle (ssrContext) {
  __webpack_require__("+3tv")
}
var userInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var userInfo___vue_template_functional__ = false
/* styles */
var userInfo___vue_styles__ = userInfo_injectStyle
/* scopeId */
var userInfo___vue_scopeId__ = "data-v-44755020"
/* moduleIdentifier (server only) */
var userInfo___vue_module_identifier__ = null
var userInfo_Component = userInfo_normalizeComponent(
  userComponents_userInfo,
  components_userComponents_userInfo,
  userInfo___vue_template_functional__,
  userInfo___vue_styles__,
  userInfo___vue_scopeId__,
  userInfo___vue_module_identifier__
)

/* harmony default export */ var src_components_userComponents_userInfo = (userInfo_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/module.js + 2 modules
var alert_module = __webpack_require__("+zLN");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userComponents/houseBind.vue
















/* harmony default export */ var houseBind = ({
  components: {
    XHeader: vux_src_components_x_header,
    Group: group["a" /* default */],
    PopupRadio: vux_src_components_popup_radio,
    XInput: x_input["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    Cell: cell["a" /* default */],
    XButton: vux_src_components_x_button,
    PopupPicker: popup_picker["a" /* default */],
    Alert: components_alert["a" /* default */],
    loadPage: src_components_loadingPage,
    $: jquery_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      districtlist: [[]],
      districtlistid: [],
      district: [' '],
      houselist: [[], [], []],
      houselistn: [],
      houselistid: [],
      house: [' ', ' ', ' '],
      buildid: [],
      relation: ['本人'],
      relationlist: [[]],
      relationlistid: [],
      owner: '',
      messageWarn: '',
      username: '',
      phone: '',
      houseBind: '',
      alertTitle: '',
      alertContent: '',
      showAlert: false,
      readonlyable: true,
      buildList: []
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    /*获取所有小区*/
    this.$http.get(global.host + 'community/getList').then(function (res) {
      if (res.body) {
        var datacommunity = res.body.result;
        var list = [];var listid = [];
        for (var i = 0; i < datacommunity.length; i++) {
          this.districtlist[0].push(datacommunity[i].comnName);
          this.districtlistid.push(datacommunity[i].comnCode);
        }
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    }),
    /*获取与业主的关系*/
    this.$http.get(global.host + '/dict/getDiceByTypeEqHousereLation').then(function (res) {
      if (res.body.result) {
        var data = res.body.result;
        for (var i = 0; i < data.length; i++) {
          this.relationlist[0].push(data[i].label);
          this.relationlistid.push(data[i].id);
        }
      }
    }, function (err) {
      console.log(err);
    });
  },
  mounted: function mounted() {
    var mobile = this.$router.history.current.query.phone;
    this.phone = mobile.substring(0, 3) + '****' + mobile.substring(7, 11);
    if (this.$router.history.current.path == "/houseBind") {
      document.title = "业主认证";
    }
  },

  methods: {
    onHide: function onHide() {
      this.showAlert = false;
      if (this.alertContent == '房屋绑定成功') {
        if (this.$router.history.current.query.muId == 3) {
          this.$router.push({ path: '/pay/tenement', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
        } else if (this.$router.history.current.query.muId == 4) {
          this.$router.push({ path: '/', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
        } else {
          this.$router.push({ path: '/user', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
        }
      }
    },
    beforXy: function beforXy(mrquerUrl) {

      var objectInfo = new Object();
      objectInfo.comnCode = this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])];
      objectInfo.hsNo = this.house[2];
      objectInfo.hsName = this.owner;
      objectInfo.phoneModel = navigator.userAgent;
      objectInfo.requestUrl = mrquerUrl;

      var newUrl = global.host + 'sys/addSystemLog';
      this.$http.post(newUrl, objectInfo).then(function (res) {
        console.log(res.body.result);
      }, function (err) {
        console.log(err);
      });
    },

    /*房间绑定验证*/
    bindHouse: function bindHouse() {

      this.owner = this.owner.replace(/(^\s*)|(\s*$)/g, "");
      this.$http.get(global.host + '/users/checkUserIsExistByUtil?comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0], this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' + this.house[2] + '&userName=' + encodeURIComponent(this.owner)).then(function (res) {
        if (res.body.success) {
          /*改变样式 存在*/
          this.houseBind = true;
          this.bindHouseSubmit();
        } else {
          /*改变样式 不存在*/
          this.alertTitle = '温馨提示';
          this.alertContent = '请输入物业登记的业主姓名';
          this.houseBind = false;
          this.showAlert = true;
          setTimeout(function () {
            this.showAlert = false;
          }, 2000);
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*房间绑定提交*/
    bindHouseSubmit: function bindHouseSubmit() {
      var regRule = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
      if (this.district[0] == ' ' || !this.district[0]) {
        this.messageWarn = '温馨提示：请选择小区';
      } else if ((!this.house[0] || this.house[0] == ' ') && (!this.house[1] || this.house[1] == ' ') && (!this.house[2] || this.house[2] == ' ')) {
        this.messageWarn = '温馨提示：请选择房间';
      } else if (!this.owner) {
        this.messageWarn = '温馨提示：请输入业主姓名';
      } else if (this.owner.match(regRule)) {
        this.messageWarn = '温馨提示：业主姓名不能输入特殊符号';
      } else if (!this.username) {
        this.messageWarn = '温馨提示：请输入您的真实姓名';
      } else if (!this.houseBind) {
        console.log("xxxxxxxxxxxxxxxxxx" + this.houseBind);
        this.messageWarn = '温馨提示：房屋与业主不匹配';
      } else if (!this.relation[0]) {
        this.messageWarn = '温馨提示：请选择与业主的关系';
      } else {

        this.beforXy("#绑定房间信息#users/register/" + this.$router.history.current.query.openid + '/' + this.$router.history.current.query.phone + '/' + this.house[2] + '/' + this.username + '/' + this.$router.history.current.query.phone + '/' + this.relationlistid[this.getIndex(this.relationlist[0], this.relation[0])] + '/' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '/' + this.$router.history.current.query.IsDefault);
        this.username = this.username.replace(/(^\s*)|(\s*$)/g, "");
        console.log(global.host + 'users/register?openid=' + this.$router.history.current.query.openid + '&phone=' + this.$router.history.current.query.phone + '&roomNumber=' + this.house[2] + '&registrantName=' + this.username + '&phoneNumber=' + this.$router.history.current.query.phone + '&relationShip=' + this.relationlistid[this.getIndex(this.relationlist[0], this.relation[0])] + '&comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '&IsDefault=' + this.$router.history.current.query.IsDefault);
        this.$http.get(global.host + 'users/register?openid=' + this.$router.history.current.query.openid + '&phone=' + this.$router.history.current.query.phone + '&roomNumber=' + this.house[2] + '&registrantName=' + this.username + '&phoneNumber=' + this.$router.history.current.query.phone + '&relationShip=' + this.relationlistid[this.getIndex(this.relationlist[0], this.relation[0])] + '&comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '&IsDefault=' + this.$router.history.current.query.IsDefault).then(function (res) {
          console.log(res);
          if (res.body.result == 'success') {
            this.alertTitle = '恭喜';
            this.alertContent = '房屋绑定成功';
            this.showAlert = true;
          } else {
            this.alertTitle = '抱歉';
            this.alertContent = res.body.message;
            this.showAlert = true;
          }
        }, function (err) {
          console.log(err);
        });
      }
    },

    /*房间检测*/
    updateVal: function updateVal() {
      this.houseBind = false;
    },
    checkBind: function checkBind() {
      this.houseBind = false;
      if (!this.district[0]) {
        this.messageWarn = '请选择小区';
      } else if (!this.house[0] && !this.house[1] && !this.house[2]) {
        this.messageWarn = '请选择房间';
      } else if (!this.owner) {
        this.messageWarn = '请输入业主姓名';
      } else {

        this.beforXy("#验证业主是否匹配#users/checkUserIsExistByUtil?comnCode=" + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0], this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' + this.house[2] + '&userName=' + encodeURIComponent(this.owner));
        this.owner = this.owner.replace(/(^\s*)|(\s*$)/g, "");
        this.$http.get(global.host + '/users/checkUserIsExistByUtil?comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0], this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' + this.house[2] + '&userName=' + encodeURIComponent(this.owner)).then(function (res) {
          if (res.body.success) {
            /*改变样式 存在*/
            this.houseBind = true;
          } else {
            /*改变样式 不存在*/
            this.alertTitle = '温馨提示';
            this.alertContent = '请输入物业登记的业主姓名';
            this.houseBind = false;
            this.showAlert = true;
            setTimeout(function () {
              this.showAlert = false;
            }, 2000);
          }
        }, function (err) {
          console.log(err);
        });
      }
    },

    /*选择小区获取楼的数据*/
    selectComnBuildList: function selectComnBuildList(value) {
      console.log("######################");
      this.houselist = [];
      this.buildid = [];
      this.houselistid = [];
      this.buildList = [];
      /*获取小区中的楼号信息*/
      this.$http.get(global.host + 'building/getList?comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], value[0])]).then(function (resbuild) {
        if (resbuild.body.result) {
          var arr1 = [];
          var databuild = resbuild.body.result;
          this.buildList = resbuild.body.result;

          for (var j = 0; j < databuild.length; j++) {
            arr1.push(databuild[j].buildName + (databuild[j].unitName ? databuild[j].unitName : ''));
            if (databuild[j].unitid) {
              this.houselistid.push(databuild[j].buildid);
              this.buildid.push(databuild[j].unitid);
            } else {
              this.houselistid.push(databuild[j].buildid);
            }
          }

          this.houselist.push(arr1);
          var arr2 = [];
          console.log(databuild[0].height);
          for (var i = 0; i < databuild[0].height.length; i++) {
            arr2.push(databuild[0].height[i]);
          }
          this.houselist.push(arr2);
          /*获取房间的信息*/
          this.$http.get(global.host + 'house/getList?comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], value[0])] + '&buildCode=' + this.houselistid[0] + '&fool=1F' + '&unit=' + (this.buildid[0] ? this.buildid[0] : '')).then(function (reshouse) {
            if (reshouse.body.result) {
              var datahouse = reshouse.body.result;
              var arr3 = [];
              for (var k = 0; k < datahouse.length; k++) {
                arr3.push(datahouse[k].hsNo);
              }
              this.houselist.push(arr3);
            }
          }, function (errhouse) {
            console.log(errhouse);
          });
        }
      }, function (errbuild) {
        console.log(errbuild);
      });
    },


    /*选择小区*/
    selectDistrict: function selectDistrict() {
      this.houselist = [];
      this.buildid = [];
      this.houselistid = [];
      /*获取小区中的楼号信息*/
      this.$http.get(global.host + 'building/getList?comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])]).then(function (resbuild) {
        if (resbuild.body.result) {
          var arr1 = [];
          var databuild = resbuild.body.result;
          this.buildList = resbuild.body.result;
          for (var j = 0; j < databuild.length; j++) {
            arr1.push(databuild[j].buildName + (databuild[j].unitName ? databuild[j].unitName : ''));
            if (databuild[j].unitid) {
              this.houselistid.push(databuild[j].buildid);
              this.buildid.push(databuild[j].unitid);
            } else {
              this.houselistid.push(databuild[j].buildid);
            }
          }
          this.houselist.push(arr1);
          var arr2 = [];
          for (var i = 0; i < databuild[0].height.length; i++) {
            arr2.push(databuild[0].height[i]);
          }
          this.houselist.push(arr2);
          /*获取房间的信息*/
          this.$http.get(global.host + 'house/getList?comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '&buildCode=' + this.houselistid[0] + '&fool=1F' + '&unit=' + (this.buildid[0] ? this.buildid[0] : '')).then(function (reshouse) {
            if (reshouse.body.result) {
              var datahouse = reshouse.body.result;
              var arr3 = [];
              for (var k = 0; k < datahouse.length; k++) {
                arr3.push(datahouse[k].hsNo);
              }
              this.houselist.push(arr3);
            }
          }, function (errhouse) {
            console.log(errhouse);
          });
        }
      }, function (errbuild) {
        console.log(errbuild);
      });
    },

    /*联调函数*/
    selectValue: function selectValue(value) {
      var _this = this;

      for (var i = 0; i < 3; i++) {
        if (value[i] != this.house[i]) {
          switch (i) {
            case 0:
              this.house[0] = value[0];
              this.getStoreyInfo(value[0]);
              this.$nextTick(function () {
                popup_picker["a" /* default */].props.data = _this.houselist;
              });
              return;
            case 1:
              this.house[0] = value[0];
              this.house[1] = value[1];
              this.getHouseInfo(value[0], this.district[0], value[1]);
              this.$nextTick(function () {
                popup_picker["a" /* default */].props.data = _this.houselist;
              });
              return;
            case 2:
              this.house[0] = value[0];
              this.house[1] = value[1];
              this.house[2] = value[2];
              return;
          }
        }
      }
    },

    /*选择楼号获取楼层高度*/
    getStoreyInfo: function getStoreyInfo(storeyname) {
      /*this.$http.get(global.host + 'building/getList?comnCode='+ this.districtlistid[this.getIndex(this.districtlist[0],this.district[0])]).then(function(res){
      let storeyid = this.getIndex(this.houselist[0],storeyname);
      let commid = this.getIndex(this.districtlist[0],this.district[0])
      if(res.body.result) {*/
      var storeyid = this.getIndex(this.houselist[0], storeyname);
      var commid = this.getIndex(this.districtlist[0], this.district[0]);
      var size = this.houselist[1].length;
      var size1 = this.houselist[2].length;

      for (var j = 1; j < size; j++) {
        this.houselist[1].pop();
      }
      for (var j = 1; j < size1; j++) {
        this.houselist[2].pop();
      }
      var databuild = this.buildList[this.getIndex(this.houselist[0], storeyname)].height;
      for (var i = 0; i < databuild.length; i++) {
        this.houselist[1].push(databuild[i]);
      }
      if (this.houselist[1].length > 1) {
        this.houselist[1].shift();
      } else {
        this.houselist[1].push(' ');
        this.houselist[1].shift();
      }
      this.$http.get(global.host + 'house/getList?comnCode=' + this.districtlistid[commid] + '&buildCode=' + this.houselistid[storeyid] + '&fool=' + (this.house[1] ? this.house[1] : 1) + '&unit=' + (this.buildid[storeyid] ? this.buildid[storeyid] : '')).then(function (res) {
        if (res.body.result) {
          var data = res.body.result;
          var mis = [];
          /*let size = this.houselist[2].length;
          for(let a = 1; a< size; a++){
          this.houselist[2].pop();
          }*/
          for (var k = 0; k < data.length; k++) {
            this.houselist[2].push(data[k].hsNo);
          }
          if (this.houselist[2].length > 1) {
            this.houselist[2].shift();
          }
        } else {
          this.houselist[2].push('');
          var houseNum = this.houselist[2].length - 1;
          for (var _i = 0; _i < houseNum; _i++) {
            this.houselist[2].pop();
          }
        }
      }, function (err) {
        console.log(err);
      });
      /* }
      },function(err){
      console.log(err)
      });*/
    },

    /*选择楼层高度获取房间号*/
    getHouseInfo: function getHouseInfo(storeyname, buildname, floor) {
      var storeyid = this.getIndex(this.houselist[0], storeyname);
      var commid = this.getIndex(this.districtlist[0], buildname);
      var houseInfo = new Array();
      this.$http.get(global.host + 'house/getList?comnCode=' + this.districtlistid[commid] + '&buildCode=' + this.houselistid[storeyid] + '&fool=' + floor + '&unit=' + (this.buildid[storeyid] ? this.buildid[storeyid] : '')).then(function (res) {
        console.log(res);
        if (res.body.result) {
          var size = this.houselist[2].length;
          for (var j = 1; j < size; j++) {
            this.houselist[2].pop();
          }
          var data = res.body.result;
          for (var k = 0; k < data.length; k++) {
            this.houselist[2].push(data[k].hsNo);
          }
          this.houselist[2].shift();
        } else {
          /*清空房间信息 追加一个空的信息 防止数据为空*/
          var _size = this.houselist[2].length;
          for (var j = 1; j < _size; j++) {
            this.houselist[2].pop();
          }
          this.houselist[2].push('');
          this.houselist[2].shift();
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*获取索引值*/
    getIndex: function getIndex(arr, feild) {
      for (var i = 0; i < arr.length; i++) {
        if (feild == arr[i]) {
          return i;
        } else {
          continue;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userComponents/houseBind.vue
















/* harmony default export */ var userComponents_houseBind = ({
  components: {
    XHeader: vux_src_components_x_header,
    Group: group["a" /* default */],
    PopupRadio: vux_src_components_popup_radio,
    XInput: x_input["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    Cell: cell["a" /* default */],
    XButton: vux_src_components_x_button,
    PopupPicker: popup_picker["a" /* default */],
    Alert: components_alert["a" /* default */],
    loadPage: src_components_loadingPage,
    $: jquery_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      districtlist: [[]],
      districtlistid: [],
      district: [' '],
      houselist: [[], [], []],
      houselistn: [],
      houselistid: [],
      house: [' ', ' ', ' '],
      buildid: [],
      relation: ['本人'],
      relationlist: [[]],
      relationlistid: [],
      owner: '',
      messageWarn: '',
      username: '',
      phone: '',
      houseBind: '',
      alertTitle: '',
      alertContent: '',
      showAlert: false,
      readonlyable: true,
      buildList: []
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    /*获取所有小区*/
    this.$http.get(global.host + 'community/getList').then(function (res) {
      if (res.body) {
        var datacommunity = res.body.result;
        var list = [];var listid = [];
        for (var i = 0; i < datacommunity.length; i++) {
          this.districtlist[0].push(datacommunity[i].comnName);
          this.districtlistid.push(datacommunity[i].comnCode);
        }
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    }),
    /*获取与业主的关系*/
    this.$http.get(global.host + '/dict/getDiceByTypeEqHousereLation').then(function (res) {
      if (res.body.result) {
        var data = res.body.result;
        for (var i = 0; i < data.length; i++) {
          this.relationlist[0].push(data[i].label);
          this.relationlistid.push(data[i].id);
        }
      }
    }, function (err) {
      console.log(err);
    });
  },
  mounted: function mounted() {
    var mobile = this.$router.history.current.query.phone;
    this.phone = mobile.substring(0, 3) + '****' + mobile.substring(7, 11);
    if (this.$router.history.current.path == "/houseBind") {
      document.title = "业主认证";
    }
  },

  methods: {
    onHide: function onHide() {
      this.showAlert = false;
      if (this.alertContent == '房屋绑定成功') {
        if (this.$router.history.current.query.muId == 3) {
          this.$router.push({ path: '/pay/tenement', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
        } else if (this.$router.history.current.query.muId == 4) {
          this.$router.push({ path: '/', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
        } else {
          this.$router.push({ path: '/user', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
        }
      }
    },
    beforXy: function beforXy(mrquerUrl) {

      var objectInfo = new Object();
      objectInfo.comnCode = this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])];
      objectInfo.hsNo = this.house[2];
      objectInfo.hsName = this.owner;
      objectInfo.phoneModel = navigator.userAgent;
      objectInfo.requestUrl = mrquerUrl;

      var newUrl = global.host + 'sys/addSystemLog';
      this.$http.post(newUrl, objectInfo).then(function (res) {
        console.log(res.body.result);
      }, function (err) {
        console.log(err);
      });
    },

    /*房间绑定验证*/
    bindHouse: function bindHouse() {

      this.owner = this.owner.replace(/(^\s*)|(\s*$)/g, "");
      this.$http.get(global.host + '/users/checkUserIsExistByUtil?comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0], this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' + this.house[2] + '&userName=' + encodeURIComponent(this.owner)).then(function (res) {
        if (res.body.success) {
          /*改变样式 存在*/
          this.houseBind = true;
          this.bindHouseSubmit();
        } else {
          /*改变样式 不存在*/
          this.alertTitle = '温馨提示';
          this.alertContent = '请输入物业登记的业主姓名';
          this.houseBind = false;
          this.showAlert = true;
          setTimeout(function () {
            this.showAlert = false;
          }, 2000);
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*房间绑定提交*/
    bindHouseSubmit: function bindHouseSubmit() {
      var regRule = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
      if (this.district[0] == ' ' || !this.district[0]) {
        this.messageWarn = '温馨提示：请选择小区';
      } else if ((!this.house[0] || this.house[0] == ' ') && (!this.house[1] || this.house[1] == ' ') && (!this.house[2] || this.house[2] == ' ')) {
        this.messageWarn = '温馨提示：请选择房间';
      } else if (!this.owner) {
        this.messageWarn = '温馨提示：请输入业主姓名';
      } else if (this.owner.match(regRule)) {
        this.messageWarn = '温馨提示：业主姓名不能输入特殊符号';
      } else if (!this.username) {
        this.messageWarn = '温馨提示：请输入您的真实姓名';
      } else if (!this.houseBind) {
        console.log("xxxxxxxxxxxxxxxxxx" + this.houseBind);
        this.messageWarn = '温馨提示：房屋与业主不匹配';
      } else if (!this.relation[0]) {
        this.messageWarn = '温馨提示：请选择与业主的关系';
      } else {

        this.beforXy("#绑定房间信息#users/register/" + this.$router.history.current.query.openid + '/' + this.$router.history.current.query.phone + '/' + this.house[2] + '/' + this.username + '/' + this.$router.history.current.query.phone + '/' + this.relationlistid[this.getIndex(this.relationlist[0], this.relation[0])] + '/' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '/' + this.$router.history.current.query.IsDefault);
        this.username = this.username.replace(/(^\s*)|(\s*$)/g, "");
        console.log(global.host + 'users/register?openid=' + this.$router.history.current.query.openid + '&phone=' + this.$router.history.current.query.phone + '&roomNumber=' + this.house[2] + '&registrantName=' + this.username + '&phoneNumber=' + this.$router.history.current.query.phone + '&relationShip=' + this.relationlistid[this.getIndex(this.relationlist[0], this.relation[0])] + '&comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '&IsDefault=' + this.$router.history.current.query.IsDefault);
        this.$http.get(global.host + 'users/register?openid=' + this.$router.history.current.query.openid + '&phone=' + this.$router.history.current.query.phone + '&roomNumber=' + this.house[2] + '&registrantName=' + this.username + '&phoneNumber=' + this.$router.history.current.query.phone + '&relationShip=' + this.relationlistid[this.getIndex(this.relationlist[0], this.relation[0])] + '&comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '&IsDefault=' + this.$router.history.current.query.IsDefault).then(function (res) {
          console.log(res);
          if (res.body.result == 'success') {
            this.alertTitle = '恭喜';
            this.alertContent = '房屋绑定成功';
            this.showAlert = true;
          } else {
            this.alertTitle = '抱歉';
            this.alertContent = res.body.message;
            this.showAlert = true;
          }
        }, function (err) {
          console.log(err);
        });
      }
    },

    /*房间检测*/
    updateVal: function updateVal() {
      this.houseBind = false;
    },
    checkBind: function checkBind() {
      this.houseBind = false;
      if (!this.district[0]) {
        this.messageWarn = '请选择小区';
      } else if (!this.house[0] && !this.house[1] && !this.house[2]) {
        this.messageWarn = '请选择房间';
      } else if (!this.owner) {
        this.messageWarn = '请输入业主姓名';
      } else {

        this.beforXy("#验证业主是否匹配#users/checkUserIsExistByUtil?comnCode=" + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0], this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' + this.house[2] + '&userName=' + encodeURIComponent(this.owner));
        this.owner = this.owner.replace(/(^\s*)|(\s*$)/g, "");
        this.$http.get(global.host + '/users/checkUserIsExistByUtil?comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0], this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' + this.house[2] + '&userName=' + encodeURIComponent(this.owner)).then(function (res) {
          if (res.body.success) {
            /*改变样式 存在*/
            this.houseBind = true;
          } else {
            /*改变样式 不存在*/
            this.alertTitle = '温馨提示';
            this.alertContent = '请输入物业登记的业主姓名';
            this.houseBind = false;
            this.showAlert = true;
            setTimeout(function () {
              this.showAlert = false;
            }, 2000);
          }
        }, function (err) {
          console.log(err);
        });
      }
    },

    /*选择小区获取楼的数据*/
    selectComnBuildList: function selectComnBuildList(value) {
      console.log("######################");
      this.houselist = [];
      this.buildid = [];
      this.houselistid = [];
      this.buildList = [];
      /*获取小区中的楼号信息*/
      this.$http.get(global.host + 'building/getList?comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], value[0])]).then(function (resbuild) {
        if (resbuild.body.result) {
          var arr1 = [];
          var databuild = resbuild.body.result;
          this.buildList = resbuild.body.result;

          for (var j = 0; j < databuild.length; j++) {
            arr1.push(databuild[j].buildName + (databuild[j].unitName ? databuild[j].unitName : ''));
            if (databuild[j].unitid) {
              this.houselistid.push(databuild[j].buildid);
              this.buildid.push(databuild[j].unitid);
            } else {
              this.houselistid.push(databuild[j].buildid);
            }
          }

          this.houselist.push(arr1);
          var arr2 = [];
          console.log(databuild[0].height);
          for (var i = 0; i < databuild[0].height.length; i++) {
            arr2.push(databuild[0].height[i]);
          }
          this.houselist.push(arr2);
          /*获取房间的信息*/
          this.$http.get(global.host + 'house/getList?comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], value[0])] + '&buildCode=' + this.houselistid[0] + '&fool=1F' + '&unit=' + (this.buildid[0] ? this.buildid[0] : '')).then(function (reshouse) {
            if (reshouse.body.result) {
              var datahouse = reshouse.body.result;
              var arr3 = [];
              for (var k = 0; k < datahouse.length; k++) {
                arr3.push(datahouse[k].hsNo);
              }
              this.houselist.push(arr3);
            }
          }, function (errhouse) {
            console.log(errhouse);
          });
        }
      }, function (errbuild) {
        console.log(errbuild);
      });
    },


    /*选择小区*/
    selectDistrict: function selectDistrict() {
      this.houselist = [];
      this.buildid = [];
      this.houselistid = [];
      /*获取小区中的楼号信息*/
      this.$http.get(global.host + 'building/getList?comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])]).then(function (resbuild) {
        if (resbuild.body.result) {
          var arr1 = [];
          var databuild = resbuild.body.result;
          this.buildList = resbuild.body.result;
          for (var j = 0; j < databuild.length; j++) {
            arr1.push(databuild[j].buildName + (databuild[j].unitName ? databuild[j].unitName : ''));
            if (databuild[j].unitid) {
              this.houselistid.push(databuild[j].buildid);
              this.buildid.push(databuild[j].unitid);
            } else {
              this.houselistid.push(databuild[j].buildid);
            }
          }
          this.houselist.push(arr1);
          var arr2 = [];
          for (var i = 0; i < databuild[0].height.length; i++) {
            arr2.push(databuild[0].height[i]);
          }
          this.houselist.push(arr2);
          /*获取房间的信息*/
          this.$http.get(global.host + 'house/getList?comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0], this.district[0])] + '&buildCode=' + this.houselistid[0] + '&fool=1F' + '&unit=' + (this.buildid[0] ? this.buildid[0] : '')).then(function (reshouse) {
            if (reshouse.body.result) {
              var datahouse = reshouse.body.result;
              var arr3 = [];
              for (var k = 0; k < datahouse.length; k++) {
                arr3.push(datahouse[k].hsNo);
              }
              this.houselist.push(arr3);
            }
          }, function (errhouse) {
            console.log(errhouse);
          });
        }
      }, function (errbuild) {
        console.log(errbuild);
      });
    },

    /*联调函数*/
    selectValue: function selectValue(value) {
      var _this = this;

      for (var i = 0; i < 3; i++) {
        if (value[i] != this.house[i]) {
          switch (i) {
            case 0:
              this.house[0] = value[0];
              this.getStoreyInfo(value[0]);
              this.$nextTick(function () {
                popup_picker["a" /* default */].props.data = _this.houselist;
              });
              return;
            case 1:
              this.house[0] = value[0];
              this.house[1] = value[1];
              this.getHouseInfo(value[0], this.district[0], value[1]);
              this.$nextTick(function () {
                popup_picker["a" /* default */].props.data = _this.houselist;
              });
              return;
            case 2:
              this.house[0] = value[0];
              this.house[1] = value[1];
              this.house[2] = value[2];
              return;
          }
        }
      }
    },

    /*选择楼号获取楼层高度*/
    getStoreyInfo: function getStoreyInfo(storeyname) {
      /*this.$http.get(global.host + 'building/getList?comnCode='+ this.districtlistid[this.getIndex(this.districtlist[0],this.district[0])]).then(function(res){
      let storeyid = this.getIndex(this.houselist[0],storeyname);
      let commid = this.getIndex(this.districtlist[0],this.district[0])
      if(res.body.result) {*/
      var storeyid = this.getIndex(this.houselist[0], storeyname);
      var commid = this.getIndex(this.districtlist[0], this.district[0]);
      var size = this.houselist[1].length;
      var size1 = this.houselist[2].length;

      for (var j = 1; j < size; j++) {
        this.houselist[1].pop();
      }
      for (var j = 1; j < size1; j++) {
        this.houselist[2].pop();
      }
      var databuild = this.buildList[this.getIndex(this.houselist[0], storeyname)].height;
      for (var i = 0; i < databuild.length; i++) {
        this.houselist[1].push(databuild[i]);
      }
      if (this.houselist[1].length > 1) {
        this.houselist[1].shift();
      } else {
        this.houselist[1].push(' ');
        this.houselist[1].shift();
      }
      this.$http.get(global.host + 'house/getList?comnCode=' + this.districtlistid[commid] + '&buildCode=' + this.houselistid[storeyid] + '&fool=' + (this.house[1] ? this.house[1] : 1) + '&unit=' + (this.buildid[storeyid] ? this.buildid[storeyid] : '')).then(function (res) {
        if (res.body.result) {
          var data = res.body.result;
          var mis = [];
          /*let size = this.houselist[2].length;
          for(let a = 1; a< size; a++){
          this.houselist[2].pop();
          }*/
          for (var k = 0; k < data.length; k++) {
            this.houselist[2].push(data[k].hsNo);
          }
          if (this.houselist[2].length > 1) {
            this.houselist[2].shift();
          }
        } else {
          this.houselist[2].push('');
          var houseNum = this.houselist[2].length - 1;
          for (var _i = 0; _i < houseNum; _i++) {
            this.houselist[2].pop();
          }
        }
      }, function (err) {
        console.log(err);
      });
      /* }
      },function(err){
      console.log(err)
      });*/
    },

    /*选择楼层高度获取房间号*/
    getHouseInfo: function getHouseInfo(storeyname, buildname, floor) {
      var storeyid = this.getIndex(this.houselist[0], storeyname);
      var commid = this.getIndex(this.districtlist[0], buildname);
      var houseInfo = new Array();
      this.$http.get(global.host + 'house/getList?comnCode=' + this.districtlistid[commid] + '&buildCode=' + this.houselistid[storeyid] + '&fool=' + floor + '&unit=' + (this.buildid[storeyid] ? this.buildid[storeyid] : '')).then(function (res) {
        console.log(res);
        if (res.body.result) {
          var size = this.houselist[2].length;
          for (var j = 1; j < size; j++) {
            this.houselist[2].pop();
          }
          var data = res.body.result;
          for (var k = 0; k < data.length; k++) {
            this.houselist[2].push(data[k].hsNo);
          }
          this.houselist[2].shift();
        } else {
          /*清空房间信息 追加一个空的信息 防止数据为空*/
          var _size = this.houselist[2].length;
          for (var j = 1; j < _size; j++) {
            this.houselist[2].pop();
          }
          this.houselist[2].push('');
          this.houselist[2].shift();
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*获取索引值*/
    getIndex: function getIndex(arr, feild) {
      for (var i = 0; i < arr.length; i++) {
        if (feild == arr[i]) {
          return i;
        } else {
          continue;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45631654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userComponents/houseBind.vue
var houseBind_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('popup-picker',{attrs:{"title":"<span style='color:red'> * </span>小区名称","data":_vm.districtlist},on:{"on-change":_vm.selectComnBuildList},model:{value:(_vm.district),callback:function ($$v) {_vm.district=$$v},expression:"district"}}),_vm._v(" "),_c('popup-picker',{attrs:{"title":"<span style='color:red'> * </span>房号","data":_vm.houselist},on:{"on-shadow-change":_vm.selectValue},model:{value:(_vm.house),callback:function ($$v) {_vm.house=$$v},expression:"house"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5%"}}),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"<span style='color:red'> * </span>业主姓名","name":"owner","placeholder":"请输入真实的业主姓名","text-align":"right"},on:{"on-blur":_vm.checkBind,"on-focus":_vm.updateVal},model:{value:(_vm.owner),callback:function ($$v) {_vm.owner=$$v},expression:"owner"}}),_vm._v(" "),_c('popup-picker',{ref:"info",attrs:{"title":"<span style='color:red'> * </span>与业主关系","data":_vm.relationlist},model:{value:(_vm.relation),callback:function ($$v) {_vm.relation=$$v},expression:"relation"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5%"}}),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"<span style='color:red'> * </span>绑定人姓名","name":"username","placeholder":"请输入真实的姓名","text-align":"right"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('x-input',{ref:"phoneCheck",attrs:{"title":"<span style='color:white'> * </span>绑定手机号","name":"phone","readonly":_vm.readonlyable,"text-align":"right"},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5%"}}),_vm._v(" "),_c('group',[_c('cell',{staticStyle:{"text-align":"center"},attrs:{"title":"温馨提示"}}),_vm._v(" "),_c('x-textarea',{staticStyle:{"font-size":"0.8em"},attrs:{"value":"1.请输入与房屋信息匹配的业主信息，否则会绑定失败\n2.请真实填写所有信息，否则会导致部分功能使用异常 3.如果业主姓名为多人，输入示例为：张三/李四","readonly":"readonly"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5%"}}),_vm._v(" "),(_vm.messageWarn)?_c('h4',{staticStyle:{"text-align":"center","color":"red"}},[_vm._v(_vm._s(_vm.messageWarn))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5%"}}),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.bindHouse($event)}}},[_vm._v("立即绑定")]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('alert',{attrs:{"title":_vm.alertTitle,"content":_vm.alertContent},on:{"on-hide":_vm.onHide},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}})],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var houseBind_staticRenderFns = []
var houseBind_esExports = { render: houseBind_render, staticRenderFns: houseBind_staticRenderFns }
/* harmony default export */ var components_userComponents_houseBind = (houseBind_esExports);
// CONCATENATED MODULE: ./src/components/userComponents/houseBind.vue
function houseBind_injectStyle (ssrContext) {
  __webpack_require__("OQuy")
}
var houseBind_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var houseBind___vue_template_functional__ = false
/* styles */
var houseBind___vue_styles__ = houseBind_injectStyle
/* scopeId */
var houseBind___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var houseBind___vue_module_identifier__ = null
var houseBind_Component = houseBind_normalizeComponent(
  userComponents_houseBind,
  components_userComponents_houseBind,
  houseBind___vue_template_functional__,
  houseBind___vue_styles__,
  houseBind___vue_scopeId__,
  houseBind___vue_module_identifier__
)

/* harmony default export */ var src_components_userComponents_houseBind = (houseBind_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/tenementDesc.vue




/* harmony default export */ var tenementDesc = ({
  components: {
    LoadMore: vux_src_components_load_more
  },
  data: function data() {
    return {
      content: ''
    };
  },
  beforeMount: function beforeMount() {
    /*正式环境*/
    var urlnotice = global.host + 'news/getNewByTypeEqDesc?comnCode=' + this.$router.history.current.query.communityId + '&pageNum=1';
    /*测试环境*/

    this.$http.get(urlnotice).then(function (res) {
      if (res.body.result.list) {
        this.content = res.body.result.list[0].content + "<style>img{width:100%;height:auto;max-width:100%;}</style>";
      }
    }, function (err) {
      console.log(err);
    });
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/tenementDesc") {
      document.title = "社区介绍";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/tenementDesc.vue




/* harmony default export */ var newComponents_tenementDesc = ({
  components: {
    LoadMore: vux_src_components_load_more
  },
  data: function data() {
    return {
      content: ''
    };
  },
  beforeMount: function beforeMount() {
    /*正式环境*/
    var urlnotice = global.host + 'news/getNewByTypeEqDesc?comnCode=' + this.$router.history.current.query.communityId + '&pageNum=1';
    /*测试环境*/

    this.$http.get(urlnotice).then(function (res) {
      if (res.body.result.list) {
        this.content = res.body.result.list[0].content + "<style>img{width:100%;height:auto;max-width:100%;}</style>";
      }
    }, function (err) {
      console.log(err);
    });
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/tenementDesc") {
      document.title = "社区介绍";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-669533cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/newComponents/tenementDesc.vue
var tenementDesc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',{staticStyle:{"padding-top":"55%"}},[_c('load-more',{attrs:{"tip":"正在加载"}})],1)])}
var tenementDesc_staticRenderFns = []
var tenementDesc_esExports = { render: tenementDesc_render, staticRenderFns: tenementDesc_staticRenderFns }
/* harmony default export */ var components_newComponents_tenementDesc = (tenementDesc_esExports);
// CONCATENATED MODULE: ./src/components/newComponents/tenementDesc.vue
var tenementDesc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tenementDesc___vue_template_functional__ = false
/* styles */
var tenementDesc___vue_styles__ = null
/* scopeId */
var tenementDesc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tenementDesc___vue_module_identifier__ = null
var tenementDesc_Component = tenementDesc_normalizeComponent(
  newComponents_tenementDesc,
  components_newComponents_tenementDesc,
  tenementDesc___vue_template_functional__,
  tenementDesc___vue_styles__,
  tenementDesc___vue_scopeId__,
  tenementDesc___vue_module_identifier__
)

/* harmony default export */ var src_components_newComponents_tenementDesc = (tenementDesc_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userComponents/editUserInformation.vue
var editUserInformation = __webpack_require__("LbyF");

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userComponents/editUserInformation.vue
var userComponents_editUserInformation = __webpack_require__("vOg8");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46038d9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userComponents/editUserInformation.vue
var editUserInformation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('popup-header',{attrs:{"left-text":"取消","right-text":"保存"},on:{"on-click-left":_vm.cancle,"on-click-right":_vm.colectMethod}}),_vm._v(" "),(_vm.muSid == 0)?_c('div',[_c('group',[_c('popup-picker',{attrs:{"title":"与业主关系","data":_vm.list1},on:{"on-change":_vm.onChanges},model:{value:(_vm.value3),callback:function ($$v) {_vm.value3=$$v},expression:"value3"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.muSid == 1)?_c('div',[_c('group',[_c('x-input',{attrs:{"title":"绑定人姓名","text-align":"right"},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1)],1):_vm._e()],1)}
var editUserInformation_staticRenderFns = []
var editUserInformation_esExports = { render: editUserInformation_render, staticRenderFns: editUserInformation_staticRenderFns }
/* harmony default export */ var components_userComponents_editUserInformation = (editUserInformation_esExports);
// CONCATENATED MODULE: ./src/components/userComponents/editUserInformation.vue
function editUserInformation_injectStyle (ssrContext) {
  __webpack_require__("6xlL")
}
var editUserInformation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editUserInformation___vue_template_functional__ = false
/* styles */
var editUserInformation___vue_styles__ = editUserInformation_injectStyle
/* scopeId */
var editUserInformation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editUserInformation___vue_module_identifier__ = null
var editUserInformation_Component = editUserInformation_normalizeComponent(
  userComponents_editUserInformation["a" /* default */],
  components_userComponents_editUserInformation,
  editUserInformation___vue_template_functional__,
  editUserInformation___vue_styles__,
  editUserInformation___vue_scopeId__,
  editUserInformation___vue_module_identifier__
)

/* harmony default export */ var src_components_userComponents_editUserInformation = (editUserInformation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/timeline/timeline.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var timeline = ({
  name: 'timeline',
  props: {
    color: String,
    isShowIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    setChildProps: function setChildProps() {
      if (!this.$children) return;
      var len = this.$children.length;
      this.$children.forEach(function (child, index) {
        child.isLast = index === len - 1;
        child.isFirst = index === 0;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/timeline/timeline.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var timeline_timeline = ({
  name: 'timeline',
  props: {
    color: String,
    isShowIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    setChildProps: function setChildProps() {
      if (!this.$children) return;
      var len = this.$children.length;
      this.$children.forEach(function (child, index) {
        child.isLast = index === len - 1;
        child.isFirst = index === 0;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63e13588","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/timeline/timeline.vue
var timeline_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-timeline"},[_c('ul',[_vm._t("default")],2)])}
var timeline_staticRenderFns = []
var timeline_esExports = { render: timeline_render, staticRenderFns: timeline_staticRenderFns }
/* harmony default export */ var components_timeline_timeline = (timeline_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/timeline/timeline.vue
function timeline_injectStyle (ssrContext) {
  __webpack_require__("y2NU")
}
var timeline_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var timeline___vue_template_functional__ = false
/* styles */
var timeline___vue_styles__ = timeline_injectStyle
/* scopeId */
var timeline___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var timeline___vue_module_identifier__ = null
var timeline_Component = timeline_normalizeComponent(
  timeline_timeline,
  components_timeline_timeline,
  timeline___vue_template_functional__,
  timeline___vue_styles__,
  timeline___vue_scopeId__,
  timeline___vue_module_identifier__
)

/* harmony default export */ var src_components_timeline_timeline = (timeline_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/timeline/timeline-item.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var timeline_item = ({
  name: 'timeline-item',
  data: function data() {
    return {
      isLast: true,
      isFirst: true,
      headStyle: { backgroundColor: this.$parent.color }
    };
  },
  mounted: function mounted() {
    this.$parent.setChildProps();
  },
  beforeDestroy: function beforeDestroy() {
    // this will be null
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.setChildProps();
    });
  },

  components: {
    Icon: icon["a" /* default */]
  },
  computed: {
    tailStyle: function tailStyle() {
      return this.isLast ? { display: 'none', backgroundColor: this.$parent.color } : { display: 'block', backgroundColor: this.$parent.color };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/timeline/timeline-item.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var timeline_timeline_item = ({
  name: 'timeline-item',
  data: function data() {
    return {
      isLast: true,
      isFirst: true,
      headStyle: { backgroundColor: this.$parent.color }
    };
  },
  mounted: function mounted() {
    this.$parent.setChildProps();
  },
  beforeDestroy: function beforeDestroy() {
    // this will be null
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.setChildProps();
    });
  },

  components: {
    Icon: icon["a" /* default */]
  },
  computed: {
    tailStyle: function tailStyle() {
      return this.isLast ? { display: 'none', backgroundColor: this.$parent.color } : { display: 'block', backgroundColor: this.$parent.color };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52bfa033","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/timeline/timeline-item.vue
var timeline_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"vux-timeline-item"},[_c('div',{class:['vux-timeline-item-color', {'vux-timeline-item-head': !_vm.isFirst,'vux-timeline-item-head-first': _vm.isFirst }],style:(_vm.headStyle)},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFirst && _vm.$parent.isShowIcon),expression:"isFirst && $parent.isShowIcon"}],staticClass:"vux-timeline-item-checked",attrs:{"type":"success_no_circle"}})],1),_vm._v(" "),_c('div',{staticClass:"vux-timeline-item-tail",style:(_vm.tailStyle)}),_vm._v(" "),_c('div',{staticClass:"vux-timeline-item-content"},[_vm._t("default")],2)])}
var timeline_item_staticRenderFns = []
var timeline_item_esExports = { render: timeline_item_render, staticRenderFns: timeline_item_staticRenderFns }
/* harmony default export */ var components_timeline_timeline_item = (timeline_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/timeline/timeline-item.vue
var timeline_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var timeline_item___vue_template_functional__ = false
/* styles */
var timeline_item___vue_styles__ = null
/* scopeId */
var timeline_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var timeline_item___vue_module_identifier__ = null
var timeline_item_Component = timeline_item_normalizeComponent(
  timeline_timeline_item,
  components_timeline_timeline_item,
  timeline_item___vue_template_functional__,
  timeline_item___vue_styles__,
  timeline_item___vue_scopeId__,
  timeline_item___vue_module_identifier__
)

/* harmony default export */ var src_components_timeline_timeline_item = (timeline_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/panel/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var panel = ({
  name: 'panel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onImgError: function onImgError(item, $event) {
      this.$emit('on-img-error', JSON.parse(stringify_default()(item)), $event);
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc;
      }
    },
    getUrl: function getUrl(url) {
      return Object(router["a" /* getUrl */])(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      Object(router["b" /* go */])(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      Object(router["b" /* go */])(item.url, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/panel/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_panel = ({
  name: 'panel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onImgError: function onImgError(item, $event) {
      this.$emit('on-img-error', JSON.parse(stringify_default()(item)), $event);
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc;
      }
    },
    getUrl: function getUrl(url) {
      return Object(router["a" /* getUrl */])(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      Object(router["b" /* go */])(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      Object(router["b" /* go */])(item.url, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ac89c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/panel/index.vue
var panel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-panel weui-panel_access"},[(_vm.header)?_c('div',{staticClass:"weui-panel__hd",domProps:{"innerHTML":_vm._s(_vm.header)},on:{"click":_vm.onClickHeader}},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-panel__bd"},[_vm._t("body",[(_vm.type === '1')?_vm._l((_vm.list),function(item){return _c('a',{staticClass:"weui-media-box weui-media-box_appmsg",attrs:{"href":_vm.getUrl(item.url)},on:{"click":function($event){$event.preventDefault();_vm.onItemClick(item)}}},[(item.src)?_c('div',{staticClass:"weui-media-box__hd"},[_c('img',{staticClass:"weui-media-box__thumb",attrs:{"src":item.src,"alt":""},on:{"error":function($event){_vm.onImgError(item, $event)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-media-box__bd"},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])])}):_vm._e(),_vm._v(" "),(_vm.type === '2')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();_vm.onItemClick(item)}}},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])}):_vm._e(),_vm._v(" "),(_vm.type === '3')?[_c('div',{staticClass:"weui-media-box weui-media-box_small-appmsg"},[_c('div',{staticClass:"weui-cells"},_vm._l((_vm.list),function(item){return _c('a',{staticClass:"weui-cell weui-cell_access",attrs:{"href":_vm.getUrl(item.url)},on:{"click":function($event){$event.preventDefault();_vm.onItemClick(item)}}},[_c('div',{staticClass:"weui-cell__hd"},[_c('img',{staticStyle:{"width":"20px","margin-right":"5px","display":"block"},attrs:{"src":item.src,"alt":""},on:{"error":function($event){_vm.onImgError(item, $event)}}})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('p',{domProps:{"innerHTML":_vm._s(item.title)}})]),_vm._v(" "),_c('span',{staticClass:"weui-cell__ft"})])}))])]:_vm._e(),_vm._v(" "),(_vm.type === '4')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();_vm.onItemClick(item)}}},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}}),_vm._v(" "),(item.meta)?_c('ul',{staticClass:"weui-media-box__info"},[_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.source)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.date)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta weui-media-box__info__meta_extra",domProps:{"innerHTML":_vm._s(item.meta.other)}})]):_vm._e()])}):_vm._e(),_vm._v(" "),(_vm.type === '5')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();_vm.onItemClick(item)}}},[_c('div',{staticClass:"weui-media-box_appmsg"},[(item.src)?_c('div',{staticClass:"weui-media-box__hd"},[_c('img',{staticClass:"weui-media-box__thumb",attrs:{"src":item.src,"alt":""},on:{"error":function($event){_vm.onImgError(item, $event)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-media-box__bd"},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])]),_vm._v(" "),(item.meta)?_c('ul',{staticClass:"weui-media-box__info"},[_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.source)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.date)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta weui-media-box__info__meta_extra",domProps:{"innerHTML":_vm._s(item.meta.other)}})]):_vm._e()])}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-panel__ft"},[(_vm.footer && _vm.footer.title && _vm.type !== '3')?_c('a',{staticClass:"weui-cell weui-cell_access weui-cell_link",attrs:{"href":_vm.getUrl(_vm.footer.url)},on:{"click":function($event){$event.preventDefault();return _vm.onClickFooter($event)}}},[_c('div',{staticClass:"weui-cell__bd",domProps:{"innerHTML":_vm._s(_vm.footer.title)}})]):_vm._e()])])}
var panel_staticRenderFns = []
var panel_esExports = { render: panel_render, staticRenderFns: panel_staticRenderFns }
/* harmony default export */ var src_components_panel = (panel_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/panel/index.vue
function panel_injectStyle (ssrContext) {
  __webpack_require__("xewG")
}
var panel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var panel___vue_template_functional__ = false
/* styles */
var panel___vue_styles__ = panel_injectStyle
/* scopeId */
var panel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var panel___vue_module_identifier__ = null
var panel_Component = panel_normalizeComponent(
  components_panel,
  src_components_panel,
  panel___vue_template_functional__,
  panel___vue_styles__,
  panel___vue_scopeId__,
  panel___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_panel = (panel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/listNew.vue










/* harmony default export */ var listNew = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LoadMore: vux_src_components_load_more,
    Timeline: src_components_timeline_timeline,
    TimelineItem: src_components_timeline_timeline_item,
    Panel: vux_src_components_panel,
    Swiper: vux_src_components_swiper_swiper
  },
  beforeMount: function beforeMount() {
    /*正式环境*/

    /*测试环境*/

    this.$http.get(global.host + 'news/getNewsByComnCode?comnCode=' + this.$router.history.current.query.communityId + "&pageNum=" + this.pageNum + "&rows=" + this.rows).then(function (res) {
      console.log(res);
      if (res.body.result) {

        this.lastNum = res.body.result.size;
        var newData = res.body.result.list;
        this.list = new Array();
        for (var i = 0; i < newData.length; i++) {
          this.list[i] = new Object();
          this.list[i].src = newData[i].picture;
          this.list[i].title = newData[i].title;
          this.list[i].url = '/detailNew?newid=' + newData[i].news_id;
          this.list[i].meta = new Object();
          this.list[i].meta.source = newData[i].createUser;
          this.list[i].meta.date = newData[i].creatTime;
        }
        this.beginload = true;
      }
    }, function (err) {
      console.log(res);
    });
  },

  methods: {
    getMoreNews: function getMoreNews() {
      /*正式环境*/

      /*测试环境*/

      var trueH = window.innerHeight;
      var scrollH = window.scrollY;
      var totalH = document.getElementById('app').clientHeight;

      var shengyuH = totalH - trueH;
      if (scrollH >= shengyuH) {
        if (this.lastNum == this.rows) {
          this.$refs.lod.style.display = "block";
          console.log('滚动成功');
          this.pageNum++;
          console.log(this.pageNum);
          this.$http.get(global.host + 'news/getNewsByComnCode?comnCode=' + this.$router.history.current.query.communityId + "&pageNum=" + this.pageNum + "&rows=" + this.rows).then(function (res) {
            console.log(res);
            var newData = res.body.result.list;
            this.lastNum = res.body.result.size;
            if (res.body.result.size == 0) {
              /*阻止无用的请求*/
              window.removeEventListener('scroll', this.getMoreNews);
              return;
            }

            if (newData && newData.length > 0) {
              var newNews = new Array();
              for (var i = 0; i < newData.length; i++) {
                newNews[i] = new Object();
                newNews[i].src = newData[i].picture;
                newNews[i].title = newData[i].title;
                newNews[i].url = '/movecouplet/detailNew?newid=' + newData[i].news_id;
                newNews[i].meta = new Object();
                newNews[i].meta.source = newData[i].createUser;
                newNews[i].meta.date = newData[i].creatTime;
              }
              for (var j = 0; j < newNews.length; j++) {
                this.list.push(newNews[j]);
                this.$refs.lod.style.display = "none";
              }
            }
          }, function (err) {});
        } else {
          console.log(this.lastNum);
          this.$refs.lod.style.display = "none";
          if (this.$refs.lod.style.display == "none") {
            this.$refs.noS.style.display = "block";
          }
          return;
        }
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.getMoreNews);
    if (this.$router.history.current.path == "/listNew") {
      document.title = "社区新闻";
    }
  },
  data: function data() {
    return {
      list: [],
      morenew: false,
      pageNum: 1,
      rows: 6,
      lastNum: 0,
      beginload: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/listNew.vue










/* harmony default export */ var newComponents_listNew = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LoadMore: vux_src_components_load_more,
    Timeline: src_components_timeline_timeline,
    TimelineItem: src_components_timeline_timeline_item,
    Panel: vux_src_components_panel,
    Swiper: vux_src_components_swiper_swiper
  },
  beforeMount: function beforeMount() {
    /*正式环境*/

    /*测试环境*/

    this.$http.get(global.host + 'news/getNewsByComnCode?comnCode=' + this.$router.history.current.query.communityId + "&pageNum=" + this.pageNum + "&rows=" + this.rows).then(function (res) {
      console.log(res);
      if (res.body.result) {

        this.lastNum = res.body.result.size;
        var newData = res.body.result.list;
        this.list = new Array();
        for (var i = 0; i < newData.length; i++) {
          this.list[i] = new Object();
          this.list[i].src = newData[i].picture;
          this.list[i].title = newData[i].title;
          this.list[i].url = '/detailNew?newid=' + newData[i].news_id;
          this.list[i].meta = new Object();
          this.list[i].meta.source = newData[i].createUser;
          this.list[i].meta.date = newData[i].creatTime;
        }
        this.beginload = true;
      }
    }, function (err) {
      console.log(res);
    });
  },

  methods: {
    getMoreNews: function getMoreNews() {
      /*正式环境*/

      /*测试环境*/

      var trueH = window.innerHeight;
      var scrollH = window.scrollY;
      var totalH = document.getElementById('app').clientHeight;

      var shengyuH = totalH - trueH;
      if (scrollH >= shengyuH) {
        if (this.lastNum == this.rows) {
          this.$refs.lod.style.display = "block";
          console.log('滚动成功');
          this.pageNum++;
          console.log(this.pageNum);
          this.$http.get(global.host + 'news/getNewsByComnCode?comnCode=' + this.$router.history.current.query.communityId + "&pageNum=" + this.pageNum + "&rows=" + this.rows).then(function (res) {
            console.log(res);
            var newData = res.body.result.list;
            this.lastNum = res.body.result.size;
            if (res.body.result.size == 0) {
              /*阻止无用的请求*/
              window.removeEventListener('scroll', this.getMoreNews);
              return;
            }

            if (newData && newData.length > 0) {
              var newNews = new Array();
              for (var i = 0; i < newData.length; i++) {
                newNews[i] = new Object();
                newNews[i].src = newData[i].picture;
                newNews[i].title = newData[i].title;
                newNews[i].url = '/movecouplet/detailNew?newid=' + newData[i].news_id;
                newNews[i].meta = new Object();
                newNews[i].meta.source = newData[i].createUser;
                newNews[i].meta.date = newData[i].creatTime;
              }
              for (var j = 0; j < newNews.length; j++) {
                this.list.push(newNews[j]);
                this.$refs.lod.style.display = "none";
              }
            }
          }, function (err) {});
        } else {
          console.log(this.lastNum);
          this.$refs.lod.style.display = "none";
          if (this.$refs.lod.style.display == "none") {
            this.$refs.noS.style.display = "block";
          }
          return;
        }
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.getMoreNews);
    if (this.$router.history.current.path == "/listNew") {
      document.title = "社区新闻";
    }
  },
  data: function data() {
    return {
      list: [],
      morenew: false,
      pageNum: 1,
      rows: 6,
      lastNum: 0,
      beginload: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1be20730","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/newComponents/listNew.vue
var listNew_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.beginload)?_c('div',{attrs:{"id":"newlist"}},[_c('panel',{attrs:{"list":_vm.list,"type":"5"}}),_vm._v(" "),_c('div',{ref:"lod",staticStyle:{"display":"none"}},[_c('load-more',{attrs:{"tip":"正在加载"}})],1),_vm._v(" "),_c('div',{ref:"noS",staticStyle:{"font-size":"13px","color":"#ccc","text-align":"center","display":"none"}},[_vm._v("暂无更多数据")])],1):_c('div',{staticStyle:{"padding-top":"55%"}},[_c('load-more',{attrs:{"tip":"正在加载"}})],1)])}
var listNew_staticRenderFns = []
var listNew_esExports = { render: listNew_render, staticRenderFns: listNew_staticRenderFns }
/* harmony default export */ var components_newComponents_listNew = (listNew_esExports);
// CONCATENATED MODULE: ./src/components/newComponents/listNew.vue
function listNew_injectStyle (ssrContext) {
  __webpack_require__("Opf8")
}
var listNew_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var listNew___vue_template_functional__ = false
/* styles */
var listNew___vue_styles__ = listNew_injectStyle
/* scopeId */
var listNew___vue_scopeId__ = "data-v-1be20730"
/* moduleIdentifier (server only) */
var listNew___vue_module_identifier__ = null
var listNew_Component = listNew_normalizeComponent(
  newComponents_listNew,
  components_newComponents_listNew,
  listNew___vue_template_functional__,
  listNew___vue_styles__,
  listNew___vue_scopeId__,
  listNew___vue_module_identifier__
)

/* harmony default export */ var src_components_newComponents_listNew = (listNew_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/notice.vue











/* harmony default export */ var notice = ({
  data: function data() {
    return {
      mtTitle: "",
      notice: [],
      pageNum: 1,
      rows: 10,
      lastNum: 0,
      senTime: "",
      redNums: "",
      murs: false,
      beginload: false,
      list: [],
      communityId: "",
      content: []
    };
  },

  components: {
    Timeline: src_components_timeline_timeline,
    TimelineItem: src_components_timeline_timeline_item,
    LoadMore: vux_src_components_load_more,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Panel: vux_src_components_panel,
    Swiper: vux_src_components_swiper_swiper
  },
  beforeMount: function beforeMount() {
    /*正式环境*/

    var urlnotice = global.host + "news/getNewsByTypeEqNotice?comnCode=" + this.$router.history.current.query.communityId + "&pageNum=" + this.pageNum + "&rows=" + this.rows;
    /*测试环境*/

    this.communityId = this.$router.history.current.query.communityId;
    var comnCode = this.communityId;
    var openid = this.$router.history.current.query.openid;
    var phone = this.$router.history.current.query.phone;
    this.$http.get(urlnotice).then(function (res) {
      console.log(res);
      if (res.body.result.size != 0) {
        this.notice = res.body.result.list;

        for (var i = 0; i < this.notice.length; i++) {
          this.list[i] = new Object();
          this.list[i].src = "../static/image/notice_pic.jpg";
          this.list[i].title = this.notice[i].title;
          this.list[i].url = "/notice_list?newid=" + this.notice[i].news_id + "&comnCode=" + comnCode + "&phone=" + phone + "&openid=" + openid;
          this.list[i].meta = new Object();
          this.list[i].meta.date = this.notice[i].createTime;
        }
        this.beginload = true;
        this.lastNum = res.body.result.size;
      }
    }, function (err) {});
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.getMoreNotice);
    if (this.$router.history.current.path == "/notice") {
      document.title = "社区公告";
    }
  },

  methods: {
    getMoreNotice: function getMoreNotice() {
      /*正式环境*/
      var urlnotice = global.host + "news/getNewsByTypeEqNotice?comnCode=" + this.$router.history.current.query.communityId + "&pageNum=" + this.pageNum + "&rows=" + this.rows;
      /*测试环境*/

      var trueH = window.innerHeight;
      var scrollH = window.scrollY;
      var totalH = document.getElementById("app").clientHeight;
      var shengyuH = totalH - trueH;

      var comnCode = this.$router.history.current.query.communityId;
      var openid = this.$router.history.current.query.openid;
      var phone = this.$router.history.current.query.phone;

      if (scrollH >= shengyuH) {

        if (this.lastNum == this.rows) {
          this.$refs.lod.style.display = "block";
          this.pageNum++;
          console.log("滚动成功");
          this.$http.get(global.host + "news/getNewsByTypeEqNotice?comnCode=" + this.$router.history.current.query.communityId + "&pageNum=" + this.pageNum + "&rows=" + this.rows).then(function (res) {
            console.log("发送成功");
            console.log(res);
            var newData = res.body.result.list;
            this.lastNum = res.body.result.size;
            console.log(this.pageNum);
            if (res.body.result.size == 0) {
              /*阻止无用的请求*/
              window.removeEventListener("scroll", this.getMoreNews);
              return;
            }
            if (newData && newData.length > 0) {
              var newNews = new Array();
              for (var i = 0; i < newData.length; i++) {
                newNews[i] = new Object();
                newNews[i].src = "../static/image/notice_pic.jpg";
                newNews[i].title = newData[i].title;
                newNews[i].url = "/notice_list?newid=" + newData[i].news_id + "&comnCode=" + comnCode + "&phone=" + phone + "&openid=" + openid;
                newNews[i].meta = new Object();
                newNews[i].meta.date = newData[i].createTime;
              }
              for (var j = 0; j < newNews.length; j++) {
                this.list.push(newNews[j]);
                this.$refs.lod.style.display = "none";
              }
            }
          }, function (err) {
            console.log(res);
          });
        } else {
          console.log(this.lastNum);
          this.$refs.lod.style.display = "none";
          if (this.$refs.lod.style.display == "none") {
            this.$refs.noS.style.display = "block";
          }
          return;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/notice.vue











/* harmony default export */ var newComponents_notice = ({
  data: function data() {
    return {
      mtTitle: "",
      notice: [],
      pageNum: 1,
      rows: 10,
      lastNum: 0,
      senTime: "",
      redNums: "",
      murs: false,
      beginload: false,
      list: [],
      communityId: "",
      content: []
    };
  },

  components: {
    Timeline: src_components_timeline_timeline,
    TimelineItem: src_components_timeline_timeline_item,
    LoadMore: vux_src_components_load_more,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Panel: vux_src_components_panel,
    Swiper: vux_src_components_swiper_swiper
  },
  beforeMount: function beforeMount() {
    /*正式环境*/

    var urlnotice = global.host + "news/getNewsByTypeEqNotice?comnCode=" + this.$router.history.current.query.communityId + "&pageNum=" + this.pageNum + "&rows=" + this.rows;
    /*测试环境*/

    this.communityId = this.$router.history.current.query.communityId;
    var comnCode = this.communityId;
    var openid = this.$router.history.current.query.openid;
    var phone = this.$router.history.current.query.phone;
    this.$http.get(urlnotice).then(function (res) {
      console.log(res);
      if (res.body.result.size != 0) {
        this.notice = res.body.result.list;

        for (var i = 0; i < this.notice.length; i++) {
          this.list[i] = new Object();
          this.list[i].src = "../static/image/notice_pic.jpg";
          this.list[i].title = this.notice[i].title;
          this.list[i].url = "/notice_list?newid=" + this.notice[i].news_id + "&comnCode=" + comnCode + "&phone=" + phone + "&openid=" + openid;
          this.list[i].meta = new Object();
          this.list[i].meta.date = this.notice[i].createTime;
        }
        this.beginload = true;
        this.lastNum = res.body.result.size;
      }
    }, function (err) {});
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.getMoreNotice);
    if (this.$router.history.current.path == "/notice") {
      document.title = "社区公告";
    }
  },

  methods: {
    getMoreNotice: function getMoreNotice() {
      /*正式环境*/
      var urlnotice = global.host + "news/getNewsByTypeEqNotice?comnCode=" + this.$router.history.current.query.communityId + "&pageNum=" + this.pageNum + "&rows=" + this.rows;
      /*测试环境*/

      var trueH = window.innerHeight;
      var scrollH = window.scrollY;
      var totalH = document.getElementById("app").clientHeight;
      var shengyuH = totalH - trueH;

      var comnCode = this.$router.history.current.query.communityId;
      var openid = this.$router.history.current.query.openid;
      var phone = this.$router.history.current.query.phone;

      if (scrollH >= shengyuH) {

        if (this.lastNum == this.rows) {
          this.$refs.lod.style.display = "block";
          this.pageNum++;
          console.log("滚动成功");
          this.$http.get(global.host + "news/getNewsByTypeEqNotice?comnCode=" + this.$router.history.current.query.communityId + "&pageNum=" + this.pageNum + "&rows=" + this.rows).then(function (res) {
            console.log("发送成功");
            console.log(res);
            var newData = res.body.result.list;
            this.lastNum = res.body.result.size;
            console.log(this.pageNum);
            if (res.body.result.size == 0) {
              /*阻止无用的请求*/
              window.removeEventListener("scroll", this.getMoreNews);
              return;
            }
            if (newData && newData.length > 0) {
              var newNews = new Array();
              for (var i = 0; i < newData.length; i++) {
                newNews[i] = new Object();
                newNews[i].src = "../static/image/notice_pic.jpg";
                newNews[i].title = newData[i].title;
                newNews[i].url = "/notice_list?newid=" + newData[i].news_id + "&comnCode=" + comnCode + "&phone=" + phone + "&openid=" + openid;
                newNews[i].meta = new Object();
                newNews[i].meta.date = newData[i].createTime;
              }
              for (var j = 0; j < newNews.length; j++) {
                this.list.push(newNews[j]);
                this.$refs.lod.style.display = "none";
              }
            }
          }, function (err) {
            console.log(res);
          });
        } else {
          console.log(this.lastNum);
          this.$refs.lod.style.display = "none";
          if (this.$refs.lod.style.display == "none") {
            this.$refs.noS.style.display = "block";
          }
          return;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-533b3046","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/newComponents/notice.vue
var notice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notice"}},[(_vm.notice)?_c('div',[_c('img',{staticClass:"notice_img",attrs:{"src":__webpack_require__("SQkJ"),"alt":""}}),_vm._v(" "),(_vm.beginload)?_c('div',{attrs:{"id":"newlist"}},[_c('panel',{attrs:{"list":_vm.list,"type":"5"}}),_vm._v(" "),_c('div',{ref:"lod",staticStyle:{"display":"none"}},[_c('load-more',{attrs:{"tip":"正在加载"}})],1),_vm._v(" "),_c('div',{ref:"noS",staticStyle:{"font-size":"13px","color":"#ccc","text-align":"center","display":"none"}},[_vm._v("暂无更多数据")])],1):_vm._e()]):_c('div',{staticStyle:{"padding-top":"55%"}},[_c('load-more',{attrs:{"tip":"正在加载"}})],1)])}
var notice_staticRenderFns = []
var notice_esExports = { render: notice_render, staticRenderFns: notice_staticRenderFns }
/* harmony default export */ var components_newComponents_notice = (notice_esExports);
// CONCATENATED MODULE: ./src/components/newComponents/notice.vue
function notice_injectStyle (ssrContext) {
  __webpack_require__("NqXR")
  __webpack_require__("0kVb")
}
var notice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var notice___vue_template_functional__ = false
/* styles */
var notice___vue_styles__ = notice_injectStyle
/* scopeId */
var notice___vue_scopeId__ = "data-v-533b3046"
/* moduleIdentifier (server only) */
var notice___vue_module_identifier__ = null
var notice_Component = notice_normalizeComponent(
  newComponents_notice,
  components_newComponents_notice,
  notice___vue_template_functional__,
  notice___vue_styles__,
  notice___vue_scopeId__,
  notice___vue_module_identifier__
)

/* harmony default export */ var src_components_newComponents_notice = (notice_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/detailNew.vue





/* harmony default export */ var detailNew = ({
  components: {
    XHeader: vux_src_components_x_header,
    LoadMore: vux_src_components_load_more
  },
  data: function data() {
    return {
      content: ''
    };
  },
  beforeMount: function beforeMount() {
    this.$http.get(global.host + 'news/getNewsById?id=' + this.$router.history.current.query.newid).then(function (res) {
      if (res.body.result) {
        console.log(res);
        this.content = res.body.result.content + "<style>img{widht:100%;max-width:100%;height:auto;}</style>";
      }
    }, function (err) {});
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/detailNew.vue





/* harmony default export */ var newComponents_detailNew = ({
  components: {
    XHeader: vux_src_components_x_header,
    LoadMore: vux_src_components_load_more
  },
  data: function data() {
    return {
      content: ''
    };
  },
  beforeMount: function beforeMount() {
    this.$http.get(global.host + 'news/getNewsById?id=' + this.$router.history.current.query.newid).then(function (res) {
      if (res.body.result) {
        console.log(res);
        this.content = res.body.result.content + "<style>img{widht:100%;max-width:100%;height:auto;}</style>";
      }
    }, function (err) {});
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70a04d17","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/newComponents/detailNew.vue
var detailNew_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',{staticStyle:{"padding-top":"55%"}},[_c('load-more',{attrs:{"tip":"正在加载"}})],1)])}
var detailNew_staticRenderFns = []
var detailNew_esExports = { render: detailNew_render, staticRenderFns: detailNew_staticRenderFns }
/* harmony default export */ var components_newComponents_detailNew = (detailNew_esExports);
// CONCATENATED MODULE: ./src/components/newComponents/detailNew.vue
function detailNew_injectStyle (ssrContext) {
  __webpack_require__("hv1Y")
}
var detailNew_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var detailNew___vue_template_functional__ = false
/* styles */
var detailNew___vue_styles__ = detailNew_injectStyle
/* scopeId */
var detailNew___vue_scopeId__ = "data-v-70a04d17"
/* moduleIdentifier (server only) */
var detailNew___vue_module_identifier__ = null
var detailNew_Component = detailNew_normalizeComponent(
  newComponents_detailNew,
  components_newComponents_detailNew,
  detailNew___vue_template_functional__,
  detailNew___vue_styles__,
  detailNew___vue_scopeId__,
  detailNew___vue_module_identifier__
)

/* harmony default export */ var src_components_newComponents_detailNew = (detailNew_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/infoPublic.vue




/* harmony default export */ var infoPublic = ({
  components: {
    LoadMore: vux_src_components_load_more
  },
  data: function data() {
    return {
      content: ''
    };
  },
  beforeMount: function beforeMount() {
    /*正式环境*/
    var urlnotice = global.host + 'news/getNewsByTypeEqPublic?comnCode=' + this.$router.history.current.query.communityId + '&pageNum=1';
    /*测试环境*/

    this.$http.get(urlnotice).then(function (res) {
      if (res.body.result.list) {
        this.content = res.body.result.list[0].content + "<style>img{width:100%;height:auto;max-width:100%;}</style>";
      }
    }, function (err) {
      console.log(err);
    });
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/infoPublic") {
      document.title = "信息公开";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/infoPublic.vue




/* harmony default export */ var newComponents_infoPublic = ({
  components: {
    LoadMore: vux_src_components_load_more
  },
  data: function data() {
    return {
      content: ''
    };
  },
  beforeMount: function beforeMount() {
    /*正式环境*/
    var urlnotice = global.host + 'news/getNewsByTypeEqPublic?comnCode=' + this.$router.history.current.query.communityId + '&pageNum=1';
    /*测试环境*/

    this.$http.get(urlnotice).then(function (res) {
      if (res.body.result.list) {
        this.content = res.body.result.list[0].content + "<style>img{width:100%;height:auto;max-width:100%;}</style>";
      }
    }, function (err) {
      console.log(err);
    });
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/infoPublic") {
      document.title = "信息公开";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c202d02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/newComponents/infoPublic.vue
var infoPublic_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',{staticStyle:{"padding-top":"55%"}},[_c('load-more',{attrs:{"tip":"正在加载"}})],1)])}
var infoPublic_staticRenderFns = []
var infoPublic_esExports = { render: infoPublic_render, staticRenderFns: infoPublic_staticRenderFns }
/* harmony default export */ var components_newComponents_infoPublic = (infoPublic_esExports);
// CONCATENATED MODULE: ./src/components/newComponents/infoPublic.vue
var infoPublic_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var infoPublic___vue_template_functional__ = false
/* styles */
var infoPublic___vue_styles__ = null
/* scopeId */
var infoPublic___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var infoPublic___vue_module_identifier__ = null
var infoPublic_Component = infoPublic_normalizeComponent(
  newComponents_infoPublic,
  components_newComponents_infoPublic,
  infoPublic___vue_template_functional__,
  infoPublic___vue_styles__,
  infoPublic___vue_scopeId__,
  infoPublic___vue_module_identifier__
)

/* harmony default export */ var src_components_newComponents_infoPublic = (infoPublic_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/about.vue




/* harmony default export */ var about = ({
  components: {
    XImg: vux_src_components_x_img
  },
  data: function data() {
    return {
      src: global.imgUrl + '/image/applogo.jpg'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/about.vue




/* harmony default export */ var newComponents_about = ({
  components: {
    XImg: vux_src_components_x_img
  },
  data: function data() {
    return {
      src: global.imgUrl + '/image/applogo.jpg'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5389103e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/newComponents/about.vue
var about_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"head"},[_c('x-img',{attrs:{"src":_vm.src}}),_vm._v(" "),_c('h5',[_vm._v("优每家 1.0.1")])],1),_vm._v(" "),_c('p',[_vm._v("服务介绍")]),_vm._v(" "),_c('p',[_vm._v("优每家服务号致力于打造社区生活一键式服务体验。")]),_vm._v(" "),_c('p',[_vm._v("社区缴费移动化——无需跑路随时随地可以缴纳")]),_vm._v(" "),_c('p',[_vm._v("信息发布电子化——平台内快捷信息发布再也不用为出租贴广告发愁了")]),_vm._v(" "),_c('p',[_vm._v("信息公开精准化——再也不会错过重要得通告了")]),_vm._v(" "),_c('p',[_vm._v("报事报修流程化——专人对接、实时查看进程、再也不担心会抹黑回家了")]),_vm._v(" "),_c('p',{staticStyle:{"padding":"10px 15px"}},[_vm._v("商务合作")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"3em"}},[_vm._v("商务合作邮箱：hao.zhang@datad.cc")]),_vm._v(" "),_c('p',{staticStyle:{"padding":"10px 15px"}},[_vm._v("用户反馈")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"3em"}},[_vm._v("用户反馈邮箱：lei.zhang@datad.cc")])])}
var about_staticRenderFns = []
var about_esExports = { render: about_render, staticRenderFns: about_staticRenderFns }
/* harmony default export */ var components_newComponents_about = (about_esExports);
// CONCATENATED MODULE: ./src/components/newComponents/about.vue
function about_injectStyle (ssrContext) {
  __webpack_require__("5933")
}
var about_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var about___vue_template_functional__ = false
/* styles */
var about___vue_styles__ = about_injectStyle
/* scopeId */
var about___vue_scopeId__ = "data-v-5389103e"
/* moduleIdentifier (server only) */
var about___vue_module_identifier__ = null
var about_Component = about_normalizeComponent(
  newComponents_about,
  components_newComponents_about,
  about___vue_template_functional__,
  about___vue_styles__,
  about___vue_scopeId__,
  about___vue_module_identifier__
)

/* harmony default export */ var src_components_newComponents_about = (about_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/notice_list.vue





/* harmony default export */ var notice_list = ({
  components: {
    XHeader: vux_src_components_x_header,
    LoadMore: vux_src_components_load_more
  },
  data: function data() {
    return {
      content: '',
      title: '',
      totals: '',
      createTime: ''
    };
  },
  beforeMount: function beforeMount() {
    var urlnotice = global.host + 'news/getNewsById?id=' + this.$router.history.current.query.newid + '&pageNum=1';
    this.$http.get(urlnotice).then(function (res) {
      if (res.body.result) {
        console.log(res);
        this.content = res.body.result.content + "<style>img{widht:100%;max-width:100%;height:auto;}</style>";
        this.title = res.body.result.title;
        this.totals = res.body.result.totals;
        this.createTime = res.body.result.createTime;
        this.changeReadNum();
      }
    }, function (err) {
      console.log(res);
    });
  },

  methods: {
    changeReadNum: function changeReadNum() {
      var usInfo = new Object();
      usInfo.comnCode = this.$router.history.current.query.comnCode;
      usInfo.openId = this.$router.history.current.query.openid;
      usInfo.phoneNo = this.$router.history.current.query.phone;
      usInfo.sourceId = this.$router.history.current.query.newid;
      usInfo.uvSource = 'notice';
      console.log("%%%%%%%%%%%%%");
      console.log(usInfo.sourceId);
      var urls = global.host + "news/readnumber";
      this.$http.post(urls, usInfo).then(function (res) {
        console.log(res);
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/newComponents/notice_list.vue





/* harmony default export */ var newComponents_notice_list = ({
  components: {
    XHeader: vux_src_components_x_header,
    LoadMore: vux_src_components_load_more
  },
  data: function data() {
    return {
      content: '',
      title: '',
      totals: '',
      createTime: ''
    };
  },
  beforeMount: function beforeMount() {
    var urlnotice = global.host + 'news/getNewsById?id=' + this.$router.history.current.query.newid + '&pageNum=1';
    this.$http.get(urlnotice).then(function (res) {
      if (res.body.result) {
        console.log(res);
        this.content = res.body.result.content + "<style>img{widht:100%;max-width:100%;height:auto;}</style>";
        this.title = res.body.result.title;
        this.totals = res.body.result.totals;
        this.createTime = res.body.result.createTime;
        this.changeReadNum();
      }
    }, function (err) {
      console.log(res);
    });
  },

  methods: {
    changeReadNum: function changeReadNum() {
      var usInfo = new Object();
      usInfo.comnCode = this.$router.history.current.query.comnCode;
      usInfo.openId = this.$router.history.current.query.openid;
      usInfo.phoneNo = this.$router.history.current.query.phone;
      usInfo.sourceId = this.$router.history.current.query.newid;
      usInfo.uvSource = 'notice';
      console.log("%%%%%%%%%%%%%");
      console.log(usInfo.sourceId);
      var urls = global.host + "news/readnumber";
      this.$http.post(urls, usInfo).then(function (res) {
        console.log(res);
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ff109ab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/newComponents/notice_list.vue
var notice_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"notice_img",attrs:{"src":__webpack_require__("SQkJ"),"alt":""}}),_vm._v(" "),_c('h4',{staticStyle:{"font-weight":"700","text-align":"center","margin-top":"20px","font-size":"1.2rem","margin":"0 20px"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","color":"rgb(87, 166, 224)","font-size":"12px","padding-left":"15px"}},[_c('span',[_vm._v("发布时间：")]),_c('span',[_vm._v(_vm._s(_vm.createTime))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","color":"rgb(87, 166, 224)","font-size":"12px","margin":"4px 15px 0 0","float":"right"}},[_c('span',[_vm._v("阅读量：")]),_c('span',[_vm._v(_vm._s(_vm.totals))])]),_vm._v(" "),(_vm.content)?_c('div',{staticStyle:{"padding":"10px"},domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',{staticStyle:{"padding-top":"55%"}},[_c('load-more',{attrs:{"tip":"正在加载"}})],1)])}
var notice_list_staticRenderFns = []
var notice_list_esExports = { render: notice_list_render, staticRenderFns: notice_list_staticRenderFns }
/* harmony default export */ var components_newComponents_notice_list = (notice_list_esExports);
// CONCATENATED MODULE: ./src/components/newComponents/notice_list.vue
function notice_list_injectStyle (ssrContext) {
  __webpack_require__("uQHm")
}
var notice_list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var notice_list___vue_template_functional__ = false
/* styles */
var notice_list___vue_styles__ = notice_list_injectStyle
/* scopeId */
var notice_list___vue_scopeId__ = "data-v-3ff109ab"
/* moduleIdentifier (server only) */
var notice_list___vue_module_identifier__ = null
var notice_list_Component = notice_list_normalizeComponent(
  newComponents_notice_list,
  components_newComponents_notice_list,
  notice_list___vue_template_functional__,
  notice_list___vue_styles__,
  notice_list___vue_scopeId__,
  notice_list___vue_module_identifier__
)

/* harmony default export */ var src_components_newComponents_notice_list = (notice_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/yellowPage.vue







/* harmony default export */ var yellowPage = ({
  components: {
    Group: group["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */]
  },
  data: function data() {
    return {
      loopList: []
    };
  },
  beforeMount: function beforeMount() {
    var obj = new Object();
    obj.img = global.imgUrl + '/image/banner1.png';
    var obj2 = new Object();
    obj2.img = global.imgUrl + '/image/banner2.jpg';
    this.loopList.push(obj);
    this.loopList.push(obj2);
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/yellowpage") {
      document.title = "便民黄页";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/yellowPage.vue







/* harmony default export */ var convenientComponents_yellowPage = ({
  components: {
    Group: group["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */]
  },
  data: function data() {
    return {
      loopList: []
    };
  },
  beforeMount: function beforeMount() {
    var obj = new Object();
    obj.img = global.imgUrl + '/image/banner1.png';
    var obj2 = new Object();
    obj2.img = global.imgUrl + '/image/banner2.jpg';
    this.loopList.push(obj);
    this.loopList.push(obj2);
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/yellowpage") {
      document.title = "便民黄页";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa6e0b9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenientComponents/yellowPage.vue
var yellowPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('swiper',{staticStyle:{"width":"100%"},attrs:{"list":_vm.loopList,"aspect-ratio":100/200,"auto":"","dots-class":"custom-bottom","dots-position":"center"}})],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"box"},[_c('div',{staticClass:"addBorder",staticStyle:{"border-right":"1px solid #ddd","padding-top":"17px"}},[_c('router-link',{attrs:{"to":{path:'/convenientDetail/all',query:{communityId:this.$router.history.current.query.communityId,moduleId:1,serverId:2}}}},[_c('span',[_c('i',{staticClass:"iconfont icon-weibiaoti-_huabanfuben",staticStyle:{"font-size":"55px"}})])]),_vm._v(" "),_c('h4',{staticStyle:{"margin-top":"-7px"}},[_vm._v("物业电话")]),_vm._v(" "),_c('p',[_vm._v("缴费咨询|小区安保|投诉电话")])],1)]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"addBorder",staticStyle:{"padding-top":"26px"}},[_c('router-link',{attrs:{"to":{path:'/convenientDetail/all',query:{communityId:this.$router.history.current.query.communityId,moduleId:2,serverId:2}}}},[_c('span',[_c('i',{staticClass:"iconfont icon-kuaidi"})])]),_vm._v(" "),_c('h4',[_vm._v("快递电话")]),_vm._v(" "),_c('p',[_vm._v("顺丰|邮政|韵达|圆通等")])],1)]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"box"},[_c('div',{staticClass:"addBorder",staticStyle:{"border-right":"1px solid #ddd"}},[_c('router-link',{attrs:{"to":{path:'/convenientDetail/all',query:{communityId:this.$router.history.current.query.communityId,moduleId:3,serverId:2}}}},[_c('span',[_c('i',{staticClass:"iconfont icon-erji-zuzhijigou"})])]),_vm._v(" "),_c('h4',[_vm._v("机构单位")]),_vm._v(" "),_c('p',[_vm._v("社区|银行|医院")])],1)]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"addBorder"},[_c('router-link',{attrs:{"to":{path:'/convenientDetail/all',query:{communityId:this.$router.history.current.query.communityId,moduleId:4,serverId:2}}}},[_c('span',[_c('i',{staticClass:"iconfont icon-yuangonghuangye"})])]),_vm._v(" "),_c('h4',[_vm._v("便民电话")]),_vm._v(" "),_c('p',[_vm._v("送水|话费|天然气|路线查询")])],1)]),_vm._v(" "),_c('div',{staticClass:"clear"})])])}
var yellowPage_staticRenderFns = []
var yellowPage_esExports = { render: yellowPage_render, staticRenderFns: yellowPage_staticRenderFns }
/* harmony default export */ var components_convenientComponents_yellowPage = (yellowPage_esExports);
// CONCATENATED MODULE: ./src/components/convenientComponents/yellowPage.vue
function yellowPage_injectStyle (ssrContext) {
  __webpack_require__("n8Fz")
}
var yellowPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var yellowPage___vue_template_functional__ = false
/* styles */
var yellowPage___vue_styles__ = yellowPage_injectStyle
/* scopeId */
var yellowPage___vue_scopeId__ = "data-v-fa6e0b9c"
/* moduleIdentifier (server only) */
var yellowPage___vue_module_identifier__ = null
var yellowPage_Component = yellowPage_normalizeComponent(
  convenientComponents_yellowPage,
  components_convenientComponents_yellowPage,
  yellowPage___vue_template_functional__,
  yellowPage___vue_styles__,
  yellowPage___vue_scopeId__,
  yellowPage___vue_module_identifier__
)

/* harmony default export */ var src_components_convenientComponents_yellowPage = (yellowPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        backgroundColor: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.backgroundColor = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.backgroundColor = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        backgroundColor: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.backgroundColor = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.backgroundColor = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6448486f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var tab_staticRenderFns = []
var tab_esExports = { render: tab_render, staticRenderFns: tab_staticRenderFns }
/* harmony default export */ var components_tab_tab = (tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function tab_injectStyle (ssrContext) {
  __webpack_require__("fcPa")
}
var tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab___vue_template_functional__ = false
/* styles */
var tab___vue_styles__ = tab_injectStyle
/* scopeId */
var tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab___vue_module_identifier__ = null
var tab_Component = tab_normalizeComponent(
  tab_tab,
  components_tab_tab,
  tab___vue_template_functional__,
  tab___vue_styles__,
  tab___vue_scopeId__,
  tab___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b03591","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/convenientDetail.vue







/* harmony default export */ var convenientDetail = ({
  components: {
    Group: group["a" /* default */],
    XInput: x_input["a" /* default */],
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  },
  data: function data() {
    return {
      bgimg: '',
      keyword: ''
    };
  },
  beforeMount: function beforeMount() {
    this.bgimg = global.imgUrl + '/image/bg.jpg';
    console.log(this.bgimg);
  },

  methods: {
    onItemClick: function onItemClick(index) {
      if (index == 1) {
        this.$router.push({ path: '/convenientDetail/favorite', query: { communityId: communityId, moduleId: this.$router.history.current.query.moduleId, serverId: this.$router.history.current.query.serverId } });
      } else {
        this.$router.push({ path: '/convenientDetail/all', query: { communityId: communityId, moduleId: this.$router.history.current.query.moduleId, serverId: this.$router.history.current.query.serverId } });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/convenientDetail.vue







/* harmony default export */ var convenientComponents_convenientDetail = ({
  components: {
    Group: group["a" /* default */],
    XInput: x_input["a" /* default */],
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  },
  data: function data() {
    return {
      bgimg: '',
      keyword: ''
    };
  },
  beforeMount: function beforeMount() {
    this.bgimg = global.imgUrl + '/image/bg.jpg';
    console.log(this.bgimg);
  },

  methods: {
    onItemClick: function onItemClick(index) {
      if (index == 1) {
        this.$router.push({ path: '/convenientDetail/favorite', query: { communityId: communityId, moduleId: this.$router.history.current.query.moduleId, serverId: this.$router.history.current.query.serverId } });
      } else {
        this.$router.push({ path: '/convenientDetail/all', query: { communityId: communityId, moduleId: this.$router.history.current.query.moduleId, serverId: this.$router.history.current.query.serverId } });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3186af2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenientComponents/convenientDetail.vue
var convenientDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"searchbg",style:({'backgroundImage': 'url(' +_vm.bgimg+ ')',})},[_c('div',{staticClass:"search"},[_c('div',{staticClass:"input"},[_c('group',[_c('x-input',{staticStyle:{"font-size":"0.6em"},attrs:{"placeholder":"请输入关键字（检索主要业务）"},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"submit"},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-search-strong",staticStyle:{"fill":"white"},attrs:{"type":"ios-search-strong","size":"35","xmlns":"http://www.w3.org/2000/svg","width":"35","height":"35","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M344.5 298c15-23.6 23.8-51.6 23.8-81.7 0-84.1-68.1-152.3-152.1-152.3C132.1 64 64 132.2 64 216.3c0 84.1 68.1 152.3 152.1 152.3 30.5 0 58.9-9 82.7-24.4l6.9-4.8L414.3 448l33.7-34.3-108.5-108.6 5-7.1zm-43.1-166.8c22.7 22.7 35.2 52.9 35.2 85s-12.5 62.3-35.2 85c-22.7 22.7-52.9 35.2-85 35.2s-62.3-12.5-85-35.2c-22.7-22.7-35.2-52.9-35.2-85s12.5-62.3 35.2-85c22.7-22.7 52.9-35.2 85-35.2s62.3 12.5 85 35.2z"}})])]),_vm._v(" "),_c('div',{staticClass:"clear"})])]),_vm._v(" "),_c('router-view')],1)}
var convenientDetail_staticRenderFns = []
var convenientDetail_esExports = { render: convenientDetail_render, staticRenderFns: convenientDetail_staticRenderFns }
/* harmony default export */ var components_convenientComponents_convenientDetail = (convenientDetail_esExports);
// CONCATENATED MODULE: ./src/components/convenientComponents/convenientDetail.vue
function convenientDetail_injectStyle (ssrContext) {
  __webpack_require__("x1DB")
}
var convenientDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var convenientDetail___vue_template_functional__ = false
/* styles */
var convenientDetail___vue_styles__ = convenientDetail_injectStyle
/* scopeId */
var convenientDetail___vue_scopeId__ = "data-v-f3186af2"
/* moduleIdentifier (server only) */
var convenientDetail___vue_module_identifier__ = null
var convenientDetail_Component = convenientDetail_normalizeComponent(
  convenientComponents_convenientDetail,
  components_convenientComponents_convenientDetail,
  convenientDetail___vue_template_functional__,
  convenientDetail___vue_styles__,
  convenientDetail___vue_scopeId__,
  convenientDetail___vue_module_identifier__
)

/* harmony default export */ var src_components_convenientComponents_convenientDetail = (convenientDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/convenientList.vue





/* harmony default export */ var convenientList = ({
  components: {
    XImg: vux_src_components_x_img,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      list: []
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    this.src = 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1527745997085&di=fa62639b1d121b745c28e5db83f47dc2&imgtype=0&src=http%3A%2F%2Fmvimg1.meitudata.com%2F5654458af11156661.jpg';
    this.$http.get(global.host + 'conven/findtitle?comnCode=' + this.$router.history.current.query.communityId + "&serviceType=" + this.$router.history.current.query.serverId + '&moduleType=' + this.$router.history.current.query.moduleId).then(function (res) {
      this.show_1 = false;
      var data = res.body.result;
      var sizeof = this.list.length;
      for (var i = 0; i < sizeof; i++) {
        this.list.pop();
      }
      for (var _i = 0; _i < data.length; _i++) {
        data[_i].src = global.imgUrl + data[_i].serviceIcon;
        this.list.push(data[_i]);
      }

      console.log(res);
    }, function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/convenientList.vue





/* harmony default export */ var convenientComponents_convenientList = ({
  components: {
    XImg: vux_src_components_x_img,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      list: []
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    this.src = 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1527745997085&di=fa62639b1d121b745c28e5db83f47dc2&imgtype=0&src=http%3A%2F%2Fmvimg1.meitudata.com%2F5654458af11156661.jpg';
    this.$http.get(global.host + 'conven/findtitle?comnCode=' + this.$router.history.current.query.communityId + "&serviceType=" + this.$router.history.current.query.serverId + '&moduleType=' + this.$router.history.current.query.moduleId).then(function (res) {
      this.show_1 = false;
      var data = res.body.result;
      var sizeof = this.list.length;
      for (var i = 0; i < sizeof; i++) {
        this.list.pop();
      }
      for (var _i = 0; _i < data.length; _i++) {
        data[_i].src = global.imgUrl + data[_i].serviceIcon;
        this.list.push(data[_i]);
      }

      console.log(res);
    }, function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18600d10","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenientComponents/convenientList.vue
var convenientList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"left",staticStyle:{"width":"25%","margin-right":"2%"}},[_c('div',{staticClass:"circle"},[_c('x-img',{staticStyle:{"min-height":"81px"},attrs:{"src":item.serviceIcon}})],1)]),_vm._v(" "),_c('div',{staticClass:"left",staticStyle:{"width":"72%","position":"relative"}},[_c('p',[_c('span',[_vm._v(_vm._s(item.serviceTitle))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v(_vm._s(item.serviceDesc))])]),_vm._v(" "),_c('p',[_c('i',{staticClass:"iconfont icon-dianhua1"}),_c('span',[_vm._v(_vm._s(item.telePhone))])]),_vm._v(" "),_c('p',[_c('i',{staticClass:"iconfont icon-weizhi"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.serviceAddr))])]),_vm._v(" "),_c('span',[_c('a',{attrs:{"href":'tel:' + item.telePhone}},[_c('i',{staticClass:"iconfont icon-dianhua",staticStyle:{"position":"absolute","top":"15px","right":"25px","font-size":"40px"}})]),_vm._v(" "),_c('router-link',{attrs:{"to":{path:'/conventientSellDetail',query:{serviceID:item.serviceID}}}},[_c('i',{staticClass:"iconfont icon-gengduo",staticStyle:{"position":"absolute","top":"35px","right":"10px"}})])],1)]),_vm._v(" "),_c('div',{staticClass:"clear"})])}),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],2)}
var convenientList_staticRenderFns = []
var convenientList_esExports = { render: convenientList_render, staticRenderFns: convenientList_staticRenderFns }
/* harmony default export */ var components_convenientComponents_convenientList = (convenientList_esExports);
// CONCATENATED MODULE: ./src/components/convenientComponents/convenientList.vue
function convenientList_injectStyle (ssrContext) {
  __webpack_require__("HZwK")
}
var convenientList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var convenientList___vue_template_functional__ = false
/* styles */
var convenientList___vue_styles__ = convenientList_injectStyle
/* scopeId */
var convenientList___vue_scopeId__ = "data-v-18600d10"
/* moduleIdentifier (server only) */
var convenientList___vue_module_identifier__ = null
var convenientList_Component = convenientList_normalizeComponent(
  convenientComponents_convenientList,
  components_convenientComponents_convenientList,
  convenientList___vue_template_functional__,
  convenientList___vue_styles__,
  convenientList___vue_scopeId__,
  convenientList___vue_module_identifier__
)

/* harmony default export */ var src_components_convenientComponents_convenientList = (convenientList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/favorite.vue





/* harmony default export */ var favorite = ({
  components: {
    XImg: vux_src_components_x_img,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      src: '',
      list: []
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    this.src = 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1527745997085&di=fa62639b1d121b745c28e5db83f47dc2&imgtype=0&src=http%3A%2F%2Fmvimg1.meitudata.com%2F5654458af11156661.jpg';
    this.$http.get(global.host + 'conven/findtitle?comnCode=' + this.$router.history.current.query.communityId + "&serviceType=" + this.$router.history.current.query.serverId + '&moduleType=' + this.$router.history.current.query.moduleId).then(function (res) {
      var data = res.body.result;
      var sizeof = this.list.length;
      for (var i = 0; i < sizeof; i++) {
        this.list.pop();
      }
      for (var _i = 0; _i < data.length; _i++) {
        data[_i].src = global.imgUrl + data[_i].serviceIcon;
        this.list.push(data[_i]);
      }
      this.show_1 = false;
      console.log(res);
    }, function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/favorite.vue





/* harmony default export */ var convenientComponents_favorite = ({
  components: {
    XImg: vux_src_components_x_img,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      src: '',
      list: []
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    this.src = 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1527745997085&di=fa62639b1d121b745c28e5db83f47dc2&imgtype=0&src=http%3A%2F%2Fmvimg1.meitudata.com%2F5654458af11156661.jpg';
    this.$http.get(global.host + 'conven/findtitle?comnCode=' + this.$router.history.current.query.communityId + "&serviceType=" + this.$router.history.current.query.serverId + '&moduleType=' + this.$router.history.current.query.moduleId).then(function (res) {
      var data = res.body.result;
      var sizeof = this.list.length;
      for (var i = 0; i < sizeof; i++) {
        this.list.pop();
      }
      for (var _i = 0; _i < data.length; _i++) {
        data[_i].src = global.imgUrl + data[_i].serviceIcon;
        this.list.push(data[_i]);
      }
      this.show_1 = false;
      console.log(res);
    }, function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-483b70fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenientComponents/favorite.vue
var favorite_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"left",staticStyle:{"width":"25%","margin-right":"2%"}},[_c('div',{staticClass:"circle"},[_c('x-img',{staticStyle:{"min-height":"80px"},attrs:{"src":item.src}})],1)]),_vm._v(" "),_c('div',{staticClass:"left",staticStyle:{"width":"72%","position":"relative"}},[_c('p',[_c('span',[_vm._v(_vm._s(item.serviceTitle))]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-shoucang right",staticStyle:{"margin-right":"10px"}})]),_vm._v(" "),_c('p',[_c('span',[_vm._v(_vm._s(item.serviceDesc))])]),_vm._v(" "),_c('p',[_c('i',{staticClass:"iconfont icon-dianhua1"}),_c('span',[_vm._v(_vm._s(item.telePhone))])]),_vm._v(" "),_c('p',[_c('i',{staticClass:"iconfont icon-weizhi"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.serviceAddr))])]),_vm._v(" "),_c('span',[_c('a',{attrs:{"href":'tel:' + item.telePhone}},[_c('i',{staticClass:"iconfont icon-dianhua",staticStyle:{"position":"absolute","top":"15px","right":"25px","font-size":"40px"}})]),_c('i',{staticClass:"iconfont icon-gengduo",staticStyle:{"position":"absolute","top":"35px","right":"10px"}})])]),_vm._v(" "),_c('div',{staticClass:"clear"})])}),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],2)}
var favorite_staticRenderFns = []
var favorite_esExports = { render: favorite_render, staticRenderFns: favorite_staticRenderFns }
/* harmony default export */ var components_convenientComponents_favorite = (favorite_esExports);
// CONCATENATED MODULE: ./src/components/convenientComponents/favorite.vue
function favorite_injectStyle (ssrContext) {
  __webpack_require__("u6FZ")
}
var favorite_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var favorite___vue_template_functional__ = false
/* styles */
var favorite___vue_styles__ = favorite_injectStyle
/* scopeId */
var favorite___vue_scopeId__ = "data-v-483b70fc"
/* moduleIdentifier (server only) */
var favorite___vue_module_identifier__ = null
var favorite_Component = favorite_normalizeComponent(
  convenientComponents_favorite,
  components_convenientComponents_favorite,
  favorite___vue_template_functional__,
  favorite___vue_styles__,
  favorite___vue_scopeId__,
  favorite___vue_module_identifier__
)

/* harmony default export */ var src_components_convenientComponents_favorite = (favorite_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/server.vue











/* harmony default export */ var server = ({
  components: {
    Swiper: vux_src_components_swiper_swiper,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Group: group["a" /* default */],
    Alert: components_alert["a" /* default */],
    XInput: x_input["a" /* default */],
    XButton: vux_src_components_x_button,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      loopList: [],
      show: false
    };
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/convenientserver") {
      document.title = "便民服务";
    }
    this.show_1 = false;
    var obj = new Object();
    obj.img = global.imgUrl + '/image/banner3.png';
    var obj2 = new Object();
    obj2.img = global.imgUrl + '/image/banner4.jpg';
    this.loopList.push(obj);
    this.loopList.push(obj2);
    /*this.$http.get(global.host + 'users/personalCenter?').then(function(res){
    
    },function(err){
    console.log(err)
    })*/
  },

  methods: {
    change: function change() {
      console.log(1);
      this.show = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/server.vue











/* harmony default export */ var convenientComponents_server = ({
  components: {
    Swiper: vux_src_components_swiper_swiper,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Group: group["a" /* default */],
    Alert: components_alert["a" /* default */],
    XInput: x_input["a" /* default */],
    XButton: vux_src_components_x_button,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      loopList: [],
      show: false
    };
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/convenientserver") {
      document.title = "便民服务";
    }
    this.show_1 = false;
    var obj = new Object();
    obj.img = global.imgUrl + '/image/banner3.png';
    var obj2 = new Object();
    obj2.img = global.imgUrl + '/image/banner4.jpg';
    this.loopList.push(obj);
    this.loopList.push(obj2);
    /*this.$http.get(global.host + 'users/personalCenter?').then(function(res){
    
    },function(err){
    console.log(err)
    })*/
  },

  methods: {
    change: function change() {
      console.log(1);
      this.show = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48592705","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenientComponents/server.vue
var server_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('swiper',{staticStyle:{"width":"100%"},attrs:{"list":_vm.loopList,"aspect-ratio":100/200,"auto":"","dots-class":"custom-bottom","dots-position":"center"}})],1),_vm._v(" "),_c('flexbox',{attrs:{"orient":"horizontal","justify":"center","align":"center"}},[_c('flexbox-item',{staticClass:"am_content_server"},[_c('router-link',{attrs:{"to":{path:'/convenientDetail/all',query:{communityId:this.$router.history.current.query.communityId,moduleId:1,serverId:1}}}},[_c('div',{staticClass:"am_title"},[_c('h1',[_vm._v("保洁服务")]),_vm._v(" "),_c('p',[_vm._v("高效|经验丰富")])]),_vm._v(" "),_c('div',{staticClass:"am_img iconfont icon-rengongbaojie"})])],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_content_server"},[_c('router-link',{attrs:{"to":{path:'/convenientDetail/all',query:{communityId:this.$router.history.current.query.communityId,moduleId:2,serverId:1}}}},[_c('div',{staticClass:"am_title"},[_c('h1',[_vm._v("疏通管道")]),_vm._v(" "),_c('p',[_vm._v("专业|快速|彻底")])]),_vm._v(" "),_c('div',{staticClass:"am_img iconfont icon-guandaoshutong"})])],1)],1),_vm._v(" "),_c('flexbox',{attrs:{"orient":"horizontal","justify":"center","align":"center"}},[_c('flexbox-item',{staticClass:"am_content_server"},[_c('router-link',{attrs:{"to":{path:'/convenientDetail/all',query:{communityId:this.$router.history.current.query.communityId,moduleId:3,serverId:1}}}},[_c('div',{staticClass:"am_title"},[_c('h1',[_vm._v("干洗服务")]),_vm._v(" "),_c('p',[_vm._v("洁净|优惠|上门")])]),_vm._v(" "),_c('div',{staticClass:"am_img iconfont icon-xiyi"})])],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_content_server"},[_c('router-link',{attrs:{"to":{path:'/convenientDetail/all',query:{communityId:this.$router.history.current.query.communityId,moduleId:4,serverId:1}}}},[_c('div',{staticClass:"am_title"},[_c('h1',[_vm._v("家电维修")]),_vm._v(" "),_c('p',[_vm._v("品牌|经验丰富")])]),_vm._v(" "),_c('div',{staticClass:"am_img iconfont icon-weixiu1"})])],1)],1),_vm._v(" "),_c('flexbox',{attrs:{"orient":"horizontal","justify":"center","align":"center"}},[_c('flexbox-item',{staticClass:"am_content_server"},[_c('router-link',{attrs:{"to":{path:'/convenientDetail/all',query:{communityId:this.$router.history.current.query.communityId,moduleId:5,serverId:1}}}},[_c('div',{staticClass:"am_title"},[_c('h1',[_vm._v("开锁配锁")]),_vm._v(" "),_c('p',[_vm._v("公安备案|可靠")])]),_vm._v(" "),_c('div',{staticClass:"am_img iconfont icon-kaisuohuansuo"})])],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_content_server"},[_c('router-link',{attrs:{"to":{path:'/convenientDetail/all',query:{communityId:this.$router.history.current.query.communityId,moduleId:6,serverId:1}}}},[_c('div',{staticClass:"am_title"},[_c('h1',[_vm._v("搬家服务")]),_vm._v(" "),_c('p',[_vm._v("随叫随到|安心")])]),_vm._v(" "),_c('div',{staticClass:"am_img iconfont icon-banjiapeisong"})])],1)],1),_vm._v(" "),_c('flexbox',{attrs:{"orient":"horizontal","justify":"center","align":"center"}},[_c('flexbox-item',{staticClass:"am_content_server"},[_c('router-link',{attrs:{"to":{path:'/convenientDetail/all',query:{communityId:this.$router.history.current.query.communityId,moduleId:7,serverId:1}}}},[_c('div',{staticClass:"am_title"},[_c('h1',[_vm._v("送水服务")]),_vm._v(" "),_c('p',[_vm._v("快捷|纯净|安全")])]),_vm._v(" "),_c('div',{staticClass:"am_img iconfont icon-shui1"})])],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_content_server"},[_c('router-link',{attrs:{"to":{path:'/convenientDetail/all',query:{communityId:this.$router.history.current.query.communityId,moduleId:8,serverId:1}}}},[_c('div',{staticClass:"am_title"},[_c('h1',[_vm._v("快递服务")]),_vm._v(" "),_c('p',[_vm._v("上门服务|省心")])]),_vm._v(" "),_c('div',{staticClass:"am_img iconfont icon-kuaidi"})])],1)],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v("暂无入驻服务，敬请期待")])],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var server_staticRenderFns = []
var server_esExports = { render: server_render, staticRenderFns: server_staticRenderFns }
/* harmony default export */ var components_convenientComponents_server = (server_esExports);
// CONCATENATED MODULE: ./src/components/convenientComponents/server.vue
function server_injectStyle (ssrContext) {
  __webpack_require__("Gmjg")
}
var server_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var server___vue_template_functional__ = false
/* styles */
var server___vue_styles__ = server_injectStyle
/* scopeId */
var server___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var server___vue_module_identifier__ = null
var server_Component = server_normalizeComponent(
  convenientComponents_server,
  components_convenientComponents_server,
  server___vue_template_functional__,
  server___vue_styles__,
  server___vue_scopeId__,
  server___vue_module_identifier__
)

/* harmony default export */ var src_components_convenientComponents_server = (server_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/conventientParticular.vue
//
//
//
//
//
//

/* harmony default export */ var conventientParticular = ({});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/conventientParticular.vue
//
//
//
//
//
//

/* harmony default export */ var convenientComponents_conventientParticular = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c08313d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenientComponents/conventientParticular.vue
var conventientParticular_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var conventientParticular_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("详情页面")])])}]
var conventientParticular_esExports = { render: conventientParticular_render, staticRenderFns: conventientParticular_staticRenderFns }
/* harmony default export */ var components_convenientComponents_conventientParticular = (conventientParticular_esExports);
// CONCATENATED MODULE: ./src/components/convenientComponents/conventientParticular.vue
function conventientParticular_injectStyle (ssrContext) {
  __webpack_require__("QxR1")
}
var conventientParticular_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var conventientParticular___vue_template_functional__ = false
/* styles */
var conventientParticular___vue_styles__ = conventientParticular_injectStyle
/* scopeId */
var conventientParticular___vue_scopeId__ = "data-v-6c08313d"
/* moduleIdentifier (server only) */
var conventientParticular___vue_module_identifier__ = null
var conventientParticular_Component = conventientParticular_normalizeComponent(
  convenientComponents_conventientParticular,
  components_convenientComponents_conventientParticular,
  conventientParticular___vue_template_functional__,
  conventientParticular___vue_styles__,
  conventientParticular___vue_scopeId__,
  conventientParticular___vue_module_identifier__
)

/* harmony default export */ var src_components_convenientComponents_conventientParticular = (conventientParticular_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/myEnter.vue

















/* harmony default export */ var myEnter = ({
  components: {
    FlexboxItem: flexbox_item["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    XHeader: vux_src_components_x_header,
    Group: group["a" /* default */],
    Cell: cell["a" /* default */],
    XImg: vux_src_components_x_img,
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Alert: components_alert["a" /* default */],
    loadPage: src_components_loadingPage,
    $: jquery_default.a
  },
  data: function data() {
    return {
      imgs: [],
      sellerName: '',
      connectPerson: '',
      mobile: '',
      sellerPlace: '',
      value1: [''],
      list1: [[]],
      value2: [''],
      value3: [],
      list2: [[]],
      sayDetail: '',
      keys: '',
      showprompt: false,
      prompt: "",
      comnList: '',
      moduleType: '',
      scopeBusiness: '',
      dmlist: '',
      show_1: false,
      text_1: '',
      useragent: ''
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = false;
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
    var url = global.host + 'community/getList';
    this.$http.get(url).then(function (res) {
      var mlist = res.body.result;
      /*   let arr = new Array();
      this.keys = new Object();*/
      this.dmlist = res.body.result;
      for (var s in mlist) {
        /*let json1 = {"comncode":mlist[s].comnCode};
        this.value3.push(json1);*/
        this.list2[0].push(mlist[s].comnName);
      }
    }, function (err) {
      console.log(err);
    });

    var urls = global.host + 'dict/getParamsByDoMain/SELLER_PUBLISH_TYPE';
    this.$http.get(urls).then(function (res) {
      var mtlist = res.body.result;
      this.comnList = res.body.result;
      /*let arr = new Array();
      this.keys = new Object();*/

      for (var s in mtlist) {
        this.list1[0].push(mtlist[s].pvalue);
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    add_img: function add_img(event) {
      var reader = new FileReader();
      var img1 = event.target.files[0];
      reader.readAsDataURL(img1);
      var that = this;
      reader.onloadend = function (event) {
        that.imgs.shift();

        var img = new Image();

        var width = 680,
            //图像大小
        quality = 0.8,
            //图像质量
        canvas = document.createElement("canvas"),
            drawer = canvas.getContext("2d");
        img.src = this.result;
        img.onload = function () {
          canvas.width = width;
          canvas.height = width * (img.height / img.width);
          drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
          var imgBase64 = canvas.toDataURL("image/jpeg", quality);
          that.imgs.push(imgBase64);
          img.src = "";
        };
      };
    },
    onChange: function onChange(result) {

      for (var s in this.comnList) {
        if (result == this.comnList[s].pvalue) {
          this.moduleType = this.comnList[s].pkey;
        }
      }
    },
    changeRz: function changeRz(results) {
      for (var m in this.dmlist) {
        if (results == this.dmlist[m].comnName) {
          var json1 = { "comncode": this.dmlist[m].comnCode };
          this.value3.push(json1);
          console.log(this.value3);
        }
      }
    },
    change: function change() {
      console.log(1);
      this.show = true;
    },
    sendAjax: function sendAjax() {
      var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (jquery_default()("#mId").find(".vux-cell-value").text() == "") {
        this.showprompt = true;
        this.prompt = "请选择入驻小区";
      } else if (this.imgs == "") {
        this.showprompt = true;
        this.prompt = "请上传商家图片";
      } else if (this.sellerName == "") {
        this.showprompt = true;
        this.prompt = "商家姓名不能为空";
      } else if (this.connectPerson == "") {
        this.showprompt = true;
        this.prompt = "联系人不能为空";
      } else if (this.mobile == "") {
        this.showprompt = true;
        this.prompt = "手机号不能为空";
      } else if (!myreg.test(this.mobile)) {
        this.showprompt = true;
        this.prompt = "请输入正确的手机号";
      } else if (this.sellerPlace == "") {
        this.showprompt = true;
        this.prompt = "商家地址不能为空";
      } else if (this.scopeBusiness == "") {
        this.showprompt = true;
        this.prompt = "经营范围不能为空";
      } else if (jquery_default()("#selectTypes").find(".vux-cell-value").text() == "") {
        this.showprompt = true;
        this.prompt = "请选择分类";
      } else if (this.sayDetail == "") {
        this.showprompt = true;
        this.prompt = "商家简介不能为空";
      } else {
        var json = {
          "comnArray": stringify_default()(this.value3),
          "sellerTitle": this.sellerName,
          "openId": this.$router.history.current.query.openid,
          "comnCode": this.$router.history.current.query.comnCode,
          "sellerIcon": this.imgs[0],
          "telePhone": this.mobile,
          "sellerAddr": this.sellerPlace,
          "sellerContent": this.sayDetail,
          "moduleType": this.moduleType,
          "sellerDesc": this.scopeBusiness

        };
        console.log("&&&&&&&&&&&&&&&&&&&&");
        console.log(json);
        var url = global.host + 'merchant/entry';
        this.$http.post(url, json).then(function (res) {
          console.log(res);
          this.show_1 = false;
          var resCode = res.body.msgcode;
          if (resCode == "110") {
            this.showprompt = true;
            this.prompt = "申请已提交成功，正在审核中，请耐心等待...";
            this.$router.push({ path: '/myEnter', query: {} });
          } else if (resCode == "120") {
            this.showprompt = true;
            this.prompt = "系统异常";
          } else if (resCode == "130") {
            this.showprompt = true;
            this.prompt = '该商户正在审核中，请耐心等待！';
          } else if (resCode == "140") {
            this.showprompt = true;
            this.prompt = '该商户已存在';
          }
          this.show_1 = false;
        }, function (err) {
          console.log(err);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/myEnter.vue

















/* harmony default export */ var convenientComponents_myEnter = ({
  components: {
    FlexboxItem: flexbox_item["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    XHeader: vux_src_components_x_header,
    Group: group["a" /* default */],
    Cell: cell["a" /* default */],
    XImg: vux_src_components_x_img,
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Alert: components_alert["a" /* default */],
    loadPage: src_components_loadingPage,
    $: jquery_default.a
  },
  data: function data() {
    return {
      imgs: [],
      sellerName: '',
      connectPerson: '',
      mobile: '',
      sellerPlace: '',
      value1: [''],
      list1: [[]],
      value2: [''],
      value3: [],
      list2: [[]],
      sayDetail: '',
      keys: '',
      showprompt: false,
      prompt: "",
      comnList: '',
      moduleType: '',
      scopeBusiness: '',
      dmlist: '',
      show_1: false,
      text_1: '',
      useragent: ''
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = false;
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
    var url = global.host + 'community/getList';
    this.$http.get(url).then(function (res) {
      var mlist = res.body.result;
      /*   let arr = new Array();
      this.keys = new Object();*/
      this.dmlist = res.body.result;
      for (var s in mlist) {
        /*let json1 = {"comncode":mlist[s].comnCode};
        this.value3.push(json1);*/
        this.list2[0].push(mlist[s].comnName);
      }
    }, function (err) {
      console.log(err);
    });

    var urls = global.host + 'dict/getParamsByDoMain/SELLER_PUBLISH_TYPE';
    this.$http.get(urls).then(function (res) {
      var mtlist = res.body.result;
      this.comnList = res.body.result;
      /*let arr = new Array();
      this.keys = new Object();*/

      for (var s in mtlist) {
        this.list1[0].push(mtlist[s].pvalue);
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    add_img: function add_img(event) {
      var reader = new FileReader();
      var img1 = event.target.files[0];
      reader.readAsDataURL(img1);
      var that = this;
      reader.onloadend = function (event) {
        that.imgs.shift();

        var img = new Image();

        var width = 680,
            //图像大小
        quality = 0.8,
            //图像质量
        canvas = document.createElement("canvas"),
            drawer = canvas.getContext("2d");
        img.src = this.result;
        img.onload = function () {
          canvas.width = width;
          canvas.height = width * (img.height / img.width);
          drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
          var imgBase64 = canvas.toDataURL("image/jpeg", quality);
          that.imgs.push(imgBase64);
          img.src = "";
        };
      };
    },
    onChange: function onChange(result) {

      for (var s in this.comnList) {
        if (result == this.comnList[s].pvalue) {
          this.moduleType = this.comnList[s].pkey;
        }
      }
    },
    changeRz: function changeRz(results) {
      for (var m in this.dmlist) {
        if (results == this.dmlist[m].comnName) {
          var json1 = { "comncode": this.dmlist[m].comnCode };
          this.value3.push(json1);
          console.log(this.value3);
        }
      }
    },
    change: function change() {
      console.log(1);
      this.show = true;
    },
    sendAjax: function sendAjax() {
      var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (jquery_default()("#mId").find(".vux-cell-value").text() == "") {
        this.showprompt = true;
        this.prompt = "请选择入驻小区";
      } else if (this.imgs == "") {
        this.showprompt = true;
        this.prompt = "请上传商家图片";
      } else if (this.sellerName == "") {
        this.showprompt = true;
        this.prompt = "商家姓名不能为空";
      } else if (this.connectPerson == "") {
        this.showprompt = true;
        this.prompt = "联系人不能为空";
      } else if (this.mobile == "") {
        this.showprompt = true;
        this.prompt = "手机号不能为空";
      } else if (!myreg.test(this.mobile)) {
        this.showprompt = true;
        this.prompt = "请输入正确的手机号";
      } else if (this.sellerPlace == "") {
        this.showprompt = true;
        this.prompt = "商家地址不能为空";
      } else if (this.scopeBusiness == "") {
        this.showprompt = true;
        this.prompt = "经营范围不能为空";
      } else if (jquery_default()("#selectTypes").find(".vux-cell-value").text() == "") {
        this.showprompt = true;
        this.prompt = "请选择分类";
      } else if (this.sayDetail == "") {
        this.showprompt = true;
        this.prompt = "商家简介不能为空";
      } else {
        var json = {
          "comnArray": stringify_default()(this.value3),
          "sellerTitle": this.sellerName,
          "openId": this.$router.history.current.query.openid,
          "comnCode": this.$router.history.current.query.comnCode,
          "sellerIcon": this.imgs[0],
          "telePhone": this.mobile,
          "sellerAddr": this.sellerPlace,
          "sellerContent": this.sayDetail,
          "moduleType": this.moduleType,
          "sellerDesc": this.scopeBusiness

        };
        console.log("&&&&&&&&&&&&&&&&&&&&");
        console.log(json);
        var url = global.host + 'merchant/entry';
        this.$http.post(url, json).then(function (res) {
          console.log(res);
          this.show_1 = false;
          var resCode = res.body.msgcode;
          if (resCode == "110") {
            this.showprompt = true;
            this.prompt = "申请已提交成功，正在审核中，请耐心等待...";
            this.$router.push({ path: '/myEnter', query: {} });
          } else if (resCode == "120") {
            this.showprompt = true;
            this.prompt = "系统异常";
          } else if (resCode == "130") {
            this.showprompt = true;
            this.prompt = '该商户正在审核中，请耐心等待！';
          } else if (resCode == "140") {
            this.showprompt = true;
            this.prompt = '该商户已存在';
          }
          this.show_1 = false;
        }, function (err) {
          console.log(err);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32b3747c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenientComponents/myEnter.vue
var myEnter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-x":"hidden"}},[_c('group',[_c('popup-picker',{attrs:{"title":"入驻小区","data":_vm.list2,"id":"mId"},on:{"on-change":_vm.changeRz},model:{value:(_vm.value2),callback:function ($$v) {_vm.value2=$$v},expression:"value2"}})],1),_vm._v(" "),_c('div',{staticClass:"finish_room",staticStyle:{"margin-top":"1.17647059em"}},[_c('div',{staticClass:"am_uploadTitle"},[_vm._v("商家图片")]),_vm._v(" "),(_vm.useragent)?_c('div',{staticClass:"finish_room2"},[_vm._l((_vm.imgs),function(item ,index){return _c('div',{staticClass:"room_img"},[_c('img',{attrs:{"src":item}})])}),_vm._v(" "),_c('div',{staticClass:"room_add_img"},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-arrow-forward",attrs:{"type":"ios-arrow-forward","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M160 128.4L192.3 96 352 256 192.3 416 160 383.6 287.3 256z"}})]),_vm._v(" "),_c('input',{attrs:{"type":"file"},on:{"change":_vm.add_img}})])],2):_c('div',{staticClass:"finish_room2"},[_vm._l((_vm.imgs),function(item ,index){return _c('div',{staticClass:"room_img"},[_c('img',{attrs:{"src":item}})])}),_vm._v(" "),_c('div',{staticClass:"room_add_img"},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-arrow-forward",attrs:{"type":"ios-arrow-forward","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M160 128.4L192.3 96 352 256 192.3 416 160 383.6 287.3 256z"}})]),_vm._v(" "),_c('input',{attrs:{"type":"file"},on:{"change":_vm.add_img}})])],2)]),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"商家名称","type":"text","text-align":"right","placeholder":"如：风姐干洗"},model:{value:(_vm.sellerName),callback:function ($$v) {_vm.sellerName=$$v},expression:"sellerName"}})],1),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"联系人","type":"text","text-align":"right","placeholder":"请填写联系人"},model:{value:(_vm.connectPerson),callback:function ($$v) {_vm.connectPerson=$$v},expression:"connectPerson"}})],1),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"联系电话","name":"mobile","is-type":"china-mobile","keyboard":"number","text-align":"right","placeholder":"请输入手机号"},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}})],1),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"商家地址","type":"text","text-align":"right","placeholder":"如：马家湾长庆西路12号"},model:{value:(_vm.sellerPlace),callback:function ($$v) {_vm.sellerPlace=$$v},expression:"sellerPlace"}})],1),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"经营范围","type":"text","text-align":"right","placeholder":"请输入经营范围"},model:{value:(_vm.scopeBusiness),callback:function ($$v) {_vm.scopeBusiness=$$v},expression:"scopeBusiness"}})],1),_vm._v(" "),_c('group',[_c('popup-picker',{attrs:{"title":"选择分类","id":"selectTypes","data":_vm.list1},on:{"on-change":_vm.onChange},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1),_vm._v(" "),_c('group',[_c('x-textarea',{attrs:{"title":"商家简介","show-counter":false,"rows":5,"placeholder":"请尽量完善相关信息，简介详尽且属实的通过审核几率大"},model:{value:(_vm.sayDetail),callback:function ($$v) {_vm.sayDetail=$$v},expression:"sayDetail"}})],1),_vm._v(" "),_c('flexbox',{staticClass:"am_butonStyle"},[_c('flexbox-item',[_c('x-button',{attrs:{"type":"primary","id":"btn_check"},nativeOn:{"click":function($event){return _vm.sendAjax($event)}}},[_vm._v("提交审核")])],1)],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.showprompt),callback:function ($$v) {_vm.showprompt=$$v},expression:"showprompt"}},[_vm._v(_vm._s(_vm.prompt))])],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1,"text_1":_vm.text_1}})],1)}
var myEnter_staticRenderFns = []
var myEnter_esExports = { render: myEnter_render, staticRenderFns: myEnter_staticRenderFns }
/* harmony default export */ var components_convenientComponents_myEnter = (myEnter_esExports);
// CONCATENATED MODULE: ./src/components/convenientComponents/myEnter.vue
function myEnter_injectStyle (ssrContext) {
  __webpack_require__("DdAS")
}
var myEnter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myEnter___vue_template_functional__ = false
/* styles */
var myEnter___vue_styles__ = myEnter_injectStyle
/* scopeId */
var myEnter___vue_scopeId__ = "data-v-32b3747c"
/* moduleIdentifier (server only) */
var myEnter___vue_module_identifier__ = null
var myEnter_Component = myEnter_normalizeComponent(
  convenientComponents_myEnter,
  components_convenientComponents_myEnter,
  myEnter___vue_template_functional__,
  myEnter___vue_styles__,
  myEnter___vue_scopeId__,
  myEnter___vue_module_identifier__
)

/* harmony default export */ var src_components_convenientComponents_myEnter = (myEnter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/convenientSellDetail.vue











/* harmony default export */ var convenientSellDetail = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Group: group["a" /* default */],
    loadPage: src_components_loadingPage,
    $: jquery_default.a
  },
  data: function data() {
    return {
      srcs: '',
      show_1: false,
      sellerNames: '',
      dates: '',
      phones: '',
      addres: '',
      sloves: '',
      typePersson: '',
      m1: true,
      m2: false
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    var serviceId = this.$router.history.current.query.serviceID;
    var url = global.host + 'conven/findByServiceId/' + serviceId;
    console.log();
    this.$http.get(url).then(function (res) {
      console.log('电话类型电话类型电话类型电话类型电话类型电话类型电话类型电话类型电话类型电话类型电话类型');
      console.log(res);
      this.srcs = res.body.result.serviceIcon;
      this.sellerNames = res.body.result.comnname;
      this.dates = res.body.result.createDate;
      this.phones = res.body.result.telePhone;
      this.addres = res.body.result.serviceAddr;
      this.sloves = res.body.result.content;
      jquery_default()("#mtext").html(this.sloves);
      this.typePersson = res.body.result.modulename;
      this.show_1 = false;
    }, function (error) {
      console.log(error);
    });
  },

  methods: {
    colects: function colects() {
      if (this.m1 == true) {
        this.m1 = false;
        this.m2 = true;
      } else {
        this.m1 = true;
        this.m2 = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/convenientComponents/convenientSellDetail.vue











/* harmony default export */ var convenientComponents_convenientSellDetail = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Group: group["a" /* default */],
    loadPage: src_components_loadingPage,
    $: jquery_default.a
  },
  data: function data() {
    return {
      srcs: '',
      show_1: false,
      sellerNames: '',
      dates: '',
      phones: '',
      addres: '',
      sloves: '',
      typePersson: '',
      m1: true,
      m2: false
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    var serviceId = this.$router.history.current.query.serviceID;
    var url = global.host + 'conven/findByServiceId/' + serviceId;
    console.log();
    this.$http.get(url).then(function (res) {
      console.log('电话类型电话类型电话类型电话类型电话类型电话类型电话类型电话类型电话类型电话类型电话类型');
      console.log(res);
      this.srcs = res.body.result.serviceIcon;
      this.sellerNames = res.body.result.comnname;
      this.dates = res.body.result.createDate;
      this.phones = res.body.result.telePhone;
      this.addres = res.body.result.serviceAddr;
      this.sloves = res.body.result.content;
      jquery_default()("#mtext").html(this.sloves);
      this.typePersson = res.body.result.modulename;
      this.show_1 = false;
    }, function (error) {
      console.log(error);
    });
  },

  methods: {
    colects: function colects() {
      if (this.m1 == true) {
        this.m1 = false;
        this.m2 = true;
      } else {
        this.m1 = true;
        this.m2 = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1585abb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenientComponents/convenientSellDetail.vue
var convenientSellDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_pic_l",attrs:{"span":1/3}},[_c('x-img',{attrs:{"src":_vm.srcs}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_seller_r",attrs:{"span":2/3}},[_c('h4',[_vm._v(_vm._s(_vm.sellerNames))]),_vm._v(" "),_c('p',[_c('x-button',{attrs:{"mini":"","type":"warn"}},[_vm._v(_vm._s(_vm.typePersson))]),_vm._v(" "),_c('span',[_vm._v("更新日期"),_c('strong',[_vm._v(_vm._s(_vm.dates))])])],1)])],1)],1),_vm._v(" "),_c('group',[_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_phone_name",attrs:{"span":1/2}},[_vm._v("电话")]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/2}},[_vm._v(_vm._s(_vm.phones))])],1)],1),_vm._v(" "),_c('group',{attrs:{"id":"am_mdtail"}},[_c('p',{staticClass:"am_details"},[_vm._v("详细地址")])]),_vm._v(" "),_c('group',{attrs:{"id":"am_deak"}},[_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_srcHeight",attrs:{"span":1/3}},[_c('img',{attrs:{"src":__webpack_require__("iT1P"),"width":"25","height":"35"}})]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":2/3}},[_vm._v(_vm._s(_vm.addres))])],1)],1),_vm._v(" "),_c('group',[_c('p',{staticStyle:{"height":"40px","line-height":"40px","text-align":"left","padding-top":"10px","text-indent":"30px"}},[_vm._v("商家介绍")]),_vm._v(" "),_c('p',{staticStyle:{"padding":"10px 20px 20px","line-height":"25px"},attrs:{"id":"mtext"}})]),_vm._v(" "),_c('group',{staticClass:"am_botom"},[_c('p',{staticStyle:{"height":"40px","line-height":"40px","text-align":"center","padding-top":"10px"}},[_vm._v("相关说明")]),_vm._v(" "),_c('p',{staticStyle:{"padding":"10px 20px 20px","line-height":"25px"}},[_vm._v("\n      通过用户提供、网络收集等渠道获取、不免会出现错误或者过期号码，若发现有误，请你及时联系我们！\n    ")])]),_vm._v(" "),_c('flexbox',{staticClass:"am_button_bottom",attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_contel",attrs:{"span":1/5}},[_c('div',{staticClass:"am_acoh"},[_c('img',{attrs:{"src":__webpack_require__("twXI"),"alt":"","width":"25","height":"22"}})]),_vm._v(" "),_c('h4',[_vm._v("分享")])]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_contel",attrs:{"span":1/5}},[_c('div',{staticClass:"am_acoh"},[_c('img',{attrs:{"src":__webpack_require__("SH4t"),"alt":"","width":"25","height":"25"}})]),_vm._v(" "),_c('h4',[_vm._v("导航")])]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_contel",attrs:{"span":1/5}},[_c('div',{staticClass:"am_acoh",on:{"click":function($event){_vm.colects()}}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.m1),expression:"m1"}],attrs:{"src":__webpack_require__("4F7/"),"alt":"","width":"24","height":"23"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.m2),expression:"m2"}],attrs:{"src":__webpack_require__("As1b"),"alt":"","width":"24","height":"23"}})]),_vm._v(" "),_c('h4',[_vm._v("收藏")])]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_contel",attrs:{"span":2/5}},[_c('a',{attrs:{"href":'tel:'+_vm.phones}},[_c('x-button',{staticClass:"am_subButton",staticStyle:{"margin-top":"-4px"},attrs:{"mini":"","type":"warn"}},[_vm._v("\n        电话联系\n      ")])],1)])],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var convenientSellDetail_staticRenderFns = []
var convenientSellDetail_esExports = { render: convenientSellDetail_render, staticRenderFns: convenientSellDetail_staticRenderFns }
/* harmony default export */ var components_convenientComponents_convenientSellDetail = (convenientSellDetail_esExports);
// CONCATENATED MODULE: ./src/components/convenientComponents/convenientSellDetail.vue
function convenientSellDetail_injectStyle (ssrContext) {
  __webpack_require__("emhf")
}
var convenientSellDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var convenientSellDetail___vue_template_functional__ = false
/* styles */
var convenientSellDetail___vue_styles__ = convenientSellDetail_injectStyle
/* scopeId */
var convenientSellDetail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var convenientSellDetail___vue_module_identifier__ = null
var convenientSellDetail_Component = convenientSellDetail_normalizeComponent(
  convenientComponents_convenientSellDetail,
  components_convenientComponents_convenientSellDetail,
  convenientSellDetail___vue_template_functional__,
  convenientSellDetail___vue_styles__,
  convenientSellDetail___vue_scopeId__,
  convenientSellDetail___vue_module_identifier__
)

/* harmony default export */ var src_components_convenientComponents_convenientSellDetail = (convenientSellDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/complaintComponenst/complaint.vue
















/* harmony default export */ var complaint = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    Group: group["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Datetime: vux_src_components_datetime,
    Alert: components_alert["a" /* default */],
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      src: '',
      houseonwer: '1592645632(1592645632)',
      houseinfo: '',
      repair: "",
      info: '',
      perTag: [],
      perTagId: [],
      perTagName: [],
      showTime: true,
      filecontent: [],
      comnCode: '',
      hsNo: '',
      hsName: '',
      hsPhone: '',
      message: '',
      showAlert: false,
      show1: false,
      show2: false,
      text_1: ""
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/complaint") {
      document.title = "投诉建议";
    }
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
    var curTime = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD HH');
    var curHour = Object(date_format["a" /* default */])(new Date(), 'HH');
    this.ensureDate = curTime + ':00-' + curHour + ':59';
    this.minyear = new Date().getFullYear();
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      if (res.body.result) {
        var data = res.body.result[0];
        this.src = data.photoUrl;
        this.houseinfo = data.comName + data.hsNo;
        this.houseonwer = data.name + "(" + data.mainPhone + ")";
        this.hsNo = data.hsNo;
        this.hsName = data.hsName;
        this.comnCode = data.comn_code;
        this.hsPhone = data.mainPhone;
      }
    }, function (err) {
      console.log(err);
    });
    this.$http.get(global.host + 'comp/finddevicetype').then(function (res) {
      for (var i = 0; i < res.body.result.length; i++) {
        this.perTag.push(res.body.result[i]);
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    changeStype: function changeStype(index) {
      var size = document.getElementById('tag').children.length;
      for (var i = 0; i < size; i++) {
        var classList = document.getElementById('tag').children[i].classList;
        if (classList.contains('weui-btn_primary')) {
          classList.remove('weui-btn_primary');
        }
      }
      document.getElementById(index).classList.add('weui-btn_primary');
      this.repair = index;
    },
    selectFile: function selectFile() {
      var _this = this;

      var filehandler = document.getElementById('file');
      if (filehandler.files) {
        var reader;

        (function () {
          var fileList = filehandler.files;
          var self = _this;
          var size = _this.filecontent.length;
          for (var j = 0; j < size; j++) {
            _this.filecontent.pop();
          }
          for (var i = 0; i < (fileList.length > 4 ? 4 : fileList.length); i++) {
            reader = new FileReader();

            reader.readAsDataURL(fileList[i]);
            reader.onload = function (event) {
              var img = new Image();

              var width = 680,
                  //图像大小
              quality = 0.8,
                  //图像质量
              canvas = document.createElement("canvas"),
                  drawer = canvas.getContext("2d");
              img.src = this.result;
              img.onload = function () {
                canvas.width = width;
                canvas.height = width * (img.height / img.width);
                drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
                var imgBase64 = canvas.toDataURL("image/jpeg", quality);
                self.filecontent.push(imgBase64);
                img.src = "";
              };
            };
          }
        })();
      }
    },
    showTimeBox: function showTimeBox() {
      this.showselectTime = !this.showselectTime;
    },
    selectTime: function selectTime() {
      this.ensureDate = this.ensureDate + ' ' + this.ensureTime[0];
    },
    submitForm: function submitForm() {
      if (this.repair == "") {
        this.message = '请选择投诉建议类型';
        this.showAlert = true;
      } else if (!this.info) {
        this.message = '请输入投诉建议内容';
        this.showAlert = true;
      } else {
        this.show_1 = true;

        var sendDate = {};
        sendDate.comnCode = this.comnCode;
        sendDate.hsNo = this.hsNo;
        sendDate.hsName = this.hsName;
        sendDate.hsPhone = this.hsPhone;
        sendDate.feedbackType = this.repair;
        sendDate.feedbackDesc = this.info;
        sendDate.images = this.filecontent;
        this.$http.post(global.host + 'comp/submitcomppro', sendDate).then(function (res) {
          console.log(res);
          this.show_1 = false;

          if (res.body.msgcode == '120') {
            this.message = '投诉建议信息提交失败';
            this.showAlert = true;
          } else {
            this.message = '投诉建议信息提交成功';
            this.showAlert = true;
          }
        }, function (err) {
          console.log(err);
        });
      }
    },
    getIndex: function getIndex(arr, field) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == field) {
          return i;
        }
      }
    },
    hideAlert: function hideAlert() {
      if (this.message == '投诉建议信息提交成功') {
        var hsNos = this.hsNo;

        this.$router.push({ path: '/complaintCollect', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, communityId: this.comnCode, hscodes: hsNos } });
      }
    },
    changefocus: function changefocus() {
      document.getElementById('file').click();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/complaintComponenst/complaint.vue
















/* harmony default export */ var complaintComponenst_complaint = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    Group: group["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Datetime: vux_src_components_datetime,
    Alert: components_alert["a" /* default */],
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      src: '',
      houseonwer: '1592645632(1592645632)',
      houseinfo: '',
      repair: "",
      info: '',
      perTag: [],
      perTagId: [],
      perTagName: [],
      showTime: true,
      filecontent: [],
      comnCode: '',
      hsNo: '',
      hsName: '',
      hsPhone: '',
      message: '',
      showAlert: false,
      show1: false,
      show2: false,
      text_1: ""
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/complaint") {
      document.title = "投诉建议";
    }
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
    var curTime = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD HH');
    var curHour = Object(date_format["a" /* default */])(new Date(), 'HH');
    this.ensureDate = curTime + ':00-' + curHour + ':59';
    this.minyear = new Date().getFullYear();
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      if (res.body.result) {
        var data = res.body.result[0];
        this.src = data.photoUrl;
        this.houseinfo = data.comName + data.hsNo;
        this.houseonwer = data.name + "(" + data.mainPhone + ")";
        this.hsNo = data.hsNo;
        this.hsName = data.hsName;
        this.comnCode = data.comn_code;
        this.hsPhone = data.mainPhone;
      }
    }, function (err) {
      console.log(err);
    });
    this.$http.get(global.host + 'comp/finddevicetype').then(function (res) {
      for (var i = 0; i < res.body.result.length; i++) {
        this.perTag.push(res.body.result[i]);
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    changeStype: function changeStype(index) {
      var size = document.getElementById('tag').children.length;
      for (var i = 0; i < size; i++) {
        var classList = document.getElementById('tag').children[i].classList;
        if (classList.contains('weui-btn_primary')) {
          classList.remove('weui-btn_primary');
        }
      }
      document.getElementById(index).classList.add('weui-btn_primary');
      this.repair = index;
    },
    selectFile: function selectFile() {
      var _this = this;

      var filehandler = document.getElementById('file');
      if (filehandler.files) {
        var reader;

        (function () {
          var fileList = filehandler.files;
          var self = _this;
          var size = _this.filecontent.length;
          for (var j = 0; j < size; j++) {
            _this.filecontent.pop();
          }
          for (var i = 0; i < (fileList.length > 4 ? 4 : fileList.length); i++) {
            reader = new FileReader();

            reader.readAsDataURL(fileList[i]);
            reader.onload = function (event) {
              var img = new Image();

              var width = 680,
                  //图像大小
              quality = 0.8,
                  //图像质量
              canvas = document.createElement("canvas"),
                  drawer = canvas.getContext("2d");
              img.src = this.result;
              img.onload = function () {
                canvas.width = width;
                canvas.height = width * (img.height / img.width);
                drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
                var imgBase64 = canvas.toDataURL("image/jpeg", quality);
                self.filecontent.push(imgBase64);
                img.src = "";
              };
            };
          }
        })();
      }
    },
    showTimeBox: function showTimeBox() {
      this.showselectTime = !this.showselectTime;
    },
    selectTime: function selectTime() {
      this.ensureDate = this.ensureDate + ' ' + this.ensureTime[0];
    },
    submitForm: function submitForm() {
      if (this.repair == "") {
        this.message = '请选择投诉建议类型';
        this.showAlert = true;
      } else if (!this.info) {
        this.message = '请输入投诉建议内容';
        this.showAlert = true;
      } else {
        this.show_1 = true;

        var sendDate = {};
        sendDate.comnCode = this.comnCode;
        sendDate.hsNo = this.hsNo;
        sendDate.hsName = this.hsName;
        sendDate.hsPhone = this.hsPhone;
        sendDate.feedbackType = this.repair;
        sendDate.feedbackDesc = this.info;
        sendDate.images = this.filecontent;
        this.$http.post(global.host + 'comp/submitcomppro', sendDate).then(function (res) {
          console.log(res);
          this.show_1 = false;

          if (res.body.msgcode == '120') {
            this.message = '投诉建议信息提交失败';
            this.showAlert = true;
          } else {
            this.message = '投诉建议信息提交成功';
            this.showAlert = true;
          }
        }, function (err) {
          console.log(err);
        });
      }
    },
    getIndex: function getIndex(arr, field) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == field) {
          return i;
        }
      }
    },
    hideAlert: function hideAlert() {
      if (this.message == '投诉建议信息提交成功') {
        var hsNos = this.hsNo;

        this.$router.push({ path: '/complaintCollect', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, communityId: this.comnCode, hscodes: hsNos } });
      }
    },
    changefocus: function changefocus() {
      document.getElementById('file').click();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45f9354f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/complaintComponenst/complaint.vue
var complaint_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"padding":"10px 15px","background":"#fff"}},[_c('div',{staticStyle:{"display":"inline-block","width":"20%","height":"70px","max-width":"80px","float":"left","margin-right":"10px"}},[_c('x-img',{staticStyle:{"height":"auto"},attrs:{"src":_vm.src}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","width":"75%","height":"70px","float":"left"}},[_c('h4',{staticStyle:{"line-height":"1.8","padding-top":"8px","font-weight":"500","font-size":"1.2em"}},[_vm._v(_vm._s(_vm.houseonwer))]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.6","font-size":"1em","padding-top":"5px","font-weight":"500"}},[_vm._v(_vm._s(_vm.houseinfo))])]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('group',{staticStyle:{"margin-top":"-1.323564em"}},[_c('div',{staticClass:"tag",attrs:{"id":"tag"}},_vm._l((_vm.perTag),function(item,key){return _c('x-button',{key:key,staticStyle:{"margin-right":"5px"},attrs:{"mini":"","id":item.pkey},nativeOn:{"click":function($event){_vm.changeStype(item.pkey)}}},[_vm._v(_vm._s(item.pvalue))])})),_vm._v(" "),_c('x-textarea',{staticClass:"am_textares",attrs:{"placeholder":"留下你的问题和建议，让我们把服务做得更好...","rows":4,"max":300},model:{value:(_vm.info),callback:function ($$v) {_vm.info=$$v},expression:"info"}}),_vm._v(" "),_c('div',{staticStyle:{"border-top":"1px solid #D9D9D9","margin":"0 0 0 15px"}},[_c('p',{staticStyle:{"font-size":"0.8em","padding-top":"5px","color":"#999999"}},[_vm._v("我的照片")]),_vm._v(" "),(_vm.useragent)?_c('div',{staticStyle:{"width":"80px","height":"80px","background-color":"#fff","line-height":"80px","position":"relative"}},[_c('input',{staticStyle:{"display":"block","opacity":"0","width":"80px","height":"80px","position":"absolute","z-index":"99999"},attrs:{"type":"file","name":"file","id":"file","accept":"image/*","multiple":"","max":"4"},on:{"change":_vm.selectFile}}),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","display":"block","width":"100%","height":"100%","top":"0"}},[_c('i',{staticClass:"iconfont icon-xiangji",staticStyle:{"font-size":"40px","margin-left":"30%","color":"#ddd"}})]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","display":"block","width":"200px","height":"80px","top":"0","left":"100px","color":"red","font-size":"0.8em"}},[_vm._v("最多可以上传四张图片")])]):_c('div',{staticStyle:{"width":"80px","height":"80px","background-color":"#fff","line-height":"80px","position":"relative"}},[_c('span',{staticStyle:{"position":"absolute","display":"block","width":"100%","height":"100%","top":"0"}},[_c('i',{staticClass:"iconfont icon-xiangji",staticStyle:{"font-size":"40px","margin-left":"30%","color":"#ddd"}})]),_vm._v(" "),_c('input',{staticStyle:{"display":"block","opacity":"0","width":"80px","height":"80px","position":"absolute","z-index":"99999"},attrs:{"type":"file","name":"file","id":"file","accept":"image/*","multiple":"","max":"4"},on:{"change":_vm.selectFile}}),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","display":"block","width":"200px","height":"80px","top":"0","left":"100px","color":"red","font-size":"0.8em"}},[_vm._v("最多可以上传四张图片")])])]),_vm._v(" "),(_vm.filecontent.length > 0)?_c('div',{staticStyle:{"border-top":"1px solid #D9D9D9","padding":"10px 0 7px 15px"}},_vm._l((_vm.filecontent),function(item,index){return _c('x-img',{key:index,staticClass:"pic",attrs:{"src":item}})})):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"height":"20px"}}),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submitForm($event)}}},[_vm._v("提交问题")]),_vm._v(" "),_c('alert',{attrs:{"title":"温馨提示"},on:{"on-hide":_vm.hideAlert},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_vm._v(" "+_vm._s(_vm.message))]),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var complaint_staticRenderFns = []
var complaint_esExports = { render: complaint_render, staticRenderFns: complaint_staticRenderFns }
/* harmony default export */ var components_complaintComponenst_complaint = (complaint_esExports);
// CONCATENATED MODULE: ./src/components/complaintComponenst/complaint.vue
function complaint_injectStyle (ssrContext) {
  __webpack_require__("dg8L")
}
var complaint_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var complaint___vue_template_functional__ = false
/* styles */
var complaint___vue_styles__ = complaint_injectStyle
/* scopeId */
var complaint___vue_scopeId__ = "data-v-45f9354f"
/* moduleIdentifier (server only) */
var complaint___vue_module_identifier__ = null
var complaint_Component = complaint_normalizeComponent(
  complaintComponenst_complaint,
  components_complaintComponenst_complaint,
  complaint___vue_template_functional__,
  complaint___vue_styles__,
  complaint___vue_scopeId__,
  complaint___vue_module_identifier__
)

/* harmony default export */ var src_components_complaintComponenst_complaint = (complaint_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/complaintComponenst/complaintCollect.vue











/* harmony default export */ var complaintCollect = ({
  name: "complaintCollect",
  components: {
    XImg: vux_src_components_x_img,
    Group: group["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    global: global,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      picheight: window.screen.width * 0.22 - 8,
      show2: false,
      dataList: {},
      allId: "",
      srcs: "",
      msid: "",
      text_1: ""
    };
  },

  updated: {
    showAlert: function showAlert(src) {
      alert("dsfdsfdsf");

      this.show2 = true;
      this.srcs = "";
    }
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/complaintCollect") {
      document.title = "我的建议";
    }
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      if (res.body.result) {
        var data = res.body.result[0];
        this.getRepairList(data);
        this.show_1 = false;
      }
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    getRepairList: function getRepairList(paramData) {
      var phones = this.$router.history.current.query.phone;
      var sData = "comncode=" + paramData.comn_code + "&hscode=" + paramData.hsNo + "&hsphone=" + phones;
      this.$http.get(global.host + '/comp/findselfcomppro?' + sData).then(function (res) {
        var _this = this;

        var datay = res.body.result;
        this.dataList = new Object();
        this.allId = new Object();
        for (var ks in datay) {
          if ((typeof ks === 'undefined' ? 'undefined' : typeof_default()(ks)) == "object") {
            for (var ms in ks) {
              this.dataList[ms] = ks[ms];
            }
          } else {
            (function () {
              _this.dataList[ks] = datay[ks];
              var sId = datay[ks].feedbackId;
              _this.$http.get(global.host + '/repair/findPictureById?repairId=' + sId).then(function (res) {
                //v-on:click=\"showAlert("+rpic[ms].repairPic+")\"
                var rpic = res.body.result;
                var rows = "";

                for (var _ms in rpic) {
                  rows += "<flexbox-item style=\'margin-right:8px\'><img id ='" + rpic[_ms].repairId + "' style=\"height:70px;width:70px\" onclick=\"document.getElementById('showAlertLayer').style.display='table';document.getElementById('preViewImg').src=\'" + rpic[_ms].repairPic + "\';\" src=\'" + rpic[_ms].repairPic + "\'></flexbox-item>";
                }
                document.getElementById("mts" + sId).innerHTML = rows;
              }, function (err) {
                console.log(err);
              });
            })();
          }
        }
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/complaintComponenst/complaintCollect.vue











/* harmony default export */ var complaintComponenst_complaintCollect = ({
  name: "complaintCollect",
  components: {
    XImg: vux_src_components_x_img,
    Group: group["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    global: global,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      picheight: window.screen.width * 0.22 - 8,
      show2: false,
      dataList: {},
      allId: "",
      srcs: "",
      msid: "",
      text_1: ""
    };
  },

  updated: {
    showAlert: function showAlert(src) {
      alert("dsfdsfdsf");

      this.show2 = true;
      this.srcs = "";
    }
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/complaintCollect") {
      document.title = "我的建议";
    }
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      if (res.body.result) {
        var data = res.body.result[0];
        this.getRepairList(data);
        this.show_1 = false;
      }
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    getRepairList: function getRepairList(paramData) {
      var phones = this.$router.history.current.query.phone;
      var sData = "comncode=" + paramData.comn_code + "&hscode=" + paramData.hsNo + "&hsphone=" + phones;
      this.$http.get(global.host + '/comp/findselfcomppro?' + sData).then(function (res) {
        var _this = this;

        var datay = res.body.result;
        this.dataList = new Object();
        this.allId = new Object();
        for (var ks in datay) {
          if ((typeof ks === 'undefined' ? 'undefined' : typeof_default()(ks)) == "object") {
            for (var ms in ks) {
              this.dataList[ms] = ks[ms];
            }
          } else {
            (function () {
              _this.dataList[ks] = datay[ks];
              var sId = datay[ks].feedbackId;
              _this.$http.get(global.host + '/repair/findPictureById?repairId=' + sId).then(function (res) {
                //v-on:click=\"showAlert("+rpic[ms].repairPic+")\"
                var rpic = res.body.result;
                var rows = "";

                for (var _ms in rpic) {
                  rows += "<flexbox-item style=\'margin-right:8px\'><img id ='" + rpic[_ms].repairId + "' style=\"height:70px;width:70px\" onclick=\"document.getElementById('showAlertLayer').style.display='table';document.getElementById('preViewImg').src=\'" + rpic[_ms].repairPic + "\';\" src=\'" + rpic[_ms].repairPic + "\'></flexbox-item>";
                }
                document.getElementById("mts" + sId).innerHTML = rows;
              }, function (err) {
                console.log(err);
              });
            })();
          }
        }
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-736f8793","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/complaintComponenst/complaintCollect.vue
var complaintCollect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.dataList),function(key,index){return _c('div',{key:index,staticStyle:{"padding":"10px 15px","background":"#fff","border-bottom":"1px solid #D9D9D9","position":"relative","margin-bottom":"10px"}},[_c('div',{staticStyle:{"display":"inline-block","width":"20%","height":"60px","max-width":"70px","float":"left","margin-right":"10px"}},[_c('x-img',{staticStyle:{"height":"100%"},attrs:{"src":key.headimg}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","width":"70%","height":"40px","float":"left"}},[_c('h4',{staticStyle:{"line-height":"1.8","padding-top":"3px","font-weight":"500","font-size":"1.2em"}},[_vm._v(_vm._s(key.hsName))]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.6","font-size":"1em","padding-top":"5px","font-weight":"500"}},[_vm._v(_vm._s(key.feedbackDate))])]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","right":"10px","top":"30px","font-size":"20px"}},[(key.feedbackState == '0')?_c('router-link',{attrs:{"to":{path:'/evaluate',query:{feedbackId:key.feedbackId}}}},[_c('span',{staticStyle:{"color":"red","font-size":"17px"}},[_vm._v("提交成功"),_c('i',{staticClass:"iconfont icon-more",staticStyle:{"font-weight":"bold","color":"gray"}})])]):_vm._e(),_vm._v(" "),(key.feedbackState == '1')?_c('router-link',{attrs:{"to":{path:'/evaluate',query:{feedbackId:key.feedbackId}}}},[_c('span',{staticStyle:{"color":"red","font-size":"17px"}},[_vm._v("已受理"),_c('i',{staticClass:"iconfont icon-more",staticStyle:{"font-weight":"bold","color":"gray"}})])]):_vm._e(),_vm._v(" "),(key.feedbackState == '2')?_c('router-link',{attrs:{"to":{path:'/evaluate',query:{feedbackId:key.feedbackId}}}},[_c('span',{staticStyle:{"color":"red","font-size":"17px"}},[_vm._v("已解决"),_c('i',{staticClass:"iconfont icon-more",staticStyle:{"font-weight":"bold","color":"gray"}})])]):_vm._e(),_vm._v(" "),(key.feedbackState == '3')?_c('router-link',{attrs:{"to":{path:'/evaluate',query:{feedbackId:key.feedbackId}}}},[_c('span',{staticStyle:{"color":"red","font-size":"17px"}},[_vm._v("已回访"),_c('i',{staticClass:"iconfont icon-more",staticStyle:{"font-weight":"bold","color":"gray"}})])]):_vm._e(),_vm._v(" "),(key.feedbackState == '4')?_c('router-link',{attrs:{"to":{path:'/evaluate',query:{feedbackId:key.feedbackId}}}},[_c('span',{staticStyle:{"color":"red","font-size":"17px"}},[_vm._v("已评价"),_c('i',{staticClass:"iconfont icon-more",staticStyle:{"font-weight":"bold","color":"gray"}})])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.6","margin-top":"15px","margin-bottom":"8px"}},[_c('span',{staticStyle:{"color":"blue","padding-right":"10px"}},[_vm._v(_vm._s(key.feedbackType))]),_vm._v(_vm._s(key.hsNo)+_vm._s(key.feedbackDesc))]),_vm._v(" "),(key.feedbackState == '2' || key.feedbackState == '3' || key.feedbackState == '4' )?_c('p',{staticStyle:{"background":"#f7f7f7","padding":"4px 5px","margin-bottom":"7px"}},[_vm._v("物业回复："+_vm._s(key.finishDesc))]):_vm._e(),_vm._v(" "),_c('flexbox',{attrs:{"id":'mts'+key.feedbackId,"orient":"horizontal","align":"left"}})],1)}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('alert',{attrs:{"id":"ltd"},model:{value:(_vm.show2),callback:function ($$v) {_vm.show2=$$v},expression:"show2"}},[_c('img',{attrs:{"id":"mt","src":_vm.srcs}})]),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],2)}
var complaintCollect_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"},attrs:{"id":"showAlertLayer"}},[_c('div',{staticClass:"weui-mask"}),_vm._v(" "),_c('div',{staticClass:"weui-dialog"},[_c('img',{staticStyle:{"width":"100%","margin-bottom":"-8px","margin-right":"-1px"},attrs:{"id":"preViewImg","src":"","onclick":"document.getElementById('showAlertLayer').style.display='none'"}})])])}]
var complaintCollect_esExports = { render: complaintCollect_render, staticRenderFns: complaintCollect_staticRenderFns }
/* harmony default export */ var components_complaintComponenst_complaintCollect = (complaintCollect_esExports);
// CONCATENATED MODULE: ./src/components/complaintComponenst/complaintCollect.vue
function complaintCollect_injectStyle (ssrContext) {
  __webpack_require__("ExZm")
}
var complaintCollect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var complaintCollect___vue_template_functional__ = false
/* styles */
var complaintCollect___vue_styles__ = complaintCollect_injectStyle
/* scopeId */
var complaintCollect___vue_scopeId__ = "data-v-736f8793"
/* moduleIdentifier (server only) */
var complaintCollect___vue_module_identifier__ = null
var complaintCollect_Component = complaintCollect_normalizeComponent(
  complaintComponenst_complaintCollect,
  components_complaintComponenst_complaintCollect,
  complaintCollect___vue_template_functional__,
  complaintCollect___vue_styles__,
  complaintCollect___vue_scopeId__,
  complaintCollect___vue_module_identifier__
)

/* harmony default export */ var src_components_complaintComponenst_complaintCollect = (complaintCollect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/complaintComponenst/evaluate.vue












/* harmony default export */ var evaluate = ({
  name: "evaluate",
  components: {
    Group: group["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XButton: vux_src_components_x_button,
    XTextarea: vux_src_components_x_textarea,
    global: global,
    Alert: components_alert["a" /* default */],
    dateFormat: date_format["a" /* default */],
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      info: '',
      evaluate: false,
      remark: '非常满意',
      greads: "5.0",
      dataList: {},
      hides: false,
      hides1: false,
      hides2: false,
      hides3: false,
      hides4: false,
      hides5: false,
      hides6: false,
      hides7: false,
      hides8: false,
      repirds: "",
      showAlert: false,
      datays: "",
      his: false,
      evaluateTime: ""
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    var repairIds = this.$router.history.current.query.feedbackId;
    this.$http.get(global.host + 'comp/findcompdetail?feedbackId=' + repairIds).then(function (res) {
      var datay = res.body;
      this.dataList = new Object();
      this.repirds = res.body.result.feedbackId;
      for (var ks in datay) {
        if ((typeof ks === 'undefined' ? 'undefined' : typeof_default()(ks)) == "object") {
          for (var ms in ks) {
            this.dataList[ms] = ks[ms];
          }
        } else {
          this.dataList[ks] = datay[ks];
        }
      }
      var codeId = res.body.result.feedbackState;
      if (codeId == '0') {
        this.hides = true;
      } else if (codeId == '1') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
      } else if (codeId == '2') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
        this.hides3 = true;
        this.hides4 = true;
      } else if (codeId == '3') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
        this.hides3 = true;
        this.hides4 = true;
        this.hides5 = true;
        this.hides6 = true;
        this.his = true;
      } else if (codeId == '4') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
        this.hides3 = true;
        this.hides4 = true;
        this.hides5 = true;
        this.hides6 = true;
        this.hides7 = true;
        this.hides8 = true;
        this.evaluateTime = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD HH:mm:ss');
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    submitData: function submitData() {
      var usrsInfo = new Object();
      usrsInfo.feedbackId = this.repirds;
      usrsInfo.scoreLevel = this.greads;
      usrsInfo.scoreDesc = this.info;
      var urls = global.host + 'comp/updevaluate';
      this.$http.post(urls, usrsInfo).then(function (res) {
        this.datays = res.body.msg;
        if (res.body.msgcode == "110") {
          this.showAlert = true;
          this.his = false;
          this.evaluate = false;
          this.evaluateTime = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD HH:mm:ss');
          this.hides7 = true;
          this.hides8 = true;
        }
      }, function (err) {
        console.log(err);
      });
    },
    showevaluate: function showevaluate() {
      this.evaluate = true;
    },
    hideevaluate: function hideevaluate() {
      this.evaluate = false;
    },
    changeStyle: function changeStyle(id) {
      var classList = document.getElementById(id).classList;
      if (classList.contains('weui-btn_primary')) {
        classList.remove('weui-btn_primary');
      } else {
        classList.add('weui-btn_primary');
      }
    },
    preference: function preference(index) {
      switch (parseInt(index)) {
        case 1:
          this.remark = '非常不满意';
          this.greads = "1";
          break;
        case 2:
          this.remark = '比较不满意';
          this.greads = "2";
          break;
        case 3:
          this.remark = '一般满意';
          this.greads = "3";
          break;
        case 4:
          this.remark = '比较满意';
          this.greads = "4";
          break;
        case 5:
          this.remark = '非常满意';
          this.greads = "5";
          break;

      }
      var child = document.getElementById('favorite').children;
      for (var j = 0; j < 5; j++) {
        if (child[j].classList.contains('icon-ai-mark')) {
          child[j].classList.remove('icon-ai-mark');
          child[j].classList.add('icon-shoucang');
        }
      }
      for (var i = 0; i < parseInt(index); i++) {
        if (child[i].classList.contains('icon-shoucang')) {
          child[i].classList.remove('icon-shoucang');
          child[i].classList.add('icon-ai-mark');
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/complaintComponenst/evaluate.vue












/* harmony default export */ var complaintComponenst_evaluate = ({
  name: "evaluate",
  components: {
    Group: group["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XButton: vux_src_components_x_button,
    XTextarea: vux_src_components_x_textarea,
    global: global,
    Alert: components_alert["a" /* default */],
    dateFormat: date_format["a" /* default */],
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      info: '',
      evaluate: false,
      remark: '非常满意',
      greads: "5.0",
      dataList: {},
      hides: false,
      hides1: false,
      hides2: false,
      hides3: false,
      hides4: false,
      hides5: false,
      hides6: false,
      hides7: false,
      hides8: false,
      repirds: "",
      showAlert: false,
      datays: "",
      his: false,
      evaluateTime: ""
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    var repairIds = this.$router.history.current.query.feedbackId;
    this.$http.get(global.host + 'comp/findcompdetail?feedbackId=' + repairIds).then(function (res) {
      var datay = res.body;
      this.dataList = new Object();
      this.repirds = res.body.result.feedbackId;
      for (var ks in datay) {
        if ((typeof ks === 'undefined' ? 'undefined' : typeof_default()(ks)) == "object") {
          for (var ms in ks) {
            this.dataList[ms] = ks[ms];
          }
        } else {
          this.dataList[ks] = datay[ks];
        }
      }
      var codeId = res.body.result.feedbackState;
      if (codeId == '0') {
        this.hides = true;
      } else if (codeId == '1') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
      } else if (codeId == '2') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
        this.hides3 = true;
        this.hides4 = true;
      } else if (codeId == '3') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
        this.hides3 = true;
        this.hides4 = true;
        this.hides5 = true;
        this.hides6 = true;
        this.his = true;
      } else if (codeId == '4') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
        this.hides3 = true;
        this.hides4 = true;
        this.hides5 = true;
        this.hides6 = true;
        this.hides7 = true;
        this.hides8 = true;
        this.evaluateTime = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD HH:mm:ss');
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    submitData: function submitData() {
      var usrsInfo = new Object();
      usrsInfo.feedbackId = this.repirds;
      usrsInfo.scoreLevel = this.greads;
      usrsInfo.scoreDesc = this.info;
      var urls = global.host + 'comp/updevaluate';
      this.$http.post(urls, usrsInfo).then(function (res) {
        this.datays = res.body.msg;
        if (res.body.msgcode == "110") {
          this.showAlert = true;
          this.his = false;
          this.evaluate = false;
          this.evaluateTime = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD HH:mm:ss');
          this.hides7 = true;
          this.hides8 = true;
        }
      }, function (err) {
        console.log(err);
      });
    },
    showevaluate: function showevaluate() {
      this.evaluate = true;
    },
    hideevaluate: function hideevaluate() {
      this.evaluate = false;
    },
    changeStyle: function changeStyle(id) {
      var classList = document.getElementById(id).classList;
      if (classList.contains('weui-btn_primary')) {
        classList.remove('weui-btn_primary');
      } else {
        classList.add('weui-btn_primary');
      }
    },
    preference: function preference(index) {
      switch (parseInt(index)) {
        case 1:
          this.remark = '非常不满意';
          this.greads = "1";
          break;
        case 2:
          this.remark = '比较不满意';
          this.greads = "2";
          break;
        case 3:
          this.remark = '一般满意';
          this.greads = "3";
          break;
        case 4:
          this.remark = '比较满意';
          this.greads = "4";
          break;
        case 5:
          this.remark = '非常满意';
          this.greads = "5";
          break;

      }
      var child = document.getElementById('favorite').children;
      for (var j = 0; j < 5; j++) {
        if (child[j].classList.contains('icon-ai-mark')) {
          child[j].classList.remove('icon-ai-mark');
          child[j].classList.add('icon-shoucang');
        }
      }
      for (var i = 0; i < parseInt(index); i++) {
        if (child[i].classList.contains('icon-shoucang')) {
          child[i].classList.remove('icon-shoucang');
          child[i].classList.add('icon-ai-mark');
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36509716","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/complaintComponenst/evaluate.vue
var evaluate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.dataList),function(item,index){return _c('section',{key:index},[_c('group',{directives:[{name:"show",rawName:"v-show",value:(_vm.his),expression:"his"}],staticStyle:{"margin-top":"-0.94em"},nativeOn:{"click":function($event){return _vm.showevaluate($event)}}},[_c('p',{staticStyle:{"padding":"7.5px 4px","font-size":"12px","color":"gray"}},[_vm._v("您对本次服务的评价")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","padding":"8px 0"}},[_c('i',{staticClass:"iconfont icon-shoucang",staticStyle:{"font-size":"40px"}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-shoucang",staticStyle:{"font-size":"40px"}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-shoucang",staticStyle:{"font-size":"40px"}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-shoucang",staticStyle:{"font-size":"40px"}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-shoucang",staticStyle:{"font-size":"40px"}})])]),_vm._v(" "),_c('group',[_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides8),expression:"hides8"}],staticClass:"statebar"},[_c('flexbox-item',{staticClass:"time",attrs:{"span":3}},[_c('p',{staticStyle:{"margin-top":"-19px"}},[_vm._v(_vm._s(item.endDate))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-top":"-19px"}},[_c('i',{staticClass:"iconfont icon-ai-mark",staticStyle:{"font-size":"33px","color":"orange"}})])]),_vm._v(" "),_c('flexbox-item',{staticClass:"content"},[_c('div',[_c('h4',[_vm._v("已评价")]),_vm._v(" "),_c('p',[_vm._v("感谢您的支持，祝您生活幸福美满!")])])])],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides7),expression:"hides7"}],staticClass:"stateline"},[_c('flexbox-item',{attrs:{"span":3}}),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-left":"50%"}},[_c('p',{staticStyle:{"height":"50px","width":"1px","background":"#848383"}})])]),_vm._v(" "),_c('flexbox-item')],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides6),expression:"hides6"}],staticClass:"statebar"},[_c('flexbox-item',{staticClass:"time",attrs:{"span":3}},[_c('p',{staticStyle:{"margin-top":"-19px"}},[_vm._v(_vm._s(item.returnDate))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-top":"-19px"}},[_c('i',{staticClass:"iconfont icon-dianhua",staticStyle:{"font-size":"33px","color":"orange"}})])]),_vm._v(" "),_c('flexbox-item',{staticClass:"content"},[_c('div',[_c('h4',[_vm._v("已回访")]),_vm._v(" "),_c('p',[_vm._v("您的建议已处理完成，感谢您的提问，请对本次服务进行评分。")])])])],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides5),expression:"hides5"}],staticClass:"stateline"},[_c('flexbox-item',{attrs:{"span":3}}),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-left":"50%"}},[_c('p',{staticStyle:{"height":"50px","width":"1px","background":"#848383"}})])]),_vm._v(" "),_c('flexbox-item')],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides4),expression:"hides4"}],staticClass:"statebar"},[_c('flexbox-item',{staticClass:"time",attrs:{"span":3}},[_c('p',{staticStyle:{"margin-top":"-19px"}},[_vm._v(_vm._s(item.finishDate))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-top":"-19px"}},[_c('i',{staticClass:"iconfont icon-duihao2",staticStyle:{"font-size":"33px","color":"orange"}})])]),_vm._v(" "),_c('flexbox-item',{staticClass:"content"},[_c('div',[_c('h4',[_vm._v("已回复")]),_vm._v(" "),_c('p',[_vm._v("您提出的问题已解决，稍后会有工作人员进行回访，请注意接听来电")])])])],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides3),expression:"hides3"}],staticClass:"stateline"},[_c('flexbox-item',{attrs:{"span":3}}),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-left":"50%"}},[_c('p',{staticStyle:{"height":"50px","width":"1px","background":"#848383"}})])]),_vm._v(" "),_c('flexbox-item')],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides2),expression:"hides2"}],staticClass:"statebar"},[_c('flexbox-item',{staticClass:"time",attrs:{"span":3}},[_c('p',{staticStyle:{"margin-top":"-19px"}},[_vm._v(_vm._s(item.handleDate))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-top":"-19px"}},[_c('i',{staticClass:"iconfont icon-weixiu1",staticStyle:{"font-size":"33px","color":"orange"}})])]),_vm._v(" "),_c('flexbox-item',{staticClass:"content"},[_c('div',[_c('h4',[_vm._v("已受理")]),_vm._v(" "),_c('p',[_vm._v("已转交之对应处理人，请你耐心等待")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("处理人："+_vm._s(item.handleMan))]),_vm._v(" "),_c('strong',{staticStyle:{"margin-left":"10px"}},[_vm._v("联系电话："+_vm._s(item.handlePhone))])])])])],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides1),expression:"hides1"}],staticClass:"stateline"},[_c('flexbox-item',{attrs:{"span":3}}),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-left":"50%"}},[_c('p',{staticStyle:{"height":"50px","width":"1px","background":"#848383"}})])]),_vm._v(" "),_c('flexbox-item')],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides),expression:"hides"}],staticClass:"statebar"},[_c('flexbox-item',{staticClass:"time",attrs:{"span":3}},[_c('p',{staticStyle:{"margin-top":"-19px"}},[_vm._v(_vm._s(item.feedbackDate))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-top":"-19px"}},[_c('i',{staticClass:"iconfont icon-shouji-copy",staticStyle:{"font-size":"33px","color":"orange"}})])]),_vm._v(" "),_c('flexbox-item',{staticClass:"content"},[_c('div',[_c('h4',[_vm._v("提交成功")]),_vm._v(" "),_c('p',[_vm._v("您的建议已成功提交，等待处理")])])])],1)],1),_vm._v(" "),(_vm.evaluate)?_c('div',{attrs:{"id":"evaluate"}},[_c('span',{attrs:{"id":"close"},on:{"click":_vm.hideevaluate}},[_c('i',{staticClass:"iconfont icon-guanbi"})]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("评价服务")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","padding":"5px 0"},attrs:{"id":"favorite"}},[_c('i',{staticClass:"iconfont icon-ai-mark",staticStyle:{"font-size":"40px"},on:{"click":function($event){_vm.preference(1)}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-ai-mark",staticStyle:{"font-size":"40px"},on:{"click":function($event){_vm.preference(2)}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-ai-mark",staticStyle:{"font-size":"40px"},on:{"click":function($event){_vm.preference(3)}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-ai-mark",staticStyle:{"font-size":"40px"},on:{"click":function($event){_vm.preference(4)}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-ai-mark",staticStyle:{"font-size":"40px"},on:{"click":function($event){_vm.preference(5)}}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.greads)+"分,"+_vm._s(_vm.remark))])]),_vm._v(" "),_c('div',{staticClass:"tag",attrs:{"id":"tag"}},[_c('x-button',{staticStyle:{"margin-right":"5px"},attrs:{"mini":"","id":"high"},nativeOn:{"click":function($event){_vm.changeStyle('high')}}},[_vm._v("办事效率高")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-right":"5px"},attrs:{"mini":"","id":"ok"},nativeOn:{"click":function($event){_vm.changeStyle('ok')}}},[_vm._v("服务态度好")])],1),_vm._v(" "),_c('div',{staticStyle:{"width":"96%","margin":"10px 2%"}},[_c('x-textarea',{staticStyle:{"font-size":"0.8em","border":"1px solid #ddd"},attrs:{"placeholder":"描述具体情况有助于优化问题","rows":5,"max":300},model:{value:(_vm.info),callback:function ($$v) {_vm.info=$$v},expression:"info"}})],1),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"20px"},attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.submitData()}}},[_vm._v("提交")])],1):_vm._e(),_vm._v(" "),_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_vm._v(" "+_vm._s(_vm.datays))])],1)}),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1,"text":_vm.text_1}})],2)}
var evaluate_staticRenderFns = []
var evaluate_esExports = { render: evaluate_render, staticRenderFns: evaluate_staticRenderFns }
/* harmony default export */ var components_complaintComponenst_evaluate = (evaluate_esExports);
// CONCATENATED MODULE: ./src/components/complaintComponenst/evaluate.vue
function evaluate_injectStyle (ssrContext) {
  __webpack_require__("LHZU")
}
var evaluate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var evaluate___vue_template_functional__ = false
/* styles */
var evaluate___vue_styles__ = evaluate_injectStyle
/* scopeId */
var evaluate___vue_scopeId__ = "data-v-36509716"
/* moduleIdentifier (server only) */
var evaluate___vue_module_identifier__ = null
var evaluate_Component = evaluate_normalizeComponent(
  complaintComponenst_evaluate,
  components_complaintComponenst_evaluate,
  evaluate___vue_template_functional__,
  evaluate___vue_styles__,
  evaluate___vue_scopeId__,
  evaluate___vue_module_identifier__
)

/* harmony default export */ var src_components_complaintComponenst_evaluate = (evaluate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/complaintComponenst/serviceMultiplePage.vue




/* harmony default export */ var serviceMultiplePage = ({
  data: function data() {
    return {};
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/serviceMultiplePage") {
      document.title = "我的建议";
    }
    this.openid = this.$router.history.current.query.openid, this.phone = this.$router.history.current.query.phone;
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/complaintComponenst/serviceMultiplePage.vue




/* harmony default export */ var complaintComponenst_serviceMultiplePage = ({
  data: function data() {
    return {};
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/serviceMultiplePage") {
      document.title = "我的建议";
    }
    this.openid = this.$router.history.current.query.openid, this.phone = this.$router.history.current.query.phone;
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e387630","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/complaintComponenst/serviceMultiplePage.vue
var serviceMultiplePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"am_cont am_postion"},[_c('flexbox',[_c('flexbox-item',{staticClass:"am_cont"},[_c('strong',{staticClass:"iconfont icon-zhangdan am_fonts"}),_vm._v(" "),_c('router-link',{attrs:{"to":{path:'/complaint',query:{}}}},[_c('p',[_vm._v("您还没有留下建议，赶快去吐槽吧!")])])],1)],1)],1)}
var serviceMultiplePage_staticRenderFns = []
var serviceMultiplePage_esExports = { render: serviceMultiplePage_render, staticRenderFns: serviceMultiplePage_staticRenderFns }
/* harmony default export */ var components_complaintComponenst_serviceMultiplePage = (serviceMultiplePage_esExports);
// CONCATENATED MODULE: ./src/components/complaintComponenst/serviceMultiplePage.vue
function serviceMultiplePage_injectStyle (ssrContext) {
  __webpack_require__("rqO2")
}
var serviceMultiplePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var serviceMultiplePage___vue_template_functional__ = false
/* styles */
var serviceMultiplePage___vue_styles__ = serviceMultiplePage_injectStyle
/* scopeId */
var serviceMultiplePage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var serviceMultiplePage___vue_module_identifier__ = null
var serviceMultiplePage_Component = serviceMultiplePage_normalizeComponent(
  complaintComponenst_serviceMultiplePage,
  components_complaintComponenst_serviceMultiplePage,
  serviceMultiplePage___vue_template_functional__,
  serviceMultiplePage___vue_styles__,
  serviceMultiplePage___vue_scopeId__,
  serviceMultiplePage___vue_module_identifier__
)

/* harmony default export */ var src_components_complaintComponenst_serviceMultiplePage = (serviceMultiplePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/repair.vue

















/* harmony default export */ var repair = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    Group: group["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Datetime: vux_src_components_datetime,
    Alert: components_alert["a" /* default */],
    Loading: vux_src_components_loading,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      sbm: false, // 为false时候 提交不能点击
      src: '',
      houseonwer: '1592645632(1592645632)',
      houseinfo: '',
      repairtype: '',
      repair: [],
      info: '',
      perTag: [],
      perTagId: [],
      perTagName: [],
      pubTag: [],
      pubTagId: [],
      pubTagName: [],
      ensureTime: [],
      ensureDate: '',
      minyear: '',
      timelist: [['8:00-8:59', '9:00-9:59', '10:00-10:59', '11:00-11:59', '12:00-12:59', '13:00-13:59', '14:00-14:59', '15:00-15:59', '16:00-16:59', '17:00-17:59']],
      showTime: true,
      filecontent: [],
      showselectTime: false,
      format: function format(ensureDate) {
        return '' + ensureDate;
      },
      comnCode: '',
      hsNo: '',
      hsName: '',
      hsPhone: '',
      message: '',
      showAlert: false,
      show_1: false,
      show2: false,
      text_1: "",
      useragent: ''
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/repair") {
      document.title = "报事报修";
    }
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
    console.log('this.useragent = ' + this.useragent);
    var curTime = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD HH');
    var curHour = Object(date_format["a" /* default */])(new Date(), 'HH');
    this.ensureDate = curTime + ':00-' + curHour + ':59';
    console.log(this.ensureDate);
    this.minyear = new Date().getFullYear();
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      if (res.body.result) {
        console.log(res);
        var data = res.body.result[0];
        this.src = data.photoUrl;
        this.houseinfo = data.comName + data.hsNo;
        this.houseonwer = data.name + "(" + data.mainPhone + ")";
        this.hsNo = data.hsNo;
        this.hsName = data.hsName;
        this.comnCode = data.comn_code;
        this.hsPhone = data.mainPhone;
        this.initRepairTypeList();
      }
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    initRepairTypeList: function initRepairTypeList() {
      this.$http.get(global.host + 'repair/findRepairTypeList?comnCode=' + this.comnCode).then(function (res) {
        console.log(res);
        for (var i = 0; i < res.body.priAreaList.length; i++) {
          this.perTag.push(res.body.priAreaList[i]);
          this.perTagId.push(res.body.priAreaList[i].id);
          this.perTagName.push(res.body.priAreaList[i].name);
        }
        for (var _i = 0; _i < res.body.pubAreaList.length; _i++) {
          this.pubTag.push(res.body.pubAreaList[_i]);
          this.pubTagId.push(res.body.pubAreaList[_i].id);
          this.pubTagName.push(res.body.pubAreaList[_i].name);
        }

        console.log(this.perTag);
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },
    deleteImg: function deleteImg(index) {
      this.filecontent.splice(index, 1);
    },
    filteremoji: function filteremoji() {
      var ranges = ['\uD83C[\uDF00-\uDFFF]', '\uD83D[\uDC00-\uDE4F]', '\uD83D[\uDE80-\uDEFF]'];
      this.info = this.info.replace(new RegExp(ranges.join('|'), 'g'), '');
    },
    onItemClick: function onItemClick(index) {
      var size = document.getElementById('tag').children.length;
      for (var i = 0; i < size; i++) {
        if (document.getElementById('tag').children[i].classList.contains('weui-btn_primary')) {
          document.getElementById('tag').children[i].classList.remove('weui-btn_primary');
        }
      }
      var sizeType = this.repair.length;
      for (var _i2 = 0; _i2 < sizeType; _i2++) {
        this.repair.pop();
      }
      switch (index) {
        case 0:
          this.showTime = true;
          break;
        case 1:
          this.showTime = false;
          break;
      }
    },
    changeStype: function changeStype(index) {
      var classList = document.getElementById(index).classList;
      if (classList.contains('weui-btn_primary')) {
        classList.remove('weui-btn_primary');
        this.repair.splice(this.repair.indexOf(index), 1);
      } else {
        classList.add('weui-btn_primary');
        this.repair.push(index);
      }
    },
    selectFile: function selectFile() {
      var _this = this;

      var filehandler = document.getElementById('file');
      if (filehandler.files) {
        var reader;

        (function () {
          var fileList = filehandler.files;
          var self = _this;
          var size = _this.filecontent.length;

          for (var i = 0; i < (fileList.length > 3 ? 3 : fileList.length); i++) {
            reader = new FileReader();

            reader.readAsDataURL(fileList[i]);

            reader.onload = function (event) {
              var img = new Image();

              var width = 680,
                  //图像大小
              quality = 0.8,
                  //图像质量
              canvas = document.createElement("canvas"),
                  drawer = canvas.getContext("2d");
              img.src = this.result;
              img.onload = function () {
                canvas.width = width;
                canvas.height = width * (img.height / img.width);
                drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
                var imgBase64 = canvas.toDataURL("image/jpeg", quality);
                self.filecontent.push(imgBase64);
                img.src = "";
              };
            };
          }
          for (var j = 0; j < size; j++) {
            _this.filecontent.pop();
          }
        })();
      }
    },
    dianjiFile: function dianjiFile(ev) {
      var oEvent = ev || event;
      if (!oEvent.isTrusted) {
        document.getElementById("file").click();
      }

      oEvent.cancelBubble = true;
      oEvent.stopPropagation();
    },
    showTimeBox: function showTimeBox() {
      this.showselectTime = !this.showselectTime;
    },
    selectTime: function selectTime() {
      this.ensureDate = this.ensureDate + ' ' + this.ensureTime[0];
    },
    submitForm: function submitForm() {
      this.filteremoji();
      this.show_1 = true;
      this.sbm = true;

      this.show_1 = true;
      if (this.repair.length < 1) {
        this.message = '请选择报修类型';
        this.showAlert = true;
        this.show_1 = false;
        this.sbm = false;
      } else if (!this.info) {
        this.message = '请输入报修内容';
        this.showAlert = true;
        this.show_1 = false;
        this.sbm = false;
      } else if (!this.ensureDate && this.showTime) {
        this.message = '请选择服务上门时间';
        this.showAlert = true;
        this.show_1 = false;
        this.sbm = false;
      } else {
        this.show1 = true;
        this.show2 = true;
        this.repairType = this.repair.join(',');
        var sendDate = {};
        sendDate.comnCode = this.comnCode;
        sendDate.hsNo = this.hsNo;
        sendDate.hsName = this.hsName;
        sendDate.hsPhone = this.hsPhone;
        sendDate.repairType = this.repairType;
        sendDate.repairDesc = this.info;
        sendDate.applyDate = this.ensureDate;
        sendDate.images = this.filecontent;
        sendDate.handleState = '0';
        this.$http.post(global.host + 'repair/submitrepair', sendDate).then(function (res) {
          console.log(res);
          this.show1 = false;
          this.show2 = false;
          if (res.body.msgcode == '120') {
            this.message = '报修信息提交失败';
            this.showAlert = true;
            this.show_1 = false;
            this.sbm = false;
          } else {
            this.message = '报修信息提交成功';
            this.showAlert = true;
            this.show_1 = false;
          }
          document.getElementById("btns").disabled = false;
        }, function (err) {
          console.log(err);
        });
      }
    },
    getIndex: function getIndex(arr, field) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == field) {
          return i;
        }
      }
    },
    hideAlert: function hideAlert() {
      if (this.message == '报修信息提交成功') {
        var hsNos = this.hsNo;
        this.sbm = false;
        this.$router.push({ path: '/orderlist', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, communityId: this.comnCode, hscodes: hsNos } });
      }
    },
    changefocus: function changefocus() {
      document.getElementById('file').click();
    },
    createObjectURL: function createObjectURL(object) {
      return window.URL ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/repair.vue

















/* harmony default export */ var repairComponents_repair = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    Group: group["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Datetime: vux_src_components_datetime,
    Alert: components_alert["a" /* default */],
    Loading: vux_src_components_loading,
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      sbm: false, // 为false时候 提交不能点击
      src: '',
      houseonwer: '1592645632(1592645632)',
      houseinfo: '',
      repairtype: '',
      repair: [],
      info: '',
      perTag: [],
      perTagId: [],
      perTagName: [],
      pubTag: [],
      pubTagId: [],
      pubTagName: [],
      ensureTime: [],
      ensureDate: '',
      minyear: '',
      timelist: [['8:00-8:59', '9:00-9:59', '10:00-10:59', '11:00-11:59', '12:00-12:59', '13:00-13:59', '14:00-14:59', '15:00-15:59', '16:00-16:59', '17:00-17:59']],
      showTime: true,
      filecontent: [],
      showselectTime: false,
      format: function format(ensureDate) {
        return '' + ensureDate;
      },
      comnCode: '',
      hsNo: '',
      hsName: '',
      hsPhone: '',
      message: '',
      showAlert: false,
      show_1: false,
      show2: false,
      text_1: "",
      useragent: ''
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/repair") {
      document.title = "报事报修";
    }
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
    console.log('this.useragent = ' + this.useragent);
    var curTime = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD HH');
    var curHour = Object(date_format["a" /* default */])(new Date(), 'HH');
    this.ensureDate = curTime + ':00-' + curHour + ':59';
    console.log(this.ensureDate);
    this.minyear = new Date().getFullYear();
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      if (res.body.result) {
        console.log(res);
        var data = res.body.result[0];
        this.src = data.photoUrl;
        this.houseinfo = data.comName + data.hsNo;
        this.houseonwer = data.name + "(" + data.mainPhone + ")";
        this.hsNo = data.hsNo;
        this.hsName = data.hsName;
        this.comnCode = data.comn_code;
        this.hsPhone = data.mainPhone;
        this.initRepairTypeList();
      }
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    initRepairTypeList: function initRepairTypeList() {
      this.$http.get(global.host + 'repair/findRepairTypeList?comnCode=' + this.comnCode).then(function (res) {
        console.log(res);
        for (var i = 0; i < res.body.priAreaList.length; i++) {
          this.perTag.push(res.body.priAreaList[i]);
          this.perTagId.push(res.body.priAreaList[i].id);
          this.perTagName.push(res.body.priAreaList[i].name);
        }
        for (var _i = 0; _i < res.body.pubAreaList.length; _i++) {
          this.pubTag.push(res.body.pubAreaList[_i]);
          this.pubTagId.push(res.body.pubAreaList[_i].id);
          this.pubTagName.push(res.body.pubAreaList[_i].name);
        }

        console.log(this.perTag);
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },
    deleteImg: function deleteImg(index) {
      this.filecontent.splice(index, 1);
    },
    filteremoji: function filteremoji() {
      var ranges = ['\uD83C[\uDF00-\uDFFF]', '\uD83D[\uDC00-\uDE4F]', '\uD83D[\uDE80-\uDEFF]'];
      this.info = this.info.replace(new RegExp(ranges.join('|'), 'g'), '');
    },
    onItemClick: function onItemClick(index) {
      var size = document.getElementById('tag').children.length;
      for (var i = 0; i < size; i++) {
        if (document.getElementById('tag').children[i].classList.contains('weui-btn_primary')) {
          document.getElementById('tag').children[i].classList.remove('weui-btn_primary');
        }
      }
      var sizeType = this.repair.length;
      for (var _i2 = 0; _i2 < sizeType; _i2++) {
        this.repair.pop();
      }
      switch (index) {
        case 0:
          this.showTime = true;
          break;
        case 1:
          this.showTime = false;
          break;
      }
    },
    changeStype: function changeStype(index) {
      var classList = document.getElementById(index).classList;
      if (classList.contains('weui-btn_primary')) {
        classList.remove('weui-btn_primary');
        this.repair.splice(this.repair.indexOf(index), 1);
      } else {
        classList.add('weui-btn_primary');
        this.repair.push(index);
      }
    },
    selectFile: function selectFile() {
      var _this = this;

      var filehandler = document.getElementById('file');
      if (filehandler.files) {
        var reader;

        (function () {
          var fileList = filehandler.files;
          var self = _this;
          var size = _this.filecontent.length;

          for (var i = 0; i < (fileList.length > 3 ? 3 : fileList.length); i++) {
            reader = new FileReader();

            reader.readAsDataURL(fileList[i]);

            reader.onload = function (event) {
              var img = new Image();

              var width = 680,
                  //图像大小
              quality = 0.8,
                  //图像质量
              canvas = document.createElement("canvas"),
                  drawer = canvas.getContext("2d");
              img.src = this.result;
              img.onload = function () {
                canvas.width = width;
                canvas.height = width * (img.height / img.width);
                drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
                var imgBase64 = canvas.toDataURL("image/jpeg", quality);
                self.filecontent.push(imgBase64);
                img.src = "";
              };
            };
          }
          for (var j = 0; j < size; j++) {
            _this.filecontent.pop();
          }
        })();
      }
    },
    dianjiFile: function dianjiFile(ev) {
      var oEvent = ev || event;
      if (!oEvent.isTrusted) {
        document.getElementById("file").click();
      }

      oEvent.cancelBubble = true;
      oEvent.stopPropagation();
    },
    showTimeBox: function showTimeBox() {
      this.showselectTime = !this.showselectTime;
    },
    selectTime: function selectTime() {
      this.ensureDate = this.ensureDate + ' ' + this.ensureTime[0];
    },
    submitForm: function submitForm() {
      this.filteremoji();
      this.show_1 = true;
      this.sbm = true;

      this.show_1 = true;
      if (this.repair.length < 1) {
        this.message = '请选择报修类型';
        this.showAlert = true;
        this.show_1 = false;
        this.sbm = false;
      } else if (!this.info) {
        this.message = '请输入报修内容';
        this.showAlert = true;
        this.show_1 = false;
        this.sbm = false;
      } else if (!this.ensureDate && this.showTime) {
        this.message = '请选择服务上门时间';
        this.showAlert = true;
        this.show_1 = false;
        this.sbm = false;
      } else {
        this.show1 = true;
        this.show2 = true;
        this.repairType = this.repair.join(',');
        var sendDate = {};
        sendDate.comnCode = this.comnCode;
        sendDate.hsNo = this.hsNo;
        sendDate.hsName = this.hsName;
        sendDate.hsPhone = this.hsPhone;
        sendDate.repairType = this.repairType;
        sendDate.repairDesc = this.info;
        sendDate.applyDate = this.ensureDate;
        sendDate.images = this.filecontent;
        sendDate.handleState = '0';
        this.$http.post(global.host + 'repair/submitrepair', sendDate).then(function (res) {
          console.log(res);
          this.show1 = false;
          this.show2 = false;
          if (res.body.msgcode == '120') {
            this.message = '报修信息提交失败';
            this.showAlert = true;
            this.show_1 = false;
            this.sbm = false;
          } else {
            this.message = '报修信息提交成功';
            this.showAlert = true;
            this.show_1 = false;
          }
          document.getElementById("btns").disabled = false;
        }, function (err) {
          console.log(err);
        });
      }
    },
    getIndex: function getIndex(arr, field) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == field) {
          return i;
        }
      }
    },
    hideAlert: function hideAlert() {
      if (this.message == '报修信息提交成功') {
        var hsNos = this.hsNo;
        this.sbm = false;
        this.$router.push({ path: '/orderlist', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, communityId: this.comnCode, hscodes: hsNos } });
      }
    },
    changefocus: function changefocus() {
      document.getElementById('file').click();
    },
    createObjectURL: function createObjectURL(object) {
      return window.URL ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4765492e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repairComponents/repair.vue
var repair_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"repair",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"padding":"20px 15px","background":"#fff","border-bottom":"3px solid rgb(245,245,245)"}},[_c('div',{staticStyle:{"display":"inline-block","width":"20%","height":"70px","max-width":"80px","float":"left","margin-right":"10px"}},[_c('x-img',{staticClass:"repImg",staticStyle:{"height":"auto"},attrs:{"src":_vm.src}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","width":"75%","height":"70px","float":"left"}},[_c('h4',{staticStyle:{"padding-top":"8px","font-weight":"700","font-size":"1em","text-align":"center"}},[_vm._v(_vm._s(_vm.houseonwer))]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.6","font-size":"1em","padding-top":"5px","font-weight":"500","color":"rgb(123,123,123)"}},[_vm._v(_vm._s(_vm.houseinfo))])]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('group',{staticStyle:{"margin-top":"-1.323564em"}},[_c('tab',[_c('tab-item',{attrs:{"selected":""},on:{"on-item-click":function($event){_vm.onItemClick(0)}}},[_vm._v("室内")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":function($event){_vm.onItemClick(1)}}},[_vm._v("公共区域")])],1),_vm._v(" "),(_vm.showTime)?_c('div',{staticClass:"tag",attrs:{"id":"tag"}},_vm._l((_vm.perTag),function(item,key){return _c('x-button',{key:key,staticStyle:{"margin-right":"5px"},attrs:{"mini":"","id":item.id},nativeOn:{"click":function($event){_vm.changeStype(item.id)}}},[_vm._v(_vm._s(item.name))])})):_c('div',{staticClass:"tag",attrs:{"id":"tag"}},_vm._l((_vm.pubTag),function(item,key){return _c('x-button',{key:key,staticStyle:{"margin-right":"5px"},attrs:{"mini":"","id":item.id},nativeOn:{"click":function($event){_vm.changeStype(item.id)}}},[_vm._v(_vm._s(item.name))])})),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"50px","padding":"0px 15px"}},[_c('div',{staticStyle:{"width":"100%","height":"100%","border-top":"1px solid rgb(245,245,245)","position":"relative"}},[_c('img',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)","width":"30px","height":"30px"},attrs:{"src":__webpack_require__("5POz")}}),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)","left":"9%","font-size":"15px"}},[_vm._v("报修内容")])])]),_vm._v(" "),_c('x-textarea',{staticStyle:{"font-size":"0.8em"},attrs:{"placeholder":"请填写报修说明","rows":6,"max":300},model:{value:(_vm.info),callback:function ($$v) {_vm.info=$$v},expression:"info"}}),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"50px","padding":"0px 15px"}},[_c('div',{staticStyle:{"width":"100%","height":"100%","border-top":"1px solid rgb(245,245,245)","position":"relative"}},[_c('img',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)","width":"30px","height":"30px"},attrs:{"src":__webpack_require__("Y8g4")}}),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)","left":"9%","font-size":"15px"}},[_vm._v("照片上传")])])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"0 0 0 15px"}},[_c('div',{staticStyle:{"width":"80px","height":"80px","background-color":"#fff","line-height":"80px","position":"relative","display":"inline-block"}},[_c('input',{staticStyle:{"display":"block","opacity":"0","width":"80px","height":"80px","position":"absolute","z-index":"99999"},attrs:{"type":"file","name":"file","id":"file","accept":"image/*","multiple":"","max":"4"},on:{"change":_vm.selectFile}}),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","display":"block","width":"100%","height":"100%","top":"0"}},[_c('img',{staticClass:"iconfont ",staticStyle:{"display":"block","width":"80px","height":"80px"},attrs:{"src":__webpack_require__("9FLu"),"alt":""}})])]),_vm._v(" "),_vm._l((_vm.filecontent),function(item,index){return _c('div',{key:index,staticStyle:{"width":"80px","height":"80px","background-color":"#fff","line-height":"80px","position":"relative","display":"inline-block"}},[_c('img',{staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"src":item}}),_vm._v(" "),_c('i',{staticClass:"fa fa-times",staticStyle:{"font-size":"1.4rem","position":"absolute","right":"0","text-align":"center","top":"0px","width":"25px","height":"25px","background":"#ddd","border-radius":"50%"},on:{"click":function($event){_vm.deleteImg(index)}}})])})],2),_vm._v(" "),(_vm.showTime)?_c('datetime',{ref:"date",staticStyle:{"position":"relative","z-index":"20","font-size":"15px"},attrs:{"format":"YYYY-MM-DD","display-format":_vm.format,"min-year":_vm.minyear,"title":"服务上门时间"},on:{"on-change":_vm.showTimeBox},model:{value:(_vm.ensureDate),callback:function ($$v) {_vm.ensureDate=$$v},expression:"ensureDate"}}):_vm._e(),_vm._v(" "),(_vm.showTime)?_c('popup-picker',{staticStyle:{"position":"relative","z-index":"-10","margin-top":"-44px"},attrs:{"title":"服务上门时间","data":_vm.timelist,"show":_vm.showselectTime},on:{"on-change":_vm.selectTime},model:{value:(_vm.ensureTime),callback:function ($$v) {_vm.ensureTime=$$v},expression:"ensureTime"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"height":"15px"}}),_vm._v(" "),_c('x-button',{attrs:{"type":"primary","disabled":_vm.sbm,"id":"btns"},nativeOn:{"click":function($event){return _vm.submitForm($event)}}},[_vm._v("提交维修")]),_vm._v(" "),_c('alert',{attrs:{"title":"温馨提示"},on:{"on-hide":_vm.hideAlert},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_vm._v(" "+_vm._s(_vm.message))]),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var repair_staticRenderFns = []
var repair_esExports = { render: repair_render, staticRenderFns: repair_staticRenderFns }
/* harmony default export */ var components_repairComponents_repair = (repair_esExports);
// CONCATENATED MODULE: ./src/components/repairComponents/repair.vue
function repair_injectStyle (ssrContext) {
  __webpack_require__("YgkF")
  __webpack_require__("NYaz")
}
var repair_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var repair___vue_template_functional__ = false
/* styles */
var repair___vue_styles__ = repair_injectStyle
/* scopeId */
var repair___vue_scopeId__ = "data-v-4765492e"
/* moduleIdentifier (server only) */
var repair___vue_module_identifier__ = null
var repair_Component = repair_normalizeComponent(
  repairComponents_repair,
  components_repairComponents_repair,
  repair___vue_template_functional__,
  repair___vue_styles__,
  repair___vue_scopeId__,
  repair___vue_module_identifier__
)

/* harmony default export */ var src_components_repairComponents_repair = (repair_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/orderList.vue













/* harmony default export */ var orderList = ({
  name: "orderList",
  components: {
    XImg: vux_src_components_x_img,
    Group: group["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    global: global,
    Loading: vux_src_components_loading,
    XDialog: x_dialog["a" /* default */],
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      picheight: window.screen.width * 0.22 - 8,
      dataList: {},
      allId: "",
      msid: "",
      show1: false,
      show2: false
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/orderList") {
      document.title = "我的报修";
    }
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      if (res.body.result) {
        var data = res.body.result[0];
        this.getRepairList(data);
        this.show_1 = false;
      }
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    getRepairList: function getRepairList(paramData) {
      var phones = this.$router.history.current.query.phone;
      var sData = "comncode=" + paramData.comn_code + "&hscode=" + paramData.hsNo + "&hsphone=" + phones;
      this.$http.get(global.host + '/repair/findselfrepair?' + sData).then(function (res) {
        var _this = this;

        console.log('数据集合QQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQ');
        console.log(res);

        var datay = res.body.result;
        this.dataList = new Object();
        this.allId = new Object();
        for (var ks in datay) {
          if ((typeof ks === 'undefined' ? 'undefined' : typeof_default()(ks)) == "object") {

            for (var ms in ks) {
              this.dataList[ms] = ks[ms];
            }
          } else {
            (function () {
              _this.dataList[ks] = datay[ks];
              var sId = datay[ks].repairId;
              _this.$http.get(global.host + '/repair/findPictureById?repairId=' + sId).then(function (res) {
                var rpic = res.body.result;
                var rows = "";
                for (var _ms in rpic) {
                  rows += "<flexbox-item style=\'margin-right:8px\'><img id ='" + rpic[_ms].repairId + "' style=\"height:70px;width:70px\" onclick=\"document.getElementById('showAlertLayer').style.display='table';document.getElementById('preViewImg').src=\'" + rpic[_ms].repairPic + "\';\" src=\'" + rpic[_ms].repairPic + "\'></flexbox-item>";
                }
                document.getElementById("mts" + sId).innerHTML = rows;
              }, function (err) {
                console.log(err);
              });
            })();
          }
        }
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/orderList.vue













/* harmony default export */ var repairComponents_orderList = ({
  name: "orderList",
  components: {
    XImg: vux_src_components_x_img,
    Group: group["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    global: global,
    Loading: vux_src_components_loading,
    XDialog: x_dialog["a" /* default */],
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      picheight: window.screen.width * 0.22 - 8,
      dataList: {},
      allId: "",
      msid: "",
      show1: false,
      show2: false
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/orderList") {
      document.title = "我的报修";
    }
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      if (res.body.result) {
        var data = res.body.result[0];
        this.getRepairList(data);
        this.show_1 = false;
      }
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    getRepairList: function getRepairList(paramData) {
      var phones = this.$router.history.current.query.phone;
      var sData = "comncode=" + paramData.comn_code + "&hscode=" + paramData.hsNo + "&hsphone=" + phones;
      this.$http.get(global.host + '/repair/findselfrepair?' + sData).then(function (res) {
        var _this = this;

        console.log('数据集合QQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQ');
        console.log(res);

        var datay = res.body.result;
        this.dataList = new Object();
        this.allId = new Object();
        for (var ks in datay) {
          if ((typeof ks === 'undefined' ? 'undefined' : typeof_default()(ks)) == "object") {

            for (var ms in ks) {
              this.dataList[ms] = ks[ms];
            }
          } else {
            (function () {
              _this.dataList[ks] = datay[ks];
              var sId = datay[ks].repairId;
              _this.$http.get(global.host + '/repair/findPictureById?repairId=' + sId).then(function (res) {
                var rpic = res.body.result;
                var rows = "";
                for (var _ms in rpic) {
                  rows += "<flexbox-item style=\'margin-right:8px\'><img id ='" + rpic[_ms].repairId + "' style=\"height:70px;width:70px\" onclick=\"document.getElementById('showAlertLayer').style.display='table';document.getElementById('preViewImg').src=\'" + rpic[_ms].repairPic + "\';\" src=\'" + rpic[_ms].repairPic + "\'></flexbox-item>";
                }
                document.getElementById("mts" + sId).innerHTML = rows;
              }, function (err) {
                console.log(err);
              });
            })();
          }
        }
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b24020e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repairComponents/orderList.vue
var orderList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.dataList),function(key,index){return _c('div',{key:index,staticStyle:{"padding":"10px 15px","background":"#fff","border-bottom":"1px solid rgb(245,245,245)","position":"relative","margin-bottom":"10px"}},[_c('div',{staticStyle:{"display":"inline-block","width":"22%","height":"72px","max-width":"82px","float":"left","margin-right":"10px"}},[_c('x-img',{staticClass:"borImg",staticStyle:{"height":"100%"},attrs:{"src":key.headimg}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","width":"70%","height":"40px","float":"left"}},[_c('h4',{staticStyle:{"line-height":"1.8","padding-top":"3px","font-weight":"500","font-size":"1.2em"}},[_vm._v(_vm._s(key.hsName))]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"1.6","font-size":"1em","padding-top":"5px","font-weight":"500","white-space":"normal","color":"rgb(139, 139, 139)"}},[_vm._v(_vm._s(key.repairDate))])]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","right":"10px","top":"30px","font-size":"20px","background":"rgb(58, 213, 195)","border-radius":"6px","padding":"0 13px 1.3% 13px"}},[(key.repairState == '-1')?_c('router-link',{attrs:{"to":{path:'/repairsThr',query:{repairId:key.repairId,repairState:key.repairState}}}},[_c('span',{staticStyle:{"color":"#fff","font-size":"16px"}},[_vm._v("已终止")])]):_vm._e(),_vm._v(" "),(key.repairState == '0')?_c('router-link',{attrs:{"to":{path:'/repairsThr',query:{repairId:key.repairId,repairState:key.repairState}}}},[_c('span',{staticStyle:{"color":"#fff","font-size":"16px"}},[_vm._v("待维修")])]):_vm._e(),_vm._v(" "),(key.repairState == '1')?_c('router-link',{attrs:{"to":{path:'/repairsThr',query:{repairId:key.repairId,repairState:key.repairState}}}},[_c('span',{staticStyle:{"color":"#fff","font-size":"16px"}},[_vm._v("待完成")])]):_vm._e(),_vm._v(" "),(key.repairState == '2')?_c('router-link',{attrs:{"to":{path:'/repairsThr',query:{repairId:key.repairId,repairState:key.repairState}}}},[_c('span',{staticStyle:{"color":"#fff","font-size":"16px"}},[_vm._v("待评价")])]):_vm._e(),_vm._v(" "),(key.repairState == '3')?_c('router-link',{attrs:{"to":{path:'/repairsThr',query:{repairId:key.repairId,repairState:key.repairState}}}},[_c('span',{staticStyle:{"color":"#fff","font-size":"16px"}},[_vm._v("待评价")])]):_vm._e(),_vm._v(" "),(key.repairState == '4')?_c('router-link',{attrs:{"to":{path:'/repairsThr',query:{repairId:key.repairId,repairState:key.repairState}}}},[_c('span',{staticStyle:{"color":"#fff","font-size":"16px"}},[_vm._v("已完结")])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),_c('div',{staticStyle:{"line-height":"1.6","margin-top":"15px","margin-bottom":"8px","word-wrap":"break-word"}},[(key.repairType == '1')?_c('span',{staticStyle:{"color":"rgb(122, 150, 198)","padding-right":"10px"}},[_vm._v("#公共区域#")]):(key.repairType == '0')?_c('span',{staticStyle:{"color":"rgb(122, 150, 198)","padding-right":"10px"}},[_vm._v("#个人住宅#")]):_vm._e(),_vm._v(_vm._s(key.hsNo)+_vm._s(key.repairDesc))]),_vm._v(" "),_c('flexbox',{attrs:{"id":'mts'+key.repairId,"orient":"horizontal","align":"left"}})],1)}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],2)}
var orderList_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"},attrs:{"id":"showAlertLayer"}},[_c('div',{staticClass:"weui-mask"}),_vm._v(" "),_c('div',{staticClass:"weui-dialog"},[_c('img',{staticStyle:{"width":"100%","margin-bottom":"-8px","margin-right":"-1px"},attrs:{"id":"preViewImg","src":"","onclick":"document.getElementById('showAlertLayer').style.display='none'"}})])])}]
var orderList_esExports = { render: orderList_render, staticRenderFns: orderList_staticRenderFns }
/* harmony default export */ var components_repairComponents_orderList = (orderList_esExports);
// CONCATENATED MODULE: ./src/components/repairComponents/orderList.vue
function orderList_injectStyle (ssrContext) {
  __webpack_require__("uEo3")
}
var orderList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var orderList___vue_template_functional__ = false
/* styles */
var orderList___vue_styles__ = orderList_injectStyle
/* scopeId */
var orderList___vue_scopeId__ = "data-v-4b24020e"
/* moduleIdentifier (server only) */
var orderList___vue_module_identifier__ = null
var orderList_Component = orderList_normalizeComponent(
  repairComponents_orderList,
  components_repairComponents_orderList,
  orderList___vue_template_functional__,
  orderList___vue_styles__,
  orderList___vue_scopeId__,
  orderList___vue_module_identifier__
)

/* harmony default export */ var src_components_repairComponents_orderList = (orderList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/orderDetail.vue












/* harmony default export */ var orderDetail = ({
  name: "orderDetail",
  components: {
    Group: group["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XButton: vux_src_components_x_button,
    XTextarea: vux_src_components_x_textarea,
    global: global,
    Alert: components_alert["a" /* default */],
    dateFormat: date_format["a" /* default */],
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      info: '',
      evaluate: false,
      remark: '非常满意',
      greads: "5.0",
      dataList: {},
      hides: false,
      hides1: false,
      hides2: false,
      hides3: false,
      hides4: false,
      hides5: false,
      hides6: false,
      hides7: false,
      hides8: false,
      repirds: "",
      showAlert: false,
      datays: "",
      his: false,
      evaluateTime: ""
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    var repairIds = this.$router.history.current.query.repairId;
    this.$http.get(global.host + '/repair/findredetail?repairId=' + repairIds).then(function (res) {
      this.show_1 = false;
      var datay = res.body;
      this.dataList = new Object();
      this.repirds = res.body.result.repairId;
      console.log(datay);
      for (var ks in datay) {
        if ((typeof ks === 'undefined' ? 'undefined' : typeof_default()(ks)) == "object") {
          for (var ms in ks) {
            this.dataList[ms] = ks[ms];
          }
        } else {
          this.dataList[ks] = datay[ks];
        }
      }
      var codeId = res.body.result.repairState;
      if (codeId == '0') {
        this.hides = true;
      } else if (codeId == '1') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
      } else if (codeId == '2') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
        this.hides3 = true;
        this.hides4 = true;
      } else if (codeId == '3') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
        this.hides3 = true;
        this.hides4 = true;
        this.hides5 = true;
        this.hides6 = true;
        this.his = true;
      } else if (codeId == '4') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
        this.hides3 = true;
        this.hides4 = true;
        this.hides5 = true;
        this.hides6 = true;
        this.hides7 = true;
        this.hides8 = true;
        this.evaluateTime = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD HH:mm:ss');
      }
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    submitData: function submitData() {
      var usrsInfo = new Object();
      usrsInfo.repairId = this.repirds;
      usrsInfo.scoreLevel = this.greads;
      usrsInfo.scoreDesc = this.info;
      console.log(usrsInfo);
      var urls = global.host + '/repair/updevaluate';
      this.$http.post(urls, usrsInfo).then(function (res) {
        this.datays = res.body.msg;
        if (res.body.msgcode == "110") {
          this.showAlert = true;
          this.his = false;
          this.evaluate = false;
          this.evaluateTime = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD HH:mm:ss');
          this.hides7 = true;
          this.hides8 = true;
        }
      }, function (err) {
        console.log(err);
      });
    },
    showevaluate: function showevaluate() {
      this.evaluate = true;
    },
    hideevaluate: function hideevaluate() {
      this.evaluate = false;
    },
    changeStyle: function changeStyle(id) {
      var classList = document.getElementById(id).classList;
      if (classList.contains('weui-btn_primary')) {
        classList.remove('weui-btn_primary');
      } else {
        classList.add('weui-btn_primary');
      }
    },
    preference: function preference(index) {
      switch (parseInt(index)) {
        case 1:
          this.remark = '非常不满意';
          this.greads = "1";
          break;
        case 2:
          this.remark = '比较不满意';
          this.greads = "2";
          break;
        case 3:
          this.remark = '一般满意';
          this.greads = "3";
          break;
        case 4:
          this.remark = '比较满意';
          this.greads = "4";
          break;
        case 5:
          this.remark = '非常满意';
          this.greads = "5";
          break;

      }
      var child = document.getElementById('favorite').children;
      for (var j = 0; j < 5; j++) {
        if (child[j].classList.contains('icon-ai-mark')) {
          child[j].classList.remove('icon-ai-mark');
          child[j].classList.add('icon-shoucang');
        }
      }
      for (var i = 0; i < parseInt(index); i++) {
        if (child[i].classList.contains('icon-shoucang')) {
          child[i].classList.remove('icon-shoucang');
          child[i].classList.add('icon-ai-mark');
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/orderDetail.vue












/* harmony default export */ var repairComponents_orderDetail = ({
  name: "orderDetail",
  components: {
    Group: group["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XButton: vux_src_components_x_button,
    XTextarea: vux_src_components_x_textarea,
    global: global,
    Alert: components_alert["a" /* default */],
    dateFormat: date_format["a" /* default */],
    loadPage: src_components_loadingPage
  },
  data: function data() {
    return {
      info: '',
      evaluate: false,
      remark: '非常满意',
      greads: "5.0",
      dataList: {},
      hides: false,
      hides1: false,
      hides2: false,
      hides3: false,
      hides4: false,
      hides5: false,
      hides6: false,
      hides7: false,
      hides8: false,
      repirds: "",
      showAlert: false,
      datays: "",
      his: false,
      evaluateTime: ""
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    var repairIds = this.$router.history.current.query.repairId;
    this.$http.get(global.host + '/repair/findredetail?repairId=' + repairIds).then(function (res) {
      this.show_1 = false;
      var datay = res.body;
      this.dataList = new Object();
      this.repirds = res.body.result.repairId;
      console.log(datay);
      for (var ks in datay) {
        if ((typeof ks === 'undefined' ? 'undefined' : typeof_default()(ks)) == "object") {
          for (var ms in ks) {
            this.dataList[ms] = ks[ms];
          }
        } else {
          this.dataList[ks] = datay[ks];
        }
      }
      var codeId = res.body.result.repairState;
      if (codeId == '0') {
        this.hides = true;
      } else if (codeId == '1') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
      } else if (codeId == '2') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
        this.hides3 = true;
        this.hides4 = true;
      } else if (codeId == '3') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
        this.hides3 = true;
        this.hides4 = true;
        this.hides5 = true;
        this.hides6 = true;
        this.his = true;
      } else if (codeId == '4') {
        this.hides = true;
        this.hides1 = true;
        this.hides2 = true;
        this.hides3 = true;
        this.hides4 = true;
        this.hides5 = true;
        this.hides6 = true;
        this.hides7 = true;
        this.hides8 = true;
        this.evaluateTime = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD HH:mm:ss');
      }
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    submitData: function submitData() {
      var usrsInfo = new Object();
      usrsInfo.repairId = this.repirds;
      usrsInfo.scoreLevel = this.greads;
      usrsInfo.scoreDesc = this.info;
      console.log(usrsInfo);
      var urls = global.host + '/repair/updevaluate';
      this.$http.post(urls, usrsInfo).then(function (res) {
        this.datays = res.body.msg;
        if (res.body.msgcode == "110") {
          this.showAlert = true;
          this.his = false;
          this.evaluate = false;
          this.evaluateTime = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD HH:mm:ss');
          this.hides7 = true;
          this.hides8 = true;
        }
      }, function (err) {
        console.log(err);
      });
    },
    showevaluate: function showevaluate() {
      this.evaluate = true;
    },
    hideevaluate: function hideevaluate() {
      this.evaluate = false;
    },
    changeStyle: function changeStyle(id) {
      var classList = document.getElementById(id).classList;
      if (classList.contains('weui-btn_primary')) {
        classList.remove('weui-btn_primary');
      } else {
        classList.add('weui-btn_primary');
      }
    },
    preference: function preference(index) {
      switch (parseInt(index)) {
        case 1:
          this.remark = '非常不满意';
          this.greads = "1";
          break;
        case 2:
          this.remark = '比较不满意';
          this.greads = "2";
          break;
        case 3:
          this.remark = '一般满意';
          this.greads = "3";
          break;
        case 4:
          this.remark = '比较满意';
          this.greads = "4";
          break;
        case 5:
          this.remark = '非常满意';
          this.greads = "5";
          break;

      }
      var child = document.getElementById('favorite').children;
      for (var j = 0; j < 5; j++) {
        if (child[j].classList.contains('icon-ai-mark')) {
          child[j].classList.remove('icon-ai-mark');
          child[j].classList.add('icon-shoucang');
        }
      }
      for (var i = 0; i < parseInt(index); i++) {
        if (child[i].classList.contains('icon-shoucang')) {
          child[i].classList.remove('icon-shoucang');
          child[i].classList.add('icon-ai-mark');
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6df1018","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repairComponents/orderDetail.vue
var orderDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.dataList),function(item,index){return _c('section',{key:index},[_c('group',{directives:[{name:"show",rawName:"v-show",value:(_vm.his),expression:"his"}],staticStyle:{"margin-top":"-0.94em"},nativeOn:{"click":function($event){return _vm.showevaluate($event)}}},[_c('p',{staticStyle:{"padding":"7.5px 4px","font-size":"12px","color":"gray"}},[_vm._v("您对本次服务的评价")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","padding":"8px 0"}},[_c('i',{staticClass:"iconfont icon-shoucang",staticStyle:{"font-size":"40px"}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-shoucang",staticStyle:{"font-size":"40px"}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-shoucang",staticStyle:{"font-size":"40px"}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-shoucang",staticStyle:{"font-size":"40px"}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-shoucang",staticStyle:{"font-size":"40px"}})])]),_vm._v(" "),_c('group',[_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides8),expression:"hides8"}],staticClass:"statebar"},[_c('flexbox-item',{staticClass:"time",attrs:{"span":3}},[_c('p',{staticStyle:{"margin-top":"-19px"}},[_vm._v(_vm._s(item.endDate))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-top":"-19px"}},[_c('i',{staticClass:"iconfont icon-ai-mark",staticStyle:{"font-size":"33px","color":"orange"}})])]),_vm._v(" "),_c('flexbox-item',{staticClass:"content"},[_c('div',[_c('h4',[_vm._v("已评价")]),_vm._v(" "),_c('p',[_vm._v("感谢您的支持，祝您生活幸福美满")])])])],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides7),expression:"hides7"}],staticClass:"stateline"},[_c('flexbox-item',{attrs:{"span":3}}),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-left":"50%"}},[_c('p',{staticStyle:{"height":"50px","width":"1px","background":"#848383"}})])]),_vm._v(" "),_c('flexbox-item')],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides6),expression:"hides6"}],staticClass:"statebar"},[_c('flexbox-item',{staticClass:"time",attrs:{"span":3}},[_c('p',{staticStyle:{"margin-top":"-19px"}},[_vm._v(_vm._s(item.returnDate))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-top":"-19px"}},[_c('i',{staticClass:"iconfont icon-dianhua",staticStyle:{"font-size":"33px","color":"orange"}})])]),_vm._v(" "),_c('flexbox-item',{staticClass:"content"},[_c('div',[_c('h4',[_vm._v("已回访")]),_vm._v(" "),_c('p',[_vm._v("您的报修已处理完成，感谢您的提问，请对本次服务进行评分。")])])])],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides5),expression:"hides5"}],staticClass:"stateline"},[_c('flexbox-item',{attrs:{"span":3}}),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-left":"50%"}},[_c('p',{staticStyle:{"height":"50px","width":"1px","background":"#848383"}})])]),_vm._v(" "),_c('flexbox-item')],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides4),expression:"hides4"}],staticClass:"statebar"},[_c('flexbox-item',{staticClass:"time",attrs:{"span":3}},[_c('p',{staticStyle:{"margin-top":"-19px"}},[_vm._v(_vm._s(item.finishDate))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-top":"-19px"}},[_c('i',{staticClass:"iconfont icon-duihao2",staticStyle:{"font-size":"33px","color":"orange"}})])]),_vm._v(" "),_c('flexbox-item',{staticClass:"content"},[_c('div',[_c('h4',[_vm._v("已解决")]),_vm._v(" "),_c('p',[_vm._v("您报修的内容已解决，稍后会有工作人员进行回访，请注意接听来电")])])])],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides3),expression:"hides3"}],staticClass:"stateline"},[_c('flexbox-item',{attrs:{"span":3}}),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-left":"50%"}},[_c('p',{staticStyle:{"height":"50px","width":"1px","background":"#848383"}})])]),_vm._v(" "),_c('flexbox-item')],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides2),expression:"hides2"}],staticClass:"statebar"},[_c('flexbox-item',{staticClass:"time",attrs:{"span":3}},[_c('p',{staticStyle:{"margin-top":"-19px"}},[_vm._v(_vm._s(item.handleDate))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-top":"-19px"}},[_c('i',{staticClass:"iconfont icon-weixiu1",staticStyle:{"font-size":"33px","color":"orange"}})])]),_vm._v(" "),_c('flexbox-item',{staticClass:"content"},[_c('div',[_c('h4',[_vm._v("已受理")]),_vm._v(" "),_c('p',[_vm._v("已转交之对应的维修工人，请你耐心等待")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("处理人："+_vm._s(item.handleMan))]),_vm._v(" "),_c('strong',{staticStyle:{"margin-left":"10px"}},[_vm._v("联系电话："+_vm._s(item.handlePhone))])])])])],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides1),expression:"hides1"}],staticClass:"stateline"},[_c('flexbox-item',{attrs:{"span":3}}),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-left":"50%"}},[_c('p',{staticStyle:{"height":"50px","width":"1px","background":"#848383"}})])]),_vm._v(" "),_c('flexbox-item')],1),_vm._v(" "),_c('flexbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.hides),expression:"hides"}],staticClass:"statebar"},[_c('flexbox-item',{staticClass:"time",attrs:{"span":3}},[_c('p',{staticStyle:{"margin-top":"-19px"}},[_vm._v(_vm._s(item.repairDate))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1}},[_c('div',{staticStyle:{"margin-top":"-19px"}},[_c('i',{staticClass:"iconfont icon-shouji-copy",staticStyle:{"font-size":"33px","color":"orange"}})])]),_vm._v(" "),_c('flexbox-item',{staticClass:"content"},[_c('div',[_c('h4',[_vm._v("提交成功")]),_vm._v(" "),_c('p',[_vm._v("您的报修已成功提交，等待处理")])])])],1)],1),_vm._v(" "),(_vm.evaluate)?_c('div',{attrs:{"id":"evaluate"}},[_c('span',{attrs:{"id":"close"},on:{"click":_vm.hideevaluate}},[_c('i',{staticClass:"iconfont icon-guanbi"})]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("评价服务")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","padding":"5px 0"},attrs:{"id":"favorite"}},[_c('i',{staticClass:"iconfont icon-ai-mark",staticStyle:{"font-size":"40px"},on:{"click":function($event){_vm.preference(1)}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-ai-mark",staticStyle:{"font-size":"40px"},on:{"click":function($event){_vm.preference(2)}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-ai-mark",staticStyle:{"font-size":"40px"},on:{"click":function($event){_vm.preference(3)}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-ai-mark",staticStyle:{"font-size":"40px"},on:{"click":function($event){_vm.preference(4)}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-ai-mark",staticStyle:{"font-size":"40px"},on:{"click":function($event){_vm.preference(5)}}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.greads)+"分,"+_vm._s(_vm.remark))])]),_vm._v(" "),_c('div',{staticClass:"tag",attrs:{"id":"tag"}},[_c('x-button',{staticStyle:{"margin-right":"5px"},attrs:{"mini":"","id":"high"},nativeOn:{"click":function($event){_vm.changeStyle('high')}}},[_vm._v("办事效率高")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-right":"5px"},attrs:{"mini":"","id":"ok"},nativeOn:{"click":function($event){_vm.changeStyle('ok')}}},[_vm._v("服务态度好")])],1),_vm._v(" "),_c('div',{staticStyle:{"width":"96%","margin":"10px 2%"}},[_c('x-textarea',{staticStyle:{"font-size":"0.8em","border":"1px solid #ddd"},attrs:{"placeholder":"描述具体情况有助于优化问题","rows":5,"max":300},model:{value:(_vm.info),callback:function ($$v) {_vm.info=$$v},expression:"info"}})],1),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"20px"},attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.submitData()}}},[_vm._v("提交")])],1):_vm._e(),_vm._v(" "),_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_vm._v(" "+_vm._s(_vm.datays))])],1)}),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],2)}
var orderDetail_staticRenderFns = []
var orderDetail_esExports = { render: orderDetail_render, staticRenderFns: orderDetail_staticRenderFns }
/* harmony default export */ var components_repairComponents_orderDetail = (orderDetail_esExports);
// CONCATENATED MODULE: ./src/components/repairComponents/orderDetail.vue
function orderDetail_injectStyle (ssrContext) {
  __webpack_require__("q7WB")
}
var orderDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var orderDetail___vue_template_functional__ = false
/* styles */
var orderDetail___vue_styles__ = orderDetail_injectStyle
/* scopeId */
var orderDetail___vue_scopeId__ = "data-v-f6df1018"
/* moduleIdentifier (server only) */
var orderDetail___vue_module_identifier__ = null
var orderDetail_Component = orderDetail_normalizeComponent(
  repairComponents_orderDetail,
  components_repairComponents_orderDetail,
  orderDetail___vue_template_functional__,
  orderDetail___vue_styles__,
  orderDetail___vue_scopeId__,
  orderDetail___vue_module_identifier__
)

/* harmony default export */ var src_components_repairComponents_orderDetail = (orderDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/rapireMultiplePage.vue





/* harmony default export */ var rapireMultiplePage = ({
  data: function data() {
    return {
      openid: '',
      phone: ''
    };
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/rapireMultiplePage") {
      document.title = "我的报修";
    }
    this.openid = this.$router.history.current.query.openid, this.phone = this.$router.history.current.query.phone;
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/rapireMultiplePage.vue





/* harmony default export */ var repairComponents_rapireMultiplePage = ({
  data: function data() {
    return {
      openid: '',
      phone: ''
    };
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/rapireMultiplePage") {
      document.title = "我的报修";
    }
    this.openid = this.$router.history.current.query.openid, this.phone = this.$router.history.current.query.phone;
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a4daa14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repairComponents/rapireMultiplePage.vue
var rapireMultiplePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"am_cont am_postion"},[_c('flexbox',[_c('flexbox-item',{staticClass:"am_cont"},[_c('strong',{staticClass:"iconfont icon-zhangdan am_fonts"}),_vm._v(" "),_c('router-link',{attrs:{"to":{path:'/repair',query:{}}}},[_c('p',[_vm._v("您还没有留下报修记录，赶快去提报吧!")])])],1)],1)],1)}
var rapireMultiplePage_staticRenderFns = []
var rapireMultiplePage_esExports = { render: rapireMultiplePage_render, staticRenderFns: rapireMultiplePage_staticRenderFns }
/* harmony default export */ var components_repairComponents_rapireMultiplePage = (rapireMultiplePage_esExports);
// CONCATENATED MODULE: ./src/components/repairComponents/rapireMultiplePage.vue
function rapireMultiplePage_injectStyle (ssrContext) {
  __webpack_require__("v62e")
}
var rapireMultiplePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var rapireMultiplePage___vue_template_functional__ = false
/* styles */
var rapireMultiplePage___vue_styles__ = rapireMultiplePage_injectStyle
/* scopeId */
var rapireMultiplePage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var rapireMultiplePage___vue_module_identifier__ = null
var rapireMultiplePage_Component = rapireMultiplePage_normalizeComponent(
  repairComponents_rapireMultiplePage,
  components_repairComponents_rapireMultiplePage,
  rapireMultiplePage___vue_template_functional__,
  rapireMultiplePage___vue_styles__,
  rapireMultiplePage___vue_scopeId__,
  rapireMultiplePage___vue_module_identifier__
)

/* harmony default export */ var src_components_repairComponents_rapireMultiplePage = (rapireMultiplePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/imgDome.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var imgDome = ({
  data: function data() {
    return {
      showImg: false,
      scroll: ''
    };
  },

  watch: {
    scroll: function scroll() {
      this.$nextTick(function () {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
        console.log('赋值前------' + scrollTop);
        // document.getElementById('home').scrollHeight;
        // let boxHeight = document.documentElement.scrollHeight || document.body.scrollHeight 
        if (scrollTop != document.body.scrollHeight) {
          scrollTop = document.body.scrollHeight;
          document.documentElement.scrollTop = scrollTop;
        }
        console.log('赋值后------' + scrollTop);
        console.log(document.body.scrollHeight);
      });
    }
  },
  methods: {
    sky: function sky() {
      this.showImg = true;
      this.scroll = '1';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/imgDome.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var repairComponents_imgDome = ({
  data: function data() {
    return {
      showImg: false,
      scroll: ''
    };
  },

  watch: {
    scroll: function scroll() {
      this.$nextTick(function () {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
        console.log('赋值前------' + scrollTop);
        // document.getElementById('home').scrollHeight;
        // let boxHeight = document.documentElement.scrollHeight || document.body.scrollHeight 
        if (scrollTop != document.body.scrollHeight) {
          scrollTop = document.body.scrollHeight;
          document.documentElement.scrollTop = scrollTop;
        }
        console.log('赋值后------' + scrollTop);
        console.log(document.body.scrollHeight);
      });
    }
  },
  methods: {
    sky: function sky() {
      this.showImg = true;
      this.scroll = '1';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59884cbb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repairComponents/imgDome.vue
var imgDome_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chatContent",attrs:{"id":"home"}},[_c('div',{staticStyle:{"width":"100%","height":"800px","background":"black"}},[_c('div',{staticStyle:{"width":"50px","height":"50px","background":"skyblue","margin":"0 auto"},on:{"click":function($event){_vm.sky()}}})]),_vm._v(" "),(this.showImg == true)?_c('div',{staticStyle:{"width":"100%","height":"800px","background":"pink"}}):_vm._e()])}
var imgDome_staticRenderFns = []
var imgDome_esExports = { render: imgDome_render, staticRenderFns: imgDome_staticRenderFns }
/* harmony default export */ var components_repairComponents_imgDome = (imgDome_esExports);
// CONCATENATED MODULE: ./src/components/repairComponents/imgDome.vue
function imgDome_injectStyle (ssrContext) {
  __webpack_require__("xIcs")
}
var imgDome_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var imgDome___vue_template_functional__ = false
/* styles */
var imgDome___vue_styles__ = imgDome_injectStyle
/* scopeId */
var imgDome___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var imgDome___vue_module_identifier__ = null
var imgDome_Component = imgDome_normalizeComponent(
  repairComponents_imgDome,
  components_repairComponents_imgDome,
  imgDome___vue_template_functional__,
  imgDome___vue_styles__,
  imgDome___vue_scopeId__,
  imgDome___vue_module_identifier__
)

/* harmony default export */ var src_components_repairComponents_imgDome = (imgDome_Component.exports);

// EXTERNAL MODULE: ./node_modules/vant/lib/loading/style/index.js
var style = __webpack_require__("uTM9");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/vant/lib/loading/index.js
var lib_loading = __webpack_require__("Jq84");
var loading_default = /*#__PURE__*/__webpack_require__.n(lib_loading);

// EXTERNAL MODULE: ./node_modules/vant/lib/rate/style/index.js
var rate_style = __webpack_require__("QEGd");
var rate_style_default = /*#__PURE__*/__webpack_require__.n(rate_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/rate/index.js
var rate = __webpack_require__("OZZa");
var rate_default = /*#__PURE__*/__webpack_require__.n(rate);

// EXTERNAL MODULE: ./node_modules/vant/lib/popup/style/index.js
var popup_style = __webpack_require__("tLo2");
var popup_style_default = /*#__PURE__*/__webpack_require__.n(popup_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/popup/index.js
var lib_popup = __webpack_require__("blRl");
var popup_default = /*#__PURE__*/__webpack_require__.n(lib_popup);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/repairsOne.vue






 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _components;


/* harmony default export */ var repairsOne = ({
  components: (_components = {}, defineProperty_default()(_components, popup_default.a.name, popup_default.a), defineProperty_default()(_components, rate_default.a.name, rate_default.a), defineProperty_default()(_components, loading_default.a.name, loading_default.a), _components),
  data: function data() {
    return {
      loging: true,
      evaluate: false,
      value: "",
      valueone: "5",
      valuetwo: "4",
      percentage: 60,
      list: {
        percentage: 0,
        orderList: []
      },
      orderProgress: {
        percentage: 0, //订单当前总进度0-100  0==开始  100==完成
        //进度阶段List
        orderList: []
      },
      Dictionaries: [], // 评分标签
      Dictionaries_list: [], // 用户选择的评价标签
      handleMan: "", // 如果pc未派单 这个值为null 用户进来不显示头部 不为null才显示
      userList: {}, // 派单信息数据集
      handleId: ""
    };
  },
  mounted: function mounted() {
    //  alert(this.handleMan)
    //alert(this.$router.history.current.query.repairState)
    //  alert(this.$router.history.current.query.handleMan)
    this.handleMan = this.$router.history.current.query.handleMan;
    this.handleId = this.$router.history.current.query.handleId;
    this.isEvaluate();
    this.getAllListUser();
    this.getDictionaries();
    this.getUser();
  },

  methods: {
    // 点评价取消
    del: function del() {
      this.evaluate = false;
    },

    // 获取基本信息
    getUser: function getUser() {
      if (this.handleMan != null) {
        var userList = {};
        userList.handleMan = this.handleId;
        this.$http.post(global.host + "/repair/findOrderQuantity", userList).then(function (res) {
          console.log("基本信息");
          console.log(res);
          this.userList = res.body.result;
          this.value = res.body.result.avgNum;
        }, function (err) {
          console.log(err);
        });
      }
    },

    // 判断 如果参数符合标准 就弹出评价先评价 如果已评价 就不改变
    isEvaluate: function isEvaluate() {
      if (this.$router.history.current.query.repairState == 2 || this.$router.history.current.query.repairState == 3) {
        this.evaluate = true;
      }
    },

    // 删除指定元素公共方法
    removeByValue: function removeByValue(arr, val) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == val) {
          arr.splice(i, 1);
          break;
        }
      }
    },

    // 时间戳转换兼容判断机型
    formatDate: function formatDate(date, type) {
      if (date != undefined) {
        var add0 = function add0(m) {
          return m < 10 ? "0" + m : m;
        };

        //兼容ios
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) || navigator.userAgent.indexOf("Safari") > -1) {
          date = String(date).replace(/\-/g, "/");
        }
        var time = "";
        if (date.indexOf("-") != -1 || date.indexOf("/") != -1) {
          time = new Date(date);
        } else {
          time = new Date(JSON.parse(date));
        }
        var year = time.getFullYear();
        var month = time.getMonth() + 1;
        var date = time.getDate();
        var hours = time.getHours();
        var minutes = time.getMinutes();
        var seconds = time.getSeconds();
        var isTime = "";

        switch (type) {
          case "Y-M-D hh:mm:ss":
            isTime = year + "-" + add0(month) + "-" + add0(date) + " " + add0(hours) + ":" + add0(minutes) + ":" + add0(seconds);
            break;
          case "M-D hh:mm:ss":
            isTime = add0(month) + "-" + add0(date) + " " + add0(hours) + ":" + add0(minutes) + ":" + add0(seconds);
            break;
          case "M-D hh:mm":
            isTime = add0(month) + "-" + add0(date) + " " + add0(hours) + ":" + add0(minutes);
            break;
          case "hh:mm:ss":
            isTime = add0(hours) + ":" + add0(minutes) + ":" + add0(seconds);
            break;
          case "hh:mm":
            isTime = add0(hours) + ":" + add0(minutes);
            break;
        }
        return isTime;
      }
    },

    // 兼容时间格式
    getTs: function getTs(time) {
      var arr = time.split(/[- :]/),
          _date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]),
          timeStr = Date.parse(_date);
      return timeStr;
    },

    // 获取进度展示展示数据集
    getAllListUser: function getAllListUser() {
      this.list.orderList = [];
      this.$http.get(global.host + "repair/findHandleRecord?repairId=" + this.$router.history.current.query.repairId).then(function (response) {
        console.log("进度数据");
        // alert(JSON.stringify(response));
        console.log(response);
        // demo
        this.loging = false;
        for (var i = 0; i < response.body.result.length; i++) {
          var data = {
            id: i, //当前阶段id
            title: response.body.result[i].handleStatus, //当前阶段订单标题
            context: response.body.result[i].handleDesc, //当前阶段订单内容
            dataTime: response.body.result[i].handleDate //当前阶段订单结束时间
          };
          this.list.orderList.push(data);
        }
        for (var i = 0; i < this.list.orderList.length; i++) {
          //每次进度之后时间戳
          var timestamp2 = this.formatDate(this.list.orderList[i].dataTime, "Y-M-D hh:mm:ss");
          //开始时间戳
          var timestamp1 = this.formatDate(this.list.orderList[0].dataTime, "Y-M-D hh:mm:ss");
          //之后时间戳减开始
          var num = this.getTs(timestamp1) - this.getTs(timestamp2);
          //获取到总共时间
          var second = num / 1000;
          //判断当前度是否大于等于0
          if (parseInt(second / 3600) <= 0) {
            //最小0
            this.list.orderList[i].top = 0;
          } else {
            //长度拼接
            this.list.orderList[i].top = parseInt(second / 3600) + "0";
          }
        }
        //计算当前进度的总长度
        //获取最后时间戳
        var timestamp4 = this.formatDate(this.list.orderList[this.list.orderList.length - 1].dataTime, "Y-M-D hh:mm:ss");
        //获取开始时间戳
        var timestamp3 = this.formatDate(this.list.orderList[0].dataTime, "Y-M-D hh:mm:ss");
        //计算时间戳之差
        var num1 = this.getTs(timestamp3) - this.getTs(timestamp4);
        //获取到总时长
        var second1 = num1 / 1000;
        //判断总长度是否大于等于0
        if (parseInt(second1 / 3600) <= 0) {
          //最小0
          this.list.percentage = 0;
        } else {
          //拼接总进度长度
          this.list.percentage = parseInt(second1 / 3600) + "0";
        }
        //判断进度总长是否超过600
        if (this.list.percentage > 600) {
          //总进度超过600减半
          for (var j = 0; j < this.list.orderList.length; j++) {
            //每个进度减半
            this.list.orderList[j].top = this.list.orderList[j].top / 2;
          }
          //总长度减半
          this.list.percentage = this.list.percentage / 2;
        }
        //记录总加了多少长度
        var nuber = 0;
        //判断每个进度之间不能少于70px,少于70px,赋值给最低70
        for (var j = 0; j < this.list.orderList.length; j++) {
          //开始第一个阶段不用高度
          if (j == 0) {} else {
            //判断高度是否大于70
            if (this.list.orderList[j].top < 70) {
              // //小于70记录与70之间的差
              // nuber = 70 - this.list.orderList[j].top + nuber;
              //给本阶段赋值最少进度70
              this.list.orderList[j].top = 70;
              //本阶段加了长度，后面都得加上等长，循环加
              for (var s = j; s < this.list.orderList.length; s++) {
                //每个阶段循环增加
                this.list.orderList[s].top = this.list.orderList[s - 1].top + 70;
              }
              //总长度加每个进度之间的补差
              this.list.percentage = this.list.orderList[this.list.orderList.length - 1].top;
            }
          }
        }
      }, function (err) {
        console.log(err);
      });
    },

    // 获取字典
    getDictionaries: function getDictionaries() {
      this.$http.get(global.host + "repairMgr/findDictList?domain=REPAIR_SCOPE_LABEL").then(function (res) {
        if (res.body.statusCode == 200) {
          this.Dictionaries = res.body.result;

          console.log(this.Dictionaries);
        }
      }, function (err) {
        console.log(err);
      });
    },

    // 点击保存字典值 切换颜色
    getSazd: function getSazd(item, e) {
      if (e.target.classList.contains("dictionaryColor")) {
        e.target.classList.remove("dictionaryColor");
        this.removeByValue(this.Dictionaries_list, item);
      } else {
        this.Dictionaries_list.push(item);
        e.target.classList.add("dictionaryColor");
      }
    },

    // 提交评价
    payment: function payment() {
      this.Dictionaries_list = this.Dictionaries_list.join(",");
      console.log(this.Dictionaries_list);
      var submitScore = {};
      submitScore.repairId = this.$router.history.current.query.repairId;
      submitScore.handleScode = String(this.valueone);
      submitScore.serviceScode = String(this.valuetwo);
      submitScore.scodeDesc = this.Dictionaries_list;
      this.$http.post(global.host + "repair/submitScore", submitScore).then(function (res) {
        console.log(res);
        if (res.body.statusCode == 200) {
          this.getAllListUser();
          this.getUser();
          this.evaluate = false;
        }
      }, function (err) {
        console.log(err);
      });
      console.log(submitScore);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/repairsOne.vue






 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var repairsOne__components;


/* harmony default export */ var repairComponents_repairsOne = ({
  components: (repairsOne__components = {}, defineProperty_default()(repairsOne__components, popup_default.a.name, popup_default.a), defineProperty_default()(repairsOne__components, rate_default.a.name, rate_default.a), defineProperty_default()(repairsOne__components, loading_default.a.name, loading_default.a), repairsOne__components),
  data: function data() {
    return {
      loging: true,
      evaluate: false,
      value: "",
      valueone: "5",
      valuetwo: "4",
      percentage: 60,
      list: {
        percentage: 0,
        orderList: []
      },
      orderProgress: {
        percentage: 0, //订单当前总进度0-100  0==开始  100==完成
        //进度阶段List
        orderList: []
      },
      Dictionaries: [], // 评分标签
      Dictionaries_list: [], // 用户选择的评价标签
      handleMan: "", // 如果pc未派单 这个值为null 用户进来不显示头部 不为null才显示
      userList: {}, // 派单信息数据集
      handleId: ""
    };
  },
  mounted: function mounted() {
    //  alert(this.handleMan)
    //alert(this.$router.history.current.query.repairState)
    //  alert(this.$router.history.current.query.handleMan)
    this.handleMan = this.$router.history.current.query.handleMan;
    this.handleId = this.$router.history.current.query.handleId;
    this.isEvaluate();
    this.getAllListUser();
    this.getDictionaries();
    this.getUser();
  },

  methods: {
    // 点评价取消
    del: function del() {
      this.evaluate = false;
    },

    // 获取基本信息
    getUser: function getUser() {
      if (this.handleMan != null) {
        var userList = {};
        userList.handleMan = this.handleId;
        this.$http.post(global.host + "/repair/findOrderQuantity", userList).then(function (res) {
          console.log("基本信息");
          console.log(res);
          this.userList = res.body.result;
          this.value = res.body.result.avgNum;
        }, function (err) {
          console.log(err);
        });
      }
    },

    // 判断 如果参数符合标准 就弹出评价先评价 如果已评价 就不改变
    isEvaluate: function isEvaluate() {
      if (this.$router.history.current.query.repairState == 2 || this.$router.history.current.query.repairState == 3) {
        this.evaluate = true;
      }
    },

    // 删除指定元素公共方法
    removeByValue: function removeByValue(arr, val) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == val) {
          arr.splice(i, 1);
          break;
        }
      }
    },

    // 时间戳转换兼容判断机型
    formatDate: function formatDate(date, type) {
      if (date != undefined) {
        var add0 = function add0(m) {
          return m < 10 ? "0" + m : m;
        };

        //兼容ios
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) || navigator.userAgent.indexOf("Safari") > -1) {
          date = String(date).replace(/\-/g, "/");
        }
        var time = "";
        if (date.indexOf("-") != -1 || date.indexOf("/") != -1) {
          time = new Date(date);
        } else {
          time = new Date(JSON.parse(date));
        }
        var year = time.getFullYear();
        var month = time.getMonth() + 1;
        var date = time.getDate();
        var hours = time.getHours();
        var minutes = time.getMinutes();
        var seconds = time.getSeconds();
        var isTime = "";

        switch (type) {
          case "Y-M-D hh:mm:ss":
            isTime = year + "-" + add0(month) + "-" + add0(date) + " " + add0(hours) + ":" + add0(minutes) + ":" + add0(seconds);
            break;
          case "M-D hh:mm:ss":
            isTime = add0(month) + "-" + add0(date) + " " + add0(hours) + ":" + add0(minutes) + ":" + add0(seconds);
            break;
          case "M-D hh:mm":
            isTime = add0(month) + "-" + add0(date) + " " + add0(hours) + ":" + add0(minutes);
            break;
          case "hh:mm:ss":
            isTime = add0(hours) + ":" + add0(minutes) + ":" + add0(seconds);
            break;
          case "hh:mm":
            isTime = add0(hours) + ":" + add0(minutes);
            break;
        }
        return isTime;
      }
    },

    // 兼容时间格式
    getTs: function getTs(time) {
      var arr = time.split(/[- :]/),
          _date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]),
          timeStr = Date.parse(_date);
      return timeStr;
    },

    // 获取进度展示展示数据集
    getAllListUser: function getAllListUser() {
      this.list.orderList = [];
      this.$http.get(global.host + "repair/findHandleRecord?repairId=" + this.$router.history.current.query.repairId).then(function (response) {
        console.log("进度数据");
        // alert(JSON.stringify(response));
        console.log(response);
        // demo
        this.loging = false;
        for (var i = 0; i < response.body.result.length; i++) {
          var data = {
            id: i, //当前阶段id
            title: response.body.result[i].handleStatus, //当前阶段订单标题
            context: response.body.result[i].handleDesc, //当前阶段订单内容
            dataTime: response.body.result[i].handleDate //当前阶段订单结束时间
          };
          this.list.orderList.push(data);
        }
        for (var i = 0; i < this.list.orderList.length; i++) {
          //每次进度之后时间戳
          var timestamp2 = this.formatDate(this.list.orderList[i].dataTime, "Y-M-D hh:mm:ss");
          //开始时间戳
          var timestamp1 = this.formatDate(this.list.orderList[0].dataTime, "Y-M-D hh:mm:ss");
          //之后时间戳减开始
          var num = this.getTs(timestamp1) - this.getTs(timestamp2);
          //获取到总共时间
          var second = num / 1000;
          //判断当前度是否大于等于0
          if (parseInt(second / 3600) <= 0) {
            //最小0
            this.list.orderList[i].top = 0;
          } else {
            //长度拼接
            this.list.orderList[i].top = parseInt(second / 3600) + "0";
          }
        }
        //计算当前进度的总长度
        //获取最后时间戳
        var timestamp4 = this.formatDate(this.list.orderList[this.list.orderList.length - 1].dataTime, "Y-M-D hh:mm:ss");
        //获取开始时间戳
        var timestamp3 = this.formatDate(this.list.orderList[0].dataTime, "Y-M-D hh:mm:ss");
        //计算时间戳之差
        var num1 = this.getTs(timestamp3) - this.getTs(timestamp4);
        //获取到总时长
        var second1 = num1 / 1000;
        //判断总长度是否大于等于0
        if (parseInt(second1 / 3600) <= 0) {
          //最小0
          this.list.percentage = 0;
        } else {
          //拼接总进度长度
          this.list.percentage = parseInt(second1 / 3600) + "0";
        }
        //判断进度总长是否超过600
        if (this.list.percentage > 600) {
          //总进度超过600减半
          for (var j = 0; j < this.list.orderList.length; j++) {
            //每个进度减半
            this.list.orderList[j].top = this.list.orderList[j].top / 2;
          }
          //总长度减半
          this.list.percentage = this.list.percentage / 2;
        }
        //记录总加了多少长度
        var nuber = 0;
        //判断每个进度之间不能少于70px,少于70px,赋值给最低70
        for (var j = 0; j < this.list.orderList.length; j++) {
          //开始第一个阶段不用高度
          if (j == 0) {} else {
            //判断高度是否大于70
            if (this.list.orderList[j].top < 70) {
              // //小于70记录与70之间的差
              // nuber = 70 - this.list.orderList[j].top + nuber;
              //给本阶段赋值最少进度70
              this.list.orderList[j].top = 70;
              //本阶段加了长度，后面都得加上等长，循环加
              for (var s = j; s < this.list.orderList.length; s++) {
                //每个阶段循环增加
                this.list.orderList[s].top = this.list.orderList[s - 1].top + 70;
              }
              //总长度加每个进度之间的补差
              this.list.percentage = this.list.orderList[this.list.orderList.length - 1].top;
            }
          }
        }
      }, function (err) {
        console.log(err);
      });
    },

    // 获取字典
    getDictionaries: function getDictionaries() {
      this.$http.get(global.host + "repairMgr/findDictList?domain=REPAIR_SCOPE_LABEL").then(function (res) {
        if (res.body.statusCode == 200) {
          this.Dictionaries = res.body.result;

          console.log(this.Dictionaries);
        }
      }, function (err) {
        console.log(err);
      });
    },

    // 点击保存字典值 切换颜色
    getSazd: function getSazd(item, e) {
      if (e.target.classList.contains("dictionaryColor")) {
        e.target.classList.remove("dictionaryColor");
        this.removeByValue(this.Dictionaries_list, item);
      } else {
        this.Dictionaries_list.push(item);
        e.target.classList.add("dictionaryColor");
      }
    },

    // 提交评价
    payment: function payment() {
      this.Dictionaries_list = this.Dictionaries_list.join(",");
      console.log(this.Dictionaries_list);
      var submitScore = {};
      submitScore.repairId = this.$router.history.current.query.repairId;
      submitScore.handleScode = String(this.valueone);
      submitScore.serviceScode = String(this.valuetwo);
      submitScore.scodeDesc = this.Dictionaries_list;
      this.$http.post(global.host + "repair/submitScore", submitScore).then(function (res) {
        console.log(res);
        if (res.body.statusCode == 200) {
          this.getAllListUser();
          this.getUser();
          this.evaluate = false;
        }
      }, function (err) {
        console.log(err);
      });
      console.log(submitScore);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2400166","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repairComponents/repairsOne.vue
var repairsOne_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"warper"}},[(this.loging == true)?_c('div',{staticStyle:{"position":"fixed","top":"50%","left":"50%","width":"100px","height":"100px","background-color":"rgb(121, 121, 122)","transform":"translate3d(-50%,-50%,0)","border-radius":"10%"}},[_c('van-loading',{staticStyle:{"position":"absolute","top":"50%","left":"50%","transform":"translate3d(-50%,-50%,0)"},attrs:{"type":"spinner","color":"white"}})],1):_vm._e(),_vm._v(" "),(this.loging == false)?_c('div',[_c('div',{staticClass:"division"}),_vm._v(" "),(this.handleMan != null)?_c('div',{staticClass:"details-show"},[_c('div',{staticClass:"details-show-on"},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('div',{staticStyle:{"width":"100%","margin-top":"15px"}},[_c('div',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v(_vm._s(_vm.userList.userName))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"text-align":"left","color":"#7b7b7b"}},[_vm._v("工号："+_vm._s(_vm.userList.userNo))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"text-align":"left","color":"#7b7b7b"}},[_vm._v("评分"+_vm._s(_vm.userList.avgNum)+".0 单数："+_vm._s(_vm.userList.countNum)+"单")])])])]),_vm._v(" "),_c('div',{staticClass:"division"}),_vm._v(" "),_c('div',{staticClass:"details-show-score"},[_c('div',{staticClass:"details-show-score-on"},[_vm._v("总评分")]),_vm._v(" "),_c('div',{staticClass:"details-show-score-te"},[_c('van-rate',{attrs:{"readonly":true,"size":26,"count":5,"color":"#ffca00","void-color":"#ceefe8"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)]),_vm._v(" "),_c('div',{staticClass:"division"})]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"5px","margin-left":"130px","margin-top":"35px","position":"relative","background-color":"#57ccb6"},style:({ height: _vm.list.percentage + 'px' })},[_c('div',{staticStyle:{"margin-left":"-21px"}},_vm._l((_vm.list.orderList),function(item){return _c('div',{key:item.id},[_c('div',{staticClass:"divspanleft",style:({ top: item.top + 'px' })},[_vm._v(_vm._s(item.dataTime))]),_vm._v(" "),_c('span',{staticClass:"span0",style:({ top: item.top + 'px' })},[_c('img',{staticStyle:{"width":"15px","height":"15px","margin-left":"1em","margin-top":"-0.5em","position":"absolute"},attrs:{"src":__webpack_require__("Mxs7"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"divspanright",style:({ top: item.top + 'px'})},[_c('div',{staticClass:"divspanrightone"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"divspanrightywo"},[_vm._v(_vm._s(item.context))])])])}))])]):_vm._e(),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom","close-on-click-overlay":false,"overlay":true},model:{value:(_vm.evaluate),callback:function ($$v) {_vm.evaluate=$$v},expression:"evaluate"}},[_c('div',{staticClass:"evaluate-popu-show",attrs:{"id":"payment"}},[_c('div',{staticClass:"evaluate-popu-show-on"},[_c('div',{staticClass:"evaluate-popu-cancel",on:{"click":function($event){_vm.del()}}},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"evaluate-popu-fill"},[_vm._v("评价")]),_vm._v(" "),_c('div',{staticClass:"evaluate-popu-show-submit",on:{"click":function($event){_vm.payment()}}},[_vm._v("提交")])]),_vm._v(" "),_c('div',{staticClass:"evaluate-popu-show-efficiency"},[_c('div',{staticClass:"evaluate-popu-show-efficiency-on"},[_c('div',{staticClass:"evaluate-popu-show-efficiency-on-s"},[_vm._v("维修效率")]),_vm._v(" "),_c('div',{staticClass:"evaluate-show-server"},[_c('van-rate',{attrs:{"size":24,"count":5,"color":"#ffca00","void-color":"#ceefe8"},model:{value:(_vm.valueone),callback:function ($$v) {_vm.valueone=$$v},expression:"valueone"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","height":"50px"}},[_c('div',{staticStyle:{"width":"27%","padding-top":"10px","text-align":"right"}},[_vm._v("服务态度")]),_vm._v(" "),_c('div',{staticClass:"evaluate-show-server"},[_c('van-rate',{attrs:{"size":24,"count":5,"color":"#ffca00","void-color":"#ceefe8"},model:{value:(_vm.valuetwo),callback:function ($$v) {_vm.valuetwo=$$v},expression:"valuetwo"}})],1)])]),_vm._v(" "),_c('div',{staticStyle:{"height":"50px","width":"100%","display":"block !important","font-size":"15px !important"}},_vm._l((_vm.Dictionaries),function(item){return _c('div',{staticStyle:{"width":"25%","height":"30px","line-height":"30px","border":"1px solid #e4e4e4","margin-left":"6%","margin-top":"10px","text-align":"center","display":"inline-block"},on:{"click":function($event){_vm.getSazd(item,$event)}}},[_vm._v(_vm._s(item))])}))])])],1)}
var repairsOne_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details-show-on-with"},[_c('img',{staticClass:"details-show-img",attrs:{"src":__webpack_require__("w5cD"),"alt":""}})])}]
var repairsOne_esExports = { render: repairsOne_render, staticRenderFns: repairsOne_staticRenderFns }
/* harmony default export */ var components_repairComponents_repairsOne = (repairsOne_esExports);
// CONCATENATED MODULE: ./src/components/repairComponents/repairsOne.vue
function repairsOne_injectStyle (ssrContext) {
  __webpack_require__("GwFB")
}
var repairsOne_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var repairsOne___vue_template_functional__ = false
/* styles */
var repairsOne___vue_styles__ = repairsOne_injectStyle
/* scopeId */
var repairsOne___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var repairsOne___vue_module_identifier__ = null
var repairsOne_Component = repairsOne_normalizeComponent(
  repairComponents_repairsOne,
  components_repairComponents_repairsOne,
  repairsOne___vue_template_functional__,
  repairsOne___vue_styles__,
  repairsOne___vue_scopeId__,
  repairsOne___vue_module_identifier__
)

/* harmony default export */ var src_components_repairComponents_repairsOne = (repairsOne_Component.exports);

// EXTERNAL MODULE: ./node_modules/vant/lib/switch/style/index.js
var switch_style = __webpack_require__("eNeO");
var switch_style_default = /*#__PURE__*/__webpack_require__.n(switch_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/switch/index.js
var lib_switch = __webpack_require__("VcVR");
var switch_default = /*#__PURE__*/__webpack_require__.n(lib_switch);

// EXTERNAL MODULE: ./node_modules/vant/lib/tabs/style/index.js
var tabs_style = __webpack_require__("CCOf");
var tabs_style_default = /*#__PURE__*/__webpack_require__.n(tabs_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/tabs/index.js
var tabs = __webpack_require__("rrcz");
var tabs_default = /*#__PURE__*/__webpack_require__.n(tabs);

// EXTERNAL MODULE: ./node_modules/vant/lib/tab/style/index.js
var tab_style = __webpack_require__("3evy");
var tab_style_default = /*#__PURE__*/__webpack_require__.n(tab_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/tab/index.js
var lib_tab = __webpack_require__("Irlo");
var tab_default = /*#__PURE__*/__webpack_require__.n(lib_tab);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/repairsTwo.vue










 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Header from './owner_submint_head';

var repairsTwo__components;

/* harmony default export */ var repairsTwo = ({
  components: (repairsTwo__components = {}, defineProperty_default()(repairsTwo__components, popup_default.a.name, popup_default.a), defineProperty_default()(repairsTwo__components, rate_default.a.name, rate_default.a), defineProperty_default()(repairsTwo__components, tab_default.a.name, tab_default.a), defineProperty_default()(repairsTwo__components, tabs_default.a.name, tabs_default.a), defineProperty_default()(repairsTwo__components, switch_default.a.name, switch_default.a), repairsTwo__components), data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick(index, title) {}
  }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/repairsTwo.vue










 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Header from './owner_submint_head';

var repairComponents_repairsTwo__components;

/* harmony default export */ var repairComponents_repairsTwo = ({
  components: (repairComponents_repairsTwo__components = {}, defineProperty_default()(repairComponents_repairsTwo__components, popup_default.a.name, popup_default.a), defineProperty_default()(repairComponents_repairsTwo__components, rate_default.a.name, rate_default.a), defineProperty_default()(repairComponents_repairsTwo__components, tab_default.a.name, tab_default.a), defineProperty_default()(repairComponents_repairsTwo__components, tabs_default.a.name, tabs_default.a), defineProperty_default()(repairComponents_repairsTwo__components, switch_default.a.name, switch_default.a), repairComponents_repairsTwo__components), data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick(index, title) {}
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c0e40ab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repairComponents/repairsTwo.vue
var repairsTwo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"warper"}},[_c('div',{staticClass:"division"}),_vm._v(" "),_c('div',{staticClass:"informationDetails"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"division"}),_vm._v(" "),_c('van-tabs',{attrs:{"swipeable":"true","title-active-color":"rgba(20, 210, 184, 1)","color":"rgba(20, 210, 184, 1)"},on:{"click":_vm.onClick}},[_c('van-tab',{attrs:{"title":"室内"}},[_c('div',{staticClass:"evaluate-header"},[_c('div',{staticClass:"evaluate-header-on"},[_c('div',{staticClass:"evaluate"},[_vm._v("弱电")]),_vm._v(" "),_c('div',{staticClass:"evaluate"},[_vm._v("管道")]),_vm._v(" "),_c('div',{staticClass:"evaluate"},[_vm._v("暖气")]),_vm._v(" "),_c('div',{staticClass:"evaluate"},[_vm._v("门")])]),_vm._v(" "),_c('div',{staticClass:"evaluate-header-on"},[_c('div',{staticClass:"evaluate"},[_vm._v("窗")]),_vm._v(" "),_c('div',{staticClass:"evaluate"},[_vm._v("天然气")]),_vm._v(" "),_c('div',{staticClass:"evaluate"},[_vm._v("消防")]),_vm._v(" "),_c('div',{staticClass:"evaluate"},[_vm._v("其他")])])])]),_vm._v(" "),_c('van-tab',{attrs:{"title":"公共区域"}},[_c('div',{staticClass:"evaluate-header"},[_c('div',{staticClass:"evaluate-header-on"},[_c('div',{staticClass:"evaluate"},[_vm._v("弱电1")]),_vm._v(" "),_c('div',{staticClass:"evaluate"},[_vm._v("管道1")]),_vm._v(" "),_c('div',{staticClass:"evaluate"},[_vm._v("暖气1")]),_vm._v(" "),_c('div',{staticClass:"evaluate"},[_vm._v("门1")])]),_vm._v(" "),_c('div',{staticClass:"evaluate-header-on"},[_c('div',{staticClass:"evaluate"},[_vm._v("窗1")]),_vm._v(" "),_c('div',{staticClass:"evaluate"},[_vm._v("天然气1")]),_vm._v(" "),_c('div',{staticClass:"evaluate"},[_vm._v("消防1")]),_vm._v(" "),_c('div',{staticClass:"evaluate"},[_vm._v("其他1")])])])])],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticStyle:{"height":"10px","width":"100%","background-color":"#f5f5f5","margin-top":"10px"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticStyle:{"height":"2px","width":"100%","background-color":"#f5f5f5","margin-top":"10px"}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)],1)])}
var repairsTwo_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"informationDetails-on"},[_c('div',{staticClass:"informationDetails-tw"},[_c('img',{staticClass:"informationDetails-img",attrs:{"src":__webpack_require__("w5cD"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"informationDetails-tonxt"},[_c('div',{staticClass:"informationDetails-on-with"},[_c('div',{staticClass:"informationDetails-on-context"},[_vm._v("\n              俺是萌芽熊\n            ")])]),_vm._v(" "),_c('div',{staticClass:"informationDetails-on-with"},[_c('div',{staticClass:"informationDetails-on-text"},[_vm._v("\n              启迪国际-伊桔F01-4B\n            ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-margin"},[_c('div',{staticClass:"div-portrait"},[_c('div',{staticClass:"fill-contect"},[_c('img',{staticClass:"fill-contect-img",attrs:{"src":__webpack_require__("5POz")}})]),_vm._v(" "),_c('div',{staticClass:"fill-contect-on-s"},[_vm._v("报修内容")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"cs-fill-contect"},[_c('textarea',{attrs:{"placeholder":"请填写报修说明"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-margin"},[_c('div',{staticClass:"div-portrait"},[_c('div',{staticClass:"fill-contect"},[_c('img',{staticClass:"fill-contect-img",attrs:{"src":__webpack_require__("Y8g4")}})]),_vm._v(" "),_c('div',{staticClass:"fill-contect-on-s"},[_vm._v("照片上传")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"cs-fill-contect"},[_c('img',{staticClass:"cs-fill-contect-img",attrs:{"src":__webpack_require__("9FLu"),"alt":""}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-door-to-door"},[_c('div',{staticClass:"service-door-to-door-on"},[_vm._v("服务上门时间")]),_vm._v(" "),_c('div',{staticClass:"service-door-to-door-to"},[_vm._v("\n        2019-03-01 09:00-12:00  >\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subment-on"},[_c('div',{staticClass:"subment-on-content"},[_vm._v("\n        提交维修\n      ")])])}]
var repairsTwo_esExports = { render: repairsTwo_render, staticRenderFns: repairsTwo_staticRenderFns }
/* harmony default export */ var components_repairComponents_repairsTwo = (repairsTwo_esExports);
// CONCATENATED MODULE: ./src/components/repairComponents/repairsTwo.vue
function repairsTwo_injectStyle (ssrContext) {
  __webpack_require__("Lc37")
}
var repairsTwo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var repairsTwo___vue_template_functional__ = false
/* styles */
var repairsTwo___vue_styles__ = repairsTwo_injectStyle
/* scopeId */
var repairsTwo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var repairsTwo___vue_module_identifier__ = null
var repairsTwo_Component = repairsTwo_normalizeComponent(
  repairComponents_repairsTwo,
  components_repairComponents_repairsTwo,
  repairsTwo___vue_template_functional__,
  repairsTwo___vue_styles__,
  repairsTwo___vue_scopeId__,
  repairsTwo___vue_module_identifier__
)

/* harmony default export */ var src_components_repairComponents_repairsTwo = (repairsTwo_Component.exports);

// EXTERNAL MODULE: ./node_modules/vant/lib/image-preview/style/index.js
var image_preview_style = __webpack_require__("i9vB");
var image_preview_style_default = /*#__PURE__*/__webpack_require__.n(image_preview_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/image-preview/index.js
var image_preview = __webpack_require__("Mqtp");
var image_preview_default = /*#__PURE__*/__webpack_require__.n(image_preview);

// EXTERNAL MODULE: ./node_modules/vant/lib/notify/style/index.js
var notify_style = __webpack_require__("4T1P");
var notify_style_default = /*#__PURE__*/__webpack_require__.n(notify_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/notify/index.js
var notify = __webpack_require__("gJVR");
var notify_default = /*#__PURE__*/__webpack_require__.n(notify);

// EXTERNAL MODULE: ./node_modules/vant/lib/dialog/style/index.js
var dialog_style = __webpack_require__("MHRi");
var dialog_style_default = /*#__PURE__*/__webpack_require__.n(dialog_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/dialog/index.js
var dialog = __webpack_require__("6xqC");
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog);

// EXTERNAL MODULE: ./node_modules/vant/lib/checkbox-group/style/index.js
var checkbox_group_style = __webpack_require__("OeKT");
var checkbox_group_style_default = /*#__PURE__*/__webpack_require__.n(checkbox_group_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/checkbox-group/index.js
var checkbox_group = __webpack_require__("aysW");
var checkbox_group_default = /*#__PURE__*/__webpack_require__.n(checkbox_group);

// EXTERNAL MODULE: ./node_modules/vant/lib/checkbox/style/index.js
var checkbox_style = __webpack_require__("d9cu");
var checkbox_style_default = /*#__PURE__*/__webpack_require__.n(checkbox_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/checkbox/index.js
var lib_checkbox = __webpack_require__("vkhW");
var checkbox_default = /*#__PURE__*/__webpack_require__.n(lib_checkbox);

// EXTERNAL MODULE: ./node_modules/vant/lib/radio-group/style/index.js
var radio_group_style = __webpack_require__("OMF1");
var radio_group_style_default = /*#__PURE__*/__webpack_require__.n(radio_group_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/radio-group/index.js
var radio_group = __webpack_require__("Maz4");
var radio_group_default = /*#__PURE__*/__webpack_require__.n(radio_group);

// EXTERNAL MODULE: ./node_modules/vant/lib/radio/style/index.js
var radio_style = __webpack_require__("dlG5");
var radio_style_default = /*#__PURE__*/__webpack_require__.n(radio_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/radio/index.js
var lib_radio = __webpack_require__("MpXg");
var radio_default = /*#__PURE__*/__webpack_require__.n(lib_radio);

// EXTERNAL MODULE: ./node_modules/vant/lib/uploader/style/index.js
var uploader_style = __webpack_require__("dL9u");
var uploader_style_default = /*#__PURE__*/__webpack_require__.n(uploader_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/uploader/index.js
var uploader = __webpack_require__("L00R");
var uploader_default = /*#__PURE__*/__webpack_require__.n(uploader);

// EXTERNAL MODULE: ./node_modules/timers-browserify/main.js
var main = __webpack_require__("162o");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/repairsThr.vue






















 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//局部注册组件
// import Header from './repair_details_head'

var repairsThr__components;



/* harmony default export */ var repairsThr = ({
    components: (repairsThr__components = {}, defineProperty_default()(repairsThr__components, uploader_default.a.name, uploader_default.a), defineProperty_default()(repairsThr__components, radio_default.a.name, radio_default.a), defineProperty_default()(repairsThr__components, radio_group_default.a.name, radio_group_default.a), defineProperty_default()(repairsThr__components, checkbox_default.a.name, checkbox_default.a), defineProperty_default()(repairsThr__components, checkbox_group_default.a.name, checkbox_group_default.a), defineProperty_default()(repairsThr__components, popup_default.a.name, popup_default.a), defineProperty_default()(repairsThr__components, dialog_default.a.name, dialog_default.a), defineProperty_default()(repairsThr__components, loading_default.a.name, loading_default.a), defineProperty_default()(repairsThr__components, rate_default.a.name, rate_default.a), defineProperty_default()(repairsThr__components, notify_default.a.name, notify_default.a), defineProperty_default()(repairsThr__components, image_preview_default.a.name, image_preview_default.a), repairsThr__components),
    data: function data() {
        return {
            pingj: false, // 未评价是false 评价了是true
            evaluate: false,
            jind: false, // 未接单
            jind2: false, // 接单
            worker: false, //为false维修工未接单 true维修工接单
            valueone: '5',
            valuetwo: '4',
            value: '',
            Dictionaries: [], // 评分标签
            Dictionaries_list: [], // 用户选择的评价标签
            percentage: 60,
            userList: {}, // 派单信息数据集
            //    新增进度条 未派单的情况下
            list: {
                percentage: 0,
                orderList: []
            },
            //   orderProgress:{
            //             percentage: 0,  //订单当前总进度0-100  0==开始  100==完成
            //             //进度阶段List
            //             orderList:[]
            //     },
            loging: true, // 是否显示加载
            //数据集
            orderDetails: {},
            images: [], // 如果有图片 这个就是存图片id的数组
            imgageBase: [], // 存放图片、
            repairState: '', // 0:待受理；1:处理中；2：已完成待回访3：已回访待评价 4：已评价
            handleMan: '', // 维修人 下一步发请求需要传的参数
            handleId: '',
            repairType: [],
            scroll: false
        };
    },

    watch: {
        scroll: function scroll() {
            this.$nextTick(function () {
                var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                //  alert('赋值前------'+scrollTop)
                // let boxHeight = document.documentElement.scrollHeight || document.body.scrollHeight 
                //  if(scrollTop != document.body.scrollHeight){
                //      scrollTop = document.body.scrollHeight;
                //      document.documentElement.scrollTop = scrollTop; document.getElementById('home').scrollHeight
                //  }
                scrollTop = document.getElementById('warper').scrollHeight;
                document.documentElement.scrollTop = scrollTop;
                //  alert('赋值后------'+scrollTop)
                console.log(document.body.scrollHeight);
            });
        }
    },
    mounted: function mounted() {
        this.getAllList();
        this.getAllListUser();
        this.getDictionaries();
    },

    methods: {
        clkImg: function clkImg() {
            image_preview_default()(this.imgageBase);
        },

        // 删除指定元素公共方法
        removeByValue: function removeByValue(arr, val) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] == val) {
                    arr.splice(i, 1);
                    break;
                }
            }
        },

        // 获取字典
        getDictionaries: function getDictionaries() {
            this.$http.get(global.host + "repairMgr/findDictList?domain=REPAIR_SCOPE_LABEL").then(function (res) {
                if (res.body.statusCode == 200) {
                    this.Dictionaries = res.body.result;
                    console.log(this.Dictionaries);
                }
            }, function (err) {
                console.log(err);
            });
        },

        // 点击保存字典值 切换颜色
        getSazd: function getSazd(item, e) {
            console.log(item);
            console.log(e.target.classList);
            if (e.target.classList.contains('dictionaryColor')) {
                e.target.classList.remove('dictionaryColor');
                this.removeByValue(this.Dictionaries_list, item);
            } else {
                this.Dictionaries_list.push(item);
                e.target.classList.add('dictionaryColor');
            }
        },

        // 控制大盒子的margin
        marWoeker: function marWoeker() {
            if (this.worker == true) {
                //  如果维修工人接单了 大盒子的margin为100
                this.$refs.ulBox.style.margin = '0 0 100px 0';
            }
        },

        //点击展示评分项
        giveMark: function giveMark() {
            if (this.repairState == 2 || this.repairState == 3) {
                this.evaluate = true;
                //   alert('评价')
            } else {
                notify_default()({
                    message: '该订单无法评价',
                    duration: 2000,
                    background: '#1989fa'
                });
            }
        },

        // 点评价取消
        del: function del() {
            this.evaluate = false;
        },

        // 提交评价
        payment: function payment() {
            if (this.pingj == false) {
                this.Dictionaries_list = this.Dictionaries_list.join(',');
                console.log(this.Dictionaries_list);
                var _submitScore = {};
                _submitScore.repairId = this.$router.history.current.query.repairId;
                _submitScore.handleScode = String(this.valueone);
                _submitScore.serviceScode = String(this.valuetwo);
                _submitScore.scodeDesc = this.Dictionaries_list;
                this.$http.post(global.host + 'repair/submitScore', _submitScore).then(function (res) {
                    console.log(res);
                    if (res.body.statusCode == 200) {
                        this.getAllListUser();
                        this.getUser();
                        this.evaluate = false;
                        this.pingj = true;
                    }
                }, function (err) {
                    console.log(err);
                });
            } else {
                notify_default()({
                    message: '请勿重复评价',
                    duration: 2000,
                    background: '#1989fa'
                });
            }

            console.log(submitScore);
        },

        // 获取基本信息
        getUser: function getUser() {
            var userall = {};
            userall.handleMan = this.handleId;
            console.log('基本信息基本信息' + this.handleId);
            this.$http.post(global.host + '/repair/findOrderQuantity', userall).then(function (res) {
                console.log('基本信息基本信息基本信息基本信息基本信息基本信息基本信息基本信息');
                console.log(res);
                this.userList = res.body.result;
                this.value = res.body.result.avgNum;
            }, function (err) {
                console.log(err);
            });
        },

        // 获取展示数据集
        getAllList: function getAllList() {
            this.$http.get(global.host + "repair/findRepairDetail?repairId=" + this.$router.history.current.query.repairId).then(function (res) {
                console.log('详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据');
                console.log(res);
                if (res.body.statusCode == 200) {
                    this.orderDetails = res.body.result;
                    this.repairType = this.orderDetails.repairType.split(',');
                    console.log('8888888888888888888888888888888888888888888');
                    console.log(this.repairType);
                    this.repairState = res.body.result.repairState;
                    this.handleMan = res.body.result.handleMan; //如果pc未派单 这个值为null 用户进来不显示头部 不为null才显示
                    if (this.handleMan == null) {
                        this.worker = false;
                    } else {
                        this.worker = true;
                    }

                    console.log('之后的this.worker-----------' + this.worker);
                    console.log(this.worker);
                    this.handleId = res.body.result.handleId;
                    console.log('刚赋值的this.handleId ------------------------' + this.handleId);
                    console.log(this.handleId);
                    this.getUser();
                    this.marWoeker();
                    console.log(this.handleMan);
                    if (this.orderDetails.images.length != 0) {
                        this.images = this.orderDetails.images;
                        // 发送请求获取图片
                        for (var i = 0; i < this.images.length; i++) {
                            this.getImages(this.images[i]);
                        }
                    } else {
                        this.loging = false;
                    }
                }
            }, function (err) {
                console.log(err);
            });
        },

        // 获取图片的ajax
        getImages: function getImages(imgId) {
            this.$http.get(global.host + "repairMgr/findPictureByPicId?pictureId=" + imgId).then(function (res) {
                this.imgageBase.push(res.url);
                this.loging = false;
            }, function (err) {
                console.log(err);
            });
        },

        // 如果未接单 逻辑
        // 如果未接单 箭头向上事件 点击填充数据
        swipeup: function swipeup() {
            console.log("箭头向上事件");
            this.jind = true;
            console.log(this.worker);
            console.log(this.jind);
            if (this.jind == true) {
                this.$refs.warperRef.style.margin = '0 0 150px 0';
                this.scroll = true;
            } else {
                this.$refs.warperRef.style.margin = '0 0 0 0';
            }
        },

        // 如果接单
        swipeupWorker: function swipeupWorker() {
            //  alert('接单上拉事件')
            this.jind2 = true;
            this.$refs.ulBox.style.margin = '0 0 450px 0';
        },
        downWorken: function downWorken() {
            this.jind2 = false;
            this.$refs.ulBox.style.margin = '0 0 100px 0';
        },


        // 获取进度条数据
        // 时间戳转换兼容判断机型
        formatDate: function formatDate(date, type) {
            if (date != undefined) {
                var add0 = function add0(m) {
                    return m < 10 ? '0' + m : m;
                };

                //兼容ios
                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) || navigator.userAgent.indexOf("Safari") > -1) {
                    date = String(date).replace(/\-/g, "/");
                }
                var time = '';
                if (date.indexOf('-') != -1 || date.indexOf('/') != -1) {
                    time = new Date(date);
                } else {
                    time = new Date(JSON.parse(date));
                }
                var year = time.getFullYear();
                var month = time.getMonth() + 1;
                var date = time.getDate();
                var hours = time.getHours();
                var minutes = time.getMinutes();
                var seconds = time.getSeconds();
                var isTime = '';

                switch (type) {
                    case 'Y-M-D hh:mm:ss':
                        isTime = year + '-' + add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
                        break;
                    case 'M-D hh:mm:ss':
                        isTime = add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
                        break;
                    case 'M-D hh:mm':
                        isTime = add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes);
                        break;
                    case 'hh:mm:ss':
                        isTime = add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
                        break;
                    case 'hh:mm':
                        isTime = add0(hours) + ':' + add0(minutes);
                        break;
                }
                return isTime;
            }
        },

        // 兼容时间格式
        getTs: function getTs(time) {
            var arr = time.split(/[- :]/),
                _date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]),
                timeStr = Date.parse(_date);
            return timeStr;
        },

        // 获取进度展示展示数据集
        getAllListUser: function getAllListUser() {
            this.list.orderList = [];
            this.$http.get(global.host + "repair/findHandleRecord?repairId=" + this.$router.history.current.query.repairId).then(function (response) {
                // alert('进度数据')
                // alert(JSON.stringify(response));
                // demo
                this.loging = false;
                for (var i = 0; i < response.body.result.length; i++) {
                    var data = {
                        id: i, //当前阶段id
                        title: response.body.result[i].handleStatus, //当前阶段订单标题
                        context: response.body.result[i].handleDesc, //当前阶段订单内容
                        dataTime: response.body.result[i].handleDate //当前阶段订单结束时间
                    };
                    this.list.orderList.push(data);
                }
                for (var i = 0; i < this.list.orderList.length; i++) {
                    //每次进度之后时间戳
                    var timestamp2 = this.formatDate(this.list.orderList[i].dataTime, 'Y-M-D hh:mm:ss');
                    //开始时间戳
                    var timestamp1 = this.formatDate(this.list.orderList[0].dataTime, 'Y-M-D hh:mm:ss');
                    //之后时间戳减开始
                    var num = this.getTs(timestamp1) - this.getTs(timestamp2);
                    //获取到总共时间
                    var second = num / 1000;
                    //判断当前度是否大于等于0
                    if (parseInt(second / 3600) <= 0) {
                        //最小0
                        this.list.orderList[i].top = 0;
                    } else {
                        //长度拼接
                        this.list.orderList[i].top = parseInt(second / 3600) + "0";
                    }
                }
                //计算当前进度的总长度
                //获取最后时间戳
                var timestamp4 = this.formatDate(this.list.orderList[this.list.orderList.length - 1].dataTime, 'Y-M-D hh:mm:ss');
                //获取开始时间戳
                var timestamp3 = this.formatDate(this.list.orderList[0].dataTime, 'Y-M-D hh:mm:ss');
                //计算时间戳之差
                var num1 = this.getTs(timestamp3) - this.getTs(timestamp4);
                //获取到总时长
                var second1 = num1 / 1000;
                //判断总长度是否大于等于0
                if (parseInt(second1 / 3600) <= 0) {
                    //最小0
                    this.list.percentage = 0;
                } else {
                    //拼接总进度长度
                    this.list.percentage = parseInt(second1 / 3600) + "0";
                }
                //判断进度总长是否超过600
                if (this.list.percentage > 600) {
                    //总进度超过600减半
                    for (var j = 0; j < this.list.orderList.length; j++) {
                        //每个进度减半
                        this.list.orderList[j].top = this.list.orderList[j].top / 2;
                    }
                    //总长度减半
                    this.list.percentage = this.list.percentage / 2;
                }
                //记录总加了多少长度
                var nuber = 0;
                //判断每个进度之间不能少于70px,少于70px,赋值给最低70
                for (var j = 0; j < this.list.orderList.length; j++) {
                    //开始第一个阶段不用高度
                    if (j == 0) {} else {
                        //判断高度是否大于70
                        if (this.list.orderList[j].top < 70) {
                            // //小于70记录与70之间的差
                            // nuber = 70 - this.list.orderList[j].top + nuber;
                            //给本阶段赋值最少进度70
                            this.list.orderList[j].top = 70;
                            //本阶段加了长度，后面都得加上等长，循环加
                            for (var s = j; s < this.list.orderList.length; s++) {
                                //每个阶段循环增加
                                this.list.orderList[s].top = this.list.orderList[s - 1].top + 70;
                            }
                            //总长度加每个进度之间的补差
                            this.list.percentage = this.list.orderList[this.list.orderList.length - 1].top;
                        }
                    }
                }
            }, function (err) {
                console.log(err);
            });
        },


        // 跳转到评价页
        selectSpeed: function selectSpeed() {
            this.$router.push({
                path: "/repairsOne",
                query: {
                    repairId: this.$router.history.current.query.repairId,
                    repairState: this.repairState,
                    handleMan: this.handleMan,
                    handleId: this.handleId
                }
            });
        }
    }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairComponents/repairsThr.vue






















 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//局部注册组件
// import Header from './repair_details_head'

var repairComponents_repairsThr__components;



/* harmony default export */ var repairComponents_repairsThr = ({
    components: (repairComponents_repairsThr__components = {}, defineProperty_default()(repairComponents_repairsThr__components, uploader_default.a.name, uploader_default.a), defineProperty_default()(repairComponents_repairsThr__components, radio_default.a.name, radio_default.a), defineProperty_default()(repairComponents_repairsThr__components, radio_group_default.a.name, radio_group_default.a), defineProperty_default()(repairComponents_repairsThr__components, checkbox_default.a.name, checkbox_default.a), defineProperty_default()(repairComponents_repairsThr__components, checkbox_group_default.a.name, checkbox_group_default.a), defineProperty_default()(repairComponents_repairsThr__components, popup_default.a.name, popup_default.a), defineProperty_default()(repairComponents_repairsThr__components, dialog_default.a.name, dialog_default.a), defineProperty_default()(repairComponents_repairsThr__components, loading_default.a.name, loading_default.a), defineProperty_default()(repairComponents_repairsThr__components, rate_default.a.name, rate_default.a), defineProperty_default()(repairComponents_repairsThr__components, notify_default.a.name, notify_default.a), defineProperty_default()(repairComponents_repairsThr__components, image_preview_default.a.name, image_preview_default.a), repairComponents_repairsThr__components),
    data: function data() {
        return {
            pingj: false, // 未评价是false 评价了是true
            evaluate: false,
            jind: false, // 未接单
            jind2: false, // 接单
            worker: false, //为false维修工未接单 true维修工接单
            valueone: '5',
            valuetwo: '4',
            value: '',
            Dictionaries: [], // 评分标签
            Dictionaries_list: [], // 用户选择的评价标签
            percentage: 60,
            userList: {}, // 派单信息数据集
            //    新增进度条 未派单的情况下
            list: {
                percentage: 0,
                orderList: []
            },
            //   orderProgress:{
            //             percentage: 0,  //订单当前总进度0-100  0==开始  100==完成
            //             //进度阶段List
            //             orderList:[]
            //     },
            loging: true, // 是否显示加载
            //数据集
            orderDetails: {},
            images: [], // 如果有图片 这个就是存图片id的数组
            imgageBase: [], // 存放图片、
            repairState: '', // 0:待受理；1:处理中；2：已完成待回访3：已回访待评价 4：已评价
            handleMan: '', // 维修人 下一步发请求需要传的参数
            handleId: '',
            repairType: [],
            scroll: false
        };
    },

    watch: {
        scroll: function scroll() {
            this.$nextTick(function () {
                var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                //  alert('赋值前------'+scrollTop)
                // let boxHeight = document.documentElement.scrollHeight || document.body.scrollHeight 
                //  if(scrollTop != document.body.scrollHeight){
                //      scrollTop = document.body.scrollHeight;
                //      document.documentElement.scrollTop = scrollTop; document.getElementById('home').scrollHeight
                //  }
                scrollTop = document.getElementById('warper').scrollHeight;
                document.documentElement.scrollTop = scrollTop;
                //  alert('赋值后------'+scrollTop)
                console.log(document.body.scrollHeight);
            });
        }
    },
    mounted: function mounted() {
        this.getAllList();
        this.getAllListUser();
        this.getDictionaries();
    },

    methods: {
        clkImg: function clkImg() {
            image_preview_default()(this.imgageBase);
        },

        // 删除指定元素公共方法
        removeByValue: function removeByValue(arr, val) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] == val) {
                    arr.splice(i, 1);
                    break;
                }
            }
        },

        // 获取字典
        getDictionaries: function getDictionaries() {
            this.$http.get(global.host + "repairMgr/findDictList?domain=REPAIR_SCOPE_LABEL").then(function (res) {
                if (res.body.statusCode == 200) {
                    this.Dictionaries = res.body.result;
                    console.log(this.Dictionaries);
                }
            }, function (err) {
                console.log(err);
            });
        },

        // 点击保存字典值 切换颜色
        getSazd: function getSazd(item, e) {
            console.log(item);
            console.log(e.target.classList);
            if (e.target.classList.contains('dictionaryColor')) {
                e.target.classList.remove('dictionaryColor');
                this.removeByValue(this.Dictionaries_list, item);
            } else {
                this.Dictionaries_list.push(item);
                e.target.classList.add('dictionaryColor');
            }
        },

        // 控制大盒子的margin
        marWoeker: function marWoeker() {
            if (this.worker == true) {
                //  如果维修工人接单了 大盒子的margin为100
                this.$refs.ulBox.style.margin = '0 0 100px 0';
            }
        },

        //点击展示评分项
        giveMark: function giveMark() {
            if (this.repairState == 2 || this.repairState == 3) {
                this.evaluate = true;
                //   alert('评价')
            } else {
                notify_default()({
                    message: '该订单无法评价',
                    duration: 2000,
                    background: '#1989fa'
                });
            }
        },

        // 点评价取消
        del: function del() {
            this.evaluate = false;
        },

        // 提交评价
        payment: function payment() {
            if (this.pingj == false) {
                this.Dictionaries_list = this.Dictionaries_list.join(',');
                console.log(this.Dictionaries_list);
                var _submitScore = {};
                _submitScore.repairId = this.$router.history.current.query.repairId;
                _submitScore.handleScode = String(this.valueone);
                _submitScore.serviceScode = String(this.valuetwo);
                _submitScore.scodeDesc = this.Dictionaries_list;
                this.$http.post(global.host + 'repair/submitScore', _submitScore).then(function (res) {
                    console.log(res);
                    if (res.body.statusCode == 200) {
                        this.getAllListUser();
                        this.getUser();
                        this.evaluate = false;
                        this.pingj = true;
                    }
                }, function (err) {
                    console.log(err);
                });
            } else {
                notify_default()({
                    message: '请勿重复评价',
                    duration: 2000,
                    background: '#1989fa'
                });
            }

            console.log(submitScore);
        },

        // 获取基本信息
        getUser: function getUser() {
            var userall = {};
            userall.handleMan = this.handleId;
            console.log('基本信息基本信息' + this.handleId);
            this.$http.post(global.host + '/repair/findOrderQuantity', userall).then(function (res) {
                console.log('基本信息基本信息基本信息基本信息基本信息基本信息基本信息基本信息');
                console.log(res);
                this.userList = res.body.result;
                this.value = res.body.result.avgNum;
            }, function (err) {
                console.log(err);
            });
        },

        // 获取展示数据集
        getAllList: function getAllList() {
            this.$http.get(global.host + "repair/findRepairDetail?repairId=" + this.$router.history.current.query.repairId).then(function (res) {
                console.log('详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据详情的数据');
                console.log(res);
                if (res.body.statusCode == 200) {
                    this.orderDetails = res.body.result;
                    this.repairType = this.orderDetails.repairType.split(',');
                    console.log('8888888888888888888888888888888888888888888');
                    console.log(this.repairType);
                    this.repairState = res.body.result.repairState;
                    this.handleMan = res.body.result.handleMan; //如果pc未派单 这个值为null 用户进来不显示头部 不为null才显示
                    if (this.handleMan == null) {
                        this.worker = false;
                    } else {
                        this.worker = true;
                    }

                    console.log('之后的this.worker-----------' + this.worker);
                    console.log(this.worker);
                    this.handleId = res.body.result.handleId;
                    console.log('刚赋值的this.handleId ------------------------' + this.handleId);
                    console.log(this.handleId);
                    this.getUser();
                    this.marWoeker();
                    console.log(this.handleMan);
                    if (this.orderDetails.images.length != 0) {
                        this.images = this.orderDetails.images;
                        // 发送请求获取图片
                        for (var i = 0; i < this.images.length; i++) {
                            this.getImages(this.images[i]);
                        }
                    } else {
                        this.loging = false;
                    }
                }
            }, function (err) {
                console.log(err);
            });
        },

        // 获取图片的ajax
        getImages: function getImages(imgId) {
            this.$http.get(global.host + "repairMgr/findPictureByPicId?pictureId=" + imgId).then(function (res) {
                this.imgageBase.push(res.url);
                this.loging = false;
            }, function (err) {
                console.log(err);
            });
        },

        // 如果未接单 逻辑
        // 如果未接单 箭头向上事件 点击填充数据
        swipeup: function swipeup() {
            console.log("箭头向上事件");
            this.jind = true;
            console.log(this.worker);
            console.log(this.jind);
            if (this.jind == true) {
                this.$refs.warperRef.style.margin = '0 0 150px 0';
                this.scroll = true;
            } else {
                this.$refs.warperRef.style.margin = '0 0 0 0';
            }
        },

        // 如果接单
        swipeupWorker: function swipeupWorker() {
            //  alert('接单上拉事件')
            this.jind2 = true;
            this.$refs.ulBox.style.margin = '0 0 450px 0';
        },
        downWorken: function downWorken() {
            this.jind2 = false;
            this.$refs.ulBox.style.margin = '0 0 100px 0';
        },


        // 获取进度条数据
        // 时间戳转换兼容判断机型
        formatDate: function formatDate(date, type) {
            if (date != undefined) {
                var add0 = function add0(m) {
                    return m < 10 ? '0' + m : m;
                };

                //兼容ios
                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) || navigator.userAgent.indexOf("Safari") > -1) {
                    date = String(date).replace(/\-/g, "/");
                }
                var time = '';
                if (date.indexOf('-') != -1 || date.indexOf('/') != -1) {
                    time = new Date(date);
                } else {
                    time = new Date(JSON.parse(date));
                }
                var year = time.getFullYear();
                var month = time.getMonth() + 1;
                var date = time.getDate();
                var hours = time.getHours();
                var minutes = time.getMinutes();
                var seconds = time.getSeconds();
                var isTime = '';

                switch (type) {
                    case 'Y-M-D hh:mm:ss':
                        isTime = year + '-' + add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
                        break;
                    case 'M-D hh:mm:ss':
                        isTime = add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
                        break;
                    case 'M-D hh:mm':
                        isTime = add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes);
                        break;
                    case 'hh:mm:ss':
                        isTime = add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
                        break;
                    case 'hh:mm':
                        isTime = add0(hours) + ':' + add0(minutes);
                        break;
                }
                return isTime;
            }
        },

        // 兼容时间格式
        getTs: function getTs(time) {
            var arr = time.split(/[- :]/),
                _date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]),
                timeStr = Date.parse(_date);
            return timeStr;
        },

        // 获取进度展示展示数据集
        getAllListUser: function getAllListUser() {
            this.list.orderList = [];
            this.$http.get(global.host + "repair/findHandleRecord?repairId=" + this.$router.history.current.query.repairId).then(function (response) {
                // alert('进度数据')
                // alert(JSON.stringify(response));
                // demo
                this.loging = false;
                for (var i = 0; i < response.body.result.length; i++) {
                    var data = {
                        id: i, //当前阶段id
                        title: response.body.result[i].handleStatus, //当前阶段订单标题
                        context: response.body.result[i].handleDesc, //当前阶段订单内容
                        dataTime: response.body.result[i].handleDate //当前阶段订单结束时间
                    };
                    this.list.orderList.push(data);
                }
                for (var i = 0; i < this.list.orderList.length; i++) {
                    //每次进度之后时间戳
                    var timestamp2 = this.formatDate(this.list.orderList[i].dataTime, 'Y-M-D hh:mm:ss');
                    //开始时间戳
                    var timestamp1 = this.formatDate(this.list.orderList[0].dataTime, 'Y-M-D hh:mm:ss');
                    //之后时间戳减开始
                    var num = this.getTs(timestamp1) - this.getTs(timestamp2);
                    //获取到总共时间
                    var second = num / 1000;
                    //判断当前度是否大于等于0
                    if (parseInt(second / 3600) <= 0) {
                        //最小0
                        this.list.orderList[i].top = 0;
                    } else {
                        //长度拼接
                        this.list.orderList[i].top = parseInt(second / 3600) + "0";
                    }
                }
                //计算当前进度的总长度
                //获取最后时间戳
                var timestamp4 = this.formatDate(this.list.orderList[this.list.orderList.length - 1].dataTime, 'Y-M-D hh:mm:ss');
                //获取开始时间戳
                var timestamp3 = this.formatDate(this.list.orderList[0].dataTime, 'Y-M-D hh:mm:ss');
                //计算时间戳之差
                var num1 = this.getTs(timestamp3) - this.getTs(timestamp4);
                //获取到总时长
                var second1 = num1 / 1000;
                //判断总长度是否大于等于0
                if (parseInt(second1 / 3600) <= 0) {
                    //最小0
                    this.list.percentage = 0;
                } else {
                    //拼接总进度长度
                    this.list.percentage = parseInt(second1 / 3600) + "0";
                }
                //判断进度总长是否超过600
                if (this.list.percentage > 600) {
                    //总进度超过600减半
                    for (var j = 0; j < this.list.orderList.length; j++) {
                        //每个进度减半
                        this.list.orderList[j].top = this.list.orderList[j].top / 2;
                    }
                    //总长度减半
                    this.list.percentage = this.list.percentage / 2;
                }
                //记录总加了多少长度
                var nuber = 0;
                //判断每个进度之间不能少于70px,少于70px,赋值给最低70
                for (var j = 0; j < this.list.orderList.length; j++) {
                    //开始第一个阶段不用高度
                    if (j == 0) {} else {
                        //判断高度是否大于70
                        if (this.list.orderList[j].top < 70) {
                            // //小于70记录与70之间的差
                            // nuber = 70 - this.list.orderList[j].top + nuber;
                            //给本阶段赋值最少进度70
                            this.list.orderList[j].top = 70;
                            //本阶段加了长度，后面都得加上等长，循环加
                            for (var s = j; s < this.list.orderList.length; s++) {
                                //每个阶段循环增加
                                this.list.orderList[s].top = this.list.orderList[s - 1].top + 70;
                            }
                            //总长度加每个进度之间的补差
                            this.list.percentage = this.list.orderList[this.list.orderList.length - 1].top;
                        }
                    }
                }
            }, function (err) {
                console.log(err);
            });
        },


        // 跳转到评价页
        selectSpeed: function selectSpeed() {
            this.$router.push({
                path: "/repairsOne",
                query: {
                    repairId: this.$router.history.current.query.repairId,
                    repairState: this.repairState,
                    handleMan: this.handleMan,
                    handleId: this.handleId
                }
            });
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-019e5570","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repairComponents/repairsThr.vue
var repairsThr_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"warperRef",staticClass:"warperCls",attrs:{"id":"warper"}},[_c('div',{staticClass:"aui-card-list-content content_list"},[(this.loging == true)?_c('div',{staticStyle:{"position":"fixed","top":"50%","left":"50%","width":"100px","height":"100px","background-color":"rgb(121, 121, 122)","transform":"translate3d(-50%,-50%,0)","border-radius":"10%"}},[_c('van-loading',{staticStyle:{"position":"absolute","top":"50%","left":"50%","transform":"translate3d(-50%,-50%,0)"},attrs:{"type":"spinner","color":"white"}})],1):_vm._e(),_vm._v(" "),(this.loging == false)?_c('ul',{ref:"ulBox",staticClass:"aui-list aui-media-list"},[_c('div',{staticStyle:{"width":"100%","height":"0.5rem","background":"rgba(247,247,247,1)"}}),_vm._v(" "),_c('li',{staticClass:"aui-list-item aui-list-item-middle",attrs:{"onclick":"openWin(\"changePsw\")"}},[_c('div',{staticClass:"aui-media-list-item-inner"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"aui-list-item-inner aui-list-item-arrow",staticStyle:{"display":"flex","width":"100%"}},[_c('div',{staticStyle:{"width":"100px","text-align":"left"}},[_vm._v("\n                      报修类型\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","text-align":"left"}},[_vm._v("\n                        "+_vm._s(_vm.orderDetails.repairClass)+"\n                      ")])])])]),_vm._v(" "),_c('li',{staticClass:"aui-list-item aui-list-item-middle",attrs:{"onclick":"openWin(\"feedback\")"}},[_c('div',{staticClass:"aui-media-list-item-inner"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"aui-list-item-inner aui-list-item-arrow",staticStyle:{"display":"flex","width":"75%"}},[_c('div',{staticStyle:{"width":"100px","text-align":"left"}},[_vm._v("\n                        报修分类\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","text-align":"left"}},_vm._l((_vm.repairType),function(item){return _c('span',{staticStyle:{"display":"inline-block","background":"rgb(20, 210, 184)","padding":"0px 8px 0px 8px","border-radius":"7px","color":"#fff","margin-left":"1.5%","margin-bottom":"3px"}},[_vm._v(_vm._s(item))])}))])])]),_vm._v(" "),_c('li',{staticClass:"aui-list-item aui-list-item-middle"},[_c('div',{staticClass:"aui-media-list-item-inner"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"aui-list-item-inner aui-list-item-arrow ",staticStyle:{"display":"flex","width":"75%"}},[_c('div',{staticStyle:{"width":"100px","text-align":"left"}},[_vm._v("\n                        房号   \n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","text-align":"left"}},[_vm._v("\n                        "+_vm._s(_vm.orderDetails.hsNo)+"\n                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"aui-list-item aui-list-item-middle",attrs:{"onclick":"openWin(\"share\")"}},[_c('div',{staticClass:"aui-media-list-item-inner"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"aui-list-item-inner aui-list-item-arrow",staticStyle:{"display":"flex","width":"75%"}},[_c('div',{staticStyle:{"width":"100px","text-align":"left"}},[_vm._v("\n                          报修人\n                        ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","text-align":"left"}},[_vm._v("\n                          "+_vm._s(_vm.orderDetails.hsName)+"\n                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"aui-list-item aui-list-item-middle",on:{"click":function($event){_vm.openDet('callback')}}},[_c('div',{staticClass:"aui-media-list-item-inner"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"aui-list-item-inner aui-list-item-arrow",staticStyle:{"display":"flex","width":"75%"}},[_c('div',{staticStyle:{"width":"100px","text-align":"left"}},[_vm._v("\n                          报修电话\n                        ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","text-align":"left","font-size":"0.95rem"}},[_vm._v("\n                          "+_vm._s(_vm.orderDetails.hsPhone)+"\n                          ")])])])]),_vm._v(" "),_c('li',{staticClass:"aui-list-item aui-list-item-middle"},[_c('div',{staticClass:"aui-media-list-item-inner",staticStyle:{"border-bottom":"0px solid #fff"}},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"aui-list-item-inner aui-list-item-arrow ",staticStyle:{"display":"flex","width":"75%"}},[_c('div',{staticStyle:{"width":"100px","text-align":"left"}},[_vm._v("\n                        预约时间   \n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%","text-align":"left","font-size":"0.95rem !important"}},[_vm._v("\n                        "+_vm._s(_vm.orderDetails.applyDate)+"\n                      ")])])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5px","width":"100%","height":"10px","background":"rgba(247,247,247,1)"}}),_vm._v(" "),_c('li',{staticClass:"aui-list-item aui-list-item-middle",on:{"click":function($event){_vm.openDet('callback')}}},[_vm._m(6)]),_vm._v(" "),_c('li',[_c('div',{staticClass:"context-onaly"},[_vm._v("\n                "+_vm._s(_vm.orderDetails.repairDesc)+"\n              ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5px","width":"100%","height":"10px","background":"rgba(247,247,247,1)"}}),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('li',[_c('div',{staticStyle:{"margin-left":"10%","padding-bottom":"20px","display":"flex","word-wrap":"break-word","word-break":"break-all","overflow":"hidden"}},[_c('div',{staticStyle:{"width":"100%","height":"100%"}},_vm._l((_vm.imgageBase),function(item){return _c('img',{staticStyle:{"width":"50px","margin-left":"10px"},attrs:{"src":item,"alt":""},on:{"click":_vm.clkImg}})}))])])]):_vm._e()]),_vm._v(" "),(this.jind == false && this.worker == false)?_c('div',{staticClass:"arrows"},[_c('v-touch',{staticClass:"wrapper",on:{"swipeup":_vm.swipeup}},[_c('img',{attrs:{"src":__webpack_require__("kjIK"),"alt":""}})])],1):_vm._e(),_vm._v(" "),( this.worker == true)?_c('v-touch',{staticClass:"wrapper",on:{"swipeup":_vm.swipeupWorker,"swipedown":_vm.downWorken}},[_c('div',{staticClass:"details-show"},[_c('div',{staticClass:"details-show-on"},[_c('div',{staticClass:"details-show-on-with"},[_c('img',{staticClass:"details-show-img",attrs:{"src":__webpack_require__("w5cD"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('div',{staticStyle:{"width":"100%","margin-top":"15px"}},[_c('div',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("\n                "+_vm._s(_vm.userList.userName)+"\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"text-align":"left","color":"#7b7b7b"}},[_vm._v("\n                工号："+_vm._s(_vm.userList.userNo)+"\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"text-align":"left","color":"#7b7b7b"}},[_vm._v("\n                评分"+_vm._s(_vm.userList.avgNum)+".0  单数："+_vm._s(_vm.userList.countNum)+"单\n                ")])])])]),_vm._v(" "),(this.jind2 == true)?_c('div',{on:{"click":function($event){_vm.giveMark()}}},[_c('div',{staticClass:"details-show-score"},[_c('div',{staticClass:"details-show-score-on"},[_vm._v("\n                总评分\n            ")]),_vm._v(" "),_c('div',{staticClass:"details-show-score-te"},[_c('van-rate',{attrs:{"readonly":true,"size":26,"count":5,"color":"#ffca00","void-color":"#ceefe8"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)])]):_vm._e(),_vm._v(" "),(this.jind2 == true)?_c('div',[_c('div',{staticStyle:{"width":"5px","margin-left":"130px","margin-bottom":"60px","margin-top":"35px","position":"relative","background-color":"#57ccb6"},style:({ height: _vm.list.percentage + 'px' })},[_c('div',{staticStyle:{"margin-left":"-21px"}},_vm._l((_vm.list.orderList),function(item){return _c('div',{key:item.id},[_c('div',{staticClass:"divspanleft",style:({ top: item.top + 'px' })},[_vm._v(_vm._s(item.dataTime))]),_vm._v(" "),_c('span',{staticClass:"span0",style:({ top: item.top + 'px' })},[_c('img',{staticStyle:{"width":"15px","height":"15px","margin-left":"1em","margin-top":"-0.5em","position":"absolute"},attrs:{"src":__webpack_require__("Mxs7"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"divspanright",style:({ top: item.top + 'px'})},[_c('div',{staticClass:"divspanrightone"},[_vm._v("\n                        "+_vm._s(item.title)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"divspanrightywo"},[_vm._v("\n                        "+_vm._s(item.context)+"\n                    ")])])])})),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"30px"}})])]):_vm._e()])]):_vm._e(),_vm._v(" "),(this.jind == true)?_c('div',{staticStyle:{"width":"5px","margin-left":"130px","margin-bottom":"60px","margin-top":"35px","position":"relative","background-color":"#57ccb6"},style:({ height: _vm.list.percentage + 'px' })},[_c('div',{staticStyle:{"margin-left":"-21px"}},_vm._l((_vm.list.orderList),function(item){return _c('div',{key:item.id},[_c('div',{staticClass:"divspanleft",style:({ top: item.top + 'px' })},[_vm._v(_vm._s(item.dataTime))]),_vm._v(" "),_c('span',{staticClass:"span0",style:({ top: item.top + 'px' })},[_c('img',{staticStyle:{"width":"15px","height":"15px","margin-left":"1em","margin-top":"-0.5em","position":"absolute"},attrs:{"src":__webpack_require__("Mxs7"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"divspanright",style:({ top: item.top + 'px'})},[_c('div',{staticClass:"divspanrightone"},[_vm._v("\n                    "+_vm._s(item.title)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"divspanrightywo"},[_vm._v("\n                    "+_vm._s(item.context)+"\n                ")])])])}))]):_vm._e(),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom","close-on-click-overlay":false,"overlay":true},model:{value:(_vm.evaluate),callback:function ($$v) {_vm.evaluate=$$v},expression:"evaluate"}},[_c('div',{staticClass:"evaluate-popu-show",attrs:{"id":"payment"}},[_c('div',{staticClass:"evaluate-popu-show-on"},[_c('div',{staticClass:"evaluate-popu-cancel",on:{"click":function($event){_vm.del()}}},[_vm._v("\n      取消\n    ")]),_vm._v(" "),_c('div',{staticClass:"evaluate-popu-fill"},[_vm._v("\n      评价\n    ")]),_vm._v(" "),_c('div',{staticClass:"evaluate-popu-show-submit",on:{"click":function($event){_vm.payment()}}},[_vm._v("\n      提交\n    ")])]),_vm._v(" "),_c('div',{staticClass:"evaluate-popu-show-efficiency"},[_c('div',{staticClass:"evaluate-popu-show-efficiency-on"},[_c('div',{staticClass:"evaluate-popu-show-efficiency-on-s"},[_vm._v("\n        维修效率\n      ")]),_vm._v(" "),_c('div',{staticClass:"evaluate-show-server"},[_c('van-rate',{attrs:{"size":24,"count":5,"color":"#ffca00","void-color":"#ceefe8"},model:{value:(_vm.valueone),callback:function ($$v) {_vm.valueone=$$v},expression:"valueone"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","height":"50px"}},[_c('div',{staticStyle:{"width":"27%","padding-top":"10px","text-align":"right"}},[_vm._v("\n        服务态度\n      ")]),_vm._v(" "),_c('div',{staticClass:"evaluate-show-server"},[_c('van-rate',{attrs:{"size":24,"count":5,"color":"#ffca00","void-color":"#ceefe8"},model:{value:(_vm.valuetwo),callback:function ($$v) {_vm.valuetwo=$$v},expression:"valuetwo"}})],1)])]),_vm._v(" "),_c('div',{staticStyle:{"height":"50px","width":"100%","display":"block !important","font-size":"15px !important"}},_vm._l((_vm.Dictionaries),function(item){return _c('div',{staticStyle:{"width":"25%","height":"30px","line-height":"30px","border":"1px solid #e4e4e4","margin-left":"6%","margin-top":"10px","text-align":"center","display":"inline-block"},on:{"click":function($event){_vm.getSazd(item,$event)}}},[_vm._v(_vm._s(item))])}))])])],1)}
var repairsThr_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aui-list-item-media"},[_c('img',{staticClass:"aui-img-round aui-list-img-sm",attrs:{"src":__webpack_require__("qhZB")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aui-list-item-media"},[_c('img',{staticClass:"aui-img-round aui-list-img-sm",attrs:{"src":__webpack_require__("LwSa")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aui-list-item-media"},[_c('img',{staticClass:"aui-img-round aui-list-img-sm",attrs:{"src":__webpack_require__("jDpe")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aui-list-item-media"},[_c('img',{staticClass:"aui-img-round aui-list-img-sm",attrs:{"src":__webpack_require__("hWYL")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aui-list-item-media"},[_c('img',{staticClass:"aui-img-round aui-list-img-sm",attrs:{"src":__webpack_require__("OzMS")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aui-list-item-media"},[_c('img',{staticClass:"aui-img-round aui-list-img-sm",attrs:{"src":__webpack_require__("F0Jx")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aui-media-list-item-inner",staticStyle:{"border-bottom":"0px solid #fff"}},[_c('div',{staticClass:"aui-list-item-media"},[_c('img',{staticClass:"aui-img-round aui-list-img-sm",attrs:{"src":__webpack_require__("5POz")}})]),_vm._v(" "),_c('div',{staticClass:"aui-list-item-inner aui-list-item-arrow",staticStyle:{"display":"flex","width":"75%"}},[_c('div',{staticStyle:{"width":"100px","text-align":"left"}},[_vm._v("\n                        报修内容\n                      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"aui-list-item aui-list-item-middle"},[_c('div',{staticClass:"aui-media-list-item-inner",staticStyle:{"border-bottom":"0px solid #fff"}},[_c('div',{staticClass:"aui-list-item-media"},[_c('img',{staticClass:"aui-img-round aui-list-img-sm",attrs:{"src":__webpack_require__("Y8g4")}})]),_vm._v(" "),_c('div',{staticClass:"aui-list-item-inner aui-list-item-arrow ",staticStyle:{"display":"flex","width":"75%"}},[_c('div',{staticStyle:{"width":"130px","text-align":"left"}},[_vm._v("\n                        报修图片附件   \n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","text-align":"left"}})])])])}]
var repairsThr_esExports = { render: repairsThr_render, staticRenderFns: repairsThr_staticRenderFns }
/* harmony default export */ var components_repairComponents_repairsThr = (repairsThr_esExports);
// CONCATENATED MODULE: ./src/components/repairComponents/repairsThr.vue
function repairsThr_injectStyle (ssrContext) {
  __webpack_require__("ekZG")
  __webpack_require__("oCox")
}
var repairsThr_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var repairsThr___vue_template_functional__ = false
/* styles */
var repairsThr___vue_styles__ = repairsThr_injectStyle
/* scopeId */
var repairsThr___vue_scopeId__ = "data-v-019e5570"
/* moduleIdentifier (server only) */
var repairsThr___vue_module_identifier__ = null
var repairsThr_Component = repairsThr_normalizeComponent(
  repairComponents_repairsThr,
  components_repairComponents_repairsThr,
  repairsThr___vue_template_functional__,
  repairsThr___vue_styles__,
  repairsThr___vue_scopeId__,
  repairsThr___vue_module_identifier__
)

/* harmony default export */ var src_components_repairComponents_repairsThr = (repairsThr_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/suggest.vue







/* harmony default export */ var suggest = ({
  components: {
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    Group: group["a" /* default */]
  },
  data: function data() {
    return {
      style0: 'default',
      style1: 'default',
      style2: 'primary',
      style3: 'default'
    };
  },

  methods: {
    changeStyle: function changeStyle(index) {
      for (var i = 0; i < 4; i++) {
        this['style' + i] = 'default';
      }
      this['style' + index] = 'primary';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/suggest.vue







/* harmony default export */ var components_suggest = ({
  components: {
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    Group: group["a" /* default */]
  },
  data: function data() {
    return {
      style0: 'default',
      style1: 'default',
      style2: 'primary',
      style3: 'default'
    };
  },

  methods: {
    changeStyle: function changeStyle(index) {
      for (var i = 0; i < 4; i++) {
        this['style' + i] = 'default';
      }
      this['style' + index] = 'primary';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-309273c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/suggest.vue
var suggest_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticStyle:{"text-align":"center","padding":"8px 0","background":"#fff","border-bottom":"1px solid #D9D9D9","font-size":"1.2em"}},[_vm._v("意见主题")]),_vm._v(" "),_c('div',{staticStyle:{"width":"85%","min-width":"300px","margin":"15px auto 0"}},[_c('flexbox',{attrs:{"gutter":0,"wrap":"wrap"}},[_c('flexbox-item',{attrs:{"span":1/3}},[_c('div',{staticClass:"tagcontainer"},[_c('x-button',{attrs:{"mini":"","type":_vm.style0},nativeOn:{"click":function($event){_vm.changeStyle(0)}}},[_vm._v("出错bug")])],1)]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/3}},[_c('div',{staticClass:"tagcontainer"},[_c('x-button',{attrs:{"mini":"","type":_vm.style1},nativeOn:{"click":function($event){_vm.changeStyle(1)}}},[_vm._v("提议新功能")])],1)]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/3}},[_c('div',{staticClass:"tagcontainer"},[_c('x-button',{attrs:{"mini":"","type":_vm.style2},nativeOn:{"click":function($event){_vm.changeStyle(2)}}},[_vm._v("体验问题")])],1)]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/3}},[_c('div',{staticClass:"tagcontainer"},[_c('x-button',{attrs:{"mini":"","type":_vm.style3},nativeOn:{"click":function($event){_vm.changeStyle(3)}}},[_vm._v("其他问题")])],1)])],1),_vm._v(" "),_c('group',{staticStyle:{"margin-top":"-10px"}},[_c('x-textarea',{staticStyle:{"font-size":"0.8em"},attrs:{"placeholder":"请输入您的提议","rows":"6;"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_vm._v(" "),_c('div',{staticStyle:{"height":"20px"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"height":"20px"}}),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"}},[_vm._v("确认提交")])],1)])}
var suggest_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100px","height":"100px","background-color":"#fff","overflow":"hidden","line-height":"100px","position":"relative"}},[_c('span',{staticStyle:{"position":"absolute","display":"block","width":"100%","height":"100%","top":"0"}},[_c('i',{staticClass:"iconfont icon-xiangji",staticStyle:{"font-size":"40px","margin-left":"30%","color":"#ddd"}})]),_vm._v(" "),_c('input',{staticStyle:{"display":"block","opacity":"0","width":"100px","height":"100px"},attrs:{"type":"file","name":"file","accept":"image/*"}})])}]
var suggest_esExports = { render: suggest_render, staticRenderFns: suggest_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_suggest = (suggest_esExports);
// CONCATENATED MODULE: ./src/components/suggest.vue
function suggest_injectStyle (ssrContext) {
  __webpack_require__("UM/W")
}
var suggest_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var suggest___vue_template_functional__ = false
/* styles */
var suggest___vue_styles__ = suggest_injectStyle
/* scopeId */
var suggest___vue_scopeId__ = "data-v-309273c8"
/* moduleIdentifier (server only) */
var suggest___vue_module_identifier__ = null
var suggest_Component = suggest_normalizeComponent(
  components_suggest,
  selectortype_template_index_0_src_components_suggest,
  suggest___vue_template_functional__,
  suggest___vue_styles__,
  suggest___vue_scopeId__,
  suggest___vue_module_identifier__
)

/* harmony default export */ var src_components_suggest = (suggest_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/addCar.vue











/* harmony default export */ var carRentComponents_addCar = ({
  data: function data() {
    return {
      iconType: "",

      show_1: false,
      pkCode: "", //车位编号
      carNo: "", //车牌号码
      carName: "", //车主姓名
      carBrand: "", //车辆品牌
      carModel: "", //车辆型号
      carColor: "", //车身颜色
      carPhone: '', //绑定手机
      comnCode: '', //
      pkId: '',
      showprompt: false,
      prompt: '',
      carId: '',
      openid: '',
      disableBtn: false
    };
  },

  components: {
    Group: group["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    XHeader: vux_src_components_x_header,
    XInput: x_input["a" /* default */],
    XButton: vux_src_components_x_button,
    FlexboxItem: flexbox_item["a" /* default */],
    loadPage: src_components_loadingPage,
    Alert: components_alert["a" /* default */]
  },
  beforeMount: function beforeMount() {
    this.carPhone = this.$router.history.current.query.phone;
    if (this.$router.history.current.path == "/myCarInfo") {
      document.title = "添加车辆";
    }
    this.pkCode = this.$router.history.current.query.pkCode;
    this.phone = this.$router.history.current.query.phone;
    this.pkId = this.$router.history.current.query.pkId;
    this.openid = this.$router.history.current.query.openid;
  },

  methods: {
    onBlur: function onBlur(val) {
      console.log("on blur", val);
    },
    validateCarNo: function validateCarNo() {
      var carStr = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/;
      var carNos = this.carNo;
      console.log(carNos);
      var carNoNumber = carStr.test(carNos);
      if (carStr.test(carNos)) {
        this.showprompt = false;
        this.disableBtn = false;
        return true;
      } else {
        this.showprompt = true;
        this.prompt = '请输入正确的车牌号码';
        this.disableBtn = true;
        return false;
      }
    },
    changeCarInfo: function changeCarInfo() {
      var carStr = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/;
      var carNos = this.carNo;
      console.log(carNos);
      var carNoNumber = carStr.test(carNos);
      if (carStr.test(carNos)) {
        this.disableBtn = false;
        return true;
      } else {
        this.disableBtn = true;
        return false;
      }
    },
    addCar: function addCar() {
      if (!this.validateCarNo()) {
        return;
      }

      var omeinfo = new Object();
      omeinfo.pkCode = this.pkCode;
      omeinfo.carNo = this.carNo;
      omeinfo.carName = this.carName;
      omeinfo.carBrand = this.carBrand;
      omeinfo.carModel = this.carModel;
      omeinfo.carColor = this.carColor;
      omeinfo.carPhone = this.$router.history.current.query.phone;
      omeinfo.comnCode = this.$router.history.current.query.comnCode;
      omeinfo.pkId = this.$router.history.current.query.pkId;
      omeinfo.pkCode = this.$router.history.current.query.pkCode;
      omeinfo.openid = this.$router.history.current.query.openid;

      console.log(omeinfo);
      this.show_1 = true;
      var url1 = global.host + 'carInfo/bindParkingInfo';

      if (omeinfo.carNo === '') {
        this.showprompt = true;
        this.prompt = "请填写完整的信息！";
        this.show_1 = false;
        return;
      }
      console.log('@@@@@@@@@@@');
      console.log(omeinfo);
      console.log('@@@@@@@@@@@');
      this.$http.post(url1, omeinfo).then(function (res) {

        var stateCode = res.body.statusCode;
        if (stateCode == "110") {
          this.$router.push({ path: "/myCarInfo", query: { phone: omeinfo.carPhone, comnCode: omeinfo.comnCode, pkId: omeinfo.pkId, pkCode: omeinfo.pkCode, openid: omeinfo.openid } });
        } else if (stateCode == "120") {
          this.showprompt = true;
          this.prompt = "绑定失败,请重试！";
        }
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/addCar.vue











/* harmony default export */ var components_carRentComponents_addCar = ({
  data: function data() {
    return {
      iconType: "",

      show_1: false,
      pkCode: "", //车位编号
      carNo: "", //车牌号码
      carName: "", //车主姓名
      carBrand: "", //车辆品牌
      carModel: "", //车辆型号
      carColor: "", //车身颜色
      carPhone: '', //绑定手机
      comnCode: '', //
      pkId: '',
      showprompt: false,
      prompt: '',
      carId: '',
      openid: '',
      disableBtn: false
    };
  },

  components: {
    Group: group["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    XHeader: vux_src_components_x_header,
    XInput: x_input["a" /* default */],
    XButton: vux_src_components_x_button,
    FlexboxItem: flexbox_item["a" /* default */],
    loadPage: src_components_loadingPage,
    Alert: components_alert["a" /* default */]
  },
  beforeMount: function beforeMount() {
    this.carPhone = this.$router.history.current.query.phone;
    if (this.$router.history.current.path == "/myCarInfo") {
      document.title = "添加车辆";
    }
    this.pkCode = this.$router.history.current.query.pkCode;
    this.phone = this.$router.history.current.query.phone;
    this.pkId = this.$router.history.current.query.pkId;
    this.openid = this.$router.history.current.query.openid;
  },

  methods: {
    onBlur: function onBlur(val) {
      console.log("on blur", val);
    },
    validateCarNo: function validateCarNo() {
      var carStr = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/;
      var carNos = this.carNo;
      console.log(carNos);
      var carNoNumber = carStr.test(carNos);
      if (carStr.test(carNos)) {
        this.showprompt = false;
        this.disableBtn = false;
        return true;
      } else {
        this.showprompt = true;
        this.prompt = '请输入正确的车牌号码';
        this.disableBtn = true;
        return false;
      }
    },
    changeCarInfo: function changeCarInfo() {
      var carStr = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/;
      var carNos = this.carNo;
      console.log(carNos);
      var carNoNumber = carStr.test(carNos);
      if (carStr.test(carNos)) {
        this.disableBtn = false;
        return true;
      } else {
        this.disableBtn = true;
        return false;
      }
    },
    addCar: function addCar() {
      if (!this.validateCarNo()) {
        return;
      }

      var omeinfo = new Object();
      omeinfo.pkCode = this.pkCode;
      omeinfo.carNo = this.carNo;
      omeinfo.carName = this.carName;
      omeinfo.carBrand = this.carBrand;
      omeinfo.carModel = this.carModel;
      omeinfo.carColor = this.carColor;
      omeinfo.carPhone = this.$router.history.current.query.phone;
      omeinfo.comnCode = this.$router.history.current.query.comnCode;
      omeinfo.pkId = this.$router.history.current.query.pkId;
      omeinfo.pkCode = this.$router.history.current.query.pkCode;
      omeinfo.openid = this.$router.history.current.query.openid;

      console.log(omeinfo);
      this.show_1 = true;
      var url1 = global.host + 'carInfo/bindParkingInfo';

      if (omeinfo.carNo === '') {
        this.showprompt = true;
        this.prompt = "请填写完整的信息！";
        this.show_1 = false;
        return;
      }
      console.log('@@@@@@@@@@@');
      console.log(omeinfo);
      console.log('@@@@@@@@@@@');
      this.$http.post(url1, omeinfo).then(function (res) {

        var stateCode = res.body.statusCode;
        if (stateCode == "110") {
          this.$router.push({ path: "/myCarInfo", query: { phone: omeinfo.carPhone, comnCode: omeinfo.comnCode, pkId: omeinfo.pkId, pkCode: omeinfo.pkCode, openid: omeinfo.openid } });
        } else if (stateCode == "120") {
          this.showprompt = true;
          this.prompt = "绑定失败,请重试！";
        }
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aa2d470","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carRentComponents/addCar.vue
var addCar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addBox",staticStyle:{"touch-action":"none"}},[_c('group',{attrs:{"title":""}},[_c('x-input',{attrs:{"title":"车位编号:","placeholder":"车位编号","disabled":"","text-align":"right"},model:{value:(_vm.pkCode),callback:function ($$v) {_vm.pkCode=$$v},expression:"pkCode"}})],1),_vm._v(" "),_c('group',{attrs:{"title":""}},[_c('x-input',{attrs:{"title":"车牌号码:","required":"","placeholder":"请输入车牌号码","text-align":"right"},on:{"on-change":_vm.changeCarInfo,"on-blur":_vm.validateCarNo},model:{value:(_vm.carNo),callback:function ($$v) {_vm.carNo=$$v},expression:"carNo"}})],1),_vm._v(" "),_c('group',{attrs:{"title":""}},[_c('x-input',{attrs:{"title":"车主姓名:","name":"","required":"","placeholder":"请输入车主姓名","text-align":"right"},model:{value:(_vm.carName),callback:function ($$v) {_vm.carName=$$v},expression:"carName"}})],1),_vm._v(" "),_c('group',{attrs:{"title":""}},[_c('x-input',{attrs:{"title":"车辆品牌:","placeholder":"请输入车辆品牌","text-align":"right"},model:{value:(_vm.carBrand),callback:function ($$v) {_vm.carBrand=$$v},expression:"carBrand"}})],1),_vm._v(" "),_c('group',{attrs:{"title":""}},[_c('x-input',{attrs:{"title":"车辆型号:","placeholder":"请输入车辆型号","text-align":"right"},model:{value:(_vm.carModel),callback:function ($$v) {_vm.carModel=$$v},expression:"carModel"}})],1),_vm._v(" "),_c('group',{attrs:{"title":""}},[_c('x-input',{attrs:{"title":"车身颜色:","placeholder":"请输入车身颜色","text-align":"right"},model:{value:(_vm.carColor),callback:function ($$v) {_vm.carColor=$$v},expression:"carColor"}})],1),_vm._v(" "),_c('p',{staticClass:"tixing"},[_vm._v("绑定和修改的车辆信息24小时后才可生效")]),_vm._v(" "),_c('flexbox',{attrs:{"orient":"horizontal"}},[_c('flexbox-item',{staticStyle:{"display":"flex","align-items":"center"}},[_c('x-button',{staticClass:"addInfo",staticStyle:{"padding":"0 5px!important"},attrs:{"disabled":_vm.disableBtn,"type":"primary"},nativeOn:{"click":function($event){return _vm.addCar($event)}}},[_vm._v("添加车辆绑定")])],1)],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}}),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.showprompt),callback:function ($$v) {_vm.showprompt=$$v},expression:"showprompt"}},[_vm._v(_vm._s(_vm.prompt))])],1)],1)}
var addCar_staticRenderFns = []
var addCar_esExports = { render: addCar_render, staticRenderFns: addCar_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_carRentComponents_addCar = (addCar_esExports);
// CONCATENATED MODULE: ./src/components/carRentComponents/addCar.vue
function addCar_injectStyle (ssrContext) {
  __webpack_require__("IGUU")
}
var addCar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addCar___vue_template_functional__ = false
/* styles */
var addCar___vue_styles__ = addCar_injectStyle
/* scopeId */
var addCar___vue_scopeId__ = "data-v-6aa2d470"
/* moduleIdentifier (server only) */
var addCar___vue_module_identifier__ = null
var addCar_Component = addCar_normalizeComponent(
  components_carRentComponents_addCar,
  selectortype_template_index_0_src_components_carRentComponents_addCar,
  addCar___vue_template_functional__,
  addCar___vue_styles__,
  addCar___vue_scopeId__,
  addCar___vue_module_identifier__
)

/* harmony default export */ var src_components_carRentComponents_addCar = (addCar_Component.exports);

// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/myCarInfo.vue















/* harmony default export */ var myCarInfo = ({
  data: function data() {
    var _ref;

    return _ref = {
      pkCode: '',
      iconType: "",
      title: "我的车位",
      mylist1: [],
      mylistcar: [],
      nums: '1',
      show_1: false, //控制是否显示loading动画效果
      phone: "",
      comnCode: '',
      hies: false,
      carId: '',
      index: ''
    }, defineProperty_default()(_ref, 'phone', ''), defineProperty_default()(_ref, 'show_3', true), defineProperty_default()(_ref, 'showprompt', false), defineProperty_default()(_ref, 'prompt', ''), defineProperty_default()(_ref, 'openid', ''), defineProperty_default()(_ref, 'show_2', false), defineProperty_default()(_ref, 'pkUsed', ''), defineProperty_default()(_ref, 'show_4', false), defineProperty_default()(_ref, 'show_5', false), defineProperty_default()(_ref, 'show_6', true), defineProperty_default()(_ref, 'carMaxNumber', []), _ref;
  },

  components: {
    XHeader: vux_src_components_x_header,
    XTable: vux_src_components_x_table,
    Alert: components_alert["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    Group: group["a" /* default */],
    loadPage: src_components_loadingPage,
    XButton: vux_src_components_x_button
  },
  computed: {},
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/myCarInfo") {
      document.title = "我的车位";
    }
    this.openid = this.$router.history.current.query.openid;
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      var rsults = res.body.result;
      this.carMaxNumber = new Object();
      for (var ms in rsults) {
        this.carMaxNumber[ms] = rsults[ms];
      }
      /*console.log("&&&&&&&&&&&&&&&&&&&&&")
      console.log(this.carMaxNumber)*/
      if (res.body.result.length > 0) {
        var data = res.body.result[0];
        console.log("####################");
        console.log(data);
        this.comnCode = data.comn_code;
        this.phone = this.$router.history.current.query.phone;
        /*this.pkCode=this.$router.history.current.query.pkCode;
        this.carId=this.$router.history.current.query.carId;
        this.pkId=this.$router.history.current.query.pkId;*/

        var url1 = global.host + 'parkinginfo/getByPhone?phone=' + this.phone + "&comnCode=" + this.comnCode;
        this.$http.get(url1).then(function (res) {
          var _this = this;

          this.show_1 = false;
          if (res.body.result.length > 0) {
            this.show_5 = false;
          } else {
            this.show_5 = true;
          }
          res.body.result.map(function (item) {
            //遍历返回的对象，并设置相应对象的值
            item.park.pkUsed = item.park.pkUsed === '1' ? '租赁' : '购买';

            if (item.car.length <= _this.carNumber) {
              _this.show_4 = true;
            } else {
              _this.show_4 = false;
            }
          });
          this.mylist1 = res.body.result;
          console.log('!!!!!!!!!!!');
          console.log(res);
        }, function (err) {
          console.log(err);
        });
      } else {
        this.show_1 = false;
        this.show_6 = false;
        this.show_5 = true;
      }
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    deleteCarInfo: function deleteCarInfo(carId) {
      //删除绑定的车量信息
      var delUrl = global.host + 'carInfo/deleteCarInfo?carId=' + carId + '&phone=' + this.phone + '&pkCode=' + this.$router.history.current.query.pkCode;;
      console.log(delUrl);
      var this_ = this;
      this.$http.get(delUrl).then(function (res) {
        if (res.body.statusCode == '110') {
          this_.$router.go(0);
          return true;
        } else {
          this.showprompt = true;
          this.prompt = "删除失败,请重试！";
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/myCarInfo.vue















/* harmony default export */ var carRentComponents_myCarInfo = ({
  data: function data() {
    var _ref;

    return _ref = {
      pkCode: '',
      iconType: "",
      title: "我的车位",
      mylist1: [],
      mylistcar: [],
      nums: '1',
      show_1: false, //控制是否显示loading动画效果
      phone: "",
      comnCode: '',
      hies: false,
      carId: '',
      index: ''
    }, defineProperty_default()(_ref, 'phone', ''), defineProperty_default()(_ref, 'show_3', true), defineProperty_default()(_ref, 'showprompt', false), defineProperty_default()(_ref, 'prompt', ''), defineProperty_default()(_ref, 'openid', ''), defineProperty_default()(_ref, 'show_2', false), defineProperty_default()(_ref, 'pkUsed', ''), defineProperty_default()(_ref, 'show_4', false), defineProperty_default()(_ref, 'show_5', false), defineProperty_default()(_ref, 'show_6', true), defineProperty_default()(_ref, 'carMaxNumber', []), _ref;
  },

  components: {
    XHeader: vux_src_components_x_header,
    XTable: vux_src_components_x_table,
    Alert: components_alert["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    Group: group["a" /* default */],
    loadPage: src_components_loadingPage,
    XButton: vux_src_components_x_button
  },
  computed: {},
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/myCarInfo") {
      document.title = "我的车位";
    }
    this.openid = this.$router.history.current.query.openid;
    this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone + '&openid=' + this.$router.history.current.query.openid).then(function (res) {
      var rsults = res.body.result;
      this.carMaxNumber = new Object();
      for (var ms in rsults) {
        this.carMaxNumber[ms] = rsults[ms];
      }
      /*console.log("&&&&&&&&&&&&&&&&&&&&&")
      console.log(this.carMaxNumber)*/
      if (res.body.result.length > 0) {
        var data = res.body.result[0];
        console.log("####################");
        console.log(data);
        this.comnCode = data.comn_code;
        this.phone = this.$router.history.current.query.phone;
        /*this.pkCode=this.$router.history.current.query.pkCode;
        this.carId=this.$router.history.current.query.carId;
        this.pkId=this.$router.history.current.query.pkId;*/

        var url1 = global.host + 'parkinginfo/getByPhone?phone=' + this.phone + "&comnCode=" + this.comnCode;
        this.$http.get(url1).then(function (res) {
          var _this = this;

          this.show_1 = false;
          if (res.body.result.length > 0) {
            this.show_5 = false;
          } else {
            this.show_5 = true;
          }
          res.body.result.map(function (item) {
            //遍历返回的对象，并设置相应对象的值
            item.park.pkUsed = item.park.pkUsed === '1' ? '租赁' : '购买';

            if (item.car.length <= _this.carNumber) {
              _this.show_4 = true;
            } else {
              _this.show_4 = false;
            }
          });
          this.mylist1 = res.body.result;
          console.log('!!!!!!!!!!!');
          console.log(res);
        }, function (err) {
          console.log(err);
        });
      } else {
        this.show_1 = false;
        this.show_6 = false;
        this.show_5 = true;
      }
    }, function (err) {
      console.log(err);
    });
  },

  methods: {
    deleteCarInfo: function deleteCarInfo(carId) {
      //删除绑定的车量信息
      var delUrl = global.host + 'carInfo/deleteCarInfo?carId=' + carId + '&phone=' + this.phone + '&pkCode=' + this.$router.history.current.query.pkCode;;
      console.log(delUrl);
      var this_ = this;
      this.$http.get(delUrl).then(function (res) {
        if (res.body.statusCode == '110') {
          this_.$router.go(0);
          return true;
        } else {
          this.showprompt = true;
          this.prompt = "删除失败,请重试！";
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-285dfa6e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carRentComponents/myCarInfo.vue
var myCarInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.mylist1),function(item,index){return (_vm.show_6)?_c('div',{key:index,staticClass:"content"},[_c('flexbox',{staticClass:"headtop",attrs:{"orient":"horizontal","gutter":0}},[_c('flexbox-item',{staticStyle:{"display":"flex","justify-content":"flex-end"},attrs:{"span":2/8}},[_c('div',{staticClass:"am_bj"},[_vm._v("区   域:")])]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"display":"flex","justify-content":"start"},attrs:{"span":3/8}},[_c('div',{staticClass:"am_bj"},[_vm._v(_vm._s(item.park.pkRegion)+_vm._s(item.park.pkFloor))])])],1),_vm._v(" "),_c('flexbox',{staticClass:"headtop",attrs:{"orient":"horizontal","gutter":0}},[_c('flexbox-item',{staticStyle:{"display":"flex","justify-content":"flex-end"},attrs:{"span":2/8}},[_c('div',{staticClass:"am_bj"},[_vm._v("车位号:")])]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"display":"flex","justify-content":"start"},attrs:{"span":3/8}},[_c('router-link',{staticClass:"am_bj",staticStyle:{"color":"#fff"},attrs:{"to":{path:'/myCarInfoList',query:{phone:_vm.phone,comnCode:_vm.comnCode,pkId:item.park.pkId,pkCode:item.park.pkCode,carName:item.park.carName,openid:_vm.openid}}}},[_vm._v("\n                  "+_vm._s(item.park.pkCode)+"\n                  ")])],1),_vm._v(" "),_c('flexbox-item',{staticStyle:{"display":"flex","justify-content":"flex-end"},attrs:{"span":3/8}},[_c('router-link',{attrs:{"to":{path:'/carPaycoment',query:{phone:_vm.phone,comnCode:_vm.comnCode,openid:_vm.openid}}}},[_c('div',{staticClass:"add_in"},[_c('span',{staticStyle:{"font-size":"14px","color":"rgba(63,81,181,1)","margin-right":"15px"}},[_vm._v("续费")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"time_wz"},[_c('p',[_vm._v("到期时间")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.park.endDate))])]),_vm._v(" "),_vm._l((item.car),function(items,index){return (_vm.show_3)?_c('div',{key:index,staticClass:"carInfo_in"},[_c('flexbox',{attrs:{"orient":"horizontal","gutter":0}},[_c('flexbox-item',{staticStyle:{"display":"flex","justify-content":"center","line-height":"40px"},attrs:{"span":9/10}},[_c('p',{staticClass:"ziti"},[_c('i',{staticClass:"fa fa-automobile mg_2",staticStyle:{"color":"#2B2B2D"},attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(items.carNo))])]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"height":"30px"},attrs:{"span":1/10}},[_c('router-link',{attrs:{"to":{path:'/updateCarInfo',query:{carColor:items.carColor,carModel:items.carModel,carNo:items.carNo,carName:items.carName,carBrand:items.carBrand,carId:items.carId,pkCode:items.pkCode,phone:_vm.phone,comnCode:_vm.comnCode,pkId:items.pkId,openid:_vm.openid}}}},[_c('i',{staticClass:"fa fa-chevron-right",staticStyle:{"magin-lift":"15px","color":"#4A7B49","font-size":"25px","vertical-align":"middle","line-height":"30px"},attrs:{"aria-hidden":"true"}})])],1)],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.carMaxNumber),function(itms,index){return _c('div',{key:index},[(item.car.length<itms.maxCarNum)?_c('div',{staticClass:"carInfo_in absence"},[_c('router-link',{attrs:{"to":{path:'/addCar',query:{phone:_vm.phone,comnCode:_vm.comnCode,pkId:item.park.pkId,pkCode:item.park.pkCode,openid:_vm.openid}}}},[_c('p',{staticStyle:{"color":"#4A7B49"}},[_c('i',{staticClass:"fa fa-plus ",staticStyle:{"font-size":"18px","vertical-align":"middle"},attrs:{"aria-hidden":"true"}}),_vm._v(" 添加新车辆")])])],1):_vm._e()])})],2):_vm._e()}),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}}),_vm._v(" "),_c('group',{staticStyle:{"magin":"10px auto","text-align":"center"}},[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.showprompt),callback:function ($$v) {_vm.showprompt=$$v},expression:"showprompt"}},[_vm._v(_vm._s(_vm.prompt))])],1),_vm._v(" "),(_vm.show_5)?_c('div',{staticClass:"tishiInfo"},[_c('p',[_vm._v("您还没有任何车位信息,")]),_vm._v(" "),_c('p',[_vm._v("如需办理请联系物业公司!")])]):_vm._e()],2)}
var myCarInfo_staticRenderFns = []
var myCarInfo_esExports = { render: myCarInfo_render, staticRenderFns: myCarInfo_staticRenderFns }
/* harmony default export */ var components_carRentComponents_myCarInfo = (myCarInfo_esExports);
// CONCATENATED MODULE: ./src/components/carRentComponents/myCarInfo.vue
function myCarInfo_injectStyle (ssrContext) {
  __webpack_require__("w9v+")
}
var myCarInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myCarInfo___vue_template_functional__ = false
/* styles */
var myCarInfo___vue_styles__ = myCarInfo_injectStyle
/* scopeId */
var myCarInfo___vue_scopeId__ = "data-v-285dfa6e"
/* moduleIdentifier (server only) */
var myCarInfo___vue_module_identifier__ = null
var myCarInfo_Component = myCarInfo_normalizeComponent(
  carRentComponents_myCarInfo,
  components_carRentComponents_myCarInfo,
  myCarInfo___vue_template_functional__,
  myCarInfo___vue_styles__,
  myCarInfo___vue_scopeId__,
  myCarInfo___vue_module_identifier__
)

/* harmony default export */ var src_components_carRentComponents_myCarInfo = (myCarInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/weChatScaner.vue















/* harmony default export */ var weChatScaner = ({
  components: {
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage,
    $: jquery_default.a,
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      show_1: true
    };
  },


  mounted: function mounted() {
    this.code = this.$router.history.current.query.code;
    this.state = this.$router.history.current.query.state;
    var url = global.host + 'users/getuser?code=' + this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
    console.log(url);
    this.$http.get(url).then(function (res) {
      console.log(res);
      if (res.body.result) {
        this.$router.replace({ path: '/zhiF', query: { comnCode: this.state, openid: res.body.result.openId, phone: res.body.result.mainPhone } });
      } else {

        this.$router.replace({ path: '/defeated' });
      }
    }, function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/weChatScaner.vue















/* harmony default export */ var carRentComponents_weChatScaner = ({
  components: {
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage,
    $: jquery_default.a,
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      show_1: true
    };
  },


  mounted: function mounted() {
    this.code = this.$router.history.current.query.code;
    this.state = this.$router.history.current.query.state;
    var url = global.host + 'users/getuser?code=' + this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
    console.log(url);
    this.$http.get(url).then(function (res) {
      console.log(res);
      if (res.body.result) {
        this.$router.replace({ path: '/zhiF', query: { comnCode: this.state, openid: res.body.result.openId, phone: res.body.result.mainPhone } });
      } else {

        this.$router.replace({ path: '/defeated' });
      }
    }, function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3be984d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carRentComponents/weChatScaner.vue
var weChatScaner_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",staticStyle:{"overflow-x":"hidden"}},[_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var weChatScaner_staticRenderFns = []
var weChatScaner_esExports = { render: weChatScaner_render, staticRenderFns: weChatScaner_staticRenderFns }
/* harmony default export */ var components_carRentComponents_weChatScaner = (weChatScaner_esExports);
// CONCATENATED MODULE: ./src/components/carRentComponents/weChatScaner.vue
function weChatScaner_injectStyle (ssrContext) {
  __webpack_require__("KFCM")
}
var weChatScaner_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var weChatScaner___vue_template_functional__ = false
/* styles */
var weChatScaner___vue_styles__ = weChatScaner_injectStyle
/* scopeId */
var weChatScaner___vue_scopeId__ = "data-v-3be984d8"
/* moduleIdentifier (server only) */
var weChatScaner___vue_module_identifier__ = null
var weChatScaner_Component = weChatScaner_normalizeComponent(
  carRentComponents_weChatScaner,
  components_carRentComponents_weChatScaner,
  weChatScaner___vue_template_functional__,
  weChatScaner___vue_styles__,
  weChatScaner___vue_scopeId__,
  weChatScaner___vue_module_identifier__
)

/* harmony default export */ var src_components_carRentComponents_weChatScaner = (weChatScaner_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/updateCarInfo.vue













/* harmony default export */ var updateCarInfo = ({
  data: function data() {
    return {
      iconType: "",
      title: "更改车辆",
      title1: '提示操作',
      show_1: false,
      pkCode: "", //车位编号
      carNo: "", //车牌号码
      carName: "", //车主姓名
      carBrand: "", //车辆品牌
      carModel: "", //车辆型号
      carColor: "", //车身颜色
      carPhone: '', //绑定手机
      comnCode: '', pkId: '',
      showprompt: false,
      prompt: '',
      carId: '',
      phone: '',
      openid: '',
      show: false,
      disableBtn: false
    };
  },

  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Group: group["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    XHeader: vux_src_components_x_header,
    XInput: x_input["a" /* default */],
    XButton: vux_src_components_x_button,
    FlexboxItem: flexbox_item["a" /* default */],
    loadPage: src_components_loadingPage,
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm
  },
  methods: {
    onBlur: function onBlur(val) {
      console.log("on blur", val);
    },
    validateCarNo: function validateCarNo() {
      var carStr = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/;
      var carNos = this.carNo;
      console.log(carNos);
      var carNoNumber = carStr.test(carNos);
      if (carStr.test(carNos)) {
        this.showprompt = false;
        this.disableBtn = false;
        return true;
      } else {
        this.showprompt = true;
        this.prompt = '请输入正确的车牌号码';
        this.disableBtn = true;
        return false;
      }
    },
    changeCarInfo: function changeCarInfo() {
      var carStr = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/;
      var carNos = this.carNo;
      console.log(carNos);
      var carNoNumber = carStr.test(carNos);
      if (carStr.test(carNos)) {
        this.disableBtn = false;
        return true;
      } else {
        this.disableBtn = true;
        return false;
      }
    },
    updateCar: function updateCar() {
      if (!this.validateCarNo()) {
        return;
      }
      var omeinfo = new Object();
      omeinfo.pkCode = this.pkCode;
      omeinfo.carNo = this.carNo;
      omeinfo.carName = this.carName;
      omeinfo.carBrand = this.carBrand;
      omeinfo.carModel = this.carModel;
      omeinfo.carColor = this.carColor;
      omeinfo.carPhone = this.$router.history.current.query.phone;
      omeinfo.comnCode = this.$router.history.current.query.comnCode;
      omeinfo.pkId = this.$router.history.current.query.pkId;
      omeinfo.openid = this.$router.history.current.query.openid;
      omeinfo.carId = this.carId;

      this.show_1 = true;
      var url1 = global.host + 'carInfo/updateCarInfo';
      this.$http.post(url1, omeinfo).then(function (res) {
        var stateCode = res.body.statusCode;
        if (stateCode == "110") {
          this.$router.push({ path: "/myCarInfo", query: { phone: omeinfo.carPhone, comnCode: omeinfo.comnCode, pkId: omeinfo.pkId, pkCode: omeinfo.pkCode, openid: omeinfo.openid } });
        } else if (stateCode == "120") {
          this.showprompt = true;
          this.prompt = "更改失败,请重试！";
        }

        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },
    deleteCarInfo: function deleteCarInfo(carId) {
      //删除绑定的车量信息

      var omeinfo = new Object();
      omeinfo.pkCode = this.pkCode;
      omeinfo.carNo = this.carNo;
      omeinfo.carName = this.carName;
      omeinfo.carBrand = this.carBrand;
      omeinfo.carModel = this.carModel;
      omeinfo.carColor = this.carColor;
      omeinfo.carPhone = this.$router.history.current.query.phone;
      omeinfo.comnCode = this.$router.history.current.query.comnCode;
      omeinfo.pkId = this.$router.history.current.query.pkId;
      omeinfo.openid = this.$router.history.current.query.openid;
      omeinfo.carId = this.carId;
      var delUrl = global.host + 'carInfo/deleteCarInfo?carId=' + carId + '&phone=' + this.phone + '&pkCode=' + this.$router.history.current.query.pkCode;;
      console.log(delUrl);
      var this_ = this;
      this.$http.get(delUrl).then(function (res) {
        if (res.body.statusCode == '110') {
          this.$router.push({ path: "/myCarInfo", query: { phone: omeinfo.carPhone, comnCode: omeinfo.comnCode, pkId: omeinfo.pkId, pkCode: omeinfo.pkCode, openid: omeinfo.openid } });
          return true;
        } else {
          this.showprompt = true;
          this.prompt = "删除失败,请重试！";
        }
      });
    }
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/updateCarInfo") {
      document.title = "更改车辆";
    }
    this.carPhone = this.$router.history.current.query.phone;
    this.carId = this.$router.history.current.query.carId;
    this.pkCode = this.$router.history.current.query.pkCode;
    this.phone = this.$router.history.current.query.phone;
    this.carNo = this.$router.history.current.query.carNo;
    this.carName = this.$router.history.current.query.carName;
    this.carBrand = this.$router.history.current.query.carBrand;
    this.carModel = this.$router.history.current.query.carModel;
    this.carColor = this.$router.history.current.query.carColor;
    this.openid = this.$router.history.current.query.openid;
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/updateCarInfo.vue













/* harmony default export */ var carRentComponents_updateCarInfo = ({
  data: function data() {
    return {
      iconType: "",
      title: "更改车辆",
      title1: '提示操作',
      show_1: false,
      pkCode: "", //车位编号
      carNo: "", //车牌号码
      carName: "", //车主姓名
      carBrand: "", //车辆品牌
      carModel: "", //车辆型号
      carColor: "", //车身颜色
      carPhone: '', //绑定手机
      comnCode: '', pkId: '',
      showprompt: false,
      prompt: '',
      carId: '',
      phone: '',
      openid: '',
      show: false,
      disableBtn: false
    };
  },

  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Group: group["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    XHeader: vux_src_components_x_header,
    XInput: x_input["a" /* default */],
    XButton: vux_src_components_x_button,
    FlexboxItem: flexbox_item["a" /* default */],
    loadPage: src_components_loadingPage,
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm
  },
  methods: {
    onBlur: function onBlur(val) {
      console.log("on blur", val);
    },
    validateCarNo: function validateCarNo() {
      var carStr = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/;
      var carNos = this.carNo;
      console.log(carNos);
      var carNoNumber = carStr.test(carNos);
      if (carStr.test(carNos)) {
        this.showprompt = false;
        this.disableBtn = false;
        return true;
      } else {
        this.showprompt = true;
        this.prompt = '请输入正确的车牌号码';
        this.disableBtn = true;
        return false;
      }
    },
    changeCarInfo: function changeCarInfo() {
      var carStr = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/;
      var carNos = this.carNo;
      console.log(carNos);
      var carNoNumber = carStr.test(carNos);
      if (carStr.test(carNos)) {
        this.disableBtn = false;
        return true;
      } else {
        this.disableBtn = true;
        return false;
      }
    },
    updateCar: function updateCar() {
      if (!this.validateCarNo()) {
        return;
      }
      var omeinfo = new Object();
      omeinfo.pkCode = this.pkCode;
      omeinfo.carNo = this.carNo;
      omeinfo.carName = this.carName;
      omeinfo.carBrand = this.carBrand;
      omeinfo.carModel = this.carModel;
      omeinfo.carColor = this.carColor;
      omeinfo.carPhone = this.$router.history.current.query.phone;
      omeinfo.comnCode = this.$router.history.current.query.comnCode;
      omeinfo.pkId = this.$router.history.current.query.pkId;
      omeinfo.openid = this.$router.history.current.query.openid;
      omeinfo.carId = this.carId;

      this.show_1 = true;
      var url1 = global.host + 'carInfo/updateCarInfo';
      this.$http.post(url1, omeinfo).then(function (res) {
        var stateCode = res.body.statusCode;
        if (stateCode == "110") {
          this.$router.push({ path: "/myCarInfo", query: { phone: omeinfo.carPhone, comnCode: omeinfo.comnCode, pkId: omeinfo.pkId, pkCode: omeinfo.pkCode, openid: omeinfo.openid } });
        } else if (stateCode == "120") {
          this.showprompt = true;
          this.prompt = "更改失败,请重试！";
        }

        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },
    deleteCarInfo: function deleteCarInfo(carId) {
      //删除绑定的车量信息

      var omeinfo = new Object();
      omeinfo.pkCode = this.pkCode;
      omeinfo.carNo = this.carNo;
      omeinfo.carName = this.carName;
      omeinfo.carBrand = this.carBrand;
      omeinfo.carModel = this.carModel;
      omeinfo.carColor = this.carColor;
      omeinfo.carPhone = this.$router.history.current.query.phone;
      omeinfo.comnCode = this.$router.history.current.query.comnCode;
      omeinfo.pkId = this.$router.history.current.query.pkId;
      omeinfo.openid = this.$router.history.current.query.openid;
      omeinfo.carId = this.carId;
      var delUrl = global.host + 'carInfo/deleteCarInfo?carId=' + carId + '&phone=' + this.phone + '&pkCode=' + this.$router.history.current.query.pkCode;;
      console.log(delUrl);
      var this_ = this;
      this.$http.get(delUrl).then(function (res) {
        if (res.body.statusCode == '110') {
          this.$router.push({ path: "/myCarInfo", query: { phone: omeinfo.carPhone, comnCode: omeinfo.comnCode, pkId: omeinfo.pkId, pkCode: omeinfo.pkCode, openid: omeinfo.openid } });
          return true;
        } else {
          this.showprompt = true;
          this.prompt = "删除失败,请重试！";
        }
      });
    }
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/updateCarInfo") {
      document.title = "更改车辆";
    }
    this.carPhone = this.$router.history.current.query.phone;
    this.carId = this.$router.history.current.query.carId;
    this.pkCode = this.$router.history.current.query.pkCode;
    this.phone = this.$router.history.current.query.phone;
    this.carNo = this.$router.history.current.query.carNo;
    this.carName = this.$router.history.current.query.carName;
    this.carBrand = this.$router.history.current.query.carBrand;
    this.carModel = this.$router.history.current.query.carModel;
    this.carColor = this.$router.history.current.query.carColor;
    this.openid = this.$router.history.current.query.openid;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ac65c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carRentComponents/updateCarInfo.vue
var updateCarInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addBox"},[_c('group',{attrs:{"title":""}},[_c('x-input',{attrs:{"title":"车位编号:","placeholder":"车位编号","disabled":"","text-align":"right"},model:{value:(_vm.pkCode),callback:function ($$v) {_vm.pkCode=$$v},expression:"pkCode"}})],1),_vm._v(" "),_c('group',{attrs:{"title":""}},[_c('x-input',{attrs:{"title":"车牌号码:","required":"","placeholder":"请输入车牌号码","text-align":"right"},on:{"on-change":_vm.changeCarInfo,"on-blur":_vm.validateCarNo},model:{value:(_vm.carNo),callback:function ($$v) {_vm.carNo=$$v},expression:"carNo"}})],1),_vm._v(" "),_c('group',{attrs:{"title":""}},[_c('x-input',{attrs:{"title":"车主姓名:","name":"","required":"","placeholder":"请输入车主姓名","text-align":"right"},model:{value:(_vm.carName),callback:function ($$v) {_vm.carName=$$v},expression:"carName"}})],1),_vm._v(" "),_c('group',{attrs:{"title":""}},[_c('x-input',{attrs:{"title":"车辆品牌:","placeholder":"请输入车辆品牌","text-align":"right"},model:{value:(_vm.carBrand),callback:function ($$v) {_vm.carBrand=$$v},expression:"carBrand"}})],1),_vm._v(" "),_c('group',{attrs:{"title":""}},[_c('x-input',{attrs:{"title":"车辆型号:","placeholder":"请输入车辆型号","text-align":"right"},model:{value:(_vm.carModel),callback:function ($$v) {_vm.carModel=$$v},expression:"carModel"}})],1),_vm._v(" "),_c('group',{attrs:{"title":""}},[_c('x-input',{attrs:{"title":"车身颜色:","placeholder":"请输入车身颜色","text-align":"right"},model:{value:(_vm.carColor),callback:function ($$v) {_vm.carColor=$$v},expression:"carColor"}})],1),_vm._v(" "),_c('flexbox',{attrs:{"orient":"horizontal"}},[_c('flexbox-item',{staticStyle:{"display":"flex","align-items":"center"}},[_c('x-button',{staticClass:"addInfo",attrs:{"disabled":_vm.disableBtn,"type":"primary"},nativeOn:{"click":function($event){return _vm.updateCar($event)}}},[_vm._v("更改")])],1),_vm._v(" "),_c('flexbox-item',{staticStyle:{"display":"flex","align-items":"center"}},[_c('x-button',{staticClass:"addInfo",attrs:{"type":"warn"},nativeOn:{"click":function($event){_vm.deleteCarInfo(_vm.carId)}}},[_vm._v("删除")])],1)],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}}),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.showprompt),callback:function ($$v) {_vm.showprompt=$$v},expression:"showprompt"}},[_vm._v(_vm._s(_vm.prompt))])],1)],1)}
var updateCarInfo_staticRenderFns = []
var updateCarInfo_esExports = { render: updateCarInfo_render, staticRenderFns: updateCarInfo_staticRenderFns }
/* harmony default export */ var components_carRentComponents_updateCarInfo = (updateCarInfo_esExports);
// CONCATENATED MODULE: ./src/components/carRentComponents/updateCarInfo.vue
function updateCarInfo_injectStyle (ssrContext) {
  __webpack_require__("kZeC")
}
var updateCarInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var updateCarInfo___vue_template_functional__ = false
/* styles */
var updateCarInfo___vue_styles__ = updateCarInfo_injectStyle
/* scopeId */
var updateCarInfo___vue_scopeId__ = "data-v-55ac65c0"
/* moduleIdentifier (server only) */
var updateCarInfo___vue_module_identifier__ = null
var updateCarInfo_Component = updateCarInfo_normalizeComponent(
  carRentComponents_updateCarInfo,
  components_carRentComponents_updateCarInfo,
  updateCarInfo___vue_template_functional__,
  updateCarInfo___vue_styles__,
  updateCarInfo___vue_scopeId__,
  updateCarInfo___vue_module_identifier__
)

/* harmony default export */ var src_components_carRentComponents_updateCarInfo = (updateCarInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/myCarInfoList.vue














/* harmony default export */ var myCarInfoList = ({
  data: function data() {
    var _ref;

    return _ref = {
      pkCode: '', //车位编号
      pkRegion: '', //区域
      pkArea: '', //面积
      pkFloor: '', //楼层
      pkOwner: '', //权属类型
      pkUsed: '', //使用性质
      iconType: "",
      title: "我的车位",
      nums: '1',
      show_1: false,
      phone: "",
      comnCode: '',
      hies: false,
      carId: '',
      index: ''
    }, defineProperty_default()(_ref, 'phone', ''), defineProperty_default()(_ref, 'show_3', true), defineProperty_default()(_ref, 'showprompt', false), defineProperty_default()(_ref, 'prompt', ''), defineProperty_default()(_ref, 'openid', ''), defineProperty_default()(_ref, 'pkDate', ''), _ref;
  },

  components: {
    XHeader: vux_src_components_x_header,
    XTable: vux_src_components_x_table,
    Alert: components_alert["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    Group: group["a" /* default */],
    loadPage: src_components_loadingPage,
    XButton: vux_src_components_x_button
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/myCarInfoList") {
      document.title = "我的车位";
    }
    this.phone = this.$router.history.current.query.phone;
    this.pkCode = this.$router.history.current.query.pkCode;
    this.carId = this.$router.history.current.query.carId;
    this.pkId = this.$router.history.current.query.pkId;
    this.comnCode = this.$router.history.current.query.comnCode;
    var url1 = global.host + 'parkinginfo/getByPkId?comnCode=' + this.comnCode + '&pkId=' + this.pkId;
    this.$http.get(url1).then(function (res) {
      if (res.body.result.length == 0) {
        this.showprompt = true;
        this.prompt = "暂无数据！";
      }
      console.log(res.body.result);
      console.log('#########');
      var parkObj = res.body.result;
      this.pkArea = parkObj.pkArea + '㎡';
      this.pkFloor = parkObj.pkFloor;
      if (parkObj.pkUsed === '1') {
        this.pkUsed = "购买";
      } else if (parkObj.pkUsed === '2') {
        this.pkUsed = "租赁";
      } else {
        this.pkUsed = parkObj.pkUsed;
      }
      this.pkRegion = parkObj.pkRegion;
      this.pkDate = parkObj.endDate;
      if (parkObj.pkOwner === '1') {
        this.pkOwner = "公共车位";
      } else if (parkObj.pkOwner === '2') {
        this.pkOwner = "产权车位";
      } else if (parkObj.pkOwner === '3') {
        this.pkOwner = "人防车位";
      } else {
        this.pkOwner = parkObj.pkOwner;
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/myCarInfoList.vue














/* harmony default export */ var carRentComponents_myCarInfoList = ({
  data: function data() {
    var _ref;

    return _ref = {
      pkCode: '', //车位编号
      pkRegion: '', //区域
      pkArea: '', //面积
      pkFloor: '', //楼层
      pkOwner: '', //权属类型
      pkUsed: '', //使用性质
      iconType: "",
      title: "我的车位",
      nums: '1',
      show_1: false,
      phone: "",
      comnCode: '',
      hies: false,
      carId: '',
      index: ''
    }, defineProperty_default()(_ref, 'phone', ''), defineProperty_default()(_ref, 'show_3', true), defineProperty_default()(_ref, 'showprompt', false), defineProperty_default()(_ref, 'prompt', ''), defineProperty_default()(_ref, 'openid', ''), defineProperty_default()(_ref, 'pkDate', ''), _ref;
  },

  components: {
    XHeader: vux_src_components_x_header,
    XTable: vux_src_components_x_table,
    Alert: components_alert["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    Group: group["a" /* default */],
    loadPage: src_components_loadingPage,
    XButton: vux_src_components_x_button
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    if (this.$router.history.current.path == "/myCarInfoList") {
      document.title = "我的车位";
    }
    this.phone = this.$router.history.current.query.phone;
    this.pkCode = this.$router.history.current.query.pkCode;
    this.carId = this.$router.history.current.query.carId;
    this.pkId = this.$router.history.current.query.pkId;
    this.comnCode = this.$router.history.current.query.comnCode;
    var url1 = global.host + 'parkinginfo/getByPkId?comnCode=' + this.comnCode + '&pkId=' + this.pkId;
    this.$http.get(url1).then(function (res) {
      if (res.body.result.length == 0) {
        this.showprompt = true;
        this.prompt = "暂无数据！";
      }
      console.log(res.body.result);
      console.log('#########');
      var parkObj = res.body.result;
      this.pkArea = parkObj.pkArea + '㎡';
      this.pkFloor = parkObj.pkFloor;
      if (parkObj.pkUsed === '1') {
        this.pkUsed = "购买";
      } else if (parkObj.pkUsed === '2') {
        this.pkUsed = "租赁";
      } else {
        this.pkUsed = parkObj.pkUsed;
      }
      this.pkRegion = parkObj.pkRegion;
      this.pkDate = parkObj.endDate;
      if (parkObj.pkOwner === '1') {
        this.pkOwner = "公共车位";
      } else if (parkObj.pkOwner === '2') {
        this.pkOwner = "产权车位";
      } else if (parkObj.pkOwner === '3') {
        this.pkOwner = "人防车位";
      } else {
        this.pkOwner = parkObj.pkOwner;
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d984ebd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carRentComponents/myCarInfoList.vue
var myCarInfoList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carInfoList"},[_c('group',{staticClass:"style_mg",attrs:{"title":""}},[_c('x-input',{attrs:{"title":"车位编号","disabled":"","text-align":"right"},model:{value:(_vm.pkCode),callback:function ($$v) {_vm.pkCode=$$v},expression:"pkCode"}})],1),_vm._v(" "),_c('group',{staticClass:"style_mg",attrs:{"title":""}},[_c('x-input',{attrs:{"title":"区域","disabled":"","text-align":"right"},model:{value:(_vm.pkRegion),callback:function ($$v) {_vm.pkRegion=$$v},expression:"pkRegion"}})],1),_vm._v(" "),_c('group',{staticClass:"style_mg",attrs:{"title":""}},[_c('x-input',{attrs:{"title":"面积","disabled":"","text-align":"right"},model:{value:(_vm.pkArea),callback:function ($$v) {_vm.pkArea=$$v},expression:"pkArea"}})],1),_vm._v(" "),_c('group',{staticClass:"style_mg",attrs:{"title":""}},[_c('x-input',{attrs:{"title":"楼层","disabled":"","text-align":"right"},model:{value:(_vm.pkFloor),callback:function ($$v) {_vm.pkFloor=$$v},expression:"pkFloor"}})],1),_vm._v(" "),_c('group',{staticClass:"style_mg",attrs:{"title":""}},[_c('x-input',{attrs:{"title":"权属类型","disabled":"","text-align":"right"},model:{value:(_vm.pkOwner),callback:function ($$v) {_vm.pkOwner=$$v},expression:"pkOwner"}})],1),_vm._v(" "),_c('group',{staticClass:"style_mg",attrs:{"title":""}},[_c('x-input',{attrs:{"title":"使用性质","disabled":"","text-align":"right"},model:{value:(_vm.pkUsed),callback:function ($$v) {_vm.pkUsed=$$v},expression:"pkUsed"}})],1),_vm._v(" "),_c('group',{staticClass:"style_mg",attrs:{"title":""}},[_c('x-input',{attrs:{"title":"到期时间","disabled":"","text-align":"right"},model:{value:(_vm.pkDate),callback:function ($$v) {_vm.pkDate=$$v},expression:"pkDate"}})],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}}),_vm._v(" "),_c('group',{staticStyle:{"magin":"10px auto","text-align":"center"}},[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.showprompt),callback:function ($$v) {_vm.showprompt=$$v},expression:"showprompt"}},[_vm._v(_vm._s(_vm.prompt))])],1)],1)}
var myCarInfoList_staticRenderFns = []
var myCarInfoList_esExports = { render: myCarInfoList_render, staticRenderFns: myCarInfoList_staticRenderFns }
/* harmony default export */ var components_carRentComponents_myCarInfoList = (myCarInfoList_esExports);
// CONCATENATED MODULE: ./src/components/carRentComponents/myCarInfoList.vue
function myCarInfoList_injectStyle (ssrContext) {
  __webpack_require__("tn/N")
}
var myCarInfoList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myCarInfoList___vue_template_functional__ = false
/* styles */
var myCarInfoList___vue_styles__ = myCarInfoList_injectStyle
/* scopeId */
var myCarInfoList___vue_scopeId__ = "data-v-d984ebd6"
/* moduleIdentifier (server only) */
var myCarInfoList___vue_module_identifier__ = null
var myCarInfoList_Component = myCarInfoList_normalizeComponent(
  carRentComponents_myCarInfoList,
  components_carRentComponents_myCarInfoList,
  myCarInfoList___vue_template_functional__,
  myCarInfoList___vue_styles__,
  myCarInfoList___vue_scopeId__,
  myCarInfoList___vue_module_identifier__
)

/* harmony default export */ var src_components_carRentComponents_myCarInfoList = (myCarInfoList_Component.exports);

// EXTERNAL MODULE: ./static/css/style.css
var css_style = __webpack_require__("rqsT");
var css_style_default = /*#__PURE__*/__webpack_require__.n(css_style);

// EXTERNAL MODULE: ./static/css/iconfont.css
var iconfont = __webpack_require__("XlLT");
var iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/set.js
var set = __webpack_require__("lHA8");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/from.js
var from = __webpack_require__("c/Tr");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/carPaycoment.vue




















/* harmony default export */ var carPaycoment = ({

  components: {
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage,
    $: jquery_default.a,
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      classLi: 'am_ulistLiFS',
      show_5: false, // 如果有车位信息 就是false 没有 就是true
      cont: true, // 主界面
      PLSJfs: '一个月',
      title1: '车位缴费', //缴费名称
      jfYs: [['1个月', '2个月', '3个月', '4个月', '5个月', '6个月', '7个月', '8个月', '9个月', '10个月', '11个月', '12个月', '13个月', '14个月', '15个月', '16个月', '17个月', '18个月', '19个月', '20个月', '21个月', '22个月', '23个月', '24个月']],
      value_1: [], // 车位信息集合
      value_Q: [],
      list_1: [[]], // 车位信息
      valueTime: '2012/12/12', //续费至时间
      endDates: '',
      myDilogs: '',
      nextEndDates: '', // 续费至 年 + 月 + 日
      selectDate: [[], [], []], //初始化时间选择
      phone: '', //电话
      mycarList: [], //绑定车辆集合
      mycarListInfo: [], //缴费明细集合
      myTime: [], // 缴费月份集合 1-3-12-6+1-12+1
      baseRate: '', //基础量
      dailogMessage: '',
      comnCode: '',
      submitable: false,
      mousth: '',
      show: false,
      comnList: '',
      showLog: false,
      mssl: [], // 车牌号集合 页面初始化
      msrue1: false,
      msrue: false,
      feeShow: false,
      show_1: false,
      feeBillList: [],

      sMonth: '',
      sQx: '',
      pkUs: '',
      feeMoey: '',
      sDate: '', // 到期时间
      qsType: '', // 权属类型
      useXz: '', // 车位使用性质 1购买 2租赁
      sumMoney: '', // 车位单价
      totalFeeMoney: '0.0',
      prevValueTime: '',

      pkId: '', // 车位主键
      disTypes: '', // 优惠赠送字段 业务上没什么用
      billCode: '',
      dayms: '',
      mVals: '',
      qYleix: '',
      qYq: '',
      youH: '', // 优惠金额
      shiS: '', // 实收金额
      riQYF: '',
      jlJf: '', // 下拉选择缴费月份的值
      yhYFF: '',
      mousss: [],
      dateJy: '',
      oneName: ""
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    setTimeout(function () {
      this.show_1 = false;
    }, 1000);
    this.getInitSelectDate();

    var url2 = global.host + 'discountConfig/getListByPark?comnCode=' + this.$router.history.current.query.comnCode;
    this.$http.get(url2).then(function (res) {
      this.show_1 = false;
      var tiems = res.body.result;
      this.myTime = new Object();
      for (var jm in tiems) {
        this.myTime[jm] = tiems[jm];
      }
      this.loadAjax();
      console.log(this.myTime);
      try {
        this.disTypes = this.myTime[0].discType;
      } catch (e) {}

      this.show_1 = false;
    }, function (err) {
      this.show_1 = false;
      console.log(err);
    });
  },
  mounted: function mounted() {

    if (this.$router.history.current.path == '/carPaycoment') {
      document.title = "车辆缴费";
    }

    jquery_default()(".am_font1").parent(".weui-dialog__bd").css({ "padding-left": "0.1em", "padding-right": "0.1em" });

    jquery_default()(".am_ulist").delegate("li", "click", function () {
      jquery_default()(this).find("button").addClass("am_persfors");
      jquery_default()(this).siblings("li").find("button").removeClass("am_persfors");
    });
    this.msrue = true;
    this.msrue1 = false;
  },

  methods: {
    onZDY: function onZDY() {
      if (this.$refs.val_jf.currentValue[0].length == '4') {
        this.jlJf = this.$refs.val_jf.currentValue[0].substr(0, 2);
      } else {
        this.jlJf = this.$refs.val_jf.currentValue[0].substr(0, 1);
      }
      this.setPayTime(this.jlJf, 0);

      jquery_default()(".am_ulist").find("button").removeClass("am_persfors");
    },
    loadAjax: function loadAjax() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var url1;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url1 = global.host + 'parkinginfo/queryParkInfo?phone=' + _this.$router.history.current.query.phone + '&comnCode=' + _this.$router.history.current.query.comnCode;
                _context.next = 3;
                return _this.$http.get(url1).then(function (res) {
                  console.log('所有信息');
                  console.log(res);
                  var reslt = res.body.result;
                  if (reslt.length == 0) {

                    this.show_5 = true;
                    this.cont = false;
                  } else if (reslt.length != 0) {

                    this.show_5 = false;
                    this.cont = true;
                  }
                  var slit = [];
                  var mdata = "";
                  this.comnList = res.body.result;
                  if (res.status == 200) {
                    for (var i = 0; i < reslt.length; i++) {
                      this.list_1[0].push(reslt[i].park.parkingInfo.pkCode);
                      this.value_1[0] = this.list_1[0][0];
                    }
                    this.onChange(this.list_1[0][0]);

                    for (var its in reslt) {
                      try {
                        for (var mitem in reslt[its].car) {
                          mdata = reslt[its].car[mitem].pkCode;
                          this.mssl.push(reslt[its].car[0].carNo);
                        }
                      } catch (e) {
                        console.error("未找到车辆信息");
                      }

                      for (var bm in reslt[its].park) {
                        this.endDates = reslt[its].park.parkingInfo.endDate;
                        if (!this.endDates) {
                          this.dailogMessage = '该车位尚未缴纳过费用，请前往物业处确认开始缴费时间!';
                          this.feeShow = true;
                        }
                        try {
                          this.dateJy = this.dateAdd(this.endDates);
                          var mdate = this.endDates.split("-");
                          this.dayms = parseInt(mdate[2]);

                          if (this.dayms < 10) {
                            this.dayms = '0' + this.dayms;
                          }

                          var defaultCount = this.myTime[0].baseRate;
                          var yyh = this.myTime[0].defaultRate;

                          this.valueTime = this.subMonths(this.endDates, defaultCount);

                          this.nextEndDates = this.valueTime + "-" + this.dayms;
                          this.setPayTime(defaultCount, yyh);
                          jquery_default()(".am_ulist > li:eq(0)").find("button").addClass("am_persfors");
                        } catch (e) {
                          console.error('$$$$$$$$$$$$$$$$$$$$$$$$');
                          console.error(e);
                        }

                        if (this.list_1[0][0] == mdata) {
                          // 如果车位只有一个
                          this.sDate = reslt[its].park.parkingInfo.endDate;
                          this.qsType = reslt[its].park.feeItem.feeName;
                          this.qYleix = reslt[its].park.parkingInfo.pkFloor;
                          this.useXz = reslt[its].park.parkingInfo.pkUsed;
                          this.sumMoney = reslt[its].park.feeRate;
                          this.pkId = reslt[its].park.parkingInfo.pkId;
                        }
                      }
                    }

                    var ms = from_default()(new set_default.a(this.list_1[0]));
                    this.list_1[0] = ms;
                    this.value_1[0] = this.list_1[0][0];
                    this.onChange(this.list_1[0][0]);

                    this.sMonth = Object(date_format["a" /* default */])(new Date(this.sDate), 'YYYY-MM');
                    this.sQx = this.qsType;
                    this.qYq = this.qYleix;
                    this.feeMoey = this.sumMoney + "元/月";
                    this.pkUs = this.useXz;
                  }
                }, function (err) {
                  console.log(err);
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    mload: function mload() {
      this.nextEndDates = this.valueTime + "-" + this.dayms;
    },
    onChange: function onChange(index) {
      this.mycarList = [];
      this.sDate = '';
      this.endDates = '';
      this.dateJy = '';
      var carCode = "";
      for (var ns in this.comnList) {
        // 遍历一个车位里的所有车辆
        for (var bs in this.comnList[ns].car) {
          // // 遍历一个车位里的所有车辆 的car项
          carCode = this.comnList[ns].car[bs].pkCode;
          if (index == carCode) {
            try {
              var carNos = this.comnList[ns].car[bs].carNo;
              this.mycarList.push(carNos);
            } catch (e) {
              console.error("未找到车辆信息");
            }
          }
        }
        this.mycarList = from_default()(new set_default.a(this.mycarList));
        if (index == carCode) {
          this.sDate = this.comnList[ns].park.parkingInfo.endDate;
          if (!this.sDate) {
            this.dailogMessage = '该车位尚未缴纳过费用，请前往物业处确认开始缴费时间!';
            this.feeShow = true;
          }
          this.qsType = this.comnList[ns].park.feeItem.feeName;
          this.qYleix = this.comnList[ns].park.parkingInfo.pkFloor;
          var pkOwner = this.comnList[ns].park.parkingInfo.pkOwner;
          var pkUsed = this.comnList[ns].park.parkingInfo.pkUsed,
              useXz = void 0;
          if (pkOwner == "公共车位") {
            if (pkUsed == "0") {
              useXz = "已租赁";
            } else {
              useXz = "未租赁";
            }
          } else {
            if (pkUsed == "0") {
              useXz = "已出售";
            } else {
              useXz = "未出售";
            }
          }
          this.useXz = useXz;
          this.sumMoney = this.comnList[ns].park.feeRate;
          this.pkId = this.comnList[ns].park.parkingInfo.pkId;
        }
      }
      this.sMonth = Object(date_format["a" /* default */])(new Date(this.sDate), 'YYYY-MM');
      this.sQx = this.qsType;
      this.qYq = this.qYleix;
      this.feeMoey = this.sumMoney + "元/月";
      this.pkUs = this.useXz;
      this.endDates = this.sDate;
      this.valueTime = this.subMonths(this.endDates, '1');

      this.dateJy = this.dateAdd(this.endDates);

      this.setToday();
      this.setPayTime('1', '0');
      jquery_default()(".am_ulist").find("button").removeClass("am_persfors");
    },
    serchDetail: function serchDetail() {
      var url2 = global.host + 'parkinginfo/getParkTopic' + '?comnCode=' + this.$router.history.current.query.comnCode;
      this.$http.get(url2).then(function (res) {
        this.mycarListInfo = res.body.result;
      }, function (err) {
        console.log(err);
      });

      this.showLog = true;
    },
    cancel: function cancel() {
      this.submitable = false;
    },
    getMonths: function getMonths(date1, date2) {

      date1 = date1.split("-");
      date2 = date2.split("-");

      var year1 = parseInt(date1[0]),
          month1 = parseInt(date1[1]),
          year2 = parseInt(date2[0]),
          month2 = parseInt(date2[1]),
          months = (year2 - year1) * 12 + (month2 - month1);

      this.mousth = months + '个月';
      return months;
    },
    subMonths: function subMonths(date, addMonth) {

      /*let s = $(".vux-datetime").find(".vux-cell-value").text(this.mVals)
      console.log(s)*/
      addMonth = parseInt(addMonth);

      date = date.split("-");

      var year = parseInt(date[0]);
      var month = parseInt(date[1]);
      var riQ = parseInt(date[2]);
      var sumMonth = parseInt(month + addMonth);
      if (sumMonth % 12 == 0) {
        var chushu = sumMonth / 12 - 1;
        year = year + chushu;
        month = sumMonth - 12 * chushu;
      } else if (sumMonth > 12) {
        var chushu = Math.floor(sumMonth / 12);
        year = year + chushu;
        month = sumMonth - 12 * chushu;
      } else {
        month = sumMonth;
      }
      if (riQ == 1) {
        // 如果当前是1号
        var dateYar = this.getCurrentMonthLast(year + "-" + (month - 1));

        this.riQYF = dateYar.substring(dateYar.length - 2);
        if (month < 10) {
          month = "0" + month;
        }
        if (this.riQYF < 10) {
          this.riQYF = "0" + this.riQYF;
        }
        var dates = year + "-" + (parseInt(month) - 1) + '-' + this.riQYF;
        return this.dateAdd(dates);
      } else if (riQ != 1) {
        this.riQYF = riQ;
        if (month < 10) {
          month = "0" + month;
        }
        if (this.riQYF < 10) {
          this.riQYF = "0" + this.riQYF;
        }

        var dates = year + "-" + month + '-' + (this.riQYF - 1);;
        return this.dateAdd(dates);
      }
    },
    setPayTime: function setPayTime(time, defaultRate) {
      this.mousss = time + '个月';

      var timeNum = parseInt(time);
      this.feeBillList = [];
      for (var i = 1; i <= timeNum; i++) {
        var feeObj = new Object();
        feeObj.month = this.subMonths(this.endDates, i);
        this.feeBillList.push(feeObj);
        this.valueTime = feeObj.month;
      }
      this.nextEndDates = this.valueTime + "-" + this.dayms;
      if (defaultRate == '0') {
        // 如果优惠月份等于0的话
        this.yhYFF = '0';
        this.totalFeeMoney = (this.sumMoney * timeNum).toFixed(2) + '元';
        this.youH = '00.00元';
        this.shiS = this.totalFeeMoney;
      } else if (defaultRate != '0') {
        this.yhYFF = defaultRate;
        this.totalFeeMoney = (this.sumMoney * timeNum).toFixed(2) + '元';
        var danJia = this.sumMoney;
        var youHys = defaultRate;
        this.youH = (this.sumMoney * defaultRate).toFixed(2) + '元';
        var aa = (this.sumMoney * timeNum).toFixed(2);
        var bb = (danJia * youHys).toFixed(2);
        this.shiS = (aa - bb).toFixed(2) + '元';
      }
    },
    setToday: function setToday() {
      var months = this.getMonths(this.endDates, this.valueTime);
    },

    /*chanVal(){
    $(".vux-datetime").find(".vux-cell-value").text(this.valueTime);
    },*/
    /*初始化时间选择*/
    getInitSelectDate: function getInitSelectDate() {
      var date = new Date();
      date = new Date(date.getFullYear(), date.getMonth() + 1, date.getDate(), 1);
      this.selectDate[0].push(date.getFullYear());
      this.selectDate[0].push(date.getFullYear() + 1);
      var curM = date.getMonth() + 1;
      this.selectDate[1] = new Array();
      for (var i = curM; i < 13; i++) {
        this.selectDate[1].push(i);
      }

      var curD = date.getDate();
      this.selectDate[2] = new Array();
      for (var n = curD; n < 31; n++) {
        this.selectDate[2].push(n);
      }
    },
    getCurrentMonthLast: function getCurrentMonthLast(date) {
      var endDate = new Date(date);
      var month = endDate.getMonth();
      var nextMonth = ++month;
      var nextMonthFirstDay = new Date(endDate.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var dateString = new Date(nextMonthFirstDay - oneDay);
      return dateString.toLocaleDateString();
    },
    dateAdd: function dateAdd(startDate) {
      startDate = new Date(startDate);
      startDate = +startDate + 1000 * 60 * 60 * 24;
      startDate = new Date(startDate);
      var nextStartDate = startDate.getFullYear() + "-" + (startDate.getMonth() + 1) + "-" + startDate.getDate();
      var daww = nextStartDate.split('-');
      var mouth = daww[1];
      var darr = daww[2];
      if (darr < 10) {
        darr = '0' + darr;
      }
      if (mouth < 10) {
        mouth = '0' + mouth;
      }
      var dateRTY = daww[0] + "-" + mouth + "-" + darr;
      return dateRTY;
    },
    submitBefore: function submitBefore(kId, feeBz, monthCout) {
      if (!this.endDates) {
        this.dailogMessage = '该车位尚未缴纳过费用，请前往物业处确认开始缴费时间!';
        this.feeShow = true;
        return;
      }
      if (monthCout.length == '4') {
        monthCout = monthCout.substr(0, 2);
      } else {
        monthCout = monthCout.substr(0, 1);
      }

      var yzUrl = global.host + 'parkFeeBill/findownerunpaidorder?phoneNo=' + this.$router.history.current.query.phone + '&comnCode=' + this.$router.history.current.query.comnCode + '&openid=' + this.$router.history.current.query.openid;
      this.$http.get(yzUrl).then(function (res) {
        if (res.body.code == '110') {

          var usinfo = new Object();

          usinfo.comnCode = this.$router.history.current.query.comnCode;
          usinfo.startDate = this.dateJy;
          usinfo.endDate = this.valueTime;
          usinfo.pkId = kId;
          usinfo.feePrice = feeBz;
          usinfo.feeCount = monthCout;
          usinfo.discType = this.disTypes;
          usinfo.feeMoney = this.totalFeeMoney.split('元')[0];
          usinfo.freeMonth = this.yhYFF;
          usinfo.discMoney = this.youH.split('元')[0];
          if (this.youH == '00.00元') {
            usinfo.realMoney = this.totalFeeMoney.split('元')[0];
          } else {
            usinfo.realMoney = this.shiS.split('元')[0];
          }
          usinfo.startDate = this.endDates;
          usinfo.openId = this.$router.history.current.query.openid;
          usinfo.mainPhone = this.$router.history.current.query.phone;

          var urls = global.host + 'parkFeeBill/addParkFeeBill';
          this.$http.post(urls, usinfo).then(function (res) {
            var statuCodes = res.body.statusCode;

            if (statuCodes == '110') {
              this.billCode = res.body.result.billCode;
              this.gopay();
            } else if (statuCodes == '120') {
              this.feeShow = true;
              this.dailogMessage = "提交失败";
            }
          }, function (err) {
            console.log(err);
          });
        } else if (res.body.code == '120') {
          this.dailogMessage = '您有未处理的订单,请优先处理';
          this.feeShow = true;
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*去支付方法*/
    gopay: function gopay() {
      var senddata = new Object();
      senddata.comnCode = this.$router.history.current.query.comnCode;
      senddata.memberNo = this.$router.history.current.query.phone;
      senddata.openid = this.$router.history.current.query.openid;
      senddata.tradeAmount = this.shiS.split("元")[0];
      senddata.tradeNo = this.billCode;
      senddata.tradeName = '车位费';
      senddata.tradeDesc = '车位费';
      var url = global.host + 'parkFeeBill/getpayurl';
      this.$http.post(url, senddata).then(function (res) {
        if (res.body.code == '110') {
          location.href = res.body.payurl;
        } else {
          this.feeShow = true;
          this.dailogMessage = "支付异常,请稍候再试";
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*根据不同的操作进行操作*/
    refresh: function refresh() {
      if (this.dailogMessage == '您有未处理的订单,请优先处理') {
        this.submitable = true;
        this.$router.push({ path: '/paymentRecord', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/carPaycoment.vue




















/* harmony default export */ var carRentComponents_carPaycoment = ({

  components: {
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage,
    $: jquery_default.a,
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      classLi: 'am_ulistLiFS',
      show_5: false, // 如果有车位信息 就是false 没有 就是true
      cont: true, // 主界面
      PLSJfs: '一个月',
      title1: '车位缴费', //缴费名称
      jfYs: [['1个月', '2个月', '3个月', '4个月', '5个月', '6个月', '7个月', '8个月', '9个月', '10个月', '11个月', '12个月', '13个月', '14个月', '15个月', '16个月', '17个月', '18个月', '19个月', '20个月', '21个月', '22个月', '23个月', '24个月']],
      value_1: [], // 车位信息集合
      value_Q: [],
      list_1: [[]], // 车位信息
      valueTime: '2012/12/12', //续费至时间
      endDates: '',
      myDilogs: '',
      nextEndDates: '', // 续费至 年 + 月 + 日
      selectDate: [[], [], []], //初始化时间选择
      phone: '', //电话
      mycarList: [], //绑定车辆集合
      mycarListInfo: [], //缴费明细集合
      myTime: [], // 缴费月份集合 1-3-12-6+1-12+1
      baseRate: '', //基础量
      dailogMessage: '',
      comnCode: '',
      submitable: false,
      mousth: '',
      show: false,
      comnList: '',
      showLog: false,
      mssl: [], // 车牌号集合 页面初始化
      msrue1: false,
      msrue: false,
      feeShow: false,
      show_1: false,
      feeBillList: [],

      sMonth: '',
      sQx: '',
      pkUs: '',
      feeMoey: '',
      sDate: '', // 到期时间
      qsType: '', // 权属类型
      useXz: '', // 车位使用性质 1购买 2租赁
      sumMoney: '', // 车位单价
      totalFeeMoney: '0.0',
      prevValueTime: '',

      pkId: '', // 车位主键
      disTypes: '', // 优惠赠送字段 业务上没什么用
      billCode: '',
      dayms: '',
      mVals: '',
      qYleix: '',
      qYq: '',
      youH: '', // 优惠金额
      shiS: '', // 实收金额
      riQYF: '',
      jlJf: '', // 下拉选择缴费月份的值
      yhYFF: '',
      mousss: [],
      dateJy: '',
      oneName: ""
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    setTimeout(function () {
      this.show_1 = false;
    }, 1000);
    this.getInitSelectDate();

    var url2 = global.host + 'discountConfig/getListByPark?comnCode=' + this.$router.history.current.query.comnCode;
    this.$http.get(url2).then(function (res) {
      this.show_1 = false;
      var tiems = res.body.result;
      this.myTime = new Object();
      for (var jm in tiems) {
        this.myTime[jm] = tiems[jm];
      }
      this.loadAjax();
      console.log(this.myTime);
      try {
        this.disTypes = this.myTime[0].discType;
      } catch (e) {}

      this.show_1 = false;
    }, function (err) {
      this.show_1 = false;
      console.log(err);
    });
  },
  mounted: function mounted() {

    if (this.$router.history.current.path == '/carPaycoment') {
      document.title = "车辆缴费";
    }

    jquery_default()(".am_font1").parent(".weui-dialog__bd").css({ "padding-left": "0.1em", "padding-right": "0.1em" });

    jquery_default()(".am_ulist").delegate("li", "click", function () {
      jquery_default()(this).find("button").addClass("am_persfors");
      jquery_default()(this).siblings("li").find("button").removeClass("am_persfors");
    });
    this.msrue = true;
    this.msrue1 = false;
  },

  methods: {
    onZDY: function onZDY() {
      if (this.$refs.val_jf.currentValue[0].length == '4') {
        this.jlJf = this.$refs.val_jf.currentValue[0].substr(0, 2);
      } else {
        this.jlJf = this.$refs.val_jf.currentValue[0].substr(0, 1);
      }
      this.setPayTime(this.jlJf, 0);

      jquery_default()(".am_ulist").find("button").removeClass("am_persfors");
    },
    loadAjax: function loadAjax() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var url1;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url1 = global.host + 'parkinginfo/queryParkInfo?phone=' + _this.$router.history.current.query.phone + '&comnCode=' + _this.$router.history.current.query.comnCode;
                _context.next = 3;
                return _this.$http.get(url1).then(function (res) {
                  console.log('所有信息');
                  console.log(res);
                  var reslt = res.body.result;
                  if (reslt.length == 0) {

                    this.show_5 = true;
                    this.cont = false;
                  } else if (reslt.length != 0) {

                    this.show_5 = false;
                    this.cont = true;
                  }
                  var slit = [];
                  var mdata = "";
                  this.comnList = res.body.result;
                  if (res.status == 200) {
                    for (var i = 0; i < reslt.length; i++) {
                      this.list_1[0].push(reslt[i].park.parkingInfo.pkCode);
                      this.value_1[0] = this.list_1[0][0];
                    }
                    this.onChange(this.list_1[0][0]);

                    for (var its in reslt) {
                      try {
                        for (var mitem in reslt[its].car) {
                          mdata = reslt[its].car[mitem].pkCode;
                          this.mssl.push(reslt[its].car[0].carNo);
                        }
                      } catch (e) {
                        console.error("未找到车辆信息");
                      }

                      for (var bm in reslt[its].park) {
                        this.endDates = reslt[its].park.parkingInfo.endDate;
                        if (!this.endDates) {
                          this.dailogMessage = '该车位尚未缴纳过费用，请前往物业处确认开始缴费时间!';
                          this.feeShow = true;
                        }
                        try {
                          this.dateJy = this.dateAdd(this.endDates);
                          var mdate = this.endDates.split("-");
                          this.dayms = parseInt(mdate[2]);

                          if (this.dayms < 10) {
                            this.dayms = '0' + this.dayms;
                          }

                          var defaultCount = this.myTime[0].baseRate;
                          var yyh = this.myTime[0].defaultRate;

                          this.valueTime = this.subMonths(this.endDates, defaultCount);

                          this.nextEndDates = this.valueTime + "-" + this.dayms;
                          this.setPayTime(defaultCount, yyh);
                          jquery_default()(".am_ulist > li:eq(0)").find("button").addClass("am_persfors");
                        } catch (e) {
                          console.error('$$$$$$$$$$$$$$$$$$$$$$$$');
                          console.error(e);
                        }

                        if (this.list_1[0][0] == mdata) {
                          // 如果车位只有一个
                          this.sDate = reslt[its].park.parkingInfo.endDate;
                          this.qsType = reslt[its].park.feeItem.feeName;
                          this.qYleix = reslt[its].park.parkingInfo.pkFloor;
                          this.useXz = reslt[its].park.parkingInfo.pkUsed;
                          this.sumMoney = reslt[its].park.feeRate;
                          this.pkId = reslt[its].park.parkingInfo.pkId;
                        }
                      }
                    }

                    var ms = from_default()(new set_default.a(this.list_1[0]));
                    this.list_1[0] = ms;
                    this.value_1[0] = this.list_1[0][0];
                    this.onChange(this.list_1[0][0]);

                    this.sMonth = Object(date_format["a" /* default */])(new Date(this.sDate), 'YYYY-MM');
                    this.sQx = this.qsType;
                    this.qYq = this.qYleix;
                    this.feeMoey = this.sumMoney + "元/月";
                    this.pkUs = this.useXz;
                  }
                }, function (err) {
                  console.log(err);
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    mload: function mload() {
      this.nextEndDates = this.valueTime + "-" + this.dayms;
    },
    onChange: function onChange(index) {
      this.mycarList = [];
      this.sDate = '';
      this.endDates = '';
      this.dateJy = '';
      var carCode = "";
      for (var ns in this.comnList) {
        // 遍历一个车位里的所有车辆
        for (var bs in this.comnList[ns].car) {
          // // 遍历一个车位里的所有车辆 的car项
          carCode = this.comnList[ns].car[bs].pkCode;
          if (index == carCode) {
            try {
              var carNos = this.comnList[ns].car[bs].carNo;
              this.mycarList.push(carNos);
            } catch (e) {
              console.error("未找到车辆信息");
            }
          }
        }
        this.mycarList = from_default()(new set_default.a(this.mycarList));
        if (index == carCode) {
          this.sDate = this.comnList[ns].park.parkingInfo.endDate;
          if (!this.sDate) {
            this.dailogMessage = '该车位尚未缴纳过费用，请前往物业处确认开始缴费时间!';
            this.feeShow = true;
          }
          this.qsType = this.comnList[ns].park.feeItem.feeName;
          this.qYleix = this.comnList[ns].park.parkingInfo.pkFloor;
          var pkOwner = this.comnList[ns].park.parkingInfo.pkOwner;
          var pkUsed = this.comnList[ns].park.parkingInfo.pkUsed,
              useXz = void 0;
          if (pkOwner == "公共车位") {
            if (pkUsed == "0") {
              useXz = "已租赁";
            } else {
              useXz = "未租赁";
            }
          } else {
            if (pkUsed == "0") {
              useXz = "已出售";
            } else {
              useXz = "未出售";
            }
          }
          this.useXz = useXz;
          this.sumMoney = this.comnList[ns].park.feeRate;
          this.pkId = this.comnList[ns].park.parkingInfo.pkId;
        }
      }
      this.sMonth = Object(date_format["a" /* default */])(new Date(this.sDate), 'YYYY-MM');
      this.sQx = this.qsType;
      this.qYq = this.qYleix;
      this.feeMoey = this.sumMoney + "元/月";
      this.pkUs = this.useXz;
      this.endDates = this.sDate;
      this.valueTime = this.subMonths(this.endDates, '1');

      this.dateJy = this.dateAdd(this.endDates);

      this.setToday();
      this.setPayTime('1', '0');
      jquery_default()(".am_ulist").find("button").removeClass("am_persfors");
    },
    serchDetail: function serchDetail() {
      var url2 = global.host + 'parkinginfo/getParkTopic' + '?comnCode=' + this.$router.history.current.query.comnCode;
      this.$http.get(url2).then(function (res) {
        this.mycarListInfo = res.body.result;
      }, function (err) {
        console.log(err);
      });

      this.showLog = true;
    },
    cancel: function cancel() {
      this.submitable = false;
    },
    getMonths: function getMonths(date1, date2) {

      date1 = date1.split("-");
      date2 = date2.split("-");

      var year1 = parseInt(date1[0]),
          month1 = parseInt(date1[1]),
          year2 = parseInt(date2[0]),
          month2 = parseInt(date2[1]),
          months = (year2 - year1) * 12 + (month2 - month1);

      this.mousth = months + '个月';
      return months;
    },
    subMonths: function subMonths(date, addMonth) {

      /*let s = $(".vux-datetime").find(".vux-cell-value").text(this.mVals)
      console.log(s)*/
      addMonth = parseInt(addMonth);

      date = date.split("-");

      var year = parseInt(date[0]);
      var month = parseInt(date[1]);
      var riQ = parseInt(date[2]);
      var sumMonth = parseInt(month + addMonth);
      if (sumMonth % 12 == 0) {
        var chushu = sumMonth / 12 - 1;
        year = year + chushu;
        month = sumMonth - 12 * chushu;
      } else if (sumMonth > 12) {
        var chushu = Math.floor(sumMonth / 12);
        year = year + chushu;
        month = sumMonth - 12 * chushu;
      } else {
        month = sumMonth;
      }
      if (riQ == 1) {
        // 如果当前是1号
        var dateYar = this.getCurrentMonthLast(year + "-" + (month - 1));

        this.riQYF = dateYar.substring(dateYar.length - 2);
        if (month < 10) {
          month = "0" + month;
        }
        if (this.riQYF < 10) {
          this.riQYF = "0" + this.riQYF;
        }
        var dates = year + "-" + (parseInt(month) - 1) + '-' + this.riQYF;
        return this.dateAdd(dates);
      } else if (riQ != 1) {
        this.riQYF = riQ;
        if (month < 10) {
          month = "0" + month;
        }
        if (this.riQYF < 10) {
          this.riQYF = "0" + this.riQYF;
        }

        var dates = year + "-" + month + '-' + (this.riQYF - 1);;
        return this.dateAdd(dates);
      }
    },
    setPayTime: function setPayTime(time, defaultRate) {
      this.mousss = time + '个月';

      var timeNum = parseInt(time);
      this.feeBillList = [];
      for (var i = 1; i <= timeNum; i++) {
        var feeObj = new Object();
        feeObj.month = this.subMonths(this.endDates, i);
        this.feeBillList.push(feeObj);
        this.valueTime = feeObj.month;
      }
      this.nextEndDates = this.valueTime + "-" + this.dayms;
      if (defaultRate == '0') {
        // 如果优惠月份等于0的话
        this.yhYFF = '0';
        this.totalFeeMoney = (this.sumMoney * timeNum).toFixed(2) + '元';
        this.youH = '00.00元';
        this.shiS = this.totalFeeMoney;
      } else if (defaultRate != '0') {
        this.yhYFF = defaultRate;
        this.totalFeeMoney = (this.sumMoney * timeNum).toFixed(2) + '元';
        var danJia = this.sumMoney;
        var youHys = defaultRate;
        this.youH = (this.sumMoney * defaultRate).toFixed(2) + '元';
        var aa = (this.sumMoney * timeNum).toFixed(2);
        var bb = (danJia * youHys).toFixed(2);
        this.shiS = (aa - bb).toFixed(2) + '元';
      }
    },
    setToday: function setToday() {
      var months = this.getMonths(this.endDates, this.valueTime);
    },

    /*chanVal(){
    $(".vux-datetime").find(".vux-cell-value").text(this.valueTime);
    },*/
    /*初始化时间选择*/
    getInitSelectDate: function getInitSelectDate() {
      var date = new Date();
      date = new Date(date.getFullYear(), date.getMonth() + 1, date.getDate(), 1);
      this.selectDate[0].push(date.getFullYear());
      this.selectDate[0].push(date.getFullYear() + 1);
      var curM = date.getMonth() + 1;
      this.selectDate[1] = new Array();
      for (var i = curM; i < 13; i++) {
        this.selectDate[1].push(i);
      }

      var curD = date.getDate();
      this.selectDate[2] = new Array();
      for (var n = curD; n < 31; n++) {
        this.selectDate[2].push(n);
      }
    },
    getCurrentMonthLast: function getCurrentMonthLast(date) {
      var endDate = new Date(date);
      var month = endDate.getMonth();
      var nextMonth = ++month;
      var nextMonthFirstDay = new Date(endDate.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var dateString = new Date(nextMonthFirstDay - oneDay);
      return dateString.toLocaleDateString();
    },
    dateAdd: function dateAdd(startDate) {
      startDate = new Date(startDate);
      startDate = +startDate + 1000 * 60 * 60 * 24;
      startDate = new Date(startDate);
      var nextStartDate = startDate.getFullYear() + "-" + (startDate.getMonth() + 1) + "-" + startDate.getDate();
      var daww = nextStartDate.split('-');
      var mouth = daww[1];
      var darr = daww[2];
      if (darr < 10) {
        darr = '0' + darr;
      }
      if (mouth < 10) {
        mouth = '0' + mouth;
      }
      var dateRTY = daww[0] + "-" + mouth + "-" + darr;
      return dateRTY;
    },
    submitBefore: function submitBefore(kId, feeBz, monthCout) {
      if (!this.endDates) {
        this.dailogMessage = '该车位尚未缴纳过费用，请前往物业处确认开始缴费时间!';
        this.feeShow = true;
        return;
      }
      if (monthCout.length == '4') {
        monthCout = monthCout.substr(0, 2);
      } else {
        monthCout = monthCout.substr(0, 1);
      }

      var yzUrl = global.host + 'parkFeeBill/findownerunpaidorder?phoneNo=' + this.$router.history.current.query.phone + '&comnCode=' + this.$router.history.current.query.comnCode + '&openid=' + this.$router.history.current.query.openid;
      this.$http.get(yzUrl).then(function (res) {
        if (res.body.code == '110') {

          var usinfo = new Object();

          usinfo.comnCode = this.$router.history.current.query.comnCode;
          usinfo.startDate = this.dateJy;
          usinfo.endDate = this.valueTime;
          usinfo.pkId = kId;
          usinfo.feePrice = feeBz;
          usinfo.feeCount = monthCout;
          usinfo.discType = this.disTypes;
          usinfo.feeMoney = this.totalFeeMoney.split('元')[0];
          usinfo.freeMonth = this.yhYFF;
          usinfo.discMoney = this.youH.split('元')[0];
          if (this.youH == '00.00元') {
            usinfo.realMoney = this.totalFeeMoney.split('元')[0];
          } else {
            usinfo.realMoney = this.shiS.split('元')[0];
          }
          usinfo.startDate = this.endDates;
          usinfo.openId = this.$router.history.current.query.openid;
          usinfo.mainPhone = this.$router.history.current.query.phone;

          var urls = global.host + 'parkFeeBill/addParkFeeBill';
          this.$http.post(urls, usinfo).then(function (res) {
            var statuCodes = res.body.statusCode;

            if (statuCodes == '110') {
              this.billCode = res.body.result.billCode;
              this.gopay();
            } else if (statuCodes == '120') {
              this.feeShow = true;
              this.dailogMessage = "提交失败";
            }
          }, function (err) {
            console.log(err);
          });
        } else if (res.body.code == '120') {
          this.dailogMessage = '您有未处理的订单,请优先处理';
          this.feeShow = true;
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*去支付方法*/
    gopay: function gopay() {
      var senddata = new Object();
      senddata.comnCode = this.$router.history.current.query.comnCode;
      senddata.memberNo = this.$router.history.current.query.phone;
      senddata.openid = this.$router.history.current.query.openid;
      senddata.tradeAmount = this.shiS.split("元")[0];
      senddata.tradeNo = this.billCode;
      senddata.tradeName = '车位费';
      senddata.tradeDesc = '车位费';
      var url = global.host + 'parkFeeBill/getpayurl';
      this.$http.post(url, senddata).then(function (res) {
        if (res.body.code == '110') {
          location.href = res.body.payurl;
        } else {
          this.feeShow = true;
          this.dailogMessage = "支付异常,请稍候再试";
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*根据不同的操作进行操作*/
    refresh: function refresh() {
      if (this.dailogMessage == '您有未处理的订单,请优先处理') {
        this.submitable = true;
        this.$router.push({ path: '/paymentRecord', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7182a2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carRentComponents/carPaycoment.vue
var carPaycoment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",staticStyle:{"overflow-x":"hidden"}},[(_vm.cont)?_c('div',[_c('group',{staticStyle:{"margin-top":"12px","border":"1px solid #C8C8C8"}},[_c('popup-picker',{attrs:{"title":"车位信息","data":_vm.list_1},on:{"on-change":_vm.onChange},model:{value:(_vm.value_1),callback:function ($$v) {_vm.value_1=$$v},expression:"value_1"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"权属类型","text-align":"right","disabled":""},model:{value:(_vm.sQx),callback:function ($$v) {_vm.sQx=$$v},expression:"sQx"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"区域","text-align":"left","disabled":""},model:{value:(_vm.qYq),callback:function ($$v) {_vm.qYq=$$v},expression:"qYq"}}),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","position":"absolute","top":"54%","right":"0"}},[_c('x-button',{staticClass:"am_borfot am_cnter",staticStyle:{"color":"#333 !important"},attrs:{"type":"primary","mini":""},nativeOn:{"click":function($event){return _vm.serchDetail($event)}}},[_vm._v("收费标准 "+_vm._s(_vm.feeMoey)+"\n                    "),_c('i',{staticClass:"fa fa-exclamation-circle",staticStyle:{"text-algin":"middle"},attrs:{"aria-hidden":"true"}})])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"车辆信息","text-align":"right","disabled":""},model:{value:(_vm.mycarList),callback:function ($$v) {_vm.mycarList=$$v},expression:"mycarList"}})],1),_vm._v(" "),_c('group',{staticStyle:{"margin-top":"8%","border":"1px solid #C8C8C8"}},[_c('x-input',{attrs:{"title":"到期时间","text-align":"right","disabled":""},model:{value:(_vm.dateJy),callback:function ($$v) {_vm.dateJy=$$v},expression:"dateJy"}}),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","margin":"0 auto"}},[_c('div',{staticStyle:{"height":"10px"}}),_vm._v(" "),_c('ul',{staticClass:"am_ulist fix"},_vm._l((_vm.myTime),function(item2,index){return _c('li',{key:index,class:item2.defaultRate == 0 ? "am_ulistLiFS" : "am_ulistLiLS"},[_c('x-button',{ref:"dateBut",refInFor:true,staticClass:"amIndexs",attrs:{"type":"primary","plain":""},nativeOn:{"click":function($event){_vm.setPayTime(item2.baseRate,item2.defaultRate)}}},[_vm._v(_vm._s(item2.discDesc))])],1)}))]),_vm._v(" "),_c('popup-picker',{ref:"val_jf",attrs:{"title":"缴费月数","data":_vm.jfYs,"value":_vm.mousss,"placeholder":_vm.mousss},on:{"on-show":_vm.onShow,"on-hide":_vm.onHide,"on-change":function($event){_vm.onZDY()}},model:{value:(_vm.value_Q),callback:function ($$v) {_vm.value_Q=$$v},expression:"value_Q"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"续费至","text-align":"right","disabled":""},model:{value:(_vm.valueTime),callback:function ($$v) {_vm.valueTime=$$v},expression:"valueTime"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"应收金额","text-align":"right","disabled":""},model:{value:(_vm.totalFeeMoney),callback:function ($$v) {_vm.totalFeeMoney=$$v},expression:"totalFeeMoney"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"优惠金额","text-align":"right","disabled":""},model:{value:(_vm.youH),callback:function ($$v) {_vm.youH=$$v},expression:"youH"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"实收金额","text-align":"right","disabled":""},model:{value:(_vm.shiS),callback:function ($$v) {_vm.shiS=$$v},expression:"shiS"}})],1),_vm._v(" "),_c('alert',{staticClass:"am_alert_cont",attrs:{"button-text":"关闭"},model:{value:(_vm.showLog),callback:function ($$v) {_vm.showLog=$$v},expression:"showLog"}},[_c('h1',{staticClass:"am_font1"},[_vm._v("收费标准")]),_vm._v(" "),_c('group',[_c('ul',[_c('li',{staticClass:"am_font2"},[_vm._v("权属类型")]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v("区域")]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v("价格")])])]),_vm._v(" "),_vm._l((_vm.mycarListInfo),function(item1,index){return _c('ul',{key:index},[_c('li',{staticClass:"am_font2"},[_vm._v(_vm._s(item1.feeName))]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v(_vm._s(item1.pValue))]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v(_vm._s(item1.feeRate)+"/月")])])})],2),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"6%"},attrs:{"type":"primary","disabled":_vm.submitable},nativeOn:{"click":function($event){_vm.submitBefore(_vm.pkId,_vm.sumMoney,_vm.mousss)}}},[_vm._v("提交订单")]),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},on:{"on-hide":_vm.refresh},model:{value:(_vm.feeShow),callback:function ($$v) {_vm.feeShow=$$v},expression:"feeShow"}},[_vm._v(_vm._s(_vm.dailogMessage))])],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1):_vm._e(),_vm._v(" "),(_vm.show_5)?_c('div',{staticClass:"tishiInfo"},[_c('p',[_vm._v("您还没有任何车位信息,")]),_vm._v(" "),_c('p',[_vm._v("如需办理请联系物业公司!")])]):_vm._e()])}
var carPaycoment_staticRenderFns = []
var carPaycoment_esExports = { render: carPaycoment_render, staticRenderFns: carPaycoment_staticRenderFns }
/* harmony default export */ var components_carRentComponents_carPaycoment = (carPaycoment_esExports);
// CONCATENATED MODULE: ./src/components/carRentComponents/carPaycoment.vue
function carPaycoment_injectStyle (ssrContext) {
  __webpack_require__("BcM0")
}
var carPaycoment_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var carPaycoment___vue_template_functional__ = false
/* styles */
var carPaycoment___vue_styles__ = carPaycoment_injectStyle
/* scopeId */
var carPaycoment___vue_scopeId__ = "data-v-b7182a2a"
/* moduleIdentifier (server only) */
var carPaycoment___vue_module_identifier__ = null
var carPaycoment_Component = carPaycoment_normalizeComponent(
  carRentComponents_carPaycoment,
  components_carRentComponents_carPaycoment,
  carPaycoment___vue_template_functional__,
  carPaycoment___vue_styles__,
  carPaycoment___vue_scopeId__,
  carPaycoment___vue_module_identifier__
)

/* harmony default export */ var src_components_carRentComponents_carPaycoment = (carPaycoment_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/zhiF.vue















/* harmony default export */ var zhiF = ({
  components: {
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage,
    $: jquery_default.a,
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      show_1: false,
      btnSUM: false,
      isAgent: "",
      baseIMG: "",
      billCode: '',
      feeShow: false,
      dailogMessage: '',
      feeName: ''
    };
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    this.int();
    this.getUserName();

    jquery_default()(".am_ulist").delegate("li", "click", function () {
      jquery_default()(this).find("button").addClass("am_persfors");
      jquery_default()(this).siblings("li").find("button").removeClass("am_persfors");
    });
  },

  methods: {
    /*设置缴费金额*/
    setPayMoney: function setPayMoney(money) {
      console.log(money);
      jquery_default()("#moneyJE").val(money);
      this.btnSUM = true;
      this.int();
    },
    onInput: function onInput() {
      var moneyJE = jquery_default()("#moneyJE").val();
      if (moneyJE != "") {
        this.btnSUM = true;
        this.int();
      } else if (moneyJE == "") {
        this.btnSUM = false;
        this.int();
      }
    },
    getUserName: function getUserName() {
      var senddata = new Object();
      senddata.openId = this.$router.history.current.query.openid;
      var tempCode = this.$router.history.current.query.comnCode;
      senddata.comnCode = tempCode.split("_")[0];
      senddata.feeCode = tempCode.split("_")[1];
      var url = global.host + "wechatCharge/index";
      this.$http.post(url, senddata).then(function (res) {
        console.log(res);
        if (res.status == "200") {
          this.isAgent = res.body.result.isAgent;
          this.baseIMG = res.body.result.feeFactor;
          this.feeName = res.body.result.feeName;
          jquery_default()("#beiZu").val(this.feeName);
        } else {
          this.feeShow = true;
          this.dailogMessage = "网络错误";
        }
      }, function (err) {
        console.log(err);
      });
    },
    int: function int() {
      if (this.btnSUM == false) {
        jquery_default()("#sumFK").addClass("opC");
      } else {
        jquery_default()("#sumFK").removeClass("opC");
      }
    },
    submitBefore: function submitBefore() {
      if (this.btnSUM == true) {
        var sendMoney = new Object();
        sendMoney.sumFeeMoney = jquery_default()("#moneyJE").val();
        sendMoney.remark = jquery_default()("#beiZu").val();
        var tempCode = this.$router.history.current.query.comnCode;
        sendMoney.comnCode = tempCode.split("_")[0];
        sendMoney.feeCode = tempCode.split("_")[1];
        var url = global.host + "wechatCharge/collectTemporary";
        this.$http.post(url, sendMoney).then(function (res) {
          console.log(res);
          if (res.status == "200") {
            this.show_1 = true;

            this.billCode = res.body.result;

            this.goPay();
          } else {
            this.feeShow = true;
            this.dailogMessage = "网络错误";
          }
        }, function (err) {
          console.log(err);
        });
      }
    },
    goPay: function goPay() {
      var senddata = new Object();
      senddata.phone = '';
      var tempCode = this.$router.history.current.query.comnCode;
      senddata.comnCode = tempCode.split("_")[0];
      senddata.memberNo = '';
      senddata.feeCode = tempCode.split("_")[1];
      senddata.openid = this.$router.history.current.query.openid;
      senddata.tradeAmount = jquery_default()("#moneyJE").val();
      senddata.tradeNo = this.billCode.billCode;
      senddata.tradeName = this.feeName;
      senddata.tradeDesc = this.feeName;
      var url = global.host + 'wechatCharge/getpayurl';
      this.$http.post(url, senddata).then(function (res) {
        this.show_1 = false;
        if (res.body.code == '110') {
          window.location.href = res.body.payurl;
        } else {
          this.feeShow = true;
          this.dailogMessage = "网络错误";
        }
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/zhiF.vue















/* harmony default export */ var carRentComponents_zhiF = ({
  components: {
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage,
    $: jquery_default.a,
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      show_1: false,
      btnSUM: false,
      isAgent: "",
      baseIMG: "",
      billCode: '',
      feeShow: false,
      dailogMessage: '',
      feeName: ''
    };
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    this.int();
    this.getUserName();

    jquery_default()(".am_ulist").delegate("li", "click", function () {
      jquery_default()(this).find("button").addClass("am_persfors");
      jquery_default()(this).siblings("li").find("button").removeClass("am_persfors");
    });
  },

  methods: {
    /*设置缴费金额*/
    setPayMoney: function setPayMoney(money) {
      console.log(money);
      jquery_default()("#moneyJE").val(money);
      this.btnSUM = true;
      this.int();
    },
    onInput: function onInput() {
      var moneyJE = jquery_default()("#moneyJE").val();
      if (moneyJE != "") {
        this.btnSUM = true;
        this.int();
      } else if (moneyJE == "") {
        this.btnSUM = false;
        this.int();
      }
    },
    getUserName: function getUserName() {
      var senddata = new Object();
      senddata.openId = this.$router.history.current.query.openid;
      var tempCode = this.$router.history.current.query.comnCode;
      senddata.comnCode = tempCode.split("_")[0];
      senddata.feeCode = tempCode.split("_")[1];
      var url = global.host + "wechatCharge/index";
      this.$http.post(url, senddata).then(function (res) {
        console.log(res);
        if (res.status == "200") {
          this.isAgent = res.body.result.isAgent;
          this.baseIMG = res.body.result.feeFactor;
          this.feeName = res.body.result.feeName;
          jquery_default()("#beiZu").val(this.feeName);
        } else {
          this.feeShow = true;
          this.dailogMessage = "网络错误";
        }
      }, function (err) {
        console.log(err);
      });
    },
    int: function int() {
      if (this.btnSUM == false) {
        jquery_default()("#sumFK").addClass("opC");
      } else {
        jquery_default()("#sumFK").removeClass("opC");
      }
    },
    submitBefore: function submitBefore() {
      if (this.btnSUM == true) {
        var sendMoney = new Object();
        sendMoney.sumFeeMoney = jquery_default()("#moneyJE").val();
        sendMoney.remark = jquery_default()("#beiZu").val();
        var tempCode = this.$router.history.current.query.comnCode;
        sendMoney.comnCode = tempCode.split("_")[0];
        sendMoney.feeCode = tempCode.split("_")[1];
        var url = global.host + "wechatCharge/collectTemporary";
        this.$http.post(url, sendMoney).then(function (res) {
          console.log(res);
          if (res.status == "200") {
            this.show_1 = true;

            this.billCode = res.body.result;

            this.goPay();
          } else {
            this.feeShow = true;
            this.dailogMessage = "网络错误";
          }
        }, function (err) {
          console.log(err);
        });
      }
    },
    goPay: function goPay() {
      var senddata = new Object();
      senddata.phone = '';
      var tempCode = this.$router.history.current.query.comnCode;
      senddata.comnCode = tempCode.split("_")[0];
      senddata.memberNo = '';
      senddata.feeCode = tempCode.split("_")[1];
      senddata.openid = this.$router.history.current.query.openid;
      senddata.tradeAmount = jquery_default()("#moneyJE").val();
      senddata.tradeNo = this.billCode.billCode;
      senddata.tradeName = this.feeName;
      senddata.tradeDesc = this.feeName;
      var url = global.host + 'wechatCharge/getpayurl';
      this.$http.post(url, senddata).then(function (res) {
        this.show_1 = false;
        if (res.body.code == '110') {
          window.location.href = res.body.payurl;
        } else {
          this.feeShow = true;
          this.dailogMessage = "网络错误";
        }
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79e681c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carRentComponents/zhiF.vue
var zhiF_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('span',{staticClass:"s_div tit_box"},[_c('span',{staticClass:"s_div tit_fk"},[_vm._v("付款给商户")]),_vm._v(" "),_c('span',{staticClass:"s_div tit_name"},[_vm._v(_vm._s(_vm.isAgent))]),_vm._v(" "),_c('img',{staticClass:"s_div tie_img",attrs:{"src":_vm.baseIMG,"alt":""}})]),_vm._v(" "),_c('span',{staticClass:"s_div money_box"},[_c('span',{staticClass:"s_div m_ybox"},[_vm._v("金额")]),_vm._v(" "),_c('span',{staticClass:"s_div m_qbox"},[_c('span',{staticStyle:{"font-weight":"700","font-size":"31px"}},[_vm._v("￥")]),_vm._v(" "),_c('input',{staticClass:"inp_box",attrs:{"type":"number","placeholder":"输入金额","id":"moneyJE"},on:{"input":function($event){_vm.onInput()}}})]),_vm._v(" "),_c('span',{staticClass:"s_div",staticStyle:{"margin-top":"5%"}},[_c('ul',{staticClass:"am_ulist fix"},[_c('li',[_c('x-button',{staticClass:"amIndexs",attrs:{"type":"primary","plain":""},nativeOn:{"click":function($event){_vm.setPayMoney(2)}}},[_vm._v("2元")])],1),_vm._v(" "),_c('li',[_c('x-button',{staticClass:"amIndexs",attrs:{"type":"primary","plain":""},nativeOn:{"click":function($event){_vm.setPayMoney(3)}}},[_vm._v("3元")])],1),_vm._v(" "),_c('li',[_c('x-button',{staticClass:"amIndexs",attrs:{"type":"primary","plain":""},nativeOn:{"click":function($event){_vm.setPayMoney(5)}}},[_vm._v("5元")])],1),_vm._v(" "),_c('li',[_c('x-button',{staticClass:"amIndexs",attrs:{"type":"primary","plain":""},nativeOn:{"click":function($event){_vm.setPayMoney(10)}}},[_vm._v("10元")])],1)])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('x-button',{ref:"mybox",staticStyle:{"margin-top":"8%"},attrs:{"type":"primary","id":"sumFK"},nativeOn:{"click":function($event){_vm.submitBefore()}}},[_vm._v("付款")])],1),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.feeShow),callback:function ($$v) {_vm.feeShow=$$v},expression:"feeShow"}},[_vm._v(_vm._s(_vm.dailogMessage))])],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var zhiF_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"s_div",staticStyle:{"margin-top":"5%"}},[_c('span',{staticStyle:{"color":"rgb(145, 159, 171)"}},[_vm._v("备注:")]),_vm._v(" "),_c('input',{staticStyle:{"background":"rgb(251,249,254)","width":"85%","height":"30px"},attrs:{"type":"text","id":"beiZu","placeholder":""}})])}]
var zhiF_esExports = { render: zhiF_render, staticRenderFns: zhiF_staticRenderFns }
/* harmony default export */ var components_carRentComponents_zhiF = (zhiF_esExports);
// CONCATENATED MODULE: ./src/components/carRentComponents/zhiF.vue
function zhiF_injectStyle (ssrContext) {
  __webpack_require__("hiPb")
}
var zhiF_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var zhiF___vue_template_functional__ = false
/* styles */
var zhiF___vue_styles__ = zhiF_injectStyle
/* scopeId */
var zhiF___vue_scopeId__ = "data-v-79e681c8"
/* moduleIdentifier (server only) */
var zhiF___vue_module_identifier__ = null
var zhiF_Component = zhiF_normalizeComponent(
  carRentComponents_zhiF,
  components_carRentComponents_zhiF,
  zhiF___vue_template_functional__,
  zhiF___vue_styles__,
  zhiF___vue_scopeId__,
  zhiF___vue_module_identifier__
)

/* harmony default export */ var src_components_carRentComponents_zhiF = (zhiF_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/defeated.vue















/* harmony default export */ var defeated = ({
  components: {
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage,
    $: jquery_default.a,
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      show_1: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/defeated.vue















/* harmony default export */ var carRentComponents_defeated = ({
  components: {
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage,
    $: jquery_default.a,
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      show_1: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74dbd65a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carRentComponents/defeated.vue
var defeated_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",staticStyle:{"overflow-x":"hidden"}},[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("获取微信授权异常，请允许获取微信基本信息")]),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var defeated_staticRenderFns = []
var defeated_esExports = { render: defeated_render, staticRenderFns: defeated_staticRenderFns }
/* harmony default export */ var components_carRentComponents_defeated = (defeated_esExports);
// CONCATENATED MODULE: ./src/components/carRentComponents/defeated.vue
function defeated_injectStyle (ssrContext) {
  __webpack_require__("NF7M")
}
var defeated_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var defeated___vue_template_functional__ = false
/* styles */
var defeated___vue_styles__ = defeated_injectStyle
/* scopeId */
var defeated___vue_scopeId__ = "data-v-74dbd65a"
/* moduleIdentifier (server only) */
var defeated___vue_module_identifier__ = null
var defeated_Component = defeated_normalizeComponent(
  carRentComponents_defeated,
  components_carRentComponents_defeated,
  defeated___vue_template_functional__,
  defeated___vue_styles__,
  defeated___vue_scopeId__,
  defeated___vue_module_identifier__
)

/* harmony default export */ var src_components_carRentComponents_defeated = (defeated_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/carPayComFee.vue




















/* harmony default export */ var carPayComFee = ({

  components: {
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage,
    $: jquery_default.a,
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      title1: '车位缴费', //缴费名称
      value_1: [],
      list_1: [[]],
      valueTime: '2012/12/12', //缴费时间
      endDates: '',
      myDilogs: '',
      nextEndDates: '',
      selectDate: [[], [], []], //初始化时间选择
      phone: '', //电话
      mousth1: ['1'],
      allMonth: [[]],
      mycarList: [], //绑定车辆集合
      mycarListInfo: [], //缴费明细集合
      myTime: [], //选择时间集合
      baseRate: '', //基础量
      dailogMessage: '',
      comnCode: '',
      submitable: false,
      mousth: '',
      show: false,
      comnList: '',
      showLog: false,
      mssl: [],
      msrue1: false,
      msrue: false,
      feeShow: false,
      show_1: false,
      feeBillList: [],

      sMonth: '',
      sQx: '',
      pkUs: '',
      feeMoey: '',
      sDate: '',
      qsType: '',
      useXz: '',
      sumMoney: '',
      totalFeeMoney: '0.0',
      prevValueTime: '',

      pkId: '',
      disTypes: '',
      billCode: '',
      dayms: '',
      mVals: '',
      /*********/
      qxTypes: '',
      areaPlace: '',
      feeStandard: '',
      hTime: ''
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    setTimeout(function () {
      this.show_1 = false;
    }, 1000);
    this.getInitSelectDate();

    var url2 = global.host + 'discountConfig/getListByPark?comnCode=' + this.$router.history.current.query.comnCode;
    this.$http.get(url2).then(function (res) {
      var tiems = res.body.result;
      this.myTime = new Object();
      for (var jm in tiems) {
        this.myTime[jm] = tiems[jm];
      }
      this.loadAjax();
      console.log("#####");
      console.log(this.myTime[0]);

      this.disTypes = this.myTime[0].discType;
      this.show_1 = false;
    }, function (err) {
      this.show_1 = false;
      console.log(err);
    });
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == '/carPaycoment') {

      document.title = "车辆缴费";
    }
    var mi = 25;
    var arry = [];
    for (var i = 1; i < 25; i++) {
      this.allMonth[0].push(i.toString());
    }
    jquery_default()(".am_font1").parent(".weui-dialog__bd").css({ "padding-left": "0.1em", "padding-right": "0.1em" });

    jquery_default()(".am_ulist").delegate("li", "click", function () {
      jquery_default()(this).find("button").addClass("am_persfors");
      jquery_default()(this).siblings("li").find("button").removeClass("am_persfors");
    });
    this.msrue = true;
    this.msrue1 = false;
  },

  methods: {
    log: function log(str1) {
      var str2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      console.log(str1, str2);
    },
    onConfirm: function onConfirm(val) {
      console.log('on-confirm arg', val);
    },
    loadAjax: function loadAjax() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var url1;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url1 = global.host + 'parkinginfo/queryParkInfo?phone=' + _this.$router.history.current.query.phone + '&comnCode=' + _this.$router.history.current.query.comnCode;
                _context.next = 3;
                return _this.$http.get(url1).then(function (res) {
                  var reslt = res.body.result;
                  var slit = [];
                  var mdata = "";
                  this.comnList = res.body.result;
                  if (res.status == 200) {
                    for (var i = 0; i < reslt.length; i++) {
                      this.list_1[0].push(reslt[i].park.parkingInfo.pkCode);
                      this.value_1[0] = this.list_1[0][0];
                    }
                    this.onChange(this.list_1[0][0]);
                    for (var its in reslt) {
                      for (var mitem in reslt[its].car) {
                        mdata = reslt[its].car[mitem].pkCode;
                        this.mssl.push(reslt[its].car[0].carNo);
                        this.list_1[0].push(mdata);
                      }
                      for (var bm in reslt[its].park) {
                        this.endDates = reslt[its].park.parkingInfo.endDate;
                        var mdate = this.endDates.split("-");
                        this.dayms = parseInt(mdate[2]);
                        if (this.dayms < 10) {
                          this.dayms = '0' + this.dayms;
                        }
                        var defaultCount = this.myTime[0].baseRate;
                        this.valueTime = this.subMonths(this.endDates, defaultCount);

                        this.nextEndDates = this.valueTime + "-" + this.dayms;

                        this.setPayTime(defaultCount);
                        jquery_default()(".am_ulist > li:eq(0)").find("button").addClass("am_persfors");

                        if (this.list_1[0][0] == mdata) {
                          this.sDate = reslt[its].park.parkingInfo.endDate;
                          this.qsType = reslt[its].park.feeItem.feeName;
                          this.useXz = reslt[its].park.parkingInfo.pkUsed;
                          this.sumMoney = reslt[its].park.feeRate;
                          this.pkId = reslt[its].park.parkingInfo.pkId;
                        }
                      }
                    }

                    var ms = from_default()(new set_default.a(this.list_1[0]));
                    this.list_1[0] = ms;

                    this.value_1 = this.list_1[0];
                    this.onChange(this.list_1[0][0]);

                    this.sMonth = Object(date_format["a" /* default */])(new Date(this.sDate), 'YYYY-MM');
                    this.sQx = this.qsType;
                    this.feeMoey = this.sumMoney + "元/月";
                    this.pkUs = this.useXz;
                  }
                }, function (err) {
                  console.log(err);
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    mload: function mload() {
      this.nextEndDates = this.valueTime + "-" + this.dayms;
    },
    onChange: function onChange(index) {
      this.mycarList = [];
      var carCode = "";
      for (var ns in this.comnList) {
        for (var bs in this.comnList[ns].car) {
          carCode = this.comnList[ns].car[bs].pkCode;
          if (index == carCode) {
            var carNos = this.comnList[ns].car[bs].carNo;
            this.mycarList.push(carNos);
          }
        }
        if (index == carCode) {
          this.sDate = this.comnList[ns].park.parkingInfo.endDate;
          this.qsType = this.comnList[ns].park.feeItem.feeName;
          this.useXz = this.comnList[ns].park.parkingInfo.pkUsed;
          this.sumMoney = this.comnList[ns].park.feeRate;
          this.pkId = this.comnList[ns].park.parkingInfo.pkId;
          this.qxTypes = this.comnList[ns].park.parkingInfo.pkOwner;
          this.areaPlace = this.comnList[ns].park.parkingInfo.pkRegion;
          this.feeStandard = this.comnList[ns].park.feeRate;
        }
      }
      this.sMonth = Object(date_format["a" /* default */])(new Date(this.sDate), 'YYYY-MM');
      this.sQx = this.qsType;
      this.feeMoey = this.sumMoney + "元/月";
      this.pkUs = this.useXz;
      this.endDates = this.sDate;

      this.setToday();
    },
    serchDetail: function serchDetail() {
      var url2 = global.host + 'parkinginfo/getParkTopic';
      this.$http.get(url2).then(function (res) {
        this.mycarListInfo = res.body.result;
      }, function (err) {
        console.log(err);
      });

      this.showLog = true;
    },
    cancel: function cancel() {
      this.submitable = false;
    },
    getMonths: function getMonths(date1, date2) {

      date1 = date1.split("-");
      date2 = date2.split("-");

      var year1 = parseInt(date1[0]),
          month1 = parseInt(date1[1]),
          year2 = parseInt(date2[0]),
          month2 = parseInt(date2[1]),
          months = (year2 - year1) * 12 + (month2 - month1);

      this.mousth = months;
      return months;
    },
    subMonths: function subMonths(date, addMonth) {

      /*let s = $(".vux-datetime").find(".vux-cell-value").text(this.mVals)
      console.log(s)*/
      addMonth = parseInt(addMonth);

      date = date.split("-");

      var year = parseInt(date[0]);
      var month = parseInt(date[1]);
      var sumMonth = parseInt(month + addMonth);
      if (sumMonth % 12 == 0) {
        var chushu = sumMonth / 12 - 1;
        year = year + chushu;
        month = sumMonth - 12 * chushu;
      } else if (sumMonth > 12) {
        var chushu = Math.floor(sumMonth / 12);
        year = year + chushu;
        month = sumMonth - 12 * chushu;
      } else {
        month = sumMonth;
      }
      if (month < 10) {
        month = "0" + month;
      }
      return year + "-" + month;
    },
    setPayTime: function setPayTime(time, disType) {

      var timeNum = parseInt(time);
      this.feeBillList = [];
      for (var i = 1; i <= timeNum; i++) {
        var feeObj = new Object();
        feeObj.month = this.subMonths(this.endDates, i);
        this.feeBillList.push(feeObj);
        this.valueTime = feeObj.month;
      }
      this.nextEndDates = this.valueTime + "-" + this.dayms;
      this.totalFeeMoney = this.sumMoney * timeNum;
    },
    setToday: function setToday() {
      var months = this.getMonths(this.endDates, this.valueTime);
      this.setPayTime(months);
    },
    onChangeMonth: function onChangeMonth(mIndex) {
      var timeNum = parseInt(mIndex);
      this.feeBillList = [];
      for (var i = 1; i <= timeNum; i++) {
        var feeObj = new Object();
        feeObj.month = this.subMonths(this.endDates, i);
        this.feeBillList.push(feeObj);
        this.valueTime = feeObj.month;
      }
      this.nextEndDates = this.valueTime + "-" + this.dayms;
      this.totalFeeMoney = this.sumMoney * timeNum;
    },

    /*chanVal(){
    $(".vux-datetime").find(".vux-cell-value").text(this.valueTime);
    },*/
    /*初始化时间选择*/
    getInitSelectDate: function getInitSelectDate() {
      var date = new Date();
      date = new Date(date.getFullYear(), date.getMonth() + 1, date.getDate(), 1);
      this.selectDate[0].push(date.getFullYear());
      this.selectDate[0].push(date.getFullYear() + 1);
      var curM = date.getMonth() + 1;
      this.selectDate[1] = new Array();
      for (var i = curM; i < 13; i++) {
        this.selectDate[1].push(i);
      }
      var curD = date.getDate();
      this.selectDate[2] = new Array();
      for (var n = curD; n < 31; n++) {
        this.selectDate[2].push(n);
      }
    },
    submitBefore: function submitBefore(kId, feeBz, monthCout) {

      var yzUrl = global.host + 'parkFeeBill/findownerunpaidorder?phoneNo=' + this.$router.history.current.query.phone + '&comnCode=' + this.$router.history.current.query.comnCode + '&openid=' + this.$router.history.current.query.openid;
      this.$http.get(yzUrl).then(function (res) {
        if (res.body.code == '110') {

          var usinfo = new Object();
          usinfo.comnCode = this.$router.history.current.query.comnCode;
          usinfo.pkId = kId;
          usinfo.feePrice = feeBz;
          usinfo.feeCount = monthCout;
          usinfo.discType = this.disTypes;
          usinfo.freeMonth = 0;
          usinfo.discMoney = 0;
          usinfo.realMoney = this.totalFeeMoney;
          usinfo.startDate = this.endDates;
          usinfo.openId = this.$router.history.current.query.openid;
          usinfo.mainPhone = this.$router.history.current.query.phone;

          var urls = global.host + 'parkFeeBill/addParkFeeBill';
          this.$http.post(urls, usinfo).then(function (res) {
            var statuCodes = res.body.statusCode;

            if (statuCodes == '110') {
              this.billCode = res.body.result.billCode;
              console.log(res);
              this.gopay();
            } else if (statuCodes == '120') {
              this.feeShow = true;
              this.dailogMessage = "提交失败";
            }
          }, function (err) {
            console.log(err);
          });
        } else if (res.body.code == '120') {
          this.dailogMessage = '您有未处理的订单,请优先处理';
          this.feeShow = true;
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*去支付方法*/
    gopay: function gopay() {
      var senddata = new Object();
      senddata.comnCode = this.$router.history.current.query.comnCode;
      senddata.memberNo = this.$router.history.current.query.phone;
      senddata.openid = this.$router.history.current.query.openid;
      senddata.tradeAmount = this.totalFeeMoney;
      senddata.tradeNo = this.billCode;
      senddata.tradeName = '车位费';
      senddata.tradeDesc = '车位费';
      console.log(senddata);
      var url = global.host + 'parkFeeBill/getpayurl';
      this.$http.post(url, senddata).then(function (res) {
        if (res.body.code == '110') {
          location.href = res.body.payurl;
        } else {
          this.feeShow = true;
          this.dailogMessage = "支付异常,请稍候再试";
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*根据不同的操作进行操作*/
    refresh: function refresh() {
      if (this.dailogMessage == '您有未处理的订单,请优先处理') {
        this.submitable = true;
        this.$router.push({ path: '/paymentRecord', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/carRentComponents/carPayComFee.vue




















/* harmony default export */ var carRentComponents_carPayComFee = ({

  components: {
    XInput: x_input["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage,
    $: jquery_default.a,
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      title1: '车位缴费', //缴费名称
      value_1: [],
      list_1: [[]],
      valueTime: '2012/12/12', //缴费时间
      endDates: '',
      myDilogs: '',
      nextEndDates: '',
      selectDate: [[], [], []], //初始化时间选择
      phone: '', //电话
      mousth1: ['1'],
      allMonth: [[]],
      mycarList: [], //绑定车辆集合
      mycarListInfo: [], //缴费明细集合
      myTime: [], //选择时间集合
      baseRate: '', //基础量
      dailogMessage: '',
      comnCode: '',
      submitable: false,
      mousth: '',
      show: false,
      comnList: '',
      showLog: false,
      mssl: [],
      msrue1: false,
      msrue: false,
      feeShow: false,
      show_1: false,
      feeBillList: [],

      sMonth: '',
      sQx: '',
      pkUs: '',
      feeMoey: '',
      sDate: '',
      qsType: '',
      useXz: '',
      sumMoney: '',
      totalFeeMoney: '0.0',
      prevValueTime: '',

      pkId: '',
      disTypes: '',
      billCode: '',
      dayms: '',
      mVals: '',
      /*********/
      qxTypes: '',
      areaPlace: '',
      feeStandard: '',
      hTime: ''
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    setTimeout(function () {
      this.show_1 = false;
    }, 1000);
    this.getInitSelectDate();

    var url2 = global.host + 'discountConfig/getListByPark?comnCode=' + this.$router.history.current.query.comnCode;
    this.$http.get(url2).then(function (res) {
      var tiems = res.body.result;
      this.myTime = new Object();
      for (var jm in tiems) {
        this.myTime[jm] = tiems[jm];
      }
      this.loadAjax();
      console.log("#####");
      console.log(this.myTime[0]);

      this.disTypes = this.myTime[0].discType;
      this.show_1 = false;
    }, function (err) {
      this.show_1 = false;
      console.log(err);
    });
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == '/carPaycoment') {

      document.title = "车辆缴费";
    }
    var mi = 25;
    var arry = [];
    for (var i = 1; i < 25; i++) {
      this.allMonth[0].push(i.toString());
    }
    jquery_default()(".am_font1").parent(".weui-dialog__bd").css({ "padding-left": "0.1em", "padding-right": "0.1em" });

    jquery_default()(".am_ulist").delegate("li", "click", function () {
      jquery_default()(this).find("button").addClass("am_persfors");
      jquery_default()(this).siblings("li").find("button").removeClass("am_persfors");
    });
    this.msrue = true;
    this.msrue1 = false;
  },

  methods: {
    log: function log(str1) {
      var str2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      console.log(str1, str2);
    },
    onConfirm: function onConfirm(val) {
      console.log('on-confirm arg', val);
    },
    loadAjax: function loadAjax() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var url1;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url1 = global.host + 'parkinginfo/queryParkInfo?phone=' + _this.$router.history.current.query.phone + '&comnCode=' + _this.$router.history.current.query.comnCode;
                _context.next = 3;
                return _this.$http.get(url1).then(function (res) {
                  var reslt = res.body.result;
                  var slit = [];
                  var mdata = "";
                  this.comnList = res.body.result;
                  if (res.status == 200) {
                    for (var i = 0; i < reslt.length; i++) {
                      this.list_1[0].push(reslt[i].park.parkingInfo.pkCode);
                      this.value_1[0] = this.list_1[0][0];
                    }
                    this.onChange(this.list_1[0][0]);
                    for (var its in reslt) {
                      for (var mitem in reslt[its].car) {
                        mdata = reslt[its].car[mitem].pkCode;
                        this.mssl.push(reslt[its].car[0].carNo);
                        this.list_1[0].push(mdata);
                      }
                      for (var bm in reslt[its].park) {
                        this.endDates = reslt[its].park.parkingInfo.endDate;
                        var mdate = this.endDates.split("-");
                        this.dayms = parseInt(mdate[2]);
                        if (this.dayms < 10) {
                          this.dayms = '0' + this.dayms;
                        }
                        var defaultCount = this.myTime[0].baseRate;
                        this.valueTime = this.subMonths(this.endDates, defaultCount);

                        this.nextEndDates = this.valueTime + "-" + this.dayms;

                        this.setPayTime(defaultCount);
                        jquery_default()(".am_ulist > li:eq(0)").find("button").addClass("am_persfors");

                        if (this.list_1[0][0] == mdata) {
                          this.sDate = reslt[its].park.parkingInfo.endDate;
                          this.qsType = reslt[its].park.feeItem.feeName;
                          this.useXz = reslt[its].park.parkingInfo.pkUsed;
                          this.sumMoney = reslt[its].park.feeRate;
                          this.pkId = reslt[its].park.parkingInfo.pkId;
                        }
                      }
                    }

                    var ms = from_default()(new set_default.a(this.list_1[0]));
                    this.list_1[0] = ms;

                    this.value_1 = this.list_1[0];
                    this.onChange(this.list_1[0][0]);

                    this.sMonth = Object(date_format["a" /* default */])(new Date(this.sDate), 'YYYY-MM');
                    this.sQx = this.qsType;
                    this.feeMoey = this.sumMoney + "元/月";
                    this.pkUs = this.useXz;
                  }
                }, function (err) {
                  console.log(err);
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    mload: function mload() {
      this.nextEndDates = this.valueTime + "-" + this.dayms;
    },
    onChange: function onChange(index) {
      this.mycarList = [];
      var carCode = "";
      for (var ns in this.comnList) {
        for (var bs in this.comnList[ns].car) {
          carCode = this.comnList[ns].car[bs].pkCode;
          if (index == carCode) {
            var carNos = this.comnList[ns].car[bs].carNo;
            this.mycarList.push(carNos);
          }
        }
        if (index == carCode) {
          this.sDate = this.comnList[ns].park.parkingInfo.endDate;
          this.qsType = this.comnList[ns].park.feeItem.feeName;
          this.useXz = this.comnList[ns].park.parkingInfo.pkUsed;
          this.sumMoney = this.comnList[ns].park.feeRate;
          this.pkId = this.comnList[ns].park.parkingInfo.pkId;
          this.qxTypes = this.comnList[ns].park.parkingInfo.pkOwner;
          this.areaPlace = this.comnList[ns].park.parkingInfo.pkRegion;
          this.feeStandard = this.comnList[ns].park.feeRate;
        }
      }
      this.sMonth = Object(date_format["a" /* default */])(new Date(this.sDate), 'YYYY-MM');
      this.sQx = this.qsType;
      this.feeMoey = this.sumMoney + "元/月";
      this.pkUs = this.useXz;
      this.endDates = this.sDate;

      this.setToday();
    },
    serchDetail: function serchDetail() {
      var url2 = global.host + 'parkinginfo/getParkTopic';
      this.$http.get(url2).then(function (res) {
        this.mycarListInfo = res.body.result;
      }, function (err) {
        console.log(err);
      });

      this.showLog = true;
    },
    cancel: function cancel() {
      this.submitable = false;
    },
    getMonths: function getMonths(date1, date2) {

      date1 = date1.split("-");
      date2 = date2.split("-");

      var year1 = parseInt(date1[0]),
          month1 = parseInt(date1[1]),
          year2 = parseInt(date2[0]),
          month2 = parseInt(date2[1]),
          months = (year2 - year1) * 12 + (month2 - month1);

      this.mousth = months;
      return months;
    },
    subMonths: function subMonths(date, addMonth) {

      /*let s = $(".vux-datetime").find(".vux-cell-value").text(this.mVals)
      console.log(s)*/
      addMonth = parseInt(addMonth);

      date = date.split("-");

      var year = parseInt(date[0]);
      var month = parseInt(date[1]);
      var sumMonth = parseInt(month + addMonth);
      if (sumMonth % 12 == 0) {
        var chushu = sumMonth / 12 - 1;
        year = year + chushu;
        month = sumMonth - 12 * chushu;
      } else if (sumMonth > 12) {
        var chushu = Math.floor(sumMonth / 12);
        year = year + chushu;
        month = sumMonth - 12 * chushu;
      } else {
        month = sumMonth;
      }
      if (month < 10) {
        month = "0" + month;
      }
      return year + "-" + month;
    },
    setPayTime: function setPayTime(time, disType) {

      var timeNum = parseInt(time);
      this.feeBillList = [];
      for (var i = 1; i <= timeNum; i++) {
        var feeObj = new Object();
        feeObj.month = this.subMonths(this.endDates, i);
        this.feeBillList.push(feeObj);
        this.valueTime = feeObj.month;
      }
      this.nextEndDates = this.valueTime + "-" + this.dayms;
      this.totalFeeMoney = this.sumMoney * timeNum;
    },
    setToday: function setToday() {
      var months = this.getMonths(this.endDates, this.valueTime);
      this.setPayTime(months);
    },
    onChangeMonth: function onChangeMonth(mIndex) {
      var timeNum = parseInt(mIndex);
      this.feeBillList = [];
      for (var i = 1; i <= timeNum; i++) {
        var feeObj = new Object();
        feeObj.month = this.subMonths(this.endDates, i);
        this.feeBillList.push(feeObj);
        this.valueTime = feeObj.month;
      }
      this.nextEndDates = this.valueTime + "-" + this.dayms;
      this.totalFeeMoney = this.sumMoney * timeNum;
    },

    /*chanVal(){
    $(".vux-datetime").find(".vux-cell-value").text(this.valueTime);
    },*/
    /*初始化时间选择*/
    getInitSelectDate: function getInitSelectDate() {
      var date = new Date();
      date = new Date(date.getFullYear(), date.getMonth() + 1, date.getDate(), 1);
      this.selectDate[0].push(date.getFullYear());
      this.selectDate[0].push(date.getFullYear() + 1);
      var curM = date.getMonth() + 1;
      this.selectDate[1] = new Array();
      for (var i = curM; i < 13; i++) {
        this.selectDate[1].push(i);
      }
      var curD = date.getDate();
      this.selectDate[2] = new Array();
      for (var n = curD; n < 31; n++) {
        this.selectDate[2].push(n);
      }
    },
    submitBefore: function submitBefore(kId, feeBz, monthCout) {

      var yzUrl = global.host + 'parkFeeBill/findownerunpaidorder?phoneNo=' + this.$router.history.current.query.phone + '&comnCode=' + this.$router.history.current.query.comnCode + '&openid=' + this.$router.history.current.query.openid;
      this.$http.get(yzUrl).then(function (res) {
        if (res.body.code == '110') {

          var usinfo = new Object();
          usinfo.comnCode = this.$router.history.current.query.comnCode;
          usinfo.pkId = kId;
          usinfo.feePrice = feeBz;
          usinfo.feeCount = monthCout;
          usinfo.discType = this.disTypes;
          usinfo.freeMonth = 0;
          usinfo.discMoney = 0;
          usinfo.realMoney = this.totalFeeMoney;
          usinfo.startDate = this.endDates;
          usinfo.openId = this.$router.history.current.query.openid;
          usinfo.mainPhone = this.$router.history.current.query.phone;

          var urls = global.host + 'parkFeeBill/addParkFeeBill';
          this.$http.post(urls, usinfo).then(function (res) {
            var statuCodes = res.body.statusCode;

            if (statuCodes == '110') {
              this.billCode = res.body.result.billCode;
              console.log(res);
              this.gopay();
            } else if (statuCodes == '120') {
              this.feeShow = true;
              this.dailogMessage = "提交失败";
            }
          }, function (err) {
            console.log(err);
          });
        } else if (res.body.code == '120') {
          this.dailogMessage = '您有未处理的订单,请优先处理';
          this.feeShow = true;
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*去支付方法*/
    gopay: function gopay() {
      var senddata = new Object();
      senddata.comnCode = this.$router.history.current.query.comnCode;
      senddata.memberNo = this.$router.history.current.query.phone;
      senddata.openid = this.$router.history.current.query.openid;
      senddata.tradeAmount = this.totalFeeMoney;
      senddata.tradeNo = this.billCode;
      senddata.tradeName = '车位费';
      senddata.tradeDesc = '车位费';
      console.log(senddata);
      var url = global.host + 'parkFeeBill/getpayurl';
      this.$http.post(url, senddata).then(function (res) {
        if (res.body.code == '110') {
          location.href = res.body.payurl;
        } else {
          this.feeShow = true;
          this.dailogMessage = "支付异常,请稍候再试";
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*根据不同的操作进行操作*/
    refresh: function refresh() {
      if (this.dailogMessage == '您有未处理的订单,请优先处理') {
        this.submitable = true;
        this.$router.push({ path: '/paymentRecord', query: { openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone } });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b742776","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carRentComponents/carPayComFee.vue
var carPayComFee_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",staticStyle:{"overflow-x":"hidden"}},[_c('div',{staticClass:"am_zfont"},[_c('popup-picker',{attrs:{"title":"车位信息","data":_vm.list_1},on:{"on-change":_vm.onChange},model:{value:(_vm.value_1),callback:function ($$v) {_vm.value_1=$$v},expression:"value_1"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"权属类型","text-align":"right","disabled":""},model:{value:(_vm.qxTypes),callback:function ($$v) {_vm.qxTypes=$$v},expression:"qxTypes"}}),_vm._v(" "),_c('datetime',{staticClass:"texrt am_abtom",attrs:{"format":"YYYY-MM","placeholder":"请选择要缴费日期","title":"新到期时间"},on:{"on-change":_vm.setToday,"on-confirm":_vm.mload},model:{value:(_vm.valueTime),callback:function ($$v) {_vm.valueTime=$$v},expression:"valueTime"}}),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{attrs:{"span":1/2}},[_c('x-input',{attrs:{"title":"区域","text-align":"right","disabled":""},model:{value:(_vm.areaPlace),callback:function ($$v) {_vm.areaPlace=$$v},expression:"areaPlace"}})],1),_vm._v(" "),_c('flexbox-item',{staticStyle:{"border-left":"1px solid #ddd"},attrs:{"span":1/2}},[_c('x-input',{attrs:{"title":"收费标准","text-align":"right","disabled":""},model:{value:(_vm.feeStandard),callback:function ($$v) {_vm.feeStandard=$$v},expression:"feeStandard"}})],1)],1),_vm._v(" "),_c('x-input',{attrs:{"title":"车辆信息","text-align":"right","disabled":""},model:{value:(_vm.mycarList),callback:function ($$v) {_vm.mycarList=$$v},expression:"mycarList"}})],1),_vm._v(" "),_c('div',{staticClass:"am_nent"},[_c('x-input',{staticClass:"timeInfo texrt am_abtom",attrs:{"title":"到期时间","text-align":"right","disabled":""},model:{value:(_vm.endDates),callback:function ($$v) {_vm.endDates=$$v},expression:"endDates"}}),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","margin":"0 auto"}},[_c('div',{staticStyle:{"height":"10px"}}),_vm._v(" "),_c('ul',{staticClass:"am_ulist fix"},_vm._l((_vm.myTime),function(item2,index){return _c('li',{key:index},[_c('x-button',{staticClass:"amIndexs",attrs:{"type":"primary","plain":""},nativeOn:{"click":function($event){_vm.setPayTime(item2.baseRate,item2.discType)}}},[_vm._v(_vm._s(item2.discName))])],1)})),_vm._v(" "),_c('popup-picker',{staticStyle:{"font-size":"17px"},attrs:{"title":"续费月数","data":_vm.allMonth},on:{"on-change":function($event){_vm.onChangeMonth(_vm.mousth1)}},model:{value:(_vm.mousth1),callback:function ($$v) {_vm.mousth1=$$v},expression:"mousth1"}})],1),_vm._v(" "),_c('x-input',{staticClass:"texrt am_abtom",staticStyle:{"font-size":"17px"},attrs:{"title":"续费至","text-align":"right","disabled":""},model:{value:(_vm.nextEndDates),callback:function ($$v) {_vm.nextEndDates=$$v},expression:"nextEndDates"}}),_vm._v(" "),_c('flexbox',{staticClass:"totalMoney allBmoney",attrs:{"orient":"horizontal","gutter":0}},[_c('flexbox-item',{staticStyle:{"display":"flex","justify-content":"flex-start"}},[_vm._v("\n        费用合计：\n        ")]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"display":"flex","justify-content":"flex-end"}},[_c('p',{staticClass:"total_in"},[_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.totalFeeMoney))]),_vm._v("元")])])],1)],1),_vm._v(" "),_c('alert',{staticClass:"am_alert_cont",attrs:{"button-text":"关闭"},model:{value:(_vm.showLog),callback:function ($$v) {_vm.showLog=$$v},expression:"showLog"}},[_c('h1',{staticClass:"am_font1"},[_vm._v("收费标准")]),_vm._v(" "),_c('group',[_c('ul',[_c('li',{staticClass:"am_font2"},[_vm._v("权属类型")]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v("区域")]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v("价格")])])]),_vm._v(" "),_vm._l((_vm.mycarListInfo),function(item1,index){return _c('ul',{key:index},[_c('li',{staticClass:"am_font2"},[_vm._v(_vm._s(item1.feeName))]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v(_vm._s(item1.pValue))]),_vm._v(" "),_c('li',{staticClass:"am_font2"},[_vm._v(_vm._s(item1.feeRate)+"/月")])])})],2),_vm._v(" "),_c('div',{staticClass:"am_absolt"},[_c('x-button',{attrs:{"type":"primary","disabled":_vm.submitable},nativeOn:{"click":function($event){_vm.show = true;_vm.myDilogs = "确认提交吗？"}}},[_vm._v("提交订单")])],1),_vm._v(" "),_c('confirm',{attrs:{"title":"操作提示","confirm-text":"确认"},on:{"on-confirm":function($event){_vm.submitBefore(_vm.pkId,_vm.sumMoney,_vm.mousth)}},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v("\n    "+_vm._s(_vm.myDilogs)+"\n  ")]),_vm._v(" "),_c('group',[_c('alert',{attrs:{"title":"温馨提示"},on:{"on-hide":_vm.refresh},model:{value:(_vm.feeShow),callback:function ($$v) {_vm.feeShow=$$v},expression:"feeShow"}},[_vm._v(_vm._s(_vm.dailogMessage))])],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var carPayComFee_staticRenderFns = []
var carPayComFee_esExports = { render: carPayComFee_render, staticRenderFns: carPayComFee_staticRenderFns }
/* harmony default export */ var components_carRentComponents_carPayComFee = (carPayComFee_esExports);
// CONCATENATED MODULE: ./src/components/carRentComponents/carPayComFee.vue
function carPayComFee_injectStyle (ssrContext) {
  __webpack_require__("90XA")
}
var carPayComFee_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var carPayComFee___vue_template_functional__ = false
/* styles */
var carPayComFee___vue_styles__ = carPayComFee_injectStyle
/* scopeId */
var carPayComFee___vue_scopeId__ = "data-v-9b742776"
/* moduleIdentifier (server only) */
var carPayComFee___vue_module_identifier__ = null
var carPayComFee_Component = carPayComFee_normalizeComponent(
  carRentComponents_carPayComFee,
  components_carRentComponents_carPayComFee,
  carPayComFee___vue_template_functional__,
  carPayComFee___vue_styles__,
  carPayComFee___vue_scopeId__,
  carPayComFee___vue_module_identifier__
)

/* harmony default export */ var src_components_carRentComponents_carPayComFee = (carPayComFee_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-368ae452","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/search/index.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-search-box",class:{ 'vux-search-fixed':_vm.isFixed },style:({ top: _vm.isFixed ? _vm.top : '', position: _vm.fixPosition })},[_c('div',{staticClass:"weui-search-bar",class:{'weui-search-bar_focusing': !_vm.isCancel || _vm.currentValue}},[_vm._t("left"),_vm._v(" "),_c('form',{staticClass:"weui-search-bar__form",attrs:{"action":"."},on:{"submit":function($event){$event.preventDefault();_vm.$emit('on-submit', _vm.value)}}},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFixed && _vm.autoFixed),expression:"!isFixed && autoFixed"}],staticClass:"vux-search-mask",attrs:{"for":("search_input_" + _vm.uuid)},on:{"click":_vm.touch}}),_vm._v(" "),_c('div',{staticClass:"weui-search-bar__box"},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"type":"search","autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){_vm.onComposition($event, 'start')},"compositionend":function($event){_vm.onComposition($event, 'end')},"input":[function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value},function($event){_vm.onComposition($event, 'input')}]}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-icon-clear",attrs:{"href":"javascript:"},on:{"click":_vm.clear}})]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFocus && !_vm.value),expression:"!isFocus && !value"}],staticClass:"weui-search-bar__label",attrs:{"for":("search_input_" + _vm.uuid)}},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.placeholder || '搜索'))])])]),_vm._v(" "),_c('a',{staticClass:"weui-search-bar__cancel-btn",attrs:{"href":"javascript:"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText || '取消')+"\n    ")]),_vm._v(" "),_vm._t("right")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFixed),expression:"isFixed"}],staticClass:"weui-cells vux-search_show"},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.results),function(item){return _c('div',{staticClass:"weui-cell weui-cell_access",on:{"click":function($event){_vm.handleResultClick(item)}}},[_c('div',{staticClass:"weui-cell__bd weui-cell_primary"},[_c('p',[_vm._v(_vm._s(item.title))])])])})],2)])}
var search_staticRenderFns = []
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var src_components_search = (search_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/search/index.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("oYIu")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  components_search,
  src_components_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_search = (search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var components_inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79b35668","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-loading/index.vue
var inline_loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"weui-loading"})}
var inline_loading_staticRenderFns = []
var inline_loading_esExports = { render: inline_loading_render, staticRenderFns: inline_loading_staticRenderFns }
/* harmony default export */ var src_components_inline_loading = (inline_loading_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-loading/index.vue
function inline_loading_injectStyle (ssrContext) {
  __webpack_require__("eVeh")
}
var inline_loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_loading___vue_template_functional__ = false
/* styles */
var inline_loading___vue_styles__ = inline_loading_injectStyle
/* scopeId */
var inline_loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_loading___vue_module_identifier__ = null
var inline_loading_Component = inline_loading_normalizeComponent(
  components_inline_loading,
  src_components_inline_loading,
  inline_loading___vue_template_functional__,
  inline_loading___vue_styles__,
  inline_loading___vue_scopeId__,
  inline_loading___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_loading = (inline_loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/fleaMarketList.vue














/* harmony default export */ var fleaMarketList = ({
  data: function data() {
    return {
      swiperOption: {
        direction: 'horizontal',
        spaceBetween: 12,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: false
        } },
      show_1: false,
      fiterShow: false,
      value: '',
      surc: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg',
      smc: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg',
      srcs: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg",
      surc1: 'http://i1.hexunimg.cn/2014-12-30/171900456.jpg',
      srcs1: 'http://i1.hexunimg.cn/2014-12-30/171900456.jpg',
      imgs: ['http://covteam.u.qiniudn.com/test16.jpg?imageView2/2/format/webp', 'http://covteam.u.qiniudn.com/test16.jpg?imageView2/2/format/webp', 'http://covteam.u.qiniudn.com/test16.jpg?imageView2/2/format/webp'],
      titles: ['新鲜', '本小区', '电器'],
      list2: [],
      filter1: [],
      filter2: [],
      filter3: [],
      picList: [],
      value1: '',
      value2: '',
      value3: '',

      openid: '',
      comnCode: '',
      phone: '',
      comnName: '',
      num: 0,
      data: [],
      msDate: 1,
      nIndex: '',
      fliterIds: '',
      fliterTypes: ''
    };
  },

  components: {
    XButton: vux_src_components_x_button,
    XHeader: vux_src_components_x_header,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Search: vux_src_components_search,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    XImg: vux_src_components_x_img,
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    InlineLoading: vux_src_components_inline_loading,
    loadPage: src_components_loadingPage
  },
  mounted: function mounted() {
    this.openid = this.$router.history.current.query.openid;
    this.phone = this.$router.history.current.query.phone;
    this.comnCode = this.$router.history.current.query.comnCode;
    this.comnName = this.$router.history.current.query.communityName;
    var sels = this;

    mobilwmtouch(document.getElementById("g1"));
    document.getElementById("g1").addEventListener('touup', this.touchup, false);
    function mobilwmtouch(obj) {
      var stoux, stouy;
      var etoux, etouy;
      var xdire, ydire;
      obj.addEventListener("touchstart", function (e) {
        stoux = e.targetTouches[0].clientX;
        stouy = e.targetTouches[0].clientY;
      }, false);
      obj.addEventListener("touchend", function (e) {
        etoux = e.changedTouches[0].clientX;
        etouy = e.changedTouches[0].clientY;
        xdire = etoux - stoux;
        ydire = etouy - stouy;
        var chazhi = Math.abs(xdire) - Math.abs(ydire);

        if (xdire > 0 && chazhi > 0) {
          console.log("right");

          obj.dispatchEvent(evenzc('touright'));
        } else if (ydire > 0 && chazhi < 0) {
          console.log("down");
          obj.dispatchEvent(evenzc('toudown'));
        } else if (xdire < 0 && chazhi > 0) {
          console.log("left");
          obj.dispatchEvent(evenzc('touleft'));
        } else if (ydire < 0 && chazhi < 0) {
          console.log("up");
          obj.dispatchEvent(evenzc('touup'));
        }
      }, false);
    }

    function evenzc(eve) {
      var event = '';
      if (typeof document.CustomEvent === 'function') {
        event = new document.CustomEvent(eve, { //自定义事件名称
          bubbles: false, //是否冒泡
          cancelable: false
        });
        if (!document["evetself" + eve]) {
          document["evetself" + eve] = event;
        }
      } else if (typeof document.createEvent === 'function') {
        event = document.createEvent('HTMLEvents');
        event.initEvent(eve, false, false);
        if (!document["evetself" + eve]) {
          document["evetself" + eve] = event;
        }
      } else {
        return false;
      }

      return document["evetself" + eve];
    }
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/fleaMarketList") {
      document.title = "二手市场";
    }
    this.loadData(0, 0, 1);
  },

  methods: {
    touchup: function touchup() {
      $(".am_absolt").show();
      this.msDate++;
      console.log(this.msDate);
      this.loadData(this.msDate, 1, this.msDate);
      this.moreList(this.msDate, 1, this.msDate);
    },
    tabExchange: function tabExchange(index) {
      //标签切换
      this.nIndex = index;
      var size = this.picList.length;
      for (var i = 0; i < size; i++) {
        this.picList.pop();
      }
      if (index > 1) {
        this.moreList(index, 1, 1);
      } else {
        this.loadData(index, 0, 1);
      }
    },
    getResult: function getResult() {
      var size = this.picList.length;
      for (var i = 0; i < size; i++) {
        this.picList.pop();
      }

      this.loadData(this.nIndex, 1, 1);
    },
    showFilter: function showFilter() {

      this.fiterShow = true;
      this.loadData(0, 0, 1);
      var selfs = this;

      $("#am_select1").find("button").click(function () {
        $(this).addClass("weui-btn_primary").siblings("button").removeClass("weui-btn_primary");
        selfs.value1 = $(this).html();
      });
      $("#am_select2").find("button").click(function () {
        $(this).addClass("weui-btn_primary").siblings("button").removeClass("weui-btn_primary");
        selfs.value2 = $(this).html();
      });
      $("#am_select3").find("button").click(function () {
        $(this).addClass("weui-btn_primary").siblings("button").removeClass("weui-btn_primary");
        selfs.value3 = $(this).html();
      });

      $("#am_reset").click(function () {
        $(".am_button").find("button").removeClass("weui-btn_primary");
      });
    },
    selectTia: function selectTia() {
      this.picList = [];

      this.loadData(this.nIndex, 1, 1);
      this.fiterShow = false;
    },
    moreList: function moreList(index, flag, pages) {
      this.show_1 = true;

      var jsonData = {
        firstflag: flag,
        filters: [{
          filterId: this.fliterIds,
          filterType: this.fliterTypes
        }],
        page: pages,
        rows: 3,
        isOffline: 0,
        goodsState: 2
      };
      console.log("$$$$$$$$$$$$$$$$$$$$$$");
      console.log(jsonData);
      var url = global.host + 'secondMarket/findgoodslist';
      this.$http.post(url, jsonData).then(function (res) {

        var picList = res.body.goods;
        for (var mv in picList) {
          if (picList[mv].imgs.length > 0) {
            for (var nv in picList[mv].imgs) {
              picList[mv].imgs[nv].minPicUrl = global.baseImg + picList[mv].imgs[nv].minPicUrl;
              picList[mv].imgs[nv].maxPicUrl = global.baseImg + picList[mv].imgs[nv].maxPicUrl;
            }
          }
          this.picList.push(picList[mv]);
        }

        this.show_1 = false;
        $(".am_absolt").hide();

        if (jsonData.rows != res.body.goods.length) {
          document.getElementById("g1").removeEventListener('touup', this.touchup);
        }
      }, function (err) {
        console.log(err);
      });
    },
    loadData: function loadData(index, flag, pages) {
      //获取数据方法
      this.show_1 = true;

      var comnCodes = '';
      if (index == 0) {
        comnCodes = '';
      } else if (index == 1) {
        comnCodes = this.comnCode;
      }
      var jsonData = {
        goodsName: this.value,
        comnCode: comnCodes,
        firstflag: flag,
        filters: [{
          filterId: $("#am_select3").find("button.weui-btn_primary").siblings(".am_nlow3").text(),
          filterType: $("#am_select3").find("button.weui-btn_primary").siblings(".am_nlow4").text()
        }, {
          filterId: $("#am_select2").find("button.weui-btn_primary").siblings(".am_nlow3").text(),
          filterType: $("#am_select2").find("button.weui-btn_primary").siblings(".am_nlow4").text(),
          filterRule: $("#am_select2").find("button.weui-btn_primary").siblings(".am_nlow1").text(),
          filterValue: $("#am_select2").find("button.weui-btn_primary").siblings(".am_nlow2").text()
        }, {
          filterId: $("#am_select1").find("button.weui-btn_primary").siblings(".am_nlow3").text(),
          filterType: $("#am_select1").find("button.weui-btn_primary").siblings(".am_nlow4").text()
        }],
        page: pages,
        rows: 3,
        isOffline: 0,
        goodsState: 2
      };
      console.log("$$$$$$$$$$$$$$$$$$$$$$");
      console.log(jsonData);
      var url = global.host + 'secondMarket/findgoodslist';
      this.$http.post(url, jsonData).then(function (res) {

        var picList = res.body.goods;
        for (var mv in picList) {
          if (picList[mv].imgs.length > 0) {
            for (var nv in picList[mv].imgs) {
              picList[mv].imgs[nv].minPicUrl = global.baseImg + picList[mv].imgs[nv].minPicUrl;
              picList[mv].imgs[nv].maxPicUrl = global.baseImg + picList[mv].imgs[nv].maxPicUrl;
            }
          }
          this.picList.push(picList[mv]);
        }

        this.show_1 = false;
        $(".am_absolt").hide();

        var mlist = res.body;
        this.filter1 = new Object();
        this.filter2 = new Object();
        this.filter3 = new Object();
        var st = '';
        var sId = '';
        var types = '';
        for (var s in mlist[1]) {
          this.filter1[s] = mlist[1][s];
          st = mlist[1][s].filterName;
          sId = mlist[1][s].filterId;
          types = mlist[1][s].filterType;
        }

        this.titles[2] = st;
        this.fliterIds = sId;
        this.fliterTypes = types;
        console.log(this.titles);

        for (var m in mlist[2]) {
          this.filter2[m] = mlist[2][m];
        }
        for (var n in mlist[3]) {
          this.filter3[n] = mlist[3][n];
        }
        if (jsonData.rows != res.body.goods.length) {
          document.getElementById("g1").removeEventListener('touup', this.touchup);
        }
      }, function (err) {
        console.log(err);
      });
    }
  }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/fleaMarketList.vue














/* harmony default export */ var fleaMarketComponents_fleaMarketList = ({
  data: function data() {
    return {
      swiperOption: {
        direction: 'horizontal',
        spaceBetween: 12,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: false
        } },
      show_1: false,
      fiterShow: false,
      value: '',
      surc: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg',
      smc: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg',
      srcs: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg",
      surc1: 'http://i1.hexunimg.cn/2014-12-30/171900456.jpg',
      srcs1: 'http://i1.hexunimg.cn/2014-12-30/171900456.jpg',
      imgs: ['http://covteam.u.qiniudn.com/test16.jpg?imageView2/2/format/webp', 'http://covteam.u.qiniudn.com/test16.jpg?imageView2/2/format/webp', 'http://covteam.u.qiniudn.com/test16.jpg?imageView2/2/format/webp'],
      titles: ['新鲜', '本小区', '电器'],
      list2: [],
      filter1: [],
      filter2: [],
      filter3: [],
      picList: [],
      value1: '',
      value2: '',
      value3: '',

      openid: '',
      comnCode: '',
      phone: '',
      comnName: '',
      num: 0,
      data: [],
      msDate: 1,
      nIndex: '',
      fliterIds: '',
      fliterTypes: ''
    };
  },

  components: {
    XButton: vux_src_components_x_button,
    XHeader: vux_src_components_x_header,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Search: vux_src_components_search,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    XImg: vux_src_components_x_img,
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    InlineLoading: vux_src_components_inline_loading,
    loadPage: src_components_loadingPage
  },
  mounted: function mounted() {
    this.openid = this.$router.history.current.query.openid;
    this.phone = this.$router.history.current.query.phone;
    this.comnCode = this.$router.history.current.query.comnCode;
    this.comnName = this.$router.history.current.query.communityName;
    var sels = this;

    mobilwmtouch(document.getElementById("g1"));
    document.getElementById("g1").addEventListener('touup', this.touchup, false);
    function mobilwmtouch(obj) {
      var stoux, stouy;
      var etoux, etouy;
      var xdire, ydire;
      obj.addEventListener("touchstart", function (e) {
        stoux = e.targetTouches[0].clientX;
        stouy = e.targetTouches[0].clientY;
      }, false);
      obj.addEventListener("touchend", function (e) {
        etoux = e.changedTouches[0].clientX;
        etouy = e.changedTouches[0].clientY;
        xdire = etoux - stoux;
        ydire = etouy - stouy;
        var chazhi = Math.abs(xdire) - Math.abs(ydire);

        if (xdire > 0 && chazhi > 0) {
          console.log("right");

          obj.dispatchEvent(evenzc('touright'));
        } else if (ydire > 0 && chazhi < 0) {
          console.log("down");
          obj.dispatchEvent(evenzc('toudown'));
        } else if (xdire < 0 && chazhi > 0) {
          console.log("left");
          obj.dispatchEvent(evenzc('touleft'));
        } else if (ydire < 0 && chazhi < 0) {
          console.log("up");
          obj.dispatchEvent(evenzc('touup'));
        }
      }, false);
    }

    function evenzc(eve) {
      var event = '';
      if (typeof document.CustomEvent === 'function') {
        event = new document.CustomEvent(eve, { //自定义事件名称
          bubbles: false, //是否冒泡
          cancelable: false
        });
        if (!document["evetself" + eve]) {
          document["evetself" + eve] = event;
        }
      } else if (typeof document.createEvent === 'function') {
        event = document.createEvent('HTMLEvents');
        event.initEvent(eve, false, false);
        if (!document["evetself" + eve]) {
          document["evetself" + eve] = event;
        }
      } else {
        return false;
      }

      return document["evetself" + eve];
    }
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/fleaMarketList") {
      document.title = "二手市场";
    }
    this.loadData(0, 0, 1);
  },

  methods: {
    touchup: function touchup() {
      $(".am_absolt").show();
      this.msDate++;
      console.log(this.msDate);
      this.loadData(this.msDate, 1, this.msDate);
      this.moreList(this.msDate, 1, this.msDate);
    },
    tabExchange: function tabExchange(index) {
      //标签切换
      this.nIndex = index;
      var size = this.picList.length;
      for (var i = 0; i < size; i++) {
        this.picList.pop();
      }
      if (index > 1) {
        this.moreList(index, 1, 1);
      } else {
        this.loadData(index, 0, 1);
      }
    },
    getResult: function getResult() {
      var size = this.picList.length;
      for (var i = 0; i < size; i++) {
        this.picList.pop();
      }

      this.loadData(this.nIndex, 1, 1);
    },
    showFilter: function showFilter() {

      this.fiterShow = true;
      this.loadData(0, 0, 1);
      var selfs = this;

      $("#am_select1").find("button").click(function () {
        $(this).addClass("weui-btn_primary").siblings("button").removeClass("weui-btn_primary");
        selfs.value1 = $(this).html();
      });
      $("#am_select2").find("button").click(function () {
        $(this).addClass("weui-btn_primary").siblings("button").removeClass("weui-btn_primary");
        selfs.value2 = $(this).html();
      });
      $("#am_select3").find("button").click(function () {
        $(this).addClass("weui-btn_primary").siblings("button").removeClass("weui-btn_primary");
        selfs.value3 = $(this).html();
      });

      $("#am_reset").click(function () {
        $(".am_button").find("button").removeClass("weui-btn_primary");
      });
    },
    selectTia: function selectTia() {
      this.picList = [];

      this.loadData(this.nIndex, 1, 1);
      this.fiterShow = false;
    },
    moreList: function moreList(index, flag, pages) {
      this.show_1 = true;

      var jsonData = {
        firstflag: flag,
        filters: [{
          filterId: this.fliterIds,
          filterType: this.fliterTypes
        }],
        page: pages,
        rows: 3,
        isOffline: 0,
        goodsState: 2
      };
      console.log("$$$$$$$$$$$$$$$$$$$$$$");
      console.log(jsonData);
      var url = global.host + 'secondMarket/findgoodslist';
      this.$http.post(url, jsonData).then(function (res) {

        var picList = res.body.goods;
        for (var mv in picList) {
          if (picList[mv].imgs.length > 0) {
            for (var nv in picList[mv].imgs) {
              picList[mv].imgs[nv].minPicUrl = global.baseImg + picList[mv].imgs[nv].minPicUrl;
              picList[mv].imgs[nv].maxPicUrl = global.baseImg + picList[mv].imgs[nv].maxPicUrl;
            }
          }
          this.picList.push(picList[mv]);
        }

        this.show_1 = false;
        $(".am_absolt").hide();

        if (jsonData.rows != res.body.goods.length) {
          document.getElementById("g1").removeEventListener('touup', this.touchup);
        }
      }, function (err) {
        console.log(err);
      });
    },
    loadData: function loadData(index, flag, pages) {
      //获取数据方法
      this.show_1 = true;

      var comnCodes = '';
      if (index == 0) {
        comnCodes = '';
      } else if (index == 1) {
        comnCodes = this.comnCode;
      }
      var jsonData = {
        goodsName: this.value,
        comnCode: comnCodes,
        firstflag: flag,
        filters: [{
          filterId: $("#am_select3").find("button.weui-btn_primary").siblings(".am_nlow3").text(),
          filterType: $("#am_select3").find("button.weui-btn_primary").siblings(".am_nlow4").text()
        }, {
          filterId: $("#am_select2").find("button.weui-btn_primary").siblings(".am_nlow3").text(),
          filterType: $("#am_select2").find("button.weui-btn_primary").siblings(".am_nlow4").text(),
          filterRule: $("#am_select2").find("button.weui-btn_primary").siblings(".am_nlow1").text(),
          filterValue: $("#am_select2").find("button.weui-btn_primary").siblings(".am_nlow2").text()
        }, {
          filterId: $("#am_select1").find("button.weui-btn_primary").siblings(".am_nlow3").text(),
          filterType: $("#am_select1").find("button.weui-btn_primary").siblings(".am_nlow4").text()
        }],
        page: pages,
        rows: 3,
        isOffline: 0,
        goodsState: 2
      };
      console.log("$$$$$$$$$$$$$$$$$$$$$$");
      console.log(jsonData);
      var url = global.host + 'secondMarket/findgoodslist';
      this.$http.post(url, jsonData).then(function (res) {

        var picList = res.body.goods;
        for (var mv in picList) {
          if (picList[mv].imgs.length > 0) {
            for (var nv in picList[mv].imgs) {
              picList[mv].imgs[nv].minPicUrl = global.baseImg + picList[mv].imgs[nv].minPicUrl;
              picList[mv].imgs[nv].maxPicUrl = global.baseImg + picList[mv].imgs[nv].maxPicUrl;
            }
          }
          this.picList.push(picList[mv]);
        }

        this.show_1 = false;
        $(".am_absolt").hide();

        var mlist = res.body;
        this.filter1 = new Object();
        this.filter2 = new Object();
        this.filter3 = new Object();
        var st = '';
        var sId = '';
        var types = '';
        for (var s in mlist[1]) {
          this.filter1[s] = mlist[1][s];
          st = mlist[1][s].filterName;
          sId = mlist[1][s].filterId;
          types = mlist[1][s].filterType;
        }

        this.titles[2] = st;
        this.fliterIds = sId;
        this.fliterTypes = types;
        console.log(this.titles);

        for (var m in mlist[2]) {
          this.filter2[m] = mlist[2][m];
        }
        for (var n in mlist[3]) {
          this.filter3[n] = mlist[3][n];
        }
        if (jsonData.rows != res.body.goods.length) {
          document.getElementById("g1").removeEventListener('touup', this.touchup);
        }
      }, function (err) {
        console.log(err);
      });
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fbeb91a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fleaMarketComponents/fleaMarketList.vue
var fleaMarketList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body_bg"},[_c('flexbox',{staticClass:"am_boxTop",attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_fiters",attrs:{"span":1/6}},[_c('div',{staticClass:"am_aStyle am_display_sx",on:{"click":_vm.showFilter}},[_c('img',{attrs:{"src":__webpack_require__("j7d7"),"alt":""}})])]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_relative",attrs:{"span":4/6}},[_c('div',{staticStyle:{"display":"flex","height":"30px","border":"1px solid #dedede","border-radius":"10px","line-height":"30px"}},[_c('i',{staticClass:"fa  fa-search",staticStyle:{"width":"30px","height":"18px","font-size":"16px !important","padding":"6px 0 6px 10px","color":"#999"},on:{"click":function($event){_vm.getResult()}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticStyle:{"height":"30px","line-height":"30px","text-align":"center"},attrs:{"type":"text"},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/6}},[_c('router-link',{staticClass:"am_send",attrs:{"to":{path:'/marketResend',query:{openid:_vm.openid,phone:_vm.phone,comnCode:_vm.comnCode,comnName:_vm.comnName}}}},[_vm._v("\n        去发布\n      ")])],1)],1),_vm._v(" "),_c('tab',{staticClass:"mtop",attrs:{"line-width":3}},_vm._l((_vm.titles),function(item,index){return _c('tab-item',{key:index,attrs:{"selected":index===0},on:{"on-item-click":function($event){_vm.tabExchange(index)}}},[_vm._v(_vm._s(item))])})),_vm._v(" "),_c('div',{attrs:{"id":"g1"}},[_c('div',{staticClass:"contBox"},_vm._l((_vm.picList),function(items,index){return _c('div',{key:index,staticClass:"listCont"},[_c('router-link',{attrs:{"to":{path:'/marketDetailList',query:{goodsId:items.goodsId,phone:items.telePhone,phones:_vm.phone}}}},[_c('flexbox',{staticClass:"am_com_botom",attrs:{"gutter":0,"align":"center"}},[_c('flexbox-item',{staticClass:"am_centent",attrs:{"span":3/4}},[_c('span',{staticClass:"autherSrc"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(items.memberIcon),expression:"items.memberIcon"}]})]),_vm._v(" "),_c('div',{staticClass:"autherTitle"},[_c('div',{staticClass:"am_pstyle"},[_c('strong',[_vm._v(_vm._s(items.contactMan))])]),_vm._v(" "),_c('div',{staticClass:"am_pstyle"},[_c('div',{staticClass:"am_circle"}),_vm._v(_vm._s(items.createDate))]),_vm._v(" "),_c('div',{staticClass:"am_display_sx"},[_c('h1',[_vm._v(_vm._s(items.comnName))])])])]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_list_n",attrs:{"span":1/4}},[_c('span',{staticClass:"am_color"},[_c('b',[_vm._v("￥")]),_vm._v(_vm._s(items.salePrice))]),_vm._v(" "),_c('x-button',{staticClass:"btn_style",attrs:{"type":"warn","mini":""}},[_vm._v(_vm._s(items.goodsLoss))])],1)],1),_vm._v(" "),_c('flexbox',{staticClass:"am_com_botom am_pds",attrs:{"gutter":0,"align":"center","orient":"vertical"}},[_c('flexbox-item',{staticClass:"selects_mk"},[_c('strong',[_vm._v(_vm._s(items.goodsDesc))])]),_vm._v(" "),_c('flexbox-item',{staticClass:"select_nv"},[(items.imgs.length>0)?_c('swiper',{attrs:{"options":_vm.swiperOption}},_vm._l((items.imgs),function(itemd,index){return _c('swiper-slide',{key:index,staticClass:"am_switer"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(itemd.minPicUrl),expression:"itemd.minPicUrl"}]})])})):_vm._e()],1)],1)],1)],1)}))]),_vm._v(" "),_c('div',{staticClass:"am_absolt"},[_c('inline-loading'),_vm._v(" "),_c('span',{staticStyle:{"vertical-align":"middle","display":"inline-block","font-size":"14px"}},[_vm._v("加载中...")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fiterShow),expression:"fiterShow"}],staticClass:"filterPage"},[_c('flexbox',{staticStyle:{"background":"#fff"},attrs:{"gutter":0,"orient":"vertical"}},[_c('flexbox-item',{staticClass:"am_com_area"},[_c('h2',[_vm._v("商品类别")]),_vm._v(" "),_c('div',{staticClass:"am_button fix",attrs:{"id":"am_select3"}},_vm._l((_vm.filter1),function(item,index){return (item.filterType == '1')?_c('div',{key:index,staticStyle:{"float":"left","width":"auto"}},[_c('x-button',{attrs:{"type":"default","mini":""}},[_vm._v(_vm._s(item.filterName))]),_vm._v(" "),_c('div',{staticClass:"am_nlow3"},[_vm._v(_vm._s(item.filterId))]),_vm._v(" "),_c('div',{staticClass:"am_nlow4"},[_vm._v(_vm._s(item.filterType))])],1):_vm._e()})),_vm._v(" "),_c('h2',[_vm._v("价格区间")]),_vm._v(" "),_c('div',{staticClass:"am_button  fix",attrs:{"id":"am_select2"}},_vm._l((_vm.filter2),function(item,index){return (item.filterType == '2')?_c('div',{key:index,staticStyle:{"float":"left","width":"auto"}},[_c('x-button',{attrs:{"type":"default","mini":""}},[_vm._v(_vm._s(item.filterName))]),_vm._v(" "),_c('div',{staticClass:"am_nlow1"},[_vm._v(_vm._s(item.filterRule))]),_vm._v(" "),_c('div',{staticClass:"am_nlow2"},[_vm._v(_vm._s(item.filterValue))]),_vm._v(" "),_c('div',{staticClass:"am_nlow4"},[_vm._v(_vm._s(item.filterType))]),_vm._v(" "),_c('div',{staticClass:"am_nlow3"},[_vm._v(_vm._s(item.filterId))])],1):_vm._e()})),_vm._v(" "),_c('h2',[_vm._v("新旧程度")]),_vm._v(" "),_c('div',{staticClass:"am_button  fix",attrs:{"id":"am_select1"}},_vm._l((_vm.filter3),function(item,index){return (item.filterType == '3')?_c('div',{key:index,staticStyle:{"float":"left","width":"auto"}},[_c('x-button',{attrs:{"type":"default","mini":""}},[_vm._v(_vm._s(item.filterName))]),_vm._v(" "),_c('div',{staticClass:"am_nlow3"},[_vm._v(_vm._s(item.filterId))]),_vm._v(" "),_c('div',{staticClass:"am_nlow4"},[_vm._v(_vm._s(item.filterType))])],1):_vm._e()}))])],1),_vm._v(" "),_c('flexbox',{staticClass:"am_select_botom",attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_flex_cent",attrs:{"span":1/2,"id":"am_reset"}},[_c('x-button',{attrs:{"type":"default"}},[_vm._v("重置")])],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_flex_cent",attrs:{"span":1/2}},[_c('x-button',{attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.selectTia($event)}}},[_vm._v("筛选")])],1)],1)],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var fleaMarketList_staticRenderFns = []
var fleaMarketList_esExports = { render: fleaMarketList_render, staticRenderFns: fleaMarketList_staticRenderFns }
/* harmony default export */ var components_fleaMarketComponents_fleaMarketList = (fleaMarketList_esExports);
// CONCATENATED MODULE: ./src/components/fleaMarketComponents/fleaMarketList.vue
function fleaMarketList_injectStyle (ssrContext) {
  __webpack_require__("zDjd")
}
var fleaMarketList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var fleaMarketList___vue_template_functional__ = false
/* styles */
var fleaMarketList___vue_styles__ = fleaMarketList_injectStyle
/* scopeId */
var fleaMarketList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var fleaMarketList___vue_module_identifier__ = null
var fleaMarketList_Component = fleaMarketList_normalizeComponent(
  fleaMarketComponents_fleaMarketList,
  components_fleaMarketComponents_fleaMarketList,
  fleaMarketList___vue_template_functional__,
  fleaMarketList___vue_styles__,
  fleaMarketList___vue_scopeId__,
  fleaMarketList___vue_module_identifier__
)

/* harmony default export */ var src_components_fleaMarketComponents_fleaMarketList = (fleaMarketList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/marketDetailList.vue












/* harmony default export */ var marketDetailList = ({
  data: function data() {
    var _ref;

    return _ref = {
      value: '',
      mshow: false,
      mur1: false,
      show_1: false,
      picList: [],
      imgList: [],
      phones: '',
      comnNames: '',
      phonems: '',
      sayMessage: [],
      replayMes: [],
      vals: '',
      mnId: '',
      messageTip: '说点什么',
      telePhone: 'tel:0000',
      alertShow: false,
      alertMsg: "",
      mands: '',
      numbers: ''
    }, defineProperty_default()(_ref, 'picList', []), defineProperty_default()(_ref, 'datas', {}), defineProperty_default()(_ref, 'mindex', ''), defineProperty_default()(_ref, 'mphone', ''), defineProperty_default()(_ref, 'ns', ''), defineProperty_default()(_ref, 'goodSid', ''), defineProperty_default()(_ref, 'srcm', "https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2109543758,1542619281&fm=27&gp=0.jpg"), defineProperty_default()(_ref, 'smc', 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg'), defineProperty_default()(_ref, 'srcs', "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg"), _ref;
  },

  components: {
    XInput: x_input["a" /* default */],
    XButton: vux_src_components_x_button,
    XHeader: vux_src_components_x_header,
    Alert: components_alert["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    loadPage: src_components_loadingPage
  },
  beforeMount: function beforeMount() {
    this.phones = this.$router.history.current.query.phone;
    this.phonems = this.$router.history.current.query.phones;
    this.goodSid = this.$router.history.current.query.goodsId;
    this.show_1 = true;
    var url = global.host + 'secondMarket/findgoodsDetail?goodsId=' + this.$router.history.current.query.goodsId;
    this.$http.get(url).then(function (res) {
      this.datas = res.body.result;
      this.telePhone = 'tel:' + this.datas.telePhone;
      if (this.datas.imgs.length > 0) {
        for (var mv in this.datas.imgs) {
          this.datas.imgs[mv].maxPicUrl = global.baseImg + this.datas.imgs[mv].maxPicUrl;
          this.picList.push(this.datas.imgs[mv]);
        }
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });

    this.yesNoCloct();
  },
  mounted: function mounted() {

    var selfs = this;
    $(".am_cloct").click(function () {
      if (selfs.ns == "0") {
        selfs.qxClocts();
      } else if (selfs.ns == "1") {
        selfs.syCloct();
      }
    });

    if (this.$router.history.current.path == "/marketDetailList") {
      document.title = "商品详情";
    }
  },

  methods: {
    onShow: function onShow() {
      this.mur1 = true;
      $(".am_bg_content").show();
      $('#password1').focus();
      this.loadData();
    },
    noInput: function noInput() {
      this.mur1 = false;
    },
    yesNoCloct: function yesNoCloct() {
      //判断是否收藏
      var selfs = this;
      var url = global.host + 'secondMarket/findcollectinggoods';
      var sDta = {
        regPhone: this.$router.history.current.query.phones,
        sourceId: this.$router.history.current.query.goodsId
      };

      this.$http.post(url, sDta).then(function (res) {
        var statCode = res.body.code;
        if (statCode == 110) {
          $(".am_cloct").find(".iconfont").addClass("icon-ai-mark");
          this.ns = "0";
        } else if (statCode == 120) {
          $(".am_cloct").find(".iconfont").removeClass("icon-ai-mark");
          this.ns = "1";
        }
      }, function (err) {
        console.log(err);
      });
    },
    syCloct: function syCloct() {
      //收藏
      var selfs = this;
      var urls = global.host + 'secondMarket/collectinggoodsinfo';
      var surl = this.$router.history.current.fullPath;
      var sDta = {
        collectDesc: this.datas.goodsName,
        collectUrl: surl,
        collectType: 'oldGoods',
        regPhone: this.$router.history.current.query.phones,
        sourceId: this.datas.goodsId
      };

      this.$http.post(urls, sDta).then(function (res) {
        var statCode = res.body.code;
        if (statCode == 110) {
          this.ns = "0";
          $(".am_cloct").find(".iconfont").addClass("icon-ai-mark");
        } else if (statCode == 120) {
          this.ns = "1";
          $(".am_cloct").find(".iconfont").removeClass("icon-ai-mark");
        }
      }, function (err) {
        console.log(err);
      });
    },
    qxClocts: function qxClocts() {
      //取消收藏
      var selfs = this;
      var urls = global.host + 'secondMarket/cancelgoodsinfo';
      var sDta = {
        regPhone: this.$router.history.current.query.phones,
        sourceId: this.datas.goodsId
      };
      this.$http.post(urls, sDta).then(function (res) {
        var statCode = res.body.code;
        if (statCode == 110) {
          this.ns = "1";
          $(".am_cloct").find(".iconfont").removeClass("icon-ai-mark");
        } else if (statCode == 120) {
          this.ns = "0";
          $(".am_cloct").find(".iconfont").addClass("icon-ai-mark");
        }
      }, function (err) {
        console.log(err);
      });
    },
    replays: function replays(muid, mais) {
      this.mur1 = true;
      this.mindex = "1";
      this.vals = "";
      if (muid != '' && muid != null) {
        this.mnId = muid;
      } else {
        this.mnId = '';
      }
      if (mais != '' && mais != null) {
        this.mands = mais;
      } else {
        this.mands = '';
      }
      this.messageTip = "回复" + mais + "：";
    },
    sendCont: function sendCont() {
      //发送留言
      if (this.vals.trim() == '') {
        this.alertShow = true;
        this.alertMsg = '留言不能为空';
        return;
      }
      this.mur1 = false;
      var url = global.host + 'secondMarket/sendgoodsmessboard';
      var surl = this.$router.history.current.fullPath;
      var jsonData = {
        goodsId: this.datas.goodsId,
        message: this.vals,
        pushMan: this.datas.contactMan,
        regPhone: this.phonems,
        parentId: this.mnId,
        parentman: this.mands,
        noticeType: 'oldGoods',
        noticeTitle: this.datas.goodsName,
        receivePhone: this.datas.mainPhone,
        noticeLink: surl,
        flag: 1
      };

      this.$http.post(url, jsonData).then(function (res) {

        this.sayMessage = res.body;
        var bdata = res.body;
        for (var i = 1; i < bdata.length; i++) {
          this.numbers = i;
        }
        this.vals = "";
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },
    loadData: function loadData() {
      //留言列表
      this.show_1 = true;
      this.mindex = "0";
      var url = global.host + 'secondMarket/sendgoodsmessboard';
      var jsonData = {
        goodsId: this.datas.goodsId,
        flag: 0
      };
      this.$http.post(url, jsonData).then(function (res) {

        this.sayMessage = res.body;
        var bdata = res.body;
        for (var i = 1; i < bdata.length; i++) {
          this.numbers = i;
        }
        this.show_1 = false;

        setTimeout(function () {
          window.scrollTo(0, document.body.scrollHeight + 20);
        }, 100);
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/marketDetailList.vue












/* harmony default export */ var fleaMarketComponents_marketDetailList = ({
  data: function data() {
    var _ref;

    return _ref = {
      value: '',
      mshow: false,
      mur1: false,
      show_1: false,
      picList: [],
      imgList: [],
      phones: '',
      comnNames: '',
      phonems: '',
      sayMessage: [],
      replayMes: [],
      vals: '',
      mnId: '',
      messageTip: '说点什么',
      telePhone: 'tel:0000',
      alertShow: false,
      alertMsg: "",
      mands: '',
      numbers: ''
    }, defineProperty_default()(_ref, 'picList', []), defineProperty_default()(_ref, 'datas', {}), defineProperty_default()(_ref, 'mindex', ''), defineProperty_default()(_ref, 'mphone', ''), defineProperty_default()(_ref, 'ns', ''), defineProperty_default()(_ref, 'goodSid', ''), defineProperty_default()(_ref, 'srcm', "https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2109543758,1542619281&fm=27&gp=0.jpg"), defineProperty_default()(_ref, 'smc', 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg'), defineProperty_default()(_ref, 'srcs', "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg"), _ref;
  },

  components: {
    XInput: x_input["a" /* default */],
    XButton: vux_src_components_x_button,
    XHeader: vux_src_components_x_header,
    Alert: components_alert["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    loadPage: src_components_loadingPage
  },
  beforeMount: function beforeMount() {
    this.phones = this.$router.history.current.query.phone;
    this.phonems = this.$router.history.current.query.phones;
    this.goodSid = this.$router.history.current.query.goodsId;
    this.show_1 = true;
    var url = global.host + 'secondMarket/findgoodsDetail?goodsId=' + this.$router.history.current.query.goodsId;
    this.$http.get(url).then(function (res) {
      this.datas = res.body.result;
      this.telePhone = 'tel:' + this.datas.telePhone;
      if (this.datas.imgs.length > 0) {
        for (var mv in this.datas.imgs) {
          this.datas.imgs[mv].maxPicUrl = global.baseImg + this.datas.imgs[mv].maxPicUrl;
          this.picList.push(this.datas.imgs[mv]);
        }
      }
      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });

    this.yesNoCloct();
  },
  mounted: function mounted() {

    var selfs = this;
    $(".am_cloct").click(function () {
      if (selfs.ns == "0") {
        selfs.qxClocts();
      } else if (selfs.ns == "1") {
        selfs.syCloct();
      }
    });

    if (this.$router.history.current.path == "/marketDetailList") {
      document.title = "商品详情";
    }
  },

  methods: {
    onShow: function onShow() {
      this.mur1 = true;
      $(".am_bg_content").show();
      $('#password1').focus();
      this.loadData();
    },
    noInput: function noInput() {
      this.mur1 = false;
    },
    yesNoCloct: function yesNoCloct() {
      //判断是否收藏
      var selfs = this;
      var url = global.host + 'secondMarket/findcollectinggoods';
      var sDta = {
        regPhone: this.$router.history.current.query.phones,
        sourceId: this.$router.history.current.query.goodsId
      };

      this.$http.post(url, sDta).then(function (res) {
        var statCode = res.body.code;
        if (statCode == 110) {
          $(".am_cloct").find(".iconfont").addClass("icon-ai-mark");
          this.ns = "0";
        } else if (statCode == 120) {
          $(".am_cloct").find(".iconfont").removeClass("icon-ai-mark");
          this.ns = "1";
        }
      }, function (err) {
        console.log(err);
      });
    },
    syCloct: function syCloct() {
      //收藏
      var selfs = this;
      var urls = global.host + 'secondMarket/collectinggoodsinfo';
      var surl = this.$router.history.current.fullPath;
      var sDta = {
        collectDesc: this.datas.goodsName,
        collectUrl: surl,
        collectType: 'oldGoods',
        regPhone: this.$router.history.current.query.phones,
        sourceId: this.datas.goodsId
      };

      this.$http.post(urls, sDta).then(function (res) {
        var statCode = res.body.code;
        if (statCode == 110) {
          this.ns = "0";
          $(".am_cloct").find(".iconfont").addClass("icon-ai-mark");
        } else if (statCode == 120) {
          this.ns = "1";
          $(".am_cloct").find(".iconfont").removeClass("icon-ai-mark");
        }
      }, function (err) {
        console.log(err);
      });
    },
    qxClocts: function qxClocts() {
      //取消收藏
      var selfs = this;
      var urls = global.host + 'secondMarket/cancelgoodsinfo';
      var sDta = {
        regPhone: this.$router.history.current.query.phones,
        sourceId: this.datas.goodsId
      };
      this.$http.post(urls, sDta).then(function (res) {
        var statCode = res.body.code;
        if (statCode == 110) {
          this.ns = "1";
          $(".am_cloct").find(".iconfont").removeClass("icon-ai-mark");
        } else if (statCode == 120) {
          this.ns = "0";
          $(".am_cloct").find(".iconfont").addClass("icon-ai-mark");
        }
      }, function (err) {
        console.log(err);
      });
    },
    replays: function replays(muid, mais) {
      this.mur1 = true;
      this.mindex = "1";
      this.vals = "";
      if (muid != '' && muid != null) {
        this.mnId = muid;
      } else {
        this.mnId = '';
      }
      if (mais != '' && mais != null) {
        this.mands = mais;
      } else {
        this.mands = '';
      }
      this.messageTip = "回复" + mais + "：";
    },
    sendCont: function sendCont() {
      //发送留言
      if (this.vals.trim() == '') {
        this.alertShow = true;
        this.alertMsg = '留言不能为空';
        return;
      }
      this.mur1 = false;
      var url = global.host + 'secondMarket/sendgoodsmessboard';
      var surl = this.$router.history.current.fullPath;
      var jsonData = {
        goodsId: this.datas.goodsId,
        message: this.vals,
        pushMan: this.datas.contactMan,
        regPhone: this.phonems,
        parentId: this.mnId,
        parentman: this.mands,
        noticeType: 'oldGoods',
        noticeTitle: this.datas.goodsName,
        receivePhone: this.datas.mainPhone,
        noticeLink: surl,
        flag: 1
      };

      this.$http.post(url, jsonData).then(function (res) {

        this.sayMessage = res.body;
        var bdata = res.body;
        for (var i = 1; i < bdata.length; i++) {
          this.numbers = i;
        }
        this.vals = "";
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },
    loadData: function loadData() {
      //留言列表
      this.show_1 = true;
      this.mindex = "0";
      var url = global.host + 'secondMarket/sendgoodsmessboard';
      var jsonData = {
        goodsId: this.datas.goodsId,
        flag: 0
      };
      this.$http.post(url, jsonData).then(function (res) {

        this.sayMessage = res.body;
        var bdata = res.body;
        for (var i = 1; i < bdata.length; i++) {
          this.numbers = i;
        }
        this.show_1 = false;

        setTimeout(function () {
          window.scrollTo(0, document.body.scrollHeight + 20);
        }, 100);
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcc4edaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fleaMarketComponents/marketDetailList.vue
var marketDetailList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body_bg"},[_c('div',{staticClass:"contBox",staticStyle:{"padding-left":"0 !important"}},[_c('flexbox',{attrs:{"gutter":0,"align":"center","orient":"vertical"}},[_c('div',{staticClass:"am_com_botom"},[_c('flexbox-item',{staticClass:"selects1 am_flexs_item1 am_ptop"},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.datas.goodsName))]),_vm._v(" "),_c('x-button',{staticClass:"btn_style",staticStyle:{"float":"left"},attrs:{"type":"warn","mini":""}},[_vm._v(_vm._s(_vm.datas.lossName))])],1),_vm._v(" "),_c('flexbox-item',{staticClass:"selects1 am_flexs_item1"},[_c('span',{staticClass:"am_color",staticStyle:{"float":"left"}},[_c('b',[_vm._v("￥")]),_vm._v(_vm._s(_vm.datas.salePrice))]),_vm._v(" "),_c('span',{staticClass:"priceThrow",staticStyle:{"float":"left"}},[_vm._v("￥"+_vm._s(_vm.datas.buyPrice))])])],1),_vm._v(" "),_c('flexbox-item',{staticClass:"bar"}),_vm._v(" "),_c('div',{staticClass:"am_com_botom"},[_c('flexbox-item',{staticClass:"am_flexs_item1"},[_c('h2',[_vm._v("详情")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.datas.goodsDesc))]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"7px"}},[_c('span',[_vm._v("时间："+_vm._s(_vm.datas.createDate))])])]),_vm._v(" "),_c('flexbox-item',{staticClass:"select_img"},[_vm._l((_vm.picList),function(items,index){return _c('div',{key:index,staticStyle:{"margin-bottom":"15px"}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(items.maxPicUrl),expression:"items.maxPicUrl"}]})])}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","padding":"13px 0 20px","height":"60px","justify-content":"flex-start","align-items":"center"}},[_c('div',{staticClass:"amSmg"},[_c('x-img',{attrs:{"src":_vm.datas.memberIcon}})],1),_vm._v(" "),_c('div',{staticClass:"am_mlis"},[_c('div',{staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(_vm.datas.contactMan))]),_vm._v(" "),_c('div',{staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(_vm.datas.mainPhone))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","white-space":"nowrap"}},[_c('span',[_vm._v(_vm._s(_vm.datas.comnName))])])])])],2)],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_bg_content"},[_c('h2',[_vm._v("留言 • "),_c('strong',[_vm._v(_vm._s(_vm.numbers))])]),_vm._v(" "),_c('div',{staticClass:"am_img_control am_autoHeight"},_vm._l((_vm.sayMessage),function(item,index){return _c('div',{key:index,staticClass:"amDiflex"},[(item.parentId != '0' && item.parentId != null)?_c('div',{staticClass:"am_awidth",staticStyle:{"padding-left":"30px"}},[_c('ul',[_c('li',[_c('img',{staticClass:"am_sender",attrs:{"src":item.memberIcon}})]),_vm._v(" "),_c('li',{staticClass:"am_mlis"},[_c('div',{staticClass:"am_amAuther"},[_vm._v(_vm._s(item.pushMan)+" "),_c('b',[_vm._v("回复")]),_vm._v(" "+_vm._s(item.parentman))])])]),_vm._v(" "),_c('p',{staticClass:"am_sayTime"},[_vm._v("\n                "+_vm._s(item.message)+"\n              ")])]):_c('div',{staticClass:"am_awidth"},[_c('ul',[_c('li',[_c('img',{staticClass:"am_sender",attrs:{"src":item.memberIcon}})]),_vm._v(" "),_c('li',{staticClass:"am_mlis"},[_c('div',{staticClass:"am_amAuther"},[_vm._v(_vm._s(item.pushMan))])])]),_vm._v(" "),_c('p',{staticClass:"am_say"},[_vm._v(_vm._s(item.message))])]),_vm._v(" "),_c('p',{staticClass:"am_sayTime"},[_c('b',{staticStyle:{"color":"#999"}},[_vm._v(_vm._s(item.releaseDate))]),_c('strong',{on:{"click":function($event){_vm.replays(item.msgId,item.pushMan)}}},[_vm._v("回复")])])])}))])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"height":"80px"}}),_vm._v(" "),_c('flexbox',{staticClass:"am_posbottom",attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_lateSay",attrs:{"span":1/3},nativeOn:{"click":function($event){return _vm.onShow($event)}}},[_c('div',{staticClass:"iconfont icon-xinxi"}),_vm._v(" "),_c('h1',[_vm._v("留言")])]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_lateSay",attrs:{"span":1/3}},[_c('a',{attrs:{"href":_vm.telePhone}},[_c('x-button',{staticClass:"amBoton",attrs:{"type":"warn","mini":""}},[_vm._v("马上联系")])],1)]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_lateSay am_cloct",attrs:{"span":1/3}},[_c('div',{staticClass:"iconfont icon-shoucang"}),_vm._v(" "),_c('h1',[_vm._v("收藏")])])],1),_vm._v(" "),(_vm.mur1)?_c('flexbox',{staticClass:"amPostion",attrs:{"gutter":0}},[_c('flexbox-item',{attrs:{"span":4/5}},[_c('x-input',{staticClass:"am_InputStyle",attrs:{"placeholder":_vm.messageTip},on:{"on-blur":_vm.noInput},model:{value:(_vm.vals),callback:function ($$v) {_vm.vals=$$v},expression:"vals"}})],1),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/5}},[_c('x-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){return _vm.sendCont($event)}}},[_vm._v("发送")])],1)],1):_vm._e(),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}}),_vm._v(" "),_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.alertShow),callback:function ($$v) {_vm.alertShow=$$v},expression:"alertShow"}},[_c('strong',[_vm._v(_vm._s(_vm.alertMsg))])])],1)}
var marketDetailList_staticRenderFns = []
var marketDetailList_esExports = { render: marketDetailList_render, staticRenderFns: marketDetailList_staticRenderFns }
/* harmony default export */ var components_fleaMarketComponents_marketDetailList = (marketDetailList_esExports);
// CONCATENATED MODULE: ./src/components/fleaMarketComponents/marketDetailList.vue
function marketDetailList_injectStyle (ssrContext) {
  __webpack_require__("njjg")
}
var marketDetailList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var marketDetailList___vue_template_functional__ = false
/* styles */
var marketDetailList___vue_styles__ = marketDetailList_injectStyle
/* scopeId */
var marketDetailList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var marketDetailList___vue_module_identifier__ = null
var marketDetailList_Component = marketDetailList_normalizeComponent(
  fleaMarketComponents_marketDetailList,
  components_fleaMarketComponents_marketDetailList,
  marketDetailList___vue_template_functional__,
  marketDetailList___vue_styles__,
  marketDetailList___vue_scopeId__,
  marketDetailList___vue_module_identifier__
)

/* harmony default export */ var src_components_fleaMarketComponents_marketDetailList = (marketDetailList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/marketResend.vue
















/* harmony default export */ var marketResend = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    Group: group["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Alert: components_alert["a" /* default */],
    loadPage: src_components_loadingPage,
    XHeader: vux_src_components_x_header,
    XInput: x_input["a" /* default */]
  },
  data: function data() {
    return {
      repair: "",
      info: '',
      filecontent: [],
      comnCode: '',
      hsNo: '',
      textms: '商品描述\n（为免打扰，请勿泄露个人电话、微信等信息）',
      preices: '0.00元',
      preices1: '0.00元',
      lisColor: '',
      mSval: '最多可以上传四张图片',
      message: '',
      alrtext: '商品标题(不能超过15个字)',
      showAlert: false,
      show_1: false,
      useragent: '',
      alrtext1: '',
      value5: "",
      infoValue: "",
      lisType: '',
      alertShow: false,
      alertMsg: "",
      values: '',
      value3: [],
      value4: [],
      list3: [[]],
      list4: [[]],
      rsValue: '',
      stateMcode: '',
      comnList: '',
      colorId: '',
      eType: ''

    };
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/marketResend") {
      document.title = "去发布";
    }
    this.value5 = this.$router.history.current.query.phone;
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
    this.getTypeList();
  },

  methods: {
    deleteImg: function deleteImg(index) {
      this.filecontent.splice(index, 1);
    },
    comval: function comval() {
      $("#m1").find(".weui-label").css('color', '#000');
      $("#m2").find(".weui-label").css('color', '#000');
      $("#m3").find(".weui-label").css('color', '#000');
      $("#m4").find(".weui-label").css('color', '#000');
    },
    selectFile: function selectFile() {
      var _this = this;

      this.mSval = '最多可以上传四张图片';
      var filehandler = document.getElementById('file');
      if (filehandler.files) {
        var reader;

        (function () {
          var fileList = filehandler.files;
          var self = _this;
          var size = _this.filecontent.length;
          console.log(size);
          /*for(let j = 0 ; j < size ; j++){
          this.filecontent.pop();
          }*/
          if (size > 3) {
            _this.filecontent.pop();
          }
          for (var i = 0; i < (fileList.length > 4 ? 4 : fileList.length); i++) {
            reader = new FileReader();

            reader.readAsDataURL(fileList[i]);
            reader.onload = function (event) {
              var img = new Image();

              var width = 680,
                  //图像大小
              quality = 0.8,
                  //图像质量
              canvas = document.createElement("canvas"),
                  drawer = canvas.getContext("2d");
              img.src = this.result;
              img.onload = function () {
                canvas.width = width;
                canvas.height = width * (img.height / img.width);
                drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
                var imgBase64 = canvas.toDataURL("image/jpeg", quality);
                self.filecontent.push(imgBase64);
                img.src = "";
              };
            };
          }
        })();
      }
    },
    getTypeList: function getTypeList() {
      //获取成色和分类的数据
      var url = global.host + 'secondMarket/findfilter';
      this.$http.get(url).then(function (res) {
        var datas = res.body;
        this.comnList = res.body;
        for (var i in datas) {
          if (datas[i].filterType == 1) {
            this.list4[0].push(datas[i].filterName);
          } else if (datas[i].filterType == 3) {
            this.list3[0].push(datas[i].filterName);
          }
        }
      }, function (err) {
        console.log(err);
      });
    },
    changeColor: function changeColor(index) {
      //获取成色
      $("#m5").find(".weui-label").css('color', '#000');
      for (var s in this.comnList) {
        if (this.comnList[s].filterName == index && this.comnList[s].filterType == 3) {
          this.colorId = this.comnList[s].filterId;
        }
      }
    },
    changeType: function changeType(index) {
      //获取分类
      $("#m6").find(".weui-label").css('color', '#000');
      for (var s in this.comnList) {
        if (this.comnList[s].filterName == index && this.comnList[s].filterType == 1) {
          this.eType = this.comnList[s].filterId;
        }
        console.log(this.eType);
      }
    },
    submitForm: function submitForm() {
      if (this.infoValue == '') {
        this.alrtext = '请输入内容';
        $("#m1").find(".weui-label").css('color', '#ff0000');
      } else if (this.info == '') {
        this.textms = '请输入内容';
      } else if (this.filecontent.length == 0) {
        this.mSval = '请上传图片';
      } else if (this.value5 == '') {
        this.alrtext1 = '请输入手机号';
        $("#m2").find(".weui-label").css('color', '#ff0000');
      } else if (this.values == '') {
        this.preices = '请输入卖价';
        $("#m3").find(".weui-label").css('color', '#ff0000');
      } else if (this.rsValue == '') {
        this.preices1 = '请输入入手价';
        $("#m4").find(".weui-label").css('color', '#ff0000');
      } else if (this.value3 == '') {
        this.lisColor = "请选择";
        $("#m5").find(".weui-label").css('color', '#ff0000');
      } else if (this.value4 == '') {
        this.lisType = '请选择';
        $("#m6").find(".weui-label").css('color', '#ff0000');
      } else {
        this.show_1 = true;
        var usInfo = new Object();
        usInfo.comnCode = this.$router.history.current.query.comnCode;
        usInfo.telePhone = this.$router.history.current.query.phone;
        usInfo.mainPhone = this.$router.history.current.query.phone;
        usInfo.comnName = this.$router.history.current.query.comnName;
        usInfo.goodsName = this.infoValue;
        usInfo.goodsType = this.eType;
        usInfo.goodsLoss = this.colorId;
        usInfo.buyPrice = this.rsValue;
        usInfo.salePrice = this.values;
        usInfo.goodsDesc = this.info;
        usInfo.commoOrigiImg = this.filecontent;
        usInfo.openId = this.$router.history.current.query.openid;
        console.log(usInfo);
        var url = global.host + 'secondMarket/releaseGoods';
        this.$http.post(url, usInfo).then(function (res) {
          this.show_1 = false;
          this.stateMcode = res.body.code;
          var msgCode = res.body.code;
          if (msgCode == '120') {
            this.alertShow = true;
            this.alertMsg = res.body.msg;
          } else if (msgCode == '110') {
            this.alertShow = true;
            this.alertMsg = res.body.msg;
          }
        }, function (err) {
          console.log(err);
        });
      }
    },
    getIndex: function getIndex(arr, field) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == field) {
          return i;
        }
      }
    },
    onHide: function onHide() {
      if (this.stateMcode == '110') {
        var openid = this.$router.history.current.query.openid;
        var phone = this.$router.history.current.query.phone;
        var comnCode = this.$router.history.current.query.comnCode;
        var comnName = this.$router.history.current.query.comnName;
        this.$router.push({ path: '/fleaMarketList', query: defineProperty_default()({ comnCode: comnCode, openid: openid, communityName: comnName }, 'comnCode', comnCode) });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/marketResend.vue
















/* harmony default export */ var fleaMarketComponents_marketResend = ({
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    Group: group["a" /* default */],
    PopupPicker: popup_picker["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Alert: components_alert["a" /* default */],
    loadPage: src_components_loadingPage,
    XHeader: vux_src_components_x_header,
    XInput: x_input["a" /* default */]
  },
  data: function data() {
    return {
      repair: "",
      info: '',
      filecontent: [],
      comnCode: '',
      hsNo: '',
      textms: '商品描述\n（为免打扰，请勿泄露个人电话、微信等信息）',
      preices: '0.00元',
      preices1: '0.00元',
      lisColor: '',
      mSval: '最多可以上传四张图片',
      message: '',
      alrtext: '商品标题(不能超过15个字)',
      showAlert: false,
      show_1: false,
      useragent: '',
      alrtext1: '',
      value5: "",
      infoValue: "",
      lisType: '',
      alertShow: false,
      alertMsg: "",
      values: '',
      value3: [],
      value4: [],
      list3: [[]],
      list4: [[]],
      rsValue: '',
      stateMcode: '',
      comnList: '',
      colorId: '',
      eType: ''

    };
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/marketResend") {
      document.title = "去发布";
    }
    this.value5 = this.$router.history.current.query.phone;
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
    this.getTypeList();
  },

  methods: {
    deleteImg: function deleteImg(index) {
      this.filecontent.splice(index, 1);
    },
    comval: function comval() {
      $("#m1").find(".weui-label").css('color', '#000');
      $("#m2").find(".weui-label").css('color', '#000');
      $("#m3").find(".weui-label").css('color', '#000');
      $("#m4").find(".weui-label").css('color', '#000');
    },
    selectFile: function selectFile() {
      var _this = this;

      this.mSval = '最多可以上传四张图片';
      var filehandler = document.getElementById('file');
      if (filehandler.files) {
        var reader;

        (function () {
          var fileList = filehandler.files;
          var self = _this;
          var size = _this.filecontent.length;
          console.log(size);
          /*for(let j = 0 ; j < size ; j++){
          this.filecontent.pop();
          }*/
          if (size > 3) {
            _this.filecontent.pop();
          }
          for (var i = 0; i < (fileList.length > 4 ? 4 : fileList.length); i++) {
            reader = new FileReader();

            reader.readAsDataURL(fileList[i]);
            reader.onload = function (event) {
              var img = new Image();

              var width = 680,
                  //图像大小
              quality = 0.8,
                  //图像质量
              canvas = document.createElement("canvas"),
                  drawer = canvas.getContext("2d");
              img.src = this.result;
              img.onload = function () {
                canvas.width = width;
                canvas.height = width * (img.height / img.width);
                drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
                var imgBase64 = canvas.toDataURL("image/jpeg", quality);
                self.filecontent.push(imgBase64);
                img.src = "";
              };
            };
          }
        })();
      }
    },
    getTypeList: function getTypeList() {
      //获取成色和分类的数据
      var url = global.host + 'secondMarket/findfilter';
      this.$http.get(url).then(function (res) {
        var datas = res.body;
        this.comnList = res.body;
        for (var i in datas) {
          if (datas[i].filterType == 1) {
            this.list4[0].push(datas[i].filterName);
          } else if (datas[i].filterType == 3) {
            this.list3[0].push(datas[i].filterName);
          }
        }
      }, function (err) {
        console.log(err);
      });
    },
    changeColor: function changeColor(index) {
      //获取成色
      $("#m5").find(".weui-label").css('color', '#000');
      for (var s in this.comnList) {
        if (this.comnList[s].filterName == index && this.comnList[s].filterType == 3) {
          this.colorId = this.comnList[s].filterId;
        }
      }
    },
    changeType: function changeType(index) {
      //获取分类
      $("#m6").find(".weui-label").css('color', '#000');
      for (var s in this.comnList) {
        if (this.comnList[s].filterName == index && this.comnList[s].filterType == 1) {
          this.eType = this.comnList[s].filterId;
        }
        console.log(this.eType);
      }
    },
    submitForm: function submitForm() {
      if (this.infoValue == '') {
        this.alrtext = '请输入内容';
        $("#m1").find(".weui-label").css('color', '#ff0000');
      } else if (this.info == '') {
        this.textms = '请输入内容';
      } else if (this.filecontent.length == 0) {
        this.mSval = '请上传图片';
      } else if (this.value5 == '') {
        this.alrtext1 = '请输入手机号';
        $("#m2").find(".weui-label").css('color', '#ff0000');
      } else if (this.values == '') {
        this.preices = '请输入卖价';
        $("#m3").find(".weui-label").css('color', '#ff0000');
      } else if (this.rsValue == '') {
        this.preices1 = '请输入入手价';
        $("#m4").find(".weui-label").css('color', '#ff0000');
      } else if (this.value3 == '') {
        this.lisColor = "请选择";
        $("#m5").find(".weui-label").css('color', '#ff0000');
      } else if (this.value4 == '') {
        this.lisType = '请选择';
        $("#m6").find(".weui-label").css('color', '#ff0000');
      } else {
        this.show_1 = true;
        var usInfo = new Object();
        usInfo.comnCode = this.$router.history.current.query.comnCode;
        usInfo.telePhone = this.$router.history.current.query.phone;
        usInfo.mainPhone = this.$router.history.current.query.phone;
        usInfo.comnName = this.$router.history.current.query.comnName;
        usInfo.goodsName = this.infoValue;
        usInfo.goodsType = this.eType;
        usInfo.goodsLoss = this.colorId;
        usInfo.buyPrice = this.rsValue;
        usInfo.salePrice = this.values;
        usInfo.goodsDesc = this.info;
        usInfo.commoOrigiImg = this.filecontent;
        usInfo.openId = this.$router.history.current.query.openid;
        console.log(usInfo);
        var url = global.host + 'secondMarket/releaseGoods';
        this.$http.post(url, usInfo).then(function (res) {
          this.show_1 = false;
          this.stateMcode = res.body.code;
          var msgCode = res.body.code;
          if (msgCode == '120') {
            this.alertShow = true;
            this.alertMsg = res.body.msg;
          } else if (msgCode == '110') {
            this.alertShow = true;
            this.alertMsg = res.body.msg;
          }
        }, function (err) {
          console.log(err);
        });
      }
    },
    getIndex: function getIndex(arr, field) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == field) {
          return i;
        }
      }
    },
    onHide: function onHide() {
      if (this.stateMcode == '110') {
        var openid = this.$router.history.current.query.openid;
        var phone = this.$router.history.current.query.phone;
        var comnCode = this.$router.history.current.query.comnCode;
        var comnName = this.$router.history.current.query.comnName;
        this.$router.push({ path: '/fleaMarketList', query: defineProperty_default()({ comnCode: comnCode, openid: openid, communityName: comnName }, 'comnCode', comnCode) });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-694fac26","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fleaMarketComponents/marketResend.vue
var marketResend_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"am_gap"},[_c('group',[_c('x-input',{attrs:{"title":"商品名称","id":"m1","placeholder":_vm.alrtext,"text-align":"right","max":30},on:{"on-blur":_vm.comval},model:{value:(_vm.infoValue),callback:function ($$v) {_vm.infoValue=$$v},expression:"infoValue"}})],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',{staticClass:"am_text_content"},[_c('x-textarea',{staticClass:"am_textares",attrs:{"placeholder":_vm.textms,"rows":3},model:{value:(_vm.info),callback:function ($$v) {_vm.info=$$v},expression:"info"}})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"border-top":"1px solid #D9D9D9","padding":"0 0 0 15px"}},[_c('p',{staticStyle:{"font-size":"0.8em","padding-top":"15px","color":"#999999"}},[_vm._v("我的照片")]),_vm._v(" "),(_vm.useragent)?_c('div',{staticStyle:{"width":"80px","height":"80px","background-color":"#fff","line-height":"80px","position":"relative"}},[_c('input',{staticStyle:{"display":"block","opacity":"0","width":"80px","height":"80px","position":"absolute","z-index":"99999"},attrs:{"type":"file","name":"file","id":"file","accept":"image/*","multiple":"","max":"4"},on:{"change":_vm.selectFile}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","display":"block","width":"200px","height":"80px","top":"0","left":"100px","color":"red","font-size":"0.8em"}},[_vm._v(_vm._s(_vm.mSval))])]):_c('div',{staticStyle:{"width":"80px","height":"80px","background-color":"#fff","line-height":"80px","position":"relative"}},[_vm._m(1),_vm._v(" "),_c('input',{staticStyle:{"display":"block","opacity":"0","width":"80px","height":"80px","position":"absolute","z-index":"99999"},attrs:{"type":"file","name":"file","id":"file","accept":"image/*","multiple":"","max":"4"},on:{"change":_vm.selectFile}}),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","display":"block","width":"200px","height":"80px","top":"0","left":"100px","color":"red","font-size":"0.8em"}},[_vm._v(_vm._s(_vm.mSval))])])]),_vm._v(" "),(_vm.filecontent.length > 0)?_c('div',{staticClass:"am_styles"},_vm._l((_vm.filecontent),function(item,index){return _c('div',{key:index,staticClass:"amDs"},[_c('x-img',{staticClass:"pic",attrs:{"src":item}}),_vm._v(" "),_c('i',{staticClass:"fa fa-times amPosion",on:{"click":function($event){_vm.deleteImg(index)}}})],1)})):_vm._e(),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"联系方式","id":"m2","placeholder":_vm.alrtext1,"text-align":"right","max":11,"is-type":"china-mobile"},on:{"on-blur":_vm.comval},model:{value:(_vm.value5),callback:function ($$v) {_vm.value5=$$v},expression:"value5"}})],1),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"type":"number","id":"m3","title":"卖价","text-align":"right","placeholder":_vm.preices},on:{"on-blur":_vm.comval},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})],1),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"type":"number","id":"m4","title":"入手价","text-align":"right","placeholder":_vm.preices1},on:{"on-blur":_vm.comval},model:{value:(_vm.rsValue),callback:function ($$v) {_vm.rsValue=$$v},expression:"rsValue"}})],1),_vm._v(" "),_c('group',[_c('popup-picker',{attrs:{"title":"成色","id":"m5","data":_vm.list3,"placeholder":_vm.lisColor},on:{"on-change":_vm.changeColor},model:{value:(_vm.value3),callback:function ($$v) {_vm.value3=$$v},expression:"value3"}})],1),_vm._v(" "),_c('group',[_c('popup-picker',{attrs:{"title":"分类","id":"m6","data":_vm.list4,"placeholder":_vm.lisType},on:{"on-change":_vm.changeType},model:{value:(_vm.value4),callback:function ($$v) {_vm.value4=$$v},expression:"value4"}})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"height":"30px"}}),_vm._v(" "),_c('x-button',{staticClass:"btn_fa",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submitForm($event)}}},[_vm._v("发布")]),_vm._v(" "),_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_vm._v(" "+_vm._s(_vm.message))]),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}}),_vm._v(" "),_c('alert',{attrs:{"title":"温馨提示"},on:{"on-hide":_vm.onHide},model:{value:(_vm.alertShow),callback:function ($$v) {_vm.alertShow=$$v},expression:"alertShow"}},[_c('strong',[_vm._v(_vm._s(_vm.alertMsg))])])],1)}
var marketResend_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"position":"absolute","display":"block","width":"100%","height":"100%","top":"0"}},[_c('i',{staticClass:"iconfont icon-xiangji",staticStyle:{"font-size":"40px","margin-left":"30%","color":"#ddd"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"position":"absolute","display":"block","width":"100%","height":"100%","top":"0"}},[_c('i',{staticClass:"iconfont icon-xiangji",staticStyle:{"font-size":"40px","margin-left":"30%","color":"#ddd"}})])}]
var marketResend_esExports = { render: marketResend_render, staticRenderFns: marketResend_staticRenderFns }
/* harmony default export */ var components_fleaMarketComponents_marketResend = (marketResend_esExports);
// CONCATENATED MODULE: ./src/components/fleaMarketComponents/marketResend.vue
function marketResend_injectStyle (ssrContext) {
  __webpack_require__("7V4Z")
}
var marketResend_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var marketResend___vue_template_functional__ = false
/* styles */
var marketResend___vue_styles__ = marketResend_injectStyle
/* scopeId */
var marketResend___vue_scopeId__ = "data-v-694fac26"
/* moduleIdentifier (server only) */
var marketResend___vue_module_identifier__ = null
var marketResend_Component = marketResend_normalizeComponent(
  fleaMarketComponents_marketResend,
  components_fleaMarketComponents_marketResend,
  marketResend___vue_template_functional__,
  marketResend___vue_styles__,
  marketResend___vue_scopeId__,
  marketResend___vue_module_identifier__
)

/* harmony default export */ var src_components_fleaMarketComponents_marketResend = (marketResend_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/marketMyPublish.vue











/* harmony default export */ var marketMyPublish = ({
  data: function data() {
    return {
      value: '',
      mShow: true,
      show: false,
      showm1: true,
      showm2: false,
      show_1: false,
      alrshow: false,
      resends: false,
      mShows: true,
      picUrl: '',
      money1: '',
      money2: '',
      money3: '',
      money4: '',
      totalMoneys: '',
      lowMoney: '',
      txts: '',
      openid: '',
      phone: '',
      comnCode: '',
      list: [],
      lowPircId: '',
      index: '',
      godsId: '',
      smc: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg',
      srcs: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg"
    };
  },

  components: {
    XButton: vux_src_components_x_button,
    XHeader: vux_src_components_x_header,
    Alert: components_alert["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage
  },
  beforeMount: function beforeMount() {
    this.firstLoad();
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/marketMyPublish") {
      document.title = "我的发布";
    }
    this.picUrl = global.baseImg;
    this.openid = this.$router.history.current.query.openid;
    this.phone = this.$router.history.current.query.phone;
    this.comnCode = this.$router.history.current.query.comnCode;
  },

  methods: {
    submitForm: function submitForm() {
      this.$router.push({ path: '/fleaMarketList', query: {} });
    },
    lowPrice: function lowPrice(mid, price) {
      //降价
      this.show = true;
      this.lowPircId = mid;
      this.lowMoney = price;
      this.totalMoneys = price;
      this.money1 = Number(price) * 0.1;
      this.money2 = Number(price) * 0.3;
      this.money3 = Number(price) * 0.5;
      this.money4 = Number(price) * 0.8;

      var self = this;
      $(".am_expence").delegate("li", "click", function () {

        $(this).addClass("actived").siblings('li').removeClass("actived");
        self.totalMoneys = Number($(".am_expence li.actived .mflex").find("strong").html());
      });
    },
    deleteData: function deleteData(deId) {
      //删除商品
      this.show_1 = true;
      var urls = global.host + 'secondMarket/deletegoodsinfo?goodsId=' + deId;
      this.$http.get(urls).then(function (res) {
        this.show_1 = false;

        var code = res.body.code;
        if (code == "110") {
          this.alrshow = true;
          this.txts = res.body.msg;
          window.location.reload();
          console.log(res.body.msg);
        } else if (code == "120") {
          this.alrshow = true;
          this.txts = res.body.msg;
        }
      }, function (err) {
        console.log(err);
      });
    },
    replyThing: function replyThing(reId) {
      //重新发布
      this.show_1 = true;
      var urls = global.host + 'secondMarket/goodsrepublish?goodsId=' + reId;
      this.$http.get(urls).then(function (res) {
        this.show_1 = false;

        var code = res.body.code;
        if (code == "110") {
          this.alrshow = true;
          this.txts = res.body.msg;
        }
      }, function (err) {
        console.log(err);
      });
    },
    sendMessages: function sendMessages(index) {
      var size = this.list.length;
      for (var i = 0; i < size; i++) {
        this.list.pop();
      }
      if (index == 0) {
        this.firstLoad();
        $(".tabItems .tabliem:first").addClass("actives");
        $(".tabItems .tabliem:last").removeClass("actives");
      } else if (index == 1) {

        this.xjFirstLoad();
        $(".tabItems .tabliem:first").removeClass("actives");
        $(".tabItems .tabliem:last").addClass("actives");
      }
    },
    btnConfirm: function btnConfirm() {
      var urls = global.host + 'secondMarket/goodspricereduction?goodsId=' + this.lowPircId + "&salePrice=" + this.totalMoneys;
      this.$http.get(urls).then(function (res) {

        var code = res.body.code;
        if (code == "110") {
          this.alrshow = true;
          this.txts = res.body.msg;
          $("#" + this.lowPircId).find("strong").html(res.body.price);
        }
      }, function (err) {
        console.log(err);
      });
    },
    feeDown: function feeDown(goodsId) {
      //下架
      this.show_1 = true;
      this.godsId = goodsId;
      var url = global.host + 'secondMarket/goodsDown?goodsId=' + goodsId;
      this.$http.get(url).then(function (res) {
        this.show_1 = false;
        if (res.body.code == '110') {
          this.alrshow = true;
          this.txts = res.body.msg;
        } else if (res.body.code == '120') {
          this.alrshow = true;
          this.txts = res.body.msg;
        }
      }, function (err) {
        console.log(err);
      });
    },
    cancel: function cancel() {},
    xjFirstLoad: function xjFirstLoad() {
      this.show_1 = true;
      var mNum = 1;
      var datas = {
        mainPhone: this.$router.history.current.query.mainPhone,
        comnCode: this.$router.history.current.query.comnCode,
        page: 1,
        rows: 10,
        firstflag: 1,
        isOffline: mNum
      };
      if (mNum) {
        this.mShows = false;
      }
      var url = global.host + 'secondMarket/findgoodslist';
      this.$http.post(url, datas).then(function (res) {
        this.show_1 = false;

        var picList = res.body.goods;
        for (var m in picList) {
          if (picList[m].imgs.length > 0) {
            for (var n in picList[m].imgs) {
              picList[m].imgs[n].minPicUrl = global.baseImg + picList[m].imgs[n].minPicUrl;
            }
          }

          this.list.push(picList[m]);
        }
      }, function (err) {
        console.log(err);
      });
    },
    firstLoad: function firstLoad() {
      this.show_1 = true;
      var datas = {
        mainPhone: this.$router.history.current.query.mainPhone,
        page: 1,
        rows: 10
      };
      this.mShows = true;
      var url = global.host + 'secondMarket/findmyselfgoods';
      this.$http.post(url, datas).then(function (res) {
        this.show_1 = false;

        var picList = res.body.result;
        for (var m in picList) {
          if (picList[m].imgs.length > 0) {
            for (var n in picList[m].imgs) {
              picList[m].imgs[n].minPicUrl = global.baseImg + picList[m].imgs[n].minPicUrl;
            }
          }

          this.list.push(picList[m]);
        }
      }, function (err) {
        console.log(err);
      });
    }
  }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/marketMyPublish.vue











/* harmony default export */ var fleaMarketComponents_marketMyPublish = ({
  data: function data() {
    return {
      value: '',
      mShow: true,
      show: false,
      showm1: true,
      showm2: false,
      show_1: false,
      alrshow: false,
      resends: false,
      mShows: true,
      picUrl: '',
      money1: '',
      money2: '',
      money3: '',
      money4: '',
      totalMoneys: '',
      lowMoney: '',
      txts: '',
      openid: '',
      phone: '',
      comnCode: '',
      list: [],
      lowPircId: '',
      index: '',
      godsId: '',
      smc: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg',
      srcs: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg"
    };
  },

  components: {
    XButton: vux_src_components_x_button,
    XHeader: vux_src_components_x_header,
    Alert: components_alert["a" /* default */],
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XImg: vux_src_components_x_img,
    Confirm: node_modules_vux_src_components_confirm,
    loadPage: src_components_loadingPage
  },
  beforeMount: function beforeMount() {
    this.firstLoad();
  },
  mounted: function mounted() {
    if (this.$router.history.current.path == "/marketMyPublish") {
      document.title = "我的发布";
    }
    this.picUrl = global.baseImg;
    this.openid = this.$router.history.current.query.openid;
    this.phone = this.$router.history.current.query.phone;
    this.comnCode = this.$router.history.current.query.comnCode;
  },

  methods: {
    submitForm: function submitForm() {
      this.$router.push({ path: '/fleaMarketList', query: {} });
    },
    lowPrice: function lowPrice(mid, price) {
      //降价
      this.show = true;
      this.lowPircId = mid;
      this.lowMoney = price;
      this.totalMoneys = price;
      this.money1 = Number(price) * 0.1;
      this.money2 = Number(price) * 0.3;
      this.money3 = Number(price) * 0.5;
      this.money4 = Number(price) * 0.8;

      var self = this;
      $(".am_expence").delegate("li", "click", function () {

        $(this).addClass("actived").siblings('li').removeClass("actived");
        self.totalMoneys = Number($(".am_expence li.actived .mflex").find("strong").html());
      });
    },
    deleteData: function deleteData(deId) {
      //删除商品
      this.show_1 = true;
      var urls = global.host + 'secondMarket/deletegoodsinfo?goodsId=' + deId;
      this.$http.get(urls).then(function (res) {
        this.show_1 = false;

        var code = res.body.code;
        if (code == "110") {
          this.alrshow = true;
          this.txts = res.body.msg;
          window.location.reload();
          console.log(res.body.msg);
        } else if (code == "120") {
          this.alrshow = true;
          this.txts = res.body.msg;
        }
      }, function (err) {
        console.log(err);
      });
    },
    replyThing: function replyThing(reId) {
      //重新发布
      this.show_1 = true;
      var urls = global.host + 'secondMarket/goodsrepublish?goodsId=' + reId;
      this.$http.get(urls).then(function (res) {
        this.show_1 = false;

        var code = res.body.code;
        if (code == "110") {
          this.alrshow = true;
          this.txts = res.body.msg;
        }
      }, function (err) {
        console.log(err);
      });
    },
    sendMessages: function sendMessages(index) {
      var size = this.list.length;
      for (var i = 0; i < size; i++) {
        this.list.pop();
      }
      if (index == 0) {
        this.firstLoad();
        $(".tabItems .tabliem:first").addClass("actives");
        $(".tabItems .tabliem:last").removeClass("actives");
      } else if (index == 1) {

        this.xjFirstLoad();
        $(".tabItems .tabliem:first").removeClass("actives");
        $(".tabItems .tabliem:last").addClass("actives");
      }
    },
    btnConfirm: function btnConfirm() {
      var urls = global.host + 'secondMarket/goodspricereduction?goodsId=' + this.lowPircId + "&salePrice=" + this.totalMoneys;
      this.$http.get(urls).then(function (res) {

        var code = res.body.code;
        if (code == "110") {
          this.alrshow = true;
          this.txts = res.body.msg;
          $("#" + this.lowPircId).find("strong").html(res.body.price);
        }
      }, function (err) {
        console.log(err);
      });
    },
    feeDown: function feeDown(goodsId) {
      //下架
      this.show_1 = true;
      this.godsId = goodsId;
      var url = global.host + 'secondMarket/goodsDown?goodsId=' + goodsId;
      this.$http.get(url).then(function (res) {
        this.show_1 = false;
        if (res.body.code == '110') {
          this.alrshow = true;
          this.txts = res.body.msg;
        } else if (res.body.code == '120') {
          this.alrshow = true;
          this.txts = res.body.msg;
        }
      }, function (err) {
        console.log(err);
      });
    },
    cancel: function cancel() {},
    xjFirstLoad: function xjFirstLoad() {
      this.show_1 = true;
      var mNum = 1;
      var datas = {
        mainPhone: this.$router.history.current.query.mainPhone,
        comnCode: this.$router.history.current.query.comnCode,
        page: 1,
        rows: 10,
        firstflag: 1,
        isOffline: mNum
      };
      if (mNum) {
        this.mShows = false;
      }
      var url = global.host + 'secondMarket/findgoodslist';
      this.$http.post(url, datas).then(function (res) {
        this.show_1 = false;

        var picList = res.body.goods;
        for (var m in picList) {
          if (picList[m].imgs.length > 0) {
            for (var n in picList[m].imgs) {
              picList[m].imgs[n].minPicUrl = global.baseImg + picList[m].imgs[n].minPicUrl;
            }
          }

          this.list.push(picList[m]);
        }
      }, function (err) {
        console.log(err);
      });
    },
    firstLoad: function firstLoad() {
      this.show_1 = true;
      var datas = {
        mainPhone: this.$router.history.current.query.mainPhone,
        page: 1,
        rows: 10
      };
      this.mShows = true;
      var url = global.host + 'secondMarket/findmyselfgoods';
      this.$http.post(url, datas).then(function (res) {
        this.show_1 = false;

        var picList = res.body.result;
        for (var m in picList) {
          if (picList[m].imgs.length > 0) {
            for (var n in picList[m].imgs) {
              picList[m].imgs[n].minPicUrl = global.baseImg + picList[m].imgs[n].minPicUrl;
            }
          }

          this.list.push(picList[m]);
        }
      }, function (err) {
        console.log(err);
      });
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff45405c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fleaMarketComponents/marketMyPublish.vue
var marketMyPublish_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body_bg"},[_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"tabItems",attrs:{"span":1/2},nativeOn:{"click":function($event){_vm.sendMessages(0)}}},[_c('img',{staticClass:"amImgs",attrs:{"src":__webpack_require__("A4Qo"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"tabliem actives"},[_vm._v("发布信息")])]),_vm._v(" "),_c('flexbox-item',{staticClass:"tabItems",attrs:{"span":1/2},nativeOn:{"click":function($event){_vm.sendMessages(1)}}},[_c('img',{staticClass:"amImgs1",attrs:{"src":__webpack_require__("2gLD"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"tabliem"},[_vm._v("已下架的")])])],1),_vm._v(" "),_c('div',{staticClass:"bars"}),_vm._v(" "),_c('div',{staticClass:"content"},_vm._l((_vm.list),function(items,index){return _c('div',{key:index,staticClass:"contBox3"},[_c('div',{staticStyle:{"width":"100%"}},[_c('flexbox',{staticClass:"am_pbor",attrs:{"gutter":0,"align":"center"}},[_c('flexbox-item',{staticClass:"selects_m2",attrs:{"span":1/3}},[_c('div',{staticClass:"am_img_control"},[_c('router-link',{attrs:{"to":{path:'/marketDetailList',query:{goodsId:items.goodsId,phone:items.telePhone,phones:_vm.phone}}}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.picUrl+items.thumbnail),expression:"picUrl+items.thumbnail"}]})])],1)]),_vm._v(" "),_c('flexbox-item',{staticClass:"selects",attrs:{"span":1/3}},[_c('div',{staticStyle:{"display":"flex","width":"100%"}},[_c('span',{staticClass:"spns"},[_vm._v(_vm._s(items.goodsName))])]),_vm._v(" "),_c('span',{staticClass:"am_color",staticStyle:{"width":"100%"},attrs:{"id":items.goodsId}},[_c('b',[_vm._v("￥")]),_c('strong',[_vm._v(_vm._s(items.salePrice))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mShows),expression:"mShows"}],staticClass:"am_speak"},[_c('i',{staticClass:"fa fa-envelope fonts"}),_vm._v(" "),_c('router-link',{attrs:{"to":{path:'/marketDetailList',query:{goodsId:items.goodsId,phone:items.telePhone,phones:_vm.phone}}}},[_c('strong',[_vm._v("留言("+_vm._s(items.msgCount)+")")])])],1)]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_checks",attrs:{"span":1/3}},[(items.goodsState == '0'  && items.isOffline !='1')?_c('div',[_c('x-button',{staticClass:"am_min_button",attrs:{"type":"default","mini":""}},[_vm._v("临时保存")])],1):_vm._e(),_vm._v(" "),(items.goodsState == '1'  && items.isOffline !='1')?_c('div',[_c('x-button',{staticClass:"am_min_button",attrs:{"type":"default","mini":""}},[_vm._v("审核中")])],1):_vm._e(),_vm._v(" "),(items.goodsState == '2'  && items.isOffline !='1')?_c('div',[_c('x-button',{staticClass:"am_min_button",attrs:{"type":"default","mini":""}},[_vm._v("审核通过")])],1):_vm._e(),_vm._v(" "),(items.goodsState == '3'  && items.isOffline !='1')?_c('div',[_c('x-button',{staticClass:"am_min_button",attrs:{"type":"default","mini":""}},[_vm._v("审核失败")])],1):_vm._e()])],1),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticClass:"am_Date",attrs:{"span":1/2}},[_vm._v(_vm._s(items.createDate))]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"text-align":"right","display":"flex"},attrs:{"span":1/2}},[(items.goodsState == '2' && items.isOffline !='1')?_c('x-button',{staticClass:"am_min_button1 mbuttons",attrs:{"type":"default","mini":""},nativeOn:{"click":function($event){_vm.lowPrice(items.goodsId,items.salePrice,index)}}},[_vm._v("降价")]):_vm._e(),_vm._v(" "),(items.goodsState == '2' && items.isOffline !='1')?_c('x-button',{staticClass:"am_min_button1 mbuttons",attrs:{"type":"default","mini":""},nativeOn:{"click":function($event){_vm.feeDown(items.goodsId)}}},[_vm._v("下架")]):_vm._e(),_vm._v(" "),(items.isOffline == '1')?_c('x-button',{staticClass:"am_min_button1 mbuttons",attrs:{"type":"default","mini":""},nativeOn:{"click":function($event){_vm.replyThing(items.goodsId)}}},[_vm._v("重新发布")]):_vm._e(),_vm._v(" "),(items.goodsState == '1' || items.goodsState == '2' || items.goodsState == '3')?_c('x-button',{staticClass:"am_min_button1 mbuttons",attrs:{"type":"default","mini":""},nativeOn:{"click":function($event){_vm.deleteData(items.goodsId)}}},[_vm._v("删除")]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"bars",staticStyle:{"height":"7px","margin-top":"10px"}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(index))])])})),_vm._v(" "),_c('confirm',{attrs:{"title":"详情","confirm-text":"确认"},on:{"on-confirm":_vm.btnConfirm,"on-cancel":_vm.cancel},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"contents"},[_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticStyle:{"flex":"0 0 27% !important"},attrs:{"span":1/3}},[_c('img',{staticClass:"am_img",attrs:{"src":"https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg","alt":""}})]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_mlis",attrs:{"span":2/3}},[_c('div',{staticClass:"am_cfont"},[_c('strong',{staticClass:"am_cfont"},[_vm._v("现金")]),_vm._v(" "),_c('b',{staticClass:"am_nprice"},[_vm._v("￥"+_vm._s(_vm.lowMoney))])]),_vm._v(" "),_c('div',{staticClass:"am_cfont"},[_c('strong',{staticClass:"am_cfont"},[_vm._v("降价至")]),_vm._v(" "),_c('x-button',{staticClass:"am_stn",attrs:{"type":"default","mini":""}},[_vm._v("￥"+_vm._s(_vm.totalMoneys))])],1)])],1),_vm._v(" "),_c('div',{staticClass:"am_expence"},[_c('ul',{staticClass:"fix"},[_c('li',[_c('div',{staticClass:"mflex"},[_c('b',[_vm._v("￥")]),_c('strong',[_vm._v(_vm._s(_vm.money1))])]),_vm._v(" "),_c('b',[_vm._v("打1折 急速卖")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"mflex"},[_c('b',[_vm._v("￥")]),_c('strong',[_vm._v(_vm._s(_vm.money2))])]),_vm._v(" "),_c('b',[_vm._v("打3折 急速卖")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"mflex"},[_c('b',[_vm._v("￥")]),_c('strong',[_vm._v(_vm._s(_vm.money3))])]),_vm._v(" "),_c('b',[_vm._v("打5折 急速卖")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"mflex"},[_c('b',[_vm._v("￥")]),_c('strong',[_vm._v(_vm._s(_vm.money4))])]),_vm._v(" "),_c('b',[_vm._v("打8折 急速卖")])])])])],1)]),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}}),_vm._v(" "),_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.alrshow),callback:function ($$v) {_vm.alrshow=$$v},expression:"alrshow"}},[_vm._v(_vm._s(_vm.txts))])],1)}
var marketMyPublish_staticRenderFns = []
var marketMyPublish_esExports = { render: marketMyPublish_render, staticRenderFns: marketMyPublish_staticRenderFns }
/* harmony default export */ var components_fleaMarketComponents_marketMyPublish = (marketMyPublish_esExports);
// CONCATENATED MODULE: ./src/components/fleaMarketComponents/marketMyPublish.vue
function marketMyPublish_injectStyle (ssrContext) {
  __webpack_require__("Yj96")
}
var marketMyPublish_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var marketMyPublish___vue_template_functional__ = false
/* styles */
var marketMyPublish___vue_styles__ = marketMyPublish_injectStyle
/* scopeId */
var marketMyPublish___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var marketMyPublish___vue_module_identifier__ = null
var marketMyPublish_Component = marketMyPublish_normalizeComponent(
  fleaMarketComponents_marketMyPublish,
  components_fleaMarketComponents_marketMyPublish,
  marketMyPublish___vue_template_functional__,
  marketMyPublish___vue_styles__,
  marketMyPublish___vue_scopeId__,
  marketMyPublish___vue_module_identifier__
)

/* harmony default export */ var src_components_fleaMarketComponents_marketMyPublish = (marketMyPublish_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/fleaSendStatus.vue




/* harmony default export */ var fleaSendStatus = ({
  data: function data() {
    return {};
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/fleaSendStatus") {
      document.title = "审核列表";
    }
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/fleaSendStatus.vue




/* harmony default export */ var fleaMarketComponents_fleaSendStatus = ({
  data: function data() {
    return {};
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/fleaSendStatus") {
      document.title = "审核列表";
    }
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66252d98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fleaMarketComponents/fleaSendStatus.vue
var fleaSendStatus_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('flexbox',{staticClass:"am_outBor",attrs:{"gutter":0,"orient":"vertical"}},[_c('flexbox-item',{staticClass:"am_flex_row",attrs:{"span":1/2}},[_c('div',{staticClass:"am_centerBor"},[_c('span',[_vm._v("商品名称：便携式灭蚊灯")]),_vm._v(" "),_c('strong',[_vm._v("2018-08-07 10:49")])])]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_rows",attrs:{"span":1/2}},[_c('router-link',{attrs:{"tag":"a","to":{path:'/marketDetailList',query:{}}}},[_vm._v("\n          您提交的商品发布已审核通过，快去看看吧>>\n        ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"bars"})],1)])}
var fleaSendStatus_staticRenderFns = []
var fleaSendStatus_esExports = { render: fleaSendStatus_render, staticRenderFns: fleaSendStatus_staticRenderFns }
/* harmony default export */ var components_fleaMarketComponents_fleaSendStatus = (fleaSendStatus_esExports);
// CONCATENATED MODULE: ./src/components/fleaMarketComponents/fleaSendStatus.vue
function fleaSendStatus_injectStyle (ssrContext) {
  __webpack_require__("qCL5")
}
var fleaSendStatus_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var fleaSendStatus___vue_template_functional__ = false
/* styles */
var fleaSendStatus___vue_styles__ = fleaSendStatus_injectStyle
/* scopeId */
var fleaSendStatus___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var fleaSendStatus___vue_module_identifier__ = null
var fleaSendStatus_Component = fleaSendStatus_normalizeComponent(
  fleaMarketComponents_fleaSendStatus,
  components_fleaMarketComponents_fleaSendStatus,
  fleaSendStatus___vue_template_functional__,
  fleaSendStatus___vue_styles__,
  fleaSendStatus___vue_scopeId__,
  fleaSendStatus___vue_module_identifier__
)

/* harmony default export */ var src_components_fleaMarketComponents_fleaSendStatus = (fleaSendStatus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/commodityMesReply.vue







/* harmony default export */ var commodityMesReply = ({
  data: function data() {
    return {
      show_1: false,
      list: [],
      msDate: 1,
      phone: ''
    };
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    loadPage: src_components_loadingPage,
    InlineLoading: vux_src_components_inline_loading
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/commodityMesReply") {
      document.title = "留言回复";
    }
    this.phone = this.$router.history.current.query.phone;
    this.loadData(1);
  },
  mounted: function mounted() {

    mobilwmtouch(document.getElementById("g1"));
    document.getElementById("g1").addEventListener('touup', this.touchup, false);
    function mobilwmtouch(obj) {
      var stoux, stouy;
      var etoux, etouy;
      var xdire, ydire;
      obj.addEventListener("touchstart", function (e) {
        stoux = e.targetTouches[0].clientX;
        stouy = e.targetTouches[0].clientY;
      }, false);
      obj.addEventListener("touchend", function (e) {
        etoux = e.changedTouches[0].clientX;
        etouy = e.changedTouches[0].clientY;
        xdire = etoux - stoux;
        ydire = etouy - stouy;
        var chazhi = Math.abs(xdire) - Math.abs(ydire);

        if (xdire > 0 && chazhi > 0) {
          console.log("right");

          obj.dispatchEvent(evenzc('touright'));
        } else if (ydire > 0 && chazhi < 0) {
          console.log("down");
          obj.dispatchEvent(evenzc('toudown'));
        } else if (xdire < 0 && chazhi > 0) {
          console.log("left");
          obj.dispatchEvent(evenzc('touleft'));
        } else if (ydire < 0 && chazhi < 0) {
          console.log("up");
          obj.dispatchEvent(evenzc('touup'));
        }
      }, false);
    }

    function evenzc(eve) {
      var event = '';
      if (typeof document.CustomEvent === 'function') {
        event = new document.CustomEvent(eve, { //自定义事件名称
          bubbles: false, //是否冒泡
          cancelable: false
        });
        if (!document["evetself" + eve]) {
          document["evetself" + eve] = event;
        }
      } else if (typeof document.createEvent === 'function') {
        event = document.createEvent('HTMLEvents');
        event.initEvent(eve, false, false);
        if (!document["evetself" + eve]) {
          document["evetself" + eve] = event;
        }
      } else {
        return false;
      }

      return document["evetself" + eve];
    }
  },

  methods: {
    touchup: function touchup() {
      $(".am_absolt").show();
      this.msDate++;
      console.log(this.msDate);
      this.loadData(this.msDate);
    },
    loadData: function loadData(pages) {
      //获取数据方法
      this.show_1 = true;
      var jsonData = {
        receivePhone: this.$router.history.current.query.phone,
        noticeType: 'oldGoods',
        page: pages,
        rows: 4
      };
      var url = global.host + 'secondMarket/findnoticecenter';
      this.$http.post(url, jsonData).then(function (res) {

        var picList = res.body;
        for (var mv in picList) {
          this.list.push(picList[mv]);
        }

        this.show_1 = false;
        $(".am_absolt").hide();

        if (jsonData.rows != res.body.length) {
          document.getElementById("g1").removeEventListener('touup', this.touchup);
        }
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/commodityMesReply.vue







/* harmony default export */ var fleaMarketComponents_commodityMesReply = ({
  data: function data() {
    return {
      show_1: false,
      list: [],
      msDate: 1,
      phone: ''
    };
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    loadPage: src_components_loadingPage,
    InlineLoading: vux_src_components_inline_loading
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/commodityMesReply") {
      document.title = "留言回复";
    }
    this.phone = this.$router.history.current.query.phone;
    this.loadData(1);
  },
  mounted: function mounted() {

    mobilwmtouch(document.getElementById("g1"));
    document.getElementById("g1").addEventListener('touup', this.touchup, false);
    function mobilwmtouch(obj) {
      var stoux, stouy;
      var etoux, etouy;
      var xdire, ydire;
      obj.addEventListener("touchstart", function (e) {
        stoux = e.targetTouches[0].clientX;
        stouy = e.targetTouches[0].clientY;
      }, false);
      obj.addEventListener("touchend", function (e) {
        etoux = e.changedTouches[0].clientX;
        etouy = e.changedTouches[0].clientY;
        xdire = etoux - stoux;
        ydire = etouy - stouy;
        var chazhi = Math.abs(xdire) - Math.abs(ydire);

        if (xdire > 0 && chazhi > 0) {
          console.log("right");

          obj.dispatchEvent(evenzc('touright'));
        } else if (ydire > 0 && chazhi < 0) {
          console.log("down");
          obj.dispatchEvent(evenzc('toudown'));
        } else if (xdire < 0 && chazhi > 0) {
          console.log("left");
          obj.dispatchEvent(evenzc('touleft'));
        } else if (ydire < 0 && chazhi < 0) {
          console.log("up");
          obj.dispatchEvent(evenzc('touup'));
        }
      }, false);
    }

    function evenzc(eve) {
      var event = '';
      if (typeof document.CustomEvent === 'function') {
        event = new document.CustomEvent(eve, { //自定义事件名称
          bubbles: false, //是否冒泡
          cancelable: false
        });
        if (!document["evetself" + eve]) {
          document["evetself" + eve] = event;
        }
      } else if (typeof document.createEvent === 'function') {
        event = document.createEvent('HTMLEvents');
        event.initEvent(eve, false, false);
        if (!document["evetself" + eve]) {
          document["evetself" + eve] = event;
        }
      } else {
        return false;
      }

      return document["evetself" + eve];
    }
  },

  methods: {
    touchup: function touchup() {
      $(".am_absolt").show();
      this.msDate++;
      console.log(this.msDate);
      this.loadData(this.msDate);
    },
    loadData: function loadData(pages) {
      //获取数据方法
      this.show_1 = true;
      var jsonData = {
        receivePhone: this.$router.history.current.query.phone,
        noticeType: 'oldGoods',
        page: pages,
        rows: 4
      };
      var url = global.host + 'secondMarket/findnoticecenter';
      this.$http.post(url, jsonData).then(function (res) {

        var picList = res.body;
        for (var mv in picList) {
          this.list.push(picList[mv]);
        }

        this.show_1 = false;
        $(".am_absolt").hide();

        if (jsonData.rows != res.body.length) {
          document.getElementById("g1").removeEventListener('touup', this.touchup);
        }
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29d06b22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fleaMarketComponents/commodityMesReply.vue
var commodityMesReply_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"g1"}},[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"container"},[_c('flexbox',{staticClass:"am_outBor",attrs:{"gutter":0,"orient":"vertical"}},[_c('flexbox-item',{staticClass:"am_flex_row",attrs:{"span":1/2}},[_c('div',{staticClass:"am_centerBor"},[_c('span',[_vm._v("商品名称："+_vm._s(item.noticeTitle))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(item.pushDate))])])]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_rows",attrs:{"span":1/2}},[_c('router-link',{attrs:{"tag":"a","to":{path:item.noticeLink}}},[_vm._v("\n          您留言的商品有新的回复，快去看看吧>>\n        ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"bars"})],1)}),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}}),_vm._v(" "),_c('div',{staticClass:"am_absolt"},[_c('inline-loading'),_vm._v(" "),_c('span',{staticStyle:{"vertical-align":"middle","display":"inline-block","font-size":"14px"}},[_vm._v("加载中...")])],1)],2)}
var commodityMesReply_staticRenderFns = []
var commodityMesReply_esExports = { render: commodityMesReply_render, staticRenderFns: commodityMesReply_staticRenderFns }
/* harmony default export */ var components_fleaMarketComponents_commodityMesReply = (commodityMesReply_esExports);
// CONCATENATED MODULE: ./src/components/fleaMarketComponents/commodityMesReply.vue
function commodityMesReply_injectStyle (ssrContext) {
  __webpack_require__("/C2o")
}
var commodityMesReply_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var commodityMesReply___vue_template_functional__ = false
/* styles */
var commodityMesReply___vue_styles__ = commodityMesReply_injectStyle
/* scopeId */
var commodityMesReply___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var commodityMesReply___vue_module_identifier__ = null
var commodityMesReply_Component = commodityMesReply_normalizeComponent(
  fleaMarketComponents_commodityMesReply,
  components_fleaMarketComponents_commodityMesReply,
  commodityMesReply___vue_template_functional__,
  commodityMesReply___vue_styles__,
  commodityMesReply___vue_scopeId__,
  commodityMesReply___vue_module_identifier__
)

/* harmony default export */ var src_components_fleaMarketComponents_commodityMesReply = (commodityMesReply_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/checkFailure.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var checkFailure = ({
  data: function data() {
    return {
      statucode: ''
    };
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/commodityMesReply") {
      document.title = "审核页";
    }
    this.statucode = this.$router.history.current.query.status;
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/checkFailure.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var fleaMarketComponents_checkFailure = ({
  data: function data() {
    return {
      statucode: ''
    };
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/commodityMesReply") {
      document.title = "审核页";
    }
    this.statucode = this.$router.history.current.query.status;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03664c4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fleaMarketComponents/checkFailure.vue
var checkFailure_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.statucode == '0')?_c('div',[_vm._m(0)]):(_vm.statucode == '1')?_c('div',[_vm._m(1)]):(_vm.statucode == '3')?_c('div',[_vm._m(2)]):_vm._e()])}
var checkFailure_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"am_content"},[_c('i',{staticClass:"fa fa-shopping-basket am_fot1"}),_c('strong',[_vm._v("临时保存")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"am_content"},[_c('i',{staticClass:"fa fa-hourglass-half am_fot1"}),_c('strong',[_vm._v("正在审核中...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"am_content"},[_c('i',{staticClass:"fa fa-frown-o am_fot"}),_c('strong',[_vm._v("审核失败了")])])}]
var checkFailure_esExports = { render: checkFailure_render, staticRenderFns: checkFailure_staticRenderFns }
/* harmony default export */ var components_fleaMarketComponents_checkFailure = (checkFailure_esExports);
// CONCATENATED MODULE: ./src/components/fleaMarketComponents/checkFailure.vue
function checkFailure_injectStyle (ssrContext) {
  __webpack_require__("B7Bd")
}
var checkFailure_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checkFailure___vue_template_functional__ = false
/* styles */
var checkFailure___vue_styles__ = checkFailure_injectStyle
/* scopeId */
var checkFailure___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checkFailure___vue_module_identifier__ = null
var checkFailure_Component = checkFailure_normalizeComponent(
  fleaMarketComponents_checkFailure,
  components_fleaMarketComponents_checkFailure,
  checkFailure___vue_template_functional__,
  checkFailure___vue_styles__,
  checkFailure___vue_scopeId__,
  checkFailure___vue_module_identifier__
)

/* harmony default export */ var src_components_fleaMarketComponents_checkFailure = (checkFailure_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/myCloct.vue







/* harmony default export */ var myCloct = ({
  data: function data() {
    return {
      show_1: false,
      list: [],
      msDate: 1
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    var regphone = this.$router.history.current.query.phone;
    var urls = global.host + 'secondMarket/findmycollecting?regphone=' + regphone;
    this.$http.get(urls).then(function (res) {
      var resultList = res.body.result;
      for (var i in resultList) {
        if (resultList[i].imgs.length > 0) {
          for (var s in resultList[i].imgs) {
            resultList[i].imgs[s].minPicUrl = global.baseImg + resultList[i].imgs[s].minPicUrl;
            console.log(resultList[i].imgs[s].minPicUrl);
          }
        }

        this.list.push(resultList[i]);
      }

      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },
  mounted: function mounted() {

    mobilwmtouch(document.getElementById("g1"));
    document.getElementById("g1").addEventListener('touup', this.touchup, false);
    function mobilwmtouch(obj) {
      var stoux, stouy;
      var etoux, etouy;
      var xdire, ydire;
      obj.addEventListener("touchstart", function (e) {
        stoux = e.targetTouches[0].clientX;
        stouy = e.targetTouches[0].clientY;
      }, false);
      obj.addEventListener("touchend", function (e) {
        etoux = e.changedTouches[0].clientX;
        etouy = e.changedTouches[0].clientY;
        xdire = etoux - stoux;
        ydire = etouy - stouy;
        var chazhi = Math.abs(xdire) - Math.abs(ydire);

        if (xdire > 0 && chazhi > 0) {
          console.log("right");

          obj.dispatchEvent(evenzc('touright'));
        } else if (ydire > 0 && chazhi < 0) {
          console.log("down");
          obj.dispatchEvent(evenzc('toudown'));
        } else if (xdire < 0 && chazhi > 0) {
          console.log("left");
          obj.dispatchEvent(evenzc('touleft'));
        } else if (ydire < 0 && chazhi < 0) {
          console.log("up");
          obj.dispatchEvent(evenzc('touup'));
        }
      }, false);
    }

    function evenzc(eve) {
      var event = '';
      if (typeof document.CustomEvent === 'function') {
        event = new document.CustomEvent(eve, { //自定义事件名称
          bubbles: false, //是否冒泡
          cancelable: false
        });
        if (!document["evetself" + eve]) {
          document["evetself" + eve] = event;
        }
      } else if (typeof document.createEvent === 'function') {
        event = document.createEvent('HTMLEvents');
        event.initEvent(eve, false, false);
        if (!document["evetself" + eve]) {
          document["evetself" + eve] = event;
        }
      } else {
        return false;
      }

      return document["evetself" + eve];
    }
  },

  methods: {
    touchup: function touchup() {
      $(".am_absolt").show();
      this.msDate++;
      console.log(this.msDate);
      this.loadData(this.msDate);
    },
    loadData: function loadData(pages) {
      //获取数据方法
      this.show_1 = true;
      var jsonData = {
        receivePhone: this.$router.history.current.query.phone,
        noticeType: 'oldGoods',
        page: pages,
        rows: 4
      };
      var url = global.host + 'secondMarket/findnoticecenter';
      this.$http.post(url, jsonData).then(function (res) {

        var picList = res.body.result;
        for (var mv in picList) {
          if (picList[mv].imgs.length > 0) {
            for (var nv in picList[mv].imgs) {
              picList[mv].imgs[nv].minPicUrl = global.baseImg + picList[mv].imgs[nv].minPicUrl;
            }
          }
          this.list.push(picList[mv]);
        }

        this.show_1 = false;
        $(".am_absolt").hide();

        if (jsonData.rows != res.body.goods.length) {
          document.getElementById("g1").removeEventListener('touup', this.touchup);
        }
      }, function (err) {
        console.log(err);
      });
    }
  },
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    loadPage: src_components_loadingPage,
    InlineLoading: vux_src_components_inline_loading
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fleaMarketComponents/myCloct.vue







/* harmony default export */ var fleaMarketComponents_myCloct = ({
  data: function data() {
    return {
      show_1: false,
      list: [],
      msDate: 1
    };
  },
  beforeMount: function beforeMount() {
    this.show_1 = true;
    var regphone = this.$router.history.current.query.phone;
    var urls = global.host + 'secondMarket/findmycollecting?regphone=' + regphone;
    this.$http.get(urls).then(function (res) {
      var resultList = res.body.result;
      for (var i in resultList) {
        if (resultList[i].imgs.length > 0) {
          for (var s in resultList[i].imgs) {
            resultList[i].imgs[s].minPicUrl = global.baseImg + resultList[i].imgs[s].minPicUrl;
            console.log(resultList[i].imgs[s].minPicUrl);
          }
        }

        this.list.push(resultList[i]);
      }

      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },
  mounted: function mounted() {

    mobilwmtouch(document.getElementById("g1"));
    document.getElementById("g1").addEventListener('touup', this.touchup, false);
    function mobilwmtouch(obj) {
      var stoux, stouy;
      var etoux, etouy;
      var xdire, ydire;
      obj.addEventListener("touchstart", function (e) {
        stoux = e.targetTouches[0].clientX;
        stouy = e.targetTouches[0].clientY;
      }, false);
      obj.addEventListener("touchend", function (e) {
        etoux = e.changedTouches[0].clientX;
        etouy = e.changedTouches[0].clientY;
        xdire = etoux - stoux;
        ydire = etouy - stouy;
        var chazhi = Math.abs(xdire) - Math.abs(ydire);

        if (xdire > 0 && chazhi > 0) {
          console.log("right");

          obj.dispatchEvent(evenzc('touright'));
        } else if (ydire > 0 && chazhi < 0) {
          console.log("down");
          obj.dispatchEvent(evenzc('toudown'));
        } else if (xdire < 0 && chazhi > 0) {
          console.log("left");
          obj.dispatchEvent(evenzc('touleft'));
        } else if (ydire < 0 && chazhi < 0) {
          console.log("up");
          obj.dispatchEvent(evenzc('touup'));
        }
      }, false);
    }

    function evenzc(eve) {
      var event = '';
      if (typeof document.CustomEvent === 'function') {
        event = new document.CustomEvent(eve, { //自定义事件名称
          bubbles: false, //是否冒泡
          cancelable: false
        });
        if (!document["evetself" + eve]) {
          document["evetself" + eve] = event;
        }
      } else if (typeof document.createEvent === 'function') {
        event = document.createEvent('HTMLEvents');
        event.initEvent(eve, false, false);
        if (!document["evetself" + eve]) {
          document["evetself" + eve] = event;
        }
      } else {
        return false;
      }

      return document["evetself" + eve];
    }
  },

  methods: {
    touchup: function touchup() {
      $(".am_absolt").show();
      this.msDate++;
      console.log(this.msDate);
      this.loadData(this.msDate);
    },
    loadData: function loadData(pages) {
      //获取数据方法
      this.show_1 = true;
      var jsonData = {
        receivePhone: this.$router.history.current.query.phone,
        noticeType: 'oldGoods',
        page: pages,
        rows: 4
      };
      var url = global.host + 'secondMarket/findnoticecenter';
      this.$http.post(url, jsonData).then(function (res) {

        var picList = res.body.result;
        for (var mv in picList) {
          if (picList[mv].imgs.length > 0) {
            for (var nv in picList[mv].imgs) {
              picList[mv].imgs[nv].minPicUrl = global.baseImg + picList[mv].imgs[nv].minPicUrl;
            }
          }
          this.list.push(picList[mv]);
        }

        this.show_1 = false;
        $(".am_absolt").hide();

        if (jsonData.rows != res.body.goods.length) {
          document.getElementById("g1").removeEventListener('touup', this.touchup);
        }
      }, function (err) {
        console.log(err);
      });
    }
  },
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    loadPage: src_components_loadingPage,
    InlineLoading: vux_src_components_inline_loading
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09859882","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fleaMarketComponents/myCloct.vue
var myCloct_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"g1"}},[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"am_list"},[_c('router-link',{attrs:{"to":{path:item.collectUrl}}},[_c('flexbox',{attrs:{"gutter":0}},[_vm._l((item.imgs),function(itms,index){return (index ==0)?_c('flexbox-item',{key:index,staticClass:"am_flexs",attrs:{"span":1/3}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(itms.minPicUrl),expression:"itms.minPicUrl"}],attrs:{"alt":""}})]):_vm._e()}),_vm._v(" "),_c('flexbox-item',{staticClass:"am_texts",attrs:{"span":2/3}},[_c('p',[_vm._v(_vm._s(item.collectDesc))])])],2),_vm._v(" "),_c('h1',[_c('strong',[_vm._v(_vm._s(item.collectType))]),_c('b',[_vm._v(_vm._s(item.collectDate))])])],1)],1)}),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}}),_vm._v(" "),_c('div',{staticClass:"am_absolt"},[_c('inline-loading'),_vm._v(" "),_c('span',{staticStyle:{"vertical-align":"middle","display":"inline-block","font-size":"14px"}},[_vm._v("加载中...")])],1)],2)}
var myCloct_staticRenderFns = []
var myCloct_esExports = { render: myCloct_render, staticRenderFns: myCloct_staticRenderFns }
/* harmony default export */ var components_fleaMarketComponents_myCloct = (myCloct_esExports);
// CONCATENATED MODULE: ./src/components/fleaMarketComponents/myCloct.vue
function myCloct_injectStyle (ssrContext) {
  __webpack_require__("vXAY")
}
var myCloct_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myCloct___vue_template_functional__ = false
/* styles */
var myCloct___vue_styles__ = myCloct_injectStyle
/* scopeId */
var myCloct___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var myCloct___vue_module_identifier__ = null
var myCloct_Component = myCloct_normalizeComponent(
  fleaMarketComponents_myCloct,
  components_fleaMarketComponents_myCloct,
  myCloct___vue_template_functional__,
  myCloct___vue_styles__,
  myCloct___vue_scopeId__,
  myCloct___vue_module_identifier__
)

/* harmony default export */ var src_components_fleaMarketComponents_myCloct = (myCloct_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Big = __webpack_require__("gaXx");
/* harmony default export */ var x_number = ({
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new Big(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new Big(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var x_number_Big = __webpack_require__("gaXx");
/* harmony default export */ var components_x_number = ({
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new x_number_Big(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new x_number_Big(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c56f24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-number/index.vue
var x_number_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell"},[_c('div',[_c('p',{class:_vm.labelClass,style:({width: _vm.$parent.labelWidth, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.readonly),expression:"!readonly"}],staticClass:"weui-cell__ft vux-cell-primary",class:{'vux-number-round': _vm.buttonStyle === 'round'},staticStyle:{"font-size":"0"}},[_c('div',{style:({float:_vm.align})},[_c('a',{staticClass:"vux-number-selector vux-number-selector-sub",class:{'vux-number-disabled':_vm.disabledMin},on:{"click":_vm.sub}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"18"}},[_c('defs'),_c('path',{attrs:{"d":"M863.74455 544.00086 163.424056 544.00086c-17.664722 0-32.00086-14.336138-32.00086-32.00086s14.336138-32.00086 32.00086-32.00086l700.320495 0c17.695686 0 31.99914 14.336138 31.99914 32.00086S881.440237 544.00086 863.74455 544.00086z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentValue),expression:"currentValue",modifiers:{"number":true}}],staticClass:"vux-number-input",style:({width: _vm.width}),attrs:{"name":_vm.name,"readonly":!_vm.fillable,"pattern":"[0-9]*","type":"number"},domProps:{"value":(_vm.currentValue)},on:{"blur":[_vm.blur,function($event){_vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.currentValue=_vm._n($event.target.value)}}}),_vm._v(" "),_c('a',{staticClass:"vux-number-selector vux-number-selector-plus",class:{'vux-number-disabled':_vm.disabledMax},on:{"click":_vm.add}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20"}},[_c('defs'),_c('path',{attrs:{"d":"M863.328262 481.340895l-317.344013 0.099772L545.984249 162.816826c0-17.664722-14.336138-32.00086-32.00086-32.00086s-31.99914 14.336138-31.99914 32.00086l0 318.400215-322.368714-0.17718c-0.032684 0-0.063647 0-0.096331 0-17.632039 0-31.935493 14.239806-32.00086 31.904529-0.096331 17.664722 14.208843 32.031824 31.871845 32.095471l322.59234 0.17718 0 319.167424c0 17.695686 14.336138 32.00086 31.99914 32.00086s32.00086-14.303454 32.00086-32.00086L545.982529 545.440667l317.087703-0.099772c0.063647 0 0.096331 0 0.127295 0 17.632039 0 31.935493-14.239806 32.00086-31.904529S880.960301 481.404542 863.328262 481.340895z"}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readonly),expression:"readonly"}],staticClass:"weui-cell__ft vux-cell-primary"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var x_number_staticRenderFns = []
var x_number_esExports = { render: x_number_render, staticRenderFns: x_number_staticRenderFns }
/* harmony default export */ var src_components_x_number = (x_number_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-number/index.vue
function x_number_injectStyle (ssrContext) {
  __webpack_require__("uO6d")
}
var x_number_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_number___vue_template_functional__ = false
/* styles */
var x_number___vue_styles__ = x_number_injectStyle
/* scopeId */
var x_number___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_number___vue_module_identifier__ = null
var x_number_Component = x_number_normalizeComponent(
  components_x_number,
  src_components_x_number,
  x_number___vue_template_functional__,
  x_number___vue_styles__,
  x_number___vue_scopeId__,
  x_number___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_number = (x_number_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/temporaryCharge/relatedToNumber.vue










/* harmony default export */ var relatedToNumber = ({
  data: function data() {
    return {
      value1: '装修许可证工本费',
      value2: '',
      value3: '5.0元',
      changeValue: '0',
      numMoney: '5.0',
      aList: [['非业主', '业主']],
      list1: ['非业主'],
      alertVal: '',
      show_1: false,
      value4: '',
      value6: '',
      value7: '',
      value8: '',
      hsNo: '',
      hsName: '',
      m1: true,
      m2: false,
      m3: false,
      billCode: ''
    };
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    XNumber: vux_src_components_x_number,
    XButton: vux_src_components_x_button,
    PopupPicker: popup_picker["a" /* default */],
    loadPage: src_components_loadingPage

  },
  beforeMount: function beforeMount() {
    this.value1 = this.$router.history.current.query.feeName;
    this.value2 = Number(this.$router.history.current.query.price) + '元/本';
    this.changeValue = Number(this.$router.history.current.query.feeNum);
    this.value3 = Number(this.$router.history.current.query.feeMoney).toFixed(2);
    this.numMoney = Number(this.$router.history.current.query.feeMoney).toFixed(2);
    this.hsName = this.$router.history.current.query.hsName;
    this.hsNo = this.$router.history.current.query.hsNo;
    if (this.$router.history.current.path == "/relatedToNumber") {
      document.title = this.value1;
    }
  },
  mounted: function mounted() {
    this.changVal();
  },

  methods: {
    changVal: function changVal() {
      this.value3 = Number(this.value3).toFixed(2);
    },
    changeNum: function changeNum() {
      //随数量价格改变
      this.value3 = (this.changeValue * parseFloat(this.value2)).toFixed(2);
      this.numMoney = (this.changeValue * parseFloat(this.value2)).toFixed(2);
    },
    changes: function changes() {
      console.log(this.list1[0]);
      if (this.list1[0] == "业主") {
        this.m1 = false;
        this.m2 = true;
        this.m3 = true;
      } else if (this.list1[0] == "非业主") {
        this.m1 = true;
        this.m2 = false;
        this.m3 = false;
      }
    },
    comval: function comval() {
      $("#ms1").find(".weui-label").css('color', '#000');
    },
    goPay: function goPay() {
      var senddata = new Object();
      senddata.comnCode = this.$router.history.current.query.comnCode;
      senddata.memberNo = this.$router.history.current.query.mainPhone;
      senddata.openid = this.$router.history.current.query.openId;
      senddata.tradeAmount = this.numMoney;
      senddata.tradeNo = this.billCode;
      senddata.tradeName = '临时收费';
      senddata.tradeDesc = '临时收费';
      var url = global.host + 'temporaryCharge/getpayurl';
      this.$http.post(url, senddata).then(function (res) {
        if (res.body.code == '110') {
          window.location.href = res.body.payurl;
        } else {
          this.prompt = '支付异常,请稍候再试';
          this.submitable = false;
          this.showprompt = true;
        }
      }, function (err) {
        console.log(err);
      });
    },
    payFord: function payFord() {
      //立即支付
      if (this.hsName == '') {
        this.alertVal = '必填项';
        $("#ms1").find(".weui-label").css('color', '#ff0000');
      } else {
        if (this.hsNo == null || this.hsNo == '') {
          this.hsNo = '非业主';
        }
        this.show_1 = true;
        var usIn = new Object();
        usIn.comnCode = this.$router.history.current.query.comnCode;
        usIn.feeCode = this.$router.history.current.query.feeCode;
        usIn.hsNo = this.hsNo;
        usIn.hsName = this.hsName;
        usIn.remark = this.value4;
        usIn.sumFeeMoney = this.numMoney;
        usIn.feeNum = this.$router.history.current.query.feeNum + '';
        usIn.calArea = '0';
        usIn.calType = this.$router.history.current.query.calType;
        var url = global.host + 'temporaryCharge/collectTemporary';
        this.$http.post(url, usIn).then(function (res) {

          if (res.body.success == true) {
            this.billCode = res.body.result;
            this.goPay();
          }

          this.show_1 = false;
        }, function (err) {
          console.log(err);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/temporaryCharge/relatedToNumber.vue










/* harmony default export */ var temporaryCharge_relatedToNumber = ({
  data: function data() {
    return {
      value1: '装修许可证工本费',
      value2: '',
      value3: '5.0元',
      changeValue: '0',
      numMoney: '5.0',
      aList: [['非业主', '业主']],
      list1: ['非业主'],
      alertVal: '',
      show_1: false,
      value4: '',
      value6: '',
      value7: '',
      value8: '',
      hsNo: '',
      hsName: '',
      m1: true,
      m2: false,
      m3: false,
      billCode: ''
    };
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    XNumber: vux_src_components_x_number,
    XButton: vux_src_components_x_button,
    PopupPicker: popup_picker["a" /* default */],
    loadPage: src_components_loadingPage

  },
  beforeMount: function beforeMount() {
    this.value1 = this.$router.history.current.query.feeName;
    this.value2 = Number(this.$router.history.current.query.price) + '元/本';
    this.changeValue = Number(this.$router.history.current.query.feeNum);
    this.value3 = Number(this.$router.history.current.query.feeMoney).toFixed(2);
    this.numMoney = Number(this.$router.history.current.query.feeMoney).toFixed(2);
    this.hsName = this.$router.history.current.query.hsName;
    this.hsNo = this.$router.history.current.query.hsNo;
    if (this.$router.history.current.path == "/relatedToNumber") {
      document.title = this.value1;
    }
  },
  mounted: function mounted() {
    this.changVal();
  },

  methods: {
    changVal: function changVal() {
      this.value3 = Number(this.value3).toFixed(2);
    },
    changeNum: function changeNum() {
      //随数量价格改变
      this.value3 = (this.changeValue * parseFloat(this.value2)).toFixed(2);
      this.numMoney = (this.changeValue * parseFloat(this.value2)).toFixed(2);
    },
    changes: function changes() {
      console.log(this.list1[0]);
      if (this.list1[0] == "业主") {
        this.m1 = false;
        this.m2 = true;
        this.m3 = true;
      } else if (this.list1[0] == "非业主") {
        this.m1 = true;
        this.m2 = false;
        this.m3 = false;
      }
    },
    comval: function comval() {
      $("#ms1").find(".weui-label").css('color', '#000');
    },
    goPay: function goPay() {
      var senddata = new Object();
      senddata.comnCode = this.$router.history.current.query.comnCode;
      senddata.memberNo = this.$router.history.current.query.mainPhone;
      senddata.openid = this.$router.history.current.query.openId;
      senddata.tradeAmount = this.numMoney;
      senddata.tradeNo = this.billCode;
      senddata.tradeName = '临时收费';
      senddata.tradeDesc = '临时收费';
      var url = global.host + 'temporaryCharge/getpayurl';
      this.$http.post(url, senddata).then(function (res) {
        if (res.body.code == '110') {
          window.location.href = res.body.payurl;
        } else {
          this.prompt = '支付异常,请稍候再试';
          this.submitable = false;
          this.showprompt = true;
        }
      }, function (err) {
        console.log(err);
      });
    },
    payFord: function payFord() {
      //立即支付
      if (this.hsName == '') {
        this.alertVal = '必填项';
        $("#ms1").find(".weui-label").css('color', '#ff0000');
      } else {
        if (this.hsNo == null || this.hsNo == '') {
          this.hsNo = '非业主';
        }
        this.show_1 = true;
        var usIn = new Object();
        usIn.comnCode = this.$router.history.current.query.comnCode;
        usIn.feeCode = this.$router.history.current.query.feeCode;
        usIn.hsNo = this.hsNo;
        usIn.hsName = this.hsName;
        usIn.remark = this.value4;
        usIn.sumFeeMoney = this.numMoney;
        usIn.feeNum = this.$router.history.current.query.feeNum + '';
        usIn.calArea = '0';
        usIn.calType = this.$router.history.current.query.calType;
        var url = global.host + 'temporaryCharge/collectTemporary';
        this.$http.post(url, usIn).then(function (res) {

          if (res.body.success == true) {
            this.billCode = res.body.result;
            this.goPay();
          }

          this.show_1 = false;
        }, function (err) {
          console.log(err);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a55b115c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/temporaryCharge/relatedToNumber.vue
var relatedToNumber_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"am_conFent"},[_c('div',{staticClass:"am_box_bor"},[_c('flexbox',{attrs:{"gutter":0,"orient":"vertical"}},[_c('flexbox-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.m1),expression:"m1"}],staticClass:"am_comebor"},[_c('x-input',{attrs:{"title":"缴费人","id":"ms1","text-align":"right","placeholder":_vm.alertVal},on:{"on-blur":_vm.comval},model:{value:(_vm.hsName),callback:function ($$v) {_vm.hsName=$$v},expression:"hsName"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor"},[_c('x-input',{attrs:{"title":"收费项目","text-align":"right","disabled":""},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor"},[_c('x-input',{attrs:{"title":"费率","text-align":"right","disabled":""},model:{value:(_vm.value2),callback:function ($$v) {_vm.value2=$$v},expression:"value2"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor"},[_c('x-number',{staticClass:"am_Nums",attrs:{"title":"数量","width":"40px","button-style":"round","min":1},on:{"on-change":_vm.changeNum},model:{value:(_vm.changeValue),callback:function ($$v) {_vm.changeValue=$$v},expression:"changeValue"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor ncent"},[_c('span',{staticClass:"dins"},[_vm._v("金额")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","margin-right":"15px","color":"#ff0000"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value3),expression:"value3"}],staticClass:"am_Color  dings ngBg",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.value3)},on:{"change":_vm.changVal,"input":function($event){if($event.target.composing){ return; }_vm.value3=$event.target.value}}}),_vm._v("元\n          ")])]),_vm._v(" "),_c('flexbox-item',[_c('x-input',{attrs:{"title":"备注信息","text-align":"right"},model:{value:(_vm.value4),callback:function ($$v) {_vm.value4=$$v},expression:"value4"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"am_buttons"},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.payFord($event)}}},[_vm._v("立即支付("+_vm._s(_vm.numMoney)+")元")])],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var relatedToNumber_staticRenderFns = []
var relatedToNumber_esExports = { render: relatedToNumber_render, staticRenderFns: relatedToNumber_staticRenderFns }
/* harmony default export */ var components_temporaryCharge_relatedToNumber = (relatedToNumber_esExports);
// CONCATENATED MODULE: ./src/components/temporaryCharge/relatedToNumber.vue
function relatedToNumber_injectStyle (ssrContext) {
  __webpack_require__("pJHf")
}
var relatedToNumber_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var relatedToNumber___vue_template_functional__ = false
/* styles */
var relatedToNumber___vue_styles__ = relatedToNumber_injectStyle
/* scopeId */
var relatedToNumber___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var relatedToNumber___vue_module_identifier__ = null
var relatedToNumber_Component = relatedToNumber_normalizeComponent(
  temporaryCharge_relatedToNumber,
  components_temporaryCharge_relatedToNumber,
  relatedToNumber___vue_template_functional__,
  relatedToNumber___vue_styles__,
  relatedToNumber___vue_scopeId__,
  relatedToNumber___vue_module_identifier__
)

/* harmony default export */ var src_components_temporaryCharge_relatedToNumber = (relatedToNumber_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/temporaryCharge/feePayment.vue











/* harmony default export */ var feePayment = ({
  data: function data() {
    return defineProperty_default()({
      picList: [],
      titleList: [],
      srcs: '',
      show_1: false,
      openid: '',
      comnCode: '',
      feeCode: '',
      shos: false,
      msg: '',
      hsNo: '',
      hsName: '',
      mainPhone: '',
      phone: ''
    }, 'hsName', '');
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    XNumber: vux_src_components_x_number,
    XButton: vux_src_components_x_button,
    loadPage: src_components_loadingPage,
    Alert: components_alert["a" /* default */]

  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/feePayment") {
      document.title = "费用缴纳";
    }
    this.openid = this.$router.history.current.query.openid;
    this.comnCode = this.$router.history.current.query.comnCode;

    this.show_1 = true;
    var usInfo = new Object();
    usInfo.comnCode = this.comnCode;
    usInfo.openId = this.openid;
    var url = global.host + 'temporaryCharge/init';
    this.$http.post(url, usInfo).then(function (res) {

      var results = res.body.success;
      var picList = res.body.result;
      var rows = '';
      if (results) {
        for (var key in picList) {
          for (var key1 in picList[key]) {
            rows += "<h1>" + key1 + "</h1>";
            var mn = picList[key][key1];
            for (var i = 0; i < mn.length; i++) {
              rows += "<li class='am_flexItem mout' id='" + mn[i].feeCode + "' configId ='" + mn[i].configId + "' feeType = '" + mn[i].feeType + "'>";
              rows += "<img src='" + mn[i].configIcon + "'>";
              rows += "<strong>" + mn[i].configName + "</strong>";
              rows += "</li>";
            }
          }
        }
        $(".am_conFent").append(rows);
      }

      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },
  mounted: function mounted() {

    var selfs = this;
    $(".am_conFent").delegate("li", "click", function () {

      selfs.feeCode = $(this).attr("id");
      selfs.configId = $(this).attr("configId");
      selfs.feeType = $(this).attr("feeType");
      if (selfs.feeType == "02") {
        selfs.turTart();
      } else if (selfs.feeType == "05") {
        selfs.zxAjax();
      }
    });
  },

  methods: {
    turTart: function turTart() {
      //临时费用
      this.show_1 = true;
      var usInfo1 = new Object();
      usInfo1.comnCode = this.comnCode;
      usInfo1.openId = this.openid;
      var url = global.host + 'temporaryCharge/checkdecorate';
      this.$http.post(url, usInfo1).then(function (res) {

        if (res.body.success == true) {
          this.phone = res.body.result.phone;
          this.hsName = res.body.result.hsName;
          this.hsNo = res.body.result.hsNo;

          var usIn = new Object();
          usIn.comnCode = this.comnCode;
          usIn.openId = this.openid;
          usIn.feeCode = this.feeCode;
          console.log(usIn);
          var _url = global.host + 'temporaryCharge/initTemporary';
          this.$http.post(_url, usIn).then(function (res) {

            var picList = res.body.result.calType;
            if (picList == '1') {
              this.$router.push({ path: '/relatedToNumber', query: { openId: this.openid, mainPhone: this.phone, feeCode: res.body.result.feeCode, price: res.body.result.price, calType: picList, feeNum: res.body.result.feeNum, comnCode: res.body.result.comnCode, feeMoney: res.body.result.feeMoney, feeName: res.body.result.feeName, hsNo: this.hsNo, hsName: this.hsName } });
            } else if (picList == '0') {
              this.$router.push({ path: '/customAmout', query: { openId: this.openid, mainPhone: this.phone, feeCode: res.body.result.feeCode, calType: picList, feeMoney: res.body.result.feeMoney, feeName: res.body.result.feeName, comnCode: res.body.result.comnCode, feeNum: res.body.result.feeNum, hsNo: this.hsNo, hsName: this.hsName } });
            } else {
              this.shos = true;
              this.msg = '该收费项，暂未开放';
            }
            this.show_1 = false;
          }, function (err) {
            console.log(err);
          });
        }

        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },
    anHides: function anHides() {
      this.$router.push({ path: '/decorationCost', query: { feeCode: this.feeCode, hsNo: this.hsNo, hsName: this.hsName, mainPhone: this.mainPhone, configId: this.configId, openId: this.openid, comnCode: this.comnCode } });
    },
    zxAjax: function zxAjax() {
      //装修押金
      this.show_1 = true;
      var usInfo1 = new Object();
      usInfo1.comnCode = this.comnCode;
      usInfo1.openId = this.openid;
      var url = global.host + 'temporaryCharge/checkdecorate';
      this.$http.post(url, usInfo1).then(function (res) {
        var flags = res.body.result.flag;
        var picList = res.body.success;
        this.hsNo = res.body.result.hsNo;
        this.hsName = res.body.result.hsName;
        this.mainPhone = res.body.result.phone;

        if (picList == true) {
          this.$router.push({ path: '/decorationCost', query: { feeCode: this.feeCode, hsNo: this.hsNo, hsName: this.hsName, mainPhone: this.mainPhone, configId: this.configId, openId: this.openid, comnCode: this.comnCode } });
          /*if(flags == 0){
          this.shos = true;
          this.msg = res.body.result.msg;
          }else if(flags == 1){
          this.$router.push({path:'/decorationCost',query:{feeCode:this.feeCode,hsNo:this.hsNo,hsName:this.hsName,mainPhone:this.mainPhone,configId:this.configId,openId:this.openid,comnCode:this.comnCode}});
          }*/
        }

        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/temporaryCharge/feePayment.vue











/* harmony default export */ var temporaryCharge_feePayment = ({
  data: function data() {
    return defineProperty_default()({
      picList: [],
      titleList: [],
      srcs: '',
      show_1: false,
      openid: '',
      comnCode: '',
      feeCode: '',
      shos: false,
      msg: '',
      hsNo: '',
      hsName: '',
      mainPhone: '',
      phone: ''
    }, 'hsName', '');
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    XNumber: vux_src_components_x_number,
    XButton: vux_src_components_x_button,
    loadPage: src_components_loadingPage,
    Alert: components_alert["a" /* default */]

  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/feePayment") {
      document.title = "费用缴纳";
    }
    this.openid = this.$router.history.current.query.openid;
    this.comnCode = this.$router.history.current.query.comnCode;

    this.show_1 = true;
    var usInfo = new Object();
    usInfo.comnCode = this.comnCode;
    usInfo.openId = this.openid;
    var url = global.host + 'temporaryCharge/init';
    this.$http.post(url, usInfo).then(function (res) {

      var results = res.body.success;
      var picList = res.body.result;
      var rows = '';
      if (results) {
        for (var key in picList) {
          for (var key1 in picList[key]) {
            rows += "<h1>" + key1 + "</h1>";
            var mn = picList[key][key1];
            for (var i = 0; i < mn.length; i++) {
              rows += "<li class='am_flexItem mout' id='" + mn[i].feeCode + "' configId ='" + mn[i].configId + "' feeType = '" + mn[i].feeType + "'>";
              rows += "<img src='" + mn[i].configIcon + "'>";
              rows += "<strong>" + mn[i].configName + "</strong>";
              rows += "</li>";
            }
          }
        }
        $(".am_conFent").append(rows);
      }

      this.show_1 = false;
    }, function (err) {
      console.log(err);
    });
  },
  mounted: function mounted() {

    var selfs = this;
    $(".am_conFent").delegate("li", "click", function () {

      selfs.feeCode = $(this).attr("id");
      selfs.configId = $(this).attr("configId");
      selfs.feeType = $(this).attr("feeType");
      if (selfs.feeType == "02") {
        selfs.turTart();
      } else if (selfs.feeType == "05") {
        selfs.zxAjax();
      }
    });
  },

  methods: {
    turTart: function turTart() {
      //临时费用
      this.show_1 = true;
      var usInfo1 = new Object();
      usInfo1.comnCode = this.comnCode;
      usInfo1.openId = this.openid;
      var url = global.host + 'temporaryCharge/checkdecorate';
      this.$http.post(url, usInfo1).then(function (res) {

        if (res.body.success == true) {
          this.phone = res.body.result.phone;
          this.hsName = res.body.result.hsName;
          this.hsNo = res.body.result.hsNo;

          var usIn = new Object();
          usIn.comnCode = this.comnCode;
          usIn.openId = this.openid;
          usIn.feeCode = this.feeCode;
          console.log(usIn);
          var _url = global.host + 'temporaryCharge/initTemporary';
          this.$http.post(_url, usIn).then(function (res) {

            var picList = res.body.result.calType;
            if (picList == '1') {
              this.$router.push({ path: '/relatedToNumber', query: { openId: this.openid, mainPhone: this.phone, feeCode: res.body.result.feeCode, price: res.body.result.price, calType: picList, feeNum: res.body.result.feeNum, comnCode: res.body.result.comnCode, feeMoney: res.body.result.feeMoney, feeName: res.body.result.feeName, hsNo: this.hsNo, hsName: this.hsName } });
            } else if (picList == '0') {
              this.$router.push({ path: '/customAmout', query: { openId: this.openid, mainPhone: this.phone, feeCode: res.body.result.feeCode, calType: picList, feeMoney: res.body.result.feeMoney, feeName: res.body.result.feeName, comnCode: res.body.result.comnCode, feeNum: res.body.result.feeNum, hsNo: this.hsNo, hsName: this.hsName } });
            } else {
              this.shos = true;
              this.msg = '该收费项，暂未开放';
            }
            this.show_1 = false;
          }, function (err) {
            console.log(err);
          });
        }

        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },
    anHides: function anHides() {
      this.$router.push({ path: '/decorationCost', query: { feeCode: this.feeCode, hsNo: this.hsNo, hsName: this.hsName, mainPhone: this.mainPhone, configId: this.configId, openId: this.openid, comnCode: this.comnCode } });
    },
    zxAjax: function zxAjax() {
      //装修押金
      this.show_1 = true;
      var usInfo1 = new Object();
      usInfo1.comnCode = this.comnCode;
      usInfo1.openId = this.openid;
      var url = global.host + 'temporaryCharge/checkdecorate';
      this.$http.post(url, usInfo1).then(function (res) {
        var flags = res.body.result.flag;
        var picList = res.body.success;
        this.hsNo = res.body.result.hsNo;
        this.hsName = res.body.result.hsName;
        this.mainPhone = res.body.result.phone;

        if (picList == true) {
          this.$router.push({ path: '/decorationCost', query: { feeCode: this.feeCode, hsNo: this.hsNo, hsName: this.hsName, mainPhone: this.mainPhone, configId: this.configId, openId: this.openid, comnCode: this.comnCode } });
          /*if(flags == 0){
          this.shos = true;
          this.msg = res.body.result.msg;
          }else if(flags == 1){
          this.$router.push({path:'/decorationCost',query:{feeCode:this.feeCode,hsNo:this.hsNo,hsName:this.hsName,mainPhone:this.mainPhone,configId:this.configId,openId:this.openid,comnCode:this.comnCode}});
          }*/
        }

        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5793861e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/temporaryCharge/feePayment.vue
var feePayment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"zcont"}},[_c('div',{staticClass:"am_conFent fix"}),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}}),_vm._v(" "),_c('alert',{attrs:{"title":"温馨提示"},model:{value:(_vm.shos),callback:function ($$v) {_vm.shos=$$v},expression:"shos"}},[_vm._v(_vm._s(_vm.msg))])],1)}
var feePayment_staticRenderFns = []
var feePayment_esExports = { render: feePayment_render, staticRenderFns: feePayment_staticRenderFns }
/* harmony default export */ var components_temporaryCharge_feePayment = (feePayment_esExports);
// CONCATENATED MODULE: ./src/components/temporaryCharge/feePayment.vue
function feePayment_injectStyle (ssrContext) {
  __webpack_require__("0+iC")
}
var feePayment_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var feePayment___vue_template_functional__ = false
/* styles */
var feePayment___vue_styles__ = feePayment_injectStyle
/* scopeId */
var feePayment___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var feePayment___vue_module_identifier__ = null
var feePayment_Component = feePayment_normalizeComponent(
  temporaryCharge_feePayment,
  components_temporaryCharge_feePayment,
  feePayment___vue_template_functional__,
  feePayment___vue_styles__,
  feePayment___vue_scopeId__,
  feePayment___vue_module_identifier__
)

/* harmony default export */ var src_components_temporaryCharge_feePayment = (feePayment_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/temporaryCharge/customAmout.vue









/* harmony default export */ var customAmout = ({
  data: function data() {
    return {
      value1: '破坏公物罚款',
      value3: '5.0元',
      numMoney: '300.0',
      aList: [['非业主', '业主']],
      list1: ['非业主'],
      alertVal: '',
      show_1: false,
      value4: '',
      value6: '',
      value7: '',
      value8: '',
      hsNo: '',
      hsName: '',
      m1: true,
      m2: false,
      m3: false,
      billCode: ''
    };
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    XButton: vux_src_components_x_button,
    PopupPicker: popup_picker["a" /* default */],
    loadPage: src_components_loadingPage
  },
  beforeMount: function beforeMount() {
    this.value1 = this.$router.history.current.query.feeName;
    this.value3 = Number(this.$router.history.current.query.feeMoney).toFixed(2);
    this.numMoney = Number(this.$router.history.current.query.feeMoney);
    this.hsName = this.$router.history.current.query.hsName;
    this.hsNo = this.$router.history.current.query.hsNo;
    if (this.$router.history.current.path == "/customAmout") {
      document.title = this.value1;
    }
  },
  mounted: function mounted() {
    this.changVal();
  },

  methods: {
    changVal: function changVal() {
      this.value3 = Number(this.value3).toFixed(2);
      this.numMoney = this.value3.toString();
    },
    goPay: function goPay() {
      var senddata = new Object();
      senddata.comnCode = this.$router.history.current.query.comnCode;
      senddata.memberNo = this.$router.history.current.query.mainPhone;
      senddata.openid = this.$router.history.current.query.openId;
      senddata.tradeAmount = this.numMoney;
      senddata.tradeNo = this.billCode;
      senddata.tradeName = '临时收费';
      senddata.tradeDesc = '临时收费';
      var url = global.host + 'temporaryCharge/getpayurl';
      this.$http.post(url, senddata).then(function (res) {
        if (res.body.code == '110') {
          window.location.href = res.body.payurl;
        } else {
          this.prompt = '支付异常,请稍候再试';
          this.submitable = false;
          this.showprompt = true;
        }
      }, function (err) {
        console.log(err);
      });
    },
    changes: function changes() {
      console.log(this.list1[0]);
      if (this.list1[0] == "业主") {
        this.m1 = false;
        this.m2 = true;
        this.m3 = true;
      } else if (this.list1[0] == "非业主") {
        this.m1 = true;
        this.m2 = false;
        this.m3 = false;
      }
    },
    comval: function comval() {
      $("#ms1").find(".weui-label").css('color', '#000');
    },
    payFord: function payFord() {
      if (this.hsName == '') {
        this.alertVal = '必填项';
        $("#ms1").find(".weui-label").css('color', '#ff0000');
      } else {
        if (this.hsNo == null || this.hsNo == '') {
          this.hsNo = '非业主';
        }
        this.show_1 = true;
        var usIn = new Object();
        usIn.comnCode = this.$router.history.current.query.comnCode;
        usIn.feeCode = this.$router.history.current.query.feeCode;
        usIn.hsNo = this.hsNo;
        usIn.hsName = this.hsName;
        usIn.remark = this.value4;
        usIn.sumFeeMoney = this.numMoney;
        usIn.feeNum = this.$router.history.current.query.feeNum + '';
        usIn.calArea = '0';
        var url = global.host + 'temporaryCharge/collectTemporary';
        this.$http.post(url, usIn).then(function (res) {
          if (res.body.success == true) {
            this.billCode = res.body.result;
            this.goPay();
          }

          this.show_1 = false;
        }, function (err) {
          console.log(err);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/temporaryCharge/customAmout.vue









/* harmony default export */ var temporaryCharge_customAmout = ({
  data: function data() {
    return {
      value1: '破坏公物罚款',
      value3: '5.0元',
      numMoney: '300.0',
      aList: [['非业主', '业主']],
      list1: ['非业主'],
      alertVal: '',
      show_1: false,
      value4: '',
      value6: '',
      value7: '',
      value8: '',
      hsNo: '',
      hsName: '',
      m1: true,
      m2: false,
      m3: false,
      billCode: ''
    };
  },

  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    XButton: vux_src_components_x_button,
    PopupPicker: popup_picker["a" /* default */],
    loadPage: src_components_loadingPage
  },
  beforeMount: function beforeMount() {
    this.value1 = this.$router.history.current.query.feeName;
    this.value3 = Number(this.$router.history.current.query.feeMoney).toFixed(2);
    this.numMoney = Number(this.$router.history.current.query.feeMoney);
    this.hsName = this.$router.history.current.query.hsName;
    this.hsNo = this.$router.history.current.query.hsNo;
    if (this.$router.history.current.path == "/customAmout") {
      document.title = this.value1;
    }
  },
  mounted: function mounted() {
    this.changVal();
  },

  methods: {
    changVal: function changVal() {
      this.value3 = Number(this.value3).toFixed(2);
      this.numMoney = this.value3.toString();
    },
    goPay: function goPay() {
      var senddata = new Object();
      senddata.comnCode = this.$router.history.current.query.comnCode;
      senddata.memberNo = this.$router.history.current.query.mainPhone;
      senddata.openid = this.$router.history.current.query.openId;
      senddata.tradeAmount = this.numMoney;
      senddata.tradeNo = this.billCode;
      senddata.tradeName = '临时收费';
      senddata.tradeDesc = '临时收费';
      var url = global.host + 'temporaryCharge/getpayurl';
      this.$http.post(url, senddata).then(function (res) {
        if (res.body.code == '110') {
          window.location.href = res.body.payurl;
        } else {
          this.prompt = '支付异常,请稍候再试';
          this.submitable = false;
          this.showprompt = true;
        }
      }, function (err) {
        console.log(err);
      });
    },
    changes: function changes() {
      console.log(this.list1[0]);
      if (this.list1[0] == "业主") {
        this.m1 = false;
        this.m2 = true;
        this.m3 = true;
      } else if (this.list1[0] == "非业主") {
        this.m1 = true;
        this.m2 = false;
        this.m3 = false;
      }
    },
    comval: function comval() {
      $("#ms1").find(".weui-label").css('color', '#000');
    },
    payFord: function payFord() {
      if (this.hsName == '') {
        this.alertVal = '必填项';
        $("#ms1").find(".weui-label").css('color', '#ff0000');
      } else {
        if (this.hsNo == null || this.hsNo == '') {
          this.hsNo = '非业主';
        }
        this.show_1 = true;
        var usIn = new Object();
        usIn.comnCode = this.$router.history.current.query.comnCode;
        usIn.feeCode = this.$router.history.current.query.feeCode;
        usIn.hsNo = this.hsNo;
        usIn.hsName = this.hsName;
        usIn.remark = this.value4;
        usIn.sumFeeMoney = this.numMoney;
        usIn.feeNum = this.$router.history.current.query.feeNum + '';
        usIn.calArea = '0';
        var url = global.host + 'temporaryCharge/collectTemporary';
        this.$http.post(url, usIn).then(function (res) {
          if (res.body.success == true) {
            this.billCode = res.body.result;
            this.goPay();
          }

          this.show_1 = false;
        }, function (err) {
          console.log(err);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a290175","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/temporaryCharge/customAmout.vue
var customAmout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"am_conFent"},[_c('div',{staticClass:"am_box_bor"},[_c('flexbox',{attrs:{"gutter":0,"orient":"vertical"}},[_c('flexbox-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.m1),expression:"m1"}],staticClass:"am_comebor",attrs:{"id":"ms1"}},[_c('x-input',{attrs:{"title":"缴费人","text-align":"right","placeholder":_vm.alertVal},on:{"on-blur":_vm.comval},model:{value:(_vm.hsName),callback:function ($$v) {_vm.hsName=$$v},expression:"hsName"}})],1),_vm._v(" "),_c('flexbox-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.m2),expression:"m2"}],staticClass:"am_comebor"},[_c('x-input',{attrs:{"title":"房号","text-align":"right"},model:{value:(_vm.value7),callback:function ($$v) {_vm.value7=$$v},expression:"value7"}})],1),_vm._v(" "),_c('flexbox-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.m3),expression:"m3"}],staticClass:"am_comebor"},[_c('x-input',{attrs:{"title":"业主姓名","text-align":"right"},model:{value:(_vm.value8),callback:function ($$v) {_vm.value8=$$v},expression:"value8"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor"},[_c('x-input',{attrs:{"title":"收费项目","text-align":"right","disabled":""},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor ncent"},[_c('span',{staticClass:"dins"},[_vm._v("金额")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","margin-right":"15px","color":"#ff0000"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value3),expression:"value3"}],staticClass:"am_Color  dings ngBg",attrs:{"type":"text"},domProps:{"value":(_vm.value3)},on:{"change":_vm.changVal,"input":function($event){if($event.target.composing){ return; }_vm.value3=$event.target.value}}}),_vm._v("元\n          ")])]),_vm._v(" "),_c('flexbox-item',[_c('x-input',{attrs:{"title":"备注信息","text-align":"right"},model:{value:(_vm.value4),callback:function ($$v) {_vm.value4=$$v},expression:"value4"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"am_buttons"},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.payFord($event)}}},[_vm._v("立即支付("+_vm._s(_vm.numMoney)+")元")])],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var customAmout_staticRenderFns = []
var customAmout_esExports = { render: customAmout_render, staticRenderFns: customAmout_staticRenderFns }
/* harmony default export */ var components_temporaryCharge_customAmout = (customAmout_esExports);
// CONCATENATED MODULE: ./src/components/temporaryCharge/customAmout.vue
function customAmout_injectStyle (ssrContext) {
  __webpack_require__("wgqt")
}
var customAmout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var customAmout___vue_template_functional__ = false
/* styles */
var customAmout___vue_styles__ = customAmout_injectStyle
/* scopeId */
var customAmout___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var customAmout___vue_module_identifier__ = null
var customAmout_Component = customAmout_normalizeComponent(
  temporaryCharge_customAmout,
  components_temporaryCharge_customAmout,
  customAmout___vue_template_functional__,
  customAmout___vue_styles__,
  customAmout___vue_scopeId__,
  customAmout___vue_module_identifier__
)

/* harmony default export */ var src_components_temporaryCharge_customAmout = (customAmout_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/temporaryCharge/decorationCost.vue














/* harmony default export */ var decorationCost = ({
  data: function data() {
    return {
      value1: '装修垃圾清运费',
      value2: '5元/本',
      value3: '0',
      changeValue: '0',
      numMoney: '',
      value4: '拆墙费',
      value5: '50元/㎡',
      am_mbg1: false,
      show_1: false,
      value6: '',
      value7: '',
      mValue5: '90.97㎡',
      mValue6: '273.0元',
      mValue7: '装修许可证工本费',
      mValue8: '5元/本',
      mValue9: '',
      mValue10: '0',
      list: [],

      houselist: [[], [], []],
      houselistid: [],
      house: [' ', ' ', ' '],
      buildid: [],
      hsNo: '',
      hsName: '',
      messageWarn: '',
      username: '',
      houseBind: '',
      alertTitle: '',
      alertContent: '',
      showAlert: false,
      allbuild: '',
      comnCode: '',
      mTitles: '',
      bShow: false,
      mContent: '',
      yjMoney: '',
      ym1: '',
      ym2: '',
      billCode: '',
      areaNum: '',
      staCode: '',
      showTip: ''
    };
  },

  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    XNumber: vux_src_components_x_number,
    XButton: vux_src_components_x_button,
    PopupPicker: popup_picker["a" /* default */],
    loadPage: src_components_loadingPage,
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    $: jquery_default.a
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/relatedToNumber") {
      document.title = "装修费用";
    }
    this.hsName = this.$router.history.current.query.hsName;
    this.hsNos = this.$router.history.current.query.hsNo;
    if (this.hsNos == null) {
      this.showTip = '请选择房号';
    }
    this.house[2] = this.hsNos;

    if (this.hsNos == "" || this.hsNos == null) {
      this.list = [];
    } else {
      this.firstLoad(this.hsNos);
    }
  },
  mounted: function mounted() {
    this.comnCode = this.$router.history.current.query.comnCode;
  },


  watch: {
    list: function list() {
      this.sumTotalMoney();
    }
  },
  methods: {
    firstLoad: function firstLoad(hsNo) {
      this.hsNo = hsNo;
      this.showTip = '';
      this.list = [];
      if (!this.hsName.trim()) {
        this.showTip = '请输入业主姓名';
        return;
      }

      this.show_1 = true;
      var usIn = new Object();
      usIn.comnCode = this.$router.history.current.query.comnCode;
      usIn.openId = this.$router.history.current.query.openId;
      usIn.feeCode = this.$router.history.current.query.feeCode;
      usIn.hsNo = hsNo;
      usIn.hsname = this.hsName;
      usIn.mainPhone = this.$router.history.current.query.mainPhone;
      usIn.configId = this.$router.history.current.query.configId;
      var url = global.host + 'temporaryCharge/initDecorate';
      this.$http.post(url, usIn).then(function (res) {

        var msList = res.body.result;
        if (res.body.success) {
          for (var i in msList) {
            this.list.push(msList[i]);
          }
          this.sumTotalMoney();
        } else if (!res.body.success) {

          this.showTip = res.body.message;
        }
        this.staCode = res.body.statusCode;
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },
    onConfirm: function onConfirm() {
      //业主未绑定选完房号确定回填初始房号

      this.house = [];
      this.house[2] = this.hsNos;
      if (this.staCode == '120') {
        this.$router.push({ path: '/houseBind', query: { openid: this.$router.history.current.query.openId, phone: this.$router.history.current.query.mainPhone, IsDefault: 0 } });
      }
    },
    cancl: function cancl() {
      this.house = [];
      this.house[2] = this.hsNos;
      if (this.staCode == '120') {
        this.$router.push({ path: '/feePayment', query: { openid: this.$router.history.current.query.openId, comnCode: this.$router.history.current.query.comnCode } });
      }
    },
    sumTotalMoney: function sumTotalMoney() {
      //总价计算
      var this_ = this;
      setTimeout(function () {
        var sumTotalMoney = 0;
        for (var i = 0; i < this_.list.length; i++) {
          var obj = this_.list[i];

          if (obj.isChargeD == null || obj.isChargeD == "0") {
            jquery_default()(".am_sclor_" + obj.feeCode).hide();
            jquery_default()(".am_mbg_" + obj.feeCode).css("background", "none");
            sumTotalMoney += Number(jquery_default()("#" + obj.feeCode + "_feeMoney").val());
          } else {
            jquery_default()(".am_sclor_" + obj.feeCode).show();
            jquery_default()(".am_mbg_" + obj.feeCode).css("background", "#d9d9d9b0");
          }
        }
        this_.numMoney = sumTotalMoney.toFixed(2);
      }, 200);

      /*if($("#pds").html() == '1'){
      $(".am_sclor").show();
      this.am_mbg1 = true;
      }else if($("#pds").html() == '0'){
      $(".am_sclor").hide();
      this.am_mbg1 = false;
      }
      if(this.am_mbg1 == true){
      let talNums = Number(this.value3) + Number(this.mValue10);
      this.numMoney = talNums.toFixed(2);
      }else{
      let talNums = Number($("#s1").text()) + Number($("#s2").text())+ Number(this.value3) + Number(this.mValue10)
      this.numMoney = talNums.toFixed(2);
      }*/
    },
    payFord: function payFord() {
      //支付
      if (Number(this.numMoney) <= 0) {
        this.showAlert = true;
        this.alertTitle = '温馨提示';
        this.alertContent = '金额不能为零！';
        return;
      }
      var list = new Array();
      for (var i = 0; i < this.list.length; i++) {
        var obj = this.list[i];
        list[i] = new Object();

        if (obj.calType == "0") {

          if (obj.isChargeD == null || obj.isChargeD == "0") {
            list[i].feeCode = obj.feeCode;
            list[i].feeMoney = jquery_default()("#" + obj.feeCode + "_feeMoney").val();
            list[i].calType = obj.calType;
            list[i].calArea = obj.calArea;
          }
        }
        if (obj.calType == "1") {
          list[i].feeCode = obj.feeCode;
          list[i].feeMoney = jquery_default()("#" + obj.feeCode + "_feeMoney").val();
          list[i].feeNum = this.changeValue;
          list[i].calType = obj.calType;
        }
        if (obj.calType == "2") {
          list[i].feeCode = obj.feeCode;
          list[i].feeMoney = jquery_default()("#" + obj.feeCode + "_feeMoney").val();
          list[i].calArea = jquery_default()("#" + obj.feeCode + "_calArea").val();
          list[i].calType = obj.calType;
        }
      }

      var newInfo = new Object();
      newInfo.hsNo = this.hsNo;
      newInfo.hsName = this.hsName;
      newInfo.comnCode = this.comnCode;
      newInfo.remark = '';
      newInfo.sumFeeMoney = this.numMoney;
      newInfo.objectData = list;

      var Url = global.host + 'temporaryCharge/collectDecorate';
      this.$http.post(Url, newInfo).then(function (res) {
        if (res.body.success == true) {
          this.billCode = res.body.result;
          this.goPay();
        }
      }, function (err) {
        console.log(err);
      });
    },
    changeNum: function changeNum() {
      this.value3 = this.changeValue * parseInt(this.value2);
      this.sumTotalMoney();
    },
    goPay: function goPay() {
      var senddata = new Object();
      senddata.comnCode = this.comnCode;
      senddata.memberNo = this.$router.history.current.query.mainPhone;
      senddata.openid = this.$router.history.current.query.openId;
      senddata.tradeAmount = this.numMoney;
      senddata.tradeNo = this.billCode;
      senddata.tradeName = '临时收费';
      senddata.tradeDesc = '装修费用';
      var url = global.host + 'temporaryCharge/getpayurl';
      this.$http.post(url, senddata).then(function (res) {
        if (res.body.code == '110') {
          window.location.href = res.body.payurl;
        } else {
          this.prompt = '支付异常,请稍候再试';
          this.submitable = false;
          this.showprompt = true;
        }
      }, function (err) {
        console.log(err);
      });
    },
    changeMoney: function changeMoney() {
      //拆墙费输入计算
      this.mValue9 = Number(jquery_default()("#nVal").find("input").val());
      this.mValue10 = this.mValue9 * Number(jquery_default()("#mflv").find("strong").find("b").html());
      this.sumTotalMoney();
    },
    onHides: function onHides(hsNunber) {
      this.list = [];
      this.firstLoad(hsNunber);
    },

    /*房间绑定验证*/
    bindHouse: function bindHouse() {
      this.hsName = this.hsName.replace(/(^\s*)|(\s*$)/g, "");
      this.$http.get(global.host + '/users/checkUserIsExistByUtil?comnCode=' + this.comnCode + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0], this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' + this.house[2] + '&userName=' + encodeURIComponent(this.hsName)).then(function (res) {
        if (res.body.success) {
          /*改变样式 存在*/
          this.houseBind = true;
          this.bindHouseSubmit();
        } else {
          /*改变样式 不存在*/
          /*this.alertTitle ='温馨提示'
          this.alertContent = '请输入物业登记的业主姓名'
          this.showAlert = true;*/
          this.houseBind = false;
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*房间检测*/
    updateVal: function updateVal() {
      this.houseBind = false;
    },
    checkBind: function checkBind() {
      this.hsName = this.hsName.replace(/(^\s*)|(\s*$)/g, "");
      if (!this.hsNo) {
        this.showTip = '请选择房间';
      } else if (!this.hsName) {
        this.showTip = '请输入业主姓名';
      } else {
        this.firstLoad(this.hsNo);
      }
      /*this.houseBind = false;
      if(!this.house[0] && !this.house[1] && !this.house[2]){
      this.showTip = '请选择房间';
      }else if(!this.hsName){
      this.showTip = '请输入业主姓名';
      }else{
      this.hsName = this.hsName.replace(/(^\s*)|(\s*$)/g,"");
      this.$http.get(global.host + '/users/checkUserIsExistByUtil?comnCode='+ this.comnCode + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0],this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' +  this.house[2] + '&userName=' + encodeURIComponent(this.hsName),).then(function(res){
      if(res.body.success){
      /!*改变样式 存在*!/
      this.houseBind = true;
      }else{
      /!*改变样式 不存在*!/
      this.showTip = '';
      this.houseBind = false;
      }
      },function(err){
      console.log(err);
      })
      }*/
    },

    /*选择小区*/
    selectDistrict: function selectDistrict() {
      this.houselist = [];
      this.buildid = [];
      this.houselistid = [];

      /*获取小区中的楼号信息*/
      this.$http.get(global.host + 'building/getList?comnCode=' + this.comnCode).then(function (resbuild) {
        if (resbuild.body.result) {
          var arr1 = [];
          var databuild = resbuild.body.result;
          this.allbuild = resbuild.body.result;
          for (var j = 0; j < databuild.length; j++) {
            arr1.push(databuild[j].buildName + (databuild[j].unitName ? databuild[j].unitName : ''));
            if (databuild[j].unitid) {
              this.houselistid.push(databuild[j].buildid);
              this.buildid.push(databuild[j].unitid);
            } else {
              this.houselistid.push(databuild[j].buildid);
            }
          }
          this.houselist.push(arr1);
          var arr2 = [];
          for (var i = 0; i < databuild[0].height.length; i++) {
            arr2.push(databuild[0].height[i]);
          }
          this.houselist.push(arr2);
          /*获取房间的信息*/
          this.$http.get(global.host + 'house/getList?comnCode=' + this.comnCode + '&buildCode=' + this.houselistid[0] + '&fool=1F' + '&unit=' + (this.buildid[0] ? this.buildid[0] : '')).then(function (reshouse) {
            if (reshouse.body.result) {
              var datahouse = reshouse.body.result;
              var arr3 = [];
              for (var k = 0; k < datahouse.length; k++) {
                arr3.push(datahouse[k].hsNo);
              }
              this.houselist.push(arr3);
            }
          }, function (errhouse) {
            console.log(errhouse);
          });
        }
      }, function (errbuild) {
        console.log(errbuild);
      });
    },

    /*联调函数*/
    selectValue: function selectValue(value) {
      var _this = this;

      for (var i = 0; i < 3; i++) {
        if (value[i] != this.house[i]) {
          switch (i) {
            case 0:
              this.house[0] = value[0];
              this.getStoreyInfo(value[0]);
              this.$nextTick(function () {
                popup_picker["a" /* default */].props.data = _this.houselist;
              });
              return;
            case 1:
              this.house[0] = value[0];
              this.house[1] = value[1];
              this.getHouseInfo(value[0], value[1]);
              this.$nextTick(function () {
                popup_picker["a" /* default */].props.data = _this.houselist;
              });
              return;
            case 2:
              this.house[0] = value[0];
              this.house[1] = value[1];
              this.house[2] = value[2];
              return;
          }
        }
      }
    },

    /*选择楼号获取楼层高度*/
    getStoreyInfo: function getStoreyInfo(storeyname) {
      this.$http.get(global.host + 'building/getList?comnCode=' + this.comnCode).then(function (res) {
        var storeyid = this.getIndex(this.houselist[0], storeyname);
        var commid = this.comnCode;
        if (res.body.result) {
          var size = this.houselist[1].length;
          for (var j = 1; j < size; j++) {
            this.houselist[1].pop();
          }
          var size1 = this.houselist[2].length;
          for (var j = 1; j < size1; j++) {
            this.houselist[2].pop();
          }
          var databuild = res.body.result[this.getIndex(this.houselist[0], storeyname)].height;
          for (var i = 0; i < databuild.length; i++) {
            this.houselist[1].push(databuild[i]);
          }
          if (this.houselist[1].length > 1) {
            this.houselist[1].shift();
          } else {
            this.houselist[1].push(' ');
            this.houselist[1].shift();
          }
          this.$http.get(global.host + 'house/getList?comnCode=' + this.comnCode + '&buildCode=' + this.houselistid[storeyid] + '&fool=' + (this.house[1] ? this.house[1] : 1) + '&unit=' + (this.buildid[storeyid] ? this.buildid[storeyid] : '')).then(function (res) {
            if (res.body.result) {
              var data = res.body.result;
              var mis = [];
              var _size = this.houselist[2].length;
              for (var a = 1; a < _size; a++) {
                this.houselist[2].pop();
              }
              for (var k = 0; k < data.length; k++) {
                this.houselist[2].push(data[k].hsNo);
              }
              if (this.houselist[2].length > 1) {
                this.houselist[2].shift();
              }
            } else {
              this.houselist[2].push('');
              var houseNum = this.houselist[2].length - 1;
              for (var _i = 0; _i < houseNum; _i++) {
                this.houselist[2].pop();
              }
            }
          }, function (err) {
            console.log(err);
          });
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*选择楼层高度获取房间号*/
    getHouseInfo: function getHouseInfo(storeyname, floor) {
      var storeyid = this.getIndex(this.houselist[0], storeyname);
      var commid = this.comnCode;
      var houseInfo = new Array();
      this.$http.get(global.host + 'house/getList?comnCode=' + this.comnCode + '&buildCode=' + this.houselistid[storeyid] + '&fool=' + floor + '&unit=' + (this.buildid[storeyid] ? this.buildid[storeyid] : '')).then(function (res) {
        console.log(res);
        if (res.body.result) {
          var size = this.houselist[2].length;
          for (var j = 1; j < size; j++) {
            this.houselist[2].pop();
          }
          var data = res.body.result;
          for (var k = 0; k < data.length; k++) {
            this.houselist[2].push(data[k].hsNo);
          }
          this.houselist[2].shift();
        } else {
          /*清空房间信息 追加一个空的信息 防止数据为空*/
          var _size2 = this.houselist[2].length;
          for (var j = 1; j < _size2; j++) {
            this.houselist[2].pop();
          }
          this.houselist[2].push('');
          this.houselist[2].shift();
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*获取索引值*/
    getIndex: function getIndex(arr, feild) {
      for (var i = 0; i < arr.length; i++) {
        if (feild == arr[i]) {
          return i;
        } else {
          continue;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/temporaryCharge/decorationCost.vue














/* harmony default export */ var temporaryCharge_decorationCost = ({
  data: function data() {
    return {
      value1: '装修垃圾清运费',
      value2: '5元/本',
      value3: '0',
      changeValue: '0',
      numMoney: '',
      value4: '拆墙费',
      value5: '50元/㎡',
      am_mbg1: false,
      show_1: false,
      value6: '',
      value7: '',
      mValue5: '90.97㎡',
      mValue6: '273.0元',
      mValue7: '装修许可证工本费',
      mValue8: '5元/本',
      mValue9: '',
      mValue10: '0',
      list: [],

      houselist: [[], [], []],
      houselistid: [],
      house: [' ', ' ', ' '],
      buildid: [],
      hsNo: '',
      hsName: '',
      messageWarn: '',
      username: '',
      houseBind: '',
      alertTitle: '',
      alertContent: '',
      showAlert: false,
      allbuild: '',
      comnCode: '',
      mTitles: '',
      bShow: false,
      mContent: '',
      yjMoney: '',
      ym1: '',
      ym2: '',
      billCode: '',
      areaNum: '',
      staCode: '',
      showTip: ''
    };
  },

  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    XNumber: vux_src_components_x_number,
    XButton: vux_src_components_x_button,
    PopupPicker: popup_picker["a" /* default */],
    loadPage: src_components_loadingPage,
    Alert: components_alert["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm,
    $: jquery_default.a
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/relatedToNumber") {
      document.title = "装修费用";
    }
    this.hsName = this.$router.history.current.query.hsName;
    this.hsNos = this.$router.history.current.query.hsNo;
    if (this.hsNos == null) {
      this.showTip = '请选择房号';
    }
    this.house[2] = this.hsNos;

    if (this.hsNos == "" || this.hsNos == null) {
      this.list = [];
    } else {
      this.firstLoad(this.hsNos);
    }
  },
  mounted: function mounted() {
    this.comnCode = this.$router.history.current.query.comnCode;
  },


  watch: {
    list: function list() {
      this.sumTotalMoney();
    }
  },
  methods: {
    firstLoad: function firstLoad(hsNo) {
      this.hsNo = hsNo;
      this.showTip = '';
      this.list = [];
      if (!this.hsName.trim()) {
        this.showTip = '请输入业主姓名';
        return;
      }

      this.show_1 = true;
      var usIn = new Object();
      usIn.comnCode = this.$router.history.current.query.comnCode;
      usIn.openId = this.$router.history.current.query.openId;
      usIn.feeCode = this.$router.history.current.query.feeCode;
      usIn.hsNo = hsNo;
      usIn.hsname = this.hsName;
      usIn.mainPhone = this.$router.history.current.query.mainPhone;
      usIn.configId = this.$router.history.current.query.configId;
      var url = global.host + 'temporaryCharge/initDecorate';
      this.$http.post(url, usIn).then(function (res) {

        var msList = res.body.result;
        if (res.body.success) {
          for (var i in msList) {
            this.list.push(msList[i]);
          }
          this.sumTotalMoney();
        } else if (!res.body.success) {

          this.showTip = res.body.message;
        }
        this.staCode = res.body.statusCode;
        this.show_1 = false;
      }, function (err) {
        console.log(err);
      });
    },
    onConfirm: function onConfirm() {
      //业主未绑定选完房号确定回填初始房号

      this.house = [];
      this.house[2] = this.hsNos;
      if (this.staCode == '120') {
        this.$router.push({ path: '/houseBind', query: { openid: this.$router.history.current.query.openId, phone: this.$router.history.current.query.mainPhone, IsDefault: 0 } });
      }
    },
    cancl: function cancl() {
      this.house = [];
      this.house[2] = this.hsNos;
      if (this.staCode == '120') {
        this.$router.push({ path: '/feePayment', query: { openid: this.$router.history.current.query.openId, comnCode: this.$router.history.current.query.comnCode } });
      }
    },
    sumTotalMoney: function sumTotalMoney() {
      //总价计算
      var this_ = this;
      setTimeout(function () {
        var sumTotalMoney = 0;
        for (var i = 0; i < this_.list.length; i++) {
          var obj = this_.list[i];

          if (obj.isChargeD == null || obj.isChargeD == "0") {
            jquery_default()(".am_sclor_" + obj.feeCode).hide();
            jquery_default()(".am_mbg_" + obj.feeCode).css("background", "none");
            sumTotalMoney += Number(jquery_default()("#" + obj.feeCode + "_feeMoney").val());
          } else {
            jquery_default()(".am_sclor_" + obj.feeCode).show();
            jquery_default()(".am_mbg_" + obj.feeCode).css("background", "#d9d9d9b0");
          }
        }
        this_.numMoney = sumTotalMoney.toFixed(2);
      }, 200);

      /*if($("#pds").html() == '1'){
      $(".am_sclor").show();
      this.am_mbg1 = true;
      }else if($("#pds").html() == '0'){
      $(".am_sclor").hide();
      this.am_mbg1 = false;
      }
      if(this.am_mbg1 == true){
      let talNums = Number(this.value3) + Number(this.mValue10);
      this.numMoney = talNums.toFixed(2);
      }else{
      let talNums = Number($("#s1").text()) + Number($("#s2").text())+ Number(this.value3) + Number(this.mValue10)
      this.numMoney = talNums.toFixed(2);
      }*/
    },
    payFord: function payFord() {
      //支付
      if (Number(this.numMoney) <= 0) {
        this.showAlert = true;
        this.alertTitle = '温馨提示';
        this.alertContent = '金额不能为零！';
        return;
      }
      var list = new Array();
      for (var i = 0; i < this.list.length; i++) {
        var obj = this.list[i];
        list[i] = new Object();

        if (obj.calType == "0") {

          if (obj.isChargeD == null || obj.isChargeD == "0") {
            list[i].feeCode = obj.feeCode;
            list[i].feeMoney = jquery_default()("#" + obj.feeCode + "_feeMoney").val();
            list[i].calType = obj.calType;
            list[i].calArea = obj.calArea;
          }
        }
        if (obj.calType == "1") {
          list[i].feeCode = obj.feeCode;
          list[i].feeMoney = jquery_default()("#" + obj.feeCode + "_feeMoney").val();
          list[i].feeNum = this.changeValue;
          list[i].calType = obj.calType;
        }
        if (obj.calType == "2") {
          list[i].feeCode = obj.feeCode;
          list[i].feeMoney = jquery_default()("#" + obj.feeCode + "_feeMoney").val();
          list[i].calArea = jquery_default()("#" + obj.feeCode + "_calArea").val();
          list[i].calType = obj.calType;
        }
      }

      var newInfo = new Object();
      newInfo.hsNo = this.hsNo;
      newInfo.hsName = this.hsName;
      newInfo.comnCode = this.comnCode;
      newInfo.remark = '';
      newInfo.sumFeeMoney = this.numMoney;
      newInfo.objectData = list;

      var Url = global.host + 'temporaryCharge/collectDecorate';
      this.$http.post(Url, newInfo).then(function (res) {
        if (res.body.success == true) {
          this.billCode = res.body.result;
          this.goPay();
        }
      }, function (err) {
        console.log(err);
      });
    },
    changeNum: function changeNum() {
      this.value3 = this.changeValue * parseInt(this.value2);
      this.sumTotalMoney();
    },
    goPay: function goPay() {
      var senddata = new Object();
      senddata.comnCode = this.comnCode;
      senddata.memberNo = this.$router.history.current.query.mainPhone;
      senddata.openid = this.$router.history.current.query.openId;
      senddata.tradeAmount = this.numMoney;
      senddata.tradeNo = this.billCode;
      senddata.tradeName = '临时收费';
      senddata.tradeDesc = '装修费用';
      var url = global.host + 'temporaryCharge/getpayurl';
      this.$http.post(url, senddata).then(function (res) {
        if (res.body.code == '110') {
          window.location.href = res.body.payurl;
        } else {
          this.prompt = '支付异常,请稍候再试';
          this.submitable = false;
          this.showprompt = true;
        }
      }, function (err) {
        console.log(err);
      });
    },
    changeMoney: function changeMoney() {
      //拆墙费输入计算
      this.mValue9 = Number(jquery_default()("#nVal").find("input").val());
      this.mValue10 = this.mValue9 * Number(jquery_default()("#mflv").find("strong").find("b").html());
      this.sumTotalMoney();
    },
    onHides: function onHides(hsNunber) {
      this.list = [];
      this.firstLoad(hsNunber);
    },

    /*房间绑定验证*/
    bindHouse: function bindHouse() {
      this.hsName = this.hsName.replace(/(^\s*)|(\s*$)/g, "");
      this.$http.get(global.host + '/users/checkUserIsExistByUtil?comnCode=' + this.comnCode + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0], this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' + this.house[2] + '&userName=' + encodeURIComponent(this.hsName)).then(function (res) {
        if (res.body.success) {
          /*改变样式 存在*/
          this.houseBind = true;
          this.bindHouseSubmit();
        } else {
          /*改变样式 不存在*/
          /*this.alertTitle ='温馨提示'
          this.alertContent = '请输入物业登记的业主姓名'
          this.showAlert = true;*/
          this.houseBind = false;
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*房间检测*/
    updateVal: function updateVal() {
      this.houseBind = false;
    },
    checkBind: function checkBind() {
      this.hsName = this.hsName.replace(/(^\s*)|(\s*$)/g, "");
      if (!this.hsNo) {
        this.showTip = '请选择房间';
      } else if (!this.hsName) {
        this.showTip = '请输入业主姓名';
      } else {
        this.firstLoad(this.hsNo);
      }
      /*this.houseBind = false;
      if(!this.house[0] && !this.house[1] && !this.house[2]){
      this.showTip = '请选择房间';
      }else if(!this.hsName){
      this.showTip = '请输入业主姓名';
      }else{
      this.hsName = this.hsName.replace(/(^\s*)|(\s*$)/g,"");
      this.$http.get(global.host + '/users/checkUserIsExistByUtil?comnCode='+ this.comnCode + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0],this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' +  this.house[2] + '&userName=' + encodeURIComponent(this.hsName),).then(function(res){
      if(res.body.success){
      /!*改变样式 存在*!/
      this.houseBind = true;
      }else{
      /!*改变样式 不存在*!/
      this.showTip = '';
      this.houseBind = false;
      }
      },function(err){
      console.log(err);
      })
      }*/
    },

    /*选择小区*/
    selectDistrict: function selectDistrict() {
      this.houselist = [];
      this.buildid = [];
      this.houselistid = [];

      /*获取小区中的楼号信息*/
      this.$http.get(global.host + 'building/getList?comnCode=' + this.comnCode).then(function (resbuild) {
        if (resbuild.body.result) {
          var arr1 = [];
          var databuild = resbuild.body.result;
          this.allbuild = resbuild.body.result;
          for (var j = 0; j < databuild.length; j++) {
            arr1.push(databuild[j].buildName + (databuild[j].unitName ? databuild[j].unitName : ''));
            if (databuild[j].unitid) {
              this.houselistid.push(databuild[j].buildid);
              this.buildid.push(databuild[j].unitid);
            } else {
              this.houselistid.push(databuild[j].buildid);
            }
          }
          this.houselist.push(arr1);
          var arr2 = [];
          for (var i = 0; i < databuild[0].height.length; i++) {
            arr2.push(databuild[0].height[i]);
          }
          this.houselist.push(arr2);
          /*获取房间的信息*/
          this.$http.get(global.host + 'house/getList?comnCode=' + this.comnCode + '&buildCode=' + this.houselistid[0] + '&fool=1F' + '&unit=' + (this.buildid[0] ? this.buildid[0] : '')).then(function (reshouse) {
            if (reshouse.body.result) {
              var datahouse = reshouse.body.result;
              var arr3 = [];
              for (var k = 0; k < datahouse.length; k++) {
                arr3.push(datahouse[k].hsNo);
              }
              this.houselist.push(arr3);
            }
          }, function (errhouse) {
            console.log(errhouse);
          });
        }
      }, function (errbuild) {
        console.log(errbuild);
      });
    },

    /*联调函数*/
    selectValue: function selectValue(value) {
      var _this = this;

      for (var i = 0; i < 3; i++) {
        if (value[i] != this.house[i]) {
          switch (i) {
            case 0:
              this.house[0] = value[0];
              this.getStoreyInfo(value[0]);
              this.$nextTick(function () {
                popup_picker["a" /* default */].props.data = _this.houselist;
              });
              return;
            case 1:
              this.house[0] = value[0];
              this.house[1] = value[1];
              this.getHouseInfo(value[0], value[1]);
              this.$nextTick(function () {
                popup_picker["a" /* default */].props.data = _this.houselist;
              });
              return;
            case 2:
              this.house[0] = value[0];
              this.house[1] = value[1];
              this.house[2] = value[2];
              return;
          }
        }
      }
    },

    /*选择楼号获取楼层高度*/
    getStoreyInfo: function getStoreyInfo(storeyname) {
      this.$http.get(global.host + 'building/getList?comnCode=' + this.comnCode).then(function (res) {
        var storeyid = this.getIndex(this.houselist[0], storeyname);
        var commid = this.comnCode;
        if (res.body.result) {
          var size = this.houselist[1].length;
          for (var j = 1; j < size; j++) {
            this.houselist[1].pop();
          }
          var size1 = this.houselist[2].length;
          for (var j = 1; j < size1; j++) {
            this.houselist[2].pop();
          }
          var databuild = res.body.result[this.getIndex(this.houselist[0], storeyname)].height;
          for (var i = 0; i < databuild.length; i++) {
            this.houselist[1].push(databuild[i]);
          }
          if (this.houselist[1].length > 1) {
            this.houselist[1].shift();
          } else {
            this.houselist[1].push(' ');
            this.houselist[1].shift();
          }
          this.$http.get(global.host + 'house/getList?comnCode=' + this.comnCode + '&buildCode=' + this.houselistid[storeyid] + '&fool=' + (this.house[1] ? this.house[1] : 1) + '&unit=' + (this.buildid[storeyid] ? this.buildid[storeyid] : '')).then(function (res) {
            if (res.body.result) {
              var data = res.body.result;
              var mis = [];
              var _size = this.houselist[2].length;
              for (var a = 1; a < _size; a++) {
                this.houselist[2].pop();
              }
              for (var k = 0; k < data.length; k++) {
                this.houselist[2].push(data[k].hsNo);
              }
              if (this.houselist[2].length > 1) {
                this.houselist[2].shift();
              }
            } else {
              this.houselist[2].push('');
              var houseNum = this.houselist[2].length - 1;
              for (var _i = 0; _i < houseNum; _i++) {
                this.houselist[2].pop();
              }
            }
          }, function (err) {
            console.log(err);
          });
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*选择楼层高度获取房间号*/
    getHouseInfo: function getHouseInfo(storeyname, floor) {
      var storeyid = this.getIndex(this.houselist[0], storeyname);
      var commid = this.comnCode;
      var houseInfo = new Array();
      this.$http.get(global.host + 'house/getList?comnCode=' + this.comnCode + '&buildCode=' + this.houselistid[storeyid] + '&fool=' + floor + '&unit=' + (this.buildid[storeyid] ? this.buildid[storeyid] : '')).then(function (res) {
        console.log(res);
        if (res.body.result) {
          var size = this.houselist[2].length;
          for (var j = 1; j < size; j++) {
            this.houselist[2].pop();
          }
          var data = res.body.result;
          for (var k = 0; k < data.length; k++) {
            this.houselist[2].push(data[k].hsNo);
          }
          this.houselist[2].shift();
        } else {
          /*清空房间信息 追加一个空的信息 防止数据为空*/
          var _size2 = this.houselist[2].length;
          for (var j = 1; j < _size2; j++) {
            this.houselist[2].pop();
          }
          this.houselist[2].push('');
          this.houselist[2].shift();
        }
      }, function (err) {
        console.log(err);
      });
    },

    /*获取索引值*/
    getIndex: function getIndex(arr, feild) {
      for (var i = 0; i < arr.length; i++) {
        if (feild == arr[i]) {
          return i;
        } else {
          continue;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-783fe415","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/temporaryCharge/decorationCost.vue
var decorationCost_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"am_conFent"},[_c('div',{staticClass:"am_box_bor am_mrbotm"},[_c('flexbox',{attrs:{"gutter":0,"orient":"vertical"}},[_c('flexbox-item',{staticClass:"am_comebor"},[_c('popup-picker',{attrs:{"title":"<span style='color:red'> * </span>房号","data":_vm.houselist},on:{"on-shadow-change":_vm.selectValue,"on-show":_vm.selectDistrict,"on-hide":function($event){_vm.onHides(_vm.house[2])}},model:{value:(_vm.house),callback:function ($$v) {_vm.house=$$v},expression:"house"}})],1),_vm._v(" "),_c('flexbox-item',[_c('x-input',{attrs:{"title":"<span style='color:red'> * </span>业主姓名","placeholder":"请输入业主姓名(验证)","text-align":"right"},on:{"on-blur":_vm.checkBind,"on-focus":_vm.updateVal},model:{value:(_vm.hsName),callback:function ($$v) {_vm.hsName=$$v},expression:"hsName"}})],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","font-size":"18px","color":"red"}},[_vm._v(_vm._s(_vm.showTip))]),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (item.calType == 0)?_c('div',{key:index,staticClass:"am_box_bor am_mrbotm"},[(item.isAgent =='Y')?_c('div',{staticStyle:{"position":"relative"}},[_c('flexbox',{class:'am_mbg_'+item.feeCode,attrs:{"gutter":0,"orient":"vertical"}},[_c('flexbox-item',{staticClass:"am_comebor"},[_c('x-input',{attrs:{"title":"收费项目","text-align":"right","disabled":""},model:{value:(item.feeName),callback:function ($$v) {_vm.$set(item, "feeName", $$v)},expression:"item.feeName"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor"},[(item.feeName == '装修押金')?_c('div',{staticStyle:{"width":"100%"}},[_c('x-input',{attrs:{"title":"费率","text-align":"right","disabled":""},model:{value:(item.price+'元'),callback:function ($$v) {_vm.$set(item, "price+'元'", $$v)},expression:"item.price+'元'"}})],1):_c('div',{staticStyle:{"width":"100%"}},[_c('x-input',{attrs:{"title":"费率","text-align":"right","disabled":""},model:{value:(item.price+'元/㎡'),callback:function ($$v) {_vm.$set(item, "price+'元/㎡'", $$v)},expression:"item.price+'元/㎡'"}})],1)]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor"},[_c('x-input',{attrs:{"title":"计费面积(㎡)","text-align":"right","readonly":""},model:{value:(item.calArea),callback:function ($$v) {_vm.$set(item, "calArea", $$v)},expression:"item.calArea"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"ncent"},[_c('span',{staticClass:"dins"},[_vm._v("金额")]),_vm._v(" "),_c('input',{ref:"phoneNums",refInFor:true,staticClass:"am_Color dings ngBg",attrs:{"readonly":"","id":item.feeCode+'_feeMoney'},domProps:{"value":item.feeMoney}}),_vm._v(" "),_c('b',{staticStyle:{"display":"none"},attrs:{"id":"s1"}},[_vm._v(_vm._s(item.feeMoney))])])],1),_vm._v(" "),_c('div',{class:'am_sclor_'+item.feeCode+' am_sclor'},[_vm._v("已缴纳")])],1):(item.isAgent =='N')?_c('div',[_c('flexbox',{class:'am_mbg_'+item.feeCode,attrs:{"gutter":0,"orient":"vertical"}},[_c('flexbox-item',{staticClass:"am_comebor"},[_c('x-input',{attrs:{"title":"收费项目","text-align":"right","disabled":""},model:{value:(item.feeName),callback:function ($$v) {_vm.$set(item, "feeName", $$v)},expression:"item.feeName"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor"},[(item.feeName == '装修押金')?_c('div',{staticStyle:{"width":"100%"}},[_c('x-input',{attrs:{"title":"费率","text-align":"right","disabled":""},model:{value:(item.price+'元'),callback:function ($$v) {_vm.$set(item, "price+'元'", $$v)},expression:"item.price+'元'"}})],1):_c('div',{staticStyle:{"width":"100%"}},[_c('x-input',{attrs:{"title":"费率","text-align":"right","disabled":""},model:{value:(item.price+'元/㎡'),callback:function ($$v) {_vm.$set(item, "price+'元/㎡'", $$v)},expression:"item.price+'元/㎡'"}})],1)]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor"},[_c('x-input',{attrs:{"title":"计费面积(㎡)","text-align":"right","readonly":""},model:{value:(item.calArea),callback:function ($$v) {_vm.$set(item, "calArea", $$v)},expression:"item.calArea"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"ncent"},[_c('span',{staticClass:"dins"},[_vm._v("金额")]),_vm._v(" "),_c('input',{staticClass:"am_Color dings ngBg",attrs:{"id":item.feeCode+'_feeMoney',"readonly":""},domProps:{"value":item.feeMoney}}),_vm._v(" "),_c('b',{staticStyle:{"display":"none"},attrs:{"id":"s2"}},[_vm._v(_vm._s(item.feeMoney))])])],1),_vm._v(" "),_c('div',{class:'am_sclor_'+item.feeCode+' am_sclor'},[_vm._v("已缴纳")])],1):_vm._e()]):_vm._e()}),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (item.calType == 1)?_c('div',{key:index,staticClass:"am_box_bor am_mrbotm"},[_c('flexbox',{attrs:{"gutter":0,"orient":"vertical"}},[_c('flexbox-item',{staticClass:"am_comebor"},[_c('x-input',{attrs:{"title":"收费项目","text-align":"right","disabled":""},model:{value:(item.feeName),callback:function ($$v) {_vm.$set(item, "feeName", $$v)},expression:"item.feeName"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor"},[_c('x-input',{attrs:{"title":"费率","text-align":"right","disabled":""},model:{value:(item.price+'元/本'),callback:function ($$v) {_vm.$set(item, "price+'元/本'", $$v)},expression:"item.price+'元/本'"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor"},[_c('x-number',{staticClass:"am_Nums",attrs:{"title":"数量","id":item.feeCode+'_feeNum',"width":"40px","button-style":"round","min":0},on:{"on-change":_vm.changeNum},model:{value:(_vm.changeValue),callback:function ($$v) {_vm.changeValue=$$v},expression:"changeValue"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"ncent"},[_c('span',{staticClass:"dins"},[_vm._v("金额")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","margin-right":"15px"}},[_c('input',{staticClass:"am_Color dings ngBg",staticStyle:{"margin-right":"0px"},attrs:{"id":item.feeCode+'_feeMoney',"readonly":""},domProps:{"value":_vm.value3}}),_vm._v("元\n          ")])])],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (item.calType == 2)?_c('div',{key:index,staticClass:"am_box_bor am_mrbotm"},[_c('flexbox',{attrs:{"gutter":0,"orient":"vertical"}},[_c('flexbox-item',{staticClass:"am_comebor"},[_c('x-input',{attrs:{"title":"收费项目","text-align":"right","disabled":""},model:{value:(item.feeName),callback:function ($$v) {_vm.$set(item, "feeName", $$v)},expression:"item.feeName"}})],1),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor ncent",attrs:{"id":"mflv"}},[_c('b',{staticStyle:{"float":"left","margin-left":"15px"}},[_vm._v("费率")]),_vm._v(" "),_c('strong',{staticStyle:{"float":"right","margin-right":"15px","color":"#888"}},[_c('b',[_vm._v(_vm._s(item.price))]),_vm._v("元/㎡")])]),_vm._v(" "),_c('flexbox-item',{staticClass:"am_comebor  ncent"},[_c('span',{staticStyle:{"float":"left","margin-left":"15px"}},[_vm._v("计费面积(㎡)")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","display":"flex"},attrs:{"id":"nVal"}},[_c('input',{staticStyle:{"text-align":"right","font-size":"16px","display":"block !important"},attrs:{"type":"text","id":item.feeCode+'_calArea',"placeholder":"请输入面积"},domProps:{"value":_vm.mValue9},on:{"keyup":function($event){_vm.changeMoney()}}}),_vm._v(" "),_c('strong',{staticStyle:{"margin-right":"15px","color":"#888"}})])]),_vm._v(" "),_c('flexbox-item',{staticClass:"ncent"},[_c('span',{staticClass:"dins"},[_vm._v("金额")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","margin-right":"15px"}},[_c('input',{staticClass:"am_Color dings ngBg",staticStyle:{"margin-right":"0px"},attrs:{"id":item.feeCode+'_feeMoney',"readonly":""},domProps:{"value":_vm.mValue10}})])])],1)],1):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"am_buttons"},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.payFord($event)}}},[_vm._v("立即支付("+_vm._s(_vm.numMoney)+")元")])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('alert',{attrs:{"title":_vm.alertTitle,"content":_vm.alertContent},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}})],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{attrs:{"title":_vm.mTitles,"confirm-text":"确定"},on:{"on-cancel":_vm.cancl},model:{value:(_vm.bShow),callback:function ($$v) {_vm.bShow=$$v},expression:"bShow"}},[_c('p',[_vm._v(_vm._s(_vm.mContent))])])],1),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var decorationCost_staticRenderFns = []
var decorationCost_esExports = { render: decorationCost_render, staticRenderFns: decorationCost_staticRenderFns }
/* harmony default export */ var components_temporaryCharge_decorationCost = (decorationCost_esExports);
// CONCATENATED MODULE: ./src/components/temporaryCharge/decorationCost.vue
function decorationCost_injectStyle (ssrContext) {
  __webpack_require__("SAay")
}
var decorationCost_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var decorationCost___vue_template_functional__ = false
/* styles */
var decorationCost___vue_styles__ = decorationCost_injectStyle
/* scopeId */
var decorationCost___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var decorationCost___vue_module_identifier__ = null
var decorationCost_Component = decorationCost_normalizeComponent(
  temporaryCharge_decorationCost,
  components_temporaryCharge_decorationCost,
  decorationCost___vue_template_functional__,
  decorationCost___vue_styles__,
  decorationCost___vue_scopeId__,
  decorationCost___vue_module_identifier__
)

/* harmony default export */ var src_components_temporaryCharge_decorationCost = (decorationCost_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/temporaryCharge/temporaryPay.vue


//
//
//
//
//
//
//



/* harmony default export */ var temporaryPay = ({
  data: function data() {
    return {
      show_1: false,
      code: '',
      state: '',
      messageWarn: '',
      temp: ''
    };
  },

  components: {
    loadPage: src_components_loadingPage

  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/temporaryPay") {
      document.title = "费用缴纳";
    }
  },

  mounted: function mounted() {
    this.code = this.$router.history.current.query.code;
    this.state = this.$router.history.current.query.state;
    var url = '';
    if (this.state == 0) {
      url = global.host + 'users/getuserid?code=' + this.code;
    } else {
      url = global.host + 'users/getuser?code=' + this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
    }
    if (url) {
      this.$http.get(url).then(function (res) {
        if (res.body.success) {
          this.$router.replace({ path: '/feePayment', query: { comnCode: this.state, openid: res.body.result.openId, phone: res.body.result.mainPhone } });
        } else {
          this.$router.replace({ path: '/register', query: { openid: res.body.statusCode, nickname: JSON.parse(res.body.message).nickname, headerimgurl: JSON.parse(res.body.message).headimgurl } });
        }
      }, function (err) {
        console.log(err);;
      });
    }
  },
  methods: {
    iterator: function iterator(obj) {
      var str = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(obj), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var prop = _step.value;

          if (typeof_default()(obj[prop]) === 'object') {
            continue;
          } else if (typeof obj[prop] === 'function') {
            continue;
          } else {
            str = str + prop + ':' + obj[prop];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return str;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/temporaryCharge/temporaryPay.vue


//
//
//
//
//
//
//



/* harmony default export */ var temporaryCharge_temporaryPay = ({
  data: function data() {
    return {
      show_1: false,
      code: '',
      state: '',
      messageWarn: '',
      temp: ''
    };
  },

  components: {
    loadPage: src_components_loadingPage

  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/temporaryPay") {
      document.title = "费用缴纳";
    }
  },

  mounted: function mounted() {
    this.code = this.$router.history.current.query.code;
    this.state = this.$router.history.current.query.state;
    var url = '';
    if (this.state == 0) {
      url = global.host + 'users/getuserid?code=' + this.code;
    } else {
      url = global.host + 'users/getuser?code=' + this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
    }
    if (url) {
      this.$http.get(url).then(function (res) {
        if (res.body.success) {
          this.$router.replace({ path: '/feePayment', query: { comnCode: this.state, openid: res.body.result.openId, phone: res.body.result.mainPhone } });
        } else {
          this.$router.replace({ path: '/register', query: { openid: res.body.statusCode, nickname: JSON.parse(res.body.message).nickname, headerimgurl: JSON.parse(res.body.message).headimgurl } });
        }
      }, function (err) {
        console.log(err);;
      });
    }
  },
  methods: {
    iterator: function iterator(obj) {
      var str = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(obj), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var prop = _step.value;

          if (typeof_default()(obj[prop]) === 'object') {
            continue;
          } else if (typeof obj[prop] === 'function') {
            continue;
          } else {
            str = str + prop + ':' + obj[prop];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return str;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3223413a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/temporaryCharge/temporaryPay.vue
var temporaryPay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.messageWarn))]),_vm._v(" "),_c('load-page',{attrs:{"shows":_vm.show_1}})],1)}
var temporaryPay_staticRenderFns = []
var temporaryPay_esExports = { render: temporaryPay_render, staticRenderFns: temporaryPay_staticRenderFns }
/* harmony default export */ var components_temporaryCharge_temporaryPay = (temporaryPay_esExports);
// CONCATENATED MODULE: ./src/components/temporaryCharge/temporaryPay.vue
function temporaryPay_injectStyle (ssrContext) {
  __webpack_require__("oxMG")
}
var temporaryPay_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var temporaryPay___vue_template_functional__ = false
/* styles */
var temporaryPay___vue_styles__ = temporaryPay_injectStyle
/* scopeId */
var temporaryPay___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var temporaryPay___vue_module_identifier__ = null
var temporaryPay_Component = temporaryPay_normalizeComponent(
  temporaryCharge_temporaryPay,
  components_temporaryCharge_temporaryPay,
  temporaryPay___vue_template_functional__,
  temporaryPay___vue_styles__,
  temporaryPay___vue_scopeId__,
  temporaryPay___vue_module_identifier__
)

/* harmony default export */ var src_components_temporaryCharge_temporaryPay = (temporaryPay_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/map.js
var map = __webpack_require__("ifoU");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/momentsComponents/list.vue



var _beforeMount$methods$;












/* harmony default export */ var momentsComponents_list = (_beforeMount$methods$ = {
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/momentslist") {
      document.title = "邻里分享";
    }
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
  },

  methods: {
    reduce: function reduce() {
      var img = document.getElementById('bigpic');
      if (this.current > 0) {
        this.current--;
      } else {
        this.current = 0;
      }
      this.imgsrc = this.list[this.index].imgs[this.current].maxPicUrl;
      var self = this;
      img.onload = function () {
        self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        $(this).animate({ 'opacity': +1 }, 1, 'swing');
      };
    },
    add: function add() {
      if (this.current < this.list[this.index].imgs.length - 1) {
        this.current++;
      } else {
        this.current = this.list[this.index].imgs.length - 1;
      }
      var img = document.getElementById('bigpic');
      this.imgsrc = this.list[this.index].imgs[this.current].maxPicUrl;
      var self = this;
      img.onload = function () {
        self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        $(this).animate({ 'opacity': +1 }, 1, 'swing');
      };
    },
    viewBigPic: function viewBigPic(index, current) {

      this.preview = true;
      this.current = current;
      this.index = index;
      var img = document.getElementById('bigpic');
      var self = this;
      img.onload = function () {
        self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        $(this).animate({ 'opacity': +1 }, 2, 'swing');
      };
      img.onerror = function () {
        self.imgsrc = '../static/image/img_error.jpg';
      };
      this.imgsrc = this.list[this.index].imgs[this.current].maxPicUrl;
    },
    hideBigPic: function hideBigPic() {
      this.preview = false;
    },
    like: function like(index) {
      this.list[index].praisePoint += 1;
      this.$http.get(global.host + 'themeShare/like?themeId=' + this.list[index].themeId, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {
        console.log(res);
      }, function (err) {
        console.log(err);
      });
    },
    jumpto: function jumpto() {
      this.$router.push({ path: '/momentspublush', query: { communityId: this.$router.history.current.query.communityId, openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, comnCode: this.$router.history.current.query.comnCode } });
    },
    changeRange: function changeRange(index) {
      this.index = index;
      this.page = 1;
      this.clearArray(this.list);
      this.getData(this.page);
    },
    clearArray: function clearArray(arr) {
      var size = arr.length;
      for (var i = 0; i < size; i++) {
        arr.pop();
      }
    },
    getData: function getData(page) {
      var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

      var data = {};
      this.loading = true;
      if (this.index == 0) {
        data = { 'comnCode': this.$router.history.current.query.communityId, page: page, rows: rows };
      } else {
        data = { page: page, rows: rows };
      }
      var imgLoadMap = this.imgWrap;
      this.$http.post(global.host + 'themeShare/findThemelist', data, { header: { Accept: "application/json; charset=utf-8" } }).then(function (res) {
        if (res.body.result) {
          var _data = res.body.result;
          for (var i = 0; i < _data.length; i++) {
            _data[i].praisePoint = isNaN(parseInt(_data[i].praisePoint)) ? 0 : parseInt(_data[i].praisePoint);
            _data[i].msgCount = isNaN(parseInt(_data[i].msgCount)) ? 0 : parseInt(_data[i].msgCount);
            if (_data[i].imgs.length > 0) {
              for (var j = 0; j < _data[i].imgs.length; j++) {
                _data[i].imgs[j].maxPicUrl = global.baseImg + _data[i].imgs[j].maxPicUrl;
                _data[i].imgs[j].minPicUrl = global.baseImg + _data[i].imgs[j].minPicUrl;
                var imgObj = new Image();
                imgObj.src = _data[i].imgs[j].maxPicUrl;
                imgLoadMap.set(imgObj.src, imgObj);
              }
            }
            this.list.push(_data[i]);
          }
        }
        this.loading = false;
      }, function (err) {
        console.log(err);
      });
    }
  }
}, defineProperty_default()(_beforeMount$methods$, 'beforeMount', function beforeMount() {
  this.getData(this.page);
}), defineProperty_default()(_beforeMount$methods$, 'created', function created() {
  var self = this;
  window.onscroll = function () {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    if (scrollTop + windowHeight == scrollHeight) {
      if (!self.loading) {
        self.page += 1;
        self.getData(self.page);
      }
    }
  };
}), defineProperty_default()(_beforeMount$methods$, 'data', function data() {
  return {
    titles: ['本小区', '全部'],
    list: [],
    imgWrap: new map_default.a(),
    index: 0,
    loading: false,
    page: 1,
    phone: this.$router.history.current.query.phone,
    preview: false,
    imgsrc: '',
    current: 0,
    top: 0
  };
}), defineProperty_default()(_beforeMount$methods$, 'components', { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, XHeader: vux_src_components_x_header, XImg: vux_src_components_x_img, Flexbox: flexbox["a" /* default */], FlexboxItem: flexbox_item["a" /* default */], Loading: vux_src_components_loading, LoadMore: vux_src_components_load_more }), defineProperty_default()(_beforeMount$methods$, 'directives', { TransferDom: transfer_dom["a" /* default */] }), _beforeMount$methods$);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/momentsComponents/list.vue



var list__beforeMount$methods$;












/* harmony default export */ var components_momentsComponents_list = (list__beforeMount$methods$ = {
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/momentslist") {
      document.title = "邻里分享";
    }
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
  },

  methods: {
    reduce: function reduce() {
      var img = document.getElementById('bigpic');
      if (this.current > 0) {
        this.current--;
      } else {
        this.current = 0;
      }
      this.imgsrc = this.list[this.index].imgs[this.current].maxPicUrl;
      var self = this;
      img.onload = function () {
        self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        $(this).animate({ 'opacity': +1 }, 1, 'swing');
      };
    },
    add: function add() {
      if (this.current < this.list[this.index].imgs.length - 1) {
        this.current++;
      } else {
        this.current = this.list[this.index].imgs.length - 1;
      }
      var img = document.getElementById('bigpic');
      this.imgsrc = this.list[this.index].imgs[this.current].maxPicUrl;
      var self = this;
      img.onload = function () {
        self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        $(this).animate({ 'opacity': +1 }, 1, 'swing');
      };
    },
    viewBigPic: function viewBigPic(index, current) {

      this.preview = true;
      this.current = current;
      this.index = index;
      var img = document.getElementById('bigpic');
      var self = this;
      img.onload = function () {
        self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        $(this).animate({ 'opacity': +1 }, 2, 'swing');
      };
      img.onerror = function () {
        self.imgsrc = '../static/image/img_error.jpg';
      };
      this.imgsrc = this.list[this.index].imgs[this.current].maxPicUrl;
    },
    hideBigPic: function hideBigPic() {
      this.preview = false;
    },
    like: function like(index) {
      this.list[index].praisePoint += 1;
      this.$http.get(global.host + 'themeShare/like?themeId=' + this.list[index].themeId, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {
        console.log(res);
      }, function (err) {
        console.log(err);
      });
    },
    jumpto: function jumpto() {
      this.$router.push({ path: '/momentspublush', query: { communityId: this.$router.history.current.query.communityId, openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, comnCode: this.$router.history.current.query.comnCode } });
    },
    changeRange: function changeRange(index) {
      this.index = index;
      this.page = 1;
      this.clearArray(this.list);
      this.getData(this.page);
    },
    clearArray: function clearArray(arr) {
      var size = arr.length;
      for (var i = 0; i < size; i++) {
        arr.pop();
      }
    },
    getData: function getData(page) {
      var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

      var data = {};
      this.loading = true;
      if (this.index == 0) {
        data = { 'comnCode': this.$router.history.current.query.communityId, page: page, rows: rows };
      } else {
        data = { page: page, rows: rows };
      }
      var imgLoadMap = this.imgWrap;
      this.$http.post(global.host + 'themeShare/findThemelist', data, { header: { Accept: "application/json; charset=utf-8" } }).then(function (res) {
        if (res.body.result) {
          var _data = res.body.result;
          for (var i = 0; i < _data.length; i++) {
            _data[i].praisePoint = isNaN(parseInt(_data[i].praisePoint)) ? 0 : parseInt(_data[i].praisePoint);
            _data[i].msgCount = isNaN(parseInt(_data[i].msgCount)) ? 0 : parseInt(_data[i].msgCount);
            if (_data[i].imgs.length > 0) {
              for (var j = 0; j < _data[i].imgs.length; j++) {
                _data[i].imgs[j].maxPicUrl = global.baseImg + _data[i].imgs[j].maxPicUrl;
                _data[i].imgs[j].minPicUrl = global.baseImg + _data[i].imgs[j].minPicUrl;
                var imgObj = new Image();
                imgObj.src = _data[i].imgs[j].maxPicUrl;
                imgLoadMap.set(imgObj.src, imgObj);
              }
            }
            this.list.push(_data[i]);
          }
        }
        this.loading = false;
      }, function (err) {
        console.log(err);
      });
    }
  }
}, defineProperty_default()(list__beforeMount$methods$, 'beforeMount', function beforeMount() {
  this.getData(this.page);
}), defineProperty_default()(list__beforeMount$methods$, 'created', function created() {
  var self = this;
  window.onscroll = function () {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    if (scrollTop + windowHeight == scrollHeight) {
      if (!self.loading) {
        self.page += 1;
        self.getData(self.page);
      }
    }
  };
}), defineProperty_default()(list__beforeMount$methods$, 'data', function data() {
  return {
    titles: ['本小区', '全部'],
    list: [],
    imgWrap: new map_default.a(),
    index: 0,
    loading: false,
    page: 1,
    phone: this.$router.history.current.query.phone,
    preview: false,
    imgsrc: '',
    current: 0,
    top: 0
  };
}), defineProperty_default()(list__beforeMount$methods$, 'components', { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, XHeader: vux_src_components_x_header, XImg: vux_src_components_x_img, Flexbox: flexbox["a" /* default */], FlexboxItem: flexbox_item["a" /* default */], Loading: vux_src_components_loading, LoadMore: vux_src_components_load_more }), defineProperty_default()(list__beforeMount$methods$, 'directives', { TransferDom: transfer_dom["a" /* default */] }), list__beforeMount$methods$);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e23ad5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/momentsComponents/list.vue
var list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"momentslist"}},[_c('tab',{staticClass:"mtop",attrs:{"line-width":3}},_vm._l((_vm.titles),function(item,index){return _c('tab-item',{key:index,attrs:{"selected":index===0},on:{"on-item-click":function($event){_vm.changeRange(index)}}},[_vm._v(_vm._s(item))])})),_vm._v(" "),_vm._l((_vm.list),function(data,index){return _c('div',{key:index,staticClass:"content"},[_c('router-link',{attrs:{"to":{path:'/momentsdetail',query:{themeId:data.themeId,phone:_vm.phone}}}},[_c('div',{staticClass:"header",staticStyle:{"display":"flex"}},[_c('img',{staticClass:"gc-img-icon-user",attrs:{"src":data.memberIcon}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"gc-new-title"},[_vm._v(_vm._s(data.memberName))]),_vm._v(" "),_c('div',{staticClass:"gc-new-title-bottom"},[_vm._v(_vm._s(data.comnName))])])]),_vm._v(" "),_c('p',{staticClass:"context",staticStyle:{"padding-left":"2.9rem"}},[_c('span',{staticStyle:{"padding-top":"1rem"}},[_vm._v(_vm._s(data.themeDesc))])])]),_vm._v(" "),(data.imgs.length > 0)?_c('flexbox',{staticStyle:{"padding-left":"3rem"},attrs:{"gutter":0}},[_vm._l((data.imgs),function(picdata,current){return _c('flexbox-item',{key:current,staticClass:"picture",nativeOn:{"click":function($event){_vm.viewBigPic(index,current)}}},[_c('img',{attrs:{"src":picdata.minPicUrl,"onerror":"this.src='../static/image/img_error.jpg'","alt":picdata.pictureId}})])}),_vm._v(" "),(data.imgs.length == 3)?_c('flexbox-item'):_vm._e(),_vm._v(" "),(data.imgs.length == 2)?_c('flexbox-item'):_vm._e(),_vm._v(" "),(data.imgs.length == 2)?_c('flexbox-item'):_vm._e(),_vm._v(" "),(data.imgs.length == 1)?_c('flexbox-item'):_vm._e(),_vm._v(" "),(data.imgs.length == 1)?_c('flexbox-item'):_vm._e(),_vm._v(" "),(data.imgs.length == 1)?_c('flexbox-item'):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"height":"10px"}}),_vm._v(" "),_c('flexbox',{staticStyle:{"border-bottom":"1px solid #ddd","padding-bottom":"5px","margin-bottom":"15px"},attrs:{"gutter":0}},[_c('flexbox-item',{attrs:{"span":8}},[_c('span',{staticClass:"gc-new-data-no"},[_vm._v("\n          "+_vm._s(data.releaseDate)+"\n        ")])]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"text-align":"center"},attrs:{"span":2}},[_c('span',{on:{"click":function($event){_vm.like(index)}}},[(data.praisePoint == 0)?_c('img',{staticClass:"gc-new-on-icon",attrs:{"src":__webpack_require__("cHaP"),"alt":""}}):_c('img',{staticClass:"gc-new-on-icon",attrs:{"src":__webpack_require__("xJHg"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"gc-new-no-name"},[_vm._v(_vm._s(data.praisePoint))])])]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"text-align":"center"},attrs:{"span":2}},[_c('router-link',{attrs:{"to":{path:'/momentsdetail',query:{themeId:data.themeId,phone:_vm.phone}}}},[_c('span',[_c('img',{staticClass:"gc-new-on-icon",attrs:{"src":__webpack_require__("GgSw"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"gc-new-no-name"},[_vm._v(_vm._s(data.msgCount))])])])],1)],1)],1)}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.preview),expression:"preview"}],staticStyle:{"position":"fixed"},attrs:{"id":"view_01"}},[_c('span',{staticClass:"direction",on:{"click":function($event){_vm.reduce()}}},[_c('i',{staticClass:"fa fa-angle-left"})]),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.hideBigPic()}}},[_c('img',{staticStyle:{"position":"relative","color":"white","width":"100%","height":"auto","z-index":"10","opacity":"0"},style:({'top':_vm.top+'px'}),attrs:{"src":_vm.imgsrc,"alt":"暂无图片","id":"bigpic"}})]),_vm._v(" "),_c('span',{staticClass:"direction",staticStyle:{"right":"1%","text-align":"right"},on:{"click":function($event){_vm.add()}}},[_c('i',{staticClass:"fa fa-angle-right"})])]),_vm._v(" "),(_vm.loading)?_c('load-more',{attrs:{"tip":"加载中"}}):_vm._e()],2)}
var list_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gc-new-postion-icon"},[_c('img',{attrs:{"src":__webpack_require__("OS5N"),"alt":""}})])}]
var list_esExports = { render: list_render, staticRenderFns: list_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_momentsComponents_list = (list_esExports);
// CONCATENATED MODULE: ./src/components/momentsComponents/list.vue
function list_injectStyle (ssrContext) {
  __webpack_require__("BoMB")
}
var list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var list___vue_template_functional__ = false
/* styles */
var list___vue_styles__ = list_injectStyle
/* scopeId */
var list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var list___vue_module_identifier__ = null
var list_Component = list_normalizeComponent(
  components_momentsComponents_list,
  selectortype_template_index_0_src_components_momentsComponents_list,
  list___vue_template_functional__,
  list___vue_styles__,
  list___vue_scopeId__,
  list___vue_module_identifier__
)

/* harmony default export */ var src_components_momentsComponents_list = (list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/momentsComponents/detail.vue


var detail__beforeMount$methods$;












/* harmony default export */ var momentsComponents_detail = (detail__beforeMount$methods$ = {
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/momentsdetail") {
      document.title = "邻里分享";
    }
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
  },

  methods: {
    reduce: function reduce() {
      var img = document.getElementById('bigpic');
      if (this.current > 0) {
        this.current--;
      } else {
        this.current = 0;
      }
      this.imgsrc = this.data.imgs[this.current].maxPicUrl;
      var self = this;
      img.onload = function () {
        self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        $(this).animate({ 'opacity': +1 }, 1, 'swing');
      };
    },
    add: function add() {
      if (this.current < this.data.imgs.length - 1) {
        this.current++;
      } else {
        this.current = this.data.imgs.length - 1;
      }
      var img = document.getElementById('bigpic');
      this.imgsrc = this.data.imgs[this.current].maxPicUrl;
      var self = this;
      img.onload = function () {
        self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        $(this).animate({ 'opacity': +1 }, 1, 'swing');
      };
    },
    viewBigPic: function viewBigPic(current) {
      this.preview = true;
      this.current = current;
      var img = document.getElementById('bigpic');
      this.imgsrc = this.data.imgs[this.current].maxPicUrl;
      var self = this;
      img.onload = function () {
        self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        $(this).animate({ 'opacity': +1 }, 2, 'swing');
      };
    },
    hideBigPic: function hideBigPic() {
      this.preview = false;
    },
    discussinfo: function discussinfo() {

      this.parentId = 0;
      this.parentman = '';
      this.typeopera = '评论';
      this.placeholder = '我要发表评论';
    },
    revert: function revert(index) {

      this.parentId = this.replylist[index].msgId;
      this.parentman = this.replylist[index].pushMan;
      this.typeopera = '回复';
      this.placeholder = '\u6211\u8981\u56DE\u590D' + this.parentman + '\u7684\u8BC4\u8BBA';
    },
    like: function like() {
      this.data.praisePoint += 1;
      this.$http.get(global.host + 'themeShare/like?themeId=' + this.$router.history.current.query.themeId, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {}, function (err) {
        console.log(err);
      });
    },
    submitComment: function submitComment() {
      if (!this.comment) {
        alert_module["a" /* default */].show({
          title: '温馨提示',
          content: '\u8BF7\u8F93\u5165\u4F60\u8981' + this.typeopera + '\u7684\u7559\u8A00'
        });
      } else {
        this.forbid = true;
        var self = this;
        var data = { message: this.comment, "parentId": this.parentId, parentman: this.parentman, regPhone: this.$router.history.current.query.phone, themeId: this.$router.history.current.query.themeId };
        this.$http.post(global.host + 'themeShare/insertMsg', data, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {
          if (res.body.statusCode == '110') {
            this.comment = '';
            this.placeholder = '留言成功';
            this.$http.get(global.host + 'themeShare/getThemeDetail?themeId=' + this.$router.history.current.query.themeId, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {
              if (res.result.statusCode == '110') {
                this.data.msgCount = isNaN(parseInt(res.body.result.msgCount)) ? 0 : parseInt(res.body.result.msgCount);
              }
            }, function (err) {
              console.log(err);
            });
            this.$http.get(global.host + 'themeShare/getMsgBody?themeId=' + this.$router.history.current.query.themeId, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {
              if (res.body.result) {
                var size = self.replylist.length;
                for (var i = 0; i < size; i++) {
                  self.replylist.pop();
                }
                size = res.body.result.length;
                for (var _i = 0; _i < size; _i++) {
                  self.replylist.push(res.body.result[_i]);
                }
              }
            }, function (err) {
              console.log(err);
            });
          }
        }, function (err) {
          console.log(err);
        });
      }
    }
  }
}, defineProperty_default()(detail__beforeMount$methods$, 'beforeMount', function beforeMount() {
  this.$http.get(global.host + 'themeShare/getThemeDetail?themeId=' + this.$router.history.current.query.themeId, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {

    if (res.body.result) {
      this.data = res.body.result;
      this.data.praisePoint = isNaN(parseInt(this.data.praisePoint)) ? 0 : parseInt(this.data.praisePoint);
      this.data.msgCount = isNaN(parseInt(this.data.msgCount)) ? 0 : parseInt(this.data.msgCount);
      if (this.data.imgs.length > 0) {
        for (var j = 0; j < this.data.imgs.length; j++) {
          this.data.imgs[j].maxPicUrl = global.baseImg + this.data.imgs[j].maxPicUrl;
          this.data.imgs[j].minPicUrl = global.baseImg + this.data.imgs[j].minPicUrl;
        }
      }
    } else {
      this.data.themeDesc = '你参与的此话题已删除';
      this.data.memberName = '';
      this.data.comnName = '';
      this.data.msgCount = 0;
      this.data.praisePoint = 0;
    }
  }, function (err) {
    console.log(err);
  });

  this.$http.get(global.host + 'themeShare/getMsgBody?themeId=' + this.$router.history.current.query.themeId, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {
    if (res.body.result) {
      this.replylist = res.body.result;
    }
  }, function (err) {
    console.log(err);
  });
}), defineProperty_default()(detail__beforeMount$methods$, 'data', function data() {
  return {
    data: '',
    top: 0,
    comment: '',
    replyable: true,
    replylist: [],
    parentId: 0,
    parentman: '',
    typeopera: '评论',
    placeholder: '我要发表评论',
    forbid: false,
    preview: false,
    maxheight: window.screen.height - 43,
    imgsrc: '',
    current: 0
  };
}), defineProperty_default()(detail__beforeMount$methods$, 'components', { XHeader: vux_src_components_x_header, XImg: vux_src_components_x_img, Flexbox: flexbox["a" /* default */], FlexboxItem: flexbox_item["a" /* default */], XButton: vux_src_components_x_button, XInput: x_input["a" /* default */] }), detail__beforeMount$methods$);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/momentsComponents/detail.vue


var momentsComponents_detail__beforeMount$methods$;












/* harmony default export */ var components_momentsComponents_detail = (momentsComponents_detail__beforeMount$methods$ = {
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/momentsdetail") {
      document.title = "邻里分享";
    }
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
  },

  methods: {
    reduce: function reduce() {
      var img = document.getElementById('bigpic');
      if (this.current > 0) {
        this.current--;
      } else {
        this.current = 0;
      }
      this.imgsrc = this.data.imgs[this.current].maxPicUrl;
      var self = this;
      img.onload = function () {
        self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        $(this).animate({ 'opacity': +1 }, 1, 'swing');
      };
    },
    add: function add() {
      if (this.current < this.data.imgs.length - 1) {
        this.current++;
      } else {
        this.current = this.data.imgs.length - 1;
      }
      var img = document.getElementById('bigpic');
      this.imgsrc = this.data.imgs[this.current].maxPicUrl;
      var self = this;
      img.onload = function () {
        self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        $(this).animate({ 'opacity': +1 }, 1, 'swing');
      };
    },
    viewBigPic: function viewBigPic(current) {
      this.preview = true;
      this.current = current;
      var img = document.getElementById('bigpic');
      this.imgsrc = this.data.imgs[this.current].maxPicUrl;
      var self = this;
      img.onload = function () {
        self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        $(this).animate({ 'opacity': +1 }, 2, 'swing');
      };
    },
    hideBigPic: function hideBigPic() {
      this.preview = false;
    },
    discussinfo: function discussinfo() {

      this.parentId = 0;
      this.parentman = '';
      this.typeopera = '评论';
      this.placeholder = '我要发表评论';
    },
    revert: function revert(index) {

      this.parentId = this.replylist[index].msgId;
      this.parentman = this.replylist[index].pushMan;
      this.typeopera = '回复';
      this.placeholder = '\u6211\u8981\u56DE\u590D' + this.parentman + '\u7684\u8BC4\u8BBA';
    },
    like: function like() {
      this.data.praisePoint += 1;
      this.$http.get(global.host + 'themeShare/like?themeId=' + this.$router.history.current.query.themeId, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {}, function (err) {
        console.log(err);
      });
    },
    submitComment: function submitComment() {
      if (!this.comment) {
        alert_module["a" /* default */].show({
          title: '温馨提示',
          content: '\u8BF7\u8F93\u5165\u4F60\u8981' + this.typeopera + '\u7684\u7559\u8A00'
        });
      } else {
        this.forbid = true;
        var self = this;
        var data = { message: this.comment, "parentId": this.parentId, parentman: this.parentman, regPhone: this.$router.history.current.query.phone, themeId: this.$router.history.current.query.themeId };
        this.$http.post(global.host + 'themeShare/insertMsg', data, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {
          if (res.body.statusCode == '110') {
            this.comment = '';
            this.placeholder = '留言成功';
            this.$http.get(global.host + 'themeShare/getThemeDetail?themeId=' + this.$router.history.current.query.themeId, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {
              if (res.result.statusCode == '110') {
                this.data.msgCount = isNaN(parseInt(res.body.result.msgCount)) ? 0 : parseInt(res.body.result.msgCount);
              }
            }, function (err) {
              console.log(err);
            });
            this.$http.get(global.host + 'themeShare/getMsgBody?themeId=' + this.$router.history.current.query.themeId, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {
              if (res.body.result) {
                var size = self.replylist.length;
                for (var i = 0; i < size; i++) {
                  self.replylist.pop();
                }
                size = res.body.result.length;
                for (var _i = 0; _i < size; _i++) {
                  self.replylist.push(res.body.result[_i]);
                }
              }
            }, function (err) {
              console.log(err);
            });
          }
        }, function (err) {
          console.log(err);
        });
      }
    }
  }
}, defineProperty_default()(momentsComponents_detail__beforeMount$methods$, 'beforeMount', function beforeMount() {
  this.$http.get(global.host + 'themeShare/getThemeDetail?themeId=' + this.$router.history.current.query.themeId, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {

    if (res.body.result) {
      this.data = res.body.result;
      this.data.praisePoint = isNaN(parseInt(this.data.praisePoint)) ? 0 : parseInt(this.data.praisePoint);
      this.data.msgCount = isNaN(parseInt(this.data.msgCount)) ? 0 : parseInt(this.data.msgCount);
      if (this.data.imgs.length > 0) {
        for (var j = 0; j < this.data.imgs.length; j++) {
          this.data.imgs[j].maxPicUrl = global.baseImg + this.data.imgs[j].maxPicUrl;
          this.data.imgs[j].minPicUrl = global.baseImg + this.data.imgs[j].minPicUrl;
        }
      }
    } else {
      this.data.themeDesc = '你参与的此话题已删除';
      this.data.memberName = '';
      this.data.comnName = '';
      this.data.msgCount = 0;
      this.data.praisePoint = 0;
    }
  }, function (err) {
    console.log(err);
  });

  this.$http.get(global.host + 'themeShare/getMsgBody?themeId=' + this.$router.history.current.query.themeId, { header: { Accept: "application/x-www-form-urlencoded" } }).then(function (res) {
    if (res.body.result) {
      this.replylist = res.body.result;
    }
  }, function (err) {
    console.log(err);
  });
}), defineProperty_default()(momentsComponents_detail__beforeMount$methods$, 'data', function data() {
  return {
    data: '',
    top: 0,
    comment: '',
    replyable: true,
    replylist: [],
    parentId: 0,
    parentman: '',
    typeopera: '评论',
    placeholder: '我要发表评论',
    forbid: false,
    preview: false,
    maxheight: window.screen.height - 43,
    imgsrc: '',
    current: 0
  };
}), defineProperty_default()(momentsComponents_detail__beforeMount$methods$, 'components', { XHeader: vux_src_components_x_header, XImg: vux_src_components_x_img, Flexbox: flexbox["a" /* default */], FlexboxItem: flexbox_item["a" /* default */], XButton: vux_src_components_x_button, XInput: x_input["a" /* default */] }), momentsComponents_detail__beforeMount$methods$);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cdcd8c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/momentsComponents/detail.vue
var detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'maxHeight':_vm.maxheight + 'px'}),attrs:{"id":"detail_01"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"header",staticStyle:{"display":"flex"}},[_c('img',{staticClass:"gc-img-icon-user",attrs:{"src":_vm.data.memberIcon}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"gc-new-title"},[_vm._v(_vm._s(_vm.data.memberName))]),_vm._v(" "),_c('div',{staticClass:"gc-new-title-bottom"},[_vm._v(_vm._s(_vm.data.comnName))])])]),_vm._v(" "),_c('p',{staticClass:"context",staticStyle:{"padding-left":"2.9rem"}},[_vm._v(_vm._s(_vm.data.themeDesc))]),_vm._v(" "),(_vm.data.imgs  && _vm.data.imgs.length)?_c('flexbox',{staticStyle:{"padding-left":"3rem","width":"auto !important"},attrs:{"gutter":0}},[_vm._l((_vm.data.imgs),function(picdata,index){return _c('flexbox-item',{key:index,staticClass:"picture",nativeOn:{"click":function($event){_vm.viewBigPic(index)}}},[_c('img',{attrs:{"src":picdata.minPicUrl,"alt":picdata.pictureId}})])}),_vm._v(" "),(_vm.data.imgs.length == 3)?_c('flexbox-item'):_vm._e(),_vm._v(" "),(_vm.data.imgs.length == 2)?_c('flexbox-item'):_vm._e(),_vm._v(" "),(_vm.data.imgs.length == 2)?_c('flexbox-item'):_vm._e(),_vm._v(" "),(_vm.data.imgs.length == 1)?_c('flexbox-item'):_vm._e(),_vm._v(" "),(_vm.data.imgs.length == 1)?_c('flexbox-item'):_vm._e(),_vm._v(" "),(_vm.data.imgs.length == 1)?_c('flexbox-item'):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.preview),expression:"preview"}],staticStyle:{"position":"fixed"},attrs:{"id":"view_01"}},[_c('span',{staticClass:"direction",on:{"click":function($event){_vm.reduce()}}},[_c('i',{staticClass:"fa fa-angle-left"})]),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.hideBigPic()}}},[_c('img',{staticStyle:{"position":"relative","color":"white","width":"100%","height":"auto","z-index":"10","opacity":"0"},style:({'top':_vm.top+'px'}),attrs:{"src":_vm.imgsrc,"alt":"暂无图片","id":"bigpic"}})]),_vm._v(" "),_c('span',{staticClass:"direction",staticStyle:{"right":"1%","text-align":"right"},on:{"click":function($event){_vm.add()}}},[_c('i',{staticClass:"fa fa-angle-right"})])]),_vm._v(" "),_c('p',{staticStyle:{"height":"10px","min-height":"30px"}}),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{attrs:{"span":8}},[_c('span',{staticClass:"gc-new-data-no"},[_vm._v("\n          "+_vm._s(_vm.data.releaseDate)+"\n        ")])]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"text-align":"center"},attrs:{"span":2}},[_c('span',{on:{"click":function($event){_vm.like()}}},[(_vm.data.praisePoint == 0)?_c('img',{staticClass:"gc-new-on-icon",attrs:{"src":__webpack_require__("cHaP"),"alt":""}}):_c('img',{staticClass:"gc-new-on-icon",attrs:{"src":__webpack_require__("xJHg"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"gc-new-no-name"},[_vm._v(_vm._s(_vm.data.praisePoint))])])]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"text-align":"center"},attrs:{"span":2}},[_c('span',{on:{"click":function($event){_vm.discussinfo()}}},[_c('img',{staticClass:"gc-new-on-icon",attrs:{"src":__webpack_require__("GgSw"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"gc-new-no-name"},[_vm._v(_vm._s(_vm.data.msgCount))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"gc-new-xain"}),_vm._v(" "),_vm._l((_vm.replylist),function(replydata,index){return (_vm.replylist && _vm.replylist.length)?_c('div',{key:index},[_c('div',{class:{'comment': replydata.parentId ==0,'reply': replydata.parentId !=0}},[_c('div',{staticStyle:{"background":"#fff"}},[_c('div',{staticClass:"header",staticStyle:{"display":"flex"}},[_c('img',{staticClass:"gc-img-icon-user",attrs:{"src":_vm.data.memberIcon}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"gc-new-title"},[_vm._v(_vm._s(_vm.data.memberName))]),_vm._v(" "),_c('div',{staticClass:"gc-new-title-bottom"},[_vm._v(_vm._s(_vm.data.comnName))])])]),_vm._v(" "),_c('p',{staticClass:"context",staticStyle:{"padding-left":"3.5rem"}},[_vm._v(_vm._s(_vm.data.themeDesc))]),_vm._v(" "),_c('div',{staticStyle:{"height":"0.5rem"}}),_vm._v(" "),_c('div',{staticClass:"gc-new-xain"})])])]):_vm._e()}),_vm._v(" "),(_vm.replylist.length == 0)?_c('div',{staticClass:"gc-no-name-is"},[_vm._v("\n    暂无评论\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"gc-bottom-pos"},[_c('div',{staticClass:"gc-bottom-pos-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],attrs:{"type":"text","placeholder":"我要发表评论","id":""},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"gc-bottom-pos-right",on:{"click":function($event){_vm.submitComment()}}},[_vm._v("\n        评论\n    ")])])],2)}
var detail_staticRenderFns = []
var detail_esExports = { render: detail_render, staticRenderFns: detail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_momentsComponents_detail = (detail_esExports);
// CONCATENATED MODULE: ./src/components/momentsComponents/detail.vue
function detail_injectStyle (ssrContext) {
  __webpack_require__("DdhL")
}
var detail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var detail___vue_template_functional__ = false
/* styles */
var detail___vue_styles__ = detail_injectStyle
/* scopeId */
var detail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var detail___vue_module_identifier__ = null
var detail_Component = detail_normalizeComponent(
  components_momentsComponents_detail,
  selectortype_template_index_0_src_components_momentsComponents_detail,
  detail___vue_template_functional__,
  detail___vue_styles__,
  detail___vue_scopeId__,
  detail___vue_module_identifier__
)

/* harmony default export */ var src_components_momentsComponents_detail = (detail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/momentsComponents/mime.vue














/* harmony default export */ var mime = ({
  methods: {
    confirmCancel: function confirmCancel(index) {
      this.showconfirm = true;
      this.currentIndex = index;
    },
    deleteTopic: function deleteTopic() {
      this.$http.get(global.host + "themeShare/deleteTopic?themeId=" + this.currentIndex).then(function (res) {
        window.location.reload();
      }, function (err) {
        console.log(err);
      });
    },
    changeRange: function changeRange(index) {
      var curr = index;
      this.isShow = index === 1 ? false : true;
      this.clearArray(this.list);
      this.getData(this.page, ++curr);
    },
    clearArray: function clearArray(arr) {
      var size = arr.length;
      for (var i = 0; i < size; i++) {
        arr.pop();
      }
    },
    getData: function getData(page, type) {
      var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;

      this.$http.post(global.host + 'themeShare/getMyList', { type: type, phone: this.$router.history.current.query.phone, page: page, rows: rows }, { header: { Accept: "application/json" } }).then(function (res) {
        if (res.body.result) {
          var data = res.body.result;
          for (var i = 0; i < data.length; i++) {
            data[i].praisePoint = isNaN(parseInt(data[i].praisePoint)) ? 0 : parseInt(data[i].praisePoint);
            data[i].msgCount = isNaN(parseInt(data[i].msgCount)) ? 0 : parseInt(data[i].msgCount);
            /*判断是否是今天*/
            if (Object(date_format["a" /* default */])(new Date(data[i].pushDate), 'YYYY-MM-DD') === Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD')) {
              data[i].pushDate = '';
            }
            if (data[i].imgs.length > 0) {
              for (var j = 0; j < data[i].imgs.length; j++) {
                data[i].imgs[j].maxPicUrl = global.baseImg + data[i].imgs[j].maxPicUrl;
                data[i].imgs[j].minPicUrl = global.baseImg + data[i].imgs[j].minPicUrl;
              }
            }
            this.list.push(data[i]);
          }
        }
        console.log(this.list);
      }, function (err) {
        console.log(err);
      });
    }
  },
  created: function created() {
    var self = this;
    window.onscroll = function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + windowHeight == scrollHeight) {
        if (!self.loading) {
          self.page += 1;
          self.getData(self.page);
        }
      }
    };
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/momentsmime") {
      document.title = "我的分享";
    }
    this.getData(this.page, 1);
  },

  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, XHeader: vux_src_components_x_header, XImg: vux_src_components_x_img, Flexbox: flexbox["a" /* default */], FlexboxItem: flexbox_item["a" /* default */], Confirm: node_modules_vux_src_components_confirm, Loading: vux_src_components_loading, LoadMore: vux_src_components_load_more },
  filters: { dateFormat: date_format["a" /* default */] },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  data: function data() {
    return {
      titles: ['我发表的', '我参与的'],
      list: [],
      phone: this.$router.history.current.query.phone,
      isShow: true,
      width: window.screen.width - 10,
      windowWidth: window.screen.width,
      currentIndex: 0,
      showconfirm: false,
      page: 1,
      loading: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/momentsComponents/mime.vue














/* harmony default export */ var momentsComponents_mime = ({
  methods: {
    confirmCancel: function confirmCancel(index) {
      this.showconfirm = true;
      this.currentIndex = index;
    },
    deleteTopic: function deleteTopic() {
      this.$http.get(global.host + "themeShare/deleteTopic?themeId=" + this.currentIndex).then(function (res) {
        window.location.reload();
      }, function (err) {
        console.log(err);
      });
    },
    changeRange: function changeRange(index) {
      var curr = index;
      this.isShow = index === 1 ? false : true;
      this.clearArray(this.list);
      this.getData(this.page, ++curr);
    },
    clearArray: function clearArray(arr) {
      var size = arr.length;
      for (var i = 0; i < size; i++) {
        arr.pop();
      }
    },
    getData: function getData(page, type) {
      var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;

      this.$http.post(global.host + 'themeShare/getMyList', { type: type, phone: this.$router.history.current.query.phone, page: page, rows: rows }, { header: { Accept: "application/json" } }).then(function (res) {
        if (res.body.result) {
          var data = res.body.result;
          for (var i = 0; i < data.length; i++) {
            data[i].praisePoint = isNaN(parseInt(data[i].praisePoint)) ? 0 : parseInt(data[i].praisePoint);
            data[i].msgCount = isNaN(parseInt(data[i].msgCount)) ? 0 : parseInt(data[i].msgCount);
            /*判断是否是今天*/
            if (Object(date_format["a" /* default */])(new Date(data[i].pushDate), 'YYYY-MM-DD') === Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD')) {
              data[i].pushDate = '';
            }
            if (data[i].imgs.length > 0) {
              for (var j = 0; j < data[i].imgs.length; j++) {
                data[i].imgs[j].maxPicUrl = global.baseImg + data[i].imgs[j].maxPicUrl;
                data[i].imgs[j].minPicUrl = global.baseImg + data[i].imgs[j].minPicUrl;
              }
            }
            this.list.push(data[i]);
          }
        }
        console.log(this.list);
      }, function (err) {
        console.log(err);
      });
    }
  },
  created: function created() {
    var self = this;
    window.onscroll = function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + windowHeight == scrollHeight) {
        if (!self.loading) {
          self.page += 1;
          self.getData(self.page);
        }
      }
    };
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/momentsmime") {
      document.title = "我的分享";
    }
    this.getData(this.page, 1);
  },

  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, XHeader: vux_src_components_x_header, XImg: vux_src_components_x_img, Flexbox: flexbox["a" /* default */], FlexboxItem: flexbox_item["a" /* default */], Confirm: node_modules_vux_src_components_confirm, Loading: vux_src_components_loading, LoadMore: vux_src_components_load_more },
  filters: { dateFormat: date_format["a" /* default */] },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  data: function data() {
    return {
      titles: ['我发表的', '我参与的'],
      list: [],
      phone: this.$router.history.current.query.phone,
      isShow: true,
      width: window.screen.width - 10,
      windowWidth: window.screen.width,
      currentIndex: 0,
      showconfirm: false,
      page: 1,
      loading: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1590c5fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/momentsComponents/mime.vue
var mime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mime_01"}},[_c('tab',{staticClass:"mtop",attrs:{"line-width":3}},_vm._l((_vm.titles),function(item,index){return _c('tab-item',{key:index,attrs:{"selected":index===0},on:{"on-item-click":function($event){_vm.changeRange(index)}}},[_vm._v(_vm._s(item))])})),_vm._v(" "),(_vm.isShow)?_c('div',{staticClass:"content"},[_c('router-link',{attrs:{"to":{path:'/momentspublush',query:{communityId:this.$router.history.current.query.communityId,openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone,comnCode:this.$router.history.current.query.comnCode}}}},[_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticStyle:{"justify-content":"center","align-items":"baseline"},attrs:{"span":3}},[_c('h4',[_c('span',[_vm._v("今天")])])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":9}},[_c('i',{staticClass:"fa fa-camera",staticStyle:{"font-size":"2rem"}})])],1)],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(data){return _c('div',{staticClass:"content"},[(!_vm.isShow)?_c('router-link',{attrs:{"to":{path:'/momentsdetail',query:{themeId:data.themeId,phone:_vm.phone}}}},[_c('flexbox',{attrs:{"gutter":0}},[_c('flexbox-item',{staticStyle:{"justify-content":"center","align-items":"baseline"},attrs:{"span":3}},[_c('h4',[(!data.pushDate)?_c('span',[_vm._v("今天")]):_vm._e(),_vm._v(" "),(data.pushDate)?_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(data.pushDate,'DD'))),_c('small',[_vm._v("/"+_vm._s(_vm._f("dateFormat")(data.pushDate,'MM'))+"月")])]):_vm._e()])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":9}},[(data.imgs.length > 0)?_c('x-img',{staticClass:"imgbox",attrs:{"src":data.imgs[0].minPicUrl}}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"font-size":"0.8rem","margin-right":"10px","overflow":"hidden"}},[_vm._v(_vm._s(data.themeDesc))])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('div',{staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"item",style:({width:_vm.width + 105 +'px'})},[_c('router-link',{attrs:{"to":{path:'/momentsdetail',query:{themeId:data.themeId,phone:_vm.phone}}}},[_c('div',{staticClass:"info",style:({width:_vm.windowWidth +'px'})},[_c('h4',{staticStyle:{"display":"inline-block","width":"25%"}},[(!data.pushDate)?_c('span',[_vm._v("今天")]):_vm._e(),_vm._v(" "),(data.pushDate)?_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(data.pushDate,'DD'))),_c('small',[_vm._v("/"+_vm._s(_vm._f("dateFormat")(data.pushDate,'MM'))+"月")])]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","width":"70%"}},[(data.imgs.length > 0)?_c('x-img',{staticClass:"imgbox",attrs:{"src":data.imgs[0].minPicUrl}}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"font-size":"0.8rem","margin-right":"10px","overflow":"hidden","max-height":"60px"}},[_vm._v(_vm._s(data.themeDesc))])],1)])]),_vm._v(" "),_c('div',{staticClass:"delete",on:{"click":function($event){_vm.confirmCancel(data.themeId)}}},[_vm._v("删除")])],1)]):_vm._e()],1)}),_vm._v(" "),(_vm.loading)?_c('load-more',{attrs:{"tip":"加载中"}}):_vm._e(),_vm._v(" "),_c('confirm',{attrs:{"title":"温馨提示","content":"您确定要解除绑定"},on:{"on-confirm":function($event){_vm.deleteTopic()}},model:{value:(_vm.showconfirm),callback:function ($$v) {_vm.showconfirm=$$v},expression:"showconfirm"}})],2)}
var mime_staticRenderFns = []
var mime_esExports = { render: mime_render, staticRenderFns: mime_staticRenderFns }
/* harmony default export */ var components_momentsComponents_mime = (mime_esExports);
// CONCATENATED MODULE: ./src/components/momentsComponents/mime.vue
function mime_injectStyle (ssrContext) {
  __webpack_require__("hFXJ")
}
var mime_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var mime___vue_template_functional__ = false
/* styles */
var mime___vue_styles__ = mime_injectStyle
/* scopeId */
var mime___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mime___vue_module_identifier__ = null
var mime_Component = mime_normalizeComponent(
  momentsComponents_mime,
  components_momentsComponents_mime,
  mime___vue_template_functional__,
  mime___vue_styles__,
  mime___vue_scopeId__,
  mime___vue_module_identifier__
)

/* harmony default export */ var src_components_momentsComponents_mime = (mime_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  computed: {
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.$parent.labelWidth || width,
        textAlign: this.$parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && this.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  computed: {
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.$parent.labelWidth || width,
        textAlign: this.$parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && this.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3960f4c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-switch/index.vue
var x_switch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-switch weui-cell weui-cell_switch"},[_c('div',{staticClass:"weui-cell__bd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyle),domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-switch",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),(_vm.preventDefault)?_c('div',{staticClass:"vux-x-switch-overlay",on:{"click":_vm.onClick}}):_vm._e()])])}
var x_switch_staticRenderFns = []
var x_switch_esExports = { render: x_switch_render, staticRenderFns: x_switch_staticRenderFns }
/* harmony default export */ var src_components_x_switch = (x_switch_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-switch/index.vue
function x_switch_injectStyle (ssrContext) {
  __webpack_require__("R5kP")
}
var x_switch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_switch___vue_template_functional__ = false
/* styles */
var x_switch___vue_styles__ = x_switch_injectStyle
/* scopeId */
var x_switch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_switch___vue_module_identifier__ = null
var x_switch_Component = x_switch_normalizeComponent(
  components_x_switch,
  src_components_x_switch,
  x_switch___vue_template_functional__,
  x_switch___vue_styles__,
  x_switch___vue_scopeId__,
  x_switch___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_switch = (x_switch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/momentsComponents/publish.vue









/* harmony default export */ var publish = ({
  components: { XTextarea: vux_src_components_x_textarea, Group: group["a" /* default */], XHeader: vux_src_components_x_header, XSwitch: vux_src_components_x_switch, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      theme: '',
      imgList: [],
      max: 4,
      open: false,
      loadmore: false,
      maxheight: window.screen.height
    };
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/momentspublush") {
      document.title = "邻里分享";
    }
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
  },

  methods: {
    deleteImg: function deleteImg(index) {
      this.imgList.splice(index, 1);
    },
    submitTheme: function submitTheme() {
      if (!this.theme) {
        alert_module["a" /* default */].show({
          title: '温馨提示',
          content: '请输入你要发表的内容'
        });
      } else {
        this.loadmore = true;
        var data = { comnCode: this.$router.history.current.query.communityId, mainPhone: this.$router.history.current.query.phone, themeDesc: this.theme, visibleRange: this.open ? '1' : '0', origiImg: this.imgList };
        this.$http.post(global.host + 'themeShare/releaseTheme', data, { header: { Accept: "application/json; charset=utf-8" } }).then(function (res) {
          if (res.body.statusCode == '110') {
            this.$router.push({ path: '/momentslist', query: { communityId: this.$router.history.current.query.communityId, openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, comnCode: this.$router.history.current.query.comnCode, comnCodes: this.$router.history.current.query.comnCodes } });
          } else {
            alert_module["a" /* default */].show({
              title: '温馨提示',
              content: '发布邻里话题失败'
            });
            this.loadmore = false;
          }
        }, function (err) {
          alert_module["a" /* default */].show({
            title: '温馨提示',
            content: '发布邻里话题失败'
          });
          this.loadmore = false;
        });
      }
    },
    fileChange: function fileChange(el) {
      var _this2 = this;

      var files = document.getElementById('upload_file').files;
      if (this.max - this.imgList.length == 0) {
        return;
      }
      var size = files.length > this.max - this.imgList.length ? this.max - this.imgList.length : files.length;
      for (var i = 0; i < size; i++) {
        if (files[i].type.indexOf('image') == -1) {
          alert('请选择图片文件');
        } else {
          (function () {
            var reader = new FileReader();
            var _this = _this2;
            reader.readAsDataURL(files[i]);
            reader.onload = function (event) {
              var img = new Image();

              var width = 680,
                  //图像大小
              quality = 0.9,
                  //图像质量
              canvas = document.createElement("canvas"),
                  drawer = canvas.getContext("2d");
              img.src = event.target.result;
              img.onload = function () {
                canvas.width = width;
                canvas.height = width * (img.height / img.width);
                drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
                var imgBase64 = canvas.toDataURL("image/jpeg", quality);
                _this.imgList.push(imgBase64);
                img.src = "";
              };
            };
          })();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/momentsComponents/publish.vue









/* harmony default export */ var momentsComponents_publish = ({
  components: { XTextarea: vux_src_components_x_textarea, Group: group["a" /* default */], XHeader: vux_src_components_x_header, XSwitch: vux_src_components_x_switch, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      theme: '',
      imgList: [],
      max: 4,
      open: false,
      loadmore: false,
      maxheight: window.screen.height
    };
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/momentspublush") {
      document.title = "邻里分享";
    }
    this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
  },

  methods: {
    deleteImg: function deleteImg(index) {
      this.imgList.splice(index, 1);
    },
    submitTheme: function submitTheme() {
      if (!this.theme) {
        alert_module["a" /* default */].show({
          title: '温馨提示',
          content: '请输入你要发表的内容'
        });
      } else {
        this.loadmore = true;
        var data = { comnCode: this.$router.history.current.query.communityId, mainPhone: this.$router.history.current.query.phone, themeDesc: this.theme, visibleRange: this.open ? '1' : '0', origiImg: this.imgList };
        this.$http.post(global.host + 'themeShare/releaseTheme', data, { header: { Accept: "application/json; charset=utf-8" } }).then(function (res) {
          if (res.body.statusCode == '110') {
            this.$router.push({ path: '/momentslist', query: { communityId: this.$router.history.current.query.communityId, openid: this.$router.history.current.query.openid, phone: this.$router.history.current.query.phone, comnCode: this.$router.history.current.query.comnCode, comnCodes: this.$router.history.current.query.comnCodes } });
          } else {
            alert_module["a" /* default */].show({
              title: '温馨提示',
              content: '发布邻里话题失败'
            });
            this.loadmore = false;
          }
        }, function (err) {
          alert_module["a" /* default */].show({
            title: '温馨提示',
            content: '发布邻里话题失败'
          });
          this.loadmore = false;
        });
      }
    },
    fileChange: function fileChange(el) {
      var _this2 = this;

      var files = document.getElementById('upload_file').files;
      if (this.max - this.imgList.length == 0) {
        return;
      }
      var size = files.length > this.max - this.imgList.length ? this.max - this.imgList.length : files.length;
      for (var i = 0; i < size; i++) {
        if (files[i].type.indexOf('image') == -1) {
          alert('请选择图片文件');
        } else {
          (function () {
            var reader = new FileReader();
            var _this = _this2;
            reader.readAsDataURL(files[i]);
            reader.onload = function (event) {
              var img = new Image();

              var width = 680,
                  //图像大小
              quality = 0.9,
                  //图像质量
              canvas = document.createElement("canvas"),
                  drawer = canvas.getContext("2d");
              img.src = event.target.result;
              img.onload = function () {
                canvas.width = width;
                canvas.height = width * (img.height / img.width);
                drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
                var imgBase64 = canvas.toDataURL("image/jpeg", quality);
                _this.imgList.push(imgBase64);
                img.src = "";
              };
            };
          })();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147080af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/momentsComponents/publish.vue
var publish_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'maxHeight':_vm.maxheight + 'px'}),attrs:{"id":"publish_01"}},[_c('group',{staticStyle:{"margin-top":"-1.42em"}},[_c('x-textarea',{attrs:{"placeholder":"说点什么","rows":8},model:{value:(_vm.theme),callback:function ($$v) {_vm.theme=$$v},expression:"theme"}})],1),_vm._v(" "),_c('div',{staticStyle:{"height":"15px"}}),_vm._v(" "),_c('div',{staticClass:"add"},[_vm._m(0),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"upload_file","multiple":"multiple"},on:{"change":function($event){_vm.fileChange($event)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.imgList.length),expression:"imgList.length"}],staticClass:"add-img"},[_c('p',{staticClass:"font14"},[_vm._v("图片(最多4张，还可上传"),_c('span',[_vm._v(_vm._s(_vm.max-_vm.imgList.length))]),_vm._v("张)")]),_vm._v(" "),_c('ul',{staticClass:"img-list"},_vm._l((_vm.imgList),function(src,index){return _c('li',{key:index},[_c('img',{attrs:{"src":src}}),_vm._v(" "),_c('i',{staticClass:"fa fa-times",on:{"click":function($event){_vm.deleteImg(index)}}})])}))]),_vm._v(" "),_c('div',{staticStyle:{"height":"15px"}}),_vm._v(" "),_c('x-switch',{attrs:{"title":"仅本小区可见"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}}),_vm._v(" "),_c('h5',{staticStyle:{"text-indent":"1em","color":"#737373","font-size":"0.8rem"}},[_vm._v("开启后，仅在本小区绑定房屋的住户看见该话题")]),_vm._v(" "),_c('div',{staticStyle:{"height":"15px"}}),_vm._v(" "),_c('x-button',{attrs:{"type":"primary","show-loading":_vm.loadmore},nativeOn:{"click":function($event){_vm.submitTheme()}}},[_vm._v("发表")]),_vm._v(" "),_c('div',{staticStyle:{"height":"10px"}})],1)}
var publish_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-image",attrs:{"align":"center"}},[_c('i',{staticClass:"fa fa-plus",staticStyle:{"font-size":"1.5rem"}})])}]
var publish_esExports = { render: publish_render, staticRenderFns: publish_staticRenderFns }
/* harmony default export */ var components_momentsComponents_publish = (publish_esExports);
// CONCATENATED MODULE: ./src/components/momentsComponents/publish.vue
function publish_injectStyle (ssrContext) {
  __webpack_require__("Nim7")
}
var publish_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var publish___vue_template_functional__ = false
/* styles */
var publish___vue_styles__ = publish_injectStyle
/* scopeId */
var publish___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var publish___vue_module_identifier__ = null
var publish_Component = publish_normalizeComponent(
  momentsComponents_publish,
  components_momentsComponents_publish,
  publish___vue_template_functional__,
  publish___vue_styles__,
  publish___vue_scopeId__,
  publish___vue_module_identifier__
)

/* harmony default export */ var src_components_momentsComponents_publish = (publish_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/momentsComponents/preview.vue
//
//
//
//
//

/* harmony default export */ var preview = ({
    data: function data() {
        return {
            imgsrc: this.$router.history.current.query.imgsrc,
            imgHeight: 0,
            top: 0
        };
    },
    mounted: function mounted() {
        var img = document.getElementsByTagName('img')[0];
        var self = this;
        img.onload = function () {
            self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        };
    },

    methods: {
        goback: function goback() {
            this.$router.go(-1);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/momentsComponents/preview.vue
//
//
//
//
//

/* harmony default export */ var momentsComponents_preview = ({
    data: function data() {
        return {
            imgsrc: this.$router.history.current.query.imgsrc,
            imgHeight: 0,
            top: 0
        };
    },
    mounted: function mounted() {
        var img = document.getElementsByTagName('img')[0];
        var self = this;
        img.onload = function () {
            self.top = (document.getElementById('view_01').clientHeight - this.height) / 2;
        };
    },

    methods: {
        goback: function goback() {
            this.$router.go(-1);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0b5ef7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/momentsComponents/preview.vue
var preview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view_01"},on:{"click":function($event){_vm.goback()}}},[_c('img',{style:({'top':_vm.top+'px'}),attrs:{"src":_vm.imgsrc,"alt":""}})])}
var preview_staticRenderFns = []
var preview_esExports = { render: preview_render, staticRenderFns: preview_staticRenderFns }
/* harmony default export */ var components_momentsComponents_preview = (preview_esExports);
// CONCATENATED MODULE: ./src/components/momentsComponents/preview.vue
function preview_injectStyle (ssrContext) {
  __webpack_require__("FNbK")
}
var preview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var preview___vue_template_functional__ = false
/* styles */
var preview___vue_styles__ = preview_injectStyle
/* scopeId */
var preview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var preview___vue_module_identifier__ = null
var preview_Component = preview_normalizeComponent(
  momentsComponents_preview,
  components_momentsComponents_preview,
  preview___vue_template_functional__,
  preview___vue_styles__,
  preview___vue_scopeId__,
  preview___vue_module_identifier__
)

/* harmony default export */ var src_components_momentsComponents_preview = (preview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/momentsComponents/remind.vue











/* harmony default export */ var remind = ({
  data: function data() {
    return {
      list: [],
      titles: ['系统', '账单', '二手市场', '邻里互动'],
      page: 1
    };
  },

  methods: {
    changeType: function changeType(index) {
      var size = this.list.length;
      for (var i = 0; i < size; i++) {
        this.list.pop();
      }
      this.page = 1;
      if (index == 0) {
        this.getData('system', this.page);
      } else if (index == 1) {
        this.getData('charge', this.page);
      } else if (index == 2) {
        this.getData('oldGoods', this.page);
      } else if (index == 3) {
        this.getData('themeShare', this.page);
      }
    },
    noticedetail: function noticedetail(id, link) {
      this.$http.get(global.host + 'noticeCenter/updateRead?noticeId=' + id, { header: { Accept: "application/json; charset=utf-8" } }).then(function (res) {}, function (err) {
        console.log(err);
      });
      this.$router.push({ path: link.replace("movecouplet", '') });
    },
    getData: function getData(type, page) {
      var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;

      this.$http.post(global.host + 'noticeCenter/findNoticeListByType', { page: page, rows: rows, noticeType: type }, { header: { Accept: "application/json; charset=utf-8" } }).then(function (res) {
        if (res.body.result) {
          var data = res.body.result;
          for (var i = 0; i < data.length; i++) {
            this.list.push(data[i]);
          }
        }
      }, function (err) {
        console.log(err);
      });
    }
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/noticeCenter") {
      document.title = "通知中心";
    }
    this.getData('system', this.page);
  },
  created: function created() {
    var self = this;
    window.onscroll = function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + windowHeight == scrollHeight) {
        if (!self.loading) {
          self.page += 1;
          self.getData(self.page);
        }
      }
    };
  },

  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, XHeader: vux_src_components_x_header, XImg: vux_src_components_x_img, Flexbox: flexbox["a" /* default */], FlexboxItem: flexbox_item["a" /* default */], XButton: vux_src_components_x_button, XInput: x_input["a" /* default */] }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/momentsComponents/remind.vue











/* harmony default export */ var momentsComponents_remind = ({
  data: function data() {
    return {
      list: [],
      titles: ['系统', '账单', '二手市场', '邻里互动'],
      page: 1
    };
  },

  methods: {
    changeType: function changeType(index) {
      var size = this.list.length;
      for (var i = 0; i < size; i++) {
        this.list.pop();
      }
      this.page = 1;
      if (index == 0) {
        this.getData('system', this.page);
      } else if (index == 1) {
        this.getData('charge', this.page);
      } else if (index == 2) {
        this.getData('oldGoods', this.page);
      } else if (index == 3) {
        this.getData('themeShare', this.page);
      }
    },
    noticedetail: function noticedetail(id, link) {
      this.$http.get(global.host + 'noticeCenter/updateRead?noticeId=' + id, { header: { Accept: "application/json; charset=utf-8" } }).then(function (res) {}, function (err) {
        console.log(err);
      });
      this.$router.push({ path: link.replace("movecouplet", '') });
    },
    getData: function getData(type, page) {
      var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;

      this.$http.post(global.host + 'noticeCenter/findNoticeListByType', { page: page, rows: rows, noticeType: type }, { header: { Accept: "application/json; charset=utf-8" } }).then(function (res) {
        if (res.body.result) {
          var data = res.body.result;
          for (var i = 0; i < data.length; i++) {
            this.list.push(data[i]);
          }
        }
      }, function (err) {
        console.log(err);
      });
    }
  },
  beforeMount: function beforeMount() {
    if (this.$router.history.current.path == "/noticeCenter") {
      document.title = "通知中心";
    }
    this.getData('system', this.page);
  },
  created: function created() {
    var self = this;
    window.onscroll = function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + windowHeight == scrollHeight) {
        if (!self.loading) {
          self.page += 1;
          self.getData(self.page);
        }
      }
    };
  },

  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, XHeader: vux_src_components_x_header, XImg: vux_src_components_x_img, Flexbox: flexbox["a" /* default */], FlexboxItem: flexbox_item["a" /* default */], XButton: vux_src_components_x_button, XInput: x_input["a" /* default */] }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab20862","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/momentsComponents/remind.vue
var remind_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"remind_01"}},[_c('tab',{staticClass:"mtop",attrs:{"line-width":3}},_vm._l((_vm.titles),function(item,index){return _c('tab-item',{key:index,attrs:{"selected":index===0},on:{"on-item-click":function($event){_vm.changeType(index)}}},[_vm._v(_vm._s(item))])})),_vm._v(" "),_vm._l((_vm.list),function(data,index){return _c('div',{key:index,staticClass:"remind"},[_c('div',{staticClass:"header"},[(data.noticeRead == 0)?_c('span',{staticStyle:{"color":"red","font-size":"1rem","margin-right":"10px"}},[_vm._v("●")]):_vm._e(),_vm._v(_vm._s(data.noticeTitle))]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(data.noticeDesc))]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('span',{on:{"click":function($event){_vm.noticedetail(data.noticeId,data.noticeLink)}}},[_vm._v("查看详情")])])])}),_vm._v(" "),(_vm.list.length == 0)?_c('div',{staticClass:"remind"},[_c('div',{staticClass:"header"},[_vm._v("暂无信息")])]):_vm._e()],2)}
var remind_staticRenderFns = []
var remind_esExports = { render: remind_render, staticRenderFns: remind_staticRenderFns }
/* harmony default export */ var components_momentsComponents_remind = (remind_esExports);
// CONCATENATED MODULE: ./src/components/momentsComponents/remind.vue
function remind_injectStyle (ssrContext) {
  __webpack_require__("jopN")
}
var remind_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var remind___vue_template_functional__ = false
/* styles */
var remind___vue_styles__ = remind_injectStyle
/* scopeId */
var remind___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var remind___vue_module_identifier__ = null
var remind_Component = remind_normalizeComponent(
  momentsComponents_remind,
  components_momentsComponents_remind,
  remind___vue_template_functional__,
  remind___vue_styles__,
  remind___vue_scopeId__,
  remind___vue_module_identifier__
)

/* harmony default export */ var src_components_momentsComponents_remind = (remind_Component.exports);

// EXTERNAL MODULE: ./node_modules/vant/lib/toast/style/index.js
var toast_style = __webpack_require__("GKy3");
var toast_style_default = /*#__PURE__*/__webpack_require__.n(toast_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/toast/index.js
var toast = __webpack_require__("4vvA");
var toast_default = /*#__PURE__*/__webpack_require__.n(toast);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/entrance/accessControl.vue












 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var accessControl__components;



/* harmony default export */ var accessControl = ({
  components: (accessControl__components = {
    $: jquery_default.a
  }, defineProperty_default()(accessControl__components, tab_default.a.name, tab_default.a), defineProperty_default()(accessControl__components, tabs_default.a.name, tabs_default.a), defineProperty_default()(accessControl__components, switch_default.a.name, switch_default.a), defineProperty_default()(accessControl__components, loading_default.a.name, loading_default.a), defineProperty_default()(accessControl__components, dialog_default.a.name, dialog_default.a), defineProperty_default()(accessControl__components, toast_default.a.name, toast_default.a), accessControl__components),
  data: function data() {
    return {
      active: '',
      loging: true, // 是否显示加载
      show_1: false,
      check: [{ checked_one: false }, { checked_two: false }],
      // checked_one: false,
      // checked_two: false,
      hsNo: "", // 房间号
      comnCode: "", // 小区编号
      family: "", // 家庭成员数据集
      ownersName: "", // 业主姓名
      visitor: '', // 访客成员数据集
      authFlag: '', // 认证标识（1已认证；0未认证）
      isApa: false,
      stu: '' // 状态 和当前状态相反
    };
  },
  beforeMount: function beforeMount() {

    this.initial();
  },
  mounted: function mounted() {
    if (this.$route.query.active) {
      this.active = '1';
    } else {
      this.active = '0';
    }
    console.log(this.$router.history.current.query);
  },

  methods: {
    // 我的家属切换推送状态
    onInputJs: function onInputJs(index, item) {
      var _this = this;

      console.log(index);
      console.log(item);
      if (this.family[index].isPush == true) {
        dialog_default.a.confirm({
          title: '提醒',
          message: '是否关闭推送状态？'
        }).then(function () {
          // 发送请求改变推送状态
          _this.stu = '0';
          var status = new Object();
          status.configId = item.configId;
          status.isPush = _this.stu;
          status.comnCode = _this.comnCode;
          var newUrl = global.host + "guardInfo/updateGuardInfo";
          _this.$http.post(newUrl, status).then(function (res) {
            if (res.body.statusCode == 110) {
              this.family[index].isPush = false;
            } else {
              alert('更改失败');
            }
          }, function (err) {
            console.log(err);
            alert(err.body.message);
          });
        });
      } else {
        this.stu = '1';
        var status = new Object();
        status.configId = item.configId;
        status.isPush = this.stu;
        status.comnCode = this.comnCode;
        var newUrl = global.host + "guardInfo/updateGuardInfo";
        this.$http.post(newUrl, status).then(function (res) {
          if (res.body.statusCode == 110) {
            this.family[index].isPush = true;
          } else {
            alert('更改失败');
          }
        }, function (err) {
          console.log(err);
          alert(err.body.message);
        });
      }
    },

    // 我的访客切换状态
    onInputFk: function onInputFk(index, item) {
      var _this2 = this;

      console.log(index);
      console.log(item);
      if (this.visitor[index].isPush == true) {
        dialog_default.a.confirm({
          title: '提醒',
          message: '是否关闭推送状态？'
        }).then(function () {
          // 发送请求改变推送状态
          _this2.stu = '0';
          var status = new Object();
          status.configId = item.configId;
          status.isPush = _this2.stu;
          status.comnCode = _this2.comnCode;
          var newUrl = global.host + "guardVisitor/updateGuardVisitor";
          _this2.$http.post(newUrl, status).then(function (res) {
            if (res.body.statusCode == 110) {
              this.visitor[index].isPush = false;
            } else {
              alert('更改失败');
            }
          }, function (err) {
            console.log(err);
            alert(err.body.message);
          });
        });
      } else {
        this.stu = '1';
        var status = new Object();
        status.configId = item.configId;
        status.isPush = this.stu;
        status.comnCode = this.comnCode;
        var newUrl = global.host + "guardVisitor/updateGuardVisitor";
        this.$http.post(newUrl, status).then(function (res) {
          if (res.body.statusCode == 110) {
            this.visitor[index].isPush = true;
          } else {
            alert('更改失败');
          }
        }, function (err) {
          console.log(err);
          alert(err.body.message);
        });
      }
    },

    // 时间转换 公用
    renderTime: function renderTime(date) {
      var dateee = new Date(date).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, " ").replace(/\.[\d]{3}Z/, " ");
    },

    // 家庭成员类逻辑
    // 删除家庭成员当前信息
    deleMember: function deleMember(item) {
      var _this3 = this;

      dialog_default.a.confirm({
        title: '提示',
        message: '确认删除记录吗?'
      }).then(function () {
        toast_default.a.loading({
          mask: true,
          forbidClick: true,
          duration: 10000000,
          message: "删除中..."
        });
        _this3.$http.get(global.host + "guardInfo/deleteGuardInfo?configId=" + item.configId + "&comnCode=" + _this3.comnCode).then(function (res) {
          console.log('DDDDDDDDDDDDDDDDDDDDDDDDD');
          if (res.body.statusCode == '110') {
            toast_default.a.success('删除成功');
            this.initial_home();
          } else {
            toast_default.a.fail('删除失败');
          }
          console.log(res);
        }, function (err) {
          toast_default.a.fail('删除失败');
          console.log(err);
        });
      }).catch(function () {
        // on cancel
      });
      console.log(item);
    },

    // 页面初始化 查房间号和编号
    initial: function initial() {
      var url = global.host + "users/getUserInfo?openid=" + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone;
      this.$http.get(url).then(function (res) {
        console.log("333333333333333333333");
        console.log(res.body);
        if (res.body.statusCode == '200') {
          this.comnCode = res.body.result.comnCode;
          this.hsNo = res.body.result.houseNo;
          this.ownersName = res.body.result.name;
          this.authFlag = res.body.result.authFlag; //res.body.result.authFlag;  // 如果是1 已认证 如果是0 未认证  isAuthFlag
          console.log(this.authFlag);
          this.initial_home();
          this.initial_visitor();
          if (this.authFlag == '1') {
            this.isApa = true;
          } else {
            this.isApa = false;
          }
          console.log(this.isApa);
          console.log(this.ownersName);
        }
      }, function (err) {
        console.log(err);
      });
    },

    // 页面初始化 查询成员信息
    initial_home: function initial_home() {
      var initial_home = new Object();
      initial_home.comnCode = this.comnCode;
      initial_home.hsNo = this.hsNo;
      var newUrl = global.host + "guardInfo/findGuardInfo";
      this.$http.post(newUrl, initial_home).then(function (res) {
        console.log("xxxxxxfamilyxxxxxx");
        console.log(res);
        this.loging = false;
        this.family = res.body.result;
        for (var i = 0; i < this.family.length; i++) {
          if (this.family[i].relation == "0") {
            this.family[i].relation = "本人";
          } else if (this.family[i].relation == "1") {
            this.family[i].relation = "父母";
          } else if (this.family[i].relation == "2") {
            this.family[i].relation = "子女";
          } else if (this.family[i].relation == "3") {
            this.family[i].relation = "父亲";
          } else if (this.family[i].relation == "4") {
            this.family[i].relation = "兄妹";
          } else if (this.family[i].relation == "5") {
            this.family[i].relation = "其他";
          }

          if (this.family[i].isPush == "0") {
            this.family[i].isPush = false;
          } else {
            this.family[i].isPush = true;
          }
          var phoneReg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/;
          if (this.family[i].telephone == null) {
            this.family[i].telephone = null;
          } else if (!phoneReg.test(this.family[i].telephone)) {
            this.family[i].telephone = null;
          }
          this.family[i].createTime = this.renderTime(this.family[i].createTime);
        }
      }, function (err) {
        console.log(err);
      });
    },


    // 跳转新增家属
    getAddFamily: function getAddFamily() {
      console.log(this.$router.history.current.query.openid);
      console.log(this.$router.history.current.query.phone);
      this.$router.push({
        path: "/addFamily",
        query: {
          ownersName: this.ownersName,
          hsNo: this.hsNo,
          comnCode: this.comnCode,
          openid: this.$router.history.current.query.openid,
          phone: this.$router.history.current.query.phone
        }
      });
    },

    // 访客逻辑
    // 页面初始化 查询访客信息
    initial_visitor: function initial_visitor() {
      var initial_visitor = new Object();
      initial_visitor.comnCode = this.comnCode;
      initial_visitor.hsNo = this.hsNo;
      var newUrl = global.host + "guardVisitor/findGuardVisitor";
      this.$http.post(newUrl, initial_visitor).then(function (res) {
        console.log("qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");
        console.log(res);
        this.loging = false;
        this.visitor = res.body.result;
        for (var i = 0; i < this.visitor.length; i++) {
          if (this.visitor[i].relation == "1") {
            this.visitor[i].relation = "亲戚";
          } else if (this.visitor[i].relation == "2") {
            this.visitor[i].relation = "朋友";
          } else if (this.visitor[i].relation == "3") {
            this.visitor[i].relation = "同事";
          } else if (this.visitor[i].relation == "4") {
            this.visitor[i].relation = "其他";
          }
          if (this.visitor[i].isPush == "0") {
            this.visitor[i].isPush = false;
          } else {
            this.visitor[i].isPush = true;
          }
          var phoneReg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/;
          if (this.visitor[i].telephone == null) {
            this.visitor[i].telephone = null;
          } else if (!phoneReg.test(this.visitor[i].telephone)) {
            this.visitor[i].telephone = null;
          }
          this.visitor[i].createTime = this.renderTime(this.visitor[i].createTime);
        }
      }, function (err) {
        console.log(err);
      });
    },

    // 删除访客记录
    deleVisitor: function deleVisitor(item) {
      var _this4 = this;

      dialog_default.a.confirm({
        title: '提示',
        message: '确认删除记录吗?'
      }).then(function () {
        toast_default.a.loading({
          mask: true,
          forbidClick: true,
          duration: 10000000,
          message: "删除中..."
        });

        _this4.$http.get(global.host + "guardVisitor/deleteGuardVisitor?configId=" + item.configId + "&comnCode=" + _this4.comnCode).then(function (res) {
          console.log('xxx');
          console.log(res);
          if (res.body.statusCode == '110') {
            toast_default.a.success('删除成功');
            this.initial_visitor();
          } else {
            toast_default.a.fail('删除失败');
          }
        }, function (err) {
          toast_default.a.fail('删除失败');
          console.log(err);
        });
      }).catch(function () {
        // on cancel
      });
      console.log(item);
    },

    // 跳转新增访客
    getAddVisitor: function getAddVisitor() {
      this.$router.push({ path: "/addVisitor", query: {
          ownersName: this.ownersName,
          hsNo: this.hsNo,
          comnCode: this.comnCode,
          openid: this.$router.history.current.query.openid,
          phone: this.$router.history.current.query.phone
        } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/entrance/accessControl.vue












 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var entrance_accessControl__components;



/* harmony default export */ var entrance_accessControl = ({
  components: (entrance_accessControl__components = {
    $: jquery_default.a
  }, defineProperty_default()(entrance_accessControl__components, tab_default.a.name, tab_default.a), defineProperty_default()(entrance_accessControl__components, tabs_default.a.name, tabs_default.a), defineProperty_default()(entrance_accessControl__components, switch_default.a.name, switch_default.a), defineProperty_default()(entrance_accessControl__components, loading_default.a.name, loading_default.a), defineProperty_default()(entrance_accessControl__components, dialog_default.a.name, dialog_default.a), defineProperty_default()(entrance_accessControl__components, toast_default.a.name, toast_default.a), entrance_accessControl__components),
  data: function data() {
    return {
      active: '',
      loging: true, // 是否显示加载
      show_1: false,
      check: [{ checked_one: false }, { checked_two: false }],
      // checked_one: false,
      // checked_two: false,
      hsNo: "", // 房间号
      comnCode: "", // 小区编号
      family: "", // 家庭成员数据集
      ownersName: "", // 业主姓名
      visitor: '', // 访客成员数据集
      authFlag: '', // 认证标识（1已认证；0未认证）
      isApa: false,
      stu: '' // 状态 和当前状态相反
    };
  },
  beforeMount: function beforeMount() {

    this.initial();
  },
  mounted: function mounted() {
    if (this.$route.query.active) {
      this.active = '1';
    } else {
      this.active = '0';
    }
    console.log(this.$router.history.current.query);
  },

  methods: {
    // 我的家属切换推送状态
    onInputJs: function onInputJs(index, item) {
      var _this = this;

      console.log(index);
      console.log(item);
      if (this.family[index].isPush == true) {
        dialog_default.a.confirm({
          title: '提醒',
          message: '是否关闭推送状态？'
        }).then(function () {
          // 发送请求改变推送状态
          _this.stu = '0';
          var status = new Object();
          status.configId = item.configId;
          status.isPush = _this.stu;
          status.comnCode = _this.comnCode;
          var newUrl = global.host + "guardInfo/updateGuardInfo";
          _this.$http.post(newUrl, status).then(function (res) {
            if (res.body.statusCode == 110) {
              this.family[index].isPush = false;
            } else {
              alert('更改失败');
            }
          }, function (err) {
            console.log(err);
            alert(err.body.message);
          });
        });
      } else {
        this.stu = '1';
        var status = new Object();
        status.configId = item.configId;
        status.isPush = this.stu;
        status.comnCode = this.comnCode;
        var newUrl = global.host + "guardInfo/updateGuardInfo";
        this.$http.post(newUrl, status).then(function (res) {
          if (res.body.statusCode == 110) {
            this.family[index].isPush = true;
          } else {
            alert('更改失败');
          }
        }, function (err) {
          console.log(err);
          alert(err.body.message);
        });
      }
    },

    // 我的访客切换状态
    onInputFk: function onInputFk(index, item) {
      var _this2 = this;

      console.log(index);
      console.log(item);
      if (this.visitor[index].isPush == true) {
        dialog_default.a.confirm({
          title: '提醒',
          message: '是否关闭推送状态？'
        }).then(function () {
          // 发送请求改变推送状态
          _this2.stu = '0';
          var status = new Object();
          status.configId = item.configId;
          status.isPush = _this2.stu;
          status.comnCode = _this2.comnCode;
          var newUrl = global.host + "guardVisitor/updateGuardVisitor";
          _this2.$http.post(newUrl, status).then(function (res) {
            if (res.body.statusCode == 110) {
              this.visitor[index].isPush = false;
            } else {
              alert('更改失败');
            }
          }, function (err) {
            console.log(err);
            alert(err.body.message);
          });
        });
      } else {
        this.stu = '1';
        var status = new Object();
        status.configId = item.configId;
        status.isPush = this.stu;
        status.comnCode = this.comnCode;
        var newUrl = global.host + "guardVisitor/updateGuardVisitor";
        this.$http.post(newUrl, status).then(function (res) {
          if (res.body.statusCode == 110) {
            this.visitor[index].isPush = true;
          } else {
            alert('更改失败');
          }
        }, function (err) {
          console.log(err);
          alert(err.body.message);
        });
      }
    },

    // 时间转换 公用
    renderTime: function renderTime(date) {
      var dateee = new Date(date).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, " ").replace(/\.[\d]{3}Z/, " ");
    },

    // 家庭成员类逻辑
    // 删除家庭成员当前信息
    deleMember: function deleMember(item) {
      var _this3 = this;

      dialog_default.a.confirm({
        title: '提示',
        message: '确认删除记录吗?'
      }).then(function () {
        toast_default.a.loading({
          mask: true,
          forbidClick: true,
          duration: 10000000,
          message: "删除中..."
        });
        _this3.$http.get(global.host + "guardInfo/deleteGuardInfo?configId=" + item.configId + "&comnCode=" + _this3.comnCode).then(function (res) {
          console.log('DDDDDDDDDDDDDDDDDDDDDDDDD');
          if (res.body.statusCode == '110') {
            toast_default.a.success('删除成功');
            this.initial_home();
          } else {
            toast_default.a.fail('删除失败');
          }
          console.log(res);
        }, function (err) {
          toast_default.a.fail('删除失败');
          console.log(err);
        });
      }).catch(function () {
        // on cancel
      });
      console.log(item);
    },

    // 页面初始化 查房间号和编号
    initial: function initial() {
      var url = global.host + "users/getUserInfo?openid=" + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone;
      this.$http.get(url).then(function (res) {
        console.log("333333333333333333333");
        console.log(res.body);
        if (res.body.statusCode == '200') {
          this.comnCode = res.body.result.comnCode;
          this.hsNo = res.body.result.houseNo;
          this.ownersName = res.body.result.name;
          this.authFlag = res.body.result.authFlag; //res.body.result.authFlag;  // 如果是1 已认证 如果是0 未认证  isAuthFlag
          console.log(this.authFlag);
          this.initial_home();
          this.initial_visitor();
          if (this.authFlag == '1') {
            this.isApa = true;
          } else {
            this.isApa = false;
          }
          console.log(this.isApa);
          console.log(this.ownersName);
        }
      }, function (err) {
        console.log(err);
      });
    },

    // 页面初始化 查询成员信息
    initial_home: function initial_home() {
      var initial_home = new Object();
      initial_home.comnCode = this.comnCode;
      initial_home.hsNo = this.hsNo;
      var newUrl = global.host + "guardInfo/findGuardInfo";
      this.$http.post(newUrl, initial_home).then(function (res) {
        console.log("xxxxxxfamilyxxxxxx");
        console.log(res);
        this.loging = false;
        this.family = res.body.result;
        for (var i = 0; i < this.family.length; i++) {
          if (this.family[i].relation == "0") {
            this.family[i].relation = "本人";
          } else if (this.family[i].relation == "1") {
            this.family[i].relation = "父母";
          } else if (this.family[i].relation == "2") {
            this.family[i].relation = "子女";
          } else if (this.family[i].relation == "3") {
            this.family[i].relation = "父亲";
          } else if (this.family[i].relation == "4") {
            this.family[i].relation = "兄妹";
          } else if (this.family[i].relation == "5") {
            this.family[i].relation = "其他";
          }

          if (this.family[i].isPush == "0") {
            this.family[i].isPush = false;
          } else {
            this.family[i].isPush = true;
          }
          var phoneReg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/;
          if (this.family[i].telephone == null) {
            this.family[i].telephone = null;
          } else if (!phoneReg.test(this.family[i].telephone)) {
            this.family[i].telephone = null;
          }
          this.family[i].createTime = this.renderTime(this.family[i].createTime);
        }
      }, function (err) {
        console.log(err);
      });
    },


    // 跳转新增家属
    getAddFamily: function getAddFamily() {
      console.log(this.$router.history.current.query.openid);
      console.log(this.$router.history.current.query.phone);
      this.$router.push({
        path: "/addFamily",
        query: {
          ownersName: this.ownersName,
          hsNo: this.hsNo,
          comnCode: this.comnCode,
          openid: this.$router.history.current.query.openid,
          phone: this.$router.history.current.query.phone
        }
      });
    },

    // 访客逻辑
    // 页面初始化 查询访客信息
    initial_visitor: function initial_visitor() {
      var initial_visitor = new Object();
      initial_visitor.comnCode = this.comnCode;
      initial_visitor.hsNo = this.hsNo;
      var newUrl = global.host + "guardVisitor/findGuardVisitor";
      this.$http.post(newUrl, initial_visitor).then(function (res) {
        console.log("qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");
        console.log(res);
        this.loging = false;
        this.visitor = res.body.result;
        for (var i = 0; i < this.visitor.length; i++) {
          if (this.visitor[i].relation == "1") {
            this.visitor[i].relation = "亲戚";
          } else if (this.visitor[i].relation == "2") {
            this.visitor[i].relation = "朋友";
          } else if (this.visitor[i].relation == "3") {
            this.visitor[i].relation = "同事";
          } else if (this.visitor[i].relation == "4") {
            this.visitor[i].relation = "其他";
          }
          if (this.visitor[i].isPush == "0") {
            this.visitor[i].isPush = false;
          } else {
            this.visitor[i].isPush = true;
          }
          var phoneReg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/;
          if (this.visitor[i].telephone == null) {
            this.visitor[i].telephone = null;
          } else if (!phoneReg.test(this.visitor[i].telephone)) {
            this.visitor[i].telephone = null;
          }
          this.visitor[i].createTime = this.renderTime(this.visitor[i].createTime);
        }
      }, function (err) {
        console.log(err);
      });
    },

    // 删除访客记录
    deleVisitor: function deleVisitor(item) {
      var _this4 = this;

      dialog_default.a.confirm({
        title: '提示',
        message: '确认删除记录吗?'
      }).then(function () {
        toast_default.a.loading({
          mask: true,
          forbidClick: true,
          duration: 10000000,
          message: "删除中..."
        });

        _this4.$http.get(global.host + "guardVisitor/deleteGuardVisitor?configId=" + item.configId + "&comnCode=" + _this4.comnCode).then(function (res) {
          console.log('xxx');
          console.log(res);
          if (res.body.statusCode == '110') {
            toast_default.a.success('删除成功');
            this.initial_visitor();
          } else {
            toast_default.a.fail('删除失败');
          }
        }, function (err) {
          toast_default.a.fail('删除失败');
          console.log(err);
        });
      }).catch(function () {
        // on cancel
      });
      console.log(item);
    },

    // 跳转新增访客
    getAddVisitor: function getAddVisitor() {
      this.$router.push({ path: "/addVisitor", query: {
          ownersName: this.ownersName,
          hsNo: this.hsNo,
          comnCode: this.comnCode,
          openid: this.$router.history.current.query.openid,
          phone: this.$router.history.current.query.phone
        } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-496054b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/entrance/accessControl.vue
var accessControl_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"accessControl"}},[(this.loging == true)?_c('div',{staticClass:"log"},[_c('van-loading',{attrs:{"type":"spinner"}})],1):_vm._e(),_vm._v(" "),(this.loging == false)?_c('van-tabs',{attrs:{"type":"card"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('van-tab',{attrs:{"title":"我的家属"}},[_vm._l((_vm.family),function(item,index){return _c('div',{key:index,staticClass:"ulList"},[_c('div',{staticClass:"li selfLi"},[_c('div',{staticClass:"headInfo"},[_c('div',{staticClass:"imgg"},[_c('img',{staticClass:"response",attrs:{"src":item.authImg}})]),_vm._v(" "),(item.delFlag == 2)?_c('div',{staticStyle:{"text-align":"center","color":"red","font-size":"0.5rem"}},[_vm._v("删除中,请耐心等待...")]):_vm._e(),_vm._v(" "),(_vm.isApa == true)?_c('img',{ref:"delImg",refInFor:true,staticClass:"delete",attrs:{"src":__webpack_require__("npjk")},on:{"click":function($event){_vm.deleMember(item);}}}):_vm._e(),_vm._v(" "),(_vm.isApa == true)?_c('div',{staticClass:"headInfo_r"},[_c('div',{staticClass:"switch"},[_c('span',[_vm._v("消息推送")]),_vm._v(" "),_c('van-switch',{staticClass:"Switch",attrs:{"value":_vm.family[index].isPush,"active-color":"#fe9e2f","inactive-color":"#fff"},on:{"change":function($event){_vm.onInputJs(index,item)}}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(item.endTime == "flase")?_c('img',{staticStyle:{"position":"absolute","opacity":".2","width":"50%","top":"25%","right":"10%"},attrs:{"src":__webpack_require__("CBpU"),"alt":""}}):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tr',[_c('td',[_vm._v("姓名：")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.rename))])]),_vm._v(" "),(item.telephone !=null )?_c('tr',[_c('td',[_vm._v("联系方式")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.telephone))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("与业主关系：")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.relation))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("更新时间：")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.createDate))])])])])])}),_vm._v(" "),(_vm.isApa == true)?_c('div',{ref:"btnRot",staticClass:"footFix"},[_c('button',{on:{"click":function($event){_vm.getAddFamily()}}},[_c('img',{attrs:{"src":__webpack_require__("6fPh")}}),_vm._v("添加信息\n        ")])]):_vm._e()],2),_vm._v(" "),_c('van-tab',{attrs:{"title":"访客邀请"}},[_vm._l((_vm.visitor),function(item,index){return _c('div',{staticClass:"ulList"},[_c('div',{staticClass:"li selfLi"},[_c('div',{staticClass:"headInfo"},[_c('div',{staticClass:"imgg"},[_c('img',{staticClass:"response",attrs:{"src":item.authImg}})]),_vm._v(" "),(item.delFlag == 2)?_c('div',{staticStyle:{"text-align":"center","color":"red","font-size":"0.5rem"}},[_vm._v("删除中,请耐心等待...")]):_vm._e(),_vm._v(" "),(_vm.isApa == true)?_c('img',{staticClass:"delete",attrs:{"src":__webpack_require__("npjk")},on:{"click":function($event){_vm.deleVisitor(item);}}}):_vm._e(),_vm._v(" "),(_vm.isApa == true)?_c('div',{staticClass:"headInfo_r"},[_c('div',{staticClass:"switch"},[_c('span',[_vm._v("消息推送")]),_vm._v(" "),_c('van-switch',{attrs:{"value":_vm.visitor[index].isPush,"active-color":"#fe9e2f","inactive-color":"#fff"},on:{"change":function($event){_vm.onInputFk(index,item)}}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(item.endTime == "flase")?_c('img',{staticStyle:{"position":"absolute","opacity":".2","width":"50%","top":"25%","right":"10%"},attrs:{"src":__webpack_require__("CBpU"),"alt":""}}):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tr',[_c('td',[_vm._v("姓名：")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.rename))])]),_vm._v(" "),(item.telephone != null )?_c('tr',[_c('td',[_vm._v("联系方式")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.telephone))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("与业主关系：")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.relation))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("更新时间：")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.createDate))])])])])])}),_vm._v(" "),(_vm.isApa == true)?_c('div',{staticClass:"footFix"},[_c('button',{on:{"click":function($event){_vm.getAddVisitor()}}},[_c('img',{attrs:{"src":__webpack_require__("6fPh")}}),_vm._v("添加信息\n        ")])]):_vm._e()],2)],1):_vm._e()],1)}
var accessControl_staticRenderFns = []
var accessControl_esExports = { render: accessControl_render, staticRenderFns: accessControl_staticRenderFns }
/* harmony default export */ var components_entrance_accessControl = (accessControl_esExports);
// CONCATENATED MODULE: ./src/components/entrance/accessControl.vue
function accessControl_injectStyle (ssrContext) {
  __webpack_require__("byZ1")
}
var accessControl_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var accessControl___vue_template_functional__ = false
/* styles */
var accessControl___vue_styles__ = accessControl_injectStyle
/* scopeId */
var accessControl___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var accessControl___vue_module_identifier__ = null
var accessControl_Component = accessControl_normalizeComponent(
  entrance_accessControl,
  components_entrance_accessControl,
  accessControl___vue_template_functional__,
  accessControl___vue_styles__,
  accessControl___vue_scopeId__,
  accessControl___vue_module_identifier__
)

/* harmony default export */ var src_components_entrance_accessControl = (accessControl_Component.exports);

// EXTERNAL MODULE: ./node_modules/vant/lib/picker/style/index.js
var picker_style = __webpack_require__("Rv11");
var picker_style_default = /*#__PURE__*/__webpack_require__.n(picker_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/picker/index.js
var picker = __webpack_require__("TMdk");
var picker_default = /*#__PURE__*/__webpack_require__.n(picker);

// EXTERNAL MODULE: ./node_modules/cropperjs/dist/cropper.js
var cropper = __webpack_require__("4RJ8");
var cropper_default = /*#__PURE__*/__webpack_require__.n(cropper);

// EXTERNAL MODULE: ./node_modules/exif-js/exif.js
var exif = __webpack_require__("sbrb");
var exif_default = /*#__PURE__*/__webpack_require__.n(exif);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/entrance/Visito.vue













 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Visito__components;






/* harmony default export */ var Visito = ({
  components: (Visito__components = {
    $: jquery_default.a
  }, defineProperty_default()(Visito__components, picker_default.a.name, picker_default.a), defineProperty_default()(Visito__components, popup_default.a.name, popup_default.a), defineProperty_default()(Visito__components, switch_default.a.name, switch_default.a), defineProperty_default()(Visito__components, uploader_default.a.name, uploader_default.a), defineProperty_default()(Visito__components, toast_default.a.name, toast_default.a), defineProperty_default()(Visito__components, loading_default.a.name, loading_default.a), Visito__components),
  data: function data() {
    return {
      //防止保存重复点击
      repeatClick: true,
      items: '',
      columns: ["本人", "父母", "子女", "兄妹", "其他"],
      showQR: false,
      checked: false,
      imgUrl: "", // 选择后头像的64位编码
      showuser: "", // 选择联系人后的值 1：亲戚；2：朋友；3：同事；4：其他
      rename: "", // 成员姓名
      headerImage: "", // 图片集合
      picValue: "", // 需要转换的图片
      wuzhImg: "", // 没有转换过的图片64位
      access_token: "", // 百度api的token
      pass: false, // 此参数为true 执行向后台提交的请求 次参数为false 则拦截在百度AI这一层
      faceList: '' // 脸部识别所有的数据
    };
  },

  watch: {
    items: function items() {
      if (this.items.length > 4) {
        this.items = this.items.substring(0, 4);
      }
    }
  },

  beforeMount: function beforeMount() {
    this.getBadToken();
  },
  mounted: function mounted() {
    // this.getBadToken()
    console.log(this.$route.query.hsName); //业主姓名
    console.log(this.$route.query.hsNo); // 房间号
    console.log(this.$route.query.comnCode); // 小区编号
  },

  methods: {
    showUserPicker: function showUserPicker() {
      this.showQR = true;
    },
    onConfirm: function onConfirm(value, index) {
      this.showQR = false;
      this.$refs.showUser.value = value;
      if (value == "本人") {
        this.showuser = "0";
      } else if (value == "父母") {
        this.showuser = "1";
      } else if (value == "子女") {
        this.showuser = "2";
      } else if (value == "兄妹") {
        this.showuser = "4";
      } else if (value == "其他") {
        this.showuser = "5";
      }
    },
    onCancel: function onCancel() {
      this.showQR = false;
    },
    onRead: function onRead(event) {
      // console.log(file.file)
      var image = document.getElementById('img'); //预览对象
      this.clip(event, {
        resultObj: image,
        aspectRatio: 1.1
      });

      console.log(image);
      console.log('qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq');
      //  console.log(this.postImg.imgdataList)
      //  this.postImg()
      // console.log("qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");
      // console.log(file);
      // // 图片转换代码
      // this.$refs.userImg.src = file.content;

      // this.picValue = file.file;
      // this.imgPreview(this.picValue);
    },

    //  新代码  -------------------------------------------------------------------------------------------------------------------------------------------------
    initilize: function initilize(opt) {
      var self = this;
      this.options = opt;
      //创建dom
      this.createElement();
      this.resultObj = opt.resultObj;
      //初始化裁剪对象
      this.cropper = new cropper_default.a(this.preview, {
        aspectRatio: opt.aspectRatio || 1,
        autoCropArea: opt.autoCropArea || 0.8,
        viewMode: 1,
        guides: opt.aspectRatio == 'Free' ? false : true,
        cropBoxResizable: opt.aspectRatio == 'Free' ? false : true,
        cropBoxMovable: opt.aspectRatio == 'Free' ? false : true,
        dragCrop: opt.aspectRatio == 'Free' ? false : true,
        background: false,
        checkOrientation: true,
        checkCrossOrigin: true,
        zoomable: false,
        zoomOnWheel: false,
        center: false,
        toggleDragModeOnDblclick: false,
        ready: function ready() {
          // console.log(self.cropper.rotate(90))
          if (opt.aspectRatio == 'Free') {
            var cropBox = self.cropper.cropBox;
            cropBox.querySelector('span.cropper-view-box').style.outline = 'none';
            self.cropper.disable();
          }
        }
      });
    },
    createElement: function createElement() {
      //初始化图片为空对象
      this.preview = null;

      var str = '<div><img id="clip_image" src="originUrl"></div><button type="button" id="cancel_clip">取消</button><button type="button" id="clip_button">确定</button>';
      str += '<div class="crop_loading"><div class="crop_content"><img src="../static/loading.gif"><div class="crop_text">图片上传中</div></div></div>';
      str += '<div class="crop_success"><div class="crop_success_text">上传成功</div></div></div>';

      var body = document.getElementsByTagName('body')[0];
      this.reagion = document.createElement('div');
      this.reagion.id = 'clip_container';
      this.reagion.className = 'container';
      this.reagion.innerHTML = str;
      //添加创建好的DOM元素
      body.appendChild(this.reagion);
      this.preview = document.getElementById('clip_image');

      //绑定一些方法
      this.initFunction();
    },

    //初始化一些函数绑定
    initFunction: function initFunction() {
      var self = this;
      this.clickBtn = document.getElementById('clip_button');
      this.cancelBtn = document.getElementById('cancel_clip');
      //确定事件
      this.addEvent(this.clickBtn, 'click', function () {
        self.crop();
      });
      //取消事件
      this.addEvent(this.cancelBtn, 'click', function () {
        self.destoried();
      });
      //清空input的值
      this.addEvent(this.fileObj, 'click', function () {
        this.value = '';
      });
    },
    clip: function clip(e, opt) {
      var self = this;

      this.fileObj = e.srcElement;

      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return false; //不是图片直接返回

      //调用初始化方法
      this.initilize(opt);

      //获取图片文件资源
      this.picValue = files[0];

      //去获取拍照时的信息，解决拍出来的照片旋转问题
      // Exif.getData( files[0] , function(){
      //   self.Orientation = Exif.getTag( files[0], 'Orientation');
      //   console.log(self.Orientation)
      // });


      //调用方法转成url格式
      this.originUrl = this.getObjectURL(this.picValue);

      //每次替换图片要重新得到新的url
      if (this.cropper) {
        this.cropper.replace(this.originUrl);
      }
    },

    //图片转码方法
    getObjectURL: function getObjectURL(file) {
      var url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },

    //点击确定进行裁剪
    crop: function crop() {
      toast_default.a.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "识别中..."
      });
      console.log('确定事件确定事件确定事件确定事件确定事件确定事件');
      var self = this;
      var image = new Image();
      var croppedCanvas = void 0;
      var roundedCanvas = void 0;

      // Crop
      document.querySelector('.crop_loading').style.display = 'block';

      setTimeout(function () {
        croppedCanvas = self.cropper.getCroppedCanvas();
        // Round
        roundedCanvas = self.getRoundedCanvas(croppedCanvas);

        var imgData = roundedCanvas.toDataURL();
        image.src = imgData;

        //判断图片是否大于100K,是就直接上传，反之压缩图片
        //       if (this.result.length <= 100 * 1024) {
        //         self.headerImage = this.result;
        //         self.discern();
        //       } else {
        //         img.onload = function() {
        //           let data = self.compress(img, Orientation);
        //           self.headerImage = data;
        //           self.discern();
        //         };
        //判断图片是否大于100k,不大于直接上传，反之压缩
        if (imgData.length < 100 * 1024) {
          self.resultObj.src = imgData;
          self.headerImage = imgData;
          //图片上传
          self.postImg(imgData);
        } else {
          image.onload = function () {
            //压缩处理
            var data = self.compress(image, self.Orientation);
            self.resultObj.src = data;
            //图片上传
            self.headerImage = data;
            self.postImg(data);
          };
        }
      }, 20);
    },

    //获取裁剪图片资源
    getRoundedCanvas: function getRoundedCanvas(sourceCanvas) {

      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      var width = sourceCanvas.width;
      var height = sourceCanvas.height;

      canvas.width = width;
      canvas.height = height;

      context.imageSmoothingEnabled = true;
      context.drawImage(sourceCanvas, 0, 0, width, height);
      context.globalCompositeOperation = 'destination-in';
      context.beginPath();
      context.rect(0, 0, width, height);
      context.fill();

      return canvas;
    },

    //销毁原来的对象
    destoried: function destoried() {
      var self = this;
      //移除事件
      this.removeEvent(this.clickBtn, 'click', null);
      this.removeEvent(this.cancelBtn, 'click', null);
      this.removeEvent(this.fileObj, 'click', null);
      //移除裁剪框
      this.reagion.parentNode.removeChild(this.reagion);

      //销毁裁剪对象
      this.cropper.destroy();
      this.cropper = null;
    },

    //图片上传
    postImg: function postImg(imageData) {
      this.discern();
      //这边写图片的上传
      var self = this;
      self.destoried();
      console.log('图片上传图片上传图片上传图片上传图片上传图片上传');
      var imgdataList = imageData;
      console.log(imageData);
      window.setTimeout(function () {
        document.querySelector('.crop_loading').style.display = 'none';
        document.querySelector('.crop_success').style.display = 'block';
        //裁剪完后摧毁对象
        self.destoried();
      }, 3000);
    },


    //图片旋转
    rotateImg: function rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      var min_step = 0;
      var max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      var height = img.height;
      var width = img.width;
      var step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == 'right') {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      var degree = step * 90 * Math.PI / 180;
      var ctx = canvas.getContext('2d');
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },


    //图片压缩
    compress: function compress(img, Orientation) {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext('2d');
      //瓦片canvas
      var tCanvas = document.createElement("canvas");
      var tctx = tCanvas.getContext("2d");
      var initSize = img.src.length;
      var width = img.width;
      var height = img.height;

      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      var ratio = void 0;
      if ((ratio = width * height / 4000000) > 1) {
        console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      var count = void 0;
      if ((count = width * height / 1000000) > 1) {
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        var nw = ~~(width / count);
        var nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (var i = 0; i < count; i++) {
          for (var j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6:
            //需要顺时针（向左）90度旋转
            this.rotateImg(img, 'left', canvas);
            break;
          case 8:
            //需要逆时针（向右）90度旋转
            this.rotateImg(img, 'right', canvas);
            break;
          case 3:
            //需要180度旋转
            this.rotateImg(img, 'right', canvas); //转两次
            this.rotateImg(img, 'right', canvas);
            break;
        }
      }
      //进行最小压缩
      var ndata = canvas.toDataURL('image/jpeg', 0.1);
      console.log('压缩前：' + initSize);
      console.log('压缩后：' + ndata.length);
      console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + "%");
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;

      return ndata;
    },


    //添加事件
    addEvent: function addEvent(obj, type, fn) {
      if (obj.addEventListener) {
        obj.addEventListener(type, fn, false);
      } else {
        obj.attachEvent('on' + type, fn);
      }
    },

    //移除事件
    removeEvent: function removeEvent(obj, type, fn) {
      if (obj.removeEventListener) {
        obj.removeEventListener(type, fn, false);
      } else {
        obj.detachEvent('on' + type, fn);
      }
    },


    //  新代码 end-------------------------------------------------------------------------------------------------------------------------------------------------------------
    // 图片压缩
    // imgPreview(file) {
    //   let self = this;
    //   let Orientation;
    //   //去获取拍照时的信息，解决拍出来的照片旋转问题
    //   Exif.getData(file, function() {
    //     Orientation = Exif.getTag(this, "Orientation");
    //   });
    //   // 看支持不支持FileReader
    //   if (!file || !window.FileReader) return;

    //   if (/^image/.test(file.type)) {
    //     // 创建一个reader
    //     let reader = new FileReader();
    //     // 将图片2将转成 base64 格式
    //     reader.readAsDataURL(file);
    //     // 读取成功后的回调
    //     reader.onloadend = function() {
    //       let result = this.result;
    //       let img = new Image();
    //       img.src = result;
    //       //判断图片是否大于100K,是就直接上传，反之压缩图片
    //       if (this.result.length <= 100 * 1024) {
    //         self.headerImage = this.result;
    //         self.discern();
    //       } else {
    //         img.onload = function() {
    //           let data = self.compress(img, Orientation);
    //           self.headerImage = data;
    //           self.discern();
    //         };
    //       }
    //     };
    //   }
    // },
    // compress(img, Orientation) {
    //   let canvas = document.createElement("canvas");
    //   let ctx = canvas.getContext("2d");
    //   //瓦片canvas
    //   let tCanvas = document.createElement("canvas");
    //   let tctx = tCanvas.getContext("2d");
    //   let initSize = img.src.length;
    //   let width = img.width;
    //   let height = img.height;
    //   //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
    //   let ratio;
    //   if ((ratio = (width * height) / 4000000) > 1) {
    //     console.log("大于400万像素");
    //     ratio = Math.sqrt(ratio);
    //     width /= ratio;
    //     height /= ratio;
    //   } else {
    //     ratio = 1;
    //   }
    //   canvas.width = width;
    //   canvas.height = height;
    //   //        铺底色
    //   // ctx.fillStyle = "#fff";
    //   ctx.fillRect(0, 0, canvas.width, canvas.height);
    //   //如果图片像素大于100万则使用瓦片绘制
    //   let count;
    //   if ((count = (width * height) / 1000000) > 1) {
    //     console.log("超过100W像素");
    //     count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
    //     //            计算每块瓦片的宽和高
    //     let nw = ~~(width / count);
    //     let nh = ~~(height / count);
    //     tCanvas.width = nw;
    //     tCanvas.height = nh;
    //     for (let i = 0; i < count; i++) {
    //       for (let j = 0; j < count; j++) {
    //         tctx.drawImage(
    //           img,
    //           i * nw * ratio,
    //           j * nh * ratio,
    //           nw * ratio,
    //           nh * ratio,
    //           0,
    //           0,
    //           nw,
    //           nh
    //         );
    //         ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
    //       }
    //     }
    //   } else {
    //     ctx.drawImage(img, 0, 0, width, height);
    //   }
    //   //修复ios上传图片的时候 被旋转的问题
    //   if (Orientation != "" && Orientation != 1) {
    //     switch (Orientation) {
    //       case 6: //需要顺时针（向左）90度旋转
    //         this.rotateImg(img, "left", canvas);
    //         break;
    //       case 8: //需要逆时针（向右）90度旋转
    //         this.rotateImg(img, "right", canvas);
    //         break;
    //       case 3: //需要180度旋转
    //         this.rotateImg(img, "right", canvas); //转两次
    //         this.rotateImg(img, "right", canvas);
    //         break;
    //     }
    //   }
    //   //进行最小压缩
    //   let ndata = canvas.toDataURL("image/jpeg", 0.1);
    //   console.log("压缩前：" + initSize);
    //   console.log("压缩后：" + ndata.length);
    //   console.log(
    //     "压缩率：" + ~~((100 * (initSize - ndata.length)) / initSize) + "%"
    //   );
    //   tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
    //   return ndata;
    // },
    // rotateImg(img, direction, canvas) {
    //   //最小与最大旋转方向，图片旋转4次后回到原方向
    //   const min_step = 0;
    //   const max_step = 3;
    //   if (img == null) return;
    //   //img的高度和宽度不能在img元素隐藏后获取，否则会出错
    //   let height = img.height;
    //   let width = img.width;
    //   let step = 2;
    //   if (step == null) {
    //     step = min_step;
    //   }
    //   if (direction == "right") {
    //     step++;
    //     //旋转到原位置，即超过最大值
    //     step > max_step && (step = min_step);
    //   } else {
    //     step--;
    //     step < min_step && (step = max_step);
    //   }
    //   //旋转角度以弧度值为参数
    //   let degree = (step * 90 * Math.PI) / 180;
    //   let ctx = canvas.getContext("2d");
    //   switch (step) {
    //     case 0:
    //       canvas.width = width;
    //       canvas.height = height;
    //       ctx.drawImage(img, 0, 0);
    //       break;
    //     case 1:
    //       canvas.width = height;
    //       canvas.height = width;
    //       ctx.rotate(degree);
    //       ctx.drawImage(img, 0, -height);
    //       break;
    //     case 2:
    //       canvas.width = width;
    //       canvas.height = height;
    //       ctx.rotate(degree);
    //       ctx.drawImage(img, -width, -height);
    //       break;
    //     case 3:
    //       canvas.width = height;
    //       canvas.height = width;
    //       ctx.rotate(degree);
    //       ctx.drawImage(img, -width, 0);
    //       break;
    //   }
    // },
    // 调用百度api 获取token
    getBadToken: function getBadToken() {
      // 百度api
      // /BD 配置在config index.js文件内做跨域处理
      console.log("调用百度api token");
      this.$http.post(global.host + "/face/aip/access_token.json").then(function (res) {
        console.log("新的token新的token新的token新的token新的token新的token");
        console.log(res);
        this.access_token = res.body.access_token;
        console.log(this.access_token);
      }, function (err) {
        console.log("人脸识别token获取失败");
        console.log(err);
      });
    },

    // 唤起人脸识别检测接口
    discern: function discern() {
      this.pass = false;
      // this.headerImage = '',
      console.log("唤起人脸识别检测接口");
      // console.log(this.headerImage)
      console.log(this.headerImage);
      var strIng = this.headerImage.indexOf(",");
      var result = this.headerImage.substr(strIng + 1, this.headerImage.length);
      // console.log(result)
      var self = this;
      jquery_default.a.ajax({
        type: "post",
        url: "https://aip.baidubce.com/rest/2.0/face/v3/detect?access_token=" + this.access_token,
        data: {
          image: result,
          image_type: "BASE64",
          face_field: "angel,quality,face_type,glasses,gender,age,face_token,eye_status,race,landmark,",
          max_face_num: "2"
        },
        dataType: "json",
        crossDomain: true,
        success: function success(result) {
          console.log("百度AI调用成功返回参数");
          console.log(result);
          if (result.error_code == "222202") {
            toast_default.a.fail("图片中没有人脸");
          } else if (result.error_code == "222203") {
            toast_default.a.fail("无法解析人脸");
          } else if (result.error_code == "223114") {
            toast_default.a.fail("人脸模糊");
          } else if (result.error_code == "223115") {
            toast_default.a.fail("人脸光照不好");
          } else if (result.result.face_list[0].face_type.type == "cartoon") {
            toast_default.a.fail("请上传真实人脸");
          } else if (result.result.face_list[0].face_type.probability <= "0.85") {
            toast_default.a.fail("请不要使用美颜拍照");
          } else if (result.result.face_list[0].quality.completeness != "1") {
            toast_default.a.fail("人脸不完整");
          } else if (result.result.face_list[0].face_probability != "1") {
            toast_default.a.fail("人脸模糊");
          } else if (result.result.face_list[0].quality.blur != "0") {
            toast_default.a.fail("相片不够清晰");
          } else if (result.result.face_list[0].quality.completeness != "1") {
            toast_default.a.fail("人脸不够完整");
          } else if (result.result.face_list[0].quality.illumination < 70) {
            toast_default.a.fail("光照太弱");
          } else if (result.result.face_list[0].quality.occlusion.chin_contour > "0.4") {
            toast_default.a.fail("下巴被遮挡");
          } else if (result.result.face_list[0].location.rotation < -50 || result.result.face_list[0].location.rotation > 50) {
            toast_default.a.fail("照片角度不符");
          } else if (result.result.face_list[0].quality.occlusion.left_cheek > "0.4") {
            toast_default.a.fail("左脸颊被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.left_eye > "0.4") {
            toast_default.a.fail("左眼被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.mouth > "0.4") {
            toast_default.a.fail("嘴巴被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.nose > "0.4") {
            toast_default.a.fail("鼻子被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.right_cheek > "0.4") {
            toast_default.a.fail("右脸颊被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.right_eye > "0.4") {
            toast_default.a.fail("右眼被遮挡");
          } else if (result.result.face_num > "1") {
            toast_default.a.fail("请单人拍照");
          } else if (result.result.face_list[0].glasses.type != "none") {
            toast_default.a.fail("请摘下眼镜");
          } else if (result.result.face_list[0].eye_status.left_eye != "1" && result.result.face_list[0].eye_status.right_eye != "1") {
            toast_default.a.fail("请睁开眼睛拍照");
          } else if (
          // result.result.face_list[0].angle.pitch <= -10 ||
          result.result.face_list[0].angle.pitch >= 20) {
            toast_default.a.fail("照片角度不符");
          } else if (
          // result.result.face_list[0].angle.roll <= -20 ||
          result.result.face_list[0].angle.roll >= 20) {
            toast_default.a.fail("照片角度不符");
          } else if (
          //  result.result.face_list[0].angle.yaw <= -20 ||
          result.result.face_list[0].angle.yaw >= 20) {
            toast_default.a.fail("照片角度不符");
          }
          // else if (
          //   result.result.face_list[0].location.width > 850 || result.result.face_list[0].location.height > 850
          // ) {
          //   Toast.fail("请离摄像头远一点");
          // }
          else if (result.result.face_list[0].location.width < 300 || result.result.face_list[0].location.height < 300) {
              toast_default.a.fail("请不要使用全身照");
            } else {
              self.pass = true;
              toast_default.a.success("照片合格");
            }
          if (self.pass == false) {
            self.$refs.userImg.src = '../../../static/image/defaultImg.png';
          }
          this.headerImage = '';
          self.faceList = stringify_default()(result);
          console.log('脸部特征');
          console.log(self.faceList);
        },
        error: function error(result) {
          this.headerImage = '';
          self.pass = false;
          toast_default.a.fail("上传失败,请重新上传");
          console.log(result);
        }
      });
    },

    //
    // 保存
    getSave: function getSave() {
      if (!this.repeatClick) {
        return;
      }
      // 判断必填选是否已选择
      if (this.headerImage == "") {
        toast_default.a.fail("头像不能为空");
      } else if (this.$refs.rename.value == "") {
        toast_default.a.fail("姓名不能为空");
      } else if (this.showuser == "") {
        toast_default.a.fail("请选择关系");
      } else if (this.pass == false) {
        toast_default.a.fail("图片不符合标准");
      } else {
        this.uploading();
      }
    },


    // 全部检测通过后 向服务器上传数据
    uploading: function uploading() {
      //重复点击
      this.repeatClick = false;
      var isPush = "";
      if (this.checked == true) {
        // 推送
        isPush = "1";
      } else {
        isPush = "0";
      }
      toast_default.a.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "添加中..."
      });

      var msgHome = new Object();
      msgHome.comnCode = this.$route.query.comnCode;
      msgHome.hsNo = this.$route.query.hsNo;
      msgHome.relation = this.showuser; // 与我的关系
      msgHome.rename = this.$refs.rename.value; // 成员姓名
      msgHome.authImg = this.headerImage; // 成员照片
      msgHome.telephone = this.$refs.telephone.value; // 联系方式
      msgHome.hsName = this.$route.query.ownersName; // 业主姓名 ownersName  
      msgHome.faceParam = this.faceList; // 数据集
      msgHome.isPush = isPush;
      console.log(msgHome);
      var newUrl = global.host + "guardInfo/addGuardInfo";
      this.$http.post(newUrl, msgHome).then(function (res) {
        console.log("添加后返回");
        console.log(res);
        if (res.body.statusCode == "120") {
          setTimeout(function () {
            toast_default.a.success("网络错误,重新上传");
          }, 1000);
          //重复点击
          this.repeatClick = true;
        } else {
          setTimeout(function () {
            toast_default.a.success(res.body.message);
          }, 1000);
          var this_ = this;
          setTimeout(function () {
            this_.$router.push({
              path: "/accessControl",
              query: {
                ownersName: this_.ownersName,
                hsNo: this_.hsNo,
                comnCode: this_.comnCode,
                openid: this_.$router.history.current.query.openid,
                phone: this_.$router.history.current.query.phone
              }
            });
          }, 2000);
          //重复点击
          this.repeatClick = true;
        }
      }, function (err) {
        //重复点击
        this.repeatClick = true;
        toast_default.a.fail("添加失败,请重试");
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/entrance/Visito.vue













 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var entrance_Visito__components;






/* harmony default export */ var entrance_Visito = ({
  components: (entrance_Visito__components = {
    $: jquery_default.a
  }, defineProperty_default()(entrance_Visito__components, picker_default.a.name, picker_default.a), defineProperty_default()(entrance_Visito__components, popup_default.a.name, popup_default.a), defineProperty_default()(entrance_Visito__components, switch_default.a.name, switch_default.a), defineProperty_default()(entrance_Visito__components, uploader_default.a.name, uploader_default.a), defineProperty_default()(entrance_Visito__components, toast_default.a.name, toast_default.a), defineProperty_default()(entrance_Visito__components, loading_default.a.name, loading_default.a), entrance_Visito__components),
  data: function data() {
    return {
      //防止保存重复点击
      repeatClick: true,
      items: '',
      columns: ["本人", "父母", "子女", "兄妹", "其他"],
      showQR: false,
      checked: false,
      imgUrl: "", // 选择后头像的64位编码
      showuser: "", // 选择联系人后的值 1：亲戚；2：朋友；3：同事；4：其他
      rename: "", // 成员姓名
      headerImage: "", // 图片集合
      picValue: "", // 需要转换的图片
      wuzhImg: "", // 没有转换过的图片64位
      access_token: "", // 百度api的token
      pass: false, // 此参数为true 执行向后台提交的请求 次参数为false 则拦截在百度AI这一层
      faceList: '' // 脸部识别所有的数据
    };
  },

  watch: {
    items: function items() {
      if (this.items.length > 4) {
        this.items = this.items.substring(0, 4);
      }
    }
  },

  beforeMount: function beforeMount() {
    this.getBadToken();
  },
  mounted: function mounted() {
    // this.getBadToken()
    console.log(this.$route.query.hsName); //业主姓名
    console.log(this.$route.query.hsNo); // 房间号
    console.log(this.$route.query.comnCode); // 小区编号
  },

  methods: {
    showUserPicker: function showUserPicker() {
      this.showQR = true;
    },
    onConfirm: function onConfirm(value, index) {
      this.showQR = false;
      this.$refs.showUser.value = value;
      if (value == "本人") {
        this.showuser = "0";
      } else if (value == "父母") {
        this.showuser = "1";
      } else if (value == "子女") {
        this.showuser = "2";
      } else if (value == "兄妹") {
        this.showuser = "4";
      } else if (value == "其他") {
        this.showuser = "5";
      }
    },
    onCancel: function onCancel() {
      this.showQR = false;
    },
    onRead: function onRead(event) {
      // console.log(file.file)
      var image = document.getElementById('img'); //预览对象
      this.clip(event, {
        resultObj: image,
        aspectRatio: 1.1
      });

      console.log(image);
      console.log('qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq');
      //  console.log(this.postImg.imgdataList)
      //  this.postImg()
      // console.log("qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");
      // console.log(file);
      // // 图片转换代码
      // this.$refs.userImg.src = file.content;

      // this.picValue = file.file;
      // this.imgPreview(this.picValue);
    },

    //  新代码  -------------------------------------------------------------------------------------------------------------------------------------------------
    initilize: function initilize(opt) {
      var self = this;
      this.options = opt;
      //创建dom
      this.createElement();
      this.resultObj = opt.resultObj;
      //初始化裁剪对象
      this.cropper = new cropper_default.a(this.preview, {
        aspectRatio: opt.aspectRatio || 1,
        autoCropArea: opt.autoCropArea || 0.8,
        viewMode: 1,
        guides: opt.aspectRatio == 'Free' ? false : true,
        cropBoxResizable: opt.aspectRatio == 'Free' ? false : true,
        cropBoxMovable: opt.aspectRatio == 'Free' ? false : true,
        dragCrop: opt.aspectRatio == 'Free' ? false : true,
        background: false,
        checkOrientation: true,
        checkCrossOrigin: true,
        zoomable: false,
        zoomOnWheel: false,
        center: false,
        toggleDragModeOnDblclick: false,
        ready: function ready() {
          // console.log(self.cropper.rotate(90))
          if (opt.aspectRatio == 'Free') {
            var cropBox = self.cropper.cropBox;
            cropBox.querySelector('span.cropper-view-box').style.outline = 'none';
            self.cropper.disable();
          }
        }
      });
    },
    createElement: function createElement() {
      //初始化图片为空对象
      this.preview = null;

      var str = '<div><img id="clip_image" src="originUrl"></div><button type="button" id="cancel_clip">取消</button><button type="button" id="clip_button">确定</button>';
      str += '<div class="crop_loading"><div class="crop_content"><img src="../static/loading.gif"><div class="crop_text">图片上传中</div></div></div>';
      str += '<div class="crop_success"><div class="crop_success_text">上传成功</div></div></div>';

      var body = document.getElementsByTagName('body')[0];
      this.reagion = document.createElement('div');
      this.reagion.id = 'clip_container';
      this.reagion.className = 'container';
      this.reagion.innerHTML = str;
      //添加创建好的DOM元素
      body.appendChild(this.reagion);
      this.preview = document.getElementById('clip_image');

      //绑定一些方法
      this.initFunction();
    },

    //初始化一些函数绑定
    initFunction: function initFunction() {
      var self = this;
      this.clickBtn = document.getElementById('clip_button');
      this.cancelBtn = document.getElementById('cancel_clip');
      //确定事件
      this.addEvent(this.clickBtn, 'click', function () {
        self.crop();
      });
      //取消事件
      this.addEvent(this.cancelBtn, 'click', function () {
        self.destoried();
      });
      //清空input的值
      this.addEvent(this.fileObj, 'click', function () {
        this.value = '';
      });
    },
    clip: function clip(e, opt) {
      var self = this;

      this.fileObj = e.srcElement;

      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return false; //不是图片直接返回

      //调用初始化方法
      this.initilize(opt);

      //获取图片文件资源
      this.picValue = files[0];

      //去获取拍照时的信息，解决拍出来的照片旋转问题
      // Exif.getData( files[0] , function(){
      //   self.Orientation = Exif.getTag( files[0], 'Orientation');
      //   console.log(self.Orientation)
      // });


      //调用方法转成url格式
      this.originUrl = this.getObjectURL(this.picValue);

      //每次替换图片要重新得到新的url
      if (this.cropper) {
        this.cropper.replace(this.originUrl);
      }
    },

    //图片转码方法
    getObjectURL: function getObjectURL(file) {
      var url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },

    //点击确定进行裁剪
    crop: function crop() {
      toast_default.a.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "识别中..."
      });
      console.log('确定事件确定事件确定事件确定事件确定事件确定事件');
      var self = this;
      var image = new Image();
      var croppedCanvas = void 0;
      var roundedCanvas = void 0;

      // Crop
      document.querySelector('.crop_loading').style.display = 'block';

      setTimeout(function () {
        croppedCanvas = self.cropper.getCroppedCanvas();
        // Round
        roundedCanvas = self.getRoundedCanvas(croppedCanvas);

        var imgData = roundedCanvas.toDataURL();
        image.src = imgData;

        //判断图片是否大于100K,是就直接上传，反之压缩图片
        //       if (this.result.length <= 100 * 1024) {
        //         self.headerImage = this.result;
        //         self.discern();
        //       } else {
        //         img.onload = function() {
        //           let data = self.compress(img, Orientation);
        //           self.headerImage = data;
        //           self.discern();
        //         };
        //判断图片是否大于100k,不大于直接上传，反之压缩
        if (imgData.length < 100 * 1024) {
          self.resultObj.src = imgData;
          self.headerImage = imgData;
          //图片上传
          self.postImg(imgData);
        } else {
          image.onload = function () {
            //压缩处理
            var data = self.compress(image, self.Orientation);
            self.resultObj.src = data;
            //图片上传
            self.headerImage = data;
            self.postImg(data);
          };
        }
      }, 20);
    },

    //获取裁剪图片资源
    getRoundedCanvas: function getRoundedCanvas(sourceCanvas) {

      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      var width = sourceCanvas.width;
      var height = sourceCanvas.height;

      canvas.width = width;
      canvas.height = height;

      context.imageSmoothingEnabled = true;
      context.drawImage(sourceCanvas, 0, 0, width, height);
      context.globalCompositeOperation = 'destination-in';
      context.beginPath();
      context.rect(0, 0, width, height);
      context.fill();

      return canvas;
    },

    //销毁原来的对象
    destoried: function destoried() {
      var self = this;
      //移除事件
      this.removeEvent(this.clickBtn, 'click', null);
      this.removeEvent(this.cancelBtn, 'click', null);
      this.removeEvent(this.fileObj, 'click', null);
      //移除裁剪框
      this.reagion.parentNode.removeChild(this.reagion);

      //销毁裁剪对象
      this.cropper.destroy();
      this.cropper = null;
    },

    //图片上传
    postImg: function postImg(imageData) {
      this.discern();
      //这边写图片的上传
      var self = this;
      self.destoried();
      console.log('图片上传图片上传图片上传图片上传图片上传图片上传');
      var imgdataList = imageData;
      console.log(imageData);
      window.setTimeout(function () {
        document.querySelector('.crop_loading').style.display = 'none';
        document.querySelector('.crop_success').style.display = 'block';
        //裁剪完后摧毁对象
        self.destoried();
      }, 3000);
    },


    //图片旋转
    rotateImg: function rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      var min_step = 0;
      var max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      var height = img.height;
      var width = img.width;
      var step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == 'right') {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      var degree = step * 90 * Math.PI / 180;
      var ctx = canvas.getContext('2d');
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },


    //图片压缩
    compress: function compress(img, Orientation) {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext('2d');
      //瓦片canvas
      var tCanvas = document.createElement("canvas");
      var tctx = tCanvas.getContext("2d");
      var initSize = img.src.length;
      var width = img.width;
      var height = img.height;

      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      var ratio = void 0;
      if ((ratio = width * height / 4000000) > 1) {
        console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      var count = void 0;
      if ((count = width * height / 1000000) > 1) {
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        var nw = ~~(width / count);
        var nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (var i = 0; i < count; i++) {
          for (var j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6:
            //需要顺时针（向左）90度旋转
            this.rotateImg(img, 'left', canvas);
            break;
          case 8:
            //需要逆时针（向右）90度旋转
            this.rotateImg(img, 'right', canvas);
            break;
          case 3:
            //需要180度旋转
            this.rotateImg(img, 'right', canvas); //转两次
            this.rotateImg(img, 'right', canvas);
            break;
        }
      }
      //进行最小压缩
      var ndata = canvas.toDataURL('image/jpeg', 0.1);
      console.log('压缩前：' + initSize);
      console.log('压缩后：' + ndata.length);
      console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + "%");
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;

      return ndata;
    },


    //添加事件
    addEvent: function addEvent(obj, type, fn) {
      if (obj.addEventListener) {
        obj.addEventListener(type, fn, false);
      } else {
        obj.attachEvent('on' + type, fn);
      }
    },

    //移除事件
    removeEvent: function removeEvent(obj, type, fn) {
      if (obj.removeEventListener) {
        obj.removeEventListener(type, fn, false);
      } else {
        obj.detachEvent('on' + type, fn);
      }
    },


    //  新代码 end-------------------------------------------------------------------------------------------------------------------------------------------------------------
    // 图片压缩
    // imgPreview(file) {
    //   let self = this;
    //   let Orientation;
    //   //去获取拍照时的信息，解决拍出来的照片旋转问题
    //   Exif.getData(file, function() {
    //     Orientation = Exif.getTag(this, "Orientation");
    //   });
    //   // 看支持不支持FileReader
    //   if (!file || !window.FileReader) return;

    //   if (/^image/.test(file.type)) {
    //     // 创建一个reader
    //     let reader = new FileReader();
    //     // 将图片2将转成 base64 格式
    //     reader.readAsDataURL(file);
    //     // 读取成功后的回调
    //     reader.onloadend = function() {
    //       let result = this.result;
    //       let img = new Image();
    //       img.src = result;
    //       //判断图片是否大于100K,是就直接上传，反之压缩图片
    //       if (this.result.length <= 100 * 1024) {
    //         self.headerImage = this.result;
    //         self.discern();
    //       } else {
    //         img.onload = function() {
    //           let data = self.compress(img, Orientation);
    //           self.headerImage = data;
    //           self.discern();
    //         };
    //       }
    //     };
    //   }
    // },
    // compress(img, Orientation) {
    //   let canvas = document.createElement("canvas");
    //   let ctx = canvas.getContext("2d");
    //   //瓦片canvas
    //   let tCanvas = document.createElement("canvas");
    //   let tctx = tCanvas.getContext("2d");
    //   let initSize = img.src.length;
    //   let width = img.width;
    //   let height = img.height;
    //   //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
    //   let ratio;
    //   if ((ratio = (width * height) / 4000000) > 1) {
    //     console.log("大于400万像素");
    //     ratio = Math.sqrt(ratio);
    //     width /= ratio;
    //     height /= ratio;
    //   } else {
    //     ratio = 1;
    //   }
    //   canvas.width = width;
    //   canvas.height = height;
    //   //        铺底色
    //   // ctx.fillStyle = "#fff";
    //   ctx.fillRect(0, 0, canvas.width, canvas.height);
    //   //如果图片像素大于100万则使用瓦片绘制
    //   let count;
    //   if ((count = (width * height) / 1000000) > 1) {
    //     console.log("超过100W像素");
    //     count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
    //     //            计算每块瓦片的宽和高
    //     let nw = ~~(width / count);
    //     let nh = ~~(height / count);
    //     tCanvas.width = nw;
    //     tCanvas.height = nh;
    //     for (let i = 0; i < count; i++) {
    //       for (let j = 0; j < count; j++) {
    //         tctx.drawImage(
    //           img,
    //           i * nw * ratio,
    //           j * nh * ratio,
    //           nw * ratio,
    //           nh * ratio,
    //           0,
    //           0,
    //           nw,
    //           nh
    //         );
    //         ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
    //       }
    //     }
    //   } else {
    //     ctx.drawImage(img, 0, 0, width, height);
    //   }
    //   //修复ios上传图片的时候 被旋转的问题
    //   if (Orientation != "" && Orientation != 1) {
    //     switch (Orientation) {
    //       case 6: //需要顺时针（向左）90度旋转
    //         this.rotateImg(img, "left", canvas);
    //         break;
    //       case 8: //需要逆时针（向右）90度旋转
    //         this.rotateImg(img, "right", canvas);
    //         break;
    //       case 3: //需要180度旋转
    //         this.rotateImg(img, "right", canvas); //转两次
    //         this.rotateImg(img, "right", canvas);
    //         break;
    //     }
    //   }
    //   //进行最小压缩
    //   let ndata = canvas.toDataURL("image/jpeg", 0.1);
    //   console.log("压缩前：" + initSize);
    //   console.log("压缩后：" + ndata.length);
    //   console.log(
    //     "压缩率：" + ~~((100 * (initSize - ndata.length)) / initSize) + "%"
    //   );
    //   tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
    //   return ndata;
    // },
    // rotateImg(img, direction, canvas) {
    //   //最小与最大旋转方向，图片旋转4次后回到原方向
    //   const min_step = 0;
    //   const max_step = 3;
    //   if (img == null) return;
    //   //img的高度和宽度不能在img元素隐藏后获取，否则会出错
    //   let height = img.height;
    //   let width = img.width;
    //   let step = 2;
    //   if (step == null) {
    //     step = min_step;
    //   }
    //   if (direction == "right") {
    //     step++;
    //     //旋转到原位置，即超过最大值
    //     step > max_step && (step = min_step);
    //   } else {
    //     step--;
    //     step < min_step && (step = max_step);
    //   }
    //   //旋转角度以弧度值为参数
    //   let degree = (step * 90 * Math.PI) / 180;
    //   let ctx = canvas.getContext("2d");
    //   switch (step) {
    //     case 0:
    //       canvas.width = width;
    //       canvas.height = height;
    //       ctx.drawImage(img, 0, 0);
    //       break;
    //     case 1:
    //       canvas.width = height;
    //       canvas.height = width;
    //       ctx.rotate(degree);
    //       ctx.drawImage(img, 0, -height);
    //       break;
    //     case 2:
    //       canvas.width = width;
    //       canvas.height = height;
    //       ctx.rotate(degree);
    //       ctx.drawImage(img, -width, -height);
    //       break;
    //     case 3:
    //       canvas.width = height;
    //       canvas.height = width;
    //       ctx.rotate(degree);
    //       ctx.drawImage(img, -width, 0);
    //       break;
    //   }
    // },
    // 调用百度api 获取token
    getBadToken: function getBadToken() {
      // 百度api
      // /BD 配置在config index.js文件内做跨域处理
      console.log("调用百度api token");
      this.$http.post(global.host + "/face/aip/access_token.json").then(function (res) {
        console.log("新的token新的token新的token新的token新的token新的token");
        console.log(res);
        this.access_token = res.body.access_token;
        console.log(this.access_token);
      }, function (err) {
        console.log("人脸识别token获取失败");
        console.log(err);
      });
    },

    // 唤起人脸识别检测接口
    discern: function discern() {
      this.pass = false;
      // this.headerImage = '',
      console.log("唤起人脸识别检测接口");
      // console.log(this.headerImage)
      console.log(this.headerImage);
      var strIng = this.headerImage.indexOf(",");
      var result = this.headerImage.substr(strIng + 1, this.headerImage.length);
      // console.log(result)
      var self = this;
      jquery_default.a.ajax({
        type: "post",
        url: "https://aip.baidubce.com/rest/2.0/face/v3/detect?access_token=" + this.access_token,
        data: {
          image: result,
          image_type: "BASE64",
          face_field: "angel,quality,face_type,glasses,gender,age,face_token,eye_status,race,landmark,",
          max_face_num: "2"
        },
        dataType: "json",
        crossDomain: true,
        success: function success(result) {
          console.log("百度AI调用成功返回参数");
          console.log(result);
          if (result.error_code == "222202") {
            toast_default.a.fail("图片中没有人脸");
          } else if (result.error_code == "222203") {
            toast_default.a.fail("无法解析人脸");
          } else if (result.error_code == "223114") {
            toast_default.a.fail("人脸模糊");
          } else if (result.error_code == "223115") {
            toast_default.a.fail("人脸光照不好");
          } else if (result.result.face_list[0].face_type.type == "cartoon") {
            toast_default.a.fail("请上传真实人脸");
          } else if (result.result.face_list[0].face_type.probability <= "0.85") {
            toast_default.a.fail("请不要使用美颜拍照");
          } else if (result.result.face_list[0].quality.completeness != "1") {
            toast_default.a.fail("人脸不完整");
          } else if (result.result.face_list[0].face_probability != "1") {
            toast_default.a.fail("人脸模糊");
          } else if (result.result.face_list[0].quality.blur != "0") {
            toast_default.a.fail("相片不够清晰");
          } else if (result.result.face_list[0].quality.completeness != "1") {
            toast_default.a.fail("人脸不够完整");
          } else if (result.result.face_list[0].quality.illumination < 70) {
            toast_default.a.fail("光照太弱");
          } else if (result.result.face_list[0].quality.occlusion.chin_contour > "0.4") {
            toast_default.a.fail("下巴被遮挡");
          } else if (result.result.face_list[0].location.rotation < -50 || result.result.face_list[0].location.rotation > 50) {
            toast_default.a.fail("照片角度不符");
          } else if (result.result.face_list[0].quality.occlusion.left_cheek > "0.4") {
            toast_default.a.fail("左脸颊被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.left_eye > "0.4") {
            toast_default.a.fail("左眼被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.mouth > "0.4") {
            toast_default.a.fail("嘴巴被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.nose > "0.4") {
            toast_default.a.fail("鼻子被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.right_cheek > "0.4") {
            toast_default.a.fail("右脸颊被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.right_eye > "0.4") {
            toast_default.a.fail("右眼被遮挡");
          } else if (result.result.face_num > "1") {
            toast_default.a.fail("请单人拍照");
          } else if (result.result.face_list[0].glasses.type != "none") {
            toast_default.a.fail("请摘下眼镜");
          } else if (result.result.face_list[0].eye_status.left_eye != "1" && result.result.face_list[0].eye_status.right_eye != "1") {
            toast_default.a.fail("请睁开眼睛拍照");
          } else if (
          // result.result.face_list[0].angle.pitch <= -10 ||
          result.result.face_list[0].angle.pitch >= 20) {
            toast_default.a.fail("照片角度不符");
          } else if (
          // result.result.face_list[0].angle.roll <= -20 ||
          result.result.face_list[0].angle.roll >= 20) {
            toast_default.a.fail("照片角度不符");
          } else if (
          //  result.result.face_list[0].angle.yaw <= -20 ||
          result.result.face_list[0].angle.yaw >= 20) {
            toast_default.a.fail("照片角度不符");
          }
          // else if (
          //   result.result.face_list[0].location.width > 850 || result.result.face_list[0].location.height > 850
          // ) {
          //   Toast.fail("请离摄像头远一点");
          // }
          else if (result.result.face_list[0].location.width < 300 || result.result.face_list[0].location.height < 300) {
              toast_default.a.fail("请不要使用全身照");
            } else {
              self.pass = true;
              toast_default.a.success("照片合格");
            }
          if (self.pass == false) {
            self.$refs.userImg.src = '../../../static/image/defaultImg.png';
          }
          this.headerImage = '';
          self.faceList = stringify_default()(result);
          console.log('脸部特征');
          console.log(self.faceList);
        },
        error: function error(result) {
          this.headerImage = '';
          self.pass = false;
          toast_default.a.fail("上传失败,请重新上传");
          console.log(result);
        }
      });
    },

    //
    // 保存
    getSave: function getSave() {
      if (!this.repeatClick) {
        return;
      }
      // 判断必填选是否已选择
      if (this.headerImage == "") {
        toast_default.a.fail("头像不能为空");
      } else if (this.$refs.rename.value == "") {
        toast_default.a.fail("姓名不能为空");
      } else if (this.showuser == "") {
        toast_default.a.fail("请选择关系");
      } else if (this.pass == false) {
        toast_default.a.fail("图片不符合标准");
      } else {
        this.uploading();
      }
    },


    // 全部检测通过后 向服务器上传数据
    uploading: function uploading() {
      //重复点击
      this.repeatClick = false;
      var isPush = "";
      if (this.checked == true) {
        // 推送
        isPush = "1";
      } else {
        isPush = "0";
      }
      toast_default.a.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "添加中..."
      });

      var msgHome = new Object();
      msgHome.comnCode = this.$route.query.comnCode;
      msgHome.hsNo = this.$route.query.hsNo;
      msgHome.relation = this.showuser; // 与我的关系
      msgHome.rename = this.$refs.rename.value; // 成员姓名
      msgHome.authImg = this.headerImage; // 成员照片
      msgHome.telephone = this.$refs.telephone.value; // 联系方式
      msgHome.hsName = this.$route.query.ownersName; // 业主姓名 ownersName  
      msgHome.faceParam = this.faceList; // 数据集
      msgHome.isPush = isPush;
      console.log(msgHome);
      var newUrl = global.host + "guardInfo/addGuardInfo";
      this.$http.post(newUrl, msgHome).then(function (res) {
        console.log("添加后返回");
        console.log(res);
        if (res.body.statusCode == "120") {
          setTimeout(function () {
            toast_default.a.success("网络错误,重新上传");
          }, 1000);
          //重复点击
          this.repeatClick = true;
        } else {
          setTimeout(function () {
            toast_default.a.success(res.body.message);
          }, 1000);
          var this_ = this;
          setTimeout(function () {
            this_.$router.push({
              path: "/accessControl",
              query: {
                ownersName: this_.ownersName,
                hsNo: this_.hsNo,
                comnCode: this_.comnCode,
                openid: this_.$router.history.current.query.openid,
                phone: this_.$router.history.current.query.phone
              }
            });
          }, 2000);
          //重复点击
          this.repeatClick = true;
        }
      }, function (err) {
        //重复点击
        this.repeatClick = true;
        toast_default.a.fail("添加失败,请重试");
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d81a78d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/entrance/Visito.vue
var Visito_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"addFamily"}},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"updataBox",attrs:{"id":"headimg"}},[_c('div',{staticClass:"updataImg"},[_c('img',{ref:"userImg",staticClass:"userImg response",attrs:{"id":"img","src":__webpack_require__("AHIP")}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('input',{attrs:{"type":"file","accept":"image/png,image/jpg,image/jpeg"},on:{"change":function($event){_vm.onRead($event)}}})]),_vm._v(" "),_c('p',[_vm._v("上传头像")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('section',[_c('span',[_vm._v("家属姓名：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.items),expression:"items"}],ref:"rename",staticClass:"input",attrs:{"id":"nickName","type":"text","placeholder":"请输入姓名(最多四个字)"},domProps:{"value":(_vm.items)},on:{"input":function($event){if($event.target.composing){ return; }_vm.items=$event.target.value}}})]),_vm._v(" "),_c('section',[_c('span',[_vm._v("联系方式")]),_vm._v(" "),_c('input',{ref:"telephone",staticClass:"input",attrs:{"id":"telephone","type":"text","placeholder":"请输入联系方式"}})]),_vm._v(" "),_c('section',{staticClass:"choose"},[_c('span',[_vm._v("与我的关系：")]),_vm._v(" "),_c('input',{ref:"showUser",staticClass:"input",attrs:{"id":"showUserPicker","readonly":"readonly","type":"text","placeholder":"请选择"},on:{"click":function($event){_vm.showUserPicker()}}})]),_vm._v(" "),_c('section',[_c('span',[_vm._v("是否推送消息：")]),_vm._v(" "),_c('van-switch',{attrs:{"active-color":"#4cd964","inactive-color":"#fff"},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)]),_vm._v(" "),_c('div',{staticClass:"footFix",on:{"click":function($event){_vm.getSave()}}},[_c('span',{staticClass:"confirmBtn btn"},[_vm._v("保存")])])]),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showQR),callback:function ($$v) {_vm.showQR=$$v},expression:"showQR"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"","columns":_vm.columns},on:{"cancel":_vm.onCancel,"confirm":_vm.onConfirm}})],1)],1)}
var Visito_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ico"},[_c('img',{staticClass:"response ico_img",attrs:{"src":__webpack_require__("+F4+")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warning"},[_c('div',[_vm._v("上传须知:")]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("※1.真实拍摄的单人照片且不能佩戴眼镜")]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("※2.五官清晰、完整不能有遮挡且光照充足")])])}]
var Visito_esExports = { render: Visito_render, staticRenderFns: Visito_staticRenderFns }
/* harmony default export */ var components_entrance_Visito = (Visito_esExports);
// CONCATENATED MODULE: ./src/components/entrance/Visito.vue
function Visito_injectStyle (ssrContext) {
  __webpack_require__("Xw0J")
}
var Visito_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Visito___vue_template_functional__ = false
/* styles */
var Visito___vue_styles__ = Visito_injectStyle
/* scopeId */
var Visito___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Visito___vue_module_identifier__ = null
var Visito_Component = Visito_normalizeComponent(
  entrance_Visito,
  components_entrance_Visito,
  Visito___vue_template_functional__,
  Visito___vue_styles__,
  Visito___vue_scopeId__,
  Visito___vue_module_identifier__
)

/* harmony default export */ var src_components_entrance_Visito = (Visito_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/entrance/addFamily.vue













 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var addFamily__components;




/* harmony default export */ var addFamily = ({
  components: (addFamily__components = {
    $: jquery_default.a
  }, defineProperty_default()(addFamily__components, picker_default.a.name, picker_default.a), defineProperty_default()(addFamily__components, popup_default.a.name, popup_default.a), defineProperty_default()(addFamily__components, switch_default.a.name, switch_default.a), defineProperty_default()(addFamily__components, uploader_default.a.name, uploader_default.a), defineProperty_default()(addFamily__components, toast_default.a.name, toast_default.a), defineProperty_default()(addFamily__components, loading_default.a.name, loading_default.a), addFamily__components),
  data: function data() {
    return {
      //防止保存重复点击
      repeatClick: true,
      items: '',
      columns: ["本人", "父母", "子女", "兄妹", "其他"],
      showQR: false,
      checked: false,
      imgUrl: "", // 选择后头像的64位编码
      showuser: "", // 选择联系人后的值 1：亲戚；2：朋友；3：同事；4：其他
      rename: "", // 成员姓名
      headerImage: "", // 图片集合
      picValue: "", // 需要转换的图片
      wuzhImg: "", // 没有转换过的图片64位
      access_token: "", // 百度api的token
      pass: false, // 此参数为true 执行向后台提交的请求 次参数为false 则拦截在百度AI这一层
      faceList: '' // 脸部识别所有的数据
    };
  },

  watch: {
    items: function items() {
      if (this.items.length > 4) {
        this.items = this.items.substring(0, 4);
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getBadToken();
  },
  mounted: function mounted() {
    // this.getBadToken()
    console.log(this.$route.query.hsName); //业主姓名
    console.log(this.$route.query.hsNo); // 房间号
    console.log(this.$route.query.comnCode); // 小区编号
  },

  methods: {
    showUserPicker: function showUserPicker() {
      this.showQR = true;
    },
    onConfirm: function onConfirm(value, index) {
      this.showQR = false;
      this.$refs.showUser.value = value;
      if (value == "本人") {
        this.showuser = "0";
      } else if (value == "夫妻") {
        this.showuser = "0";
      } else if (value == "父母") {
        this.showuser = "1";
      } else if (value == "子女") {
        this.showuser = "2";
      } else if (value == "兄妹") {
        this.showuser = "4";
      } else if (value == "其他") {
        this.showuser = "5";
      }
    },
    onCancel: function onCancel() {
      this.showQR = false;
    },
    onRead: function onRead(file) {
      console.log("qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");
      console.log(file);
      // 图片转换代码
      this.$refs.userImg.src = file.content;
      // this.wuzhImg = file.content;
      this.picValue = file.file;
      this.imgPreview(this.picValue);
      toast_default.a.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "识别中..."
      });
    },


    // 图片压缩
    imgPreview: function imgPreview(file) {
      var self = this;
      var Orientation = void 0;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      exif_default.a.getData(file, function () {
        Orientation = exif_default.a.getTag(this, "Orientation");
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;

      if (/^image/.test(file.type)) {
        // 创建一个reader
        var reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          var result = this.result;
          var img = new Image();
          img.src = result;
          //判断图片是否大于100K,是就直接上传，反之压缩图片
          if (this.result.length <= 100 * 1024) {
            self.headerImage = this.result;
            self.discern();
          } else {
            img.onload = function () {
              var data = self.compress(img, Orientation);
              self.headerImage = data;
              self.discern();
            };
          }
        };
      }
    },
    compress: function compress(img, Orientation) {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      //瓦片canvas
      var tCanvas = document.createElement("canvas");
      var tctx = tCanvas.getContext("2d");
      var initSize = img.src.length;
      var width = img.width;
      var height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      var ratio = void 0;
      if ((ratio = width * height / 4000000) > 1) {
        console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      // ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      var count = void 0;
      if ((count = width * height / 1000000) > 1) {
        console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        var nw = ~~(width / count);
        var nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (var i = 0; i < count; i++) {
          for (var j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6:
            //需要顺时针（向左）90度旋转
            this.rotateImg(img, "left", canvas);
            break;
          case 8:
            //需要逆时针（向右）90度旋转
            this.rotateImg(img, "right", canvas);
            break;
          case 3:
            //需要180度旋转
            this.rotateImg(img, "right", canvas); //转两次
            this.rotateImg(img, "right", canvas);
            break;
        }
      }
      //进行最小压缩
      var ndata = canvas.toDataURL("image/jpeg", 0.1);
      console.log("压缩前：" + initSize);
      console.log("压缩后：" + ndata.length);
      console.log("压缩率：" + ~~(100 * (initSize - ndata.length) / initSize) + "%");
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    rotateImg: function rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      var min_step = 0;
      var max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      var height = img.height;
      var width = img.width;
      var step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == "right") {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      var degree = step * 90 * Math.PI / 180;
      var ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },

    // 调用百度api 获取token
    getBadToken: function getBadToken() {
      // 百度api
      // /BD 配置在config index.js文件内做跨域处理
      console.log("调用百度api token");
      this.$http.post(global.host + "/face/aip/access_token.json").then(function (res) {
        console.log("新的token新的token新的token新的token新的token新的token");
        console.log(res);
        this.access_token = res.body.access_token;
        console.log(this.access_token);
      }, function (err) {
        console.log("人脸识别token获取失败");
        console.log(err);
      });
    },

    // 唤起人脸识别检测接口
    discern: function discern() {
      this.pass = false;
      console.log("唤起人脸识别检测接口");
      // console.log(this.headerImage)
      var strIng = this.headerImage.indexOf(",");
      var result = this.headerImage.substr(strIng + 1, this.headerImage.length);
      //  console.log(result)
      var self = this;
      jquery_default.a.ajax({
        type: "post",
        url: "https://aip.baidubce.com/rest/2.0/face/v3/detect?access_token=" + this.access_token,
        data: {
          image: result,
          image_type: "BASE64",
          face_field: "angel,quality,face_type,glasses,gender,age,face_token,eye_status,race,landmark,",
          max_face_num: "2"
        },
        dataType: "json",
        crossDomain: true,
        success: function success(result) {
          console.log("百度AI调用成功返回参数");
          console.log(result);
          if (result.error_code == "222202") {
            toast_default.a.fail("图片中没有人脸");
          } else if (result.error_code == "222203") {
            toast_default.a.fail("无法解析人脸");
          } else if (result.error_code == "223114") {
            toast_default.a.fail("人脸模糊");
          } else if (result.error_code == "223115") {
            toast_default.a.fail("人脸光照不好");
          } else if (result.result.face_list[0].face_type.type == "cartoon") {
            toast_default.a.fail("请上传真实人脸");
          } else if (result.result.face_list[0].face_type.probability <= "0.85") {
            toast_default.a.fail("请不要使用美颜拍照");
          } else if (result.result.face_list[0].quality.completeness != "1") {
            toast_default.a.fail("人脸不完整");
          } else if (result.result.face_list[0].face_probability != "1") {
            toast_default.a.fail("人脸模糊");
          } else if (result.result.face_list[0].quality.blur != "0") {
            toast_default.a.fail("相片不够清晰");
          } else if (result.result.face_list[0].quality.completeness != "1") {
            toast_default.a.fail("人脸不够完整");
          } else if (result.result.face_list[0].quality.illumination < 70) {
            toast_default.a.fail("光照太弱");
          } else if (result.result.face_list[0].quality.occlusion.chin_contour > "0.4") {
            toast_default.a.fail("下巴被遮挡");
          } else if (result.result.face_list[0].location.rotation < -50 || result.result.face_list[0].location.rotation > 50) {
            toast_default.a.fail("照片角度不符");
          } else if (result.result.face_list[0].quality.occlusion.left_cheek > "0.4") {
            toast_default.a.fail("左脸颊被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.left_eye > "0.4") {
            toast_default.a.fail("左眼被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.mouth > "0.4") {
            toast_default.a.fail("嘴巴被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.nose > "0.4") {
            toast_default.a.fail("鼻子被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.right_cheek > "0.4") {
            toast_default.a.fail("右脸颊被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.right_eye > "0.4") {
            toast_default.a.fail("右眼被遮挡");
          } else if (result.result.face_num > "1") {
            toast_default.a.fail("请单人拍照");
          } else if (result.result.face_list[0].glasses.type != "none") {
            toast_default.a.fail("请摘下眼镜");
          } else if (result.result.face_list[0].eye_status.left_eye != "1" && result.result.face_list[0].eye_status.right_eye != "1") {
            toast_default.a.fail("请睁开眼睛拍照");
          } else if (
          // result.result.face_list[0].angle.pitch <= -10 ||
          result.result.face_list[0].angle.pitch >= 20) {
            toast_default.a.fail("照片角度不符");
          } else if (
          // result.result.face_list[0].angle.roll <= -20 ||
          result.result.face_list[0].angle.roll >= 20) {
            toast_default.a.fail("照片角度不符");
          } else if (
          //  result.result.face_list[0].angle.yaw <= -20 ||
          result.result.face_list[0].angle.yaw >= 20) {
            toast_default.a.fail("照片角度不符");
          }
          // else if (
          //   result.result.face_list[0].location.width > 850 || result.result.face_list[0].location.height > 850
          // ) {
          //   Toast.fail("请离摄像头远一点");
          // }
          else if (result.result.face_list[0].location.width < 200 || result.result.face_list[0].location.height < 200) {
              toast_default.a.fail("请不要使用全身照");
            } else {
              self.pass = true;
              toast_default.a.success("照片合格");
            }
          if (self.pass == false) {
            self.$refs.userImg.src = '../../../static/image/defaultImg.png';
          }
          this.headerImage = '';
          self.faceList = stringify_default()(result);
          console.log('脸部特征');
          console.log(self.faceList);
        },
        error: function error(result) {
          this.headerImage = '';
          self.pass = false;
          toast_default.a.fail("上传失败,请重新上传");
          console.log(result);
        }
      });
    },

    //
    // 保存
    getSave: function getSave() {
      if (!this.repeatClick) {
        return;
      }
      // 判断必填选是否已选择
      if (this.headerImage == "") {
        toast_default.a.fail("头像不能为空");
      } else if (this.$refs.rename.value == "") {
        toast_default.a.fail("姓名不能为空");
      } else if (this.showuser == "") {
        toast_default.a.fail("请选择关系");
      } else if (this.pass == false) {
        toast_default.a.fail("图片不符合标准");
      } else {
        this.uploading();
      }
    },


    // 全部检测通过后 向服务器上传数据
    uploading: function uploading() {
      //重复点击
      this.repeatClick = false;
      var isPush = "";
      if (this.checked == true) {
        // 推送
        isPush = "1";
      } else {
        isPush = "0";
      }
      toast_default.a.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "添加中..."
      });
      if (this.$refs.rename.value.length > 4) {
        toast_default()('姓名长度不能超过4个字');
        //重复点击
        this.repeatClick = true;
        return;
      }
      var regRule = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
      if (this.$refs.rename.value.match(regRule)) {
        toast_default()('不支持表情');
        //重复点击
        this.repeatClick = true;
        return;
      }

      var msgHome = new Object();
      msgHome.comnCode = this.$route.query.comnCode;
      msgHome.phone = this.$router.history.current.query.phone;
      msgHome.hsNo = this.$route.query.hsNo;
      msgHome.relation = this.showuser; // 与我的关系
      msgHome.rename = this.$refs.rename.value; // 成员姓名
      msgHome.authImg = this.headerImage; // 成员照片
      msgHome.telephone = this.$refs.telephone.value; // 联系方式
      msgHome.hsName = this.$route.query.ownersName; // 业主姓名 ownersName
      msgHome.faceParam = this.faceList; // 数据集
      msgHome.isPush = isPush;
      console.log(msgHome);
      var newUrl = global.host + "guardInfo/addGuardInfo";
      this.$http.post(newUrl, msgHome).then(function (res) {
        console.log("添加后返回");
        console.log(res);
        if (res.body.statusCode == "120") {
          setTimeout(function () {
            toast_default.a.success("网络错误,重新上传");
          }, 1000);
          //重复点击
          this.repeatClick = true;
        } else {
          setTimeout(function () {
            toast_default.a.success(res.body.message);
          }, 1000);
          var this_ = this;
          setTimeout(function () {
            this_.$router.push({
              path: "/accessControl",
              query: {
                ownersName: this_.ownersName,
                hsNo: this_.hsNo,
                comnCode: this_.comnCode,
                openid: this_.$router.history.current.query.openid,
                phone: this_.$router.history.current.query.phone
              }
            });
          }, 2000);
          //重复点击
          this.repeatClick = true;
        }
      }, function (err) {
        //重复点击
        this.repeatClick = true;
        toast_default.a.fail("添加失败,请重试");
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/entrance/addFamily.vue













 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var entrance_addFamily__components;




/* harmony default export */ var entrance_addFamily = ({
  components: (entrance_addFamily__components = {
    $: jquery_default.a
  }, defineProperty_default()(entrance_addFamily__components, picker_default.a.name, picker_default.a), defineProperty_default()(entrance_addFamily__components, popup_default.a.name, popup_default.a), defineProperty_default()(entrance_addFamily__components, switch_default.a.name, switch_default.a), defineProperty_default()(entrance_addFamily__components, uploader_default.a.name, uploader_default.a), defineProperty_default()(entrance_addFamily__components, toast_default.a.name, toast_default.a), defineProperty_default()(entrance_addFamily__components, loading_default.a.name, loading_default.a), entrance_addFamily__components),
  data: function data() {
    return {
      //防止保存重复点击
      repeatClick: true,
      items: '',
      columns: ["本人", "父母", "子女", "兄妹", "其他"],
      showQR: false,
      checked: false,
      imgUrl: "", // 选择后头像的64位编码
      showuser: "", // 选择联系人后的值 1：亲戚；2：朋友；3：同事；4：其他
      rename: "", // 成员姓名
      headerImage: "", // 图片集合
      picValue: "", // 需要转换的图片
      wuzhImg: "", // 没有转换过的图片64位
      access_token: "", // 百度api的token
      pass: false, // 此参数为true 执行向后台提交的请求 次参数为false 则拦截在百度AI这一层
      faceList: '' // 脸部识别所有的数据
    };
  },

  watch: {
    items: function items() {
      if (this.items.length > 4) {
        this.items = this.items.substring(0, 4);
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getBadToken();
  },
  mounted: function mounted() {
    // this.getBadToken()
    console.log(this.$route.query.hsName); //业主姓名
    console.log(this.$route.query.hsNo); // 房间号
    console.log(this.$route.query.comnCode); // 小区编号
  },

  methods: {
    showUserPicker: function showUserPicker() {
      this.showQR = true;
    },
    onConfirm: function onConfirm(value, index) {
      this.showQR = false;
      this.$refs.showUser.value = value;
      if (value == "本人") {
        this.showuser = "0";
      } else if (value == "夫妻") {
        this.showuser = "0";
      } else if (value == "父母") {
        this.showuser = "1";
      } else if (value == "子女") {
        this.showuser = "2";
      } else if (value == "兄妹") {
        this.showuser = "4";
      } else if (value == "其他") {
        this.showuser = "5";
      }
    },
    onCancel: function onCancel() {
      this.showQR = false;
    },
    onRead: function onRead(file) {
      console.log("qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");
      console.log(file);
      // 图片转换代码
      this.$refs.userImg.src = file.content;
      // this.wuzhImg = file.content;
      this.picValue = file.file;
      this.imgPreview(this.picValue);
      toast_default.a.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "识别中..."
      });
    },


    // 图片压缩
    imgPreview: function imgPreview(file) {
      var self = this;
      var Orientation = void 0;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      exif_default.a.getData(file, function () {
        Orientation = exif_default.a.getTag(this, "Orientation");
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;

      if (/^image/.test(file.type)) {
        // 创建一个reader
        var reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          var result = this.result;
          var img = new Image();
          img.src = result;
          //判断图片是否大于100K,是就直接上传，反之压缩图片
          if (this.result.length <= 100 * 1024) {
            self.headerImage = this.result;
            self.discern();
          } else {
            img.onload = function () {
              var data = self.compress(img, Orientation);
              self.headerImage = data;
              self.discern();
            };
          }
        };
      }
    },
    compress: function compress(img, Orientation) {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      //瓦片canvas
      var tCanvas = document.createElement("canvas");
      var tctx = tCanvas.getContext("2d");
      var initSize = img.src.length;
      var width = img.width;
      var height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      var ratio = void 0;
      if ((ratio = width * height / 4000000) > 1) {
        console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      // ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      var count = void 0;
      if ((count = width * height / 1000000) > 1) {
        console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        var nw = ~~(width / count);
        var nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (var i = 0; i < count; i++) {
          for (var j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6:
            //需要顺时针（向左）90度旋转
            this.rotateImg(img, "left", canvas);
            break;
          case 8:
            //需要逆时针（向右）90度旋转
            this.rotateImg(img, "right", canvas);
            break;
          case 3:
            //需要180度旋转
            this.rotateImg(img, "right", canvas); //转两次
            this.rotateImg(img, "right", canvas);
            break;
        }
      }
      //进行最小压缩
      var ndata = canvas.toDataURL("image/jpeg", 0.1);
      console.log("压缩前：" + initSize);
      console.log("压缩后：" + ndata.length);
      console.log("压缩率：" + ~~(100 * (initSize - ndata.length) / initSize) + "%");
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    rotateImg: function rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      var min_step = 0;
      var max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      var height = img.height;
      var width = img.width;
      var step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == "right") {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      var degree = step * 90 * Math.PI / 180;
      var ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },

    // 调用百度api 获取token
    getBadToken: function getBadToken() {
      // 百度api
      // /BD 配置在config index.js文件内做跨域处理
      console.log("调用百度api token");
      this.$http.post(global.host + "/face/aip/access_token.json").then(function (res) {
        console.log("新的token新的token新的token新的token新的token新的token");
        console.log(res);
        this.access_token = res.body.access_token;
        console.log(this.access_token);
      }, function (err) {
        console.log("人脸识别token获取失败");
        console.log(err);
      });
    },

    // 唤起人脸识别检测接口
    discern: function discern() {
      this.pass = false;
      console.log("唤起人脸识别检测接口");
      // console.log(this.headerImage)
      var strIng = this.headerImage.indexOf(",");
      var result = this.headerImage.substr(strIng + 1, this.headerImage.length);
      //  console.log(result)
      var self = this;
      jquery_default.a.ajax({
        type: "post",
        url: "https://aip.baidubce.com/rest/2.0/face/v3/detect?access_token=" + this.access_token,
        data: {
          image: result,
          image_type: "BASE64",
          face_field: "angel,quality,face_type,glasses,gender,age,face_token,eye_status,race,landmark,",
          max_face_num: "2"
        },
        dataType: "json",
        crossDomain: true,
        success: function success(result) {
          console.log("百度AI调用成功返回参数");
          console.log(result);
          if (result.error_code == "222202") {
            toast_default.a.fail("图片中没有人脸");
          } else if (result.error_code == "222203") {
            toast_default.a.fail("无法解析人脸");
          } else if (result.error_code == "223114") {
            toast_default.a.fail("人脸模糊");
          } else if (result.error_code == "223115") {
            toast_default.a.fail("人脸光照不好");
          } else if (result.result.face_list[0].face_type.type == "cartoon") {
            toast_default.a.fail("请上传真实人脸");
          } else if (result.result.face_list[0].face_type.probability <= "0.85") {
            toast_default.a.fail("请不要使用美颜拍照");
          } else if (result.result.face_list[0].quality.completeness != "1") {
            toast_default.a.fail("人脸不完整");
          } else if (result.result.face_list[0].face_probability != "1") {
            toast_default.a.fail("人脸模糊");
          } else if (result.result.face_list[0].quality.blur != "0") {
            toast_default.a.fail("相片不够清晰");
          } else if (result.result.face_list[0].quality.completeness != "1") {
            toast_default.a.fail("人脸不够完整");
          } else if (result.result.face_list[0].quality.illumination < 70) {
            toast_default.a.fail("光照太弱");
          } else if (result.result.face_list[0].quality.occlusion.chin_contour > "0.4") {
            toast_default.a.fail("下巴被遮挡");
          } else if (result.result.face_list[0].location.rotation < -50 || result.result.face_list[0].location.rotation > 50) {
            toast_default.a.fail("照片角度不符");
          } else if (result.result.face_list[0].quality.occlusion.left_cheek > "0.4") {
            toast_default.a.fail("左脸颊被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.left_eye > "0.4") {
            toast_default.a.fail("左眼被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.mouth > "0.4") {
            toast_default.a.fail("嘴巴被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.nose > "0.4") {
            toast_default.a.fail("鼻子被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.right_cheek > "0.4") {
            toast_default.a.fail("右脸颊被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.right_eye > "0.4") {
            toast_default.a.fail("右眼被遮挡");
          } else if (result.result.face_num > "1") {
            toast_default.a.fail("请单人拍照");
          } else if (result.result.face_list[0].glasses.type != "none") {
            toast_default.a.fail("请摘下眼镜");
          } else if (result.result.face_list[0].eye_status.left_eye != "1" && result.result.face_list[0].eye_status.right_eye != "1") {
            toast_default.a.fail("请睁开眼睛拍照");
          } else if (
          // result.result.face_list[0].angle.pitch <= -10 ||
          result.result.face_list[0].angle.pitch >= 20) {
            toast_default.a.fail("照片角度不符");
          } else if (
          // result.result.face_list[0].angle.roll <= -20 ||
          result.result.face_list[0].angle.roll >= 20) {
            toast_default.a.fail("照片角度不符");
          } else if (
          //  result.result.face_list[0].angle.yaw <= -20 ||
          result.result.face_list[0].angle.yaw >= 20) {
            toast_default.a.fail("照片角度不符");
          }
          // else if (
          //   result.result.face_list[0].location.width > 850 || result.result.face_list[0].location.height > 850
          // ) {
          //   Toast.fail("请离摄像头远一点");
          // }
          else if (result.result.face_list[0].location.width < 200 || result.result.face_list[0].location.height < 200) {
              toast_default.a.fail("请不要使用全身照");
            } else {
              self.pass = true;
              toast_default.a.success("照片合格");
            }
          if (self.pass == false) {
            self.$refs.userImg.src = '../../../static/image/defaultImg.png';
          }
          this.headerImage = '';
          self.faceList = stringify_default()(result);
          console.log('脸部特征');
          console.log(self.faceList);
        },
        error: function error(result) {
          this.headerImage = '';
          self.pass = false;
          toast_default.a.fail("上传失败,请重新上传");
          console.log(result);
        }
      });
    },

    //
    // 保存
    getSave: function getSave() {
      if (!this.repeatClick) {
        return;
      }
      // 判断必填选是否已选择
      if (this.headerImage == "") {
        toast_default.a.fail("头像不能为空");
      } else if (this.$refs.rename.value == "") {
        toast_default.a.fail("姓名不能为空");
      } else if (this.showuser == "") {
        toast_default.a.fail("请选择关系");
      } else if (this.pass == false) {
        toast_default.a.fail("图片不符合标准");
      } else {
        this.uploading();
      }
    },


    // 全部检测通过后 向服务器上传数据
    uploading: function uploading() {
      //重复点击
      this.repeatClick = false;
      var isPush = "";
      if (this.checked == true) {
        // 推送
        isPush = "1";
      } else {
        isPush = "0";
      }
      toast_default.a.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "添加中..."
      });
      if (this.$refs.rename.value.length > 4) {
        toast_default()('姓名长度不能超过4个字');
        //重复点击
        this.repeatClick = true;
        return;
      }
      var regRule = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
      if (this.$refs.rename.value.match(regRule)) {
        toast_default()('不支持表情');
        //重复点击
        this.repeatClick = true;
        return;
      }

      var msgHome = new Object();
      msgHome.comnCode = this.$route.query.comnCode;
      msgHome.phone = this.$router.history.current.query.phone;
      msgHome.hsNo = this.$route.query.hsNo;
      msgHome.relation = this.showuser; // 与我的关系
      msgHome.rename = this.$refs.rename.value; // 成员姓名
      msgHome.authImg = this.headerImage; // 成员照片
      msgHome.telephone = this.$refs.telephone.value; // 联系方式
      msgHome.hsName = this.$route.query.ownersName; // 业主姓名 ownersName
      msgHome.faceParam = this.faceList; // 数据集
      msgHome.isPush = isPush;
      console.log(msgHome);
      var newUrl = global.host + "guardInfo/addGuardInfo";
      this.$http.post(newUrl, msgHome).then(function (res) {
        console.log("添加后返回");
        console.log(res);
        if (res.body.statusCode == "120") {
          setTimeout(function () {
            toast_default.a.success("网络错误,重新上传");
          }, 1000);
          //重复点击
          this.repeatClick = true;
        } else {
          setTimeout(function () {
            toast_default.a.success(res.body.message);
          }, 1000);
          var this_ = this;
          setTimeout(function () {
            this_.$router.push({
              path: "/accessControl",
              query: {
                ownersName: this_.ownersName,
                hsNo: this_.hsNo,
                comnCode: this_.comnCode,
                openid: this_.$router.history.current.query.openid,
                phone: this_.$router.history.current.query.phone
              }
            });
          }, 2000);
          //重复点击
          this.repeatClick = true;
        }
      }, function (err) {
        //重复点击
        this.repeatClick = true;
        toast_default.a.fail("添加失败,请重试");
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64032a3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/entrance/addFamily.vue
var addFamily_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"addFamily"}},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"updataBox",attrs:{"id":"headimg"}},[_c('div',{staticClass:"updataImg"},[_c('img',{ref:"userImg",staticClass:"userImg response",attrs:{"src":__webpack_require__("AHIP")}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('van-uploader',{attrs:{"after-read":_vm.onRead}},[_c('van-icon',{attrs:{"name":"photograph"}})],1)],1),_vm._v(" "),_c('p',[_vm._v("上传头像")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('section',[_c('span',[_vm._v("家属姓名：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.items),expression:"items"}],ref:"rename",staticClass:"input",attrs:{"id":"nickName","type":"text","placeholder":"请输入姓名(最多四个字)"},domProps:{"value":(_vm.items)},on:{"input":function($event){if($event.target.composing){ return; }_vm.items=$event.target.value}}})]),_vm._v(" "),_c('section',[_c('span',[_vm._v("联系方式")]),_vm._v(" "),_c('input',{ref:"telephone",staticClass:"input",attrs:{"id":"telephone","type":"text","placeholder":"请输入联系方式"}})]),_vm._v(" "),_c('section',{staticClass:"choose"},[_c('span',[_vm._v("与我的关系：")]),_vm._v(" "),_c('input',{ref:"showUser",staticClass:"input",attrs:{"id":"showUserPicker","readonly":"readonly","type":"text","placeholder":"请选择"},on:{"click":function($event){_vm.showUserPicker()}}})]),_vm._v(" "),_c('section',[_c('span',[_vm._v("是否推送消息：")]),_vm._v(" "),_c('van-switch',{attrs:{"active-color":"#4cd964","inactive-color":"#fff"},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)]),_vm._v(" "),_c('div',{staticClass:"footFix",on:{"click":function($event){_vm.getSave()}}},[_c('span',{staticClass:"confirmBtn btn"},[_vm._v("保存")])])]),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showQR),callback:function ($$v) {_vm.showQR=$$v},expression:"showQR"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"","columns":_vm.columns},on:{"cancel":_vm.onCancel,"confirm":_vm.onConfirm}})],1)],1)}
var addFamily_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ico"},[_c('img',{staticClass:"response ico_img",attrs:{"src":__webpack_require__("+F4+")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warning"},[_c('div',[_vm._v("上传须知:")]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("※1.真实拍摄的单人照片且不能佩戴眼镜")]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("※2.五官清晰、完整不能有遮挡且光照充足")]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("※3.照片背景需为纯色，以白色为最佳")])])}]
var addFamily_esExports = { render: addFamily_render, staticRenderFns: addFamily_staticRenderFns }
/* harmony default export */ var components_entrance_addFamily = (addFamily_esExports);
// CONCATENATED MODULE: ./src/components/entrance/addFamily.vue
function addFamily_injectStyle (ssrContext) {
  __webpack_require__("loc2")
}
var addFamily_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addFamily___vue_template_functional__ = false
/* styles */
var addFamily___vue_styles__ = addFamily_injectStyle
/* scopeId */
var addFamily___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var addFamily___vue_module_identifier__ = null
var addFamily_Component = addFamily_normalizeComponent(
  entrance_addFamily,
  components_entrance_addFamily,
  addFamily___vue_template_functional__,
  addFamily___vue_styles__,
  addFamily___vue_scopeId__,
  addFamily___vue_module_identifier__
)

/* harmony default export */ var src_components_entrance_addFamily = (addFamily_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/entrance/addVisitor.vue














 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var addVisitor__components;




var citys = {
  '时间': ['1小时', '2小时', '3小时', '4小时', '5小时', '6小时', '7小时', '8小时', '9小时', '10小时', '11小时', '12小时', '24小时', '48小时', '72小时']
  // '次数': ['1次', '2次', '3次', '4次', '5次','6次','7次','8次','9次','10次','20次',]
};
/* harmony default export */ var addVisitor = ({
  components: (addVisitor__components = {
    $: jquery_default.a
  }, defineProperty_default()(addVisitor__components, picker_default.a.name, picker_default.a), defineProperty_default()(addVisitor__components, popup_default.a.name, popup_default.a), defineProperty_default()(addVisitor__components, switch_default.a.name, switch_default.a), defineProperty_default()(addVisitor__components, uploader_default.a.name, uploader_default.a), defineProperty_default()(addVisitor__components, toast_default.a.name, toast_default.a), defineProperty_default()(addVisitor__components, loading_default.a.name, loading_default.a), addVisitor__components),
  data: function data() {
    return {
      //防止保存重复点击
      repeatClick: true,
      items: '',
      columns: ["亲戚", "朋友", "同事", "其他"], // 与我的关系
      showQR: false, // 与我的关系
      checked: false, // 开关
      imgUrl: "", // base64 用户上传的头像
      showLL: false, // 有效期
      period: '', // 有效期+时间 数组0=limitType 限制条件（time:时间；count:次数） 数组1=limitRule  使用时长或使用次数
      columnsL: [{
        values: keys_default()(citys),
        className: 'columnsLL1'
      }, {
        values: citys['时间'],
        className: 'columnsLL2',
        defaultIndex: 2
      }], // 有效期默认选择
      headerImage: '', // 图片集合
      picValue: '',
      access_token: "", // 百度api的token
      pass: false, // 此参数为true 执行向后台提交的请求 次参数为false 则拦截在百度AI这一层
      faceList: '' // 脸部识别所有的数据
    };
  },

  watch: {
    items: function items() {
      if (this.items.length > 4) {
        this.items = this.items.substring(0, 4);
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getBadToken();
  },
  mounted: function mounted() {},

  methods: {
    // 与我的关系点击弹出
    showUserPicker: function showUserPicker() {
      this.showQR = true;
    },

    // 点击确认后选择回填
    onConfirm: function onConfirm(value, index) {
      this.showQR = false;
      this.$refs.showUser.value = value;
      if (value == "亲戚") {
        this.showuser = "1";
      } else if (value == "朋友") {
        this.showuser = "2";
      } else if (value == "同事") {
        this.showuser = "3";
      } else if (value == "其他") {
        this.showuser = "4";
      }
    },

    //  与我的关系 点击取消
    onCancel: function onCancel() {
      this.showQR = false;
    },

    // 上传头像
    onRead: function onRead(file) {
      console.log('qqqqqqqqqqqqqq');
      console.log(file);
      // 图片转换代码
      this.$refs.userImg.src = file.content;
      // this.headerImage = file.content;
      this.picValue = file.file;
      this.imgPreview(this.picValue);
      toast_default.a.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "识别中..."
      });
    },

    // 图片压缩
    imgPreview: function imgPreview(file) {
      var self = this;
      var Orientation = void 0;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      exif_default.a.getData(file, function () {
        Orientation = exif_default.a.getTag(this, 'Orientation');
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;

      if (/^image/.test(file.type)) {
        // 创建一个reader
        var reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          var result = this.result;
          var img = new Image();
          img.src = result;
          //判断图片是否大于100K,是就直接上传，反之压缩图片
          if (this.result.length <= 100 * 1024) {
            self.headerImage = this.result;
            self.discern();
          } else {
            img.onload = function () {
              var data = self.compress(img, Orientation);
              self.headerImage = data;
              self.discern();
            };
          }
        };
      }
    },
    compress: function compress(img, Orientation) {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext('2d');
      //瓦片canvas
      var tCanvas = document.createElement("canvas");
      var tctx = tCanvas.getContext("2d");
      var initSize = img.src.length;
      var width = img.width;
      var height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      var ratio = void 0;
      if ((ratio = width * height / 4000000) > 1) {
        console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      // ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      var count = void 0;
      if ((count = width * height / 1000000) > 1) {
        console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        var nw = ~~(width / count);
        var nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (var i = 0; i < count; i++) {
          for (var j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6:
            //需要顺时针（向左）90度旋转
            this.rotateImg(img, 'left', canvas);
            break;
          case 8:
            //需要逆时针（向右）90度旋转
            this.rotateImg(img, 'right', canvas);
            break;
          case 3:
            //需要180度旋转
            this.rotateImg(img, 'right', canvas); //转两次
            this.rotateImg(img, 'right', canvas);
            break;
        }
      }
      //进行最小压缩
      var ndata = canvas.toDataURL('image/jpeg', 0.1);
      console.log('压缩前：' + initSize);
      console.log('压缩后：' + ndata.length);
      console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + "%");
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    rotateImg: function rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      var min_step = 0;
      var max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      var height = img.height;
      var width = img.width;
      var step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == 'right') {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      var degree = step * 90 * Math.PI / 180;
      var ctx = canvas.getContext('2d');
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },

    // 有效期弹出
    showLLQR: function showLLQR() {
      this.showLL = true;
    },

    // 有效期 取消
    onDet: function onDet() {
      this.showLL = false;
      console.log('取消');
    },

    // 有效期 点击确认
    onQR: function onQR(value, index) {
      this.period = value;
      console.log(this.period);
      this.showLL = false;
      this.$refs.showLLQREW.value = value;
    },

    // 有效期联动
    onChange: function onChange(picker, values) {
      picker.setColumnValues(1, citys[values[0]]);
    },

    // 调用百度api 获取token
    getBadToken: function getBadToken() {
      // 百度api
      // /BD 配置在config index.js文件内做跨域处理
      console.log("调用百度api token");
      this.$http.post(global.host + "/face/aip/access_token.json").then(function (res) {
        console.log('新的token新的token新的token新的token新的token新的token');
        console.log(res);
        this.access_token = res.body.access_token;
        console.log(this.access_token);
      }, function (err) {
        console.log('人脸识别token获取失败');
        console.log(err);
      });
    },

    // 唤起人脸识别检测接口
    discern: function discern() {
      this.pass = false;
      console.log("唤起人脸识别检测接口");
      // console.log(this.headerImage)
      var strIng = this.headerImage.indexOf(",");
      var result = this.headerImage.substr(strIng + 1, this.headerImage.length);
      //  console.log(result)
      var self = this;
      jquery_default.a.ajax({
        type: "post",
        url: "https://aip.baidubce.com/rest/2.0/face/v3/detect?access_token=" + this.access_token,
        data: {
          "image": result,
          "image_type": 'BASE64',
          'face_field': 'angel,quality,face_type,glasses,gender,age,face_token,eye_status,race,landmark,',
          'max_face_num': '2'
        },
        dataType: 'json',
        crossDomain: true,
        success: function success(result) {
          console.log('百度AI调用成功返回参数');
          console.log(result);
          if (result.error_code == "222202") {
            toast_default.a.fail("图片中没有人脸");
          } else if (result.error_code == "222203") {
            toast_default.a.fail("无法解析人脸");
          } else if (result.error_code == "223114") {
            toast_default.a.fail("人脸模糊");
          } else if (result.error_code == "223115") {
            toast_default.a.fail("人脸光照不好");
          } else if (result.result.face_list[0].face_type.type == "cartoon") {
            toast_default.a.fail("请上传真实人脸");
          } else if (result.result.face_list[0].face_type.probability <= "0.85") {
            toast_default.a.fail("请不要使用美颜拍照");
          } else if (result.result.face_list[0].quality.completeness != "1") {
            toast_default.a.fail("人脸不完整");
          } else if (result.result.face_list[0].face_probability != "1") {
            toast_default.a.fail("人脸模糊");
          } else if (result.result.face_list[0].quality.blur != "0") {
            toast_default.a.fail("相片不够清晰");
          } else if (result.result.face_list[0].quality.completeness != "1") {
            toast_default.a.fail("人脸不够完整");
          } else if (result.result.face_list[0].quality.illumination < 70) {
            toast_default.a.fail("光照太弱");
          } else if (result.result.face_list[0].quality.occlusion.chin_contour > "0.4") {
            toast_default.a.fail("下巴被遮挡");
          } else if (result.result.face_list[0].location.rotation < -50 || result.result.face_list[0].location.rotation > 50) {
            toast_default.a.fail("照片角度不符");
          } else if (result.result.face_list[0].quality.occlusion.left_cheek > "0.4") {
            toast_default.a.fail("左脸颊被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.left_eye > "0.4") {
            toast_default.a.fail("左眼被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.mouth > "0.4") {
            toast_default.a.fail("嘴巴被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.nose > "0.4") {
            toast_default.a.fail("鼻子被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.right_cheek > "0.4") {
            toast_default.a.fail("右脸颊被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.right_eye > "0.4") {
            toast_default.a.fail("右眼被遮挡");
          } else if (result.result.face_num > "1") {
            toast_default.a.fail("请单人拍照");
          } else if (result.result.face_list[0].glasses.type != "none") {
            toast_default.a.fail("请摘下眼镜");
          } else if (result.result.face_list[0].eye_status.left_eye != "1" && result.result.face_list[0].eye_status.right_eye != "1") {
            toast_default.a.fail("请睁开眼睛拍照");
          } else if (
          // result.result.face_list[0].angle.pitch <= -10 ||
          result.result.face_list[0].angle.pitch >= 20) {
            toast_default.a.fail("照片角度不符");
          } else if (
          // result.result.face_list[0].angle.roll <= -20 ||
          result.result.face_list[0].angle.roll >= 20) {
            toast_default.a.fail("照片角度不符");
          } else if (
          //  result.result.face_list[0].angle.yaw <= -20 ||
          result.result.face_list[0].angle.yaw >= 20) {
            toast_default.a.fail("照片角度不符");
          }
          // else if (
          //   result.result.face_list[0].location.width > 850 || result.result.face_list[0].location.height > 850
          // ) {
          //   Toast.fail("请离摄像头远一点");
          // }
          else if (result.result.face_list[0].location.width < 200 || result.result.face_list[0].location.height < 200) {
              toast_default.a.fail("请不要使用全身照");
            } else {
              self.pass = true;
              toast_default.a.success("照片合格");
            }
          if (self.pass == false) {
            self.$refs.userImg.src = '../../../static/image/defaultImg.png';
          }
          this.headerImage = '';
          self.faceList = stringify_default()(result);
          console.log('脸部特征');
          console.log(self.faceList);
        },
        error: function error(result) {
          this.headerImage = '';
          self.pass = false;
          toast_default.a.fail("上传失败,请重新上传");
          console.log(result);
        }
      });
    },

    // 保存
    getSave: function getSave() {
      if (!this.repeatClick) {
        return;
      }
      console.log(this.period);
      // 判断必填选是否已选择
      if (this.headerImage == "") {
        toast_default.a.fail("头像不能为空");
      } else if (this.$refs.rename.value == "") {
        toast_default.a.fail("姓名不能为空");
      } else if (this.$refs.showUser.value == "") {
        toast_default.a.fail("请选择关系");
      } else if (this.period.length == 0) {
        toast_default.a.fail("有效期不能为空");
      } else if (this.pass == false) {
        toast_default.a.fail('图片不符合标准');
      } else {
        this.uploading();
      }
    },

    // 全部检测通过后 向服务器上传数据
    uploading: function uploading() {
      //重复点击
      this.repeatClick = false;
      var isPush = "";
      var limitType = '';
      if (this.period[0] == '时间') {
        limitType = 'time';
      } else if (this.period[0] == '次数') {
        limitType = 'count';
      }
      if (this.checked == true) {
        // 推送
        isPush = "1";
      } else {
        isPush = "0";
      }
      toast_default.a.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "添加中..."
      });
      if (this.$refs.rename.value.length > 4) {
        toast_default()('姓名长度不能超过4个字');
        //重复点击
        this.repeatClick = true;
        return;
      }
      var regRule = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
      if (this.$refs.rename.value.match(regRule)) {
        toast_default()('不支持表情');
        //重复点击
        this.repeatClick = true;
        return;
      }
      console.log(this.headerImage);
      var periodOne = this.period[1].substring(0, 1);
      var msgHome = new Object();
      msgHome.comnCode = this.$route.query.comnCode;
      msgHome.phone = this.$router.history.current.query.phone;
      msgHome.hsNo = this.$route.query.hsNo;
      msgHome.relation = this.showuser; // 与我的关系
      msgHome.rename = this.$refs.rename.value; // 成员姓名
      msgHome.authImg = this.headerImage; // 成员照片
      msgHome.telephone = this.$refs.telephone.value; // 联系方式
      msgHome.hsName = this.$route.query.ownersName; // 业主姓名 ownersName
      msgHome.isPush = isPush; // 是否推送
      msgHome.limitType = limitType; // 有效期
      msgHome.limitRule = periodOne; // 使用时长或者次数
      msgHome.faceParam = this.faceList; // 数据集
      console.log(msgHome);
      var newUrl = global.host + "guardVisitor/addGuardVisitor";
      this.$http.post(newUrl, msgHome).then(function (res) {
        console.log(res);
        if (res.body.statusCode == '120') {
          setTimeout(function () {
            toast_default.a.success('网络错误,重新上传');
          }, 1000);
          //重复点击
          this.repeatClick = true;
        } else {
          setTimeout(function () {
            toast_default.a.success(res.body.message);
          }, 1000);
          var this_ = this;
          setTimeout(function () {
            this_.$router.push({
              path: "/accessControl",
              query: {
                ownersName: this_.ownersName,
                hsNo: this_.hsNo,
                comnCode: this_.comnCode,
                openid: this_.$router.history.current.query.openid,
                phone: this_.$router.history.current.query.phone,
                active: true
              }
            });
          }, 2000);
          //重复点击
          this.repeatClick = true;
        }
      }, function (err) {
        toast_default.a.fail("添加失败,请重试");
        //重复点击
        this.repeatClick = true;
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/entrance/addVisitor.vue














 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var entrance_addVisitor__components;




var addVisitor_citys = {
  '时间': ['1小时', '2小时', '3小时', '4小时', '5小时', '6小时', '7小时', '8小时', '9小时', '10小时', '11小时', '12小时', '24小时', '48小时', '72小时']
  // '次数': ['1次', '2次', '3次', '4次', '5次','6次','7次','8次','9次','10次','20次',]
};
/* harmony default export */ var entrance_addVisitor = ({
  components: (entrance_addVisitor__components = {
    $: jquery_default.a
  }, defineProperty_default()(entrance_addVisitor__components, picker_default.a.name, picker_default.a), defineProperty_default()(entrance_addVisitor__components, popup_default.a.name, popup_default.a), defineProperty_default()(entrance_addVisitor__components, switch_default.a.name, switch_default.a), defineProperty_default()(entrance_addVisitor__components, uploader_default.a.name, uploader_default.a), defineProperty_default()(entrance_addVisitor__components, toast_default.a.name, toast_default.a), defineProperty_default()(entrance_addVisitor__components, loading_default.a.name, loading_default.a), entrance_addVisitor__components),
  data: function data() {
    return {
      //防止保存重复点击
      repeatClick: true,
      items: '',
      columns: ["亲戚", "朋友", "同事", "其他"], // 与我的关系
      showQR: false, // 与我的关系
      checked: false, // 开关
      imgUrl: "", // base64 用户上传的头像
      showLL: false, // 有效期
      period: '', // 有效期+时间 数组0=limitType 限制条件（time:时间；count:次数） 数组1=limitRule  使用时长或使用次数
      columnsL: [{
        values: keys_default()(addVisitor_citys),
        className: 'columnsLL1'
      }, {
        values: addVisitor_citys['时间'],
        className: 'columnsLL2',
        defaultIndex: 2
      }], // 有效期默认选择
      headerImage: '', // 图片集合
      picValue: '',
      access_token: "", // 百度api的token
      pass: false, // 此参数为true 执行向后台提交的请求 次参数为false 则拦截在百度AI这一层
      faceList: '' // 脸部识别所有的数据
    };
  },

  watch: {
    items: function items() {
      if (this.items.length > 4) {
        this.items = this.items.substring(0, 4);
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getBadToken();
  },
  mounted: function mounted() {},

  methods: {
    // 与我的关系点击弹出
    showUserPicker: function showUserPicker() {
      this.showQR = true;
    },

    // 点击确认后选择回填
    onConfirm: function onConfirm(value, index) {
      this.showQR = false;
      this.$refs.showUser.value = value;
      if (value == "亲戚") {
        this.showuser = "1";
      } else if (value == "朋友") {
        this.showuser = "2";
      } else if (value == "同事") {
        this.showuser = "3";
      } else if (value == "其他") {
        this.showuser = "4";
      }
    },

    //  与我的关系 点击取消
    onCancel: function onCancel() {
      this.showQR = false;
    },

    // 上传头像
    onRead: function onRead(file) {
      console.log('qqqqqqqqqqqqqq');
      console.log(file);
      // 图片转换代码
      this.$refs.userImg.src = file.content;
      // this.headerImage = file.content;
      this.picValue = file.file;
      this.imgPreview(this.picValue);
      toast_default.a.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "识别中..."
      });
    },

    // 图片压缩
    imgPreview: function imgPreview(file) {
      var self = this;
      var Orientation = void 0;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      exif_default.a.getData(file, function () {
        Orientation = exif_default.a.getTag(this, 'Orientation');
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;

      if (/^image/.test(file.type)) {
        // 创建一个reader
        var reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          var result = this.result;
          var img = new Image();
          img.src = result;
          //判断图片是否大于100K,是就直接上传，反之压缩图片
          if (this.result.length <= 100 * 1024) {
            self.headerImage = this.result;
            self.discern();
          } else {
            img.onload = function () {
              var data = self.compress(img, Orientation);
              self.headerImage = data;
              self.discern();
            };
          }
        };
      }
    },
    compress: function compress(img, Orientation) {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext('2d');
      //瓦片canvas
      var tCanvas = document.createElement("canvas");
      var tctx = tCanvas.getContext("2d");
      var initSize = img.src.length;
      var width = img.width;
      var height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      var ratio = void 0;
      if ((ratio = width * height / 4000000) > 1) {
        console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      // ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      var count = void 0;
      if ((count = width * height / 1000000) > 1) {
        console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        var nw = ~~(width / count);
        var nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (var i = 0; i < count; i++) {
          for (var j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6:
            //需要顺时针（向左）90度旋转
            this.rotateImg(img, 'left', canvas);
            break;
          case 8:
            //需要逆时针（向右）90度旋转
            this.rotateImg(img, 'right', canvas);
            break;
          case 3:
            //需要180度旋转
            this.rotateImg(img, 'right', canvas); //转两次
            this.rotateImg(img, 'right', canvas);
            break;
        }
      }
      //进行最小压缩
      var ndata = canvas.toDataURL('image/jpeg', 0.1);
      console.log('压缩前：' + initSize);
      console.log('压缩后：' + ndata.length);
      console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + "%");
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    rotateImg: function rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      var min_step = 0;
      var max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      var height = img.height;
      var width = img.width;
      var step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == 'right') {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      var degree = step * 90 * Math.PI / 180;
      var ctx = canvas.getContext('2d');
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },

    // 有效期弹出
    showLLQR: function showLLQR() {
      this.showLL = true;
    },

    // 有效期 取消
    onDet: function onDet() {
      this.showLL = false;
      console.log('取消');
    },

    // 有效期 点击确认
    onQR: function onQR(value, index) {
      this.period = value;
      console.log(this.period);
      this.showLL = false;
      this.$refs.showLLQREW.value = value;
    },

    // 有效期联动
    onChange: function onChange(picker, values) {
      picker.setColumnValues(1, addVisitor_citys[values[0]]);
    },

    // 调用百度api 获取token
    getBadToken: function getBadToken() {
      // 百度api
      // /BD 配置在config index.js文件内做跨域处理
      console.log("调用百度api token");
      this.$http.post(global.host + "/face/aip/access_token.json").then(function (res) {
        console.log('新的token新的token新的token新的token新的token新的token');
        console.log(res);
        this.access_token = res.body.access_token;
        console.log(this.access_token);
      }, function (err) {
        console.log('人脸识别token获取失败');
        console.log(err);
      });
    },

    // 唤起人脸识别检测接口
    discern: function discern() {
      this.pass = false;
      console.log("唤起人脸识别检测接口");
      // console.log(this.headerImage)
      var strIng = this.headerImage.indexOf(",");
      var result = this.headerImage.substr(strIng + 1, this.headerImage.length);
      //  console.log(result)
      var self = this;
      jquery_default.a.ajax({
        type: "post",
        url: "https://aip.baidubce.com/rest/2.0/face/v3/detect?access_token=" + this.access_token,
        data: {
          "image": result,
          "image_type": 'BASE64',
          'face_field': 'angel,quality,face_type,glasses,gender,age,face_token,eye_status,race,landmark,',
          'max_face_num': '2'
        },
        dataType: 'json',
        crossDomain: true,
        success: function success(result) {
          console.log('百度AI调用成功返回参数');
          console.log(result);
          if (result.error_code == "222202") {
            toast_default.a.fail("图片中没有人脸");
          } else if (result.error_code == "222203") {
            toast_default.a.fail("无法解析人脸");
          } else if (result.error_code == "223114") {
            toast_default.a.fail("人脸模糊");
          } else if (result.error_code == "223115") {
            toast_default.a.fail("人脸光照不好");
          } else if (result.result.face_list[0].face_type.type == "cartoon") {
            toast_default.a.fail("请上传真实人脸");
          } else if (result.result.face_list[0].face_type.probability <= "0.85") {
            toast_default.a.fail("请不要使用美颜拍照");
          } else if (result.result.face_list[0].quality.completeness != "1") {
            toast_default.a.fail("人脸不完整");
          } else if (result.result.face_list[0].face_probability != "1") {
            toast_default.a.fail("人脸模糊");
          } else if (result.result.face_list[0].quality.blur != "0") {
            toast_default.a.fail("相片不够清晰");
          } else if (result.result.face_list[0].quality.completeness != "1") {
            toast_default.a.fail("人脸不够完整");
          } else if (result.result.face_list[0].quality.illumination < 70) {
            toast_default.a.fail("光照太弱");
          } else if (result.result.face_list[0].quality.occlusion.chin_contour > "0.4") {
            toast_default.a.fail("下巴被遮挡");
          } else if (result.result.face_list[0].location.rotation < -50 || result.result.face_list[0].location.rotation > 50) {
            toast_default.a.fail("照片角度不符");
          } else if (result.result.face_list[0].quality.occlusion.left_cheek > "0.4") {
            toast_default.a.fail("左脸颊被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.left_eye > "0.4") {
            toast_default.a.fail("左眼被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.mouth > "0.4") {
            toast_default.a.fail("嘴巴被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.nose > "0.4") {
            toast_default.a.fail("鼻子被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.right_cheek > "0.4") {
            toast_default.a.fail("右脸颊被遮挡");
          } else if (result.result.face_list[0].quality.occlusion.right_eye > "0.4") {
            toast_default.a.fail("右眼被遮挡");
          } else if (result.result.face_num > "1") {
            toast_default.a.fail("请单人拍照");
          } else if (result.result.face_list[0].glasses.type != "none") {
            toast_default.a.fail("请摘下眼镜");
          } else if (result.result.face_list[0].eye_status.left_eye != "1" && result.result.face_list[0].eye_status.right_eye != "1") {
            toast_default.a.fail("请睁开眼睛拍照");
          } else if (
          // result.result.face_list[0].angle.pitch <= -10 ||
          result.result.face_list[0].angle.pitch >= 20) {
            toast_default.a.fail("照片角度不符");
          } else if (
          // result.result.face_list[0].angle.roll <= -20 ||
          result.result.face_list[0].angle.roll >= 20) {
            toast_default.a.fail("照片角度不符");
          } else if (
          //  result.result.face_list[0].angle.yaw <= -20 ||
          result.result.face_list[0].angle.yaw >= 20) {
            toast_default.a.fail("照片角度不符");
          }
          // else if (
          //   result.result.face_list[0].location.width > 850 || result.result.face_list[0].location.height > 850
          // ) {
          //   Toast.fail("请离摄像头远一点");
          // }
          else if (result.result.face_list[0].location.width < 200 || result.result.face_list[0].location.height < 200) {
              toast_default.a.fail("请不要使用全身照");
            } else {
              self.pass = true;
              toast_default.a.success("照片合格");
            }
          if (self.pass == false) {
            self.$refs.userImg.src = '../../../static/image/defaultImg.png';
          }
          this.headerImage = '';
          self.faceList = stringify_default()(result);
          console.log('脸部特征');
          console.log(self.faceList);
        },
        error: function error(result) {
          this.headerImage = '';
          self.pass = false;
          toast_default.a.fail("上传失败,请重新上传");
          console.log(result);
        }
      });
    },

    // 保存
    getSave: function getSave() {
      if (!this.repeatClick) {
        return;
      }
      console.log(this.period);
      // 判断必填选是否已选择
      if (this.headerImage == "") {
        toast_default.a.fail("头像不能为空");
      } else if (this.$refs.rename.value == "") {
        toast_default.a.fail("姓名不能为空");
      } else if (this.$refs.showUser.value == "") {
        toast_default.a.fail("请选择关系");
      } else if (this.period.length == 0) {
        toast_default.a.fail("有效期不能为空");
      } else if (this.pass == false) {
        toast_default.a.fail('图片不符合标准');
      } else {
        this.uploading();
      }
    },

    // 全部检测通过后 向服务器上传数据
    uploading: function uploading() {
      //重复点击
      this.repeatClick = false;
      var isPush = "";
      var limitType = '';
      if (this.period[0] == '时间') {
        limitType = 'time';
      } else if (this.period[0] == '次数') {
        limitType = 'count';
      }
      if (this.checked == true) {
        // 推送
        isPush = "1";
      } else {
        isPush = "0";
      }
      toast_default.a.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "添加中..."
      });
      if (this.$refs.rename.value.length > 4) {
        toast_default()('姓名长度不能超过4个字');
        //重复点击
        this.repeatClick = true;
        return;
      }
      var regRule = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
      if (this.$refs.rename.value.match(regRule)) {
        toast_default()('不支持表情');
        //重复点击
        this.repeatClick = true;
        return;
      }
      console.log(this.headerImage);
      var periodOne = this.period[1].substring(0, 1);
      var msgHome = new Object();
      msgHome.comnCode = this.$route.query.comnCode;
      msgHome.phone = this.$router.history.current.query.phone;
      msgHome.hsNo = this.$route.query.hsNo;
      msgHome.relation = this.showuser; // 与我的关系
      msgHome.rename = this.$refs.rename.value; // 成员姓名
      msgHome.authImg = this.headerImage; // 成员照片
      msgHome.telephone = this.$refs.telephone.value; // 联系方式
      msgHome.hsName = this.$route.query.ownersName; // 业主姓名 ownersName
      msgHome.isPush = isPush; // 是否推送
      msgHome.limitType = limitType; // 有效期
      msgHome.limitRule = periodOne; // 使用时长或者次数
      msgHome.faceParam = this.faceList; // 数据集
      console.log(msgHome);
      var newUrl = global.host + "guardVisitor/addGuardVisitor";
      this.$http.post(newUrl, msgHome).then(function (res) {
        console.log(res);
        if (res.body.statusCode == '120') {
          setTimeout(function () {
            toast_default.a.success('网络错误,重新上传');
          }, 1000);
          //重复点击
          this.repeatClick = true;
        } else {
          setTimeout(function () {
            toast_default.a.success(res.body.message);
          }, 1000);
          var this_ = this;
          setTimeout(function () {
            this_.$router.push({
              path: "/accessControl",
              query: {
                ownersName: this_.ownersName,
                hsNo: this_.hsNo,
                comnCode: this_.comnCode,
                openid: this_.$router.history.current.query.openid,
                phone: this_.$router.history.current.query.phone,
                active: true
              }
            });
          }, 2000);
          //重复点击
          this.repeatClick = true;
        }
      }, function (err) {
        toast_default.a.fail("添加失败,请重试");
        //重复点击
        this.repeatClick = true;
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62007d4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/entrance/addVisitor.vue
var addVisitor_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"addVisitor"}},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"updataBox",attrs:{"id":"headimg"}},[_c('div',{staticClass:"updataImg"},[_c('img',{ref:"userImg",staticClass:"userImg response",attrs:{"src":__webpack_require__("AHIP")}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('van-uploader',{attrs:{"after-read":_vm.onRead}},[_c('van-icon',{attrs:{"name":"photograph"}})],1)],1),_vm._v(" "),_c('p',[_vm._v("上传头像")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('section',[_c('span',[_vm._v("拜访人姓名：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.items),expression:"items"}],ref:"rename",staticClass:"input",attrs:{"id":"nickName","type":"text","placeholder":"请输入姓名(最多四个字)"},domProps:{"value":(_vm.items)},on:{"input":function($event){if($event.target.composing){ return; }_vm.items=$event.target.value}}})]),_vm._v(" "),_c('section',[_c('span',[_vm._v("联系方式")]),_vm._v(" "),_c('input',{ref:"telephone",staticClass:"input",attrs:{"id":"telephone","type":"text","placeholder":"请输入联系方式"}})]),_vm._v(" "),_c('section',{staticClass:"choose"},[_c('span',[_vm._v("与我的关系：")]),_vm._v(" "),_c('input',{ref:"showUser",staticClass:"input",attrs:{"id":"showUserPicker","readonly":"readonly","type":"text","placeholder":"请选择"},on:{"click":function($event){_vm.showUserPicker()}}})]),_vm._v(" "),_c('section',{staticClass:"choose"},[_c('span',[_vm._v("有效期：")]),_vm._v(" "),_c('input',{ref:"showLLQREW",staticClass:"input",attrs:{"id":"showUserPicker","readonly":"readonly","type":"text","placeholder":"请选择"},on:{"click":function($event){_vm.showLLQR()}}})]),_vm._v(" "),_c('section',[_c('span',[_vm._v("是否推送消息：")]),_vm._v(" "),_c('van-switch',{attrs:{"active-color":"#4cd964","inactive-color":"#fff"},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)]),_vm._v(" "),_c('div',{staticClass:"footFix",on:{"click":function($event){_vm.getSave()}}},[_c('span',{staticClass:"confirmBtn btn"},[_vm._v("保存")])])]),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showQR),callback:function ($$v) {_vm.showQR=$$v},expression:"showQR"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"","columns":_vm.columns},on:{"cancel":_vm.onCancel,"confirm":_vm.onConfirm}})],1),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showLL),callback:function ($$v) {_vm.showLL=$$v},expression:"showLL"}},[_c('van-picker',{attrs:{"show-toolbar":"","columns":_vm.columnsL},on:{"change":_vm.onChange,"cancel":_vm.onDet,"confirm":_vm.onQR}})],1)],1)}
var addVisitor_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ico"},[_c('img',{staticClass:"response ico_img",attrs:{"src":__webpack_require__("+F4+")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warning"},[_c('div',[_vm._v("上传须知:")]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("※1.真实拍摄的单人照片且不能佩戴眼镜")]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("※2.五官清晰、完整不能有遮挡且光照充足")])])}]
var addVisitor_esExports = { render: addVisitor_render, staticRenderFns: addVisitor_staticRenderFns }
/* harmony default export */ var components_entrance_addVisitor = (addVisitor_esExports);
// CONCATENATED MODULE: ./src/components/entrance/addVisitor.vue
function addVisitor_injectStyle (ssrContext) {
  __webpack_require__("9UmN")
}
var addVisitor_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addVisitor___vue_template_functional__ = false
/* styles */
var addVisitor___vue_styles__ = addVisitor_injectStyle
/* scopeId */
var addVisitor___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var addVisitor___vue_module_identifier__ = null
var addVisitor_Component = addVisitor_normalizeComponent(
  entrance_addVisitor,
  components_entrance_addVisitor,
  addVisitor___vue_template_functional__,
  addVisitor___vue_styles__,
  addVisitor___vue_scopeId__,
  addVisitor___vue_module_identifier__
)

/* harmony default export */ var src_components_entrance_addVisitor = (addVisitor_Component.exports);

// EXTERNAL MODULE: ./node_modules/vant/lib/cell-group/style/index.js
var cell_group_style = __webpack_require__("QP/A");
var cell_group_style_default = /*#__PURE__*/__webpack_require__.n(cell_group_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/cell-group/index.js
var cell_group = __webpack_require__("pyxX");
var cell_group_default = /*#__PURE__*/__webpack_require__.n(cell_group);

// EXTERNAL MODULE: ./node_modules/vant/lib/cell/style/index.js
var cell_style = __webpack_require__("cnGM");
var cell_style_default = /*#__PURE__*/__webpack_require__.n(cell_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/cell/index.js
var lib_cell = __webpack_require__("S6j6");
var cell_default = /*#__PURE__*/__webpack_require__.n(lib_cell);

// EXTERNAL MODULE: ./node_modules/vant/lib/button/style/index.js
var button_style = __webpack_require__("FDxC");
var button_style_default = /*#__PURE__*/__webpack_require__.n(button_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/button/index.js
var lib_button = __webpack_require__("w+oK");
var button_default = /*#__PURE__*/__webpack_require__.n(lib_button);

// EXTERNAL MODULE: ./node_modules/vant/lib/field/style/index.js
var field_style = __webpack_require__("wvM5");
var field_style_default = /*#__PURE__*/__webpack_require__.n(field_style);

// EXTERNAL MODULE: ./node_modules/vant/lib/field/index.js
var field = __webpack_require__("MyDk");
var field_default = /*#__PURE__*/__webpack_require__.n(field);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue-qr/dist/vue-qr.js
var vue_qr = __webpack_require__("PUIo");
var vue_qr_default = /*#__PURE__*/__webpack_require__.n(vue_qr);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/accessControl/accessCode.vue

























 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var accessCode__components;




/* harmony default export */ var accessCode = ({
  components: (accessCode__components = {}, defineProperty_default()(accessCode__components, field_default.a.name, field_default.a), defineProperty_default()(accessCode__components, button_default.a.name, button_default.a), defineProperty_default()(accessCode__components, cell_default.a.name, cell_default.a), defineProperty_default()(accessCode__components, cell_group_default.a.name, cell_group_default.a), defineProperty_default()(accessCode__components, radio_group_default.a.name, radio_group_default.a), defineProperty_default()(accessCode__components, radio_default.a.name, radio_default.a), defineProperty_default()(accessCode__components, popup_default.a.name, popup_default.a), defineProperty_default()(accessCode__components, loading_default.a.name, loading_default.a), defineProperty_default()(accessCode__components, picker_default.a.name, picker_default.a), defineProperty_default()(accessCode__components, uploader_default.a.name, uploader_default.a), defineProperty_default()(accessCode__components, dialog_default.a.name, dialog_default.a), defineProperty_default()(accessCode__components, toast_default.a.name, toast_default.a), defineProperty_default()(accessCode__components, vue_qr_default.a.name, vue_qr_default.a), accessCode__components),
  data: function data() {
    return {
      //二维码code
      imgUrl: "../../../static/image/house_icon.png",
      codeText: "",
      openId: "",
      status: false
    };
  },
  mounted: function mounted() {
    toast_default.a.loading({
      message: '加载中...',
      forbidClick: false,
      duration: 500
    });
    document.title = "门禁二维码";
    this.openId = this.$router.history.current.query.openid;
    this.load();
  },

  methods: {
    //初始化二维码
    load: function load() {
      this.$http.get(global.host + 'guardCard/qrcode?openid=' + this.openId).then(function (res) {
        console.log("res   ===   " + stringify_default()(res));
        if (res.body.code == "200") {
          if (res.body.data) {
            this.status = false;
            this.codeText = res.body.data;
          } else {
            this.status = true;
          }
        } else {
          this.status = true;
        }
        console.log(" this.codeText   ===   " + this.codeText);
      }, function (err) {
        toast_default.a.loading({
          message: '服务异常，请稍后重试',
          forbidClick: false,
          duration: 3000
        });
      });
    },

    //刷新二维码
    refresh: function refresh() {
      toast_default.a.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 500
      });
      this.load();
    }
  }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/accessControl/accessCode.vue

























 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var accessControl_accessCode__components;




/* harmony default export */ var accessControl_accessCode = ({
  components: (accessControl_accessCode__components = {}, defineProperty_default()(accessControl_accessCode__components, field_default.a.name, field_default.a), defineProperty_default()(accessControl_accessCode__components, button_default.a.name, button_default.a), defineProperty_default()(accessControl_accessCode__components, cell_default.a.name, cell_default.a), defineProperty_default()(accessControl_accessCode__components, cell_group_default.a.name, cell_group_default.a), defineProperty_default()(accessControl_accessCode__components, radio_group_default.a.name, radio_group_default.a), defineProperty_default()(accessControl_accessCode__components, radio_default.a.name, radio_default.a), defineProperty_default()(accessControl_accessCode__components, popup_default.a.name, popup_default.a), defineProperty_default()(accessControl_accessCode__components, loading_default.a.name, loading_default.a), defineProperty_default()(accessControl_accessCode__components, picker_default.a.name, picker_default.a), defineProperty_default()(accessControl_accessCode__components, uploader_default.a.name, uploader_default.a), defineProperty_default()(accessControl_accessCode__components, dialog_default.a.name, dialog_default.a), defineProperty_default()(accessControl_accessCode__components, toast_default.a.name, toast_default.a), defineProperty_default()(accessControl_accessCode__components, vue_qr_default.a.name, vue_qr_default.a), accessControl_accessCode__components),
  data: function data() {
    return {
      //二维码code
      imgUrl: "../../../static/image/house_icon.png",
      codeText: "",
      openId: "",
      status: false
    };
  },
  mounted: function mounted() {
    toast_default.a.loading({
      message: '加载中...',
      forbidClick: false,
      duration: 500
    });
    document.title = "门禁二维码";
    this.openId = this.$router.history.current.query.openid;
    this.load();
  },

  methods: {
    //初始化二维码
    load: function load() {
      this.$http.get(global.host + 'guardCard/qrcode?openid=' + this.openId).then(function (res) {
        console.log("res   ===   " + stringify_default()(res));
        if (res.body.code == "200") {
          if (res.body.data) {
            this.status = false;
            this.codeText = res.body.data;
          } else {
            this.status = true;
          }
        } else {
          this.status = true;
        }
        console.log(" this.codeText   ===   " + this.codeText);
      }, function (err) {
        toast_default.a.loading({
          message: '服务异常，请稍后重试',
          forbidClick: false,
          duration: 3000
        });
      });
    },

    //刷新二维码
    refresh: function refresh() {
      toast_default.a.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 500
      });
      this.load();
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5218a3dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/accessControl/accessCode.vue
var accessCode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#c7c7c752","height":"100%"}},[_c('div',{staticStyle:{"height":"1rem"}}),_vm._v(" "),_c('div',{staticClass:"gc-postion"},[_c('div',{staticClass:"gc-code-ke"},[_c('vue-qr',{staticClass:"gc-code-img",attrs:{"text":_vm.codeText,"size":1024}}),_vm._v(" "),_c('div',{staticClass:"gc-div-refresh"},[_c('span',{staticClass:"gc-refresh",on:{"click":function($event){_vm.refresh()}}},[_vm._v("刷新")])])],1),_vm._v(" "),(_vm.status)?_c('div',{staticClass:"gc-postion"},[_vm._v("无权限!")]):_vm._e()])])}
var accessCode_staticRenderFns = []
var accessCode_esExports = { render: accessCode_render, staticRenderFns: accessCode_staticRenderFns }
/* harmony default export */ var components_accessControl_accessCode = (accessCode_esExports);
// CONCATENATED MODULE: ./src/components/accessControl/accessCode.vue
function accessCode_injectStyle (ssrContext) {
  __webpack_require__("c/Ku")
}
var accessCode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var accessCode___vue_template_functional__ = false
/* styles */
var accessCode___vue_styles__ = accessCode_injectStyle
/* scopeId */
var accessCode___vue_scopeId__ = "data-v-5218a3dc"
/* moduleIdentifier (server only) */
var accessCode___vue_module_identifier__ = null
var accessCode_Component = accessCode_normalizeComponent(
  accessControl_accessCode,
  components_accessControl_accessCode,
  accessCode___vue_template_functional__,
  accessCode___vue_styles__,
  accessCode___vue_scopeId__,
  accessCode___vue_module_identifier__
)

/* harmony default export */ var src_components_accessControl_accessCode = (accessCode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/accessControl/visitorAuthCode.vue



 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var visitorAuthCode = ({
  components: defineProperty_default()({}, toast_default.a.name, toast_default.a),
  data: function data() {
    return {
      arr: [],
      num: [0, 0, 0, 0],
      openId: ""
    };
  },
  mounted: function mounted() {
    this.openId = this.$router.history.current.query.openid;
    this.getAuthCode();
  },

  methods: {
    getAuthCode: function getAuthCode() {
      this.$http.get(global.host + 'guardCard/visitorAuthCode?openid=' + this.openId).then(function (res) {
        console.log("res   ===   " + stringify_default()(res));
        if (res.body.code == "200") {
          if (res.body.data) {
            this.num = res.body.data.split('');
          }
        } else {
          toast_default.a.fail({
            message: res.body.message,
            duration: 3000
          });
        }
      }, function (err) {
        toast_default.a.fail({
          message: '服务异常，请稍后重试',
          duration: 3000
        });
      });
    },
    randomNum: function randomNum() {
      var i = 0,
          j = 0;
      for (var _i = 0; _i < 18; _i++) {
        this.arr[_i] = Math.floor(Math.random() * 10); //获取到随机数
      }
      for (i; i < this.arr.length; i++) {
        for (j = i + 1; j < this.arr.length; j++) {
          if (this.arr[i] == this.arr[j]) {
            this.arr.splice(j, 1);
            j--;
          }
        }
      }
      this.num = this.arr.slice(0, 4);
      console.log("截取", this.num);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/accessControl/visitorAuthCode.vue



 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var accessControl_visitorAuthCode = ({
  components: defineProperty_default()({}, toast_default.a.name, toast_default.a),
  data: function data() {
    return {
      arr: [],
      num: [0, 0, 0, 0],
      openId: ""
    };
  },
  mounted: function mounted() {
    this.openId = this.$router.history.current.query.openid;
    this.getAuthCode();
  },

  methods: {
    getAuthCode: function getAuthCode() {
      this.$http.get(global.host + 'guardCard/visitorAuthCode?openid=' + this.openId).then(function (res) {
        console.log("res   ===   " + stringify_default()(res));
        if (res.body.code == "200") {
          if (res.body.data) {
            this.num = res.body.data.split('');
          }
        } else {
          toast_default.a.fail({
            message: res.body.message,
            duration: 3000
          });
        }
      }, function (err) {
        toast_default.a.fail({
          message: '服务异常，请稍后重试',
          duration: 3000
        });
      });
    },
    randomNum: function randomNum() {
      var i = 0,
          j = 0;
      for (var _i = 0; _i < 18; _i++) {
        this.arr[_i] = Math.floor(Math.random() * 10); //获取到随机数
      }
      for (i; i < this.arr.length; i++) {
        for (j = i + 1; j < this.arr.length; j++) {
          if (this.arr[i] == this.arr[j]) {
            this.arr.splice(j, 1);
            j--;
          }
        }
      }
      this.num = this.arr.slice(0, 4);
      console.log("截取", this.num);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b888e24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/accessControl/visitorAuthCode.vue
var visitorAuthCode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"box"}},[_c('img',{attrs:{"src":__webpack_require__("3wvI"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"txt"},[_c('h1',[_vm._v("访客授权码")]),_vm._v(" "),_c('div',{staticClass:"num"},[_c('ul',_vm._l((_vm.num),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(item))])}))])])])])}
var visitorAuthCode_staticRenderFns = []
var visitorAuthCode_esExports = { render: visitorAuthCode_render, staticRenderFns: visitorAuthCode_staticRenderFns }
/* harmony default export */ var components_accessControl_visitorAuthCode = (visitorAuthCode_esExports);
// CONCATENATED MODULE: ./src/components/accessControl/visitorAuthCode.vue
function visitorAuthCode_injectStyle (ssrContext) {
  __webpack_require__("MKn2")
}
var visitorAuthCode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var visitorAuthCode___vue_template_functional__ = false
/* styles */
var visitorAuthCode___vue_styles__ = visitorAuthCode_injectStyle
/* scopeId */
var visitorAuthCode___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var visitorAuthCode___vue_module_identifier__ = null
var visitorAuthCode_Component = visitorAuthCode_normalizeComponent(
  accessControl_visitorAuthCode,
  components_accessControl_visitorAuthCode,
  visitorAuthCode___vue_template_functional__,
  visitorAuthCode___vue_styles__,
  visitorAuthCode___vue_scopeId__,
  visitorAuthCode___vue_module_identifier__
)

/* harmony default export */ var src_components_accessControl_visitorAuthCode = (visitorAuthCode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/accessControl/visitorAccessQrcode.vue



 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var visitorAccessQrcode__components;



//import QRCode from 'qrcodejs2'
/* harmony default export */ var visitorAccessQrcode = ({
  components: (visitorAccessQrcode__components = {}, defineProperty_default()(visitorAccessQrcode__components, vue_qr_default.a.name, vue_qr_default.a), defineProperty_default()(visitorAccessQrcode__components, toast_default.a.name, toast_default.a), visitorAccessQrcode__components),
  data: function data() {
    return {
      num: "",
      imgUrl: "../../../static/image/house_icon.png",
      codeText: "",
      dateTime: ""
    };
  },
  mounted: function mounted() {
    this.initPage();
  },

  methods: {
    creatQrCode: function creatQrCode() {
      this.$http.get(global.host + 'guardCard/visitorQrcode?authCode=' + this.num).then(function (res) {
        console.log("res   ===   " + stringify_default()(res));
        if (res.body.code == "200") {
          if (res.body.data) {
            $("#tel4").blur();
            this.codeText = res.body.data;
            this.dateTime = "失效时间：" + res.body.message;
            // var qrcode = new QRCode(this.$refs.qrCodeUrl, {
            //     text: this.codeText, // 需要转换为二维码的内容
            //     width: 100,
            //     height: 100,
            //     colorDark: '#000000',
            //     colorLight: '#ffffff',
            //     correctLevel: QRCode.CorrectLevel.H
            // });
          }
        } else {
          $("#tel1").focus();
          toast_default.a.fail({
            message: res.body.message,
            duration: 3000
          });
        }
      }, function (err) {
        $("#tel1").focus();
        toast_default.a.fail({
          message: '服务异常，请稍后重试',
          duration: 3000
        });
      });
    },
    initPage: function initPage() {
      $("#tel1").focus(function () {
        //第一个input框获得焦点时触发的事件
        var txts = $(".num input");
        for (var i = 0; i < txts.length; i++) {
          var t = txts[i];
          t.index = i;
          t.setAttribute("readonly", true);
          t.onkeyup = function () {
            this.value = this.value.replace(/^(.).*$/, "$1");
            var next = this.index + 1;
            if (next > txts.length - 1) return;
            txts[next].removeAttribute("readonly");
            if (this.value) {
              txts[next].focus();
            }
          };
        }
        txts[0].removeAttribute("readonly");
      });

      var that = this;
      $("#tel4").keyup(function () {
        var oLi = document.querySelectorAll("input");
        for (var i = 0; i < oLi.length; i++) {
          that.num += oLi[i].value;
        }
        console.log(that.num);
        that.creatQrCode();
      });

      $("#tel1").keydown(function () {
        that.num = "";
        var oLi = document.querySelectorAll("input");
        for (var i = 0; i < oLi.length; i++) {
          if (oLi[i].value) {
            oLi[i].value = "";
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/accessControl/visitorAccessQrcode.vue



 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var accessControl_visitorAccessQrcode__components;



//import QRCode from 'qrcodejs2'
/* harmony default export */ var accessControl_visitorAccessQrcode = ({
  components: (accessControl_visitorAccessQrcode__components = {}, defineProperty_default()(accessControl_visitorAccessQrcode__components, vue_qr_default.a.name, vue_qr_default.a), defineProperty_default()(accessControl_visitorAccessQrcode__components, toast_default.a.name, toast_default.a), accessControl_visitorAccessQrcode__components),
  data: function data() {
    return {
      num: "",
      imgUrl: "../../../static/image/house_icon.png",
      codeText: "",
      dateTime: ""
    };
  },
  mounted: function mounted() {
    this.initPage();
  },

  methods: {
    creatQrCode: function creatQrCode() {
      this.$http.get(global.host + 'guardCard/visitorQrcode?authCode=' + this.num).then(function (res) {
        console.log("res   ===   " + stringify_default()(res));
        if (res.body.code == "200") {
          if (res.body.data) {
            $("#tel4").blur();
            this.codeText = res.body.data;
            this.dateTime = "失效时间：" + res.body.message;
            // var qrcode = new QRCode(this.$refs.qrCodeUrl, {
            //     text: this.codeText, // 需要转换为二维码的内容
            //     width: 100,
            //     height: 100,
            //     colorDark: '#000000',
            //     colorLight: '#ffffff',
            //     correctLevel: QRCode.CorrectLevel.H
            // });
          }
        } else {
          $("#tel1").focus();
          toast_default.a.fail({
            message: res.body.message,
            duration: 3000
          });
        }
      }, function (err) {
        $("#tel1").focus();
        toast_default.a.fail({
          message: '服务异常，请稍后重试',
          duration: 3000
        });
      });
    },
    initPage: function initPage() {
      $("#tel1").focus(function () {
        //第一个input框获得焦点时触发的事件
        var txts = $(".num input");
        for (var i = 0; i < txts.length; i++) {
          var t = txts[i];
          t.index = i;
          t.setAttribute("readonly", true);
          t.onkeyup = function () {
            this.value = this.value.replace(/^(.).*$/, "$1");
            var next = this.index + 1;
            if (next > txts.length - 1) return;
            txts[next].removeAttribute("readonly");
            if (this.value) {
              txts[next].focus();
            }
          };
        }
        txts[0].removeAttribute("readonly");
      });

      var that = this;
      $("#tel4").keyup(function () {
        var oLi = document.querySelectorAll("input");
        for (var i = 0; i < oLi.length; i++) {
          that.num += oLi[i].value;
        }
        console.log(that.num);
        that.creatQrCode();
      });

      $("#tel1").keydown(function () {
        that.num = "";
        var oLi = document.querySelectorAll("input");
        for (var i = 0; i < oLi.length; i++) {
          if (oLi[i].value) {
            oLi[i].value = "";
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e6f3c11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/accessControl/visitorAccessQrcode.vue
var visitorAccessQrcode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"erwema"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"pic"},[_c('vue-qr',{staticClass:"gc-code-img",attrs:{"logoSrc":_vm.imgUrl,"logoScale":0.2,"text":_vm.codeText,"size":600}})],1),_vm._v(" "),_c('div',{staticClass:"time"},[_c('p',[_vm._v(_vm._s(_vm.dateTime))])])])])}
var visitorAccessQrcode_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"box"}},[_c('img',{attrs:{"src":__webpack_require__("3wvI"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"txt"},[_c('h1',[_vm._v("访客授权码")]),_vm._v(" "),_c('div',{staticClass:"num"},[_c('ul',[_c('li',[_c('input',{attrs:{"type":"number","pattern":"\\d*","id":"tel1"}})]),_vm._v(" "),_c('li',[_c('input',{attrs:{"type":"number","pattern":"\\d*"}})]),_vm._v(" "),_c('li',[_c('input',{attrs:{"type":"number","pattern":"\\d*"}})]),_vm._v(" "),_c('li',[_c('input',{attrs:{"type":"number","pattern":"\\d*","id":"tel4"}})])])]),_vm._v(" "),_c('p',[_vm._v("请联系业主索取四位访客授权码")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title",attrs:{"onclick":"codeinput()"}},[_c('p',[_vm._v("门禁二维码")])])}]
var visitorAccessQrcode_esExports = { render: visitorAccessQrcode_render, staticRenderFns: visitorAccessQrcode_staticRenderFns }
/* harmony default export */ var components_accessControl_visitorAccessQrcode = (visitorAccessQrcode_esExports);
// CONCATENATED MODULE: ./src/components/accessControl/visitorAccessQrcode.vue
function visitorAccessQrcode_injectStyle (ssrContext) {
  __webpack_require__("m2AL")
}
var visitorAccessQrcode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var visitorAccessQrcode___vue_template_functional__ = false
/* styles */
var visitorAccessQrcode___vue_styles__ = visitorAccessQrcode_injectStyle
/* scopeId */
var visitorAccessQrcode___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var visitorAccessQrcode___vue_module_identifier__ = null
var visitorAccessQrcode_Component = visitorAccessQrcode_normalizeComponent(
  accessControl_visitorAccessQrcode,
  components_accessControl_visitorAccessQrcode,
  visitorAccessQrcode___vue_template_functional__,
  visitorAccessQrcode___vue_styles__,
  visitorAccessQrcode___vue_scopeId__,
  visitorAccessQrcode___vue_module_identifier__
)

/* harmony default export */ var src_components_accessControl_visitorAccessQrcode = (visitorAccessQrcode_Component.exports);

// EXTERNAL MODULE: ./src/style/font-awesome.css
var font_awesome = __webpack_require__("N7uh");
var font_awesome_default = /*#__PURE__*/__webpack_require__.n(font_awesome);

// CONCATENATED MODULE: ./src/main.js













// import clipper from '../static/clipper'



vue_esm["default"].config.productionTip = false;




vue_esm["default"].use(vue_touch_default.a, { name: 'v-touch' });
vue_esm["default"].use(node_modules_vue_fullpage_default.a);
// Vue.use(clipper)

window.$ = jquery_default.a;

/*注册入口路由*/

/*微信入口路由*/





/*空白页路由后期请删除*/

/*缴费入口路由*/




/*用户个人中心路由*/








/*新闻类路由*/






/*黄页服务路由*/








/*投诉建议入口*/





/*物业报修*/





// 物业报修新替换页面 静态



/*路由在服务器修改后可删除*/

/*车位租售*/





/*字体图标*/


// 车量缴费





//二手市场









//临时收费



/*import areaCorrelation from './components/temporaryCharge/areaCorrelation'
import areaDestory from './components/temporaryCharge/areaDestory'*/



/*邻里分享*/






/*通知中心*/


// 智慧门禁
 // 我的家属/访客邀请
 // 做备份
 // 新增家属
 // 新增访客
 // 门禁二维码
 // 访客授权码
 // 访客二维码



//Vue.use(jquery)
vue_esm["default"].use(vuex_esm["a" /* default */]);
var store = new vuex_esm["a" /* default */].Store({});
vue_esm["default"].use(vue_easy_uploader["a" /* default */], store);
vue_esm["default"].use(vue_router_esm["a" /* default */]);
vue_esm["default"].use(vue_resource_esm["a" /* default */]);
vue_esm["default"].use(vue_awesome_swiper_default.a);
vue_esm["default"].use(vue_lazyload_default.a);

var routes = [{
  path: '/',
  component: src_components
}, {
  path: '/visitorAuthCode',
  component: src_components_accessControl_visitorAuthCode
}, {
  path: '/visitorAccessQrcode',
  component: src_components_accessControl_visitorAccessQrcode
}, {
  path: '/accessCode',
  component: src_components_accessControl_accessCode
}, {
  path: '/imgDome',
  component: src_components_repairComponents_imgDome
}, {
  path: '/accessControl',
  component: src_components_entrance_accessControl
}, {
  path: '/visito',
  component: src_components_entrance_Visito
}, {
  path: '/addFamily',
  component: src_components_entrance_addFamily
}, {
  path: '/addVisitor',
  component: src_components_entrance_addVisitor
}, {
  path: '/firstlogin',
  component: src_components_beforelogin_firstlogin
}, {
  path: '/notice_list',
  component: src_components_newComponents_notice_list
}, {
  path: '/serviceMultiplePage',
  component: src_components_complaintComponenst_serviceMultiplePage
}, {
  path: '/rapireMultiplePage',
  component: src_components_repairComponents_rapireMultiplePage
}, {
  path: '/momentspublush',
  component: src_components_momentsComponents_publish
}, {
  path: '/noticeCenter',
  component: src_components_momentsComponents_remind
}, {
  path: '/momentsmime',
  component: src_components_momentsComponents_mime
}, {
  path: '/momentsdetail',
  component: src_components_momentsComponents_detail
}, {
  path: '/momentpreview',
  component: src_components_momentsComponents_preview
}, {
  path: '/momentslist',
  component: src_components_momentsComponents_list
}, {
  path: '/complaint',
  component: src_components_complaintComponenst_complaint
}, {
  path: '/complaintCollect',
  component: src_components_complaintComponenst_complaintCollect
}, {
  path: '/evaluate',
  component: src_components_complaintComponenst_evaluate
}, {
  path: '/fleaMarketList',
  component: src_components_fleaMarketComponents_fleaMarketList
}, {
  path: '/marketDetailList',
  component: src_components_fleaMarketComponents_marketDetailList
}, {
  path: '/weChatScaner',
  component: src_components_carRentComponents_weChatScaner
}, {
  path: '/defeated',
  component: src_components_carRentComponents_defeated
}, {
  path: '/marketResend',
  component: src_components_fleaMarketComponents_marketResend
}, {
  path: '/marketMyPublish',
  component: src_components_fleaMarketComponents_marketMyPublish
}, {
  path: '/fleaSendStatus',
  component: src_components_fleaMarketComponents_fleaSendStatus
}, {
  path: '/commodityMesReply',
  component: src_components_fleaMarketComponents_commodityMesReply
}, {
  path: '/checkFailure',
  component: src_components_fleaMarketComponents_checkFailure
}, {
  path: '/myCloct',
  component: src_components_fleaMarketComponents_myCloct
},
/*{
  path:'/areaCorrelation',
  component:areaCorrelation
},*/
{
  path: '/temporaryPay',
  component: src_components_temporaryCharge_temporaryPay
},
/*{
  path:'/areaDestory',
  component:areaDestory
},*/
{
  path: '/decorationCost',
  component: src_components_temporaryCharge_decorationCost
}, {
  path: '/relatedToNumber',
  component: src_components_temporaryCharge_relatedToNumber
}, {
  path: '/feePayment',
  component: src_components_temporaryCharge_feePayment
}, {
  path: '/customAmout',
  component: src_components_temporaryCharge_customAmout
}, {
  path: '/orderlist',
  component: src_components_repairComponents_orderList
}, {
  path: '/orderDetail',
  component: src_components_repairComponents_orderDetail
}, {
  path: '/repair',
  component: src_components_repairComponents_repair
}, {
  path: '/suggest',
  component: src_components_suggest
}, {
  path: '/myEnter',
  component: src_components_convenientComponents_myEnter
}, {
  path: '/yellowPage',
  component: src_components_convenientComponents_yellowPage
}, {
  path: '/conventientSellDetail',
  component: src_components_convenientComponents_convenientSellDetail
}, {
  path: '/particular',
  component: src_components_convenientComponents_conventientParticular
}, {
  path: '/convenientserver',
  component: src_components_convenientComponents_server
}, {
  path: '/convenientDetail',
  component: src_components_convenientComponents_convenientDetail,
  children: [{
    path: 'all',
    component: src_components_convenientComponents_convenientList
  }, {
    path: 'favorite',
    component: src_components_convenientComponents_favorite
  }]
}, {
  path: '/black',
  component: black["default"]
}, {
  path: '/about',
  component: src_components_newComponents_about
}, {
  path: '/beforeLogin',
  component: src_components_beforelogin_beforelogin
}, {
  path: '/dayPay',
  component: src_components_beforelogin_dayPay
}, {
  path: '/bindSysUser',
  component: src_components_beforelogin_bindSysUser
}, {
  path: '/register',
  component: src_components_register
}, {
  path: '/houseBind',
  component: src_components_userComponents_houseBind
}, {
  path: '/user',
  component: src_components_userComponents_user
}, {
  path: '/changeHouse',
  component: src_components_userComponents_changeHouse
}, {
  path: '/userinfo',
  component: src_components_userComponents_userInfo
}, {
  path: '/listNew',
  component: src_components_newComponents_listNew
}, {
  path: '/notice',
  component: src_components_newComponents_notice
}, {
  path: '/detailNew',
  component: src_components_newComponents_detailNew
}, {
  path: '/tenementDesc',
  component: src_components_newComponents_tenementDesc
}, {
  path: '/paymentRecord',
  component: src_components_payComponents_paymentRecord
}, {
  path: '/infoPublic',
  component: src_components_newComponents_infoPublic
}, {
  path: '/pay',
  component: src_components_payment,
  children: [{
    path: 'water',
    component: src_components_payComponents_water
  }, {
    path: 'electricity',
    component: src_components_payComponents_electricity
  }, {
    path: 'tenement',
    component: src_components_payComponents_tenement
  }]
}, {
  path: '/addCar',
  component: src_components_carRentComponents_addCar
}, {
  path: '/myCarInfo',
  component: src_components_carRentComponents_myCarInfo
}, {
  path: '/updateCarInfo',
  component: src_components_carRentComponents_updateCarInfo
}, {
  path: '/myCarInfoList',
  component: src_components_carRentComponents_myCarInfoList
}, {
  path: '/carPaycoment',
  component: src_components_carRentComponents_carPaycoment
}, {
  path: '/zhiF',
  component: src_components_carRentComponents_zhiF
}, {
  path: '/carPayComFee',
  component: src_components_carRentComponents_carPayComFee
}, {
  path: '/editUserInformation',
  component: src_components_userComponents_editUserInformation
}, {
  path: '/repairsOne',
  component: src_components_repairComponents_repairsOne
}, {
  path: '/repairsTwo',
  component: src_components_repairComponents_repairsTwo
}, {
  path: '/repairsThr',
  component: src_components_repairComponents_repairsThr
}];

var main_router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: 'movecouplet',
  routes: routes
});

fastclick_default.a.attach(document.body);

vue_esm["default"].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["default"]({
  router: main_router,

  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "NYaz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NeJJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nim7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NqXR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OQuy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OS5N":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/new_0603-2.6a5d8c9.png";

/***/ }),

/***/ "Opf8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OzMS":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAA2ZJREFUWAntV01IVFEUPmdGG7IxyJSM/iCKIoICwxathKQQlaQY00CyEP/aBEXr2hS1svAvo6jA0QEp0gra2O8u2ggtWuQmhFAL+vPvzTt9z3rxfN437zqOgTAXhvvuOd8953vfue/eO0TpllYgrcDyVoD96Lf1SK2YdIyYCiwsCw0xU1tjFT/wm5sKvyfBWzHJmTaoV4gOqhKB5EBukI5GIjyt8qfKFvAKNBWnTi9y1hwRKh0zqMtrfqrsSgU7eqUkHqfHfkmgogSCtLshwu/9sMn6lQqaQsU6AaEimwad1MEmi1ESxEexXzegMG3TxSaDUxK0SqcbDGvkpy42GZySINh91g0G7IAuNhmckiBU0SIIpb9khKk/mcS6c7wIjvgGYJoKBKiivox/+WIXAVASNAP02ifmEE6W8oZKfumDW7Q7QxUhj+nN6J/Fv8rtR1nvNh6nWmYcev+hKRX8e3y9UOUHq5L7zyhL5VsKm5KglQjr65EyoVDe93FqVvqWwOhJcG2A7mGdodLzG77y813dsm6+J/UWT4Io8wQItqhSosy5M0x9nW8lU+VPpU35kdgJskLUOjFBF0Ao27bZPc7hA8YHuoFxg23z6m/GZK9hUiHOpy3AjGQG6UldhIe98E47qpW4tffIGdOcJaIEogQtO9fTuaIiNtyArj7ZODNNrXiZ8jk+JgOJrwS306X6fTwzx+ca+BIUEW6P0lOoeMg1998QQQaD2RTBpj1mG2/HJG/SoFeYt8O2uXtsWQNNVVzmtjvHnmvQBln7XTBEtRiP2zZ3DxJF8R/0rj0qpwYHZXbZTMbpWiJyVgzr0tsaldPueM6xr4I2uKNbik28MYKusG2qHgE/SoCuYxu/6oednc803FzFW1WxLJs2QQsMhSqgSo9WYmuCZsMb59dVs/KC4ltiZw7rnxw2cOu27VluJ177OcP7ZFoQQSuhdUEIhagAC9z3P4sOQZRwckOYPG9PCyqxO2Fbrxwhk1pQ8s1un/aYKYo1WO2FX7CCzkBNlfwwnEO7oOZl2L85fZrP4yuEzibCLkpBZ+BYTMKjJtXgtKhB0EKomjg20wjUOYF1/dwZx/2cOIgbrTm+E5N87IOHTcJaJdqDaZvwW4PfSrzAJ9j6ZTVdbCrlr5oh07C0AmkFlq0CvwEJQeO4W5fv2gAAAABJRU5ErkJggg=="

/***/ }),

/***/ "QxR1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R5kP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RQZx":
/***/ (function(module, exports) {

//
//
//
//
//
//

/***/ }),

/***/ "S/I2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SAay":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SH4t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/am_guid.1294deb.png";

/***/ }),

/***/ "SQkJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ymj_adv.d79c410.png";

/***/ }),

/***/ "UM/W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uf+m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V08F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VrI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WBmC":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "WZtS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72e1168a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-header/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-popup-header",class:_vm.showBottomBorder ? 'vux-1px-b' : ''},[_c('div',{staticClass:"vux-popup-header-left",on:{"click":function($event){_vm.$emit('on-click-left')}}},[_vm._t("left-text",[_vm._v(_vm._s(_vm.leftText))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-right",on:{"click":function($event){_vm.$emit('on-click-right')}}},[_vm._t("right-text",[_vm._v(_vm._s(_vm.rightText))])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_popup_header = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-header/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("pski")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_popup_header,
  src_components_popup_header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_header = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X+dp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X+l2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X8h/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XlLT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XqYu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xw0J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y8g4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "YAYC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YgkF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yj96":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d806436","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function injectStyle (ssrContext) {
  __webpack_require__("7I26")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a2kH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticStyle:{"padding-top":"49%","text-align":"center"}},[_vm._v("功能暂未上线")]),_vm._v(" "),_c('h3',{staticStyle:{"padding-top":"4%","text-align":"center"}},[_vm._v("敬请期待...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aG1J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aN9Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "apyy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "be3g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bg0x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "byZ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c/In":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c/Ku":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cC6l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cHaP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "d9KP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dg8L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eVeh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ej5L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ekZG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "emhf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fZR+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fcPa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gMie":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gW3h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_black_vue__ = __webpack_require__("IWdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_black_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_black_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_black_vue__ = __webpack_require__("RQZx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_black_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_black_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fadc388_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_black_vue__ = __webpack_require__("a2kH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_black_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fadc388_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_black_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gYt2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hFXJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hSFT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hWYL":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAoCAYAAACIC2hQAAAAAXNSR0IArs4c6QAAA0VJREFUWAntV0tIVFEYPv+ZbMSKyojAIighiqygVStLnHEVoYStNMmYuVBIq9xEiyxaRAtDyJkx7EVQux5gUKNEuAhd9VgVWWQLIyKrhc0Y9+87pXS9r7nnDuOmuZtz7v/6vvnOf849I0T5KStQVuD/UoCK/blvhrqi7yZz7YLpkCCuw1hNxFMsxBhJuhVPpO8Vi6HyiyI6nDLqTeJBZlHrRYZIjFJFpCPW2T/hFRPEHppoNp1sNpluC8HRQkAkaApqN8WNzMtCsV7+UERHMse3/+LZMcGiyquw3Q6yEyC7G2S/2X1B3mWQIHsMSGZ0SKp8FrwZfdtjrxX0XVtRLHmDyWIkKIA1Dv36M1oR3Vjf2ffZag8y11bUFHQwSGG3GGy6ylw+v9/NV8imTRSLuK9QUT8/E+/183v59Iky1XgVC2JHr60PEmeP0Scqgu90O5h6x4YKfFJY87WJ4qvzyVpAe84UKl+bKD6Rr7TJWRIAGOrQ1yYKRYcsuNpTjsiH2klI0Ca6fFn0Jq4IX8OA4Rwdjyf6n4XJ1Sa6p63vOxGd1QcjU0jZrZ/3N0ObqEqLJft7oc59HVC0TE88kXqik2ONDUUUinLN6ppWjHesxdzm+EGMC8lpXEbOuPmD2rS/9fbCj9LJVth6cEButfoUQVAcFRHZHbYvF9SzvrjNnw52rc3n8+349LXgsK4F+KSMVB6IJS4tOA8fp5M7WFKdNLmaSU4JNseh4of5mtmBE+vYnHmAGhugzluMdysrojeCXlB8Fc0OGEfZ5Iu4TKyaB1QjlvILlv2CkNHrdsLWODVXBIWZ62Dmbki8xuqH6tMgfLLJyFyx2t3mnkSh0DkQPOWW9M9GJgo8h9ovMH5kph/KhxZe8Uc5pp0Yd+HD6bsXJMnzMSPli+VKNJsy2kzBOC8X8ZHycFMy5YnpIAolV4Lee/tyl5qyaoMlS6s2NRzpnXbDciwJCWksNklFTGHO5mYMN5LK5iCKpm/xCi61Hcvb7IXhIIp/itu8gktu98F2EMXOdfRtyQnOAfhhO4jCcHWxiDlwiK85bHMGh3roURoeONYohLkFHe7wexUqyo6DF9vldWPi8rC6RxRVq5xcVqCsgL8CvwFo//XwdPIiwgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "hiPb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hv1Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iT1P":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/am_position.903a2ed.png";

/***/ }),

/***/ "iz3p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j7d7":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "jDpe":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAoCAYAAACIC2hQAAAAAXNSR0IArs4c6QAABFJJREFUWAntl11oHFUUx++ZmXRDKk1abCpWiq0fKexHHtqkVEW67KoEREStiL6IIHnrbpP1qyrsk4tfTRQEH/SlUJG2KsWPUHeSrYoalEhNGoov4kcfbAjE2GYTszNz/N9Ntt3szs7s7mwgQhZ279xzzj33d8899+wdIdY/6xFY2xGgRuAd5BPqBf3bPvh6iom2oz2nEL80EXnr60b4lz48g4Z+Tmw0p3Kn4SuyAooEC6K+ycjg4Ap5nR2lznH5YftGk5usKeMMOishpRaYwuKBwHD8xbyxx5+6I7r/u8NbLs/xGRa8142BiFLno4NH3Oyc9HWBBvQj2wRn04AMOjkv1hEpb09EjsYBzcXyap9rBg1lnr3JMhd1Zu6odpKCHSDfeyTS1pukpFWQVdvWBBr6KrHTWswNIyQ7q52g1A6wx69X2548G04apTqnftWHKTQS67ByxjdeICUIduKJaXPmxMHJ5AYnsFJdVREN6ImQYEPmZHupg7r7REObWujh7+8YmK/Gh2tE/Xp/F7ORaSikJGPuuZy1Pj+QSV7nGbQz3X8XIqnD6xYnZyRoFqc6oaja3mZN26qScjdy8RgqqeMJZxbhafPvL/ekn2t18i91Fbc+qB+OMlunMVOLkxMA/eJj371j97z6R6ldYCT+EJviJBbquHPw8ZNPVe8bC785Xeqj0LcFDeh99zObp2DkKxjat2SpmnLnePjoqF/vCwu2UiiTN8M2I8TG+PnoK5f86VgK/eftxxdJiSZb1Kboj+HX/yqSXn0sW2kw079bCPNjWLhAwoLEWQkpK4JgcwiR24ft3IbvY0JkP8EJJ1XzvQND97rJ7J83cp9eJSt5KAPdYGhZOP4zn3f53KOKpxI2Y9KfxQSwlQsD5P7OTPz28fBrF7EA2ygts/xTmAv9X5dlZY1WKlnOtVsK8qAe60WevlvoF7dE4l/Zx0QaqkKxaumZmpryenk9sVFLXbNo3oE5Z5cGVP4ti2hl03INotYpparCHyHZzWILwE90HOi+0JV55gYsBV9vH0+gmLpH5vS58CAuyth+ot9wgg20I2gfPEmPmgtm7mksqGznasX25CAPYBrHuvUXen6IpmSVOCVv+xJQggSH4z2weblWKDt7T6DSIXKva07MjwbS8ZRvc9uHgMyiBu9Czh5CYvYidfN5ajd5LTLPoEuT8a04K+8vzswuoP8BAAewhAdqAXGz9Zqjbv4bpl8VULVde1zVmoIoXzONIl0V0PHON+YUYVxE/lb8s6h1AasCiv/34zlDXALMjbUCVbJfFdCt2uZeIq1rzW49E3ejbhLeh674WP19zW49IGOooTN+PTa9IBYauvUNqqPXMguFvtXufnLNor4n1xxlUqbqc+0+CheZ7K7onivulkK4gvpad38Gh19U46w2G1rErSpRuBe4jbV9FbEbJF/Aci2m+63fbrCNbHv7jtmh2w7l77M26nXRegT+dxH4D3XXc4V/C5AJAAAAAElFTkSuQmCC"

/***/ }),

/***/ "jopN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kZeC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kbG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02febef1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Js7q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kjIK":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhKgAcAPefACvWv7fx6fv+/l/gz/3//hbSuCzWv9X38vP9+8r17/j+/d/59bLw6FPeyy3Xv6Xu5B3Uu/L9++b69y7XwL/z7EjcyPf9/O37+e78+tb38s318BfSuT/axTXYwpbr38Lz7Lbx6SbVvWzj0hrTuRvTunjl1ivWwLjx6vr+/irVv9759YTn2qnu5eX695Lq3pzs4RbSuSfWvj7axVLey6rv5WDgz4fo23vm1xXRuEfcxzfZwmvj0jzaxCjWvibVvm7j00ncyCDUu1Pdy3zm15Dq3Yno21PezJ7s4SPVvBnTuTTYwRjTuS/XwC3XwIbo2izWwMLz7aXt5C3WwBzTuxbRuTXYwxnSufL8+2zi0kjbyCXUve38+hfSunjl18Hz7Mz18Pf9/db385br4Ob6+Hjk1hrTur7y7DTXwhvTu+37+rfx6j/axmzj0xrSuj7ZxZbq33rl1zzaxUfcyIbo20nbyKju5VLdyz3ZxWvj04Xn2pDq3ifVvm3i0zTYwp7s4h/Tu2Dg0EncyY/p3Xvl12vi0kbbxzbYwhnTuijWvy7WwBjTujzZxDPXwS/XwSPVvZ3s4ZHq3iLUvIjo2yDUvJvs4Yno3Hzm2LXx6RjSuYbn2zfZw27j1BXSuRTRuBXSuP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo3NjU4Y2I5YS1lNWQyLTQyM2ItYjVkNS1lNDY4Y2QxMGRjODciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjFDQ0RCN0E1REI0MTFFOUExRTRDQTZCOEI0ODE2MkQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjFDQ0RCNzk1REI0MTFFOUExRTRDQTZCOEI0ODE2MkQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowMTU5NDUyZi04MWRmLTRiOTctOTFjYi0wMjdhZGRkYjk5NTAiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo2ZGIxZDFmZS0yN2Q5LTExN2MtYTkzYi1jY2Y4MWQ5ZGRlNTYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4B//79/Pv6+fj39vX08/Lx8O/u7ezr6uno5+bl5OPi4eDf3t3c29rZ2NfW1dTT0tHQz87NzMvKycjHxsXEw8LBwL++vby7urm4t7a1tLOysbCvrq2sq6qpqKempaSjoqGgn56dnJuamZiXlpWUk5KRkI+OjYyLiomIh4aFhIOCgYB/fn18e3p5eHd2dXRzcnFwb25tbGtqaWhnZmVkY2JhYF9eXVxbWllYV1ZVVFNSUVBPTk1MS0pJSEdGRURDQkFAPz49PDs6OTg3NjU0MzIxMC8uLSwrKikoJyYlJCMiISAfHh0cGxoZGBcWFRQTEhEQDw4NDAsKCQgHBgUEAwIBAAAh+QQJFACfACwAAAAAKgAcAAAI8AA/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatwoMYoUA48IcDy4pUank53oZBhJ0AwAlCit5LEwUsEgHDBzGvKy8cCdnIUG5MSBZQvGN21gbsgk4NMlKTn3sKgoQUhORgkIXiFDJaeQBRIZaMmJ5crBL25yToHUtCECPjm1MFCIQtCUnG6+MExwJqedFg0XWIVJhQwChAIkYYLZ5o3Ih3V85EwEwqCKLDkXHZh4gRBOmAMkDATxByYOOAoseukLM9IJgSlgAjCT0cIKKzBTCHx5csAFjhkwn9T9KUAKA1FYfiJAyUCKAMqjS1ceEAAh+QQJFACfACwAAAAAKgAcAAAI8QA/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgZPpjg4AiBjAox1PBE0hOQDCAPUjBQsuQIJxZSClQwpEDLmzo+pDwg42aOATcLiMCA0QOJlktsCPgEYsLNHjQqSmhwU0kCghFKbLjZYIFEBiFuiohwUAOHmxBcLG2I4MfNEAwUoiAC4SYHDQwTdLg5o0XDBVRbbiiBAKGAIklakvDw8SGLGDeZBDCoosJNHgcmXthhs+UACQMDBGlZ4IYCix/2tkRyQiCAlgYoZLSwYkRLAAJZkhxwQWYGyyRxfwoAwMEDmQMJvHAAYDLy59CjS59eMSAAIfkECRQAnwAsAAAAACoAHAAACPUAPwkcSLCgwYMIEypcyLDhwgcTHBwh4LCiQQw1PGn0BCSDxY8UDGzcOMKJhY8MFQwpMLKljg8oEx6Q0TLHgJYFRGCIWdADiZFLbAj4BGJCyx40eH6S0KClkgQEI5TY0LLBApQMQrQUEeGgBg4tIbgY2hDBj5YhGChEQQRCSw4aGCbo0HJGi4YLmo7cUAIBQgFFkowk4YFiRRYxWjIJYFBFhZY8DsS8sIPlyAESBgYIMrLADQVKP32gOxLJCYEARhqgEHqghRUjRgIQKFLjgAutC2Z4rHH2pwAAHDzIfZDACwcAGBNfzry58+fQo0ufTr269Y8BAQAh+QQJFACfACwAAAAAKgAcAAAI8gA/CRxIsKDBgwgTKlzIsKHDhxAjSpxIUeKDCU38EKjoEAMgTiA5BQrDcSGFJyFDlpkDpqRBBZZgpJypCYrLgQdkzJQzYCYMNhhcikGTUpENAZ9ATJiJiEbFMUZm9klAMEIXLjONLJDIwMdMNhEOalgzE4ILpA0RbJrpg4FCFHogzFyjgWGCKjNntGi4IGpKLl0QIBRQ6VBKNGI2PmQRY2ajAAZVVJgZ58DENHhkphwwZmCASSlh3FDAEQrelI5OCDSR8gmFm2BWlElpQiBKkAPS3BwYZjLI2p/UmGjyYHdBAi+amFBjvLnz59CjS59OHWJAACH5BAkUAJ8ALAAAAAAqABwAAAjxAD8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNqHPhggoMjBDYixFDDk0lPQDKILEjBwMmTI5xYWKlgSIGXOHV82HhABs4cA3AWEIEBowcSL5fYEPAJxAScPWhUlNAAp5IEBCOU2ICzwQKJDELgFBHhoAYOOCG4YNoQwQ+cIRgoREEEAk4OGhgm6IBzRouGC6q+3FACAUIBRZK8JOEh5EMWMXAyCWBQRQWcPA5MvLDj5ssBEgYGCPKywA0FFj/wfYnkhEAALw1QyGhhxYiXAAS6NDnggsgMl03m/hQAgIMHKwUSeOEAAOXk0KNLn44wIAA7"

/***/ }),

/***/ "l+GJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lDWe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "loc2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m2AL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mT/2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a40302c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')},"on-show":function($event){_vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("d9KP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n8Fz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "njjg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "npjk":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "oCox":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oWtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13ee6e34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("iz3p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_icon,
  src_components_icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oYIu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oxMG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pC2a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pDNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js
var base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f9fa4da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("NeJJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Toast: vux_src_components_toast
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        width: this.labelWidthComputed || this.$parent.labelWidth || this.labelWidthComputed,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      setTimeout(function () {
        if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
          setTimeout(function () {
            document.activeElement.scrollIntoViewIfNeeded();
          }, time);
        }
      });
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      this.scrollIntoView(500);
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal) {
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      this.$emit('input', this.maskValue(newVal));
      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Toast: vux_src_components_toast
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        width: this.labelWidthComputed || this.$parent.labelWidth || this.labelWidthComputed,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      setTimeout(function () {
        if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
          setTimeout(function () {
            document.activeElement.scrollIntoViewIfNeeded();
          }, time);
        }
      });
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      this.scrollIntoView(500);
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal) {
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      this.$emit('input', this.maskValue(newVal));
      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9b7aff6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"click":function($event){return _vm.clear($event)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("X8h/")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = __webpack_exports__["a"] = (x_input_Component.exports);


/***/ }),

/***/ "pJHf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pski":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q7WB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qCL5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qNPa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qhZB":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAA5BJREFUWAntV01IVFEUPuf53sjM2I8uTApq085VFoFWVKuIyHCEoB/KKGgTtciiNkFkVLvUVS2E1uGIBK2aIgjaFFGgYGVuErOI0tTRNzPvdO6rl/Nzz5s3ppQwgrx7z/nud7937rvfvQNQ/itXoFyB5V0BDCJ/RTzVmAGnHQiaCLAGgD4h4GPTtK5PHsD32RwbH1LlaNKezY4VazPXq5nWUIMOZ+iCXqx+gELh3rlbaaJnRBAjgDoWF+L8egJqS2VSr8N99hkPvxRPX4EfhuwOnvQii9LjiCLgUHc0bh9fCnGKUz8xJ9SyAuH5IBNzZW+HH9A6HdYw4DAv4db8f0C4qcPnx8z8gNd3vzmfF/Bw6klEqzFtn+bmley42zZgYKYl9CY/Hum1G/gzyQ8X9MUKAuC2ArRPgKg0vA9VTkoUyJuiOgdZpMN2UFsEsqC0KFBZSWmMwkYqjaQALQpUPleA/gcBcZMoE2afO8g7IPI3usgxmqN9doEJ8yfELlGcWRSoTohwr32JKbqK08gIcpxrAXSIBOISqxHJ1lC3gdiGiN9FhiVOiBX05p2Ohe6xCT9SPqes5Ndu1W4I90yu3MD2PgSD3vhgTxoOhvsPUYFuM9m6N78ga+Jz4RG5qhacl1swpbDqRpM9xmtv2gvp+4gZrx/kGUhgVTy10wHngjpd1LGmI0aEwZlYZb3vdQuRkGicEBOWZV2d3I/vdFzZMd9Noibjm0pnBugJ28I+SVw2oW+bP2Le0XVsXUdSNl/V4vZZXzwnfQWOzaZuOERnmTBQpYtNlpunMPN2RvvmjubGc3uiQL5ubXcIzuXCF7/H794V6ae1ErMoMEMO3wW1diJxLSjOn001pNMnpcGiQEBslAYtehydJolTFFjqdYt3uGsxykr45Uo83VDrDEq0KJCXd0x6K22caFTFlc8pK9FixKA8lyiQz9+EyKdJIBp/8MrnNBCfkIwXBVqm1cHLNuXDmp0aiVSbd72AMmEem/T6vk+EtzV1Vo+EEQVONOMIm1+7NHA+jk4FGie+7J5/GfeEMODyPEZqYcYEo+1jk/wyokBFyb/271QgHOLl/qqdAmHYrMBdUzHraX4+2RLqNAw8xmO/5efcPlfORNzxI2Y91+Z/BwOdENF+WkOZ9CkAh3/pIf+Y4vOUMLGyyuoZ34PTfhO4Jqx8zrUStVvVhsCEWla/yvlxlnPlCpQrsJwq8BOYayk0qvePWwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "rHil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0290eb8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("vKGX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rqO2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rqsT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tn/N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "topb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "twXI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/am_share.7782946.png";

/***/ }),

/***/ "u1cv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u6FZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uEo3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uJm6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uO6d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uQHm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v62e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vKGX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vOg8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_popup_header_index_vue__ = __webpack_require__("WZtS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_group_index_vue__ = __webpack_require__("rHil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_input_index_vue__ = __webpack_require__("pDNl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_popup_picker_index_vue__ = __webpack_require__("7Ah8");






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      value1: "",
      muSid: '',
      value3: ['本人'],
      list1: [["亲戚", "老师", "朋友"]],
      phones: '',
      openids: ''
    };
  },
  beforeMount: function beforeMount() {
    this.muSid = this.$router.history.current.query.msId;
    this.phones = this.$router.history.current.query.phone;
    this.openids = this.$router.history.current.query.openid;
    var urls = global.host + 'users/personalCenter';
    this.$http.get(urls).then(function (res) {}, function (err) {
      console.log(err);
    });
  },

  components: {
    PopupHeader: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_popup_header_index_vue__["a" /* default */],
    Group: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_group_index_vue__["a" /* default */],
    XInput: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_input_index_vue__["a" /* default */],
    PopupPicker: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_popup_picker_index_vue__["a" /* default */]
  },
  methods: {
    cancle: function cancle() {
      this.$router.push({ path: '/userinfo', query: { openid: this.openids, phone: this.phones } });
    },
    colectMethod: function colectMethod() {
      var urls = global.host + 'users/personalCenter';
      this.$http.get(urls).then(function (res) {
        this.$router.push({ path: '/userinfo', query: { openid: openids, phone: phones } });
      }, function (err) {
        console.log(err);
      });
    },
    onChanges: function onChanges() {}
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "vXAY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vm/u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w5cD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "w9v+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wgqt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x1DB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xIcs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJHg":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "xewG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y2NU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yiUR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zDjd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f8a22c76d8a87b46fb33.js